import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  json: any;
  jsonb: any;
  lquery: any;
  ltree: any;
  ltxtquery: any;
  numeric: any;
  smallint: any;
  timestamptz: any;
  uuid: any;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type CirclePost = {
  __typename?: 'CirclePost';
  body: Scalars['json'];
  comments_count: Scalars['Int'];
  created_at: Scalars['String'];
  hide_meta_info: Scalars['Boolean'];
  id: Scalars['Int'];
  likes_count: Scalars['Int'];
  name: Scalars['String'];
  slug: Scalars['String'];
  space_id: Scalars['Int'];
  space_name: Scalars['String'];
  space_slug: Scalars['String'];
  url: Scalars['String'];
  user_avatar_url: Scalars['String'];
  user_name: Scalars['String'];
};

export type CircleSpace = {
  __typename?: 'CircleSpace';
  emoji: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  slug: Scalars['String'];
  space_group_id: Scalars['Int'];
  space_group_name: Scalars['String'];
  url: Scalars['String'];
};

export type CircleSpaceGroup = {
  __typename?: 'CircleSpaceGroup';
  created_at: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  slug: Scalars['String'];
  space_order_array: Array<Scalars['Int']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type StreamIoCreateActivityInput = {
  actor: Scalars['String'];
  description: Scalars['String'];
  foreign_id: Scalars['String'];
  object: Scalars['String'];
  target: Scalars['String'];
  time: Scalars['String'];
  type: Scalars['String'];
  verb: Scalars['String'];
};

export type StreamIoCreateActivityOutput = {
  __typename?: 'StreamIOCreateActivityOutput';
  id: Scalars['String'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type Api_Create_Classroom_Output = {
  __typename?: 'api_create_classroom_output';
  id?: Maybe<Scalars['String']>;
  learnerGroup?: Maybe<Learner_Group>;
};

export type Api_Create_Project_File_Input = {
  fileCaptureMethod?: InputMaybe<Scalars['String']>;
  filename: Scalars['String'];
  id: Scalars['String'];
};

export type Api_Create_Project_File_Output = {
  __typename?: 'api_create_project_file_output';
  filename: Scalars['String'];
  id: Scalars['String'];
};

export type Api_Create_Project_Input = {
  file?: InputMaybe<Api_Create_Project_File_Input>;
  fileCaptureMethod?: InputMaybe<Scalars['String']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  nodeId: Scalars['uuid'];
  text?: InputMaybe<Scalars['String']>;
};

export type Api_Create_Project_Output = {
  __typename?: 'api_create_project_output';
  file?: Maybe<Api_Create_Project_File_Output>;
  id?: Maybe<Scalars['String']>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export type Api_Disable_User_Input = {
  disabled: Scalars['Boolean'];
  userId: Scalars['String'];
};

export type Api_Disable_User_Output = {
  __typename?: 'api_disable_user_output';
  disabled: Scalars['Boolean'];
  userId: Scalars['String'];
};

export type Api_Import_Classrooms_Output = {
  __typename?: 'api_import_classrooms_output';
  id?: Maybe<Scalars['String']>;
  learnerGroup?: Maybe<Learner_Group>;
};

export type Api_Join_Classroom_Output = {
  __typename?: 'api_join_classroom_output';
  learnerGroupId?: Maybe<Scalars['String']>;
};

export type Api_Onboard_Educator_Output = {
  __typename?: 'api_onboard_educator_output';
  orgId?: Maybe<Scalars['String']>;
};

export type Api_Sign_Up_Output = {
  __typename?: 'api_sign_up_output';
  authToken: Scalars['String'];
  userId: Scalars['String'];
};

export enum Api_Sign_Up_Role {
  Educator = 'EDUCATOR',
  Parent = 'PARENT',
  Student = 'STUDENT'
}

export type Api_Sync_Roster_Output = {
  __typename?: 'api_sync_roster_output';
  invitesCount?: Maybe<Scalars['bigint']>;
};

export type Api_Update_Learner_Group_Settings_Input = {
  classId: Scalars['uuid'];
  color?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  privacyScope?: InputMaybe<Scalars['String']>;
};

export type Api_Update_Learner_Group_Settings_Output = {
  __typename?: 'api_update_learner_group_settings_output';
  classId: Scalars['uuid'];
  color?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  privacyScope?: Maybe<Scalars['String']>;
};

export type Api_Update_Privacy_Input = {
  pathPrivacy?: InputMaybe<Scalars['String']>;
  profilePrivacy?: InputMaybe<Scalars['String']>;
  projectPrivacy?: InputMaybe<Scalars['String']>;
};

export type Api_Update_Privacy_Output = {
  __typename?: 'api_update_privacy_output';
  pathPrivacy?: Maybe<Scalars['String']>;
  profilePrivacy?: Maybe<Scalars['String']>;
  projectPrivacy?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type Api_Upsert_Organization_Data_Input = {
  avatar?: InputMaybe<Scalars['String']>;
  emailDomains: Array<Scalars['String']>;
  gradeLevel: Scalars['String'];
  orgId?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  shopEnabled?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type Api_Upsert_Organization_Output = {
  __typename?: 'api_upsert_organization_output';
  orgId: Scalars['String'];
};

/** columns and relationships of "assignment" */
export type Assignment = {
  __typename?: 'assignment';
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An array relationship */
  learnerGroups: Array<Assignment_Learner_Group>;
  /** An aggregate relationship */
  learnerGroups_aggregate: Assignment_Learner_Group_Aggregate;
  mode: Scalars['Int'];
  /** An array relationship */
  paths: Array<Assignment_Path>;
  /** An aggregate relationship */
  paths_aggregate: Assignment_Path_Aggregate;
  startDate: Scalars['timestamptz'];
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userId: Scalars['String'];
};


/** columns and relationships of "assignment" */
export type AssignmentLearnerGroupsArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Learner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Learner_Group_Order_By>>;
  where?: InputMaybe<Assignment_Learner_Group_Bool_Exp>;
};


/** columns and relationships of "assignment" */
export type AssignmentLearnerGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Learner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Learner_Group_Order_By>>;
  where?: InputMaybe<Assignment_Learner_Group_Bool_Exp>;
};


/** columns and relationships of "assignment" */
export type AssignmentPathsArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Path_Order_By>>;
  where?: InputMaybe<Assignment_Path_Bool_Exp>;
};


/** columns and relationships of "assignment" */
export type AssignmentPaths_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Path_Order_By>>;
  where?: InputMaybe<Assignment_Path_Bool_Exp>;
};

/** aggregated selection of "assignment" */
export type Assignment_Aggregate = {
  __typename?: 'assignment_aggregate';
  aggregate?: Maybe<Assignment_Aggregate_Fields>;
  nodes: Array<Assignment>;
};

/** aggregate fields of "assignment" */
export type Assignment_Aggregate_Fields = {
  __typename?: 'assignment_aggregate_fields';
  avg?: Maybe<Assignment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Assignment_Max_Fields>;
  min?: Maybe<Assignment_Min_Fields>;
  stddev?: Maybe<Assignment_Stddev_Fields>;
  stddev_pop?: Maybe<Assignment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Assignment_Stddev_Samp_Fields>;
  sum?: Maybe<Assignment_Sum_Fields>;
  var_pop?: Maybe<Assignment_Var_Pop_Fields>;
  var_samp?: Maybe<Assignment_Var_Samp_Fields>;
  variance?: Maybe<Assignment_Variance_Fields>;
};


/** aggregate fields of "assignment" */
export type Assignment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assignment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Assignment_Avg_Fields = {
  __typename?: 'assignment_avg_fields';
  mode?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "assignment". All fields are combined with a logical 'AND'. */
export type Assignment_Bool_Exp = {
  _and?: InputMaybe<Array<Assignment_Bool_Exp>>;
  _not?: InputMaybe<Assignment_Bool_Exp>;
  _or?: InputMaybe<Array<Assignment_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dueDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  learnerGroups?: InputMaybe<Assignment_Learner_Group_Bool_Exp>;
  mode?: InputMaybe<Int_Comparison_Exp>;
  paths?: InputMaybe<Assignment_Path_Bool_Exp>;
  startDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "assignment" */
export enum Assignment_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssignmentPkey = 'assignment_pkey'
}

/** input type for incrementing numeric columns in table "assignment" */
export type Assignment_Inc_Input = {
  mode?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "assignment" */
export type Assignment_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  learnerGroups?: InputMaybe<Assignment_Learner_Group_Arr_Rel_Insert_Input>;
  mode?: InputMaybe<Scalars['Int']>;
  paths?: InputMaybe<Assignment_Path_Arr_Rel_Insert_Input>;
  startDate?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "assignment_learner_group" */
export type Assignment_Learner_Group = {
  __typename?: 'assignment_learner_group';
  /** An object relationship */
  assignment: Assignment;
  assignmentId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  isFinished: Scalars['Boolean'];
  /** An object relationship */
  learnerGroup: Learner_Group;
  learnerGroupId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "assignment_learner_group" */
export type Assignment_Learner_Group_Aggregate = {
  __typename?: 'assignment_learner_group_aggregate';
  aggregate?: Maybe<Assignment_Learner_Group_Aggregate_Fields>;
  nodes: Array<Assignment_Learner_Group>;
};

/** aggregate fields of "assignment_learner_group" */
export type Assignment_Learner_Group_Aggregate_Fields = {
  __typename?: 'assignment_learner_group_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Assignment_Learner_Group_Max_Fields>;
  min?: Maybe<Assignment_Learner_Group_Min_Fields>;
};


/** aggregate fields of "assignment_learner_group" */
export type Assignment_Learner_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assignment_Learner_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "assignment_learner_group" */
export type Assignment_Learner_Group_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Assignment_Learner_Group_Max_Order_By>;
  min?: InputMaybe<Assignment_Learner_Group_Min_Order_By>;
};

/** input type for inserting array relation for remote table "assignment_learner_group" */
export type Assignment_Learner_Group_Arr_Rel_Insert_Input = {
  data: Array<Assignment_Learner_Group_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Assignment_Learner_Group_On_Conflict>;
};

/** Boolean expression to filter rows from the table "assignment_learner_group". All fields are combined with a logical 'AND'. */
export type Assignment_Learner_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Assignment_Learner_Group_Bool_Exp>>;
  _not?: InputMaybe<Assignment_Learner_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Assignment_Learner_Group_Bool_Exp>>;
  assignment?: InputMaybe<Assignment_Bool_Exp>;
  assignmentId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  isFinished?: InputMaybe<Boolean_Comparison_Exp>;
  learnerGroup?: InputMaybe<Learner_Group_Bool_Exp>;
  learnerGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "assignment_learner_group" */
export enum Assignment_Learner_Group_Constraint {
  /** unique or primary key constraint on columns "assignment_id", "learner_group_id" */
  AssignmentLearnerGroupPkey = 'assignment_learner_group_pkey'
}

/** input type for inserting data into table "assignment_learner_group" */
export type Assignment_Learner_Group_Insert_Input = {
  assignment?: InputMaybe<Assignment_Obj_Rel_Insert_Input>;
  assignmentId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isFinished?: InputMaybe<Scalars['Boolean']>;
  learnerGroup?: InputMaybe<Learner_Group_Obj_Rel_Insert_Input>;
  learnerGroupId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Assignment_Learner_Group_Max_Fields = {
  __typename?: 'assignment_learner_group_max_fields';
  assignmentId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  learnerGroupId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "assignment_learner_group" */
export type Assignment_Learner_Group_Max_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  learnerGroupId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Assignment_Learner_Group_Min_Fields = {
  __typename?: 'assignment_learner_group_min_fields';
  assignmentId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  learnerGroupId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "assignment_learner_group" */
export type Assignment_Learner_Group_Min_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  learnerGroupId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "assignment_learner_group" */
export type Assignment_Learner_Group_Mutation_Response = {
  __typename?: 'assignment_learner_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Assignment_Learner_Group>;
};

/** on_conflict condition type for table "assignment_learner_group" */
export type Assignment_Learner_Group_On_Conflict = {
  constraint: Assignment_Learner_Group_Constraint;
  update_columns?: Array<Assignment_Learner_Group_Update_Column>;
  where?: InputMaybe<Assignment_Learner_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "assignment_learner_group". */
export type Assignment_Learner_Group_Order_By = {
  assignment?: InputMaybe<Assignment_Order_By>;
  assignmentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  isFinished?: InputMaybe<Order_By>;
  learnerGroup?: InputMaybe<Learner_Group_Order_By>;
  learnerGroupId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: assignment_learner_group */
export type Assignment_Learner_Group_Pk_Columns_Input = {
  assignmentId: Scalars['uuid'];
  learnerGroupId: Scalars['uuid'];
};

/** select columns of table "assignment_learner_group" */
export enum Assignment_Learner_Group_Select_Column {
  /** column name */
  AssignmentId = 'assignmentId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  IsFinished = 'isFinished',
  /** column name */
  LearnerGroupId = 'learnerGroupId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "assignment_learner_group" */
export type Assignment_Learner_Group_Set_Input = {
  assignmentId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isFinished?: InputMaybe<Scalars['Boolean']>;
  learnerGroupId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "assignment_learner_group" */
export type Assignment_Learner_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assignment_Learner_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assignment_Learner_Group_Stream_Cursor_Value_Input = {
  assignmentId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isFinished?: InputMaybe<Scalars['Boolean']>;
  learnerGroupId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "assignment_learner_group" */
export enum Assignment_Learner_Group_Update_Column {
  /** column name */
  AssignmentId = 'assignmentId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  IsFinished = 'isFinished',
  /** column name */
  LearnerGroupId = 'learnerGroupId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Assignment_Learner_Group_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assignment_Learner_Group_Set_Input>;
  where: Assignment_Learner_Group_Bool_Exp;
};

/** aggregate max on columns */
export type Assignment_Max_Fields = {
  __typename?: 'assignment_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  mode?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Assignment_Min_Fields = {
  __typename?: 'assignment_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  mode?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "assignment" */
export type Assignment_Mutation_Response = {
  __typename?: 'assignment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Assignment>;
};

/** input type for inserting object relation for remote table "assignment" */
export type Assignment_Obj_Rel_Insert_Input = {
  data: Assignment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Assignment_On_Conflict>;
};

/** on_conflict condition type for table "assignment" */
export type Assignment_On_Conflict = {
  constraint: Assignment_Constraint;
  update_columns?: Array<Assignment_Update_Column>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};

/** Ordering options when selecting data from "assignment". */
export type Assignment_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dueDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  learnerGroups_aggregate?: InputMaybe<Assignment_Learner_Group_Aggregate_Order_By>;
  mode?: InputMaybe<Order_By>;
  paths_aggregate?: InputMaybe<Assignment_Path_Aggregate_Order_By>;
  startDate?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "assignment_path" */
export type Assignment_Path = {
  __typename?: 'assignment_path';
  /** An object relationship */
  assignment: Assignment;
  assignmentId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  path: Path;
  pathId: Scalars['bigint'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "assignment_path" */
export type Assignment_Path_Aggregate = {
  __typename?: 'assignment_path_aggregate';
  aggregate?: Maybe<Assignment_Path_Aggregate_Fields>;
  nodes: Array<Assignment_Path>;
};

/** aggregate fields of "assignment_path" */
export type Assignment_Path_Aggregate_Fields = {
  __typename?: 'assignment_path_aggregate_fields';
  avg?: Maybe<Assignment_Path_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Assignment_Path_Max_Fields>;
  min?: Maybe<Assignment_Path_Min_Fields>;
  stddev?: Maybe<Assignment_Path_Stddev_Fields>;
  stddev_pop?: Maybe<Assignment_Path_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Assignment_Path_Stddev_Samp_Fields>;
  sum?: Maybe<Assignment_Path_Sum_Fields>;
  var_pop?: Maybe<Assignment_Path_Var_Pop_Fields>;
  var_samp?: Maybe<Assignment_Path_Var_Samp_Fields>;
  variance?: Maybe<Assignment_Path_Variance_Fields>;
};


/** aggregate fields of "assignment_path" */
export type Assignment_Path_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assignment_Path_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "assignment_path" */
export type Assignment_Path_Aggregate_Order_By = {
  avg?: InputMaybe<Assignment_Path_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Assignment_Path_Max_Order_By>;
  min?: InputMaybe<Assignment_Path_Min_Order_By>;
  stddev?: InputMaybe<Assignment_Path_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Assignment_Path_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Assignment_Path_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Assignment_Path_Sum_Order_By>;
  var_pop?: InputMaybe<Assignment_Path_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Assignment_Path_Var_Samp_Order_By>;
  variance?: InputMaybe<Assignment_Path_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "assignment_path" */
export type Assignment_Path_Arr_Rel_Insert_Input = {
  data: Array<Assignment_Path_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Assignment_Path_On_Conflict>;
};

/** aggregate avg on columns */
export type Assignment_Path_Avg_Fields = {
  __typename?: 'assignment_path_avg_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "assignment_path" */
export type Assignment_Path_Avg_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "assignment_path". All fields are combined with a logical 'AND'. */
export type Assignment_Path_Bool_Exp = {
  _and?: InputMaybe<Array<Assignment_Path_Bool_Exp>>;
  _not?: InputMaybe<Assignment_Path_Bool_Exp>;
  _or?: InputMaybe<Array<Assignment_Path_Bool_Exp>>;
  assignment?: InputMaybe<Assignment_Bool_Exp>;
  assignmentId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  path?: InputMaybe<Path_Bool_Exp>;
  pathId?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "assignment_path" */
export enum Assignment_Path_Constraint {
  /** unique or primary key constraint on columns "assignment_id", "path_id" */
  AssignmentPathPkey = 'assignment_path_pkey'
}

/** input type for incrementing numeric columns in table "assignment_path" */
export type Assignment_Path_Inc_Input = {
  pathId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "assignment_path" */
export type Assignment_Path_Insert_Input = {
  assignment?: InputMaybe<Assignment_Obj_Rel_Insert_Input>;
  assignmentId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  path?: InputMaybe<Path_Obj_Rel_Insert_Input>;
  pathId?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Assignment_Path_Max_Fields = {
  __typename?: 'assignment_path_max_fields';
  assignmentId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  pathId?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "assignment_path" */
export type Assignment_Path_Max_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Assignment_Path_Min_Fields = {
  __typename?: 'assignment_path_min_fields';
  assignmentId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  pathId?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "assignment_path" */
export type Assignment_Path_Min_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "assignment_path" */
export type Assignment_Path_Mutation_Response = {
  __typename?: 'assignment_path_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Assignment_Path>;
};

/** on_conflict condition type for table "assignment_path" */
export type Assignment_Path_On_Conflict = {
  constraint: Assignment_Path_Constraint;
  update_columns?: Array<Assignment_Path_Update_Column>;
  where?: InputMaybe<Assignment_Path_Bool_Exp>;
};

/** Ordering options when selecting data from "assignment_path". */
export type Assignment_Path_Order_By = {
  assignment?: InputMaybe<Assignment_Order_By>;
  assignmentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  path?: InputMaybe<Path_Order_By>;
  pathId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: assignment_path */
export type Assignment_Path_Pk_Columns_Input = {
  assignmentId: Scalars['uuid'];
  pathId: Scalars['bigint'];
};

/** select columns of table "assignment_path" */
export enum Assignment_Path_Select_Column {
  /** column name */
  AssignmentId = 'assignmentId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  PathId = 'pathId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "assignment_path" */
export type Assignment_Path_Set_Input = {
  assignmentId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  pathId?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Assignment_Path_Stddev_Fields = {
  __typename?: 'assignment_path_stddev_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "assignment_path" */
export type Assignment_Path_Stddev_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Assignment_Path_Stddev_Pop_Fields = {
  __typename?: 'assignment_path_stddev_pop_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "assignment_path" */
export type Assignment_Path_Stddev_Pop_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Assignment_Path_Stddev_Samp_Fields = {
  __typename?: 'assignment_path_stddev_samp_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "assignment_path" */
export type Assignment_Path_Stddev_Samp_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "assignment_path" */
export type Assignment_Path_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assignment_Path_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assignment_Path_Stream_Cursor_Value_Input = {
  assignmentId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  pathId?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Assignment_Path_Sum_Fields = {
  __typename?: 'assignment_path_sum_fields';
  pathId?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "assignment_path" */
export type Assignment_Path_Sum_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** update columns of table "assignment_path" */
export enum Assignment_Path_Update_Column {
  /** column name */
  AssignmentId = 'assignmentId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  PathId = 'pathId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Assignment_Path_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Assignment_Path_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assignment_Path_Set_Input>;
  where: Assignment_Path_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Assignment_Path_Var_Pop_Fields = {
  __typename?: 'assignment_path_var_pop_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "assignment_path" */
export type Assignment_Path_Var_Pop_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Assignment_Path_Var_Samp_Fields = {
  __typename?: 'assignment_path_var_samp_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "assignment_path" */
export type Assignment_Path_Var_Samp_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Assignment_Path_Variance_Fields = {
  __typename?: 'assignment_path_variance_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "assignment_path" */
export type Assignment_Path_Variance_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: assignment */
export type Assignment_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "assignment" */
export enum Assignment_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  DueDate = 'dueDate',
  /** column name */
  Id = 'id',
  /** column name */
  Mode = 'mode',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "assignment" */
export type Assignment_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  mode?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Assignment_Stddev_Fields = {
  __typename?: 'assignment_stddev_fields';
  mode?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Assignment_Stddev_Pop_Fields = {
  __typename?: 'assignment_stddev_pop_fields';
  mode?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Assignment_Stddev_Samp_Fields = {
  __typename?: 'assignment_stddev_samp_fields';
  mode?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "assignment" */
export type Assignment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assignment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assignment_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  mode?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Assignment_Sum_Fields = {
  __typename?: 'assignment_sum_fields';
  mode?: Maybe<Scalars['Int']>;
};

/** update columns of table "assignment" */
export enum Assignment_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  DueDate = 'dueDate',
  /** column name */
  Id = 'id',
  /** column name */
  Mode = 'mode',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Assignment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Assignment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assignment_Set_Input>;
  where: Assignment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Assignment_Var_Pop_Fields = {
  __typename?: 'assignment_var_pop_fields';
  mode?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Assignment_Var_Samp_Fields = {
  __typename?: 'assignment_var_samp_fields';
  mode?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Assignment_Variance_Fields = {
  __typename?: 'assignment_variance_fields';
  mode?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "award" */
export type Award = {
  __typename?: 'award';
  bonus: Scalars['Int'];
  bonusDescription?: Maybe<Scalars['String']>;
  cost: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  description: Scalars['String'];
  disabled: Scalars['Boolean'];
  filePath: Scalars['String'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  ownerId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "award" */
export type Award_Aggregate = {
  __typename?: 'award_aggregate';
  aggregate?: Maybe<Award_Aggregate_Fields>;
  nodes: Array<Award>;
};

/** aggregate fields of "award" */
export type Award_Aggregate_Fields = {
  __typename?: 'award_aggregate_fields';
  avg?: Maybe<Award_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Award_Max_Fields>;
  min?: Maybe<Award_Min_Fields>;
  stddev?: Maybe<Award_Stddev_Fields>;
  stddev_pop?: Maybe<Award_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Award_Stddev_Samp_Fields>;
  sum?: Maybe<Award_Sum_Fields>;
  var_pop?: Maybe<Award_Var_Pop_Fields>;
  var_samp?: Maybe<Award_Var_Samp_Fields>;
  variance?: Maybe<Award_Variance_Fields>;
};


/** aggregate fields of "award" */
export type Award_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Award_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Award_Avg_Fields = {
  __typename?: 'award_avg_fields';
  bonus?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "award". All fields are combined with a logical 'AND'. */
export type Award_Bool_Exp = {
  _and?: InputMaybe<Array<Award_Bool_Exp>>;
  _not?: InputMaybe<Award_Bool_Exp>;
  _or?: InputMaybe<Array<Award_Bool_Exp>>;
  bonus?: InputMaybe<Int_Comparison_Exp>;
  bonusDescription?: InputMaybe<String_Comparison_Exp>;
  cost?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  filePath?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  ownerId?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "award" */
export enum Award_Constraint {
  /** unique or primary key constraint on columns "id" */
  AwardsPkey = 'awards_pkey'
}

/** input type for incrementing numeric columns in table "award" */
export type Award_Inc_Input = {
  bonus?: InputMaybe<Scalars['Int']>;
  cost?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "award" */
export type Award_Insert_Input = {
  bonus?: InputMaybe<Scalars['Int']>;
  bonusDescription?: InputMaybe<Scalars['String']>;
  cost?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  filePath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Award_Max_Fields = {
  __typename?: 'award_max_fields';
  bonus?: Maybe<Scalars['Int']>;
  bonusDescription?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  filePath?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Award_Min_Fields = {
  __typename?: 'award_min_fields';
  bonus?: Maybe<Scalars['Int']>;
  bonusDescription?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  filePath?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "award" */
export type Award_Mutation_Response = {
  __typename?: 'award_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Award>;
};

/** input type for inserting object relation for remote table "award" */
export type Award_Obj_Rel_Insert_Input = {
  data: Award_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Award_On_Conflict>;
};

/** on_conflict condition type for table "award" */
export type Award_On_Conflict = {
  constraint: Award_Constraint;
  update_columns?: Array<Award_Update_Column>;
  where?: InputMaybe<Award_Bool_Exp>;
};

/** Ordering options when selecting data from "award". */
export type Award_Order_By = {
  bonus?: InputMaybe<Order_By>;
  bonusDescription?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  disabled?: InputMaybe<Order_By>;
  filePath?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  ownerId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: award */
export type Award_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "award" */
export enum Award_Select_Column {
  /** column name */
  Bonus = 'bonus',
  /** column name */
  BonusDescription = 'bonusDescription',
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  FilePath = 'filePath',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerId = 'ownerId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "award" */
export type Award_Set_Input = {
  bonus?: InputMaybe<Scalars['Int']>;
  bonusDescription?: InputMaybe<Scalars['String']>;
  cost?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  filePath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Award_Stddev_Fields = {
  __typename?: 'award_stddev_fields';
  bonus?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Award_Stddev_Pop_Fields = {
  __typename?: 'award_stddev_pop_fields';
  bonus?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Award_Stddev_Samp_Fields = {
  __typename?: 'award_stddev_samp_fields';
  bonus?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "award" */
export type Award_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Award_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Award_Stream_Cursor_Value_Input = {
  bonus?: InputMaybe<Scalars['Int']>;
  bonusDescription?: InputMaybe<Scalars['String']>;
  cost?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  filePath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Award_Sum_Fields = {
  __typename?: 'award_sum_fields';
  bonus?: Maybe<Scalars['Int']>;
  cost?: Maybe<Scalars['Int']>;
};

/** update columns of table "award" */
export enum Award_Update_Column {
  /** column name */
  Bonus = 'bonus',
  /** column name */
  BonusDescription = 'bonusDescription',
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  FilePath = 'filePath',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerId = 'ownerId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Award_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Award_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Award_Set_Input>;
  where: Award_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Award_Var_Pop_Fields = {
  __typename?: 'award_var_pop_fields';
  bonus?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Award_Var_Samp_Fields = {
  __typename?: 'award_var_samp_fields';
  bonus?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Award_Variance_Fields = {
  __typename?: 'award_variance_fields';
  bonus?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

export type Classroom_Input = {
  id: Scalars['String'];
  name: Scalars['String'];
};

/** columns and relationships of "coin_trx" */
export type Coin_Trx = {
  __typename?: 'coin_trx';
  amount: Scalars['Int'];
  balance: Scalars['Int'];
  category: Enums_Coin_Trx_Category_Enum;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userId: Scalars['String'];
};

/** aggregated selection of "coin_trx" */
export type Coin_Trx_Aggregate = {
  __typename?: 'coin_trx_aggregate';
  aggregate?: Maybe<Coin_Trx_Aggregate_Fields>;
  nodes: Array<Coin_Trx>;
};

/** aggregate fields of "coin_trx" */
export type Coin_Trx_Aggregate_Fields = {
  __typename?: 'coin_trx_aggregate_fields';
  avg?: Maybe<Coin_Trx_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Coin_Trx_Max_Fields>;
  min?: Maybe<Coin_Trx_Min_Fields>;
  stddev?: Maybe<Coin_Trx_Stddev_Fields>;
  stddev_pop?: Maybe<Coin_Trx_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Coin_Trx_Stddev_Samp_Fields>;
  sum?: Maybe<Coin_Trx_Sum_Fields>;
  var_pop?: Maybe<Coin_Trx_Var_Pop_Fields>;
  var_samp?: Maybe<Coin_Trx_Var_Samp_Fields>;
  variance?: Maybe<Coin_Trx_Variance_Fields>;
};


/** aggregate fields of "coin_trx" */
export type Coin_Trx_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Coin_Trx_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "coin_trx" */
export type Coin_Trx_Aggregate_Order_By = {
  avg?: InputMaybe<Coin_Trx_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Coin_Trx_Max_Order_By>;
  min?: InputMaybe<Coin_Trx_Min_Order_By>;
  stddev?: InputMaybe<Coin_Trx_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Coin_Trx_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Coin_Trx_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Coin_Trx_Sum_Order_By>;
  var_pop?: InputMaybe<Coin_Trx_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Coin_Trx_Var_Samp_Order_By>;
  variance?: InputMaybe<Coin_Trx_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "coin_trx" */
export type Coin_Trx_Arr_Rel_Insert_Input = {
  data: Array<Coin_Trx_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Coin_Trx_On_Conflict>;
};

/** aggregate avg on columns */
export type Coin_Trx_Avg_Fields = {
  __typename?: 'coin_trx_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "coin_trx" */
export type Coin_Trx_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "coin_trx". All fields are combined with a logical 'AND'. */
export type Coin_Trx_Bool_Exp = {
  _and?: InputMaybe<Array<Coin_Trx_Bool_Exp>>;
  _not?: InputMaybe<Coin_Trx_Bool_Exp>;
  _or?: InputMaybe<Array<Coin_Trx_Bool_Exp>>;
  amount?: InputMaybe<Int_Comparison_Exp>;
  balance?: InputMaybe<Int_Comparison_Exp>;
  category?: InputMaybe<Enums_Coin_Trx_Category_Enum_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "coin_trx" */
export enum Coin_Trx_Constraint {
  /** unique or primary key constraint on columns "id" */
  CoinLedgerPkey = 'coin_ledger_pkey'
}

/** input type for incrementing numeric columns in table "coin_trx" */
export type Coin_Trx_Inc_Input = {
  amount?: InputMaybe<Scalars['Int']>;
  balance?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "coin_trx" */
export type Coin_Trx_Insert_Input = {
  amount?: InputMaybe<Scalars['Int']>;
  balance?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Enums_Coin_Trx_Category_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Coin_Trx_Max_Fields = {
  __typename?: 'coin_trx_max_fields';
  amount?: Maybe<Scalars['Int']>;
  balance?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "coin_trx" */
export type Coin_Trx_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Coin_Trx_Min_Fields = {
  __typename?: 'coin_trx_min_fields';
  amount?: Maybe<Scalars['Int']>;
  balance?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "coin_trx" */
export type Coin_Trx_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "coin_trx" */
export type Coin_Trx_Mutation_Response = {
  __typename?: 'coin_trx_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Coin_Trx>;
};

/** input type for inserting object relation for remote table "coin_trx" */
export type Coin_Trx_Obj_Rel_Insert_Input = {
  data: Coin_Trx_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Coin_Trx_On_Conflict>;
};

/** on_conflict condition type for table "coin_trx" */
export type Coin_Trx_On_Conflict = {
  constraint: Coin_Trx_Constraint;
  update_columns?: Array<Coin_Trx_Update_Column>;
  where?: InputMaybe<Coin_Trx_Bool_Exp>;
};

/** Ordering options when selecting data from "coin_trx". */
export type Coin_Trx_Order_By = {
  amount?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: coin_trx */
export type Coin_Trx_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "coin_trx" */
export enum Coin_Trx_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Balance = 'balance',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "coin_trx" */
export type Coin_Trx_Set_Input = {
  amount?: InputMaybe<Scalars['Int']>;
  balance?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Enums_Coin_Trx_Category_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Coin_Trx_Stddev_Fields = {
  __typename?: 'coin_trx_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "coin_trx" */
export type Coin_Trx_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Coin_Trx_Stddev_Pop_Fields = {
  __typename?: 'coin_trx_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "coin_trx" */
export type Coin_Trx_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Coin_Trx_Stddev_Samp_Fields = {
  __typename?: 'coin_trx_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "coin_trx" */
export type Coin_Trx_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "coin_trx" */
export type Coin_Trx_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Coin_Trx_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Coin_Trx_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['Int']>;
  balance?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Enums_Coin_Trx_Category_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Coin_Trx_Sum_Fields = {
  __typename?: 'coin_trx_sum_fields';
  amount?: Maybe<Scalars['Int']>;
  balance?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "coin_trx" */
export type Coin_Trx_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
};

/** update columns of table "coin_trx" */
export enum Coin_Trx_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Balance = 'balance',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Coin_Trx_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Coin_Trx_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Coin_Trx_Set_Input>;
  where: Coin_Trx_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Coin_Trx_Var_Pop_Fields = {
  __typename?: 'coin_trx_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "coin_trx" */
export type Coin_Trx_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Coin_Trx_Var_Samp_Fields = {
  __typename?: 'coin_trx_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "coin_trx" */
export type Coin_Trx_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Coin_Trx_Variance_Fields = {
  __typename?: 'coin_trx_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "coin_trx" */
export type Coin_Trx_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
};

/** columns and relationships of "comment" */
export type Comment = {
  __typename?: 'comment';
  createdAt: Scalars['timestamptz'];
  deletedAt: Scalars['timestamptz'];
  giphyId?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  missionComment?: Maybe<Mission_Comment>;
  path?: Maybe<Scalars['ltree']>;
  /** An object relationship */
  pathNodeComment?: Maybe<Path_Node_Comment>;
  /** An object relationship */
  pathReviewComment?: Maybe<Path_Review>;
  /** An object relationship */
  projectComment?: Maybe<Project_Comment>;
  published: Scalars['Boolean'];
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userId: Scalars['String'];
};

/** aggregated selection of "comment" */
export type Comment_Aggregate = {
  __typename?: 'comment_aggregate';
  aggregate?: Maybe<Comment_Aggregate_Fields>;
  nodes: Array<Comment>;
};

/** aggregate fields of "comment" */
export type Comment_Aggregate_Fields = {
  __typename?: 'comment_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Comment_Max_Fields>;
  min?: Maybe<Comment_Min_Fields>;
};


/** aggregate fields of "comment" */
export type Comment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Comment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "comment" */
export type Comment_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Comment_Max_Order_By>;
  min?: InputMaybe<Comment_Min_Order_By>;
};

/** input type for inserting array relation for remote table "comment" */
export type Comment_Arr_Rel_Insert_Input = {
  data: Array<Comment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Comment_On_Conflict>;
};

/** Boolean expression to filter rows from the table "comment". All fields are combined with a logical 'AND'. */
export type Comment_Bool_Exp = {
  _and?: InputMaybe<Array<Comment_Bool_Exp>>;
  _not?: InputMaybe<Comment_Bool_Exp>;
  _or?: InputMaybe<Array<Comment_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  giphyId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  missionComment?: InputMaybe<Mission_Comment_Bool_Exp>;
  path?: InputMaybe<Ltree_Comparison_Exp>;
  pathNodeComment?: InputMaybe<Path_Node_Comment_Bool_Exp>;
  pathReviewComment?: InputMaybe<Path_Review_Bool_Exp>;
  projectComment?: InputMaybe<Project_Comment_Bool_Exp>;
  published?: InputMaybe<Boolean_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "comment" */
export enum Comment_Constraint {
  /** unique or primary key constraint on columns "path" */
  CommentPathUindex = 'comment_path_uindex',
  /** unique or primary key constraint on columns "id" */
  CommentPkey = 'comment_pkey'
}

/** input type for inserting data into table "comment" */
export type Comment_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  giphyId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  missionComment?: InputMaybe<Mission_Comment_Obj_Rel_Insert_Input>;
  path?: InputMaybe<Scalars['ltree']>;
  pathNodeComment?: InputMaybe<Path_Node_Comment_Obj_Rel_Insert_Input>;
  pathReviewComment?: InputMaybe<Path_Review_Obj_Rel_Insert_Input>;
  projectComment?: InputMaybe<Project_Comment_Obj_Rel_Insert_Input>;
  published?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Comment_Max_Fields = {
  __typename?: 'comment_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  giphyId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  path?: Maybe<Scalars['ltree']>;
  text?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "comment" */
export type Comment_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  giphyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Comment_Min_Fields = {
  __typename?: 'comment_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  giphyId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  path?: Maybe<Scalars['ltree']>;
  text?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "comment" */
export type Comment_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  giphyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "comment" */
export type Comment_Mutation_Response = {
  __typename?: 'comment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Comment>;
};

/** input type for inserting object relation for remote table "comment" */
export type Comment_Obj_Rel_Insert_Input = {
  data: Comment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Comment_On_Conflict>;
};

/** on_conflict condition type for table "comment" */
export type Comment_On_Conflict = {
  constraint: Comment_Constraint;
  update_columns?: Array<Comment_Update_Column>;
  where?: InputMaybe<Comment_Bool_Exp>;
};

/** Ordering options when selecting data from "comment". */
export type Comment_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  giphyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  missionComment?: InputMaybe<Mission_Comment_Order_By>;
  path?: InputMaybe<Order_By>;
  pathNodeComment?: InputMaybe<Path_Node_Comment_Order_By>;
  pathReviewComment?: InputMaybe<Path_Review_Order_By>;
  projectComment?: InputMaybe<Project_Comment_Order_By>;
  published?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: comment */
export type Comment_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "comment" */
export enum Comment_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GiphyId = 'giphyId',
  /** column name */
  Id = 'id',
  /** column name */
  Path = 'path',
  /** column name */
  Published = 'published',
  /** column name */
  Text = 'text',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "comment" */
export type Comment_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  giphyId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  path?: InputMaybe<Scalars['ltree']>;
  published?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "comment" */
export type Comment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Comment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Comment_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  giphyId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  path?: InputMaybe<Scalars['ltree']>;
  published?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "comment" */
export enum Comment_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GiphyId = 'giphyId',
  /** column name */
  Id = 'id',
  /** column name */
  Path = 'path',
  /** column name */
  Published = 'published',
  /** column name */
  Text = 'text',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Comment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Comment_Set_Input>;
  where: Comment_Bool_Exp;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Stores codes that students use for creating accounts */
export type Educator_Code = {
  __typename?: 'educator_code';
  available: Scalars['Int'];
  code: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  expiresAt: Scalars['timestamptz'];
  /** An object relationship */
  learnerGroup?: Maybe<Learner_Group>;
  learnerGroupId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  redemptions: Array<Educator_Code_Redemption>;
  /** An aggregate relationship */
  redemptions_aggregate: Educator_Code_Redemption_Aggregate;
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};


/** Stores codes that students use for creating accounts */
export type Educator_CodeRedemptionsArgs = {
  distinct_on?: InputMaybe<Array<Educator_Code_Redemption_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Educator_Code_Redemption_Order_By>>;
  where?: InputMaybe<Educator_Code_Redemption_Bool_Exp>;
};


/** Stores codes that students use for creating accounts */
export type Educator_CodeRedemptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Educator_Code_Redemption_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Educator_Code_Redemption_Order_By>>;
  where?: InputMaybe<Educator_Code_Redemption_Bool_Exp>;
};

/** aggregated selection of "educator_code" */
export type Educator_Code_Aggregate = {
  __typename?: 'educator_code_aggregate';
  aggregate?: Maybe<Educator_Code_Aggregate_Fields>;
  nodes: Array<Educator_Code>;
};

/** aggregate fields of "educator_code" */
export type Educator_Code_Aggregate_Fields = {
  __typename?: 'educator_code_aggregate_fields';
  avg?: Maybe<Educator_Code_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Educator_Code_Max_Fields>;
  min?: Maybe<Educator_Code_Min_Fields>;
  stddev?: Maybe<Educator_Code_Stddev_Fields>;
  stddev_pop?: Maybe<Educator_Code_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Educator_Code_Stddev_Samp_Fields>;
  sum?: Maybe<Educator_Code_Sum_Fields>;
  var_pop?: Maybe<Educator_Code_Var_Pop_Fields>;
  var_samp?: Maybe<Educator_Code_Var_Samp_Fields>;
  variance?: Maybe<Educator_Code_Variance_Fields>;
};


/** aggregate fields of "educator_code" */
export type Educator_Code_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Educator_Code_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "educator_code" */
export type Educator_Code_Aggregate_Order_By = {
  avg?: InputMaybe<Educator_Code_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Educator_Code_Max_Order_By>;
  min?: InputMaybe<Educator_Code_Min_Order_By>;
  stddev?: InputMaybe<Educator_Code_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Educator_Code_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Educator_Code_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Educator_Code_Sum_Order_By>;
  var_pop?: InputMaybe<Educator_Code_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Educator_Code_Var_Samp_Order_By>;
  variance?: InputMaybe<Educator_Code_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "educator_code" */
export type Educator_Code_Arr_Rel_Insert_Input = {
  data: Array<Educator_Code_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Educator_Code_On_Conflict>;
};

/** aggregate avg on columns */
export type Educator_Code_Avg_Fields = {
  __typename?: 'educator_code_avg_fields';
  available?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "educator_code" */
export type Educator_Code_Avg_Order_By = {
  available?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "educator_code". All fields are combined with a logical 'AND'. */
export type Educator_Code_Bool_Exp = {
  _and?: InputMaybe<Array<Educator_Code_Bool_Exp>>;
  _not?: InputMaybe<Educator_Code_Bool_Exp>;
  _or?: InputMaybe<Array<Educator_Code_Bool_Exp>>;
  available?: InputMaybe<Int_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  learnerGroup?: InputMaybe<Learner_Group_Bool_Exp>;
  learnerGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  redemptions?: InputMaybe<Educator_Code_Redemption_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "educator_code" */
export enum Educator_Code_Constraint {
  /** unique or primary key constraint on columns "code" */
  EducatorCodePkey = 'educator_code_pkey'
}

/** input type for incrementing numeric columns in table "educator_code" */
export type Educator_Code_Inc_Input = {
  available?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "educator_code" */
export type Educator_Code_Insert_Input = {
  available?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  learnerGroup?: InputMaybe<Learner_Group_Obj_Rel_Insert_Input>;
  learnerGroupId?: InputMaybe<Scalars['uuid']>;
  redemptions?: InputMaybe<Educator_Code_Redemption_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Educator_Code_Max_Fields = {
  __typename?: 'educator_code_max_fields';
  available?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  learnerGroupId?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "educator_code" */
export type Educator_Code_Max_Order_By = {
  available?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  learnerGroupId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Educator_Code_Min_Fields = {
  __typename?: 'educator_code_min_fields';
  available?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  learnerGroupId?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "educator_code" */
export type Educator_Code_Min_Order_By = {
  available?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  learnerGroupId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "educator_code" */
export type Educator_Code_Mutation_Response = {
  __typename?: 'educator_code_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Educator_Code>;
};

/** input type for inserting object relation for remote table "educator_code" */
export type Educator_Code_Obj_Rel_Insert_Input = {
  data: Educator_Code_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Educator_Code_On_Conflict>;
};

/** on_conflict condition type for table "educator_code" */
export type Educator_Code_On_Conflict = {
  constraint: Educator_Code_Constraint;
  update_columns?: Array<Educator_Code_Update_Column>;
  where?: InputMaybe<Educator_Code_Bool_Exp>;
};

/** Ordering options when selecting data from "educator_code". */
export type Educator_Code_Order_By = {
  available?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  learnerGroup?: InputMaybe<Learner_Group_Order_By>;
  learnerGroupId?: InputMaybe<Order_By>;
  redemptions_aggregate?: InputMaybe<Educator_Code_Redemption_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: educator_code */
export type Educator_Code_Pk_Columns_Input = {
  code: Scalars['String'];
};

/** log of all educator code redemptions */
export type Educator_Code_Redemption = {
  __typename?: 'educator_code_redemption';
  code: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  educatorCode: Educator_Code;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userId: Scalars['String'];
};

/** aggregated selection of "educator_code_redemption" */
export type Educator_Code_Redemption_Aggregate = {
  __typename?: 'educator_code_redemption_aggregate';
  aggregate?: Maybe<Educator_Code_Redemption_Aggregate_Fields>;
  nodes: Array<Educator_Code_Redemption>;
};

/** aggregate fields of "educator_code_redemption" */
export type Educator_Code_Redemption_Aggregate_Fields = {
  __typename?: 'educator_code_redemption_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Educator_Code_Redemption_Max_Fields>;
  min?: Maybe<Educator_Code_Redemption_Min_Fields>;
};


/** aggregate fields of "educator_code_redemption" */
export type Educator_Code_Redemption_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Educator_Code_Redemption_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "educator_code_redemption" */
export type Educator_Code_Redemption_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Educator_Code_Redemption_Max_Order_By>;
  min?: InputMaybe<Educator_Code_Redemption_Min_Order_By>;
};

/** input type for inserting array relation for remote table "educator_code_redemption" */
export type Educator_Code_Redemption_Arr_Rel_Insert_Input = {
  data: Array<Educator_Code_Redemption_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Educator_Code_Redemption_On_Conflict>;
};

/** Boolean expression to filter rows from the table "educator_code_redemption". All fields are combined with a logical 'AND'. */
export type Educator_Code_Redemption_Bool_Exp = {
  _and?: InputMaybe<Array<Educator_Code_Redemption_Bool_Exp>>;
  _not?: InputMaybe<Educator_Code_Redemption_Bool_Exp>;
  _or?: InputMaybe<Array<Educator_Code_Redemption_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  educatorCode?: InputMaybe<Educator_Code_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "educator_code_redemption" */
export enum Educator_Code_Redemption_Constraint {
  /** unique or primary key constraint on columns "code", "user_id" */
  EducatorCodeRedemptionPkey = 'educator_code_redemption_pkey'
}

/** input type for inserting data into table "educator_code_redemption" */
export type Educator_Code_Redemption_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  educatorCode?: InputMaybe<Educator_Code_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Educator_Code_Redemption_Max_Fields = {
  __typename?: 'educator_code_redemption_max_fields';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "educator_code_redemption" */
export type Educator_Code_Redemption_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Educator_Code_Redemption_Min_Fields = {
  __typename?: 'educator_code_redemption_min_fields';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "educator_code_redemption" */
export type Educator_Code_Redemption_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "educator_code_redemption" */
export type Educator_Code_Redemption_Mutation_Response = {
  __typename?: 'educator_code_redemption_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Educator_Code_Redemption>;
};

/** on_conflict condition type for table "educator_code_redemption" */
export type Educator_Code_Redemption_On_Conflict = {
  constraint: Educator_Code_Redemption_Constraint;
  update_columns?: Array<Educator_Code_Redemption_Update_Column>;
  where?: InputMaybe<Educator_Code_Redemption_Bool_Exp>;
};

/** Ordering options when selecting data from "educator_code_redemption". */
export type Educator_Code_Redemption_Order_By = {
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  educatorCode?: InputMaybe<Educator_Code_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: educator_code_redemption */
export type Educator_Code_Redemption_Pk_Columns_Input = {
  code: Scalars['String'];
  userId: Scalars['String'];
};

/** select columns of table "educator_code_redemption" */
export enum Educator_Code_Redemption_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "educator_code_redemption" */
export type Educator_Code_Redemption_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "educator_code_redemption" */
export type Educator_Code_Redemption_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Educator_Code_Redemption_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Educator_Code_Redemption_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "educator_code_redemption" */
export enum Educator_Code_Redemption_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Educator_Code_Redemption_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Educator_Code_Redemption_Set_Input>;
  where: Educator_Code_Redemption_Bool_Exp;
};

/** select columns of table "educator_code" */
export enum Educator_Code_Select_Column {
  /** column name */
  Available = 'available',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  LearnerGroupId = 'learnerGroupId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "educator_code" */
export type Educator_Code_Set_Input = {
  available?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  learnerGroupId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Educator_Code_Stddev_Fields = {
  __typename?: 'educator_code_stddev_fields';
  available?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "educator_code" */
export type Educator_Code_Stddev_Order_By = {
  available?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Educator_Code_Stddev_Pop_Fields = {
  __typename?: 'educator_code_stddev_pop_fields';
  available?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "educator_code" */
export type Educator_Code_Stddev_Pop_Order_By = {
  available?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Educator_Code_Stddev_Samp_Fields = {
  __typename?: 'educator_code_stddev_samp_fields';
  available?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "educator_code" */
export type Educator_Code_Stddev_Samp_Order_By = {
  available?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "educator_code" */
export type Educator_Code_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Educator_Code_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Educator_Code_Stream_Cursor_Value_Input = {
  available?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  learnerGroupId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Educator_Code_Sum_Fields = {
  __typename?: 'educator_code_sum_fields';
  available?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "educator_code" */
export type Educator_Code_Sum_Order_By = {
  available?: InputMaybe<Order_By>;
};

/** update columns of table "educator_code" */
export enum Educator_Code_Update_Column {
  /** column name */
  Available = 'available',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  LearnerGroupId = 'learnerGroupId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Educator_Code_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Educator_Code_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Educator_Code_Set_Input>;
  where: Educator_Code_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Educator_Code_Var_Pop_Fields = {
  __typename?: 'educator_code_var_pop_fields';
  available?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "educator_code" */
export type Educator_Code_Var_Pop_Order_By = {
  available?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Educator_Code_Var_Samp_Fields = {
  __typename?: 'educator_code_var_samp_fields';
  available?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "educator_code" */
export type Educator_Code_Var_Samp_Order_By = {
  available?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Educator_Code_Variance_Fields = {
  __typename?: 'educator_code_variance_fields';
  available?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "educator_code" */
export type Educator_Code_Variance_Order_By = {
  available?: InputMaybe<Order_By>;
};

/** columns and relationships of "enums.coin_trx_category" */
export type Enums_Coin_Trx_Category = {
  __typename?: 'enums_coin_trx_category';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "enums.coin_trx_category" */
export type Enums_Coin_Trx_Category_Aggregate = {
  __typename?: 'enums_coin_trx_category_aggregate';
  aggregate?: Maybe<Enums_Coin_Trx_Category_Aggregate_Fields>;
  nodes: Array<Enums_Coin_Trx_Category>;
};

/** aggregate fields of "enums.coin_trx_category" */
export type Enums_Coin_Trx_Category_Aggregate_Fields = {
  __typename?: 'enums_coin_trx_category_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Enums_Coin_Trx_Category_Max_Fields>;
  min?: Maybe<Enums_Coin_Trx_Category_Min_Fields>;
};


/** aggregate fields of "enums.coin_trx_category" */
export type Enums_Coin_Trx_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enums_Coin_Trx_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enums.coin_trx_category". All fields are combined with a logical 'AND'. */
export type Enums_Coin_Trx_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Enums_Coin_Trx_Category_Bool_Exp>>;
  _not?: InputMaybe<Enums_Coin_Trx_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Enums_Coin_Trx_Category_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enums.coin_trx_category" */
export enum Enums_Coin_Trx_Category_Constraint {
  /** unique or primary key constraint on columns "value" */
  CoinTrxCategoryPkey = 'coin_trx_category_pkey'
}

export enum Enums_Coin_Trx_Category_Enum {
  /** Transaction created from an admin manual adjustment */
  AdminAdjustment = 'admin_adjustment',
  /** Transaction created from a daily gift */
  DailyGift = 'daily_gift',
  /** Transaction created when balance was migrated over from Firestore */
  Migration = 'migration',
  /**  Transaction is the opening balance */
  OpeningBalance = 'opening_balance',
  /** Transaction created from a prize redemption */
  PrizeRedemption = 'prize_redemption',
  /** Transaction created for award giver */
  ProjectAwardBonus = 'project_award_bonus',
  /** Transaction created for project owner */
  ProjectAwardPurchase = 'project_award_purchase',
  /** Transaction created from a project rejection */
  ProjectReject = 'project_reject',
  /** Transaction created when an admin unrejects a project */
  ProjectRejectRefund = 'project_reject_refund',
  /** Transaction created from a project reward */
  ProjectReward = 'project_reward',
  /** Transaction was created for unknown reason */
  Unknown = 'unknown'
}

/** Boolean expression to compare columns of type "enums_coin_trx_category_enum". All fields are combined with logical 'AND'. */
export type Enums_Coin_Trx_Category_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enums_Coin_Trx_Category_Enum>;
  _in?: InputMaybe<Array<Enums_Coin_Trx_Category_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Enums_Coin_Trx_Category_Enum>;
  _nin?: InputMaybe<Array<Enums_Coin_Trx_Category_Enum>>;
};

/** input type for inserting data into table "enums.coin_trx_category" */
export type Enums_Coin_Trx_Category_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Enums_Coin_Trx_Category_Max_Fields = {
  __typename?: 'enums_coin_trx_category_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Enums_Coin_Trx_Category_Min_Fields = {
  __typename?: 'enums_coin_trx_category_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enums.coin_trx_category" */
export type Enums_Coin_Trx_Category_Mutation_Response = {
  __typename?: 'enums_coin_trx_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Enums_Coin_Trx_Category>;
};

/** on_conflict condition type for table "enums.coin_trx_category" */
export type Enums_Coin_Trx_Category_On_Conflict = {
  constraint: Enums_Coin_Trx_Category_Constraint;
  update_columns?: Array<Enums_Coin_Trx_Category_Update_Column>;
  where?: InputMaybe<Enums_Coin_Trx_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "enums.coin_trx_category". */
export type Enums_Coin_Trx_Category_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enums.coin_trx_category */
export type Enums_Coin_Trx_Category_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "enums.coin_trx_category" */
export enum Enums_Coin_Trx_Category_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enums.coin_trx_category" */
export type Enums_Coin_Trx_Category_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "enums_coin_trx_category" */
export type Enums_Coin_Trx_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enums_Coin_Trx_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enums_Coin_Trx_Category_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "enums.coin_trx_category" */
export enum Enums_Coin_Trx_Category_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Enums_Coin_Trx_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enums_Coin_Trx_Category_Set_Input>;
  where: Enums_Coin_Trx_Category_Bool_Exp;
};

/** integration providers like Google or Clever */
export type Enums_Integration_Provider = {
  __typename?: 'enums_integration_provider';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "enums.integration_provider" */
export type Enums_Integration_Provider_Aggregate = {
  __typename?: 'enums_integration_provider_aggregate';
  aggregate?: Maybe<Enums_Integration_Provider_Aggregate_Fields>;
  nodes: Array<Enums_Integration_Provider>;
};

/** aggregate fields of "enums.integration_provider" */
export type Enums_Integration_Provider_Aggregate_Fields = {
  __typename?: 'enums_integration_provider_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Enums_Integration_Provider_Max_Fields>;
  min?: Maybe<Enums_Integration_Provider_Min_Fields>;
};


/** aggregate fields of "enums.integration_provider" */
export type Enums_Integration_Provider_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enums_Integration_Provider_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enums.integration_provider". All fields are combined with a logical 'AND'. */
export type Enums_Integration_Provider_Bool_Exp = {
  _and?: InputMaybe<Array<Enums_Integration_Provider_Bool_Exp>>;
  _not?: InputMaybe<Enums_Integration_Provider_Bool_Exp>;
  _or?: InputMaybe<Array<Enums_Integration_Provider_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enums.integration_provider" */
export enum Enums_Integration_Provider_Constraint {
  /** unique or primary key constraint on columns "value" */
  IntegrationProviderPkey = 'integration_provider_pkey'
}

export enum Enums_Integration_Provider_Enum {
  /** https://www.clever.com */
  Clever = 'clever',
  /** https://www.google.com */
  Google = 'google',
  /** https://www.microsoft.com */
  Microsoft = 'microsoft'
}

/** Boolean expression to compare columns of type "enums_integration_provider_enum". All fields are combined with logical 'AND'. */
export type Enums_Integration_Provider_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enums_Integration_Provider_Enum>;
  _in?: InputMaybe<Array<Enums_Integration_Provider_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Enums_Integration_Provider_Enum>;
  _nin?: InputMaybe<Array<Enums_Integration_Provider_Enum>>;
};

/** input type for inserting data into table "enums.integration_provider" */
export type Enums_Integration_Provider_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Enums_Integration_Provider_Max_Fields = {
  __typename?: 'enums_integration_provider_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Enums_Integration_Provider_Min_Fields = {
  __typename?: 'enums_integration_provider_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enums.integration_provider" */
export type Enums_Integration_Provider_Mutation_Response = {
  __typename?: 'enums_integration_provider_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Enums_Integration_Provider>;
};

/** on_conflict condition type for table "enums.integration_provider" */
export type Enums_Integration_Provider_On_Conflict = {
  constraint: Enums_Integration_Provider_Constraint;
  update_columns?: Array<Enums_Integration_Provider_Update_Column>;
  where?: InputMaybe<Enums_Integration_Provider_Bool_Exp>;
};

/** Ordering options when selecting data from "enums.integration_provider". */
export type Enums_Integration_Provider_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enums.integration_provider */
export type Enums_Integration_Provider_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "enums.integration_provider" */
export enum Enums_Integration_Provider_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enums.integration_provider" */
export type Enums_Integration_Provider_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "enums_integration_provider" */
export type Enums_Integration_Provider_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enums_Integration_Provider_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enums_Integration_Provider_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "enums.integration_provider" */
export enum Enums_Integration_Provider_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Enums_Integration_Provider_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enums_Integration_Provider_Set_Input>;
  where: Enums_Integration_Provider_Bool_Exp;
};

/** columns and relationships of "enums.project_status" */
export type Enums_Project_Status = {
  __typename?: 'enums_project_status';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "enums.project_status" */
export type Enums_Project_Status_Aggregate = {
  __typename?: 'enums_project_status_aggregate';
  aggregate?: Maybe<Enums_Project_Status_Aggregate_Fields>;
  nodes: Array<Enums_Project_Status>;
};

/** aggregate fields of "enums.project_status" */
export type Enums_Project_Status_Aggregate_Fields = {
  __typename?: 'enums_project_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Enums_Project_Status_Max_Fields>;
  min?: Maybe<Enums_Project_Status_Min_Fields>;
};


/** aggregate fields of "enums.project_status" */
export type Enums_Project_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enums_Project_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enums.project_status". All fields are combined with a logical 'AND'. */
export type Enums_Project_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Enums_Project_Status_Bool_Exp>>;
  _not?: InputMaybe<Enums_Project_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Enums_Project_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enums.project_status" */
export enum Enums_Project_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  ProjectStatusPkey = 'project_status_pkey'
}

/** input type for inserting data into table "enums.project_status" */
export type Enums_Project_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Enums_Project_Status_Max_Fields = {
  __typename?: 'enums_project_status_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Enums_Project_Status_Min_Fields = {
  __typename?: 'enums_project_status_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enums.project_status" */
export type Enums_Project_Status_Mutation_Response = {
  __typename?: 'enums_project_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Enums_Project_Status>;
};

/** on_conflict condition type for table "enums.project_status" */
export type Enums_Project_Status_On_Conflict = {
  constraint: Enums_Project_Status_Constraint;
  update_columns?: Array<Enums_Project_Status_Update_Column>;
  where?: InputMaybe<Enums_Project_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "enums.project_status". */
export type Enums_Project_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enums.project_status */
export type Enums_Project_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "enums.project_status" */
export enum Enums_Project_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enums.project_status" */
export type Enums_Project_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "enums_project_status" */
export type Enums_Project_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enums_Project_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enums_Project_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "enums.project_status" */
export enum Enums_Project_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Enums_Project_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enums_Project_Status_Set_Input>;
  where: Enums_Project_Status_Bool_Exp;
};

/** Teacher project guides */
export type Guide = {
  __typename?: 'guide';
  bigIdea?: Maybe<Scalars['String']>;
  concepts?: Maybe<Scalars['String']>;
  contentStandards?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  discussionQuestions?: Maybe<Scalars['String']>;
  downloadUrl?: Maybe<Scalars['String']>;
  /** units: days */
  durationLower?: Maybe<Scalars['Int']>;
  /** units: days */
  durationUpper?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  learningObjectives?: Maybe<Scalars['String']>;
  /** An array relationship */
  paths: Array<Guide_Path>;
  /** An aggregate relationship */
  paths_aggregate: Guide_Path_Aggregate;
  resources?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};


/** Teacher project guides */
export type GuidePathsArgs = {
  distinct_on?: InputMaybe<Array<Guide_Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guide_Path_Order_By>>;
  where?: InputMaybe<Guide_Path_Bool_Exp>;
};


/** Teacher project guides */
export type GuidePaths_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Guide_Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guide_Path_Order_By>>;
  where?: InputMaybe<Guide_Path_Bool_Exp>;
};

/** aggregated selection of "guide" */
export type Guide_Aggregate = {
  __typename?: 'guide_aggregate';
  aggregate?: Maybe<Guide_Aggregate_Fields>;
  nodes: Array<Guide>;
};

/** aggregate fields of "guide" */
export type Guide_Aggregate_Fields = {
  __typename?: 'guide_aggregate_fields';
  avg?: Maybe<Guide_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Guide_Max_Fields>;
  min?: Maybe<Guide_Min_Fields>;
  stddev?: Maybe<Guide_Stddev_Fields>;
  stddev_pop?: Maybe<Guide_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Guide_Stddev_Samp_Fields>;
  sum?: Maybe<Guide_Sum_Fields>;
  var_pop?: Maybe<Guide_Var_Pop_Fields>;
  var_samp?: Maybe<Guide_Var_Samp_Fields>;
  variance?: Maybe<Guide_Variance_Fields>;
};


/** aggregate fields of "guide" */
export type Guide_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Guide_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Guide_Avg_Fields = {
  __typename?: 'guide_avg_fields';
  /** units: days */
  durationLower?: Maybe<Scalars['Float']>;
  /** units: days */
  durationUpper?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "guide". All fields are combined with a logical 'AND'. */
export type Guide_Bool_Exp = {
  _and?: InputMaybe<Array<Guide_Bool_Exp>>;
  _not?: InputMaybe<Guide_Bool_Exp>;
  _or?: InputMaybe<Array<Guide_Bool_Exp>>;
  bigIdea?: InputMaybe<String_Comparison_Exp>;
  concepts?: InputMaybe<String_Comparison_Exp>;
  contentStandards?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  discussionQuestions?: InputMaybe<String_Comparison_Exp>;
  downloadUrl?: InputMaybe<String_Comparison_Exp>;
  durationLower?: InputMaybe<Int_Comparison_Exp>;
  durationUpper?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  learningObjectives?: InputMaybe<String_Comparison_Exp>;
  paths?: InputMaybe<Guide_Path_Bool_Exp>;
  resources?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "guide" */
export enum Guide_Constraint {
  /** unique or primary key constraint on columns "id" */
  GuidePkey = 'guide_pkey'
}

/** input type for incrementing numeric columns in table "guide" */
export type Guide_Inc_Input = {
  /** units: days */
  durationLower?: InputMaybe<Scalars['Int']>;
  /** units: days */
  durationUpper?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "guide" */
export type Guide_Insert_Input = {
  bigIdea?: InputMaybe<Scalars['String']>;
  concepts?: InputMaybe<Scalars['String']>;
  contentStandards?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  discussionQuestions?: InputMaybe<Scalars['String']>;
  downloadUrl?: InputMaybe<Scalars['String']>;
  /** units: days */
  durationLower?: InputMaybe<Scalars['Int']>;
  /** units: days */
  durationUpper?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningObjectives?: InputMaybe<Scalars['String']>;
  paths?: InputMaybe<Guide_Path_Arr_Rel_Insert_Input>;
  resources?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Guide_Max_Fields = {
  __typename?: 'guide_max_fields';
  bigIdea?: Maybe<Scalars['String']>;
  concepts?: Maybe<Scalars['String']>;
  contentStandards?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  discussionQuestions?: Maybe<Scalars['String']>;
  downloadUrl?: Maybe<Scalars['String']>;
  /** units: days */
  durationLower?: Maybe<Scalars['Int']>;
  /** units: days */
  durationUpper?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  learningObjectives?: Maybe<Scalars['String']>;
  resources?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Guide_Min_Fields = {
  __typename?: 'guide_min_fields';
  bigIdea?: Maybe<Scalars['String']>;
  concepts?: Maybe<Scalars['String']>;
  contentStandards?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  discussionQuestions?: Maybe<Scalars['String']>;
  downloadUrl?: Maybe<Scalars['String']>;
  /** units: days */
  durationLower?: Maybe<Scalars['Int']>;
  /** units: days */
  durationUpper?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  learningObjectives?: Maybe<Scalars['String']>;
  resources?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "guide" */
export type Guide_Mutation_Response = {
  __typename?: 'guide_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Guide>;
};

/** input type for inserting object relation for remote table "guide" */
export type Guide_Obj_Rel_Insert_Input = {
  data: Guide_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Guide_On_Conflict>;
};

/** on_conflict condition type for table "guide" */
export type Guide_On_Conflict = {
  constraint: Guide_Constraint;
  update_columns?: Array<Guide_Update_Column>;
  where?: InputMaybe<Guide_Bool_Exp>;
};

/** Ordering options when selecting data from "guide". */
export type Guide_Order_By = {
  bigIdea?: InputMaybe<Order_By>;
  concepts?: InputMaybe<Order_By>;
  contentStandards?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  discussionQuestions?: InputMaybe<Order_By>;
  downloadUrl?: InputMaybe<Order_By>;
  durationLower?: InputMaybe<Order_By>;
  durationUpper?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  learningObjectives?: InputMaybe<Order_By>;
  paths_aggregate?: InputMaybe<Guide_Path_Aggregate_Order_By>;
  resources?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Project guides and attached paths */
export type Guide_Path = {
  __typename?: 'guide_path';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  guide: Guide;
  guideId: Scalars['uuid'];
  isRelatedPath: Scalars['Boolean'];
  /** An object relationship */
  path: Path;
  pathId: Scalars['bigint'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "guide_path" */
export type Guide_Path_Aggregate = {
  __typename?: 'guide_path_aggregate';
  aggregate?: Maybe<Guide_Path_Aggregate_Fields>;
  nodes: Array<Guide_Path>;
};

/** aggregate fields of "guide_path" */
export type Guide_Path_Aggregate_Fields = {
  __typename?: 'guide_path_aggregate_fields';
  avg?: Maybe<Guide_Path_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Guide_Path_Max_Fields>;
  min?: Maybe<Guide_Path_Min_Fields>;
  stddev?: Maybe<Guide_Path_Stddev_Fields>;
  stddev_pop?: Maybe<Guide_Path_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Guide_Path_Stddev_Samp_Fields>;
  sum?: Maybe<Guide_Path_Sum_Fields>;
  var_pop?: Maybe<Guide_Path_Var_Pop_Fields>;
  var_samp?: Maybe<Guide_Path_Var_Samp_Fields>;
  variance?: Maybe<Guide_Path_Variance_Fields>;
};


/** aggregate fields of "guide_path" */
export type Guide_Path_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Guide_Path_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "guide_path" */
export type Guide_Path_Aggregate_Order_By = {
  avg?: InputMaybe<Guide_Path_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Guide_Path_Max_Order_By>;
  min?: InputMaybe<Guide_Path_Min_Order_By>;
  stddev?: InputMaybe<Guide_Path_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Guide_Path_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Guide_Path_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Guide_Path_Sum_Order_By>;
  var_pop?: InputMaybe<Guide_Path_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Guide_Path_Var_Samp_Order_By>;
  variance?: InputMaybe<Guide_Path_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "guide_path" */
export type Guide_Path_Arr_Rel_Insert_Input = {
  data: Array<Guide_Path_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Guide_Path_On_Conflict>;
};

/** aggregate avg on columns */
export type Guide_Path_Avg_Fields = {
  __typename?: 'guide_path_avg_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "guide_path" */
export type Guide_Path_Avg_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "guide_path". All fields are combined with a logical 'AND'. */
export type Guide_Path_Bool_Exp = {
  _and?: InputMaybe<Array<Guide_Path_Bool_Exp>>;
  _not?: InputMaybe<Guide_Path_Bool_Exp>;
  _or?: InputMaybe<Array<Guide_Path_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  guide?: InputMaybe<Guide_Bool_Exp>;
  guideId?: InputMaybe<Uuid_Comparison_Exp>;
  isRelatedPath?: InputMaybe<Boolean_Comparison_Exp>;
  path?: InputMaybe<Path_Bool_Exp>;
  pathId?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "guide_path" */
export enum Guide_Path_Constraint {
  /** unique or primary key constraint on columns "guide_id", "path_id" */
  GuidePathPkey = 'guide_path_pkey'
}

/** input type for incrementing numeric columns in table "guide_path" */
export type Guide_Path_Inc_Input = {
  pathId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "guide_path" */
export type Guide_Path_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  guide?: InputMaybe<Guide_Obj_Rel_Insert_Input>;
  guideId?: InputMaybe<Scalars['uuid']>;
  isRelatedPath?: InputMaybe<Scalars['Boolean']>;
  path?: InputMaybe<Path_Obj_Rel_Insert_Input>;
  pathId?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Guide_Path_Max_Fields = {
  __typename?: 'guide_path_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  guideId?: Maybe<Scalars['uuid']>;
  pathId?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "guide_path" */
export type Guide_Path_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  guideId?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Guide_Path_Min_Fields = {
  __typename?: 'guide_path_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  guideId?: Maybe<Scalars['uuid']>;
  pathId?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "guide_path" */
export type Guide_Path_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  guideId?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "guide_path" */
export type Guide_Path_Mutation_Response = {
  __typename?: 'guide_path_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Guide_Path>;
};

/** on_conflict condition type for table "guide_path" */
export type Guide_Path_On_Conflict = {
  constraint: Guide_Path_Constraint;
  update_columns?: Array<Guide_Path_Update_Column>;
  where?: InputMaybe<Guide_Path_Bool_Exp>;
};

/** Ordering options when selecting data from "guide_path". */
export type Guide_Path_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  guide?: InputMaybe<Guide_Order_By>;
  guideId?: InputMaybe<Order_By>;
  isRelatedPath?: InputMaybe<Order_By>;
  path?: InputMaybe<Path_Order_By>;
  pathId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: guide_path */
export type Guide_Path_Pk_Columns_Input = {
  guideId: Scalars['uuid'];
  pathId: Scalars['bigint'];
};

/** select columns of table "guide_path" */
export enum Guide_Path_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GuideId = 'guideId',
  /** column name */
  IsRelatedPath = 'isRelatedPath',
  /** column name */
  PathId = 'pathId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "guide_path" */
export type Guide_Path_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  guideId?: InputMaybe<Scalars['uuid']>;
  isRelatedPath?: InputMaybe<Scalars['Boolean']>;
  pathId?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Guide_Path_Stddev_Fields = {
  __typename?: 'guide_path_stddev_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "guide_path" */
export type Guide_Path_Stddev_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Guide_Path_Stddev_Pop_Fields = {
  __typename?: 'guide_path_stddev_pop_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "guide_path" */
export type Guide_Path_Stddev_Pop_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Guide_Path_Stddev_Samp_Fields = {
  __typename?: 'guide_path_stddev_samp_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "guide_path" */
export type Guide_Path_Stddev_Samp_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "guide_path" */
export type Guide_Path_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Guide_Path_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Guide_Path_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  guideId?: InputMaybe<Scalars['uuid']>;
  isRelatedPath?: InputMaybe<Scalars['Boolean']>;
  pathId?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Guide_Path_Sum_Fields = {
  __typename?: 'guide_path_sum_fields';
  pathId?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "guide_path" */
export type Guide_Path_Sum_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** update columns of table "guide_path" */
export enum Guide_Path_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GuideId = 'guideId',
  /** column name */
  IsRelatedPath = 'isRelatedPath',
  /** column name */
  PathId = 'pathId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Guide_Path_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Guide_Path_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Guide_Path_Set_Input>;
  where: Guide_Path_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Guide_Path_Var_Pop_Fields = {
  __typename?: 'guide_path_var_pop_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "guide_path" */
export type Guide_Path_Var_Pop_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Guide_Path_Var_Samp_Fields = {
  __typename?: 'guide_path_var_samp_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "guide_path" */
export type Guide_Path_Var_Samp_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Guide_Path_Variance_Fields = {
  __typename?: 'guide_path_variance_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "guide_path" */
export type Guide_Path_Variance_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: guide */
export type Guide_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "guide" */
export enum Guide_Select_Column {
  /** column name */
  BigIdea = 'bigIdea',
  /** column name */
  Concepts = 'concepts',
  /** column name */
  ContentStandards = 'contentStandards',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  DiscussionQuestions = 'discussionQuestions',
  /** column name */
  DownloadUrl = 'downloadUrl',
  /** column name */
  DurationLower = 'durationLower',
  /** column name */
  DurationUpper = 'durationUpper',
  /** column name */
  Id = 'id',
  /** column name */
  LearningObjectives = 'learningObjectives',
  /** column name */
  Resources = 'resources',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "guide" */
export type Guide_Set_Input = {
  bigIdea?: InputMaybe<Scalars['String']>;
  concepts?: InputMaybe<Scalars['String']>;
  contentStandards?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  discussionQuestions?: InputMaybe<Scalars['String']>;
  downloadUrl?: InputMaybe<Scalars['String']>;
  /** units: days */
  durationLower?: InputMaybe<Scalars['Int']>;
  /** units: days */
  durationUpper?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningObjectives?: InputMaybe<Scalars['String']>;
  resources?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Guide_Stddev_Fields = {
  __typename?: 'guide_stddev_fields';
  /** units: days */
  durationLower?: Maybe<Scalars['Float']>;
  /** units: days */
  durationUpper?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Guide_Stddev_Pop_Fields = {
  __typename?: 'guide_stddev_pop_fields';
  /** units: days */
  durationLower?: Maybe<Scalars['Float']>;
  /** units: days */
  durationUpper?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Guide_Stddev_Samp_Fields = {
  __typename?: 'guide_stddev_samp_fields';
  /** units: days */
  durationLower?: Maybe<Scalars['Float']>;
  /** units: days */
  durationUpper?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "guide" */
export type Guide_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Guide_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Guide_Stream_Cursor_Value_Input = {
  bigIdea?: InputMaybe<Scalars['String']>;
  concepts?: InputMaybe<Scalars['String']>;
  contentStandards?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  discussionQuestions?: InputMaybe<Scalars['String']>;
  downloadUrl?: InputMaybe<Scalars['String']>;
  /** units: days */
  durationLower?: InputMaybe<Scalars['Int']>;
  /** units: days */
  durationUpper?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningObjectives?: InputMaybe<Scalars['String']>;
  resources?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Guide_Sum_Fields = {
  __typename?: 'guide_sum_fields';
  /** units: days */
  durationLower?: Maybe<Scalars['Int']>;
  /** units: days */
  durationUpper?: Maybe<Scalars['Int']>;
};

/** update columns of table "guide" */
export enum Guide_Update_Column {
  /** column name */
  BigIdea = 'bigIdea',
  /** column name */
  Concepts = 'concepts',
  /** column name */
  ContentStandards = 'contentStandards',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  DiscussionQuestions = 'discussionQuestions',
  /** column name */
  DownloadUrl = 'downloadUrl',
  /** column name */
  DurationLower = 'durationLower',
  /** column name */
  DurationUpper = 'durationUpper',
  /** column name */
  Id = 'id',
  /** column name */
  LearningObjectives = 'learningObjectives',
  /** column name */
  Resources = 'resources',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Guide_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Guide_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Guide_Set_Input>;
  where: Guide_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Guide_Var_Pop_Fields = {
  __typename?: 'guide_var_pop_fields';
  /** units: days */
  durationLower?: Maybe<Scalars['Float']>;
  /** units: days */
  durationUpper?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Guide_Var_Samp_Fields = {
  __typename?: 'guide_var_samp_fields';
  /** units: days */
  durationLower?: Maybe<Scalars['Float']>;
  /** units: days */
  durationUpper?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Guide_Variance_Fields = {
  __typename?: 'guide_variance_fields';
  /** units: days */
  durationLower?: Maybe<Scalars['Float']>;
  /** units: days */
  durationUpper?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']>;
  _gt?: InputMaybe<Scalars['json']>;
  _gte?: InputMaybe<Scalars['json']>;
  _in?: InputMaybe<Array<Scalars['json']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['json']>;
  _lte?: InputMaybe<Scalars['json']>;
  _neq?: InputMaybe<Scalars['json']>;
  _nin?: InputMaybe<Array<Scalars['json']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "learner_group" */
export type Learner_Group = {
  __typename?: 'learner_group';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  assignments: Array<Assignment_Learner_Group>;
  /** An aggregate relationship */
  assignments_aggregate: Assignment_Learner_Group_Aggregate;
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  educatorCodes: Array<Educator_Code>;
  /** An aggregate relationship */
  educatorCodes_aggregate: Educator_Code_Aggregate;
  firestoreId?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An array relationship */
  learner_group_path_collections: Array<Learner_Group_Path_Collection>;
  /** An aggregate relationship */
  learner_group_path_collections_aggregate: Learner_Group_Path_Collection_Aggregate;
  /** An array relationship */
  members: Array<Learner_Group_Member>;
  /** An aggregate relationship */
  members_aggregate: Learner_Group_Member_Aggregate;
  name?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
  /** An object relationship */
  organization?: Maybe<Organization>;
  pathPrivacy?: Maybe<Scalars['String']>;
  /** An array relationship */
  pendingMembers: Array<Learner_Group_Pending_Member>;
  /** An aggregate relationship */
  pendingMembers_aggregate: Learner_Group_Pending_Member_Aggregate;
  privacyScope?: Maybe<Scalars['String']>;
  profilePrivacy?: Maybe<Scalars['String']>;
  projectPrivacy?: Maybe<Scalars['String']>;
  source?: Maybe<Enums_Integration_Provider_Enum>;
  sourceId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "learner_group" */
export type Learner_GroupAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Learner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Learner_Group_Order_By>>;
  where?: InputMaybe<Assignment_Learner_Group_Bool_Exp>;
};


/** columns and relationships of "learner_group" */
export type Learner_GroupAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Learner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Learner_Group_Order_By>>;
  where?: InputMaybe<Assignment_Learner_Group_Bool_Exp>;
};


/** columns and relationships of "learner_group" */
export type Learner_GroupEducatorCodesArgs = {
  distinct_on?: InputMaybe<Array<Educator_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Educator_Code_Order_By>>;
  where?: InputMaybe<Educator_Code_Bool_Exp>;
};


/** columns and relationships of "learner_group" */
export type Learner_GroupEducatorCodes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Educator_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Educator_Code_Order_By>>;
  where?: InputMaybe<Educator_Code_Bool_Exp>;
};


/** columns and relationships of "learner_group" */
export type Learner_GroupLearner_Group_Path_CollectionsArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Path_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Path_Collection_Order_By>>;
  where?: InputMaybe<Learner_Group_Path_Collection_Bool_Exp>;
};


/** columns and relationships of "learner_group" */
export type Learner_GroupLearner_Group_Path_Collections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Path_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Path_Collection_Order_By>>;
  where?: InputMaybe<Learner_Group_Path_Collection_Bool_Exp>;
};


/** columns and relationships of "learner_group" */
export type Learner_GroupMembersArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Member_Order_By>>;
  where?: InputMaybe<Learner_Group_Member_Bool_Exp>;
};


/** columns and relationships of "learner_group" */
export type Learner_GroupMembers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Member_Order_By>>;
  where?: InputMaybe<Learner_Group_Member_Bool_Exp>;
};


/** columns and relationships of "learner_group" */
export type Learner_GroupPendingMembersArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Pending_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Pending_Member_Order_By>>;
  where?: InputMaybe<Learner_Group_Pending_Member_Bool_Exp>;
};


/** columns and relationships of "learner_group" */
export type Learner_GroupPendingMembers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Pending_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Pending_Member_Order_By>>;
  where?: InputMaybe<Learner_Group_Pending_Member_Bool_Exp>;
};

/** aggregated selection of "learner_group" */
export type Learner_Group_Aggregate = {
  __typename?: 'learner_group_aggregate';
  aggregate?: Maybe<Learner_Group_Aggregate_Fields>;
  nodes: Array<Learner_Group>;
};

/** aggregate fields of "learner_group" */
export type Learner_Group_Aggregate_Fields = {
  __typename?: 'learner_group_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Learner_Group_Max_Fields>;
  min?: Maybe<Learner_Group_Min_Fields>;
};


/** aggregate fields of "learner_group" */
export type Learner_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Learner_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "learner_group". All fields are combined with a logical 'AND'. */
export type Learner_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Learner_Group_Bool_Exp>>;
  _not?: InputMaybe<Learner_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Learner_Group_Bool_Exp>>;
  archivedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  assignments?: InputMaybe<Assignment_Learner_Group_Bool_Exp>;
  color?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  educatorCodes?: InputMaybe<Educator_Code_Bool_Exp>;
  firestoreId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  learner_group_path_collections?: InputMaybe<Learner_Group_Path_Collection_Bool_Exp>;
  members?: InputMaybe<Learner_Group_Member_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  orgId?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  pathPrivacy?: InputMaybe<String_Comparison_Exp>;
  pendingMembers?: InputMaybe<Learner_Group_Pending_Member_Bool_Exp>;
  privacyScope?: InputMaybe<String_Comparison_Exp>;
  profilePrivacy?: InputMaybe<String_Comparison_Exp>;
  projectPrivacy?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<Enums_Integration_Provider_Enum_Comparison_Exp>;
  sourceId?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "learner_group" */
export enum Learner_Group_Constraint {
  /** unique or primary key constraint on columns "firestore_id" */
  LearnerGroupFirestoreIdKey = 'learner_group_firestore_id_key',
  /** unique or primary key constraint on columns "id" */
  LearnerGroupPkey = 'learner_group_pkey'
}

/** input type for inserting data into table "learner_group" */
export type Learner_Group_Insert_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  assignments?: InputMaybe<Assignment_Learner_Group_Arr_Rel_Insert_Input>;
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  educatorCodes?: InputMaybe<Educator_Code_Arr_Rel_Insert_Input>;
  firestoreId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  learner_group_path_collections?: InputMaybe<Learner_Group_Path_Collection_Arr_Rel_Insert_Input>;
  members?: InputMaybe<Learner_Group_Member_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  orgId?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  pathPrivacy?: InputMaybe<Scalars['String']>;
  pendingMembers?: InputMaybe<Learner_Group_Pending_Member_Arr_Rel_Insert_Input>;
  privacyScope?: InputMaybe<Scalars['String']>;
  profilePrivacy?: InputMaybe<Scalars['String']>;
  projectPrivacy?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Enums_Integration_Provider_Enum>;
  sourceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Learner_Group_Max_Fields = {
  __typename?: 'learner_group_max_fields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  firestoreId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
  pathPrivacy?: Maybe<Scalars['String']>;
  privacyScope?: Maybe<Scalars['String']>;
  profilePrivacy?: Maybe<Scalars['String']>;
  projectPrivacy?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "learner_group_member" */
export type Learner_Group_Member = {
  __typename?: 'learner_group_member';
  createdAt: Scalars['timestamptz'];
  isOwner: Scalars['Boolean'];
  /** An object relationship */
  learnerGroup: Learner_Group;
  learnerGroupId: Scalars['uuid'];
  role: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userId: Scalars['String'];
};

/** aggregated selection of "learner_group_member" */
export type Learner_Group_Member_Aggregate = {
  __typename?: 'learner_group_member_aggregate';
  aggregate?: Maybe<Learner_Group_Member_Aggregate_Fields>;
  nodes: Array<Learner_Group_Member>;
};

/** aggregate fields of "learner_group_member" */
export type Learner_Group_Member_Aggregate_Fields = {
  __typename?: 'learner_group_member_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Learner_Group_Member_Max_Fields>;
  min?: Maybe<Learner_Group_Member_Min_Fields>;
};


/** aggregate fields of "learner_group_member" */
export type Learner_Group_Member_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Learner_Group_Member_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "learner_group_member" */
export type Learner_Group_Member_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Learner_Group_Member_Max_Order_By>;
  min?: InputMaybe<Learner_Group_Member_Min_Order_By>;
};

/** input type for inserting array relation for remote table "learner_group_member" */
export type Learner_Group_Member_Arr_Rel_Insert_Input = {
  data: Array<Learner_Group_Member_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Learner_Group_Member_On_Conflict>;
};

/** Boolean expression to filter rows from the table "learner_group_member". All fields are combined with a logical 'AND'. */
export type Learner_Group_Member_Bool_Exp = {
  _and?: InputMaybe<Array<Learner_Group_Member_Bool_Exp>>;
  _not?: InputMaybe<Learner_Group_Member_Bool_Exp>;
  _or?: InputMaybe<Array<Learner_Group_Member_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  isOwner?: InputMaybe<Boolean_Comparison_Exp>;
  learnerGroup?: InputMaybe<Learner_Group_Bool_Exp>;
  learnerGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "learner_group_member" */
export enum Learner_Group_Member_Constraint {
  /** unique or primary key constraint on columns "learner_group_id" */
  LearnerGroupMemberLearnerGroupIdIsOwner = 'learner_group_member_learner_group_id_is_owner',
  /** unique or primary key constraint on columns "user_id", "learner_group_id" */
  LearnerGroupMemberPkey = 'learner_group_member_pkey'
}

/** input type for inserting data into table "learner_group_member" */
export type Learner_Group_Member_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isOwner?: InputMaybe<Scalars['Boolean']>;
  learnerGroup?: InputMaybe<Learner_Group_Obj_Rel_Insert_Input>;
  learnerGroupId?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Learner_Group_Member_Max_Fields = {
  __typename?: 'learner_group_member_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  learnerGroupId?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "learner_group_member" */
export type Learner_Group_Member_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  learnerGroupId?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Learner_Group_Member_Min_Fields = {
  __typename?: 'learner_group_member_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  learnerGroupId?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "learner_group_member" */
export type Learner_Group_Member_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  learnerGroupId?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "learner_group_member" */
export type Learner_Group_Member_Mutation_Response = {
  __typename?: 'learner_group_member_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Learner_Group_Member>;
};

/** on_conflict condition type for table "learner_group_member" */
export type Learner_Group_Member_On_Conflict = {
  constraint: Learner_Group_Member_Constraint;
  update_columns?: Array<Learner_Group_Member_Update_Column>;
  where?: InputMaybe<Learner_Group_Member_Bool_Exp>;
};

/** Ordering options when selecting data from "learner_group_member". */
export type Learner_Group_Member_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  isOwner?: InputMaybe<Order_By>;
  learnerGroup?: InputMaybe<Learner_Group_Order_By>;
  learnerGroupId?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: learner_group_member */
export type Learner_Group_Member_Pk_Columns_Input = {
  learnerGroupId: Scalars['uuid'];
  userId: Scalars['String'];
};

/** select columns of table "learner_group_member" */
export enum Learner_Group_Member_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  IsOwner = 'isOwner',
  /** column name */
  LearnerGroupId = 'learnerGroupId',
  /** column name */
  Role = 'role',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "learner_group_member" */
export type Learner_Group_Member_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isOwner?: InputMaybe<Scalars['Boolean']>;
  learnerGroupId?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "learner_group_member" */
export type Learner_Group_Member_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Learner_Group_Member_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Learner_Group_Member_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isOwner?: InputMaybe<Scalars['Boolean']>;
  learnerGroupId?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "learner_group_member" */
export enum Learner_Group_Member_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  IsOwner = 'isOwner',
  /** column name */
  LearnerGroupId = 'learnerGroupId',
  /** column name */
  Role = 'role',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Learner_Group_Member_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Learner_Group_Member_Set_Input>;
  where: Learner_Group_Member_Bool_Exp;
};

/** aggregate min on columns */
export type Learner_Group_Min_Fields = {
  __typename?: 'learner_group_min_fields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  firestoreId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
  pathPrivacy?: Maybe<Scalars['String']>;
  privacyScope?: Maybe<Scalars['String']>;
  profilePrivacy?: Maybe<Scalars['String']>;
  projectPrivacy?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "learner_group" */
export type Learner_Group_Mutation_Response = {
  __typename?: 'learner_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Learner_Group>;
};

/** input type for inserting object relation for remote table "learner_group" */
export type Learner_Group_Obj_Rel_Insert_Input = {
  data: Learner_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Learner_Group_On_Conflict>;
};

/** on_conflict condition type for table "learner_group" */
export type Learner_Group_On_Conflict = {
  constraint: Learner_Group_Constraint;
  update_columns?: Array<Learner_Group_Update_Column>;
  where?: InputMaybe<Learner_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "learner_group". */
export type Learner_Group_Order_By = {
  archivedAt?: InputMaybe<Order_By>;
  assignments_aggregate?: InputMaybe<Assignment_Learner_Group_Aggregate_Order_By>;
  color?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  educatorCodes_aggregate?: InputMaybe<Educator_Code_Aggregate_Order_By>;
  firestoreId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  learner_group_path_collections_aggregate?: InputMaybe<Learner_Group_Path_Collection_Aggregate_Order_By>;
  members_aggregate?: InputMaybe<Learner_Group_Member_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  pathPrivacy?: InputMaybe<Order_By>;
  pendingMembers_aggregate?: InputMaybe<Learner_Group_Pending_Member_Aggregate_Order_By>;
  privacyScope?: InputMaybe<Order_By>;
  profilePrivacy?: InputMaybe<Order_By>;
  projectPrivacy?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  sourceId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** columns and relationships of "learner_group_path_collection" */
export type Learner_Group_Path_Collection = {
  __typename?: 'learner_group_path_collection';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  learnerGroup: Learner_Group;
  learnerGroupId: Scalars['uuid'];
  /** An object relationship */
  pathCollection: Path_Collection;
  pathCollectionId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "learner_group_path_collection" */
export type Learner_Group_Path_Collection_Aggregate = {
  __typename?: 'learner_group_path_collection_aggregate';
  aggregate?: Maybe<Learner_Group_Path_Collection_Aggregate_Fields>;
  nodes: Array<Learner_Group_Path_Collection>;
};

/** aggregate fields of "learner_group_path_collection" */
export type Learner_Group_Path_Collection_Aggregate_Fields = {
  __typename?: 'learner_group_path_collection_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Learner_Group_Path_Collection_Max_Fields>;
  min?: Maybe<Learner_Group_Path_Collection_Min_Fields>;
};


/** aggregate fields of "learner_group_path_collection" */
export type Learner_Group_Path_Collection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Learner_Group_Path_Collection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "learner_group_path_collection" */
export type Learner_Group_Path_Collection_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Learner_Group_Path_Collection_Max_Order_By>;
  min?: InputMaybe<Learner_Group_Path_Collection_Min_Order_By>;
};

/** input type for inserting array relation for remote table "learner_group_path_collection" */
export type Learner_Group_Path_Collection_Arr_Rel_Insert_Input = {
  data: Array<Learner_Group_Path_Collection_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Learner_Group_Path_Collection_On_Conflict>;
};

/** Boolean expression to filter rows from the table "learner_group_path_collection". All fields are combined with a logical 'AND'. */
export type Learner_Group_Path_Collection_Bool_Exp = {
  _and?: InputMaybe<Array<Learner_Group_Path_Collection_Bool_Exp>>;
  _not?: InputMaybe<Learner_Group_Path_Collection_Bool_Exp>;
  _or?: InputMaybe<Array<Learner_Group_Path_Collection_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  learnerGroup?: InputMaybe<Learner_Group_Bool_Exp>;
  learnerGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  pathCollection?: InputMaybe<Path_Collection_Bool_Exp>;
  pathCollectionId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "learner_group_path_collection" */
export enum Learner_Group_Path_Collection_Constraint {
  /** unique or primary key constraint on columns "learner_group_id" */
  LearnerGroupPathCollectionPkey = 'learner_group_path_collection_pkey'
}

/** input type for inserting data into table "learner_group_path_collection" */
export type Learner_Group_Path_Collection_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  learnerGroup?: InputMaybe<Learner_Group_Obj_Rel_Insert_Input>;
  learnerGroupId?: InputMaybe<Scalars['uuid']>;
  pathCollection?: InputMaybe<Path_Collection_Obj_Rel_Insert_Input>;
  pathCollectionId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Learner_Group_Path_Collection_Max_Fields = {
  __typename?: 'learner_group_path_collection_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  learnerGroupId?: Maybe<Scalars['uuid']>;
  pathCollectionId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "learner_group_path_collection" */
export type Learner_Group_Path_Collection_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  learnerGroupId?: InputMaybe<Order_By>;
  pathCollectionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Learner_Group_Path_Collection_Min_Fields = {
  __typename?: 'learner_group_path_collection_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  learnerGroupId?: Maybe<Scalars['uuid']>;
  pathCollectionId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "learner_group_path_collection" */
export type Learner_Group_Path_Collection_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  learnerGroupId?: InputMaybe<Order_By>;
  pathCollectionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "learner_group_path_collection" */
export type Learner_Group_Path_Collection_Mutation_Response = {
  __typename?: 'learner_group_path_collection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Learner_Group_Path_Collection>;
};

/** on_conflict condition type for table "learner_group_path_collection" */
export type Learner_Group_Path_Collection_On_Conflict = {
  constraint: Learner_Group_Path_Collection_Constraint;
  update_columns?: Array<Learner_Group_Path_Collection_Update_Column>;
  where?: InputMaybe<Learner_Group_Path_Collection_Bool_Exp>;
};

/** Ordering options when selecting data from "learner_group_path_collection". */
export type Learner_Group_Path_Collection_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  learnerGroup?: InputMaybe<Learner_Group_Order_By>;
  learnerGroupId?: InputMaybe<Order_By>;
  pathCollection?: InputMaybe<Path_Collection_Order_By>;
  pathCollectionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: learner_group_path_collection */
export type Learner_Group_Path_Collection_Pk_Columns_Input = {
  learnerGroupId: Scalars['uuid'];
};

/** select columns of table "learner_group_path_collection" */
export enum Learner_Group_Path_Collection_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  LearnerGroupId = 'learnerGroupId',
  /** column name */
  PathCollectionId = 'pathCollectionId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "learner_group_path_collection" */
export type Learner_Group_Path_Collection_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  learnerGroupId?: InputMaybe<Scalars['uuid']>;
  pathCollectionId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "learner_group_path_collection" */
export type Learner_Group_Path_Collection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Learner_Group_Path_Collection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Learner_Group_Path_Collection_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  learnerGroupId?: InputMaybe<Scalars['uuid']>;
  pathCollectionId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "learner_group_path_collection" */
export enum Learner_Group_Path_Collection_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  LearnerGroupId = 'learnerGroupId',
  /** column name */
  PathCollectionId = 'pathCollectionId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Learner_Group_Path_Collection_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Learner_Group_Path_Collection_Set_Input>;
  where: Learner_Group_Path_Collection_Bool_Exp;
};

/** Stores members imported from a provider which haven't been onboarded */
export type Learner_Group_Pending_Member = {
  __typename?: 'learner_group_pending_member';
  createdAt: Scalars['timestamptz'];
  firstName?: Maybe<Scalars['String']>;
  foreignId: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  learnerGroupId: Scalars['uuid'];
  provider: Enums_Integration_Provider_Enum;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "learner_group_pending_member" */
export type Learner_Group_Pending_Member_Aggregate = {
  __typename?: 'learner_group_pending_member_aggregate';
  aggregate?: Maybe<Learner_Group_Pending_Member_Aggregate_Fields>;
  nodes: Array<Learner_Group_Pending_Member>;
};

/** aggregate fields of "learner_group_pending_member" */
export type Learner_Group_Pending_Member_Aggregate_Fields = {
  __typename?: 'learner_group_pending_member_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Learner_Group_Pending_Member_Max_Fields>;
  min?: Maybe<Learner_Group_Pending_Member_Min_Fields>;
};


/** aggregate fields of "learner_group_pending_member" */
export type Learner_Group_Pending_Member_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Learner_Group_Pending_Member_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "learner_group_pending_member" */
export type Learner_Group_Pending_Member_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Learner_Group_Pending_Member_Max_Order_By>;
  min?: InputMaybe<Learner_Group_Pending_Member_Min_Order_By>;
};

/** input type for inserting array relation for remote table "learner_group_pending_member" */
export type Learner_Group_Pending_Member_Arr_Rel_Insert_Input = {
  data: Array<Learner_Group_Pending_Member_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Learner_Group_Pending_Member_On_Conflict>;
};

/** Boolean expression to filter rows from the table "learner_group_pending_member". All fields are combined with a logical 'AND'. */
export type Learner_Group_Pending_Member_Bool_Exp = {
  _and?: InputMaybe<Array<Learner_Group_Pending_Member_Bool_Exp>>;
  _not?: InputMaybe<Learner_Group_Pending_Member_Bool_Exp>;
  _or?: InputMaybe<Array<Learner_Group_Pending_Member_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  foreignId?: InputMaybe<String_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  learnerGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  provider?: InputMaybe<Enums_Integration_Provider_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "learner_group_pending_member" */
export enum Learner_Group_Pending_Member_Constraint {
  /** unique or primary key constraint on columns "provider", "foreign_id", "learner_group_id" */
  LearnerGroupPendingMemberPkey = 'learner_group_pending_member_pkey'
}

/** input type for inserting data into table "learner_group_pending_member" */
export type Learner_Group_Pending_Member_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  firstName?: InputMaybe<Scalars['String']>;
  foreignId?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  learnerGroupId?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Enums_Integration_Provider_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Learner_Group_Pending_Member_Max_Fields = {
  __typename?: 'learner_group_pending_member_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  firstName?: Maybe<Scalars['String']>;
  foreignId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  learnerGroupId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "learner_group_pending_member" */
export type Learner_Group_Pending_Member_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  foreignId?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  learnerGroupId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Learner_Group_Pending_Member_Min_Fields = {
  __typename?: 'learner_group_pending_member_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  firstName?: Maybe<Scalars['String']>;
  foreignId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  learnerGroupId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "learner_group_pending_member" */
export type Learner_Group_Pending_Member_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  foreignId?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  learnerGroupId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "learner_group_pending_member" */
export type Learner_Group_Pending_Member_Mutation_Response = {
  __typename?: 'learner_group_pending_member_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Learner_Group_Pending_Member>;
};

/** on_conflict condition type for table "learner_group_pending_member" */
export type Learner_Group_Pending_Member_On_Conflict = {
  constraint: Learner_Group_Pending_Member_Constraint;
  update_columns?: Array<Learner_Group_Pending_Member_Update_Column>;
  where?: InputMaybe<Learner_Group_Pending_Member_Bool_Exp>;
};

/** Ordering options when selecting data from "learner_group_pending_member". */
export type Learner_Group_Pending_Member_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  foreignId?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  learnerGroupId?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: learner_group_pending_member */
export type Learner_Group_Pending_Member_Pk_Columns_Input = {
  foreignId: Scalars['String'];
  learnerGroupId: Scalars['uuid'];
  provider: Enums_Integration_Provider_Enum;
};

/** select columns of table "learner_group_pending_member" */
export enum Learner_Group_Pending_Member_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  ForeignId = 'foreignId',
  /** column name */
  LastName = 'lastName',
  /** column name */
  LearnerGroupId = 'learnerGroupId',
  /** column name */
  Provider = 'provider',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "learner_group_pending_member" */
export type Learner_Group_Pending_Member_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  firstName?: InputMaybe<Scalars['String']>;
  foreignId?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  learnerGroupId?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Enums_Integration_Provider_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "learner_group_pending_member" */
export type Learner_Group_Pending_Member_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Learner_Group_Pending_Member_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Learner_Group_Pending_Member_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  firstName?: InputMaybe<Scalars['String']>;
  foreignId?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  learnerGroupId?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Enums_Integration_Provider_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "learner_group_pending_member" */
export enum Learner_Group_Pending_Member_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  ForeignId = 'foreignId',
  /** column name */
  LastName = 'lastName',
  /** column name */
  LearnerGroupId = 'learnerGroupId',
  /** column name */
  Provider = 'provider',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Learner_Group_Pending_Member_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Learner_Group_Pending_Member_Set_Input>;
  where: Learner_Group_Pending_Member_Bool_Exp;
};

/** primary key columns input for table: learner_group */
export type Learner_Group_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "learner_group" */
export enum Learner_Group_Select_Column {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FirestoreId = 'firestoreId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrgId = 'orgId',
  /** column name */
  PathPrivacy = 'pathPrivacy',
  /** column name */
  PrivacyScope = 'privacyScope',
  /** column name */
  ProfilePrivacy = 'profilePrivacy',
  /** column name */
  ProjectPrivacy = 'projectPrivacy',
  /** column name */
  Source = 'source',
  /** column name */
  SourceId = 'sourceId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "learner_group" */
export type Learner_Group_Set_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  firestoreId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  orgId?: InputMaybe<Scalars['String']>;
  pathPrivacy?: InputMaybe<Scalars['String']>;
  privacyScope?: InputMaybe<Scalars['String']>;
  profilePrivacy?: InputMaybe<Scalars['String']>;
  projectPrivacy?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Enums_Integration_Provider_Enum>;
  sourceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "learner_group" */
export type Learner_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Learner_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Learner_Group_Stream_Cursor_Value_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  firestoreId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  orgId?: InputMaybe<Scalars['String']>;
  pathPrivacy?: InputMaybe<Scalars['String']>;
  privacyScope?: InputMaybe<Scalars['String']>;
  profilePrivacy?: InputMaybe<Scalars['String']>;
  projectPrivacy?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Enums_Integration_Provider_Enum>;
  sourceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "learner_group" */
export enum Learner_Group_Update_Column {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FirestoreId = 'firestoreId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrgId = 'orgId',
  /** column name */
  PathPrivacy = 'pathPrivacy',
  /** column name */
  PrivacyScope = 'privacyScope',
  /** column name */
  ProfilePrivacy = 'profilePrivacy',
  /** column name */
  ProjectPrivacy = 'projectPrivacy',
  /** column name */
  Source = 'source',
  /** column name */
  SourceId = 'sourceId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Learner_Group_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Learner_Group_Set_Input>;
  where: Learner_Group_Bool_Exp;
};

/** columns and relationships of "livestream" */
export type Livestream = {
  __typename?: 'livestream';
  /** An object relationship */
  coverFile?: Maybe<User_File>;
  coverFileId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  disabled: Scalars['Boolean'];
  endDate?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  hostUser: User;
  hostUserId: Scalars['String'];
  id: Scalars['uuid'];
  startDate?: Maybe<Scalars['timestamptz']>;
  title: Scalars['String'];
  upatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "livestream" */
export type Livestream_Aggregate = {
  __typename?: 'livestream_aggregate';
  aggregate?: Maybe<Livestream_Aggregate_Fields>;
  nodes: Array<Livestream>;
};

/** aggregate fields of "livestream" */
export type Livestream_Aggregate_Fields = {
  __typename?: 'livestream_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Livestream_Max_Fields>;
  min?: Maybe<Livestream_Min_Fields>;
};


/** aggregate fields of "livestream" */
export type Livestream_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Livestream_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "livestream". All fields are combined with a logical 'AND'. */
export type Livestream_Bool_Exp = {
  _and?: InputMaybe<Array<Livestream_Bool_Exp>>;
  _not?: InputMaybe<Livestream_Bool_Exp>;
  _or?: InputMaybe<Array<Livestream_Bool_Exp>>;
  coverFile?: InputMaybe<User_File_Bool_Exp>;
  coverFileId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  endDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  hostUser?: InputMaybe<User_Bool_Exp>;
  hostUserId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  startDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  upatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "livestream" */
export enum Livestream_Constraint {
  /** unique or primary key constraint on columns "id" */
  LivestreamPkey = 'livestream_pkey'
}

/** input type for inserting data into table "livestream" */
export type Livestream_Insert_Input = {
  coverFile?: InputMaybe<User_File_Obj_Rel_Insert_Input>;
  coverFileId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['timestamptz']>;
  hostUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
  hostUserId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  startDate?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  upatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Livestream_Max_Fields = {
  __typename?: 'livestream_max_fields';
  coverFileId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  hostUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  upatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Livestream_Min_Fields = {
  __typename?: 'livestream_min_fields';
  coverFileId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  hostUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  upatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "livestream" */
export type Livestream_Mutation_Response = {
  __typename?: 'livestream_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Livestream>;
};

/** on_conflict condition type for table "livestream" */
export type Livestream_On_Conflict = {
  constraint: Livestream_Constraint;
  update_columns?: Array<Livestream_Update_Column>;
  where?: InputMaybe<Livestream_Bool_Exp>;
};

/** Ordering options when selecting data from "livestream". */
export type Livestream_Order_By = {
  coverFile?: InputMaybe<User_File_Order_By>;
  coverFileId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  disabled?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  hostUser?: InputMaybe<User_Order_By>;
  hostUserId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  upatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: livestream */
export type Livestream_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "livestream" */
export enum Livestream_Select_Column {
  /** column name */
  CoverFileId = 'coverFileId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  HostUserId = 'hostUserId',
  /** column name */
  Id = 'id',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Title = 'title',
  /** column name */
  UpatedAt = 'upatedAt'
}

/** input type for updating data in table "livestream" */
export type Livestream_Set_Input = {
  coverFileId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['timestamptz']>;
  hostUserId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  startDate?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  upatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "livestream" */
export type Livestream_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Livestream_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Livestream_Stream_Cursor_Value_Input = {
  coverFileId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['timestamptz']>;
  hostUserId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  startDate?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  upatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "livestream" */
export enum Livestream_Update_Column {
  /** column name */
  CoverFileId = 'coverFileId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  HostUserId = 'hostUserId',
  /** column name */
  Id = 'id',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Title = 'title',
  /** column name */
  UpatedAt = 'upatedAt'
}

export type Livestream_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Livestream_Set_Input>;
  where: Livestream_Bool_Exp;
};

/** learning management system */
export type Lms = {
  __typename?: 'lms';
  created_at: Scalars['timestamptz'];
  helpArticleLink: Scalars['String'];
  id: Scalars['uuid'];
  imageFilePath?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "lms" */
export type Lms_Aggregate = {
  __typename?: 'lms_aggregate';
  aggregate?: Maybe<Lms_Aggregate_Fields>;
  nodes: Array<Lms>;
};

/** aggregate fields of "lms" */
export type Lms_Aggregate_Fields = {
  __typename?: 'lms_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Lms_Max_Fields>;
  min?: Maybe<Lms_Min_Fields>;
};


/** aggregate fields of "lms" */
export type Lms_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lms_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "lms". All fields are combined with a logical 'AND'. */
export type Lms_Bool_Exp = {
  _and?: InputMaybe<Array<Lms_Bool_Exp>>;
  _not?: InputMaybe<Lms_Bool_Exp>;
  _or?: InputMaybe<Array<Lms_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  helpArticleLink?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imageFilePath?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "lms" */
export enum Lms_Constraint {
  /** unique or primary key constraint on columns "id" */
  LmsPkey = 'LMS_pkey'
}

/** input type for inserting data into table "lms" */
export type Lms_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  helpArticleLink?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  imageFilePath?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Lms_Max_Fields = {
  __typename?: 'lms_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  helpArticleLink?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  imageFilePath?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Lms_Min_Fields = {
  __typename?: 'lms_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  helpArticleLink?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  imageFilePath?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "lms" */
export type Lms_Mutation_Response = {
  __typename?: 'lms_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Lms>;
};

/** on_conflict condition type for table "lms" */
export type Lms_On_Conflict = {
  constraint: Lms_Constraint;
  update_columns?: Array<Lms_Update_Column>;
  where?: InputMaybe<Lms_Bool_Exp>;
};

/** Ordering options when selecting data from "lms". */
export type Lms_Order_By = {
  created_at?: InputMaybe<Order_By>;
  helpArticleLink?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imageFilePath?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lms */
export type Lms_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "lms" */
export enum Lms_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HelpArticleLink = 'helpArticleLink',
  /** column name */
  Id = 'id',
  /** column name */
  ImageFilePath = 'imageFilePath',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "lms" */
export type Lms_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  helpArticleLink?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  imageFilePath?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "lms" */
export type Lms_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lms_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lms_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  helpArticleLink?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  imageFilePath?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "lms" */
export enum Lms_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HelpArticleLink = 'helpArticleLink',
  /** column name */
  Id = 'id',
  /** column name */
  ImageFilePath = 'imageFilePath',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Lms_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lms_Set_Input>;
  where: Lms_Bool_Exp;
};

/** Boolean expression to compare columns of type "ltree". All fields are combined with logical 'AND'. */
export type Ltree_Comparison_Exp = {
  /** is the left argument an ancestor of right (or equal)? */
  _ancestor?: InputMaybe<Scalars['ltree']>;
  /** does array contain an ancestor of `ltree`? */
  _ancestor_any?: InputMaybe<Array<Scalars['ltree']>>;
  /** is the left argument a descendant of right (or equal)? */
  _descendant?: InputMaybe<Scalars['ltree']>;
  /** does array contain a descendant of `ltree`? */
  _descendant_any?: InputMaybe<Array<Scalars['ltree']>>;
  _eq?: InputMaybe<Scalars['ltree']>;
  _gt?: InputMaybe<Scalars['ltree']>;
  _gte?: InputMaybe<Scalars['ltree']>;
  _in?: InputMaybe<Array<Scalars['ltree']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['ltree']>;
  _lte?: InputMaybe<Scalars['ltree']>;
  /** does `ltree` match `lquery`? */
  _matches?: InputMaybe<Scalars['lquery']>;
  /** does `ltree` match any `lquery` in array? */
  _matches_any?: InputMaybe<Array<Scalars['String']>>;
  /** does `ltree` match `ltxtquery`? */
  _matches_fulltext?: InputMaybe<Scalars['ltxtquery']>;
  _neq?: InputMaybe<Scalars['ltree']>;
  _nin?: InputMaybe<Array<Scalars['ltree']>>;
};

/** columns and relationships of "mission" */
export type Mission = {
  __typename?: 'mission';
  /** An array relationship */
  challenges: Array<Mission_Challenge>;
  /** An aggregate relationship */
  challenges_aggregate: Mission_Challenge_Aggregate;
  /** An array relationship */
  comments: Array<Mission_Comment>;
  /** An aggregate relationship */
  comments_aggregate: Mission_Comment_Aggregate;
  coverFileId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  firestoreId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isCapstone?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  path: Path;
  pathId: Scalars['Int'];
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['String'];
  /** An object relationship */
  video?: Maybe<User_File>;
  videoFileId?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "mission" */
export type MissionChallengesArgs = {
  distinct_on?: InputMaybe<Array<Mission_Challenge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Challenge_Order_By>>;
  where?: InputMaybe<Mission_Challenge_Bool_Exp>;
};


/** columns and relationships of "mission" */
export type MissionChallenges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mission_Challenge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Challenge_Order_By>>;
  where?: InputMaybe<Mission_Challenge_Bool_Exp>;
};


/** columns and relationships of "mission" */
export type MissionCommentsArgs = {
  distinct_on?: InputMaybe<Array<Mission_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Comment_Order_By>>;
  where?: InputMaybe<Mission_Comment_Bool_Exp>;
};


/** columns and relationships of "mission" */
export type MissionComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mission_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Comment_Order_By>>;
  where?: InputMaybe<Mission_Comment_Bool_Exp>;
};

/** aggregated selection of "mission" */
export type Mission_Aggregate = {
  __typename?: 'mission_aggregate';
  aggregate?: Maybe<Mission_Aggregate_Fields>;
  nodes: Array<Mission>;
};

/** aggregate fields of "mission" */
export type Mission_Aggregate_Fields = {
  __typename?: 'mission_aggregate_fields';
  avg?: Maybe<Mission_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Mission_Max_Fields>;
  min?: Maybe<Mission_Min_Fields>;
  stddev?: Maybe<Mission_Stddev_Fields>;
  stddev_pop?: Maybe<Mission_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mission_Stddev_Samp_Fields>;
  sum?: Maybe<Mission_Sum_Fields>;
  var_pop?: Maybe<Mission_Var_Pop_Fields>;
  var_samp?: Maybe<Mission_Var_Samp_Fields>;
  variance?: Maybe<Mission_Variance_Fields>;
};


/** aggregate fields of "mission" */
export type Mission_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "mission" */
export type Mission_Aggregate_Order_By = {
  avg?: InputMaybe<Mission_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mission_Max_Order_By>;
  min?: InputMaybe<Mission_Min_Order_By>;
  stddev?: InputMaybe<Mission_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mission_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mission_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mission_Sum_Order_By>;
  var_pop?: InputMaybe<Mission_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mission_Var_Samp_Order_By>;
  variance?: InputMaybe<Mission_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mission" */
export type Mission_Arr_Rel_Insert_Input = {
  data: Array<Mission_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mission_On_Conflict>;
};

/** maintains a list of download attachments for missions */
export type Mission_Attachment = {
  __typename?: 'mission_attachment';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  file: User_File;
  fileId: Scalars['uuid'];
  /** An object relationship */
  mission: Mission;
  missionId: Scalars['Int'];
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "mission_attachment" */
export type Mission_Attachment_Aggregate = {
  __typename?: 'mission_attachment_aggregate';
  aggregate?: Maybe<Mission_Attachment_Aggregate_Fields>;
  nodes: Array<Mission_Attachment>;
};

/** aggregate fields of "mission_attachment" */
export type Mission_Attachment_Aggregate_Fields = {
  __typename?: 'mission_attachment_aggregate_fields';
  avg?: Maybe<Mission_Attachment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Mission_Attachment_Max_Fields>;
  min?: Maybe<Mission_Attachment_Min_Fields>;
  stddev?: Maybe<Mission_Attachment_Stddev_Fields>;
  stddev_pop?: Maybe<Mission_Attachment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mission_Attachment_Stddev_Samp_Fields>;
  sum?: Maybe<Mission_Attachment_Sum_Fields>;
  var_pop?: Maybe<Mission_Attachment_Var_Pop_Fields>;
  var_samp?: Maybe<Mission_Attachment_Var_Samp_Fields>;
  variance?: Maybe<Mission_Attachment_Variance_Fields>;
};


/** aggregate fields of "mission_attachment" */
export type Mission_Attachment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mission_Attachment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Mission_Attachment_Avg_Fields = {
  __typename?: 'mission_attachment_avg_fields';
  missionId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "mission_attachment". All fields are combined with a logical 'AND'. */
export type Mission_Attachment_Bool_Exp = {
  _and?: InputMaybe<Array<Mission_Attachment_Bool_Exp>>;
  _not?: InputMaybe<Mission_Attachment_Bool_Exp>;
  _or?: InputMaybe<Array<Mission_Attachment_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<User_File_Bool_Exp>;
  fileId?: InputMaybe<Uuid_Comparison_Exp>;
  mission?: InputMaybe<Mission_Bool_Exp>;
  missionId?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mission_attachment" */
export enum Mission_Attachment_Constraint {
  /** unique or primary key constraint on columns "mission_id", "file_id" */
  MissionAttachmentPkey = 'mission_attachment_pkey'
}

/** input type for incrementing numeric columns in table "mission_attachment" */
export type Mission_Attachment_Inc_Input = {
  missionId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "mission_attachment" */
export type Mission_Attachment_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  file?: InputMaybe<User_File_Obj_Rel_Insert_Input>;
  fileId?: InputMaybe<Scalars['uuid']>;
  mission?: InputMaybe<Mission_Obj_Rel_Insert_Input>;
  missionId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Mission_Attachment_Max_Fields = {
  __typename?: 'mission_attachment_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  fileId?: Maybe<Scalars['uuid']>;
  missionId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Mission_Attachment_Min_Fields = {
  __typename?: 'mission_attachment_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  fileId?: Maybe<Scalars['uuid']>;
  missionId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "mission_attachment" */
export type Mission_Attachment_Mutation_Response = {
  __typename?: 'mission_attachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Mission_Attachment>;
};

/** on_conflict condition type for table "mission_attachment" */
export type Mission_Attachment_On_Conflict = {
  constraint: Mission_Attachment_Constraint;
  update_columns?: Array<Mission_Attachment_Update_Column>;
  where?: InputMaybe<Mission_Attachment_Bool_Exp>;
};

/** Ordering options when selecting data from "mission_attachment". */
export type Mission_Attachment_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  file?: InputMaybe<User_File_Order_By>;
  fileId?: InputMaybe<Order_By>;
  mission?: InputMaybe<Mission_Order_By>;
  missionId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mission_attachment */
export type Mission_Attachment_Pk_Columns_Input = {
  fileId: Scalars['uuid'];
  missionId: Scalars['Int'];
};

/** select columns of table "mission_attachment" */
export enum Mission_Attachment_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  MissionId = 'missionId',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "mission_attachment" */
export type Mission_Attachment_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fileId?: InputMaybe<Scalars['uuid']>;
  missionId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Mission_Attachment_Stddev_Fields = {
  __typename?: 'mission_attachment_stddev_fields';
  missionId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Mission_Attachment_Stddev_Pop_Fields = {
  __typename?: 'mission_attachment_stddev_pop_fields';
  missionId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Mission_Attachment_Stddev_Samp_Fields = {
  __typename?: 'mission_attachment_stddev_samp_fields';
  missionId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "mission_attachment" */
export type Mission_Attachment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mission_Attachment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mission_Attachment_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fileId?: InputMaybe<Scalars['uuid']>;
  missionId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Mission_Attachment_Sum_Fields = {
  __typename?: 'mission_attachment_sum_fields';
  missionId?: Maybe<Scalars['Int']>;
};

/** update columns of table "mission_attachment" */
export enum Mission_Attachment_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  MissionId = 'missionId',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Mission_Attachment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mission_Attachment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mission_Attachment_Set_Input>;
  where: Mission_Attachment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mission_Attachment_Var_Pop_Fields = {
  __typename?: 'mission_attachment_var_pop_fields';
  missionId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Mission_Attachment_Var_Samp_Fields = {
  __typename?: 'mission_attachment_var_samp_fields';
  missionId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Mission_Attachment_Variance_Fields = {
  __typename?: 'mission_attachment_variance_fields';
  missionId?: Maybe<Scalars['Float']>;
};

/** aggregate avg on columns */
export type Mission_Avg_Fields = {
  __typename?: 'mission_avg_fields';
  id?: Maybe<Scalars['Float']>;
  pathId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "mission" */
export type Mission_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mission". All fields are combined with a logical 'AND'. */
export type Mission_Bool_Exp = {
  _and?: InputMaybe<Array<Mission_Bool_Exp>>;
  _not?: InputMaybe<Mission_Bool_Exp>;
  _or?: InputMaybe<Array<Mission_Bool_Exp>>;
  challenges?: InputMaybe<Mission_Challenge_Bool_Exp>;
  comments?: InputMaybe<Mission_Comment_Bool_Exp>;
  coverFileId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  firestoreId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  isCapstone?: InputMaybe<Boolean_Comparison_Exp>;
  path?: InputMaybe<Path_Bool_Exp>;
  pathId?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
  video?: InputMaybe<User_File_Bool_Exp>;
  videoFileId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** columns and relationships of "mission_challenge" */
export type Mission_Challenge = {
  __typename?: 'mission_challenge';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  firestoreId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  minutesToComplete: Scalars['Int'];
  /** An object relationship */
  mission: Mission;
  missionId: Scalars['Int'];
  /** An array relationship */
  projects: Array<Project>;
  /** An aggregate relationship */
  projects_aggregate: Project_Aggregate;
  question: Scalars['String'];
  responseType: Scalars['String'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "mission_challenge" */
export type Mission_ChallengeProjectsArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


/** columns and relationships of "mission_challenge" */
export type Mission_ChallengeProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};

/** aggregated selection of "mission_challenge" */
export type Mission_Challenge_Aggregate = {
  __typename?: 'mission_challenge_aggregate';
  aggregate?: Maybe<Mission_Challenge_Aggregate_Fields>;
  nodes: Array<Mission_Challenge>;
};

/** aggregate fields of "mission_challenge" */
export type Mission_Challenge_Aggregate_Fields = {
  __typename?: 'mission_challenge_aggregate_fields';
  avg?: Maybe<Mission_Challenge_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Mission_Challenge_Max_Fields>;
  min?: Maybe<Mission_Challenge_Min_Fields>;
  stddev?: Maybe<Mission_Challenge_Stddev_Fields>;
  stddev_pop?: Maybe<Mission_Challenge_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mission_Challenge_Stddev_Samp_Fields>;
  sum?: Maybe<Mission_Challenge_Sum_Fields>;
  var_pop?: Maybe<Mission_Challenge_Var_Pop_Fields>;
  var_samp?: Maybe<Mission_Challenge_Var_Samp_Fields>;
  variance?: Maybe<Mission_Challenge_Variance_Fields>;
};


/** aggregate fields of "mission_challenge" */
export type Mission_Challenge_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mission_Challenge_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "mission_challenge" */
export type Mission_Challenge_Aggregate_Order_By = {
  avg?: InputMaybe<Mission_Challenge_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mission_Challenge_Max_Order_By>;
  min?: InputMaybe<Mission_Challenge_Min_Order_By>;
  stddev?: InputMaybe<Mission_Challenge_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mission_Challenge_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mission_Challenge_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mission_Challenge_Sum_Order_By>;
  var_pop?: InputMaybe<Mission_Challenge_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mission_Challenge_Var_Samp_Order_By>;
  variance?: InputMaybe<Mission_Challenge_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mission_challenge" */
export type Mission_Challenge_Arr_Rel_Insert_Input = {
  data: Array<Mission_Challenge_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mission_Challenge_On_Conflict>;
};

/** aggregate avg on columns */
export type Mission_Challenge_Avg_Fields = {
  __typename?: 'mission_challenge_avg_fields';
  id?: Maybe<Scalars['Float']>;
  minutesToComplete?: Maybe<Scalars['Float']>;
  missionId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "mission_challenge" */
export type Mission_Challenge_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  minutesToComplete?: InputMaybe<Order_By>;
  missionId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mission_challenge". All fields are combined with a logical 'AND'. */
export type Mission_Challenge_Bool_Exp = {
  _and?: InputMaybe<Array<Mission_Challenge_Bool_Exp>>;
  _not?: InputMaybe<Mission_Challenge_Bool_Exp>;
  _or?: InputMaybe<Array<Mission_Challenge_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  firestoreId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  minutesToComplete?: InputMaybe<Int_Comparison_Exp>;
  mission?: InputMaybe<Mission_Bool_Exp>;
  missionId?: InputMaybe<Int_Comparison_Exp>;
  projects?: InputMaybe<Project_Bool_Exp>;
  question?: InputMaybe<String_Comparison_Exp>;
  responseType?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mission_challenge" */
export enum Mission_Challenge_Constraint {
  /** unique or primary key constraint on columns "id" */
  ChallengePkey = 'challenge_pkey',
  /** unique or primary key constraint on columns "firestore_id" */
  MissionChallengeFirestoreIdKey = 'mission_challenge_firestore_id_key'
}

/** input type for incrementing numeric columns in table "mission_challenge" */
export type Mission_Challenge_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  minutesToComplete?: InputMaybe<Scalars['Int']>;
  missionId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "mission_challenge" */
export type Mission_Challenge_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  firestoreId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  minutesToComplete?: InputMaybe<Scalars['Int']>;
  mission?: InputMaybe<Mission_Obj_Rel_Insert_Input>;
  missionId?: InputMaybe<Scalars['Int']>;
  projects?: InputMaybe<Project_Arr_Rel_Insert_Input>;
  question?: InputMaybe<Scalars['String']>;
  responseType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Mission_Challenge_Max_Fields = {
  __typename?: 'mission_challenge_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  firestoreId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  minutesToComplete?: Maybe<Scalars['Int']>;
  missionId?: Maybe<Scalars['Int']>;
  question?: Maybe<Scalars['String']>;
  responseType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "mission_challenge" */
export type Mission_Challenge_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  firestoreId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  minutesToComplete?: InputMaybe<Order_By>;
  missionId?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  responseType?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mission_Challenge_Min_Fields = {
  __typename?: 'mission_challenge_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  firestoreId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  minutesToComplete?: Maybe<Scalars['Int']>;
  missionId?: Maybe<Scalars['Int']>;
  question?: Maybe<Scalars['String']>;
  responseType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "mission_challenge" */
export type Mission_Challenge_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  firestoreId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  minutesToComplete?: InputMaybe<Order_By>;
  missionId?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  responseType?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mission_challenge" */
export type Mission_Challenge_Mutation_Response = {
  __typename?: 'mission_challenge_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Mission_Challenge>;
};

/** input type for inserting object relation for remote table "mission_challenge" */
export type Mission_Challenge_Obj_Rel_Insert_Input = {
  data: Mission_Challenge_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mission_Challenge_On_Conflict>;
};

/** on_conflict condition type for table "mission_challenge" */
export type Mission_Challenge_On_Conflict = {
  constraint: Mission_Challenge_Constraint;
  update_columns?: Array<Mission_Challenge_Update_Column>;
  where?: InputMaybe<Mission_Challenge_Bool_Exp>;
};

/** Ordering options when selecting data from "mission_challenge". */
export type Mission_Challenge_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  firestoreId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  minutesToComplete?: InputMaybe<Order_By>;
  mission?: InputMaybe<Mission_Order_By>;
  missionId?: InputMaybe<Order_By>;
  projects_aggregate?: InputMaybe<Project_Aggregate_Order_By>;
  question?: InputMaybe<Order_By>;
  responseType?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mission_challenge */
export type Mission_Challenge_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "mission_challenge" */
export enum Mission_Challenge_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  FirestoreId = 'firestoreId',
  /** column name */
  Id = 'id',
  /** column name */
  MinutesToComplete = 'minutesToComplete',
  /** column name */
  MissionId = 'missionId',
  /** column name */
  Question = 'question',
  /** column name */
  ResponseType = 'responseType',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "mission_challenge" */
export type Mission_Challenge_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  firestoreId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  minutesToComplete?: InputMaybe<Scalars['Int']>;
  missionId?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['String']>;
  responseType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Mission_Challenge_Stddev_Fields = {
  __typename?: 'mission_challenge_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  minutesToComplete?: Maybe<Scalars['Float']>;
  missionId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "mission_challenge" */
export type Mission_Challenge_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  minutesToComplete?: InputMaybe<Order_By>;
  missionId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mission_Challenge_Stddev_Pop_Fields = {
  __typename?: 'mission_challenge_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  minutesToComplete?: Maybe<Scalars['Float']>;
  missionId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "mission_challenge" */
export type Mission_Challenge_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  minutesToComplete?: InputMaybe<Order_By>;
  missionId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mission_Challenge_Stddev_Samp_Fields = {
  __typename?: 'mission_challenge_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  minutesToComplete?: Maybe<Scalars['Float']>;
  missionId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "mission_challenge" */
export type Mission_Challenge_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  minutesToComplete?: InputMaybe<Order_By>;
  missionId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mission_challenge" */
export type Mission_Challenge_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mission_Challenge_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mission_Challenge_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  firestoreId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  minutesToComplete?: InputMaybe<Scalars['Int']>;
  missionId?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['String']>;
  responseType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Mission_Challenge_Sum_Fields = {
  __typename?: 'mission_challenge_sum_fields';
  id?: Maybe<Scalars['Int']>;
  minutesToComplete?: Maybe<Scalars['Int']>;
  missionId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "mission_challenge" */
export type Mission_Challenge_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  minutesToComplete?: InputMaybe<Order_By>;
  missionId?: InputMaybe<Order_By>;
};

/** update columns of table "mission_challenge" */
export enum Mission_Challenge_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  FirestoreId = 'firestoreId',
  /** column name */
  Id = 'id',
  /** column name */
  MinutesToComplete = 'minutesToComplete',
  /** column name */
  MissionId = 'missionId',
  /** column name */
  Question = 'question',
  /** column name */
  ResponseType = 'responseType',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Mission_Challenge_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mission_Challenge_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mission_Challenge_Set_Input>;
  where: Mission_Challenge_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mission_Challenge_Var_Pop_Fields = {
  __typename?: 'mission_challenge_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  minutesToComplete?: Maybe<Scalars['Float']>;
  missionId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "mission_challenge" */
export type Mission_Challenge_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  minutesToComplete?: InputMaybe<Order_By>;
  missionId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mission_Challenge_Var_Samp_Fields = {
  __typename?: 'mission_challenge_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  minutesToComplete?: Maybe<Scalars['Float']>;
  missionId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "mission_challenge" */
export type Mission_Challenge_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  minutesToComplete?: InputMaybe<Order_By>;
  missionId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mission_Challenge_Variance_Fields = {
  __typename?: 'mission_challenge_variance_fields';
  id?: Maybe<Scalars['Float']>;
  minutesToComplete?: Maybe<Scalars['Float']>;
  missionId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "mission_challenge" */
export type Mission_Challenge_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  minutesToComplete?: InputMaybe<Order_By>;
  missionId?: InputMaybe<Order_By>;
};

/** columns and relationships of "mission_comment" */
export type Mission_Comment = {
  __typename?: 'mission_comment';
  /** An object relationship */
  comment: Comment;
  commentId: Scalars['uuid'];
  missionId: Scalars['Int'];
};

/** aggregated selection of "mission_comment" */
export type Mission_Comment_Aggregate = {
  __typename?: 'mission_comment_aggregate';
  aggregate?: Maybe<Mission_Comment_Aggregate_Fields>;
  nodes: Array<Mission_Comment>;
};

/** aggregate fields of "mission_comment" */
export type Mission_Comment_Aggregate_Fields = {
  __typename?: 'mission_comment_aggregate_fields';
  avg?: Maybe<Mission_Comment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Mission_Comment_Max_Fields>;
  min?: Maybe<Mission_Comment_Min_Fields>;
  stddev?: Maybe<Mission_Comment_Stddev_Fields>;
  stddev_pop?: Maybe<Mission_Comment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mission_Comment_Stddev_Samp_Fields>;
  sum?: Maybe<Mission_Comment_Sum_Fields>;
  var_pop?: Maybe<Mission_Comment_Var_Pop_Fields>;
  var_samp?: Maybe<Mission_Comment_Var_Samp_Fields>;
  variance?: Maybe<Mission_Comment_Variance_Fields>;
};


/** aggregate fields of "mission_comment" */
export type Mission_Comment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mission_Comment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "mission_comment" */
export type Mission_Comment_Aggregate_Order_By = {
  avg?: InputMaybe<Mission_Comment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mission_Comment_Max_Order_By>;
  min?: InputMaybe<Mission_Comment_Min_Order_By>;
  stddev?: InputMaybe<Mission_Comment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mission_Comment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mission_Comment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mission_Comment_Sum_Order_By>;
  var_pop?: InputMaybe<Mission_Comment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mission_Comment_Var_Samp_Order_By>;
  variance?: InputMaybe<Mission_Comment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mission_comment" */
export type Mission_Comment_Arr_Rel_Insert_Input = {
  data: Array<Mission_Comment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mission_Comment_On_Conflict>;
};

/** aggregate avg on columns */
export type Mission_Comment_Avg_Fields = {
  __typename?: 'mission_comment_avg_fields';
  missionId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "mission_comment" */
export type Mission_Comment_Avg_Order_By = {
  missionId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mission_comment". All fields are combined with a logical 'AND'. */
export type Mission_Comment_Bool_Exp = {
  _and?: InputMaybe<Array<Mission_Comment_Bool_Exp>>;
  _not?: InputMaybe<Mission_Comment_Bool_Exp>;
  _or?: InputMaybe<Array<Mission_Comment_Bool_Exp>>;
  comment?: InputMaybe<Comment_Bool_Exp>;
  commentId?: InputMaybe<Uuid_Comparison_Exp>;
  missionId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "mission_comment" */
export enum Mission_Comment_Constraint {
  /** unique or primary key constraint on columns "comment_id" */
  MissionCommentPkey = 'mission_comment_pkey'
}

/** input type for incrementing numeric columns in table "mission_comment" */
export type Mission_Comment_Inc_Input = {
  missionId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "mission_comment" */
export type Mission_Comment_Insert_Input = {
  comment?: InputMaybe<Comment_Obj_Rel_Insert_Input>;
  commentId?: InputMaybe<Scalars['uuid']>;
  missionId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Mission_Comment_Max_Fields = {
  __typename?: 'mission_comment_max_fields';
  commentId?: Maybe<Scalars['uuid']>;
  missionId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "mission_comment" */
export type Mission_Comment_Max_Order_By = {
  commentId?: InputMaybe<Order_By>;
  missionId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mission_Comment_Min_Fields = {
  __typename?: 'mission_comment_min_fields';
  commentId?: Maybe<Scalars['uuid']>;
  missionId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "mission_comment" */
export type Mission_Comment_Min_Order_By = {
  commentId?: InputMaybe<Order_By>;
  missionId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mission_comment" */
export type Mission_Comment_Mutation_Response = {
  __typename?: 'mission_comment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Mission_Comment>;
};

/** input type for inserting object relation for remote table "mission_comment" */
export type Mission_Comment_Obj_Rel_Insert_Input = {
  data: Mission_Comment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mission_Comment_On_Conflict>;
};

/** on_conflict condition type for table "mission_comment" */
export type Mission_Comment_On_Conflict = {
  constraint: Mission_Comment_Constraint;
  update_columns?: Array<Mission_Comment_Update_Column>;
  where?: InputMaybe<Mission_Comment_Bool_Exp>;
};

/** Ordering options when selecting data from "mission_comment". */
export type Mission_Comment_Order_By = {
  comment?: InputMaybe<Comment_Order_By>;
  commentId?: InputMaybe<Order_By>;
  missionId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mission_comment */
export type Mission_Comment_Pk_Columns_Input = {
  commentId: Scalars['uuid'];
};

/** select columns of table "mission_comment" */
export enum Mission_Comment_Select_Column {
  /** column name */
  CommentId = 'commentId',
  /** column name */
  MissionId = 'missionId'
}

/** input type for updating data in table "mission_comment" */
export type Mission_Comment_Set_Input = {
  commentId?: InputMaybe<Scalars['uuid']>;
  missionId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Mission_Comment_Stddev_Fields = {
  __typename?: 'mission_comment_stddev_fields';
  missionId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "mission_comment" */
export type Mission_Comment_Stddev_Order_By = {
  missionId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mission_Comment_Stddev_Pop_Fields = {
  __typename?: 'mission_comment_stddev_pop_fields';
  missionId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "mission_comment" */
export type Mission_Comment_Stddev_Pop_Order_By = {
  missionId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mission_Comment_Stddev_Samp_Fields = {
  __typename?: 'mission_comment_stddev_samp_fields';
  missionId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "mission_comment" */
export type Mission_Comment_Stddev_Samp_Order_By = {
  missionId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mission_comment" */
export type Mission_Comment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mission_Comment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mission_Comment_Stream_Cursor_Value_Input = {
  commentId?: InputMaybe<Scalars['uuid']>;
  missionId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Mission_Comment_Sum_Fields = {
  __typename?: 'mission_comment_sum_fields';
  missionId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "mission_comment" */
export type Mission_Comment_Sum_Order_By = {
  missionId?: InputMaybe<Order_By>;
};

/** update columns of table "mission_comment" */
export enum Mission_Comment_Update_Column {
  /** column name */
  CommentId = 'commentId',
  /** column name */
  MissionId = 'missionId'
}

export type Mission_Comment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mission_Comment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mission_Comment_Set_Input>;
  where: Mission_Comment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mission_Comment_Var_Pop_Fields = {
  __typename?: 'mission_comment_var_pop_fields';
  missionId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "mission_comment" */
export type Mission_Comment_Var_Pop_Order_By = {
  missionId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mission_Comment_Var_Samp_Fields = {
  __typename?: 'mission_comment_var_samp_fields';
  missionId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "mission_comment" */
export type Mission_Comment_Var_Samp_Order_By = {
  missionId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mission_Comment_Variance_Fields = {
  __typename?: 'mission_comment_variance_fields';
  missionId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "mission_comment" */
export type Mission_Comment_Variance_Order_By = {
  missionId?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "mission" */
export enum Mission_Constraint {
  /** unique or primary key constraint on columns "firestore_id" */
  MissionFirestoreIdKey = 'mission_firestore_id_key',
  /** unique or primary key constraint on columns "path_id" */
  MissionPathIdCapstone = 'mission_path_id_capstone',
  /** unique or primary key constraint on columns "id" */
  MissionPkey = 'mission_pkey'
}

/** input type for incrementing numeric columns in table "mission" */
export type Mission_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  pathId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "mission" */
export type Mission_Insert_Input = {
  challenges?: InputMaybe<Mission_Challenge_Arr_Rel_Insert_Input>;
  comments?: InputMaybe<Mission_Comment_Arr_Rel_Insert_Input>;
  coverFileId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  firestoreId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isCapstone?: InputMaybe<Scalars['Boolean']>;
  path?: InputMaybe<Path_Obj_Rel_Insert_Input>;
  pathId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
  video?: InputMaybe<User_File_Obj_Rel_Insert_Input>;
  videoFileId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Mission_Max_Fields = {
  __typename?: 'mission_max_fields';
  coverFileId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  firestoreId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  pathId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
  videoFileId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "mission" */
export type Mission_Max_Order_By = {
  coverFileId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  firestoreId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  videoFileId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mission_Min_Fields = {
  __typename?: 'mission_min_fields';
  coverFileId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  firestoreId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  pathId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
  videoFileId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "mission" */
export type Mission_Min_Order_By = {
  coverFileId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  firestoreId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  videoFileId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mission" */
export type Mission_Mutation_Response = {
  __typename?: 'mission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Mission>;
};

/** input type for inserting object relation for remote table "mission" */
export type Mission_Obj_Rel_Insert_Input = {
  data: Mission_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mission_On_Conflict>;
};

/** on_conflict condition type for table "mission" */
export type Mission_On_Conflict = {
  constraint: Mission_Constraint;
  update_columns?: Array<Mission_Update_Column>;
  where?: InputMaybe<Mission_Bool_Exp>;
};

/** Ordering options when selecting data from "mission". */
export type Mission_Order_By = {
  challenges_aggregate?: InputMaybe<Mission_Challenge_Aggregate_Order_By>;
  comments_aggregate?: InputMaybe<Mission_Comment_Aggregate_Order_By>;
  coverFileId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  firestoreId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isCapstone?: InputMaybe<Order_By>;
  path?: InputMaybe<Path_Order_By>;
  pathId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  video?: InputMaybe<User_File_Order_By>;
  videoFileId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mission */
export type Mission_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "mission" */
export enum Mission_Select_Column {
  /** column name */
  CoverFileId = 'coverFileId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  FirestoreId = 'firestoreId',
  /** column name */
  Id = 'id',
  /** column name */
  IsCapstone = 'isCapstone',
  /** column name */
  PathId = 'pathId',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  VideoFileId = 'videoFileId'
}

/** input type for updating data in table "mission" */
export type Mission_Set_Input = {
  coverFileId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  firestoreId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isCapstone?: InputMaybe<Scalars['Boolean']>;
  pathId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
  videoFileId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Mission_Stddev_Fields = {
  __typename?: 'mission_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "mission" */
export type Mission_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mission_Stddev_Pop_Fields = {
  __typename?: 'mission_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "mission" */
export type Mission_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mission_Stddev_Samp_Fields = {
  __typename?: 'mission_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "mission" */
export type Mission_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mission" */
export type Mission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mission_Stream_Cursor_Value_Input = {
  coverFileId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  firestoreId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isCapstone?: InputMaybe<Scalars['Boolean']>;
  pathId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
  videoFileId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Mission_Sum_Fields = {
  __typename?: 'mission_sum_fields';
  id?: Maybe<Scalars['Int']>;
  pathId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "mission" */
export type Mission_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
};

/** update columns of table "mission" */
export enum Mission_Update_Column {
  /** column name */
  CoverFileId = 'coverFileId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  FirestoreId = 'firestoreId',
  /** column name */
  Id = 'id',
  /** column name */
  IsCapstone = 'isCapstone',
  /** column name */
  PathId = 'pathId',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  VideoFileId = 'videoFileId'
}

export type Mission_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mission_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mission_Set_Input>;
  where: Mission_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mission_Var_Pop_Fields = {
  __typename?: 'mission_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  pathId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "mission" */
export type Mission_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mission_Var_Samp_Fields = {
  __typename?: 'mission_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  pathId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "mission" */
export type Mission_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mission_Variance_Fields = {
  __typename?: 'mission_variance_fields';
  id?: Maybe<Scalars['Float']>;
  pathId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "mission" */
export type Mission_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  api_create_classroom?: Maybe<Api_Create_Classroom_Output>;
  api_create_project?: Maybe<Api_Create_Project_Output>;
  api_delete_user: Scalars['String'];
  api_disable_user?: Maybe<Api_Disable_User_Output>;
  api_import_classrooms?: Maybe<Array<Maybe<Api_Import_Classrooms_Output>>>;
  api_join_classroom?: Maybe<Api_Join_Classroom_Output>;
  api_join_livestream: Scalars['uuid'];
  api_onboard_educator?: Maybe<Api_Onboard_Educator_Output>;
  api_sign_up?: Maybe<Api_Sign_Up_Output>;
  api_sync_roster?: Maybe<Api_Sync_Roster_Output>;
  api_update_learner_group_settings?: Maybe<Api_Update_Learner_Group_Settings_Output>;
  api_update_privacy?: Maybe<Api_Update_Privacy_Output>;
  api_upsert_organization?: Maybe<Api_Upsert_Organization_Output>;
  /** delete data from the table: "assignment" */
  delete_assignment?: Maybe<Assignment_Mutation_Response>;
  /** delete single row from the table: "assignment" */
  delete_assignment_by_pk?: Maybe<Assignment>;
  /** delete data from the table: "assignment_learner_group" */
  delete_assignment_learner_group?: Maybe<Assignment_Learner_Group_Mutation_Response>;
  /** delete single row from the table: "assignment_learner_group" */
  delete_assignment_learner_group_by_pk?: Maybe<Assignment_Learner_Group>;
  /** delete data from the table: "assignment_path" */
  delete_assignment_path?: Maybe<Assignment_Path_Mutation_Response>;
  /** delete single row from the table: "assignment_path" */
  delete_assignment_path_by_pk?: Maybe<Assignment_Path>;
  /** delete data from the table: "award" */
  delete_award?: Maybe<Award_Mutation_Response>;
  /** delete single row from the table: "award" */
  delete_award_by_pk?: Maybe<Award>;
  /** delete data from the table: "coin_trx" */
  delete_coin_trx?: Maybe<Coin_Trx_Mutation_Response>;
  /** delete single row from the table: "coin_trx" */
  delete_coin_trx_by_pk?: Maybe<Coin_Trx>;
  /** delete data from the table: "comment" */
  delete_comment?: Maybe<Comment_Mutation_Response>;
  /** delete single row from the table: "comment" */
  delete_comment_by_pk?: Maybe<Comment>;
  /** delete data from the table: "educator_code" */
  delete_educator_code?: Maybe<Educator_Code_Mutation_Response>;
  /** delete single row from the table: "educator_code" */
  delete_educator_code_by_pk?: Maybe<Educator_Code>;
  /** delete data from the table: "educator_code_redemption" */
  delete_educator_code_redemption?: Maybe<Educator_Code_Redemption_Mutation_Response>;
  /** delete single row from the table: "educator_code_redemption" */
  delete_educator_code_redemption_by_pk?: Maybe<Educator_Code_Redemption>;
  /** delete data from the table: "enums.coin_trx_category" */
  delete_enums_coin_trx_category?: Maybe<Enums_Coin_Trx_Category_Mutation_Response>;
  /** delete single row from the table: "enums.coin_trx_category" */
  delete_enums_coin_trx_category_by_pk?: Maybe<Enums_Coin_Trx_Category>;
  /** delete data from the table: "enums.integration_provider" */
  delete_enums_integration_provider?: Maybe<Enums_Integration_Provider_Mutation_Response>;
  /** delete single row from the table: "enums.integration_provider" */
  delete_enums_integration_provider_by_pk?: Maybe<Enums_Integration_Provider>;
  /** delete data from the table: "enums.project_status" */
  delete_enums_project_status?: Maybe<Enums_Project_Status_Mutation_Response>;
  /** delete single row from the table: "enums.project_status" */
  delete_enums_project_status_by_pk?: Maybe<Enums_Project_Status>;
  /** delete data from the table: "guide" */
  delete_guide?: Maybe<Guide_Mutation_Response>;
  /** delete single row from the table: "guide" */
  delete_guide_by_pk?: Maybe<Guide>;
  /** delete data from the table: "guide_path" */
  delete_guide_path?: Maybe<Guide_Path_Mutation_Response>;
  /** delete single row from the table: "guide_path" */
  delete_guide_path_by_pk?: Maybe<Guide_Path>;
  /** delete data from the table: "learner_group" */
  delete_learner_group?: Maybe<Learner_Group_Mutation_Response>;
  /** delete single row from the table: "learner_group" */
  delete_learner_group_by_pk?: Maybe<Learner_Group>;
  /** delete data from the table: "learner_group_member" */
  delete_learner_group_member?: Maybe<Learner_Group_Member_Mutation_Response>;
  /** delete single row from the table: "learner_group_member" */
  delete_learner_group_member_by_pk?: Maybe<Learner_Group_Member>;
  /** delete data from the table: "learner_group_path_collection" */
  delete_learner_group_path_collection?: Maybe<Learner_Group_Path_Collection_Mutation_Response>;
  /** delete single row from the table: "learner_group_path_collection" */
  delete_learner_group_path_collection_by_pk?: Maybe<Learner_Group_Path_Collection>;
  /** delete data from the table: "learner_group_pending_member" */
  delete_learner_group_pending_member?: Maybe<Learner_Group_Pending_Member_Mutation_Response>;
  /** delete single row from the table: "learner_group_pending_member" */
  delete_learner_group_pending_member_by_pk?: Maybe<Learner_Group_Pending_Member>;
  /** delete data from the table: "livestream" */
  delete_livestream?: Maybe<Livestream_Mutation_Response>;
  /** delete single row from the table: "livestream" */
  delete_livestream_by_pk?: Maybe<Livestream>;
  /** delete data from the table: "lms" */
  delete_lms?: Maybe<Lms_Mutation_Response>;
  /** delete single row from the table: "lms" */
  delete_lms_by_pk?: Maybe<Lms>;
  /** delete data from the table: "mission" */
  delete_mission?: Maybe<Mission_Mutation_Response>;
  /** delete data from the table: "mission_attachment" */
  delete_mission_attachment?: Maybe<Mission_Attachment_Mutation_Response>;
  /** delete single row from the table: "mission_attachment" */
  delete_mission_attachment_by_pk?: Maybe<Mission_Attachment>;
  /** delete single row from the table: "mission" */
  delete_mission_by_pk?: Maybe<Mission>;
  /** delete data from the table: "mission_challenge" */
  delete_mission_challenge?: Maybe<Mission_Challenge_Mutation_Response>;
  /** delete single row from the table: "mission_challenge" */
  delete_mission_challenge_by_pk?: Maybe<Mission_Challenge>;
  /** delete data from the table: "mission_comment" */
  delete_mission_comment?: Maybe<Mission_Comment_Mutation_Response>;
  /** delete single row from the table: "mission_comment" */
  delete_mission_comment_by_pk?: Maybe<Mission_Comment>;
  /** delete data from the table: "organization" */
  delete_organization?: Maybe<Organization_Mutation_Response>;
  /** delete single row from the table: "organization" */
  delete_organization_by_pk?: Maybe<Organization>;
  /** delete data from the table: "organization_domain" */
  delete_organization_domain?: Maybe<Organization_Domain_Mutation_Response>;
  /** delete single row from the table: "organization_domain" */
  delete_organization_domain_by_pk?: Maybe<Organization_Domain>;
  /** delete data from the table: "path" */
  delete_path?: Maybe<Path_Mutation_Response>;
  /** delete data from the table: "path_active_user" */
  delete_path_active_user?: Maybe<Path_Active_User_Mutation_Response>;
  /** delete single row from the table: "path_active_user" */
  delete_path_active_user_by_pk?: Maybe<Path_Active_User>;
  /** delete data from the table: "path_activity" */
  delete_path_activity?: Maybe<Path_Activity_Mutation_Response>;
  /** delete single row from the table: "path_activity" */
  delete_path_activity_by_pk?: Maybe<Path_Activity>;
  /** delete data from the table: "path_author" */
  delete_path_author?: Maybe<Path_Author_Mutation_Response>;
  /** delete single row from the table: "path_author" */
  delete_path_author_by_pk?: Maybe<Path_Author>;
  /** delete single row from the table: "path" */
  delete_path_by_pk?: Maybe<Path>;
  /** delete data from the table: "path_collection" */
  delete_path_collection?: Maybe<Path_Collection_Mutation_Response>;
  /** delete single row from the table: "path_collection" */
  delete_path_collection_by_pk?: Maybe<Path_Collection>;
  /** delete data from the table: "path_collection_item" */
  delete_path_collection_item?: Maybe<Path_Collection_Item_Mutation_Response>;
  /** delete single row from the table: "path_collection_item" */
  delete_path_collection_item_by_pk?: Maybe<Path_Collection_Item>;
  /** delete data from the table: "path_feed" */
  delete_path_feed?: Maybe<Path_Feed_Mutation_Response>;
  /** delete single row from the table: "path_feed" */
  delete_path_feed_by_pk?: Maybe<Path_Feed>;
  /** delete data from the table: "path_node" */
  delete_path_node?: Maybe<Path_Node_Mutation_Response>;
  /** delete single row from the table: "path_node" */
  delete_path_node_by_pk?: Maybe<Path_Node>;
  /** delete data from the table: "path_node_comment" */
  delete_path_node_comment?: Maybe<Path_Node_Comment_Mutation_Response>;
  /** delete single row from the table: "path_node_comment" */
  delete_path_node_comment_by_pk?: Maybe<Path_Node_Comment>;
  /** delete data from the table: "path_review" */
  delete_path_review?: Maybe<Path_Review_Mutation_Response>;
  /** delete single row from the table: "path_review" */
  delete_path_review_by_pk?: Maybe<Path_Review>;
  /** delete data from the table: "project" */
  delete_project?: Maybe<Project_Mutation_Response>;
  /** delete data from the table: "project_award" */
  delete_project_award?: Maybe<Project_Award_Mutation_Response>;
  /** delete single row from the table: "project_award" */
  delete_project_award_by_pk?: Maybe<Project_Award>;
  /** delete single row from the table: "project" */
  delete_project_by_pk?: Maybe<Project>;
  /** delete data from the table: "project_comment" */
  delete_project_comment?: Maybe<Project_Comment_Mutation_Response>;
  /** delete single row from the table: "project_comment" */
  delete_project_comment_by_pk?: Maybe<Project_Comment>;
  /** delete data from the table: "project_reaction" */
  delete_project_reaction?: Maybe<Project_Reaction_Mutation_Response>;
  /** delete single row from the table: "project_reaction" */
  delete_project_reaction_by_pk?: Maybe<Project_Reaction>;
  /** delete data from the table: "project_stats" */
  delete_project_stats?: Maybe<Project_Stats_Mutation_Response>;
  /** delete single row from the table: "project_stats" */
  delete_project_stats_by_pk?: Maybe<Project_Stats>;
  /** delete data from the table: "shop_item" */
  delete_shop_item?: Maybe<Shop_Item_Mutation_Response>;
  /** delete single row from the table: "shop_item" */
  delete_shop_item_by_pk?: Maybe<Shop_Item>;
  /** delete data from the table: "shop_item_purchase" */
  delete_shop_item_purchase?: Maybe<Shop_Item_Purchase_Mutation_Response>;
  /** delete single row from the table: "shop_item_purchase" */
  delete_shop_item_purchase_by_pk?: Maybe<Shop_Item_Purchase>;
  /** delete data from the table: "user" */
  delete_user?: Maybe<User_Mutation_Response>;
  /** delete data from the table: "user_award" */
  delete_user_award?: Maybe<User_Award_Mutation_Response>;
  /** delete single row from the table: "user_award" */
  delete_user_award_by_pk?: Maybe<User_Award>;
  /** delete single row from the table: "user" */
  delete_user_by_pk?: Maybe<User>;
  /** delete data from the table: "user_file" */
  delete_user_file?: Maybe<User_File_Mutation_Response>;
  /** delete single row from the table: "user_file" */
  delete_user_file_by_pk?: Maybe<User_File>;
  /** delete data from the table: "user_file_integration" */
  delete_user_file_integration?: Maybe<User_File_Integration_Mutation_Response>;
  /** delete single row from the table: "user_file_integration" */
  delete_user_file_integration_by_pk?: Maybe<User_File_Integration>;
  /** delete data from the table: "user_file_transform" */
  delete_user_file_transform?: Maybe<User_File_Transform_Mutation_Response>;
  /** delete single row from the table: "user_file_transform" */
  delete_user_file_transform_by_pk?: Maybe<User_File_Transform>;
  /** delete data from the table: "user_follow" */
  delete_user_follow?: Maybe<User_Follow_Mutation_Response>;
  /** delete single row from the table: "user_follow" */
  delete_user_follow_by_pk?: Maybe<User_Follow>;
  /** delete data from the table: "user_integration" */
  delete_user_integration?: Maybe<User_Integration_Mutation_Response>;
  /** delete single row from the table: "user_integration" */
  delete_user_integration_by_pk?: Maybe<User_Integration>;
  /** delete data from the table: "user_path" */
  delete_user_path?: Maybe<User_Path_Mutation_Response>;
  /** delete single row from the table: "user_path" */
  delete_user_path_by_pk?: Maybe<User_Path>;
  /** delete data from the table: "user_subscription" */
  delete_user_subscription?: Maybe<User_Subscription_Mutation_Response>;
  /** delete single row from the table: "user_subscription" */
  delete_user_subscription_by_pk?: Maybe<User_Subscription>;
  /** delete data from the table: "user_teacher" */
  delete_user_teacher?: Maybe<User_Teacher_Mutation_Response>;
  /** delete single row from the table: "user_teacher" */
  delete_user_teacher_by_pk?: Maybe<User_Teacher>;
  /** insert data into the table: "assignment" */
  insert_assignment?: Maybe<Assignment_Mutation_Response>;
  /** insert data into the table: "assignment_learner_group" */
  insert_assignment_learner_group?: Maybe<Assignment_Learner_Group_Mutation_Response>;
  /** insert a single row into the table: "assignment_learner_group" */
  insert_assignment_learner_group_one?: Maybe<Assignment_Learner_Group>;
  /** insert a single row into the table: "assignment" */
  insert_assignment_one?: Maybe<Assignment>;
  /** insert data into the table: "assignment_path" */
  insert_assignment_path?: Maybe<Assignment_Path_Mutation_Response>;
  /** insert a single row into the table: "assignment_path" */
  insert_assignment_path_one?: Maybe<Assignment_Path>;
  /** insert data into the table: "award" */
  insert_award?: Maybe<Award_Mutation_Response>;
  /** insert a single row into the table: "award" */
  insert_award_one?: Maybe<Award>;
  /** insert data into the table: "coin_trx" */
  insert_coin_trx?: Maybe<Coin_Trx_Mutation_Response>;
  /** insert a single row into the table: "coin_trx" */
  insert_coin_trx_one?: Maybe<Coin_Trx>;
  /** insert data into the table: "comment" */
  insert_comment?: Maybe<Comment_Mutation_Response>;
  /** insert a single row into the table: "comment" */
  insert_comment_one?: Maybe<Comment>;
  /** insert data into the table: "educator_code" */
  insert_educator_code?: Maybe<Educator_Code_Mutation_Response>;
  /** insert a single row into the table: "educator_code" */
  insert_educator_code_one?: Maybe<Educator_Code>;
  /** insert data into the table: "educator_code_redemption" */
  insert_educator_code_redemption?: Maybe<Educator_Code_Redemption_Mutation_Response>;
  /** insert a single row into the table: "educator_code_redemption" */
  insert_educator_code_redemption_one?: Maybe<Educator_Code_Redemption>;
  /** insert data into the table: "enums.coin_trx_category" */
  insert_enums_coin_trx_category?: Maybe<Enums_Coin_Trx_Category_Mutation_Response>;
  /** insert a single row into the table: "enums.coin_trx_category" */
  insert_enums_coin_trx_category_one?: Maybe<Enums_Coin_Trx_Category>;
  /** insert data into the table: "enums.integration_provider" */
  insert_enums_integration_provider?: Maybe<Enums_Integration_Provider_Mutation_Response>;
  /** insert a single row into the table: "enums.integration_provider" */
  insert_enums_integration_provider_one?: Maybe<Enums_Integration_Provider>;
  /** insert data into the table: "enums.project_status" */
  insert_enums_project_status?: Maybe<Enums_Project_Status_Mutation_Response>;
  /** insert a single row into the table: "enums.project_status" */
  insert_enums_project_status_one?: Maybe<Enums_Project_Status>;
  /** insert data into the table: "guide" */
  insert_guide?: Maybe<Guide_Mutation_Response>;
  /** insert a single row into the table: "guide" */
  insert_guide_one?: Maybe<Guide>;
  /** insert data into the table: "guide_path" */
  insert_guide_path?: Maybe<Guide_Path_Mutation_Response>;
  /** insert a single row into the table: "guide_path" */
  insert_guide_path_one?: Maybe<Guide_Path>;
  /** insert data into the table: "learner_group" */
  insert_learner_group?: Maybe<Learner_Group_Mutation_Response>;
  /** insert data into the table: "learner_group_member" */
  insert_learner_group_member?: Maybe<Learner_Group_Member_Mutation_Response>;
  /** insert a single row into the table: "learner_group_member" */
  insert_learner_group_member_one?: Maybe<Learner_Group_Member>;
  /** insert a single row into the table: "learner_group" */
  insert_learner_group_one?: Maybe<Learner_Group>;
  /** insert data into the table: "learner_group_path_collection" */
  insert_learner_group_path_collection?: Maybe<Learner_Group_Path_Collection_Mutation_Response>;
  /** insert a single row into the table: "learner_group_path_collection" */
  insert_learner_group_path_collection_one?: Maybe<Learner_Group_Path_Collection>;
  /** insert data into the table: "learner_group_pending_member" */
  insert_learner_group_pending_member?: Maybe<Learner_Group_Pending_Member_Mutation_Response>;
  /** insert a single row into the table: "learner_group_pending_member" */
  insert_learner_group_pending_member_one?: Maybe<Learner_Group_Pending_Member>;
  /** insert data into the table: "livestream" */
  insert_livestream?: Maybe<Livestream_Mutation_Response>;
  /** insert a single row into the table: "livestream" */
  insert_livestream_one?: Maybe<Livestream>;
  /** insert data into the table: "lms" */
  insert_lms?: Maybe<Lms_Mutation_Response>;
  /** insert a single row into the table: "lms" */
  insert_lms_one?: Maybe<Lms>;
  /** insert data into the table: "mission" */
  insert_mission?: Maybe<Mission_Mutation_Response>;
  /** insert data into the table: "mission_attachment" */
  insert_mission_attachment?: Maybe<Mission_Attachment_Mutation_Response>;
  /** insert a single row into the table: "mission_attachment" */
  insert_mission_attachment_one?: Maybe<Mission_Attachment>;
  /** insert data into the table: "mission_challenge" */
  insert_mission_challenge?: Maybe<Mission_Challenge_Mutation_Response>;
  /** insert a single row into the table: "mission_challenge" */
  insert_mission_challenge_one?: Maybe<Mission_Challenge>;
  /** insert data into the table: "mission_comment" */
  insert_mission_comment?: Maybe<Mission_Comment_Mutation_Response>;
  /** insert a single row into the table: "mission_comment" */
  insert_mission_comment_one?: Maybe<Mission_Comment>;
  /** insert a single row into the table: "mission" */
  insert_mission_one?: Maybe<Mission>;
  /** insert data into the table: "organization" */
  insert_organization?: Maybe<Organization_Mutation_Response>;
  /** insert data into the table: "organization_domain" */
  insert_organization_domain?: Maybe<Organization_Domain_Mutation_Response>;
  /** insert a single row into the table: "organization_domain" */
  insert_organization_domain_one?: Maybe<Organization_Domain>;
  /** insert a single row into the table: "organization" */
  insert_organization_one?: Maybe<Organization>;
  /** insert data into the table: "path" */
  insert_path?: Maybe<Path_Mutation_Response>;
  /** insert data into the table: "path_active_user" */
  insert_path_active_user?: Maybe<Path_Active_User_Mutation_Response>;
  /** insert a single row into the table: "path_active_user" */
  insert_path_active_user_one?: Maybe<Path_Active_User>;
  /** insert data into the table: "path_activity" */
  insert_path_activity?: Maybe<Path_Activity_Mutation_Response>;
  /** insert a single row into the table: "path_activity" */
  insert_path_activity_one?: Maybe<Path_Activity>;
  /** insert data into the table: "path_author" */
  insert_path_author?: Maybe<Path_Author_Mutation_Response>;
  /** insert a single row into the table: "path_author" */
  insert_path_author_one?: Maybe<Path_Author>;
  /** insert data into the table: "path_collection" */
  insert_path_collection?: Maybe<Path_Collection_Mutation_Response>;
  /** insert data into the table: "path_collection_item" */
  insert_path_collection_item?: Maybe<Path_Collection_Item_Mutation_Response>;
  /** insert a single row into the table: "path_collection_item" */
  insert_path_collection_item_one?: Maybe<Path_Collection_Item>;
  /** insert a single row into the table: "path_collection" */
  insert_path_collection_one?: Maybe<Path_Collection>;
  /** insert data into the table: "path_feed" */
  insert_path_feed?: Maybe<Path_Feed_Mutation_Response>;
  /** insert a single row into the table: "path_feed" */
  insert_path_feed_one?: Maybe<Path_Feed>;
  /** insert data into the table: "path_node" */
  insert_path_node?: Maybe<Path_Node_Mutation_Response>;
  /** insert data into the table: "path_node_comment" */
  insert_path_node_comment?: Maybe<Path_Node_Comment_Mutation_Response>;
  /** insert a single row into the table: "path_node_comment" */
  insert_path_node_comment_one?: Maybe<Path_Node_Comment>;
  /** insert a single row into the table: "path_node" */
  insert_path_node_one?: Maybe<Path_Node>;
  /** insert a single row into the table: "path" */
  insert_path_one?: Maybe<Path>;
  /** insert data into the table: "path_review" */
  insert_path_review?: Maybe<Path_Review_Mutation_Response>;
  /** insert a single row into the table: "path_review" */
  insert_path_review_one?: Maybe<Path_Review>;
  /** insert data into the table: "project" */
  insert_project?: Maybe<Project_Mutation_Response>;
  /** insert data into the table: "project_award" */
  insert_project_award?: Maybe<Project_Award_Mutation_Response>;
  /** insert a single row into the table: "project_award" */
  insert_project_award_one?: Maybe<Project_Award>;
  /** insert data into the table: "project_comment" */
  insert_project_comment?: Maybe<Project_Comment_Mutation_Response>;
  /** insert a single row into the table: "project_comment" */
  insert_project_comment_one?: Maybe<Project_Comment>;
  /** insert a single row into the table: "project" */
  insert_project_one?: Maybe<Project>;
  /** insert data into the table: "project_reaction" */
  insert_project_reaction?: Maybe<Project_Reaction_Mutation_Response>;
  /** insert a single row into the table: "project_reaction" */
  insert_project_reaction_one?: Maybe<Project_Reaction>;
  /** insert data into the table: "project_stats" */
  insert_project_stats?: Maybe<Project_Stats_Mutation_Response>;
  /** insert a single row into the table: "project_stats" */
  insert_project_stats_one?: Maybe<Project_Stats>;
  /** insert data into the table: "shop_item" */
  insert_shop_item?: Maybe<Shop_Item_Mutation_Response>;
  /** insert a single row into the table: "shop_item" */
  insert_shop_item_one?: Maybe<Shop_Item>;
  /** insert data into the table: "shop_item_purchase" */
  insert_shop_item_purchase?: Maybe<Shop_Item_Purchase_Mutation_Response>;
  /** insert a single row into the table: "shop_item_purchase" */
  insert_shop_item_purchase_one?: Maybe<Shop_Item_Purchase>;
  /** insert data into the table: "user" */
  insert_user?: Maybe<User_Mutation_Response>;
  /** insert data into the table: "user_award" */
  insert_user_award?: Maybe<User_Award_Mutation_Response>;
  /** insert a single row into the table: "user_award" */
  insert_user_award_one?: Maybe<User_Award>;
  /** insert data into the table: "user_file" */
  insert_user_file?: Maybe<User_File_Mutation_Response>;
  /** insert data into the table: "user_file_integration" */
  insert_user_file_integration?: Maybe<User_File_Integration_Mutation_Response>;
  /** insert a single row into the table: "user_file_integration" */
  insert_user_file_integration_one?: Maybe<User_File_Integration>;
  /** insert a single row into the table: "user_file" */
  insert_user_file_one?: Maybe<User_File>;
  /** insert data into the table: "user_file_transform" */
  insert_user_file_transform?: Maybe<User_File_Transform_Mutation_Response>;
  /** insert a single row into the table: "user_file_transform" */
  insert_user_file_transform_one?: Maybe<User_File_Transform>;
  /** insert data into the table: "user_follow" */
  insert_user_follow?: Maybe<User_Follow_Mutation_Response>;
  /** insert a single row into the table: "user_follow" */
  insert_user_follow_one?: Maybe<User_Follow>;
  /** insert data into the table: "user_integration" */
  insert_user_integration?: Maybe<User_Integration_Mutation_Response>;
  /** insert a single row into the table: "user_integration" */
  insert_user_integration_one?: Maybe<User_Integration>;
  /** insert a single row into the table: "user" */
  insert_user_one?: Maybe<User>;
  /** insert data into the table: "user_path" */
  insert_user_path?: Maybe<User_Path_Mutation_Response>;
  /** insert a single row into the table: "user_path" */
  insert_user_path_one?: Maybe<User_Path>;
  /** insert data into the table: "user_subscription" */
  insert_user_subscription?: Maybe<User_Subscription_Mutation_Response>;
  /** insert a single row into the table: "user_subscription" */
  insert_user_subscription_one?: Maybe<User_Subscription>;
  /** insert data into the table: "user_teacher" */
  insert_user_teacher?: Maybe<User_Teacher_Mutation_Response>;
  /** insert a single row into the table: "user_teacher" */
  insert_user_teacher_one?: Maybe<User_Teacher>;
  /** Stream IO Feed Create Activity */
  streamio_create_activity?: Maybe<StreamIoCreateActivityOutput>;
  /** update data of the table: "assignment" */
  update_assignment?: Maybe<Assignment_Mutation_Response>;
  /** update single row of the table: "assignment" */
  update_assignment_by_pk?: Maybe<Assignment>;
  /** update data of the table: "assignment_learner_group" */
  update_assignment_learner_group?: Maybe<Assignment_Learner_Group_Mutation_Response>;
  /** update single row of the table: "assignment_learner_group" */
  update_assignment_learner_group_by_pk?: Maybe<Assignment_Learner_Group>;
  /** update multiples rows of table: "assignment_learner_group" */
  update_assignment_learner_group_many?: Maybe<Array<Maybe<Assignment_Learner_Group_Mutation_Response>>>;
  /** update multiples rows of table: "assignment" */
  update_assignment_many?: Maybe<Array<Maybe<Assignment_Mutation_Response>>>;
  /** update data of the table: "assignment_path" */
  update_assignment_path?: Maybe<Assignment_Path_Mutation_Response>;
  /** update single row of the table: "assignment_path" */
  update_assignment_path_by_pk?: Maybe<Assignment_Path>;
  /** update multiples rows of table: "assignment_path" */
  update_assignment_path_many?: Maybe<Array<Maybe<Assignment_Path_Mutation_Response>>>;
  /** update data of the table: "award" */
  update_award?: Maybe<Award_Mutation_Response>;
  /** update single row of the table: "award" */
  update_award_by_pk?: Maybe<Award>;
  /** update multiples rows of table: "award" */
  update_award_many?: Maybe<Array<Maybe<Award_Mutation_Response>>>;
  /** update data of the table: "coin_trx" */
  update_coin_trx?: Maybe<Coin_Trx_Mutation_Response>;
  /** update single row of the table: "coin_trx" */
  update_coin_trx_by_pk?: Maybe<Coin_Trx>;
  /** update multiples rows of table: "coin_trx" */
  update_coin_trx_many?: Maybe<Array<Maybe<Coin_Trx_Mutation_Response>>>;
  /** update data of the table: "comment" */
  update_comment?: Maybe<Comment_Mutation_Response>;
  /** update single row of the table: "comment" */
  update_comment_by_pk?: Maybe<Comment>;
  /** update multiples rows of table: "comment" */
  update_comment_many?: Maybe<Array<Maybe<Comment_Mutation_Response>>>;
  /** update data of the table: "educator_code" */
  update_educator_code?: Maybe<Educator_Code_Mutation_Response>;
  /** update single row of the table: "educator_code" */
  update_educator_code_by_pk?: Maybe<Educator_Code>;
  /** update multiples rows of table: "educator_code" */
  update_educator_code_many?: Maybe<Array<Maybe<Educator_Code_Mutation_Response>>>;
  /** update data of the table: "educator_code_redemption" */
  update_educator_code_redemption?: Maybe<Educator_Code_Redemption_Mutation_Response>;
  /** update single row of the table: "educator_code_redemption" */
  update_educator_code_redemption_by_pk?: Maybe<Educator_Code_Redemption>;
  /** update multiples rows of table: "educator_code_redemption" */
  update_educator_code_redemption_many?: Maybe<Array<Maybe<Educator_Code_Redemption_Mutation_Response>>>;
  /** update data of the table: "enums.coin_trx_category" */
  update_enums_coin_trx_category?: Maybe<Enums_Coin_Trx_Category_Mutation_Response>;
  /** update single row of the table: "enums.coin_trx_category" */
  update_enums_coin_trx_category_by_pk?: Maybe<Enums_Coin_Trx_Category>;
  /** update multiples rows of table: "enums.coin_trx_category" */
  update_enums_coin_trx_category_many?: Maybe<Array<Maybe<Enums_Coin_Trx_Category_Mutation_Response>>>;
  /** update data of the table: "enums.integration_provider" */
  update_enums_integration_provider?: Maybe<Enums_Integration_Provider_Mutation_Response>;
  /** update single row of the table: "enums.integration_provider" */
  update_enums_integration_provider_by_pk?: Maybe<Enums_Integration_Provider>;
  /** update multiples rows of table: "enums.integration_provider" */
  update_enums_integration_provider_many?: Maybe<Array<Maybe<Enums_Integration_Provider_Mutation_Response>>>;
  /** update data of the table: "enums.project_status" */
  update_enums_project_status?: Maybe<Enums_Project_Status_Mutation_Response>;
  /** update single row of the table: "enums.project_status" */
  update_enums_project_status_by_pk?: Maybe<Enums_Project_Status>;
  /** update multiples rows of table: "enums.project_status" */
  update_enums_project_status_many?: Maybe<Array<Maybe<Enums_Project_Status_Mutation_Response>>>;
  /** update data of the table: "guide" */
  update_guide?: Maybe<Guide_Mutation_Response>;
  /** update single row of the table: "guide" */
  update_guide_by_pk?: Maybe<Guide>;
  /** update multiples rows of table: "guide" */
  update_guide_many?: Maybe<Array<Maybe<Guide_Mutation_Response>>>;
  /** update data of the table: "guide_path" */
  update_guide_path?: Maybe<Guide_Path_Mutation_Response>;
  /** update single row of the table: "guide_path" */
  update_guide_path_by_pk?: Maybe<Guide_Path>;
  /** update multiples rows of table: "guide_path" */
  update_guide_path_many?: Maybe<Array<Maybe<Guide_Path_Mutation_Response>>>;
  /** update data of the table: "learner_group" */
  update_learner_group?: Maybe<Learner_Group_Mutation_Response>;
  /** update single row of the table: "learner_group" */
  update_learner_group_by_pk?: Maybe<Learner_Group>;
  /** update multiples rows of table: "learner_group" */
  update_learner_group_many?: Maybe<Array<Maybe<Learner_Group_Mutation_Response>>>;
  /** update data of the table: "learner_group_member" */
  update_learner_group_member?: Maybe<Learner_Group_Member_Mutation_Response>;
  /** update single row of the table: "learner_group_member" */
  update_learner_group_member_by_pk?: Maybe<Learner_Group_Member>;
  /** update multiples rows of table: "learner_group_member" */
  update_learner_group_member_many?: Maybe<Array<Maybe<Learner_Group_Member_Mutation_Response>>>;
  /** update data of the table: "learner_group_path_collection" */
  update_learner_group_path_collection?: Maybe<Learner_Group_Path_Collection_Mutation_Response>;
  /** update single row of the table: "learner_group_path_collection" */
  update_learner_group_path_collection_by_pk?: Maybe<Learner_Group_Path_Collection>;
  /** update multiples rows of table: "learner_group_path_collection" */
  update_learner_group_path_collection_many?: Maybe<Array<Maybe<Learner_Group_Path_Collection_Mutation_Response>>>;
  /** update data of the table: "learner_group_pending_member" */
  update_learner_group_pending_member?: Maybe<Learner_Group_Pending_Member_Mutation_Response>;
  /** update single row of the table: "learner_group_pending_member" */
  update_learner_group_pending_member_by_pk?: Maybe<Learner_Group_Pending_Member>;
  /** update multiples rows of table: "learner_group_pending_member" */
  update_learner_group_pending_member_many?: Maybe<Array<Maybe<Learner_Group_Pending_Member_Mutation_Response>>>;
  /** update data of the table: "livestream" */
  update_livestream?: Maybe<Livestream_Mutation_Response>;
  /** update single row of the table: "livestream" */
  update_livestream_by_pk?: Maybe<Livestream>;
  /** update multiples rows of table: "livestream" */
  update_livestream_many?: Maybe<Array<Maybe<Livestream_Mutation_Response>>>;
  /** update data of the table: "lms" */
  update_lms?: Maybe<Lms_Mutation_Response>;
  /** update single row of the table: "lms" */
  update_lms_by_pk?: Maybe<Lms>;
  /** update multiples rows of table: "lms" */
  update_lms_many?: Maybe<Array<Maybe<Lms_Mutation_Response>>>;
  /** update data of the table: "mission" */
  update_mission?: Maybe<Mission_Mutation_Response>;
  /** update data of the table: "mission_attachment" */
  update_mission_attachment?: Maybe<Mission_Attachment_Mutation_Response>;
  /** update single row of the table: "mission_attachment" */
  update_mission_attachment_by_pk?: Maybe<Mission_Attachment>;
  /** update multiples rows of table: "mission_attachment" */
  update_mission_attachment_many?: Maybe<Array<Maybe<Mission_Attachment_Mutation_Response>>>;
  /** update single row of the table: "mission" */
  update_mission_by_pk?: Maybe<Mission>;
  /** update data of the table: "mission_challenge" */
  update_mission_challenge?: Maybe<Mission_Challenge_Mutation_Response>;
  /** update single row of the table: "mission_challenge" */
  update_mission_challenge_by_pk?: Maybe<Mission_Challenge>;
  /** update multiples rows of table: "mission_challenge" */
  update_mission_challenge_many?: Maybe<Array<Maybe<Mission_Challenge_Mutation_Response>>>;
  /** update data of the table: "mission_comment" */
  update_mission_comment?: Maybe<Mission_Comment_Mutation_Response>;
  /** update single row of the table: "mission_comment" */
  update_mission_comment_by_pk?: Maybe<Mission_Comment>;
  /** update multiples rows of table: "mission_comment" */
  update_mission_comment_many?: Maybe<Array<Maybe<Mission_Comment_Mutation_Response>>>;
  /** update multiples rows of table: "mission" */
  update_mission_many?: Maybe<Array<Maybe<Mission_Mutation_Response>>>;
  /** update data of the table: "organization" */
  update_organization?: Maybe<Organization_Mutation_Response>;
  /** update single row of the table: "organization" */
  update_organization_by_pk?: Maybe<Organization>;
  /** update data of the table: "organization_domain" */
  update_organization_domain?: Maybe<Organization_Domain_Mutation_Response>;
  /** update single row of the table: "organization_domain" */
  update_organization_domain_by_pk?: Maybe<Organization_Domain>;
  /** update multiples rows of table: "organization_domain" */
  update_organization_domain_many?: Maybe<Array<Maybe<Organization_Domain_Mutation_Response>>>;
  /** update multiples rows of table: "organization" */
  update_organization_many?: Maybe<Array<Maybe<Organization_Mutation_Response>>>;
  /** update data of the table: "path" */
  update_path?: Maybe<Path_Mutation_Response>;
  /** update data of the table: "path_active_user" */
  update_path_active_user?: Maybe<Path_Active_User_Mutation_Response>;
  /** update single row of the table: "path_active_user" */
  update_path_active_user_by_pk?: Maybe<Path_Active_User>;
  /** update multiples rows of table: "path_active_user" */
  update_path_active_user_many?: Maybe<Array<Maybe<Path_Active_User_Mutation_Response>>>;
  /** update data of the table: "path_activity" */
  update_path_activity?: Maybe<Path_Activity_Mutation_Response>;
  /** update single row of the table: "path_activity" */
  update_path_activity_by_pk?: Maybe<Path_Activity>;
  /** update multiples rows of table: "path_activity" */
  update_path_activity_many?: Maybe<Array<Maybe<Path_Activity_Mutation_Response>>>;
  /** update data of the table: "path_author" */
  update_path_author?: Maybe<Path_Author_Mutation_Response>;
  /** update single row of the table: "path_author" */
  update_path_author_by_pk?: Maybe<Path_Author>;
  /** update multiples rows of table: "path_author" */
  update_path_author_many?: Maybe<Array<Maybe<Path_Author_Mutation_Response>>>;
  /** update single row of the table: "path" */
  update_path_by_pk?: Maybe<Path>;
  /** update data of the table: "path_collection" */
  update_path_collection?: Maybe<Path_Collection_Mutation_Response>;
  /** update single row of the table: "path_collection" */
  update_path_collection_by_pk?: Maybe<Path_Collection>;
  /** update data of the table: "path_collection_item" */
  update_path_collection_item?: Maybe<Path_Collection_Item_Mutation_Response>;
  /** update single row of the table: "path_collection_item" */
  update_path_collection_item_by_pk?: Maybe<Path_Collection_Item>;
  /** update multiples rows of table: "path_collection_item" */
  update_path_collection_item_many?: Maybe<Array<Maybe<Path_Collection_Item_Mutation_Response>>>;
  /** update multiples rows of table: "path_collection" */
  update_path_collection_many?: Maybe<Array<Maybe<Path_Collection_Mutation_Response>>>;
  /** update data of the table: "path_feed" */
  update_path_feed?: Maybe<Path_Feed_Mutation_Response>;
  /** update single row of the table: "path_feed" */
  update_path_feed_by_pk?: Maybe<Path_Feed>;
  /** update multiples rows of table: "path_feed" */
  update_path_feed_many?: Maybe<Array<Maybe<Path_Feed_Mutation_Response>>>;
  /** update multiples rows of table: "path" */
  update_path_many?: Maybe<Array<Maybe<Path_Mutation_Response>>>;
  /** update data of the table: "path_node" */
  update_path_node?: Maybe<Path_Node_Mutation_Response>;
  /** update single row of the table: "path_node" */
  update_path_node_by_pk?: Maybe<Path_Node>;
  /** update data of the table: "path_node_comment" */
  update_path_node_comment?: Maybe<Path_Node_Comment_Mutation_Response>;
  /** update single row of the table: "path_node_comment" */
  update_path_node_comment_by_pk?: Maybe<Path_Node_Comment>;
  /** update multiples rows of table: "path_node_comment" */
  update_path_node_comment_many?: Maybe<Array<Maybe<Path_Node_Comment_Mutation_Response>>>;
  /** update multiples rows of table: "path_node" */
  update_path_node_many?: Maybe<Array<Maybe<Path_Node_Mutation_Response>>>;
  /** update data of the table: "path_review" */
  update_path_review?: Maybe<Path_Review_Mutation_Response>;
  /** update single row of the table: "path_review" */
  update_path_review_by_pk?: Maybe<Path_Review>;
  /** update multiples rows of table: "path_review" */
  update_path_review_many?: Maybe<Array<Maybe<Path_Review_Mutation_Response>>>;
  /** update data of the table: "project" */
  update_project?: Maybe<Project_Mutation_Response>;
  /** update data of the table: "project_award" */
  update_project_award?: Maybe<Project_Award_Mutation_Response>;
  /** update single row of the table: "project_award" */
  update_project_award_by_pk?: Maybe<Project_Award>;
  /** update multiples rows of table: "project_award" */
  update_project_award_many?: Maybe<Array<Maybe<Project_Award_Mutation_Response>>>;
  /** update single row of the table: "project" */
  update_project_by_pk?: Maybe<Project>;
  /** update data of the table: "project_comment" */
  update_project_comment?: Maybe<Project_Comment_Mutation_Response>;
  /** update single row of the table: "project_comment" */
  update_project_comment_by_pk?: Maybe<Project_Comment>;
  /** update multiples rows of table: "project_comment" */
  update_project_comment_many?: Maybe<Array<Maybe<Project_Comment_Mutation_Response>>>;
  /** update multiples rows of table: "project" */
  update_project_many?: Maybe<Array<Maybe<Project_Mutation_Response>>>;
  /** update data of the table: "project_reaction" */
  update_project_reaction?: Maybe<Project_Reaction_Mutation_Response>;
  /** update single row of the table: "project_reaction" */
  update_project_reaction_by_pk?: Maybe<Project_Reaction>;
  /** update multiples rows of table: "project_reaction" */
  update_project_reaction_many?: Maybe<Array<Maybe<Project_Reaction_Mutation_Response>>>;
  /** update data of the table: "project_stats" */
  update_project_stats?: Maybe<Project_Stats_Mutation_Response>;
  /** update single row of the table: "project_stats" */
  update_project_stats_by_pk?: Maybe<Project_Stats>;
  /** update multiples rows of table: "project_stats" */
  update_project_stats_many?: Maybe<Array<Maybe<Project_Stats_Mutation_Response>>>;
  /** update data of the table: "shop_item" */
  update_shop_item?: Maybe<Shop_Item_Mutation_Response>;
  /** update single row of the table: "shop_item" */
  update_shop_item_by_pk?: Maybe<Shop_Item>;
  /** update multiples rows of table: "shop_item" */
  update_shop_item_many?: Maybe<Array<Maybe<Shop_Item_Mutation_Response>>>;
  /** update data of the table: "shop_item_purchase" */
  update_shop_item_purchase?: Maybe<Shop_Item_Purchase_Mutation_Response>;
  /** update single row of the table: "shop_item_purchase" */
  update_shop_item_purchase_by_pk?: Maybe<Shop_Item_Purchase>;
  /** update multiples rows of table: "shop_item_purchase" */
  update_shop_item_purchase_many?: Maybe<Array<Maybe<Shop_Item_Purchase_Mutation_Response>>>;
  /** update data of the table: "user" */
  update_user?: Maybe<User_Mutation_Response>;
  /** update data of the table: "user_award" */
  update_user_award?: Maybe<User_Award_Mutation_Response>;
  /** update single row of the table: "user_award" */
  update_user_award_by_pk?: Maybe<User_Award>;
  /** update multiples rows of table: "user_award" */
  update_user_award_many?: Maybe<Array<Maybe<User_Award_Mutation_Response>>>;
  /** update single row of the table: "user" */
  update_user_by_pk?: Maybe<User>;
  /** update data of the table: "user_file" */
  update_user_file?: Maybe<User_File_Mutation_Response>;
  /** update single row of the table: "user_file" */
  update_user_file_by_pk?: Maybe<User_File>;
  /** update data of the table: "user_file_integration" */
  update_user_file_integration?: Maybe<User_File_Integration_Mutation_Response>;
  /** update single row of the table: "user_file_integration" */
  update_user_file_integration_by_pk?: Maybe<User_File_Integration>;
  /** update multiples rows of table: "user_file_integration" */
  update_user_file_integration_many?: Maybe<Array<Maybe<User_File_Integration_Mutation_Response>>>;
  /** update multiples rows of table: "user_file" */
  update_user_file_many?: Maybe<Array<Maybe<User_File_Mutation_Response>>>;
  /** update data of the table: "user_file_transform" */
  update_user_file_transform?: Maybe<User_File_Transform_Mutation_Response>;
  /** update single row of the table: "user_file_transform" */
  update_user_file_transform_by_pk?: Maybe<User_File_Transform>;
  /** update multiples rows of table: "user_file_transform" */
  update_user_file_transform_many?: Maybe<Array<Maybe<User_File_Transform_Mutation_Response>>>;
  /** update data of the table: "user_follow" */
  update_user_follow?: Maybe<User_Follow_Mutation_Response>;
  /** update single row of the table: "user_follow" */
  update_user_follow_by_pk?: Maybe<User_Follow>;
  /** update multiples rows of table: "user_follow" */
  update_user_follow_many?: Maybe<Array<Maybe<User_Follow_Mutation_Response>>>;
  /** update data of the table: "user_integration" */
  update_user_integration?: Maybe<User_Integration_Mutation_Response>;
  /** update single row of the table: "user_integration" */
  update_user_integration_by_pk?: Maybe<User_Integration>;
  /** update multiples rows of table: "user_integration" */
  update_user_integration_many?: Maybe<Array<Maybe<User_Integration_Mutation_Response>>>;
  /** update multiples rows of table: "user" */
  update_user_many?: Maybe<Array<Maybe<User_Mutation_Response>>>;
  /** update data of the table: "user_path" */
  update_user_path?: Maybe<User_Path_Mutation_Response>;
  /** update single row of the table: "user_path" */
  update_user_path_by_pk?: Maybe<User_Path>;
  /** update multiples rows of table: "user_path" */
  update_user_path_many?: Maybe<Array<Maybe<User_Path_Mutation_Response>>>;
  /** update data of the table: "user_subscription" */
  update_user_subscription?: Maybe<User_Subscription_Mutation_Response>;
  /** update single row of the table: "user_subscription" */
  update_user_subscription_by_pk?: Maybe<User_Subscription>;
  /** update multiples rows of table: "user_subscription" */
  update_user_subscription_many?: Maybe<Array<Maybe<User_Subscription_Mutation_Response>>>;
  /** update data of the table: "user_teacher" */
  update_user_teacher?: Maybe<User_Teacher_Mutation_Response>;
  /** update single row of the table: "user_teacher" */
  update_user_teacher_by_pk?: Maybe<User_Teacher>;
  /** update multiples rows of table: "user_teacher" */
  update_user_teacher_many?: Maybe<Array<Maybe<User_Teacher_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootApi_Create_ClassroomArgs = {
  name: Scalars['String'];
  orgId: Scalars['String'];
  pathId?: InputMaybe<Scalars['bigint']>;
  userId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootApi_Create_ProjectArgs = {
  input?: InputMaybe<Api_Create_Project_Input>;
};


/** mutation root */
export type Mutation_RootApi_Delete_UserArgs = {
  userId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootApi_Disable_UserArgs = {
  input?: InputMaybe<Api_Disable_User_Input>;
};


/** mutation root */
export type Mutation_RootApi_Import_ClassroomsArgs = {
  accessToken: Scalars['String'];
  classes: Array<Classroom_Input>;
  orgId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootApi_Join_ClassroomArgs = {
  educatorCode: Scalars['String'];
  source?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootApi_Join_LivestreamArgs = {
  livestreamId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootApi_Onboard_EducatorArgs = {
  gradeLevel?: InputMaybe<Scalars['String']>;
  orgId?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootApi_Sign_UpArgs = {
  code?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  role: Api_Sign_Up_Role;
  username?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootApi_Sync_RosterArgs = {
  accessToken: Scalars['String'];
  classId: Scalars['String'];
  learnerGroupId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootApi_Update_Learner_Group_SettingsArgs = {
  input?: InputMaybe<Api_Update_Learner_Group_Settings_Input>;
};


/** mutation root */
export type Mutation_RootApi_Update_PrivacyArgs = {
  input?: InputMaybe<Api_Update_Privacy_Input>;
};


/** mutation root */
export type Mutation_RootApi_Upsert_OrganizationArgs = {
  data: Api_Upsert_Organization_Data_Input;
};


/** mutation root */
export type Mutation_RootDelete_AssignmentArgs = {
  where: Assignment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Assignment_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Assignment_Learner_GroupArgs = {
  where: Assignment_Learner_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Assignment_Learner_Group_By_PkArgs = {
  assignmentId: Scalars['uuid'];
  learnerGroupId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Assignment_PathArgs = {
  where: Assignment_Path_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Assignment_Path_By_PkArgs = {
  assignmentId: Scalars['uuid'];
  pathId: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_AwardArgs = {
  where: Award_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Award_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Coin_TrxArgs = {
  where: Coin_Trx_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Coin_Trx_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_CommentArgs = {
  where: Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Comment_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Educator_CodeArgs = {
  where: Educator_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Educator_Code_By_PkArgs = {
  code: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Educator_Code_RedemptionArgs = {
  where: Educator_Code_Redemption_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Educator_Code_Redemption_By_PkArgs = {
  code: Scalars['String'];
  userId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Enums_Coin_Trx_CategoryArgs = {
  where: Enums_Coin_Trx_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enums_Coin_Trx_Category_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Enums_Integration_ProviderArgs = {
  where: Enums_Integration_Provider_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enums_Integration_Provider_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Enums_Project_StatusArgs = {
  where: Enums_Project_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enums_Project_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_GuideArgs = {
  where: Guide_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Guide_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Guide_PathArgs = {
  where: Guide_Path_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Guide_Path_By_PkArgs = {
  guideId: Scalars['uuid'];
  pathId: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Learner_GroupArgs = {
  where: Learner_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Learner_Group_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Learner_Group_MemberArgs = {
  where: Learner_Group_Member_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Learner_Group_Member_By_PkArgs = {
  learnerGroupId: Scalars['uuid'];
  userId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Learner_Group_Path_CollectionArgs = {
  where: Learner_Group_Path_Collection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Learner_Group_Path_Collection_By_PkArgs = {
  learnerGroupId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Learner_Group_Pending_MemberArgs = {
  where: Learner_Group_Pending_Member_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Learner_Group_Pending_Member_By_PkArgs = {
  foreignId: Scalars['String'];
  learnerGroupId: Scalars['uuid'];
  provider: Enums_Integration_Provider_Enum;
};


/** mutation root */
export type Mutation_RootDelete_LivestreamArgs = {
  where: Livestream_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Livestream_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_LmsArgs = {
  where: Lms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lms_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_MissionArgs = {
  where: Mission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mission_AttachmentArgs = {
  where: Mission_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mission_Attachment_By_PkArgs = {
  fileId: Scalars['uuid'];
  missionId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Mission_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Mission_ChallengeArgs = {
  where: Mission_Challenge_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mission_Challenge_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Mission_CommentArgs = {
  where: Mission_Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mission_Comment_By_PkArgs = {
  commentId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_OrganizationArgs = {
  where: Organization_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_By_PkArgs = {
  firestoreId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_DomainArgs = {
  where: Organization_Domain_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Domain_By_PkArgs = {
  domain: Scalars['String'];
  orgId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_PathArgs = {
  where: Path_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Path_Active_UserArgs = {
  where: Path_Active_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Path_Active_User_By_PkArgs = {
  pathId: Scalars['bigint'];
  userId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Path_ActivityArgs = {
  where: Path_Activity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Path_Activity_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Path_AuthorArgs = {
  where: Path_Author_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Path_Author_By_PkArgs = {
  pathId: Scalars['bigint'];
  userId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Path_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Path_CollectionArgs = {
  where: Path_Collection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Path_Collection_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Path_Collection_ItemArgs = {
  where: Path_Collection_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Path_Collection_Item_By_PkArgs = {
  collectionId: Scalars['uuid'];
  pathId: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Path_FeedArgs = {
  where: Path_Feed_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Path_Feed_By_PkArgs = {
  pathId: Scalars['bigint'];
  slug: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Path_NodeArgs = {
  where: Path_Node_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Path_Node_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Path_Node_CommentArgs = {
  where: Path_Node_Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Path_Node_Comment_By_PkArgs = {
  commentId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Path_ReviewArgs = {
  where: Path_Review_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Path_Review_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectArgs = {
  where: Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_AwardArgs = {
  where: Project_Award_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Award_By_PkArgs = {
  awardId: Scalars['uuid'];
  projectId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Project_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Project_CommentArgs = {
  where: Project_Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Comment_By_PkArgs = {
  commentId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Project_ReactionArgs = {
  where: Project_Reaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Reaction_By_PkArgs = {
  projectId: Scalars['uuid'];
  userId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Project_StatsArgs = {
  where: Project_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Stats_By_PkArgs = {
  projectId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Shop_ItemArgs = {
  where: Shop_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shop_Item_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Shop_Item_PurchaseArgs = {
  where: Shop_Item_Purchase_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shop_Item_Purchase_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_UserArgs = {
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_AwardArgs = {
  where: User_Award_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Award_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_By_PkArgs = {
  firestoreId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_FileArgs = {
  where: User_File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_File_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_File_IntegrationArgs = {
  where: User_File_Integration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_File_Integration_By_PkArgs = {
  fileId: Scalars['uuid'];
  source: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_File_TransformArgs = {
  where: User_File_Transform_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_File_Transform_By_PkArgs = {
  fileId: Scalars['uuid'];
  filename: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_FollowArgs = {
  where: User_Follow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Follow_By_PkArgs = {
  sourceUserId: Scalars['String'];
  targetUserId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_IntegrationArgs = {
  where: User_Integration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Integration_By_PkArgs = {
  foreignId: Scalars['String'];
  provider: Enums_Integration_Provider_Enum;
};


/** mutation root */
export type Mutation_RootDelete_User_PathArgs = {
  where: User_Path_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Path_By_PkArgs = {
  pathId: Scalars['Int'];
  userId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_SubscriptionArgs = {
  where: User_Subscription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Subscription_By_PkArgs = {
  userId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_TeacherArgs = {
  where: User_Teacher_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Teacher_By_PkArgs = {
  userId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootInsert_AssignmentArgs = {
  objects: Array<Assignment_Insert_Input>;
  on_conflict?: InputMaybe<Assignment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assignment_Learner_GroupArgs = {
  objects: Array<Assignment_Learner_Group_Insert_Input>;
  on_conflict?: InputMaybe<Assignment_Learner_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assignment_Learner_Group_OneArgs = {
  object: Assignment_Learner_Group_Insert_Input;
  on_conflict?: InputMaybe<Assignment_Learner_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assignment_OneArgs = {
  object: Assignment_Insert_Input;
  on_conflict?: InputMaybe<Assignment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assignment_PathArgs = {
  objects: Array<Assignment_Path_Insert_Input>;
  on_conflict?: InputMaybe<Assignment_Path_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assignment_Path_OneArgs = {
  object: Assignment_Path_Insert_Input;
  on_conflict?: InputMaybe<Assignment_Path_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AwardArgs = {
  objects: Array<Award_Insert_Input>;
  on_conflict?: InputMaybe<Award_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Award_OneArgs = {
  object: Award_Insert_Input;
  on_conflict?: InputMaybe<Award_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Coin_TrxArgs = {
  objects: Array<Coin_Trx_Insert_Input>;
  on_conflict?: InputMaybe<Coin_Trx_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Coin_Trx_OneArgs = {
  object: Coin_Trx_Insert_Input;
  on_conflict?: InputMaybe<Coin_Trx_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CommentArgs = {
  objects: Array<Comment_Insert_Input>;
  on_conflict?: InputMaybe<Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Comment_OneArgs = {
  object: Comment_Insert_Input;
  on_conflict?: InputMaybe<Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Educator_CodeArgs = {
  objects: Array<Educator_Code_Insert_Input>;
  on_conflict?: InputMaybe<Educator_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Educator_Code_OneArgs = {
  object: Educator_Code_Insert_Input;
  on_conflict?: InputMaybe<Educator_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Educator_Code_RedemptionArgs = {
  objects: Array<Educator_Code_Redemption_Insert_Input>;
  on_conflict?: InputMaybe<Educator_Code_Redemption_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Educator_Code_Redemption_OneArgs = {
  object: Educator_Code_Redemption_Insert_Input;
  on_conflict?: InputMaybe<Educator_Code_Redemption_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enums_Coin_Trx_CategoryArgs = {
  objects: Array<Enums_Coin_Trx_Category_Insert_Input>;
  on_conflict?: InputMaybe<Enums_Coin_Trx_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enums_Coin_Trx_Category_OneArgs = {
  object: Enums_Coin_Trx_Category_Insert_Input;
  on_conflict?: InputMaybe<Enums_Coin_Trx_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enums_Integration_ProviderArgs = {
  objects: Array<Enums_Integration_Provider_Insert_Input>;
  on_conflict?: InputMaybe<Enums_Integration_Provider_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enums_Integration_Provider_OneArgs = {
  object: Enums_Integration_Provider_Insert_Input;
  on_conflict?: InputMaybe<Enums_Integration_Provider_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enums_Project_StatusArgs = {
  objects: Array<Enums_Project_Status_Insert_Input>;
  on_conflict?: InputMaybe<Enums_Project_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enums_Project_Status_OneArgs = {
  object: Enums_Project_Status_Insert_Input;
  on_conflict?: InputMaybe<Enums_Project_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GuideArgs = {
  objects: Array<Guide_Insert_Input>;
  on_conflict?: InputMaybe<Guide_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Guide_OneArgs = {
  object: Guide_Insert_Input;
  on_conflict?: InputMaybe<Guide_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Guide_PathArgs = {
  objects: Array<Guide_Path_Insert_Input>;
  on_conflict?: InputMaybe<Guide_Path_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Guide_Path_OneArgs = {
  object: Guide_Path_Insert_Input;
  on_conflict?: InputMaybe<Guide_Path_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Learner_GroupArgs = {
  objects: Array<Learner_Group_Insert_Input>;
  on_conflict?: InputMaybe<Learner_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Learner_Group_MemberArgs = {
  objects: Array<Learner_Group_Member_Insert_Input>;
  on_conflict?: InputMaybe<Learner_Group_Member_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Learner_Group_Member_OneArgs = {
  object: Learner_Group_Member_Insert_Input;
  on_conflict?: InputMaybe<Learner_Group_Member_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Learner_Group_OneArgs = {
  object: Learner_Group_Insert_Input;
  on_conflict?: InputMaybe<Learner_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Learner_Group_Path_CollectionArgs = {
  objects: Array<Learner_Group_Path_Collection_Insert_Input>;
  on_conflict?: InputMaybe<Learner_Group_Path_Collection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Learner_Group_Path_Collection_OneArgs = {
  object: Learner_Group_Path_Collection_Insert_Input;
  on_conflict?: InputMaybe<Learner_Group_Path_Collection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Learner_Group_Pending_MemberArgs = {
  objects: Array<Learner_Group_Pending_Member_Insert_Input>;
  on_conflict?: InputMaybe<Learner_Group_Pending_Member_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Learner_Group_Pending_Member_OneArgs = {
  object: Learner_Group_Pending_Member_Insert_Input;
  on_conflict?: InputMaybe<Learner_Group_Pending_Member_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LivestreamArgs = {
  objects: Array<Livestream_Insert_Input>;
  on_conflict?: InputMaybe<Livestream_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Livestream_OneArgs = {
  object: Livestream_Insert_Input;
  on_conflict?: InputMaybe<Livestream_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LmsArgs = {
  objects: Array<Lms_Insert_Input>;
  on_conflict?: InputMaybe<Lms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lms_OneArgs = {
  object: Lms_Insert_Input;
  on_conflict?: InputMaybe<Lms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MissionArgs = {
  objects: Array<Mission_Insert_Input>;
  on_conflict?: InputMaybe<Mission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mission_AttachmentArgs = {
  objects: Array<Mission_Attachment_Insert_Input>;
  on_conflict?: InputMaybe<Mission_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mission_Attachment_OneArgs = {
  object: Mission_Attachment_Insert_Input;
  on_conflict?: InputMaybe<Mission_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mission_ChallengeArgs = {
  objects: Array<Mission_Challenge_Insert_Input>;
  on_conflict?: InputMaybe<Mission_Challenge_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mission_Challenge_OneArgs = {
  object: Mission_Challenge_Insert_Input;
  on_conflict?: InputMaybe<Mission_Challenge_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mission_CommentArgs = {
  objects: Array<Mission_Comment_Insert_Input>;
  on_conflict?: InputMaybe<Mission_Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mission_Comment_OneArgs = {
  object: Mission_Comment_Insert_Input;
  on_conflict?: InputMaybe<Mission_Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mission_OneArgs = {
  object: Mission_Insert_Input;
  on_conflict?: InputMaybe<Mission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganizationArgs = {
  objects: Array<Organization_Insert_Input>;
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_DomainArgs = {
  objects: Array<Organization_Domain_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Domain_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Domain_OneArgs = {
  object: Organization_Domain_Insert_Input;
  on_conflict?: InputMaybe<Organization_Domain_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_OneArgs = {
  object: Organization_Insert_Input;
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PathArgs = {
  objects: Array<Path_Insert_Input>;
  on_conflict?: InputMaybe<Path_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Path_Active_UserArgs = {
  objects: Array<Path_Active_User_Insert_Input>;
  on_conflict?: InputMaybe<Path_Active_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Path_Active_User_OneArgs = {
  object: Path_Active_User_Insert_Input;
  on_conflict?: InputMaybe<Path_Active_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Path_ActivityArgs = {
  objects: Array<Path_Activity_Insert_Input>;
  on_conflict?: InputMaybe<Path_Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Path_Activity_OneArgs = {
  object: Path_Activity_Insert_Input;
  on_conflict?: InputMaybe<Path_Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Path_AuthorArgs = {
  objects: Array<Path_Author_Insert_Input>;
  on_conflict?: InputMaybe<Path_Author_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Path_Author_OneArgs = {
  object: Path_Author_Insert_Input;
  on_conflict?: InputMaybe<Path_Author_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Path_CollectionArgs = {
  objects: Array<Path_Collection_Insert_Input>;
  on_conflict?: InputMaybe<Path_Collection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Path_Collection_ItemArgs = {
  objects: Array<Path_Collection_Item_Insert_Input>;
  on_conflict?: InputMaybe<Path_Collection_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Path_Collection_Item_OneArgs = {
  object: Path_Collection_Item_Insert_Input;
  on_conflict?: InputMaybe<Path_Collection_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Path_Collection_OneArgs = {
  object: Path_Collection_Insert_Input;
  on_conflict?: InputMaybe<Path_Collection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Path_FeedArgs = {
  objects: Array<Path_Feed_Insert_Input>;
  on_conflict?: InputMaybe<Path_Feed_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Path_Feed_OneArgs = {
  object: Path_Feed_Insert_Input;
  on_conflict?: InputMaybe<Path_Feed_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Path_NodeArgs = {
  objects: Array<Path_Node_Insert_Input>;
  on_conflict?: InputMaybe<Path_Node_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Path_Node_CommentArgs = {
  objects: Array<Path_Node_Comment_Insert_Input>;
  on_conflict?: InputMaybe<Path_Node_Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Path_Node_Comment_OneArgs = {
  object: Path_Node_Comment_Insert_Input;
  on_conflict?: InputMaybe<Path_Node_Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Path_Node_OneArgs = {
  object: Path_Node_Insert_Input;
  on_conflict?: InputMaybe<Path_Node_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Path_OneArgs = {
  object: Path_Insert_Input;
  on_conflict?: InputMaybe<Path_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Path_ReviewArgs = {
  objects: Array<Path_Review_Insert_Input>;
  on_conflict?: InputMaybe<Path_Review_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Path_Review_OneArgs = {
  object: Path_Review_Insert_Input;
  on_conflict?: InputMaybe<Path_Review_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectArgs = {
  objects: Array<Project_Insert_Input>;
  on_conflict?: InputMaybe<Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_AwardArgs = {
  objects: Array<Project_Award_Insert_Input>;
  on_conflict?: InputMaybe<Project_Award_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Award_OneArgs = {
  object: Project_Award_Insert_Input;
  on_conflict?: InputMaybe<Project_Award_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_CommentArgs = {
  objects: Array<Project_Comment_Insert_Input>;
  on_conflict?: InputMaybe<Project_Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Comment_OneArgs = {
  object: Project_Comment_Insert_Input;
  on_conflict?: InputMaybe<Project_Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_OneArgs = {
  object: Project_Insert_Input;
  on_conflict?: InputMaybe<Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_ReactionArgs = {
  objects: Array<Project_Reaction_Insert_Input>;
  on_conflict?: InputMaybe<Project_Reaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Reaction_OneArgs = {
  object: Project_Reaction_Insert_Input;
  on_conflict?: InputMaybe<Project_Reaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_StatsArgs = {
  objects: Array<Project_Stats_Insert_Input>;
  on_conflict?: InputMaybe<Project_Stats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Stats_OneArgs = {
  object: Project_Stats_Insert_Input;
  on_conflict?: InputMaybe<Project_Stats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_ItemArgs = {
  objects: Array<Shop_Item_Insert_Input>;
  on_conflict?: InputMaybe<Shop_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Item_OneArgs = {
  object: Shop_Item_Insert_Input;
  on_conflict?: InputMaybe<Shop_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Item_PurchaseArgs = {
  objects: Array<Shop_Item_Purchase_Insert_Input>;
  on_conflict?: InputMaybe<Shop_Item_Purchase_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Item_Purchase_OneArgs = {
  object: Shop_Item_Purchase_Insert_Input;
  on_conflict?: InputMaybe<Shop_Item_Purchase_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserArgs = {
  objects: Array<User_Insert_Input>;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_AwardArgs = {
  objects: Array<User_Award_Insert_Input>;
  on_conflict?: InputMaybe<User_Award_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Award_OneArgs = {
  object: User_Award_Insert_Input;
  on_conflict?: InputMaybe<User_Award_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_FileArgs = {
  objects: Array<User_File_Insert_Input>;
  on_conflict?: InputMaybe<User_File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_File_IntegrationArgs = {
  objects: Array<User_File_Integration_Insert_Input>;
  on_conflict?: InputMaybe<User_File_Integration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_File_Integration_OneArgs = {
  object: User_File_Integration_Insert_Input;
  on_conflict?: InputMaybe<User_File_Integration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_File_OneArgs = {
  object: User_File_Insert_Input;
  on_conflict?: InputMaybe<User_File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_File_TransformArgs = {
  objects: Array<User_File_Transform_Insert_Input>;
  on_conflict?: InputMaybe<User_File_Transform_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_File_Transform_OneArgs = {
  object: User_File_Transform_Insert_Input;
  on_conflict?: InputMaybe<User_File_Transform_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_FollowArgs = {
  objects: Array<User_Follow_Insert_Input>;
  on_conflict?: InputMaybe<User_Follow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Follow_OneArgs = {
  object: User_Follow_Insert_Input;
  on_conflict?: InputMaybe<User_Follow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_IntegrationArgs = {
  objects: Array<User_Integration_Insert_Input>;
  on_conflict?: InputMaybe<User_Integration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Integration_OneArgs = {
  object: User_Integration_Insert_Input;
  on_conflict?: InputMaybe<User_Integration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_OneArgs = {
  object: User_Insert_Input;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_PathArgs = {
  objects: Array<User_Path_Insert_Input>;
  on_conflict?: InputMaybe<User_Path_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Path_OneArgs = {
  object: User_Path_Insert_Input;
  on_conflict?: InputMaybe<User_Path_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_SubscriptionArgs = {
  objects: Array<User_Subscription_Insert_Input>;
  on_conflict?: InputMaybe<User_Subscription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Subscription_OneArgs = {
  object: User_Subscription_Insert_Input;
  on_conflict?: InputMaybe<User_Subscription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_TeacherArgs = {
  objects: Array<User_Teacher_Insert_Input>;
  on_conflict?: InputMaybe<User_Teacher_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Teacher_OneArgs = {
  object: User_Teacher_Insert_Input;
  on_conflict?: InputMaybe<User_Teacher_On_Conflict>;
};


/** mutation root */
export type Mutation_RootStreamio_Create_ActivityArgs = {
  activity: StreamIoCreateActivityInput;
  api_key: Scalars['String'];
  feed_slug: Scalars['String'];
  feed_user_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdate_AssignmentArgs = {
  _inc?: InputMaybe<Assignment_Inc_Input>;
  _set?: InputMaybe<Assignment_Set_Input>;
  where: Assignment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_By_PkArgs = {
  _inc?: InputMaybe<Assignment_Inc_Input>;
  _set?: InputMaybe<Assignment_Set_Input>;
  pk_columns: Assignment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_Learner_GroupArgs = {
  _set?: InputMaybe<Assignment_Learner_Group_Set_Input>;
  where: Assignment_Learner_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_Learner_Group_By_PkArgs = {
  _set?: InputMaybe<Assignment_Learner_Group_Set_Input>;
  pk_columns: Assignment_Learner_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_Learner_Group_ManyArgs = {
  updates: Array<Assignment_Learner_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_ManyArgs = {
  updates: Array<Assignment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_PathArgs = {
  _inc?: InputMaybe<Assignment_Path_Inc_Input>;
  _set?: InputMaybe<Assignment_Path_Set_Input>;
  where: Assignment_Path_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_Path_By_PkArgs = {
  _inc?: InputMaybe<Assignment_Path_Inc_Input>;
  _set?: InputMaybe<Assignment_Path_Set_Input>;
  pk_columns: Assignment_Path_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_Path_ManyArgs = {
  updates: Array<Assignment_Path_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AwardArgs = {
  _inc?: InputMaybe<Award_Inc_Input>;
  _set?: InputMaybe<Award_Set_Input>;
  where: Award_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Award_By_PkArgs = {
  _inc?: InputMaybe<Award_Inc_Input>;
  _set?: InputMaybe<Award_Set_Input>;
  pk_columns: Award_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Award_ManyArgs = {
  updates: Array<Award_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Coin_TrxArgs = {
  _inc?: InputMaybe<Coin_Trx_Inc_Input>;
  _set?: InputMaybe<Coin_Trx_Set_Input>;
  where: Coin_Trx_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Coin_Trx_By_PkArgs = {
  _inc?: InputMaybe<Coin_Trx_Inc_Input>;
  _set?: InputMaybe<Coin_Trx_Set_Input>;
  pk_columns: Coin_Trx_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Coin_Trx_ManyArgs = {
  updates: Array<Coin_Trx_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CommentArgs = {
  _set?: InputMaybe<Comment_Set_Input>;
  where: Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Comment_By_PkArgs = {
  _set?: InputMaybe<Comment_Set_Input>;
  pk_columns: Comment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Comment_ManyArgs = {
  updates: Array<Comment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Educator_CodeArgs = {
  _inc?: InputMaybe<Educator_Code_Inc_Input>;
  _set?: InputMaybe<Educator_Code_Set_Input>;
  where: Educator_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Educator_Code_By_PkArgs = {
  _inc?: InputMaybe<Educator_Code_Inc_Input>;
  _set?: InputMaybe<Educator_Code_Set_Input>;
  pk_columns: Educator_Code_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Educator_Code_ManyArgs = {
  updates: Array<Educator_Code_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Educator_Code_RedemptionArgs = {
  _set?: InputMaybe<Educator_Code_Redemption_Set_Input>;
  where: Educator_Code_Redemption_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Educator_Code_Redemption_By_PkArgs = {
  _set?: InputMaybe<Educator_Code_Redemption_Set_Input>;
  pk_columns: Educator_Code_Redemption_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Educator_Code_Redemption_ManyArgs = {
  updates: Array<Educator_Code_Redemption_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enums_Coin_Trx_CategoryArgs = {
  _set?: InputMaybe<Enums_Coin_Trx_Category_Set_Input>;
  where: Enums_Coin_Trx_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enums_Coin_Trx_Category_By_PkArgs = {
  _set?: InputMaybe<Enums_Coin_Trx_Category_Set_Input>;
  pk_columns: Enums_Coin_Trx_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enums_Coin_Trx_Category_ManyArgs = {
  updates: Array<Enums_Coin_Trx_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enums_Integration_ProviderArgs = {
  _set?: InputMaybe<Enums_Integration_Provider_Set_Input>;
  where: Enums_Integration_Provider_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enums_Integration_Provider_By_PkArgs = {
  _set?: InputMaybe<Enums_Integration_Provider_Set_Input>;
  pk_columns: Enums_Integration_Provider_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enums_Integration_Provider_ManyArgs = {
  updates: Array<Enums_Integration_Provider_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enums_Project_StatusArgs = {
  _set?: InputMaybe<Enums_Project_Status_Set_Input>;
  where: Enums_Project_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enums_Project_Status_By_PkArgs = {
  _set?: InputMaybe<Enums_Project_Status_Set_Input>;
  pk_columns: Enums_Project_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enums_Project_Status_ManyArgs = {
  updates: Array<Enums_Project_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GuideArgs = {
  _inc?: InputMaybe<Guide_Inc_Input>;
  _set?: InputMaybe<Guide_Set_Input>;
  where: Guide_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Guide_By_PkArgs = {
  _inc?: InputMaybe<Guide_Inc_Input>;
  _set?: InputMaybe<Guide_Set_Input>;
  pk_columns: Guide_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Guide_ManyArgs = {
  updates: Array<Guide_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Guide_PathArgs = {
  _inc?: InputMaybe<Guide_Path_Inc_Input>;
  _set?: InputMaybe<Guide_Path_Set_Input>;
  where: Guide_Path_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Guide_Path_By_PkArgs = {
  _inc?: InputMaybe<Guide_Path_Inc_Input>;
  _set?: InputMaybe<Guide_Path_Set_Input>;
  pk_columns: Guide_Path_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Guide_Path_ManyArgs = {
  updates: Array<Guide_Path_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Learner_GroupArgs = {
  _set?: InputMaybe<Learner_Group_Set_Input>;
  where: Learner_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Learner_Group_By_PkArgs = {
  _set?: InputMaybe<Learner_Group_Set_Input>;
  pk_columns: Learner_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Learner_Group_ManyArgs = {
  updates: Array<Learner_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Learner_Group_MemberArgs = {
  _set?: InputMaybe<Learner_Group_Member_Set_Input>;
  where: Learner_Group_Member_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Learner_Group_Member_By_PkArgs = {
  _set?: InputMaybe<Learner_Group_Member_Set_Input>;
  pk_columns: Learner_Group_Member_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Learner_Group_Member_ManyArgs = {
  updates: Array<Learner_Group_Member_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Learner_Group_Path_CollectionArgs = {
  _set?: InputMaybe<Learner_Group_Path_Collection_Set_Input>;
  where: Learner_Group_Path_Collection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Learner_Group_Path_Collection_By_PkArgs = {
  _set?: InputMaybe<Learner_Group_Path_Collection_Set_Input>;
  pk_columns: Learner_Group_Path_Collection_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Learner_Group_Path_Collection_ManyArgs = {
  updates: Array<Learner_Group_Path_Collection_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Learner_Group_Pending_MemberArgs = {
  _set?: InputMaybe<Learner_Group_Pending_Member_Set_Input>;
  where: Learner_Group_Pending_Member_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Learner_Group_Pending_Member_By_PkArgs = {
  _set?: InputMaybe<Learner_Group_Pending_Member_Set_Input>;
  pk_columns: Learner_Group_Pending_Member_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Learner_Group_Pending_Member_ManyArgs = {
  updates: Array<Learner_Group_Pending_Member_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LivestreamArgs = {
  _set?: InputMaybe<Livestream_Set_Input>;
  where: Livestream_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Livestream_By_PkArgs = {
  _set?: InputMaybe<Livestream_Set_Input>;
  pk_columns: Livestream_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Livestream_ManyArgs = {
  updates: Array<Livestream_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LmsArgs = {
  _set?: InputMaybe<Lms_Set_Input>;
  where: Lms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lms_By_PkArgs = {
  _set?: InputMaybe<Lms_Set_Input>;
  pk_columns: Lms_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lms_ManyArgs = {
  updates: Array<Lms_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MissionArgs = {
  _inc?: InputMaybe<Mission_Inc_Input>;
  _set?: InputMaybe<Mission_Set_Input>;
  where: Mission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mission_AttachmentArgs = {
  _inc?: InputMaybe<Mission_Attachment_Inc_Input>;
  _set?: InputMaybe<Mission_Attachment_Set_Input>;
  where: Mission_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mission_Attachment_By_PkArgs = {
  _inc?: InputMaybe<Mission_Attachment_Inc_Input>;
  _set?: InputMaybe<Mission_Attachment_Set_Input>;
  pk_columns: Mission_Attachment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mission_Attachment_ManyArgs = {
  updates: Array<Mission_Attachment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mission_By_PkArgs = {
  _inc?: InputMaybe<Mission_Inc_Input>;
  _set?: InputMaybe<Mission_Set_Input>;
  pk_columns: Mission_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mission_ChallengeArgs = {
  _inc?: InputMaybe<Mission_Challenge_Inc_Input>;
  _set?: InputMaybe<Mission_Challenge_Set_Input>;
  where: Mission_Challenge_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mission_Challenge_By_PkArgs = {
  _inc?: InputMaybe<Mission_Challenge_Inc_Input>;
  _set?: InputMaybe<Mission_Challenge_Set_Input>;
  pk_columns: Mission_Challenge_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mission_Challenge_ManyArgs = {
  updates: Array<Mission_Challenge_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mission_CommentArgs = {
  _inc?: InputMaybe<Mission_Comment_Inc_Input>;
  _set?: InputMaybe<Mission_Comment_Set_Input>;
  where: Mission_Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mission_Comment_By_PkArgs = {
  _inc?: InputMaybe<Mission_Comment_Inc_Input>;
  _set?: InputMaybe<Mission_Comment_Set_Input>;
  pk_columns: Mission_Comment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mission_Comment_ManyArgs = {
  updates: Array<Mission_Comment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mission_ManyArgs = {
  updates: Array<Mission_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrganizationArgs = {
  _set?: InputMaybe<Organization_Set_Input>;
  where: Organization_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_By_PkArgs = {
  _set?: InputMaybe<Organization_Set_Input>;
  pk_columns: Organization_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_DomainArgs = {
  _set?: InputMaybe<Organization_Domain_Set_Input>;
  where: Organization_Domain_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Domain_By_PkArgs = {
  _set?: InputMaybe<Organization_Domain_Set_Input>;
  pk_columns: Organization_Domain_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Domain_ManyArgs = {
  updates: Array<Organization_Domain_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_ManyArgs = {
  updates: Array<Organization_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PathArgs = {
  _append?: InputMaybe<Path_Append_Input>;
  _delete_at_path?: InputMaybe<Path_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Path_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Path_Delete_Key_Input>;
  _inc?: InputMaybe<Path_Inc_Input>;
  _prepend?: InputMaybe<Path_Prepend_Input>;
  _set?: InputMaybe<Path_Set_Input>;
  where: Path_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Path_Active_UserArgs = {
  _inc?: InputMaybe<Path_Active_User_Inc_Input>;
  _set?: InputMaybe<Path_Active_User_Set_Input>;
  where: Path_Active_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Path_Active_User_By_PkArgs = {
  _inc?: InputMaybe<Path_Active_User_Inc_Input>;
  _set?: InputMaybe<Path_Active_User_Set_Input>;
  pk_columns: Path_Active_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Path_Active_User_ManyArgs = {
  updates: Array<Path_Active_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Path_ActivityArgs = {
  _inc?: InputMaybe<Path_Activity_Inc_Input>;
  _set?: InputMaybe<Path_Activity_Set_Input>;
  where: Path_Activity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Path_Activity_By_PkArgs = {
  _inc?: InputMaybe<Path_Activity_Inc_Input>;
  _set?: InputMaybe<Path_Activity_Set_Input>;
  pk_columns: Path_Activity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Path_Activity_ManyArgs = {
  updates: Array<Path_Activity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Path_AuthorArgs = {
  _inc?: InputMaybe<Path_Author_Inc_Input>;
  _set?: InputMaybe<Path_Author_Set_Input>;
  where: Path_Author_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Path_Author_By_PkArgs = {
  _inc?: InputMaybe<Path_Author_Inc_Input>;
  _set?: InputMaybe<Path_Author_Set_Input>;
  pk_columns: Path_Author_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Path_Author_ManyArgs = {
  updates: Array<Path_Author_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Path_By_PkArgs = {
  _append?: InputMaybe<Path_Append_Input>;
  _delete_at_path?: InputMaybe<Path_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Path_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Path_Delete_Key_Input>;
  _inc?: InputMaybe<Path_Inc_Input>;
  _prepend?: InputMaybe<Path_Prepend_Input>;
  _set?: InputMaybe<Path_Set_Input>;
  pk_columns: Path_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Path_CollectionArgs = {
  _set?: InputMaybe<Path_Collection_Set_Input>;
  where: Path_Collection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Path_Collection_By_PkArgs = {
  _set?: InputMaybe<Path_Collection_Set_Input>;
  pk_columns: Path_Collection_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Path_Collection_ItemArgs = {
  _inc?: InputMaybe<Path_Collection_Item_Inc_Input>;
  _set?: InputMaybe<Path_Collection_Item_Set_Input>;
  where: Path_Collection_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Path_Collection_Item_By_PkArgs = {
  _inc?: InputMaybe<Path_Collection_Item_Inc_Input>;
  _set?: InputMaybe<Path_Collection_Item_Set_Input>;
  pk_columns: Path_Collection_Item_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Path_Collection_Item_ManyArgs = {
  updates: Array<Path_Collection_Item_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Path_Collection_ManyArgs = {
  updates: Array<Path_Collection_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Path_FeedArgs = {
  _inc?: InputMaybe<Path_Feed_Inc_Input>;
  _set?: InputMaybe<Path_Feed_Set_Input>;
  where: Path_Feed_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Path_Feed_By_PkArgs = {
  _inc?: InputMaybe<Path_Feed_Inc_Input>;
  _set?: InputMaybe<Path_Feed_Set_Input>;
  pk_columns: Path_Feed_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Path_Feed_ManyArgs = {
  updates: Array<Path_Feed_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Path_ManyArgs = {
  updates: Array<Path_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Path_NodeArgs = {
  _inc?: InputMaybe<Path_Node_Inc_Input>;
  _set?: InputMaybe<Path_Node_Set_Input>;
  where: Path_Node_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Path_Node_By_PkArgs = {
  _inc?: InputMaybe<Path_Node_Inc_Input>;
  _set?: InputMaybe<Path_Node_Set_Input>;
  pk_columns: Path_Node_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Path_Node_CommentArgs = {
  _set?: InputMaybe<Path_Node_Comment_Set_Input>;
  where: Path_Node_Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Path_Node_Comment_By_PkArgs = {
  _set?: InputMaybe<Path_Node_Comment_Set_Input>;
  pk_columns: Path_Node_Comment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Path_Node_Comment_ManyArgs = {
  updates: Array<Path_Node_Comment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Path_Node_ManyArgs = {
  updates: Array<Path_Node_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Path_ReviewArgs = {
  _inc?: InputMaybe<Path_Review_Inc_Input>;
  _set?: InputMaybe<Path_Review_Set_Input>;
  where: Path_Review_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Path_Review_By_PkArgs = {
  _inc?: InputMaybe<Path_Review_Inc_Input>;
  _set?: InputMaybe<Path_Review_Set_Input>;
  pk_columns: Path_Review_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Path_Review_ManyArgs = {
  updates: Array<Path_Review_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectArgs = {
  _inc?: InputMaybe<Project_Inc_Input>;
  _set?: InputMaybe<Project_Set_Input>;
  where: Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_AwardArgs = {
  _inc?: InputMaybe<Project_Award_Inc_Input>;
  _set?: InputMaybe<Project_Award_Set_Input>;
  where: Project_Award_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Award_By_PkArgs = {
  _inc?: InputMaybe<Project_Award_Inc_Input>;
  _set?: InputMaybe<Project_Award_Set_Input>;
  pk_columns: Project_Award_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Award_ManyArgs = {
  updates: Array<Project_Award_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_By_PkArgs = {
  _inc?: InputMaybe<Project_Inc_Input>;
  _set?: InputMaybe<Project_Set_Input>;
  pk_columns: Project_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_CommentArgs = {
  _set?: InputMaybe<Project_Comment_Set_Input>;
  where: Project_Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Comment_By_PkArgs = {
  _set?: InputMaybe<Project_Comment_Set_Input>;
  pk_columns: Project_Comment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Comment_ManyArgs = {
  updates: Array<Project_Comment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_ManyArgs = {
  updates: Array<Project_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_ReactionArgs = {
  _inc?: InputMaybe<Project_Reaction_Inc_Input>;
  _set?: InputMaybe<Project_Reaction_Set_Input>;
  where: Project_Reaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Reaction_By_PkArgs = {
  _inc?: InputMaybe<Project_Reaction_Inc_Input>;
  _set?: InputMaybe<Project_Reaction_Set_Input>;
  pk_columns: Project_Reaction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Reaction_ManyArgs = {
  updates: Array<Project_Reaction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_StatsArgs = {
  _inc?: InputMaybe<Project_Stats_Inc_Input>;
  _set?: InputMaybe<Project_Stats_Set_Input>;
  where: Project_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Stats_By_PkArgs = {
  _inc?: InputMaybe<Project_Stats_Inc_Input>;
  _set?: InputMaybe<Project_Stats_Set_Input>;
  pk_columns: Project_Stats_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Stats_ManyArgs = {
  updates: Array<Project_Stats_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_ItemArgs = {
  _append?: InputMaybe<Shop_Item_Append_Input>;
  _delete_at_path?: InputMaybe<Shop_Item_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Shop_Item_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Shop_Item_Delete_Key_Input>;
  _inc?: InputMaybe<Shop_Item_Inc_Input>;
  _prepend?: InputMaybe<Shop_Item_Prepend_Input>;
  _set?: InputMaybe<Shop_Item_Set_Input>;
  where: Shop_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Item_By_PkArgs = {
  _append?: InputMaybe<Shop_Item_Append_Input>;
  _delete_at_path?: InputMaybe<Shop_Item_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Shop_Item_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Shop_Item_Delete_Key_Input>;
  _inc?: InputMaybe<Shop_Item_Inc_Input>;
  _prepend?: InputMaybe<Shop_Item_Prepend_Input>;
  _set?: InputMaybe<Shop_Item_Set_Input>;
  pk_columns: Shop_Item_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Item_ManyArgs = {
  updates: Array<Shop_Item_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Item_PurchaseArgs = {
  _set?: InputMaybe<Shop_Item_Purchase_Set_Input>;
  where: Shop_Item_Purchase_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Item_Purchase_By_PkArgs = {
  _set?: InputMaybe<Shop_Item_Purchase_Set_Input>;
  pk_columns: Shop_Item_Purchase_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Item_Purchase_ManyArgs = {
  updates: Array<Shop_Item_Purchase_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserArgs = {
  _append?: InputMaybe<User_Append_Input>;
  _delete_at_path?: InputMaybe<User_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Delete_Key_Input>;
  _inc?: InputMaybe<User_Inc_Input>;
  _prepend?: InputMaybe<User_Prepend_Input>;
  _set?: InputMaybe<User_Set_Input>;
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_AwardArgs = {
  _set?: InputMaybe<User_Award_Set_Input>;
  where: User_Award_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Award_By_PkArgs = {
  _set?: InputMaybe<User_Award_Set_Input>;
  pk_columns: User_Award_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Award_ManyArgs = {
  updates: Array<User_Award_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_By_PkArgs = {
  _append?: InputMaybe<User_Append_Input>;
  _delete_at_path?: InputMaybe<User_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Delete_Key_Input>;
  _inc?: InputMaybe<User_Inc_Input>;
  _prepend?: InputMaybe<User_Prepend_Input>;
  _set?: InputMaybe<User_Set_Input>;
  pk_columns: User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_FileArgs = {
  _set?: InputMaybe<User_File_Set_Input>;
  where: User_File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_File_By_PkArgs = {
  _set?: InputMaybe<User_File_Set_Input>;
  pk_columns: User_File_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_File_IntegrationArgs = {
  _set?: InputMaybe<User_File_Integration_Set_Input>;
  where: User_File_Integration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_File_Integration_By_PkArgs = {
  _set?: InputMaybe<User_File_Integration_Set_Input>;
  pk_columns: User_File_Integration_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_File_Integration_ManyArgs = {
  updates: Array<User_File_Integration_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_File_ManyArgs = {
  updates: Array<User_File_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_File_TransformArgs = {
  _set?: InputMaybe<User_File_Transform_Set_Input>;
  where: User_File_Transform_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_File_Transform_By_PkArgs = {
  _set?: InputMaybe<User_File_Transform_Set_Input>;
  pk_columns: User_File_Transform_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_File_Transform_ManyArgs = {
  updates: Array<User_File_Transform_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_FollowArgs = {
  _set?: InputMaybe<User_Follow_Set_Input>;
  where: User_Follow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Follow_By_PkArgs = {
  _set?: InputMaybe<User_Follow_Set_Input>;
  pk_columns: User_Follow_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Follow_ManyArgs = {
  updates: Array<User_Follow_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_IntegrationArgs = {
  _set?: InputMaybe<User_Integration_Set_Input>;
  where: User_Integration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Integration_By_PkArgs = {
  _set?: InputMaybe<User_Integration_Set_Input>;
  pk_columns: User_Integration_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Integration_ManyArgs = {
  updates: Array<User_Integration_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ManyArgs = {
  updates: Array<User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_PathArgs = {
  _inc?: InputMaybe<User_Path_Inc_Input>;
  _set?: InputMaybe<User_Path_Set_Input>;
  where: User_Path_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Path_By_PkArgs = {
  _inc?: InputMaybe<User_Path_Inc_Input>;
  _set?: InputMaybe<User_Path_Set_Input>;
  pk_columns: User_Path_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Path_ManyArgs = {
  updates: Array<User_Path_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_SubscriptionArgs = {
  _set?: InputMaybe<User_Subscription_Set_Input>;
  where: User_Subscription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Subscription_By_PkArgs = {
  _set?: InputMaybe<User_Subscription_Set_Input>;
  pk_columns: User_Subscription_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Subscription_ManyArgs = {
  updates: Array<User_Subscription_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_TeacherArgs = {
  _append?: InputMaybe<User_Teacher_Append_Input>;
  _delete_at_path?: InputMaybe<User_Teacher_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Teacher_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Teacher_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Teacher_Prepend_Input>;
  _set?: InputMaybe<User_Teacher_Set_Input>;
  where: User_Teacher_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Teacher_By_PkArgs = {
  _append?: InputMaybe<User_Teacher_Append_Input>;
  _delete_at_path?: InputMaybe<User_Teacher_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Teacher_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Teacher_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Teacher_Prepend_Input>;
  _set?: InputMaybe<User_Teacher_Set_Input>;
  pk_columns: User_Teacher_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Teacher_ManyArgs = {
  updates: Array<User_Teacher_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

export type Org = {
  __typename?: 'org';
  id: Scalars['uuid'];
  isVerified: Scalars['Boolean'];
  name: Scalars['String'];
};

/** columns and relationships of "organization" */
export type Organization = {
  __typename?: 'organization';
  address: Scalars['String'];
  addressLine1: Scalars['String'];
  addressLine2: Scalars['String'];
  avatar?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  domains: Array<Organization_Domain>;
  /** An aggregate relationship */
  domains_aggregate: Organization_Domain_Aggregate;
  firestoreId: Scalars['String'];
  gradeLevel?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  placeId?: Maybe<Scalars['String']>;
  region: Scalars['String'];
  shopEnabled: Scalars['Boolean'];
  status: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  users: Array<User>;
  /** An aggregate relationship */
  users_aggregate: User_Aggregate;
  verified: Scalars['Boolean'];
  zip: Scalars['String'];
};


/** columns and relationships of "organization" */
export type OrganizationDomainsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Domain_Order_By>>;
  where?: InputMaybe<Organization_Domain_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationDomains_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Domain_Order_By>>;
  where?: InputMaybe<Organization_Domain_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationUsersArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** aggregated selection of "organization" */
export type Organization_Aggregate = {
  __typename?: 'organization_aggregate';
  aggregate?: Maybe<Organization_Aggregate_Fields>;
  nodes: Array<Organization>;
};

/** aggregate fields of "organization" */
export type Organization_Aggregate_Fields = {
  __typename?: 'organization_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Organization_Max_Fields>;
  min?: Maybe<Organization_Min_Fields>;
};


/** aggregate fields of "organization" */
export type Organization_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "organization". All fields are combined with a logical 'AND'. */
export type Organization_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Bool_Exp>>;
  _not?: InputMaybe<Organization_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  addressLine1?: InputMaybe<String_Comparison_Exp>;
  addressLine2?: InputMaybe<String_Comparison_Exp>;
  avatar?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  domains?: InputMaybe<Organization_Domain_Bool_Exp>;
  firestoreId?: InputMaybe<String_Comparison_Exp>;
  gradeLevel?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  placeId?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  shopEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  users?: InputMaybe<User_Bool_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
  zip?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization" */
export enum Organization_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationIdKey = 'organization_id_key',
  /** unique or primary key constraint on columns "firestore_id" */
  OrganizationPkey = 'organization_pkey'
}

/** columns and relationships of "organization_domain" */
export type Organization_Domain = {
  __typename?: 'organization_domain';
  domain: Scalars['String'];
  orgId: Scalars['String'];
  /** An object relationship */
  organization: Organization;
};

/** aggregated selection of "organization_domain" */
export type Organization_Domain_Aggregate = {
  __typename?: 'organization_domain_aggregate';
  aggregate?: Maybe<Organization_Domain_Aggregate_Fields>;
  nodes: Array<Organization_Domain>;
};

/** aggregate fields of "organization_domain" */
export type Organization_Domain_Aggregate_Fields = {
  __typename?: 'organization_domain_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Organization_Domain_Max_Fields>;
  min?: Maybe<Organization_Domain_Min_Fields>;
};


/** aggregate fields of "organization_domain" */
export type Organization_Domain_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Domain_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "organization_domain" */
export type Organization_Domain_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Domain_Max_Order_By>;
  min?: InputMaybe<Organization_Domain_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_domain" */
export type Organization_Domain_Arr_Rel_Insert_Input = {
  data: Array<Organization_Domain_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Domain_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_domain". All fields are combined with a logical 'AND'. */
export type Organization_Domain_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Domain_Bool_Exp>>;
  _not?: InputMaybe<Organization_Domain_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Domain_Bool_Exp>>;
  domain?: InputMaybe<String_Comparison_Exp>;
  orgId?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
};

/** unique or primary key constraints on table "organization_domain" */
export enum Organization_Domain_Constraint {
  /** unique or primary key constraint on columns "org_id", "domain" */
  OrganizationDomainPkey = 'organization_domain_pkey'
}

/** input type for inserting data into table "organization_domain" */
export type Organization_Domain_Insert_Input = {
  domain?: InputMaybe<Scalars['String']>;
  orgId?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Organization_Domain_Max_Fields = {
  __typename?: 'organization_domain_max_fields';
  domain?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "organization_domain" */
export type Organization_Domain_Max_Order_By = {
  domain?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Domain_Min_Fields = {
  __typename?: 'organization_domain_min_fields';
  domain?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "organization_domain" */
export type Organization_Domain_Min_Order_By = {
  domain?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_domain" */
export type Organization_Domain_Mutation_Response = {
  __typename?: 'organization_domain_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Domain>;
};

/** on_conflict condition type for table "organization_domain" */
export type Organization_Domain_On_Conflict = {
  constraint: Organization_Domain_Constraint;
  update_columns?: Array<Organization_Domain_Update_Column>;
  where?: InputMaybe<Organization_Domain_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_domain". */
export type Organization_Domain_Order_By = {
  domain?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
};

/** primary key columns input for table: organization_domain */
export type Organization_Domain_Pk_Columns_Input = {
  domain: Scalars['String'];
  orgId: Scalars['String'];
};

/** select columns of table "organization_domain" */
export enum Organization_Domain_Select_Column {
  /** column name */
  Domain = 'domain',
  /** column name */
  OrgId = 'orgId'
}

/** input type for updating data in table "organization_domain" */
export type Organization_Domain_Set_Input = {
  domain?: InputMaybe<Scalars['String']>;
  orgId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "organization_domain" */
export type Organization_Domain_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Domain_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Domain_Stream_Cursor_Value_Input = {
  domain?: InputMaybe<Scalars['String']>;
  orgId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "organization_domain" */
export enum Organization_Domain_Update_Column {
  /** column name */
  Domain = 'domain',
  /** column name */
  OrgId = 'orgId'
}

export type Organization_Domain_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Domain_Set_Input>;
  where: Organization_Domain_Bool_Exp;
};

/** input type for inserting data into table "organization" */
export type Organization_Insert_Input = {
  address?: InputMaybe<Scalars['String']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  avatar?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  domains?: InputMaybe<Organization_Domain_Arr_Rel_Insert_Input>;
  firestoreId?: InputMaybe<Scalars['String']>;
  gradeLevel?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  shopEnabled?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  users?: InputMaybe<User_Arr_Rel_Insert_Input>;
  verified?: InputMaybe<Scalars['Boolean']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Organization_Max_Fields = {
  __typename?: 'organization_max_fields';
  address?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  firestoreId?: Maybe<Scalars['String']>;
  gradeLevel?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  zip?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Organization_Min_Fields = {
  __typename?: 'organization_min_fields';
  address?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  firestoreId?: Maybe<Scalars['String']>;
  gradeLevel?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  zip?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "organization" */
export type Organization_Mutation_Response = {
  __typename?: 'organization_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization>;
};

/** input type for inserting object relation for remote table "organization" */
export type Organization_Obj_Rel_Insert_Input = {
  data: Organization_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};

/** on_conflict condition type for table "organization" */
export type Organization_On_Conflict = {
  constraint: Organization_Constraint;
  update_columns?: Array<Organization_Update_Column>;
  where?: InputMaybe<Organization_Bool_Exp>;
};

/** Ordering options when selecting data from "organization". */
export type Organization_Order_By = {
  address?: InputMaybe<Order_By>;
  addressLine1?: InputMaybe<Order_By>;
  addressLine2?: InputMaybe<Order_By>;
  avatar?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  domains_aggregate?: InputMaybe<Organization_Domain_Aggregate_Order_By>;
  firestoreId?: InputMaybe<Order_By>;
  gradeLevel?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  placeId?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  shopEnabled?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<User_Aggregate_Order_By>;
  verified?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization */
export type Organization_Pk_Columns_Input = {
  firestoreId: Scalars['String'];
};

/** select columns of table "organization" */
export enum Organization_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AddressLine1 = 'addressLine1',
  /** column name */
  AddressLine2 = 'addressLine2',
  /** column name */
  Avatar = 'avatar',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FirestoreId = 'firestoreId',
  /** column name */
  GradeLevel = 'gradeLevel',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PlaceId = 'placeId',
  /** column name */
  Region = 'region',
  /** column name */
  ShopEnabled = 'shopEnabled',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Verified = 'verified',
  /** column name */
  Zip = 'zip'
}

/** input type for updating data in table "organization" */
export type Organization_Set_Input = {
  address?: InputMaybe<Scalars['String']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  avatar?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  firestoreId?: InputMaybe<Scalars['String']>;
  gradeLevel?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  shopEnabled?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  verified?: InputMaybe<Scalars['Boolean']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "organization" */
export type Organization_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  avatar?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  firestoreId?: InputMaybe<Scalars['String']>;
  gradeLevel?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  shopEnabled?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  verified?: InputMaybe<Scalars['Boolean']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** update columns of table "organization" */
export enum Organization_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AddressLine1 = 'addressLine1',
  /** column name */
  AddressLine2 = 'addressLine2',
  /** column name */
  Avatar = 'avatar',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FirestoreId = 'firestoreId',
  /** column name */
  GradeLevel = 'gradeLevel',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PlaceId = 'placeId',
  /** column name */
  Region = 'region',
  /** column name */
  ShopEnabled = 'shopEnabled',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Verified = 'verified',
  /** column name */
  Zip = 'zip'
}

export type Organization_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Set_Input>;
  where: Organization_Bool_Exp;
};

/** columns and relationships of "path" */
export type Path = {
  __typename?: 'path';
  _schemaVersion: Scalars['Int'];
  /** An array relationship */
  activities: Array<Path_Activity>;
  /** An aggregate relationship */
  activities_aggregate: Path_Activity_Aggregate;
  authorId: Scalars['String'];
  /** An array relationship */
  authors: Array<Path_Author>;
  /** An aggregate relationship */
  authors_aggregate: Path_Author_Aggregate;
  cover?: Maybe<Scalars['String']>;
  coverAnimated?: Maybe<Scalars['String']>;
  /** An object relationship */
  coverAnimatedFile?: Maybe<User_File>;
  coverAnimatedFileId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  coverFile?: Maybe<User_File>;
  coverFileId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  firestoreId?: Maybe<Scalars['String']>;
  gradeLevels?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  guides: Array<Guide_Path>;
  /** An aggregate relationship */
  guides_aggregate: Guide_Path_Aggregate;
  id: Scalars['bigint'];
  interestArea?: Maybe<Scalars['String']>;
  isFeatured: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  isTractOriginal: Scalars['Boolean'];
  isVisibleUnauthed?: Maybe<Scalars['Boolean']>;
  leadersCount: Scalars['Int'];
  media?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  missions: Array<Mission>;
  missionsOrder?: Maybe<Scalars['jsonb']>;
  /** An aggregate relationship */
  missions_aggregate: Mission_Aggregate;
  /** An array relationship */
  nodes: Array<Path_Node>;
  /** An aggregate relationship */
  nodes_aggregate: Path_Node_Aggregate;
  notified?: Maybe<Scalars['json']>;
  orgId?: Maybe<Scalars['String']>;
  /** An array relationship */
  pathCollectionItems: Array<Path_Collection_Item>;
  /** An aggregate relationship */
  pathCollectionItems_aggregate: Path_Collection_Item_Aggregate;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  questionsCount: Scalars['Int'];
  /** An array relationship */
  reviews: Array<Path_Review>;
  /** An aggregate relationship */
  reviews_aggregate: Path_Review_Aggregate;
  skills?: Maybe<Scalars['jsonb']>;
  slug?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  subjects?: Maybe<Scalars['jsonb']>;
  supplies?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['jsonb']>;
  title?: Maybe<Scalars['String']>;
  totalXP: Scalars['Int'];
  /** An object relationship */
  trailer?: Maybe<User_File>;
  trailerFileId?: Maybe<Scalars['uuid']>;
  trailerUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<User>;
  visibility: Scalars['String'];
  xpMultiplier: Scalars['smallint'];
};


/** columns and relationships of "path" */
export type PathActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Path_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Activity_Order_By>>;
  where?: InputMaybe<Path_Activity_Bool_Exp>;
};


/** columns and relationships of "path" */
export type PathActivities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Activity_Order_By>>;
  where?: InputMaybe<Path_Activity_Bool_Exp>;
};


/** columns and relationships of "path" */
export type PathAuthorsArgs = {
  distinct_on?: InputMaybe<Array<Path_Author_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Author_Order_By>>;
  where?: InputMaybe<Path_Author_Bool_Exp>;
};


/** columns and relationships of "path" */
export type PathAuthors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Author_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Author_Order_By>>;
  where?: InputMaybe<Path_Author_Bool_Exp>;
};


/** columns and relationships of "path" */
export type PathGradeLevelsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "path" */
export type PathGuidesArgs = {
  distinct_on?: InputMaybe<Array<Guide_Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guide_Path_Order_By>>;
  where?: InputMaybe<Guide_Path_Bool_Exp>;
};


/** columns and relationships of "path" */
export type PathGuides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Guide_Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guide_Path_Order_By>>;
  where?: InputMaybe<Guide_Path_Bool_Exp>;
};


/** columns and relationships of "path" */
export type PathMediaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "path" */
export type PathMissionsArgs = {
  distinct_on?: InputMaybe<Array<Mission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Order_By>>;
  where?: InputMaybe<Mission_Bool_Exp>;
};


/** columns and relationships of "path" */
export type PathMissionsOrderArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "path" */
export type PathMissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Order_By>>;
  where?: InputMaybe<Mission_Bool_Exp>;
};


/** columns and relationships of "path" */
export type PathNodesArgs = {
  distinct_on?: InputMaybe<Array<Path_Node_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Node_Order_By>>;
  where?: InputMaybe<Path_Node_Bool_Exp>;
};


/** columns and relationships of "path" */
export type PathNodes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Node_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Node_Order_By>>;
  where?: InputMaybe<Path_Node_Bool_Exp>;
};


/** columns and relationships of "path" */
export type PathNotifiedArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "path" */
export type PathPathCollectionItemsArgs = {
  distinct_on?: InputMaybe<Array<Path_Collection_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Collection_Item_Order_By>>;
  where?: InputMaybe<Path_Collection_Item_Bool_Exp>;
};


/** columns and relationships of "path" */
export type PathPathCollectionItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Collection_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Collection_Item_Order_By>>;
  where?: InputMaybe<Path_Collection_Item_Bool_Exp>;
};


/** columns and relationships of "path" */
export type PathReviewsArgs = {
  distinct_on?: InputMaybe<Array<Path_Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Review_Order_By>>;
  where?: InputMaybe<Path_Review_Bool_Exp>;
};


/** columns and relationships of "path" */
export type PathReviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Review_Order_By>>;
  where?: InputMaybe<Path_Review_Bool_Exp>;
};


/** columns and relationships of "path" */
export type PathSkillsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "path" */
export type PathSubjectsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "path" */
export type PathTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** used to track when someone last visited a path */
export type Path_Active_User = {
  __typename?: 'path_active_user';
  createdAt: Scalars['timestamptz'];
  pathId: Scalars['bigint'];
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['String'];
};

/** aggregated selection of "path_active_user" */
export type Path_Active_User_Aggregate = {
  __typename?: 'path_active_user_aggregate';
  aggregate?: Maybe<Path_Active_User_Aggregate_Fields>;
  nodes: Array<Path_Active_User>;
};

/** aggregate fields of "path_active_user" */
export type Path_Active_User_Aggregate_Fields = {
  __typename?: 'path_active_user_aggregate_fields';
  avg?: Maybe<Path_Active_User_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Path_Active_User_Max_Fields>;
  min?: Maybe<Path_Active_User_Min_Fields>;
  stddev?: Maybe<Path_Active_User_Stddev_Fields>;
  stddev_pop?: Maybe<Path_Active_User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Path_Active_User_Stddev_Samp_Fields>;
  sum?: Maybe<Path_Active_User_Sum_Fields>;
  var_pop?: Maybe<Path_Active_User_Var_Pop_Fields>;
  var_samp?: Maybe<Path_Active_User_Var_Samp_Fields>;
  variance?: Maybe<Path_Active_User_Variance_Fields>;
};


/** aggregate fields of "path_active_user" */
export type Path_Active_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Path_Active_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "path_active_user" */
export type Path_Active_User_Aggregate_Order_By = {
  avg?: InputMaybe<Path_Active_User_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Path_Active_User_Max_Order_By>;
  min?: InputMaybe<Path_Active_User_Min_Order_By>;
  stddev?: InputMaybe<Path_Active_User_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Path_Active_User_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Path_Active_User_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Path_Active_User_Sum_Order_By>;
  var_pop?: InputMaybe<Path_Active_User_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Path_Active_User_Var_Samp_Order_By>;
  variance?: InputMaybe<Path_Active_User_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "path_active_user" */
export type Path_Active_User_Arr_Rel_Insert_Input = {
  data: Array<Path_Active_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Path_Active_User_On_Conflict>;
};

/** aggregate avg on columns */
export type Path_Active_User_Avg_Fields = {
  __typename?: 'path_active_user_avg_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "path_active_user" */
export type Path_Active_User_Avg_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "path_active_user". All fields are combined with a logical 'AND'. */
export type Path_Active_User_Bool_Exp = {
  _and?: InputMaybe<Array<Path_Active_User_Bool_Exp>>;
  _not?: InputMaybe<Path_Active_User_Bool_Exp>;
  _or?: InputMaybe<Array<Path_Active_User_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  pathId?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "path_active_user" */
export enum Path_Active_User_Constraint {
  /** unique or primary key constraint on columns "user_id", "path_id" */
  PathActiveUserPkey = 'path_active_user_pkey'
}

/** input type for incrementing numeric columns in table "path_active_user" */
export type Path_Active_User_Inc_Input = {
  pathId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "path_active_user" */
export type Path_Active_User_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  pathId?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Path_Active_User_Max_Fields = {
  __typename?: 'path_active_user_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  pathId?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "path_active_user" */
export type Path_Active_User_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Path_Active_User_Min_Fields = {
  __typename?: 'path_active_user_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  pathId?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "path_active_user" */
export type Path_Active_User_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "path_active_user" */
export type Path_Active_User_Mutation_Response = {
  __typename?: 'path_active_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Path_Active_User>;
};

/** on_conflict condition type for table "path_active_user" */
export type Path_Active_User_On_Conflict = {
  constraint: Path_Active_User_Constraint;
  update_columns?: Array<Path_Active_User_Update_Column>;
  where?: InputMaybe<Path_Active_User_Bool_Exp>;
};

/** Ordering options when selecting data from "path_active_user". */
export type Path_Active_User_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: path_active_user */
export type Path_Active_User_Pk_Columns_Input = {
  pathId: Scalars['bigint'];
  userId: Scalars['String'];
};

/** select columns of table "path_active_user" */
export enum Path_Active_User_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  PathId = 'pathId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "path_active_user" */
export type Path_Active_User_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  pathId?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Path_Active_User_Stddev_Fields = {
  __typename?: 'path_active_user_stddev_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "path_active_user" */
export type Path_Active_User_Stddev_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Path_Active_User_Stddev_Pop_Fields = {
  __typename?: 'path_active_user_stddev_pop_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "path_active_user" */
export type Path_Active_User_Stddev_Pop_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Path_Active_User_Stddev_Samp_Fields = {
  __typename?: 'path_active_user_stddev_samp_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "path_active_user" */
export type Path_Active_User_Stddev_Samp_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "path_active_user" */
export type Path_Active_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Path_Active_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Path_Active_User_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  pathId?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Path_Active_User_Sum_Fields = {
  __typename?: 'path_active_user_sum_fields';
  pathId?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "path_active_user" */
export type Path_Active_User_Sum_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** update columns of table "path_active_user" */
export enum Path_Active_User_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  PathId = 'pathId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Path_Active_User_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Path_Active_User_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Path_Active_User_Set_Input>;
  where: Path_Active_User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Path_Active_User_Var_Pop_Fields = {
  __typename?: 'path_active_user_var_pop_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "path_active_user" */
export type Path_Active_User_Var_Pop_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Path_Active_User_Var_Samp_Fields = {
  __typename?: 'path_active_user_var_samp_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "path_active_user" */
export type Path_Active_User_Var_Samp_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Path_Active_User_Variance_Fields = {
  __typename?: 'path_active_user_variance_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "path_active_user" */
export type Path_Active_User_Variance_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** columns and relationships of "path_activity" */
export type Path_Activity = {
  __typename?: 'path_activity';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  path: Path;
  pathId: Scalars['bigint'];
  /** An object relationship */
  pathReview?: Maybe<Path_Review>;
  pathReviewId?: Maybe<Scalars['uuid']>;
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userId: Scalars['String'];
};

/** aggregated selection of "path_activity" */
export type Path_Activity_Aggregate = {
  __typename?: 'path_activity_aggregate';
  aggregate?: Maybe<Path_Activity_Aggregate_Fields>;
  nodes: Array<Path_Activity>;
};

/** aggregate fields of "path_activity" */
export type Path_Activity_Aggregate_Fields = {
  __typename?: 'path_activity_aggregate_fields';
  avg?: Maybe<Path_Activity_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Path_Activity_Max_Fields>;
  min?: Maybe<Path_Activity_Min_Fields>;
  stddev?: Maybe<Path_Activity_Stddev_Fields>;
  stddev_pop?: Maybe<Path_Activity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Path_Activity_Stddev_Samp_Fields>;
  sum?: Maybe<Path_Activity_Sum_Fields>;
  var_pop?: Maybe<Path_Activity_Var_Pop_Fields>;
  var_samp?: Maybe<Path_Activity_Var_Samp_Fields>;
  variance?: Maybe<Path_Activity_Variance_Fields>;
};


/** aggregate fields of "path_activity" */
export type Path_Activity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Path_Activity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "path_activity" */
export type Path_Activity_Aggregate_Order_By = {
  avg?: InputMaybe<Path_Activity_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Path_Activity_Max_Order_By>;
  min?: InputMaybe<Path_Activity_Min_Order_By>;
  stddev?: InputMaybe<Path_Activity_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Path_Activity_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Path_Activity_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Path_Activity_Sum_Order_By>;
  var_pop?: InputMaybe<Path_Activity_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Path_Activity_Var_Samp_Order_By>;
  variance?: InputMaybe<Path_Activity_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "path_activity" */
export type Path_Activity_Arr_Rel_Insert_Input = {
  data: Array<Path_Activity_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Path_Activity_On_Conflict>;
};

/** aggregate avg on columns */
export type Path_Activity_Avg_Fields = {
  __typename?: 'path_activity_avg_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "path_activity" */
export type Path_Activity_Avg_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "path_activity". All fields are combined with a logical 'AND'. */
export type Path_Activity_Bool_Exp = {
  _and?: InputMaybe<Array<Path_Activity_Bool_Exp>>;
  _not?: InputMaybe<Path_Activity_Bool_Exp>;
  _or?: InputMaybe<Array<Path_Activity_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  path?: InputMaybe<Path_Bool_Exp>;
  pathId?: InputMaybe<Bigint_Comparison_Exp>;
  pathReview?: InputMaybe<Path_Review_Bool_Exp>;
  pathReviewId?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "path_activity" */
export enum Path_Activity_Constraint {
  /** unique or primary key constraint on columns "id" */
  PathActivityPkey = 'path_activity_pkey'
}

/** input type for incrementing numeric columns in table "path_activity" */
export type Path_Activity_Inc_Input = {
  pathId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "path_activity" */
export type Path_Activity_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  path?: InputMaybe<Path_Obj_Rel_Insert_Input>;
  pathId?: InputMaybe<Scalars['bigint']>;
  pathReview?: InputMaybe<Path_Review_Obj_Rel_Insert_Input>;
  pathReviewId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Path_Activity_Max_Fields = {
  __typename?: 'path_activity_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  pathId?: Maybe<Scalars['bigint']>;
  pathReviewId?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "path_activity" */
export type Path_Activity_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  pathReviewId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Path_Activity_Min_Fields = {
  __typename?: 'path_activity_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  pathId?: Maybe<Scalars['bigint']>;
  pathReviewId?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "path_activity" */
export type Path_Activity_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  pathReviewId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "path_activity" */
export type Path_Activity_Mutation_Response = {
  __typename?: 'path_activity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Path_Activity>;
};

/** on_conflict condition type for table "path_activity" */
export type Path_Activity_On_Conflict = {
  constraint: Path_Activity_Constraint;
  update_columns?: Array<Path_Activity_Update_Column>;
  where?: InputMaybe<Path_Activity_Bool_Exp>;
};

/** Ordering options when selecting data from "path_activity". */
export type Path_Activity_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  path?: InputMaybe<Path_Order_By>;
  pathId?: InputMaybe<Order_By>;
  pathReview?: InputMaybe<Path_Review_Order_By>;
  pathReviewId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: path_activity */
export type Path_Activity_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "path_activity" */
export enum Path_Activity_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PathId = 'pathId',
  /** column name */
  PathReviewId = 'pathReviewId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "path_activity" */
export type Path_Activity_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  pathId?: InputMaybe<Scalars['bigint']>;
  pathReviewId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Path_Activity_Stddev_Fields = {
  __typename?: 'path_activity_stddev_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "path_activity" */
export type Path_Activity_Stddev_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Path_Activity_Stddev_Pop_Fields = {
  __typename?: 'path_activity_stddev_pop_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "path_activity" */
export type Path_Activity_Stddev_Pop_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Path_Activity_Stddev_Samp_Fields = {
  __typename?: 'path_activity_stddev_samp_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "path_activity" */
export type Path_Activity_Stddev_Samp_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "path_activity" */
export type Path_Activity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Path_Activity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Path_Activity_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  pathId?: InputMaybe<Scalars['bigint']>;
  pathReviewId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Path_Activity_Sum_Fields = {
  __typename?: 'path_activity_sum_fields';
  pathId?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "path_activity" */
export type Path_Activity_Sum_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** update columns of table "path_activity" */
export enum Path_Activity_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PathId = 'pathId',
  /** column name */
  PathReviewId = 'pathReviewId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Path_Activity_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Path_Activity_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Path_Activity_Set_Input>;
  where: Path_Activity_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Path_Activity_Var_Pop_Fields = {
  __typename?: 'path_activity_var_pop_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "path_activity" */
export type Path_Activity_Var_Pop_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Path_Activity_Var_Samp_Fields = {
  __typename?: 'path_activity_var_samp_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "path_activity" */
export type Path_Activity_Var_Samp_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Path_Activity_Variance_Fields = {
  __typename?: 'path_activity_variance_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "path_activity" */
export type Path_Activity_Variance_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregated selection of "path" */
export type Path_Aggregate = {
  __typename?: 'path_aggregate';
  aggregate?: Maybe<Path_Aggregate_Fields>;
  nodes: Array<Path>;
};

/** aggregate fields of "path" */
export type Path_Aggregate_Fields = {
  __typename?: 'path_aggregate_fields';
  avg?: Maybe<Path_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Path_Max_Fields>;
  min?: Maybe<Path_Min_Fields>;
  stddev?: Maybe<Path_Stddev_Fields>;
  stddev_pop?: Maybe<Path_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Path_Stddev_Samp_Fields>;
  sum?: Maybe<Path_Sum_Fields>;
  var_pop?: Maybe<Path_Var_Pop_Fields>;
  var_samp?: Maybe<Path_Var_Samp_Fields>;
  variance?: Maybe<Path_Variance_Fields>;
};


/** aggregate fields of "path" */
export type Path_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Path_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "path" */
export type Path_Aggregate_Order_By = {
  avg?: InputMaybe<Path_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Path_Max_Order_By>;
  min?: InputMaybe<Path_Min_Order_By>;
  stddev?: InputMaybe<Path_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Path_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Path_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Path_Sum_Order_By>;
  var_pop?: InputMaybe<Path_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Path_Var_Samp_Order_By>;
  variance?: InputMaybe<Path_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Path_Append_Input = {
  gradeLevels?: InputMaybe<Scalars['jsonb']>;
  media?: InputMaybe<Scalars['jsonb']>;
  missionsOrder?: InputMaybe<Scalars['jsonb']>;
  skills?: InputMaybe<Scalars['jsonb']>;
  subjects?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "path" */
export type Path_Arr_Rel_Insert_Input = {
  data: Array<Path_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Path_On_Conflict>;
};

/** Stores co-authors of paths. Does not currently store the owner which is infered from path table. */
export type Path_Author = {
  __typename?: 'path_author';
  /** An object relationship */
  path: Path;
  pathId: Scalars['bigint'];
  /** An object relationship */
  user: User;
  userId: Scalars['String'];
};

/** aggregated selection of "path_author" */
export type Path_Author_Aggregate = {
  __typename?: 'path_author_aggregate';
  aggregate?: Maybe<Path_Author_Aggregate_Fields>;
  nodes: Array<Path_Author>;
};

/** aggregate fields of "path_author" */
export type Path_Author_Aggregate_Fields = {
  __typename?: 'path_author_aggregate_fields';
  avg?: Maybe<Path_Author_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Path_Author_Max_Fields>;
  min?: Maybe<Path_Author_Min_Fields>;
  stddev?: Maybe<Path_Author_Stddev_Fields>;
  stddev_pop?: Maybe<Path_Author_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Path_Author_Stddev_Samp_Fields>;
  sum?: Maybe<Path_Author_Sum_Fields>;
  var_pop?: Maybe<Path_Author_Var_Pop_Fields>;
  var_samp?: Maybe<Path_Author_Var_Samp_Fields>;
  variance?: Maybe<Path_Author_Variance_Fields>;
};


/** aggregate fields of "path_author" */
export type Path_Author_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Path_Author_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "path_author" */
export type Path_Author_Aggregate_Order_By = {
  avg?: InputMaybe<Path_Author_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Path_Author_Max_Order_By>;
  min?: InputMaybe<Path_Author_Min_Order_By>;
  stddev?: InputMaybe<Path_Author_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Path_Author_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Path_Author_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Path_Author_Sum_Order_By>;
  var_pop?: InputMaybe<Path_Author_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Path_Author_Var_Samp_Order_By>;
  variance?: InputMaybe<Path_Author_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "path_author" */
export type Path_Author_Arr_Rel_Insert_Input = {
  data: Array<Path_Author_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Path_Author_On_Conflict>;
};

/** aggregate avg on columns */
export type Path_Author_Avg_Fields = {
  __typename?: 'path_author_avg_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "path_author" */
export type Path_Author_Avg_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "path_author". All fields are combined with a logical 'AND'. */
export type Path_Author_Bool_Exp = {
  _and?: InputMaybe<Array<Path_Author_Bool_Exp>>;
  _not?: InputMaybe<Path_Author_Bool_Exp>;
  _or?: InputMaybe<Array<Path_Author_Bool_Exp>>;
  path?: InputMaybe<Path_Bool_Exp>;
  pathId?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "path_author" */
export enum Path_Author_Constraint {
  /** unique or primary key constraint on columns "user_id", "path_id" */
  PathAuthorPathIdUserIdKey = 'path_author_path_id_user_id_key',
  /** unique or primary key constraint on columns "user_id", "path_id" */
  PathAuthorPkey = 'path_author_pkey'
}

/** input type for incrementing numeric columns in table "path_author" */
export type Path_Author_Inc_Input = {
  pathId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "path_author" */
export type Path_Author_Insert_Input = {
  path?: InputMaybe<Path_Obj_Rel_Insert_Input>;
  pathId?: InputMaybe<Scalars['bigint']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Path_Author_Max_Fields = {
  __typename?: 'path_author_max_fields';
  pathId?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "path_author" */
export type Path_Author_Max_Order_By = {
  pathId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Path_Author_Min_Fields = {
  __typename?: 'path_author_min_fields';
  pathId?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "path_author" */
export type Path_Author_Min_Order_By = {
  pathId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "path_author" */
export type Path_Author_Mutation_Response = {
  __typename?: 'path_author_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Path_Author>;
};

/** on_conflict condition type for table "path_author" */
export type Path_Author_On_Conflict = {
  constraint: Path_Author_Constraint;
  update_columns?: Array<Path_Author_Update_Column>;
  where?: InputMaybe<Path_Author_Bool_Exp>;
};

/** Ordering options when selecting data from "path_author". */
export type Path_Author_Order_By = {
  path?: InputMaybe<Path_Order_By>;
  pathId?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: path_author */
export type Path_Author_Pk_Columns_Input = {
  pathId: Scalars['bigint'];
  userId: Scalars['String'];
};

/** select columns of table "path_author" */
export enum Path_Author_Select_Column {
  /** column name */
  PathId = 'pathId',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "path_author" */
export type Path_Author_Set_Input = {
  pathId?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Path_Author_Stddev_Fields = {
  __typename?: 'path_author_stddev_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "path_author" */
export type Path_Author_Stddev_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Path_Author_Stddev_Pop_Fields = {
  __typename?: 'path_author_stddev_pop_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "path_author" */
export type Path_Author_Stddev_Pop_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Path_Author_Stddev_Samp_Fields = {
  __typename?: 'path_author_stddev_samp_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "path_author" */
export type Path_Author_Stddev_Samp_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "path_author" */
export type Path_Author_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Path_Author_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Path_Author_Stream_Cursor_Value_Input = {
  pathId?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Path_Author_Sum_Fields = {
  __typename?: 'path_author_sum_fields';
  pathId?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "path_author" */
export type Path_Author_Sum_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** update columns of table "path_author" */
export enum Path_Author_Update_Column {
  /** column name */
  PathId = 'pathId',
  /** column name */
  UserId = 'userId'
}

export type Path_Author_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Path_Author_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Path_Author_Set_Input>;
  where: Path_Author_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Path_Author_Var_Pop_Fields = {
  __typename?: 'path_author_var_pop_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "path_author" */
export type Path_Author_Var_Pop_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Path_Author_Var_Samp_Fields = {
  __typename?: 'path_author_var_samp_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "path_author" */
export type Path_Author_Var_Samp_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Path_Author_Variance_Fields = {
  __typename?: 'path_author_variance_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "path_author" */
export type Path_Author_Variance_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Path_Avg_Fields = {
  __typename?: 'path_avg_fields';
  _schemaVersion?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  leadersCount?: Maybe<Scalars['Float']>;
  questionsCount?: Maybe<Scalars['Float']>;
  totalXP?: Maybe<Scalars['Float']>;
  xpMultiplier?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "path" */
export type Path_Avg_Order_By = {
  _schemaVersion?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  leadersCount?: InputMaybe<Order_By>;
  questionsCount?: InputMaybe<Order_By>;
  totalXP?: InputMaybe<Order_By>;
  xpMultiplier?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "path". All fields are combined with a logical 'AND'. */
export type Path_Bool_Exp = {
  _and?: InputMaybe<Array<Path_Bool_Exp>>;
  _not?: InputMaybe<Path_Bool_Exp>;
  _or?: InputMaybe<Array<Path_Bool_Exp>>;
  _schemaVersion?: InputMaybe<Int_Comparison_Exp>;
  activities?: InputMaybe<Path_Activity_Bool_Exp>;
  authorId?: InputMaybe<String_Comparison_Exp>;
  authors?: InputMaybe<Path_Author_Bool_Exp>;
  cover?: InputMaybe<String_Comparison_Exp>;
  coverAnimated?: InputMaybe<String_Comparison_Exp>;
  coverAnimatedFile?: InputMaybe<User_File_Bool_Exp>;
  coverAnimatedFileId?: InputMaybe<Uuid_Comparison_Exp>;
  coverFile?: InputMaybe<User_File_Bool_Exp>;
  coverFileId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  firestoreId?: InputMaybe<String_Comparison_Exp>;
  gradeLevels?: InputMaybe<Jsonb_Comparison_Exp>;
  guides?: InputMaybe<Guide_Path_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  interestArea?: InputMaybe<String_Comparison_Exp>;
  isFeatured?: InputMaybe<Boolean_Comparison_Exp>;
  isPublished?: InputMaybe<Boolean_Comparison_Exp>;
  isTractOriginal?: InputMaybe<Boolean_Comparison_Exp>;
  isVisibleUnauthed?: InputMaybe<Boolean_Comparison_Exp>;
  leadersCount?: InputMaybe<Int_Comparison_Exp>;
  media?: InputMaybe<Jsonb_Comparison_Exp>;
  missions?: InputMaybe<Mission_Bool_Exp>;
  missionsOrder?: InputMaybe<Jsonb_Comparison_Exp>;
  nodes?: InputMaybe<Path_Node_Bool_Exp>;
  notified?: InputMaybe<Json_Comparison_Exp>;
  orgId?: InputMaybe<String_Comparison_Exp>;
  pathCollectionItems?: InputMaybe<Path_Collection_Item_Bool_Exp>;
  publishedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  questionsCount?: InputMaybe<Int_Comparison_Exp>;
  reviews?: InputMaybe<Path_Review_Bool_Exp>;
  skills?: InputMaybe<Jsonb_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  subjects?: InputMaybe<Jsonb_Comparison_Exp>;
  supplies?: InputMaybe<String_Comparison_Exp>;
  tags?: InputMaybe<Jsonb_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  totalXP?: InputMaybe<Int_Comparison_Exp>;
  trailer?: InputMaybe<User_File_Bool_Exp>;
  trailerFileId?: InputMaybe<Uuid_Comparison_Exp>;
  trailerUrl?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  visibility?: InputMaybe<String_Comparison_Exp>;
  xpMultiplier?: InputMaybe<Smallint_Comparison_Exp>;
};

/** columns and relationships of "path_collection" */
export type Path_Collection = {
  __typename?: 'path_collection';
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An array relationship */
  learnerGroupPathCollection: Array<Learner_Group_Path_Collection>;
  /** An aggregate relationship */
  learnerGroupPathCollection_aggregate: Learner_Group_Path_Collection_Aggregate;
  /** An array relationship */
  pathCollectionItems: Array<Path_Collection_Item>;
  /** An aggregate relationship */
  pathCollectionItems_aggregate: Path_Collection_Item_Aggregate;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userId: Scalars['String'];
};


/** columns and relationships of "path_collection" */
export type Path_CollectionLearnerGroupPathCollectionArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Path_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Path_Collection_Order_By>>;
  where?: InputMaybe<Learner_Group_Path_Collection_Bool_Exp>;
};


/** columns and relationships of "path_collection" */
export type Path_CollectionLearnerGroupPathCollection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Path_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Path_Collection_Order_By>>;
  where?: InputMaybe<Learner_Group_Path_Collection_Bool_Exp>;
};


/** columns and relationships of "path_collection" */
export type Path_CollectionPathCollectionItemsArgs = {
  distinct_on?: InputMaybe<Array<Path_Collection_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Collection_Item_Order_By>>;
  where?: InputMaybe<Path_Collection_Item_Bool_Exp>;
};


/** columns and relationships of "path_collection" */
export type Path_CollectionPathCollectionItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Collection_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Collection_Item_Order_By>>;
  where?: InputMaybe<Path_Collection_Item_Bool_Exp>;
};

/** aggregated selection of "path_collection" */
export type Path_Collection_Aggregate = {
  __typename?: 'path_collection_aggregate';
  aggregate?: Maybe<Path_Collection_Aggregate_Fields>;
  nodes: Array<Path_Collection>;
};

/** aggregate fields of "path_collection" */
export type Path_Collection_Aggregate_Fields = {
  __typename?: 'path_collection_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Path_Collection_Max_Fields>;
  min?: Maybe<Path_Collection_Min_Fields>;
};


/** aggregate fields of "path_collection" */
export type Path_Collection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Path_Collection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "path_collection". All fields are combined with a logical 'AND'. */
export type Path_Collection_Bool_Exp = {
  _and?: InputMaybe<Array<Path_Collection_Bool_Exp>>;
  _not?: InputMaybe<Path_Collection_Bool_Exp>;
  _or?: InputMaybe<Array<Path_Collection_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  learnerGroupPathCollection?: InputMaybe<Learner_Group_Path_Collection_Bool_Exp>;
  pathCollectionItems?: InputMaybe<Path_Collection_Item_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "path_collection" */
export enum Path_Collection_Constraint {
  /** unique or primary key constraint on columns "id" */
  PathCollectionPkey = 'path_collection_pkey'
}

/** input type for inserting data into table "path_collection" */
export type Path_Collection_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  learnerGroupPathCollection?: InputMaybe<Learner_Group_Path_Collection_Arr_Rel_Insert_Input>;
  pathCollectionItems?: InputMaybe<Path_Collection_Item_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "path_collection_item" */
export type Path_Collection_Item = {
  __typename?: 'path_collection_item';
  collectionId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  lexorank: Scalars['String'];
  /** An object relationship */
  path: Path;
  /** An object relationship */
  pathCollection: Path_Collection;
  pathId: Scalars['bigint'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "path_collection_item" */
export type Path_Collection_Item_Aggregate = {
  __typename?: 'path_collection_item_aggregate';
  aggregate?: Maybe<Path_Collection_Item_Aggregate_Fields>;
  nodes: Array<Path_Collection_Item>;
};

/** aggregate fields of "path_collection_item" */
export type Path_Collection_Item_Aggregate_Fields = {
  __typename?: 'path_collection_item_aggregate_fields';
  avg?: Maybe<Path_Collection_Item_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Path_Collection_Item_Max_Fields>;
  min?: Maybe<Path_Collection_Item_Min_Fields>;
  stddev?: Maybe<Path_Collection_Item_Stddev_Fields>;
  stddev_pop?: Maybe<Path_Collection_Item_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Path_Collection_Item_Stddev_Samp_Fields>;
  sum?: Maybe<Path_Collection_Item_Sum_Fields>;
  var_pop?: Maybe<Path_Collection_Item_Var_Pop_Fields>;
  var_samp?: Maybe<Path_Collection_Item_Var_Samp_Fields>;
  variance?: Maybe<Path_Collection_Item_Variance_Fields>;
};


/** aggregate fields of "path_collection_item" */
export type Path_Collection_Item_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Path_Collection_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "path_collection_item" */
export type Path_Collection_Item_Aggregate_Order_By = {
  avg?: InputMaybe<Path_Collection_Item_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Path_Collection_Item_Max_Order_By>;
  min?: InputMaybe<Path_Collection_Item_Min_Order_By>;
  stddev?: InputMaybe<Path_Collection_Item_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Path_Collection_Item_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Path_Collection_Item_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Path_Collection_Item_Sum_Order_By>;
  var_pop?: InputMaybe<Path_Collection_Item_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Path_Collection_Item_Var_Samp_Order_By>;
  variance?: InputMaybe<Path_Collection_Item_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "path_collection_item" */
export type Path_Collection_Item_Arr_Rel_Insert_Input = {
  data: Array<Path_Collection_Item_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Path_Collection_Item_On_Conflict>;
};

/** aggregate avg on columns */
export type Path_Collection_Item_Avg_Fields = {
  __typename?: 'path_collection_item_avg_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "path_collection_item" */
export type Path_Collection_Item_Avg_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "path_collection_item". All fields are combined with a logical 'AND'. */
export type Path_Collection_Item_Bool_Exp = {
  _and?: InputMaybe<Array<Path_Collection_Item_Bool_Exp>>;
  _not?: InputMaybe<Path_Collection_Item_Bool_Exp>;
  _or?: InputMaybe<Array<Path_Collection_Item_Bool_Exp>>;
  collectionId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  lexorank?: InputMaybe<String_Comparison_Exp>;
  path?: InputMaybe<Path_Bool_Exp>;
  pathCollection?: InputMaybe<Path_Collection_Bool_Exp>;
  pathId?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "path_collection_item" */
export enum Path_Collection_Item_Constraint {
  /** unique or primary key constraint on columns "collection_id", "path_id" */
  PathCollectionItemPkey = 'path_collection_item_pkey'
}

/** input type for incrementing numeric columns in table "path_collection_item" */
export type Path_Collection_Item_Inc_Input = {
  pathId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "path_collection_item" */
export type Path_Collection_Item_Insert_Input = {
  collectionId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  lexorank?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Path_Obj_Rel_Insert_Input>;
  pathCollection?: InputMaybe<Path_Collection_Obj_Rel_Insert_Input>;
  pathId?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Path_Collection_Item_Max_Fields = {
  __typename?: 'path_collection_item_max_fields';
  collectionId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  lexorank?: Maybe<Scalars['String']>;
  pathId?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "path_collection_item" */
export type Path_Collection_Item_Max_Order_By = {
  collectionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  lexorank?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Path_Collection_Item_Min_Fields = {
  __typename?: 'path_collection_item_min_fields';
  collectionId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  lexorank?: Maybe<Scalars['String']>;
  pathId?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "path_collection_item" */
export type Path_Collection_Item_Min_Order_By = {
  collectionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  lexorank?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "path_collection_item" */
export type Path_Collection_Item_Mutation_Response = {
  __typename?: 'path_collection_item_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Path_Collection_Item>;
};

/** on_conflict condition type for table "path_collection_item" */
export type Path_Collection_Item_On_Conflict = {
  constraint: Path_Collection_Item_Constraint;
  update_columns?: Array<Path_Collection_Item_Update_Column>;
  where?: InputMaybe<Path_Collection_Item_Bool_Exp>;
};

/** Ordering options when selecting data from "path_collection_item". */
export type Path_Collection_Item_Order_By = {
  collectionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  lexorank?: InputMaybe<Order_By>;
  path?: InputMaybe<Path_Order_By>;
  pathCollection?: InputMaybe<Path_Collection_Order_By>;
  pathId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: path_collection_item */
export type Path_Collection_Item_Pk_Columns_Input = {
  collectionId: Scalars['uuid'];
  pathId: Scalars['bigint'];
};

/** select columns of table "path_collection_item" */
export enum Path_Collection_Item_Select_Column {
  /** column name */
  CollectionId = 'collectionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Lexorank = 'lexorank',
  /** column name */
  PathId = 'pathId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "path_collection_item" */
export type Path_Collection_Item_Set_Input = {
  collectionId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  lexorank?: InputMaybe<Scalars['String']>;
  pathId?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Path_Collection_Item_Stddev_Fields = {
  __typename?: 'path_collection_item_stddev_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "path_collection_item" */
export type Path_Collection_Item_Stddev_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Path_Collection_Item_Stddev_Pop_Fields = {
  __typename?: 'path_collection_item_stddev_pop_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "path_collection_item" */
export type Path_Collection_Item_Stddev_Pop_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Path_Collection_Item_Stddev_Samp_Fields = {
  __typename?: 'path_collection_item_stddev_samp_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "path_collection_item" */
export type Path_Collection_Item_Stddev_Samp_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "path_collection_item" */
export type Path_Collection_Item_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Path_Collection_Item_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Path_Collection_Item_Stream_Cursor_Value_Input = {
  collectionId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  lexorank?: InputMaybe<Scalars['String']>;
  pathId?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Path_Collection_Item_Sum_Fields = {
  __typename?: 'path_collection_item_sum_fields';
  pathId?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "path_collection_item" */
export type Path_Collection_Item_Sum_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** update columns of table "path_collection_item" */
export enum Path_Collection_Item_Update_Column {
  /** column name */
  CollectionId = 'collectionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Lexorank = 'lexorank',
  /** column name */
  PathId = 'pathId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Path_Collection_Item_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Path_Collection_Item_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Path_Collection_Item_Set_Input>;
  where: Path_Collection_Item_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Path_Collection_Item_Var_Pop_Fields = {
  __typename?: 'path_collection_item_var_pop_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "path_collection_item" */
export type Path_Collection_Item_Var_Pop_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Path_Collection_Item_Var_Samp_Fields = {
  __typename?: 'path_collection_item_var_samp_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "path_collection_item" */
export type Path_Collection_Item_Var_Samp_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Path_Collection_Item_Variance_Fields = {
  __typename?: 'path_collection_item_variance_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "path_collection_item" */
export type Path_Collection_Item_Variance_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Path_Collection_Max_Fields = {
  __typename?: 'path_collection_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Path_Collection_Min_Fields = {
  __typename?: 'path_collection_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "path_collection" */
export type Path_Collection_Mutation_Response = {
  __typename?: 'path_collection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Path_Collection>;
};

/** input type for inserting object relation for remote table "path_collection" */
export type Path_Collection_Obj_Rel_Insert_Input = {
  data: Path_Collection_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Path_Collection_On_Conflict>;
};

/** on_conflict condition type for table "path_collection" */
export type Path_Collection_On_Conflict = {
  constraint: Path_Collection_Constraint;
  update_columns?: Array<Path_Collection_Update_Column>;
  where?: InputMaybe<Path_Collection_Bool_Exp>;
};

/** Ordering options when selecting data from "path_collection". */
export type Path_Collection_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  learnerGroupPathCollection_aggregate?: InputMaybe<Learner_Group_Path_Collection_Aggregate_Order_By>;
  pathCollectionItems_aggregate?: InputMaybe<Path_Collection_Item_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: path_collection */
export type Path_Collection_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "path_collection" */
export enum Path_Collection_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "path_collection" */
export type Path_Collection_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "path_collection" */
export type Path_Collection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Path_Collection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Path_Collection_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "path_collection" */
export enum Path_Collection_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Path_Collection_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Path_Collection_Set_Input>;
  where: Path_Collection_Bool_Exp;
};

/** unique or primary key constraints on table "path" */
export enum Path_Constraint {
  /** unique or primary key constraint on columns "firestore_id" */
  PathFirestoreIdKey = 'path_firestore_id_key',
  /** unique or primary key constraint on columns "id" */
  PathPkey = 'path_pkey',
  /** unique or primary key constraint on columns "slug" */
  PathSlugKey = 'path_slug_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Path_Delete_At_Path_Input = {
  gradeLevels?: InputMaybe<Array<Scalars['String']>>;
  media?: InputMaybe<Array<Scalars['String']>>;
  missionsOrder?: InputMaybe<Array<Scalars['String']>>;
  skills?: InputMaybe<Array<Scalars['String']>>;
  subjects?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Path_Delete_Elem_Input = {
  gradeLevels?: InputMaybe<Scalars['Int']>;
  media?: InputMaybe<Scalars['Int']>;
  missionsOrder?: InputMaybe<Scalars['Int']>;
  skills?: InputMaybe<Scalars['Int']>;
  subjects?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Path_Delete_Key_Input = {
  gradeLevels?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Scalars['String']>;
  missionsOrder?: InputMaybe<Scalars['String']>;
  skills?: InputMaybe<Scalars['String']>;
  subjects?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
};

/** Admin controlled path feeds */
export type Path_Feed = {
  __typename?: 'path_feed';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  path: Path;
  pathId: Scalars['bigint'];
  slug: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userId: Scalars['String'];
};

/** aggregated selection of "path_feed" */
export type Path_Feed_Aggregate = {
  __typename?: 'path_feed_aggregate';
  aggregate?: Maybe<Path_Feed_Aggregate_Fields>;
  nodes: Array<Path_Feed>;
};

/** aggregate fields of "path_feed" */
export type Path_Feed_Aggregate_Fields = {
  __typename?: 'path_feed_aggregate_fields';
  avg?: Maybe<Path_Feed_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Path_Feed_Max_Fields>;
  min?: Maybe<Path_Feed_Min_Fields>;
  stddev?: Maybe<Path_Feed_Stddev_Fields>;
  stddev_pop?: Maybe<Path_Feed_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Path_Feed_Stddev_Samp_Fields>;
  sum?: Maybe<Path_Feed_Sum_Fields>;
  var_pop?: Maybe<Path_Feed_Var_Pop_Fields>;
  var_samp?: Maybe<Path_Feed_Var_Samp_Fields>;
  variance?: Maybe<Path_Feed_Variance_Fields>;
};


/** aggregate fields of "path_feed" */
export type Path_Feed_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Path_Feed_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Path_Feed_Avg_Fields = {
  __typename?: 'path_feed_avg_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "path_feed". All fields are combined with a logical 'AND'. */
export type Path_Feed_Bool_Exp = {
  _and?: InputMaybe<Array<Path_Feed_Bool_Exp>>;
  _not?: InputMaybe<Path_Feed_Bool_Exp>;
  _or?: InputMaybe<Array<Path_Feed_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  path?: InputMaybe<Path_Bool_Exp>;
  pathId?: InputMaybe<Bigint_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "path_feed" */
export enum Path_Feed_Constraint {
  /** unique or primary key constraint on columns "slug", "path_id" */
  PathFeedPkey = 'path_feed_pkey'
}

/** input type for incrementing numeric columns in table "path_feed" */
export type Path_Feed_Inc_Input = {
  pathId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "path_feed" */
export type Path_Feed_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  path?: InputMaybe<Path_Obj_Rel_Insert_Input>;
  pathId?: InputMaybe<Scalars['bigint']>;
  slug?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Path_Feed_Max_Fields = {
  __typename?: 'path_feed_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  pathId?: Maybe<Scalars['bigint']>;
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Path_Feed_Min_Fields = {
  __typename?: 'path_feed_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  pathId?: Maybe<Scalars['bigint']>;
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "path_feed" */
export type Path_Feed_Mutation_Response = {
  __typename?: 'path_feed_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Path_Feed>;
};

/** on_conflict condition type for table "path_feed" */
export type Path_Feed_On_Conflict = {
  constraint: Path_Feed_Constraint;
  update_columns?: Array<Path_Feed_Update_Column>;
  where?: InputMaybe<Path_Feed_Bool_Exp>;
};

/** Ordering options when selecting data from "path_feed". */
export type Path_Feed_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  path?: InputMaybe<Path_Order_By>;
  pathId?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: path_feed */
export type Path_Feed_Pk_Columns_Input = {
  pathId: Scalars['bigint'];
  slug: Scalars['String'];
};

/** select columns of table "path_feed" */
export enum Path_Feed_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  PathId = 'pathId',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "path_feed" */
export type Path_Feed_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  pathId?: InputMaybe<Scalars['bigint']>;
  slug?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Path_Feed_Stddev_Fields = {
  __typename?: 'path_feed_stddev_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Path_Feed_Stddev_Pop_Fields = {
  __typename?: 'path_feed_stddev_pop_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Path_Feed_Stddev_Samp_Fields = {
  __typename?: 'path_feed_stddev_samp_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "path_feed" */
export type Path_Feed_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Path_Feed_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Path_Feed_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  pathId?: InputMaybe<Scalars['bigint']>;
  slug?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Path_Feed_Sum_Fields = {
  __typename?: 'path_feed_sum_fields';
  pathId?: Maybe<Scalars['bigint']>;
};

/** update columns of table "path_feed" */
export enum Path_Feed_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  PathId = 'pathId',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Path_Feed_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Path_Feed_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Path_Feed_Set_Input>;
  where: Path_Feed_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Path_Feed_Var_Pop_Fields = {
  __typename?: 'path_feed_var_pop_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Path_Feed_Var_Samp_Fields = {
  __typename?: 'path_feed_var_samp_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Path_Feed_Variance_Fields = {
  __typename?: 'path_feed_variance_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "path" */
export type Path_Inc_Input = {
  _schemaVersion?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  leadersCount?: InputMaybe<Scalars['Int']>;
  questionsCount?: InputMaybe<Scalars['Int']>;
  totalXP?: InputMaybe<Scalars['Int']>;
  xpMultiplier?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "path" */
export type Path_Insert_Input = {
  _schemaVersion?: InputMaybe<Scalars['Int']>;
  activities?: InputMaybe<Path_Activity_Arr_Rel_Insert_Input>;
  authorId?: InputMaybe<Scalars['String']>;
  authors?: InputMaybe<Path_Author_Arr_Rel_Insert_Input>;
  cover?: InputMaybe<Scalars['String']>;
  coverAnimated?: InputMaybe<Scalars['String']>;
  coverAnimatedFile?: InputMaybe<User_File_Obj_Rel_Insert_Input>;
  coverAnimatedFileId?: InputMaybe<Scalars['uuid']>;
  coverFile?: InputMaybe<User_File_Obj_Rel_Insert_Input>;
  coverFileId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  firestoreId?: InputMaybe<Scalars['String']>;
  gradeLevels?: InputMaybe<Scalars['jsonb']>;
  guides?: InputMaybe<Guide_Path_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']>;
  interestArea?: InputMaybe<Scalars['String']>;
  isFeatured?: InputMaybe<Scalars['Boolean']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isTractOriginal?: InputMaybe<Scalars['Boolean']>;
  isVisibleUnauthed?: InputMaybe<Scalars['Boolean']>;
  leadersCount?: InputMaybe<Scalars['Int']>;
  media?: InputMaybe<Scalars['jsonb']>;
  missions?: InputMaybe<Mission_Arr_Rel_Insert_Input>;
  missionsOrder?: InputMaybe<Scalars['jsonb']>;
  nodes?: InputMaybe<Path_Node_Arr_Rel_Insert_Input>;
  notified?: InputMaybe<Scalars['json']>;
  orgId?: InputMaybe<Scalars['String']>;
  pathCollectionItems?: InputMaybe<Path_Collection_Item_Arr_Rel_Insert_Input>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  questionsCount?: InputMaybe<Scalars['Int']>;
  reviews?: InputMaybe<Path_Review_Arr_Rel_Insert_Input>;
  skills?: InputMaybe<Scalars['jsonb']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subjects?: InputMaybe<Scalars['jsonb']>;
  supplies?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  title?: InputMaybe<Scalars['String']>;
  totalXP?: InputMaybe<Scalars['Int']>;
  trailer?: InputMaybe<User_File_Obj_Rel_Insert_Input>;
  trailerFileId?: InputMaybe<Scalars['uuid']>;
  trailerUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  visibility?: InputMaybe<Scalars['String']>;
  xpMultiplier?: InputMaybe<Scalars['smallint']>;
};

/** aggregate max on columns */
export type Path_Max_Fields = {
  __typename?: 'path_max_fields';
  _schemaVersion?: Maybe<Scalars['Int']>;
  authorId?: Maybe<Scalars['String']>;
  cover?: Maybe<Scalars['String']>;
  coverAnimated?: Maybe<Scalars['String']>;
  coverAnimatedFileId?: Maybe<Scalars['uuid']>;
  coverFileId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  firestoreId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  interestArea?: Maybe<Scalars['String']>;
  leadersCount?: Maybe<Scalars['Int']>;
  orgId?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  questionsCount?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  supplies?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalXP?: Maybe<Scalars['Int']>;
  trailerFileId?: Maybe<Scalars['uuid']>;
  trailerUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  visibility?: Maybe<Scalars['String']>;
  xpMultiplier?: Maybe<Scalars['smallint']>;
};

/** order by max() on columns of table "path" */
export type Path_Max_Order_By = {
  _schemaVersion?: InputMaybe<Order_By>;
  authorId?: InputMaybe<Order_By>;
  cover?: InputMaybe<Order_By>;
  coverAnimated?: InputMaybe<Order_By>;
  coverAnimatedFileId?: InputMaybe<Order_By>;
  coverFileId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  firestoreId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interestArea?: InputMaybe<Order_By>;
  leadersCount?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  publishedAt?: InputMaybe<Order_By>;
  questionsCount?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplies?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  totalXP?: InputMaybe<Order_By>;
  trailerFileId?: InputMaybe<Order_By>;
  trailerUrl?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  visibility?: InputMaybe<Order_By>;
  xpMultiplier?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Path_Min_Fields = {
  __typename?: 'path_min_fields';
  _schemaVersion?: Maybe<Scalars['Int']>;
  authorId?: Maybe<Scalars['String']>;
  cover?: Maybe<Scalars['String']>;
  coverAnimated?: Maybe<Scalars['String']>;
  coverAnimatedFileId?: Maybe<Scalars['uuid']>;
  coverFileId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  firestoreId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  interestArea?: Maybe<Scalars['String']>;
  leadersCount?: Maybe<Scalars['Int']>;
  orgId?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  questionsCount?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  supplies?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalXP?: Maybe<Scalars['Int']>;
  trailerFileId?: Maybe<Scalars['uuid']>;
  trailerUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  visibility?: Maybe<Scalars['String']>;
  xpMultiplier?: Maybe<Scalars['smallint']>;
};

/** order by min() on columns of table "path" */
export type Path_Min_Order_By = {
  _schemaVersion?: InputMaybe<Order_By>;
  authorId?: InputMaybe<Order_By>;
  cover?: InputMaybe<Order_By>;
  coverAnimated?: InputMaybe<Order_By>;
  coverAnimatedFileId?: InputMaybe<Order_By>;
  coverFileId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  firestoreId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interestArea?: InputMaybe<Order_By>;
  leadersCount?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  publishedAt?: InputMaybe<Order_By>;
  questionsCount?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplies?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  totalXP?: InputMaybe<Order_By>;
  trailerFileId?: InputMaybe<Order_By>;
  trailerUrl?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  visibility?: InputMaybe<Order_By>;
  xpMultiplier?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "path" */
export type Path_Mutation_Response = {
  __typename?: 'path_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Path>;
};

/** columns and relationships of "path_node" */
export type Path_Node = {
  __typename?: 'path_node';
  caption?: Maybe<Scalars['String']>;
  /** An object relationship */
  coverFile?: Maybe<User_File>;
  coverFileId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  legacyChallengeId?: Maybe<Scalars['Int']>;
  legacyMissionId?: Maybe<Scalars['Int']>;
  lexorank: Scalars['String'];
  /** An object relationship */
  path: Path;
  pathId: Scalars['bigint'];
  /** An array relationship */
  projects: Array<Project>;
  /** An aggregate relationship */
  projects_aggregate: Project_Aggregate;
  responsesEnabled: Scalars['Boolean'];
  rewardAmount: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  videoFile?: Maybe<User_File>;
  videoFileId?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "path_node" */
export type Path_NodeProjectsArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


/** columns and relationships of "path_node" */
export type Path_NodeProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};

/** aggregated selection of "path_node" */
export type Path_Node_Aggregate = {
  __typename?: 'path_node_aggregate';
  aggregate?: Maybe<Path_Node_Aggregate_Fields>;
  nodes: Array<Path_Node>;
};

/** aggregate fields of "path_node" */
export type Path_Node_Aggregate_Fields = {
  __typename?: 'path_node_aggregate_fields';
  avg?: Maybe<Path_Node_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Path_Node_Max_Fields>;
  min?: Maybe<Path_Node_Min_Fields>;
  stddev?: Maybe<Path_Node_Stddev_Fields>;
  stddev_pop?: Maybe<Path_Node_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Path_Node_Stddev_Samp_Fields>;
  sum?: Maybe<Path_Node_Sum_Fields>;
  var_pop?: Maybe<Path_Node_Var_Pop_Fields>;
  var_samp?: Maybe<Path_Node_Var_Samp_Fields>;
  variance?: Maybe<Path_Node_Variance_Fields>;
};


/** aggregate fields of "path_node" */
export type Path_Node_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Path_Node_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "path_node" */
export type Path_Node_Aggregate_Order_By = {
  avg?: InputMaybe<Path_Node_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Path_Node_Max_Order_By>;
  min?: InputMaybe<Path_Node_Min_Order_By>;
  stddev?: InputMaybe<Path_Node_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Path_Node_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Path_Node_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Path_Node_Sum_Order_By>;
  var_pop?: InputMaybe<Path_Node_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Path_Node_Var_Samp_Order_By>;
  variance?: InputMaybe<Path_Node_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "path_node" */
export type Path_Node_Arr_Rel_Insert_Input = {
  data: Array<Path_Node_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Path_Node_On_Conflict>;
};

/** aggregate avg on columns */
export type Path_Node_Avg_Fields = {
  __typename?: 'path_node_avg_fields';
  legacyChallengeId?: Maybe<Scalars['Float']>;
  legacyMissionId?: Maybe<Scalars['Float']>;
  pathId?: Maybe<Scalars['Float']>;
  rewardAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "path_node" */
export type Path_Node_Avg_Order_By = {
  legacyChallengeId?: InputMaybe<Order_By>;
  legacyMissionId?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  rewardAmount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "path_node". All fields are combined with a logical 'AND'. */
export type Path_Node_Bool_Exp = {
  _and?: InputMaybe<Array<Path_Node_Bool_Exp>>;
  _not?: InputMaybe<Path_Node_Bool_Exp>;
  _or?: InputMaybe<Array<Path_Node_Bool_Exp>>;
  caption?: InputMaybe<String_Comparison_Exp>;
  coverFile?: InputMaybe<User_File_Bool_Exp>;
  coverFileId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  legacyChallengeId?: InputMaybe<Int_Comparison_Exp>;
  legacyMissionId?: InputMaybe<Int_Comparison_Exp>;
  lexorank?: InputMaybe<String_Comparison_Exp>;
  path?: InputMaybe<Path_Bool_Exp>;
  pathId?: InputMaybe<Bigint_Comparison_Exp>;
  projects?: InputMaybe<Project_Bool_Exp>;
  responsesEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  rewardAmount?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  videoFile?: InputMaybe<User_File_Bool_Exp>;
  videoFileId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** columns and relationships of "path_node_comment" */
export type Path_Node_Comment = {
  __typename?: 'path_node_comment';
  /** An object relationship */
  comment: Comment;
  commentId: Scalars['uuid'];
  /** An object relationship */
  node: Path_Node;
  pathNodeId: Scalars['uuid'];
};

/** aggregated selection of "path_node_comment" */
export type Path_Node_Comment_Aggregate = {
  __typename?: 'path_node_comment_aggregate';
  aggregate?: Maybe<Path_Node_Comment_Aggregate_Fields>;
  nodes: Array<Path_Node_Comment>;
};

/** aggregate fields of "path_node_comment" */
export type Path_Node_Comment_Aggregate_Fields = {
  __typename?: 'path_node_comment_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Path_Node_Comment_Max_Fields>;
  min?: Maybe<Path_Node_Comment_Min_Fields>;
};


/** aggregate fields of "path_node_comment" */
export type Path_Node_Comment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Path_Node_Comment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "path_node_comment". All fields are combined with a logical 'AND'. */
export type Path_Node_Comment_Bool_Exp = {
  _and?: InputMaybe<Array<Path_Node_Comment_Bool_Exp>>;
  _not?: InputMaybe<Path_Node_Comment_Bool_Exp>;
  _or?: InputMaybe<Array<Path_Node_Comment_Bool_Exp>>;
  comment?: InputMaybe<Comment_Bool_Exp>;
  commentId?: InputMaybe<Uuid_Comparison_Exp>;
  node?: InputMaybe<Path_Node_Bool_Exp>;
  pathNodeId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "path_node_comment" */
export enum Path_Node_Comment_Constraint {
  /** unique or primary key constraint on columns "comment_id" */
  PathNodeCommentPkey = 'path_node_comment_pkey'
}

/** input type for inserting data into table "path_node_comment" */
export type Path_Node_Comment_Insert_Input = {
  comment?: InputMaybe<Comment_Obj_Rel_Insert_Input>;
  commentId?: InputMaybe<Scalars['uuid']>;
  node?: InputMaybe<Path_Node_Obj_Rel_Insert_Input>;
  pathNodeId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Path_Node_Comment_Max_Fields = {
  __typename?: 'path_node_comment_max_fields';
  commentId?: Maybe<Scalars['uuid']>;
  pathNodeId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Path_Node_Comment_Min_Fields = {
  __typename?: 'path_node_comment_min_fields';
  commentId?: Maybe<Scalars['uuid']>;
  pathNodeId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "path_node_comment" */
export type Path_Node_Comment_Mutation_Response = {
  __typename?: 'path_node_comment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Path_Node_Comment>;
};

/** input type for inserting object relation for remote table "path_node_comment" */
export type Path_Node_Comment_Obj_Rel_Insert_Input = {
  data: Path_Node_Comment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Path_Node_Comment_On_Conflict>;
};

/** on_conflict condition type for table "path_node_comment" */
export type Path_Node_Comment_On_Conflict = {
  constraint: Path_Node_Comment_Constraint;
  update_columns?: Array<Path_Node_Comment_Update_Column>;
  where?: InputMaybe<Path_Node_Comment_Bool_Exp>;
};

/** Ordering options when selecting data from "path_node_comment". */
export type Path_Node_Comment_Order_By = {
  comment?: InputMaybe<Comment_Order_By>;
  commentId?: InputMaybe<Order_By>;
  node?: InputMaybe<Path_Node_Order_By>;
  pathNodeId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: path_node_comment */
export type Path_Node_Comment_Pk_Columns_Input = {
  commentId: Scalars['uuid'];
};

/** select columns of table "path_node_comment" */
export enum Path_Node_Comment_Select_Column {
  /** column name */
  CommentId = 'commentId',
  /** column name */
  PathNodeId = 'pathNodeId'
}

/** input type for updating data in table "path_node_comment" */
export type Path_Node_Comment_Set_Input = {
  commentId?: InputMaybe<Scalars['uuid']>;
  pathNodeId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "path_node_comment" */
export type Path_Node_Comment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Path_Node_Comment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Path_Node_Comment_Stream_Cursor_Value_Input = {
  commentId?: InputMaybe<Scalars['uuid']>;
  pathNodeId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "path_node_comment" */
export enum Path_Node_Comment_Update_Column {
  /** column name */
  CommentId = 'commentId',
  /** column name */
  PathNodeId = 'pathNodeId'
}

export type Path_Node_Comment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Path_Node_Comment_Set_Input>;
  where: Path_Node_Comment_Bool_Exp;
};

/** unique or primary key constraints on table "path_node" */
export enum Path_Node_Constraint {
  /** unique or primary key constraint on columns "legacy_challenge_id" */
  PathNodeLegacyChallengeIdKey = 'path_node_legacy_challenge_id_key',
  /** unique or primary key constraint on columns "legacy_mission_id" */
  PathNodeLegacyMissionIdKey = 'path_node_legacy_mission_id_key',
  /** unique or primary key constraint on columns "lexorank", "path_id" */
  PathNodePathIdLexorankKey = 'path_node_path_id_lexorank_key',
  /** unique or primary key constraint on columns "id" */
  PathNodePkey = 'path_node_pkey'
}

/** input type for incrementing numeric columns in table "path_node" */
export type Path_Node_Inc_Input = {
  legacyChallengeId?: InputMaybe<Scalars['Int']>;
  legacyMissionId?: InputMaybe<Scalars['Int']>;
  pathId?: InputMaybe<Scalars['bigint']>;
  rewardAmount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "path_node" */
export type Path_Node_Insert_Input = {
  caption?: InputMaybe<Scalars['String']>;
  coverFile?: InputMaybe<User_File_Obj_Rel_Insert_Input>;
  coverFileId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  legacyChallengeId?: InputMaybe<Scalars['Int']>;
  legacyMissionId?: InputMaybe<Scalars['Int']>;
  lexorank?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Path_Obj_Rel_Insert_Input>;
  pathId?: InputMaybe<Scalars['bigint']>;
  projects?: InputMaybe<Project_Arr_Rel_Insert_Input>;
  responsesEnabled?: InputMaybe<Scalars['Boolean']>;
  rewardAmount?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoFile?: InputMaybe<User_File_Obj_Rel_Insert_Input>;
  videoFileId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Path_Node_Max_Fields = {
  __typename?: 'path_node_max_fields';
  caption?: Maybe<Scalars['String']>;
  coverFileId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  legacyChallengeId?: Maybe<Scalars['Int']>;
  legacyMissionId?: Maybe<Scalars['Int']>;
  lexorank?: Maybe<Scalars['String']>;
  pathId?: Maybe<Scalars['bigint']>;
  rewardAmount?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  videoFileId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "path_node" */
export type Path_Node_Max_Order_By = {
  caption?: InputMaybe<Order_By>;
  coverFileId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacyChallengeId?: InputMaybe<Order_By>;
  legacyMissionId?: InputMaybe<Order_By>;
  lexorank?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  rewardAmount?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  videoFileId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Path_Node_Min_Fields = {
  __typename?: 'path_node_min_fields';
  caption?: Maybe<Scalars['String']>;
  coverFileId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  legacyChallengeId?: Maybe<Scalars['Int']>;
  legacyMissionId?: Maybe<Scalars['Int']>;
  lexorank?: Maybe<Scalars['String']>;
  pathId?: Maybe<Scalars['bigint']>;
  rewardAmount?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  videoFileId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "path_node" */
export type Path_Node_Min_Order_By = {
  caption?: InputMaybe<Order_By>;
  coverFileId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacyChallengeId?: InputMaybe<Order_By>;
  legacyMissionId?: InputMaybe<Order_By>;
  lexorank?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  rewardAmount?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  videoFileId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "path_node" */
export type Path_Node_Mutation_Response = {
  __typename?: 'path_node_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Path_Node>;
};

/** input type for inserting object relation for remote table "path_node" */
export type Path_Node_Obj_Rel_Insert_Input = {
  data: Path_Node_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Path_Node_On_Conflict>;
};

/** on_conflict condition type for table "path_node" */
export type Path_Node_On_Conflict = {
  constraint: Path_Node_Constraint;
  update_columns?: Array<Path_Node_Update_Column>;
  where?: InputMaybe<Path_Node_Bool_Exp>;
};

/** Ordering options when selecting data from "path_node". */
export type Path_Node_Order_By = {
  caption?: InputMaybe<Order_By>;
  coverFile?: InputMaybe<User_File_Order_By>;
  coverFileId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacyChallengeId?: InputMaybe<Order_By>;
  legacyMissionId?: InputMaybe<Order_By>;
  lexorank?: InputMaybe<Order_By>;
  path?: InputMaybe<Path_Order_By>;
  pathId?: InputMaybe<Order_By>;
  projects_aggregate?: InputMaybe<Project_Aggregate_Order_By>;
  responsesEnabled?: InputMaybe<Order_By>;
  rewardAmount?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  videoFile?: InputMaybe<User_File_Order_By>;
  videoFileId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: path_node */
export type Path_Node_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "path_node" */
export enum Path_Node_Select_Column {
  /** column name */
  Caption = 'caption',
  /** column name */
  CoverFileId = 'coverFileId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LegacyChallengeId = 'legacyChallengeId',
  /** column name */
  LegacyMissionId = 'legacyMissionId',
  /** column name */
  Lexorank = 'lexorank',
  /** column name */
  PathId = 'pathId',
  /** column name */
  ResponsesEnabled = 'responsesEnabled',
  /** column name */
  RewardAmount = 'rewardAmount',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoFileId = 'videoFileId'
}

/** input type for updating data in table "path_node" */
export type Path_Node_Set_Input = {
  caption?: InputMaybe<Scalars['String']>;
  coverFileId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  legacyChallengeId?: InputMaybe<Scalars['Int']>;
  legacyMissionId?: InputMaybe<Scalars['Int']>;
  lexorank?: InputMaybe<Scalars['String']>;
  pathId?: InputMaybe<Scalars['bigint']>;
  responsesEnabled?: InputMaybe<Scalars['Boolean']>;
  rewardAmount?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoFileId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Path_Node_Stddev_Fields = {
  __typename?: 'path_node_stddev_fields';
  legacyChallengeId?: Maybe<Scalars['Float']>;
  legacyMissionId?: Maybe<Scalars['Float']>;
  pathId?: Maybe<Scalars['Float']>;
  rewardAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "path_node" */
export type Path_Node_Stddev_Order_By = {
  legacyChallengeId?: InputMaybe<Order_By>;
  legacyMissionId?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  rewardAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Path_Node_Stddev_Pop_Fields = {
  __typename?: 'path_node_stddev_pop_fields';
  legacyChallengeId?: Maybe<Scalars['Float']>;
  legacyMissionId?: Maybe<Scalars['Float']>;
  pathId?: Maybe<Scalars['Float']>;
  rewardAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "path_node" */
export type Path_Node_Stddev_Pop_Order_By = {
  legacyChallengeId?: InputMaybe<Order_By>;
  legacyMissionId?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  rewardAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Path_Node_Stddev_Samp_Fields = {
  __typename?: 'path_node_stddev_samp_fields';
  legacyChallengeId?: Maybe<Scalars['Float']>;
  legacyMissionId?: Maybe<Scalars['Float']>;
  pathId?: Maybe<Scalars['Float']>;
  rewardAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "path_node" */
export type Path_Node_Stddev_Samp_Order_By = {
  legacyChallengeId?: InputMaybe<Order_By>;
  legacyMissionId?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  rewardAmount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "path_node" */
export type Path_Node_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Path_Node_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Path_Node_Stream_Cursor_Value_Input = {
  caption?: InputMaybe<Scalars['String']>;
  coverFileId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  legacyChallengeId?: InputMaybe<Scalars['Int']>;
  legacyMissionId?: InputMaybe<Scalars['Int']>;
  lexorank?: InputMaybe<Scalars['String']>;
  pathId?: InputMaybe<Scalars['bigint']>;
  responsesEnabled?: InputMaybe<Scalars['Boolean']>;
  rewardAmount?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoFileId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Path_Node_Sum_Fields = {
  __typename?: 'path_node_sum_fields';
  legacyChallengeId?: Maybe<Scalars['Int']>;
  legacyMissionId?: Maybe<Scalars['Int']>;
  pathId?: Maybe<Scalars['bigint']>;
  rewardAmount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "path_node" */
export type Path_Node_Sum_Order_By = {
  legacyChallengeId?: InputMaybe<Order_By>;
  legacyMissionId?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  rewardAmount?: InputMaybe<Order_By>;
};

/** update columns of table "path_node" */
export enum Path_Node_Update_Column {
  /** column name */
  Caption = 'caption',
  /** column name */
  CoverFileId = 'coverFileId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LegacyChallengeId = 'legacyChallengeId',
  /** column name */
  LegacyMissionId = 'legacyMissionId',
  /** column name */
  Lexorank = 'lexorank',
  /** column name */
  PathId = 'pathId',
  /** column name */
  ResponsesEnabled = 'responsesEnabled',
  /** column name */
  RewardAmount = 'rewardAmount',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoFileId = 'videoFileId'
}

export type Path_Node_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Path_Node_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Path_Node_Set_Input>;
  where: Path_Node_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Path_Node_Var_Pop_Fields = {
  __typename?: 'path_node_var_pop_fields';
  legacyChallengeId?: Maybe<Scalars['Float']>;
  legacyMissionId?: Maybe<Scalars['Float']>;
  pathId?: Maybe<Scalars['Float']>;
  rewardAmount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "path_node" */
export type Path_Node_Var_Pop_Order_By = {
  legacyChallengeId?: InputMaybe<Order_By>;
  legacyMissionId?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  rewardAmount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Path_Node_Var_Samp_Fields = {
  __typename?: 'path_node_var_samp_fields';
  legacyChallengeId?: Maybe<Scalars['Float']>;
  legacyMissionId?: Maybe<Scalars['Float']>;
  pathId?: Maybe<Scalars['Float']>;
  rewardAmount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "path_node" */
export type Path_Node_Var_Samp_Order_By = {
  legacyChallengeId?: InputMaybe<Order_By>;
  legacyMissionId?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  rewardAmount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Path_Node_Variance_Fields = {
  __typename?: 'path_node_variance_fields';
  legacyChallengeId?: Maybe<Scalars['Float']>;
  legacyMissionId?: Maybe<Scalars['Float']>;
  pathId?: Maybe<Scalars['Float']>;
  rewardAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "path_node" */
export type Path_Node_Variance_Order_By = {
  legacyChallengeId?: InputMaybe<Order_By>;
  legacyMissionId?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  rewardAmount?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "path" */
export type Path_Obj_Rel_Insert_Input = {
  data: Path_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Path_On_Conflict>;
};

/** on_conflict condition type for table "path" */
export type Path_On_Conflict = {
  constraint: Path_Constraint;
  update_columns?: Array<Path_Update_Column>;
  where?: InputMaybe<Path_Bool_Exp>;
};

/** Ordering options when selecting data from "path". */
export type Path_Order_By = {
  _schemaVersion?: InputMaybe<Order_By>;
  activities_aggregate?: InputMaybe<Path_Activity_Aggregate_Order_By>;
  authorId?: InputMaybe<Order_By>;
  authors_aggregate?: InputMaybe<Path_Author_Aggregate_Order_By>;
  cover?: InputMaybe<Order_By>;
  coverAnimated?: InputMaybe<Order_By>;
  coverAnimatedFile?: InputMaybe<User_File_Order_By>;
  coverAnimatedFileId?: InputMaybe<Order_By>;
  coverFile?: InputMaybe<User_File_Order_By>;
  coverFileId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  firestoreId?: InputMaybe<Order_By>;
  gradeLevels?: InputMaybe<Order_By>;
  guides_aggregate?: InputMaybe<Guide_Path_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  interestArea?: InputMaybe<Order_By>;
  isFeatured?: InputMaybe<Order_By>;
  isPublished?: InputMaybe<Order_By>;
  isTractOriginal?: InputMaybe<Order_By>;
  isVisibleUnauthed?: InputMaybe<Order_By>;
  leadersCount?: InputMaybe<Order_By>;
  media?: InputMaybe<Order_By>;
  missionsOrder?: InputMaybe<Order_By>;
  missions_aggregate?: InputMaybe<Mission_Aggregate_Order_By>;
  nodes_aggregate?: InputMaybe<Path_Node_Aggregate_Order_By>;
  notified?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  pathCollectionItems_aggregate?: InputMaybe<Path_Collection_Item_Aggregate_Order_By>;
  publishedAt?: InputMaybe<Order_By>;
  questionsCount?: InputMaybe<Order_By>;
  reviews_aggregate?: InputMaybe<Path_Review_Aggregate_Order_By>;
  skills?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subjects?: InputMaybe<Order_By>;
  supplies?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  totalXP?: InputMaybe<Order_By>;
  trailer?: InputMaybe<User_File_Order_By>;
  trailerFileId?: InputMaybe<Order_By>;
  trailerUrl?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  visibility?: InputMaybe<Order_By>;
  xpMultiplier?: InputMaybe<Order_By>;
};

/** primary key columns input for table: path */
export type Path_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Path_Prepend_Input = {
  gradeLevels?: InputMaybe<Scalars['jsonb']>;
  media?: InputMaybe<Scalars['jsonb']>;
  missionsOrder?: InputMaybe<Scalars['jsonb']>;
  skills?: InputMaybe<Scalars['jsonb']>;
  subjects?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "path_review" */
export type Path_Review = {
  __typename?: 'path_review';
  /** An object relationship */
  comment?: Maybe<Comment>;
  commentId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** Has path author requested a rereview? */
  needsReview: Scalars['Boolean'];
  /** An object relationship */
  path: Path;
  pathId: Scalars['bigint'];
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userId: Scalars['String'];
};

/** aggregated selection of "path_review" */
export type Path_Review_Aggregate = {
  __typename?: 'path_review_aggregate';
  aggregate?: Maybe<Path_Review_Aggregate_Fields>;
  nodes: Array<Path_Review>;
};

/** aggregate fields of "path_review" */
export type Path_Review_Aggregate_Fields = {
  __typename?: 'path_review_aggregate_fields';
  avg?: Maybe<Path_Review_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Path_Review_Max_Fields>;
  min?: Maybe<Path_Review_Min_Fields>;
  stddev?: Maybe<Path_Review_Stddev_Fields>;
  stddev_pop?: Maybe<Path_Review_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Path_Review_Stddev_Samp_Fields>;
  sum?: Maybe<Path_Review_Sum_Fields>;
  var_pop?: Maybe<Path_Review_Var_Pop_Fields>;
  var_samp?: Maybe<Path_Review_Var_Samp_Fields>;
  variance?: Maybe<Path_Review_Variance_Fields>;
};


/** aggregate fields of "path_review" */
export type Path_Review_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Path_Review_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "path_review" */
export type Path_Review_Aggregate_Order_By = {
  avg?: InputMaybe<Path_Review_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Path_Review_Max_Order_By>;
  min?: InputMaybe<Path_Review_Min_Order_By>;
  stddev?: InputMaybe<Path_Review_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Path_Review_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Path_Review_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Path_Review_Sum_Order_By>;
  var_pop?: InputMaybe<Path_Review_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Path_Review_Var_Samp_Order_By>;
  variance?: InputMaybe<Path_Review_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "path_review" */
export type Path_Review_Arr_Rel_Insert_Input = {
  data: Array<Path_Review_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Path_Review_On_Conflict>;
};

/** aggregate avg on columns */
export type Path_Review_Avg_Fields = {
  __typename?: 'path_review_avg_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "path_review" */
export type Path_Review_Avg_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "path_review". All fields are combined with a logical 'AND'. */
export type Path_Review_Bool_Exp = {
  _and?: InputMaybe<Array<Path_Review_Bool_Exp>>;
  _not?: InputMaybe<Path_Review_Bool_Exp>;
  _or?: InputMaybe<Array<Path_Review_Bool_Exp>>;
  comment?: InputMaybe<Comment_Bool_Exp>;
  commentId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  needsReview?: InputMaybe<Boolean_Comparison_Exp>;
  path?: InputMaybe<Path_Bool_Exp>;
  pathId?: InputMaybe<Bigint_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "path_review" */
export enum Path_Review_Constraint {
  /** unique or primary key constraint on columns "comment_id" */
  PathReviewCommentIdKey = 'path_review_comment_id_key',
  /** unique or primary key constraint on columns "id" */
  PathReviewPkey = 'path_review_pkey'
}

/** input type for incrementing numeric columns in table "path_review" */
export type Path_Review_Inc_Input = {
  pathId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "path_review" */
export type Path_Review_Insert_Input = {
  comment?: InputMaybe<Comment_Obj_Rel_Insert_Input>;
  commentId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Has path author requested a rereview? */
  needsReview?: InputMaybe<Scalars['Boolean']>;
  path?: InputMaybe<Path_Obj_Rel_Insert_Input>;
  pathId?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Path_Review_Max_Fields = {
  __typename?: 'path_review_max_fields';
  commentId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  pathId?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "path_review" */
export type Path_Review_Max_Order_By = {
  commentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Path_Review_Min_Fields = {
  __typename?: 'path_review_min_fields';
  commentId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  pathId?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "path_review" */
export type Path_Review_Min_Order_By = {
  commentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "path_review" */
export type Path_Review_Mutation_Response = {
  __typename?: 'path_review_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Path_Review>;
};

/** input type for inserting object relation for remote table "path_review" */
export type Path_Review_Obj_Rel_Insert_Input = {
  data: Path_Review_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Path_Review_On_Conflict>;
};

/** on_conflict condition type for table "path_review" */
export type Path_Review_On_Conflict = {
  constraint: Path_Review_Constraint;
  update_columns?: Array<Path_Review_Update_Column>;
  where?: InputMaybe<Path_Review_Bool_Exp>;
};

/** Ordering options when selecting data from "path_review". */
export type Path_Review_Order_By = {
  comment?: InputMaybe<Comment_Order_By>;
  commentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  needsReview?: InputMaybe<Order_By>;
  path?: InputMaybe<Path_Order_By>;
  pathId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: path_review */
export type Path_Review_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "path_review" */
export enum Path_Review_Select_Column {
  /** column name */
  CommentId = 'commentId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  NeedsReview = 'needsReview',
  /** column name */
  PathId = 'pathId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "path_review" */
export type Path_Review_Set_Input = {
  commentId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Has path author requested a rereview? */
  needsReview?: InputMaybe<Scalars['Boolean']>;
  pathId?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Path_Review_Stddev_Fields = {
  __typename?: 'path_review_stddev_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "path_review" */
export type Path_Review_Stddev_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Path_Review_Stddev_Pop_Fields = {
  __typename?: 'path_review_stddev_pop_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "path_review" */
export type Path_Review_Stddev_Pop_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Path_Review_Stddev_Samp_Fields = {
  __typename?: 'path_review_stddev_samp_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "path_review" */
export type Path_Review_Stddev_Samp_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "path_review" */
export type Path_Review_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Path_Review_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Path_Review_Stream_Cursor_Value_Input = {
  commentId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Has path author requested a rereview? */
  needsReview?: InputMaybe<Scalars['Boolean']>;
  pathId?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Path_Review_Sum_Fields = {
  __typename?: 'path_review_sum_fields';
  pathId?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "path_review" */
export type Path_Review_Sum_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** update columns of table "path_review" */
export enum Path_Review_Update_Column {
  /** column name */
  CommentId = 'commentId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  NeedsReview = 'needsReview',
  /** column name */
  PathId = 'pathId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Path_Review_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Path_Review_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Path_Review_Set_Input>;
  where: Path_Review_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Path_Review_Var_Pop_Fields = {
  __typename?: 'path_review_var_pop_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "path_review" */
export type Path_Review_Var_Pop_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Path_Review_Var_Samp_Fields = {
  __typename?: 'path_review_var_samp_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "path_review" */
export type Path_Review_Var_Samp_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Path_Review_Variance_Fields = {
  __typename?: 'path_review_variance_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "path_review" */
export type Path_Review_Variance_Order_By = {
  pathId?: InputMaybe<Order_By>;
};

/** select columns of table "path" */
export enum Path_Select_Column {
  /** column name */
  SchemaVersion = '_schemaVersion',
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  Cover = 'cover',
  /** column name */
  CoverAnimated = 'coverAnimated',
  /** column name */
  CoverAnimatedFileId = 'coverAnimatedFileId',
  /** column name */
  CoverFileId = 'coverFileId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  FirestoreId = 'firestoreId',
  /** column name */
  GradeLevels = 'gradeLevels',
  /** column name */
  Id = 'id',
  /** column name */
  InterestArea = 'interestArea',
  /** column name */
  IsFeatured = 'isFeatured',
  /** column name */
  IsPublished = 'isPublished',
  /** column name */
  IsTractOriginal = 'isTractOriginal',
  /** column name */
  IsVisibleUnauthed = 'isVisibleUnauthed',
  /** column name */
  LeadersCount = 'leadersCount',
  /** column name */
  Media = 'media',
  /** column name */
  MissionsOrder = 'missionsOrder',
  /** column name */
  Notified = 'notified',
  /** column name */
  OrgId = 'orgId',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  QuestionsCount = 'questionsCount',
  /** column name */
  Skills = 'skills',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  Subjects = 'subjects',
  /** column name */
  Supplies = 'supplies',
  /** column name */
  Tags = 'tags',
  /** column name */
  Title = 'title',
  /** column name */
  TotalXp = 'totalXP',
  /** column name */
  TrailerFileId = 'trailerFileId',
  /** column name */
  TrailerUrl = 'trailerUrl',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Visibility = 'visibility',
  /** column name */
  XpMultiplier = 'xpMultiplier'
}

/** input type for updating data in table "path" */
export type Path_Set_Input = {
  _schemaVersion?: InputMaybe<Scalars['Int']>;
  authorId?: InputMaybe<Scalars['String']>;
  cover?: InputMaybe<Scalars['String']>;
  coverAnimated?: InputMaybe<Scalars['String']>;
  coverAnimatedFileId?: InputMaybe<Scalars['uuid']>;
  coverFileId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  firestoreId?: InputMaybe<Scalars['String']>;
  gradeLevels?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['bigint']>;
  interestArea?: InputMaybe<Scalars['String']>;
  isFeatured?: InputMaybe<Scalars['Boolean']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isTractOriginal?: InputMaybe<Scalars['Boolean']>;
  isVisibleUnauthed?: InputMaybe<Scalars['Boolean']>;
  leadersCount?: InputMaybe<Scalars['Int']>;
  media?: InputMaybe<Scalars['jsonb']>;
  missionsOrder?: InputMaybe<Scalars['jsonb']>;
  notified?: InputMaybe<Scalars['json']>;
  orgId?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  questionsCount?: InputMaybe<Scalars['Int']>;
  skills?: InputMaybe<Scalars['jsonb']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subjects?: InputMaybe<Scalars['jsonb']>;
  supplies?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  title?: InputMaybe<Scalars['String']>;
  totalXP?: InputMaybe<Scalars['Int']>;
  trailerFileId?: InputMaybe<Scalars['uuid']>;
  trailerUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  visibility?: InputMaybe<Scalars['String']>;
  xpMultiplier?: InputMaybe<Scalars['smallint']>;
};

/** aggregate stddev on columns */
export type Path_Stddev_Fields = {
  __typename?: 'path_stddev_fields';
  _schemaVersion?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  leadersCount?: Maybe<Scalars['Float']>;
  questionsCount?: Maybe<Scalars['Float']>;
  totalXP?: Maybe<Scalars['Float']>;
  xpMultiplier?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "path" */
export type Path_Stddev_Order_By = {
  _schemaVersion?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  leadersCount?: InputMaybe<Order_By>;
  questionsCount?: InputMaybe<Order_By>;
  totalXP?: InputMaybe<Order_By>;
  xpMultiplier?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Path_Stddev_Pop_Fields = {
  __typename?: 'path_stddev_pop_fields';
  _schemaVersion?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  leadersCount?: Maybe<Scalars['Float']>;
  questionsCount?: Maybe<Scalars['Float']>;
  totalXP?: Maybe<Scalars['Float']>;
  xpMultiplier?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "path" */
export type Path_Stddev_Pop_Order_By = {
  _schemaVersion?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  leadersCount?: InputMaybe<Order_By>;
  questionsCount?: InputMaybe<Order_By>;
  totalXP?: InputMaybe<Order_By>;
  xpMultiplier?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Path_Stddev_Samp_Fields = {
  __typename?: 'path_stddev_samp_fields';
  _schemaVersion?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  leadersCount?: Maybe<Scalars['Float']>;
  questionsCount?: Maybe<Scalars['Float']>;
  totalXP?: Maybe<Scalars['Float']>;
  xpMultiplier?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "path" */
export type Path_Stddev_Samp_Order_By = {
  _schemaVersion?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  leadersCount?: InputMaybe<Order_By>;
  questionsCount?: InputMaybe<Order_By>;
  totalXP?: InputMaybe<Order_By>;
  xpMultiplier?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "path" */
export type Path_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Path_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Path_Stream_Cursor_Value_Input = {
  _schemaVersion?: InputMaybe<Scalars['Int']>;
  authorId?: InputMaybe<Scalars['String']>;
  cover?: InputMaybe<Scalars['String']>;
  coverAnimated?: InputMaybe<Scalars['String']>;
  coverAnimatedFileId?: InputMaybe<Scalars['uuid']>;
  coverFileId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  firestoreId?: InputMaybe<Scalars['String']>;
  gradeLevels?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['bigint']>;
  interestArea?: InputMaybe<Scalars['String']>;
  isFeatured?: InputMaybe<Scalars['Boolean']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isTractOriginal?: InputMaybe<Scalars['Boolean']>;
  isVisibleUnauthed?: InputMaybe<Scalars['Boolean']>;
  leadersCount?: InputMaybe<Scalars['Int']>;
  media?: InputMaybe<Scalars['jsonb']>;
  missionsOrder?: InputMaybe<Scalars['jsonb']>;
  notified?: InputMaybe<Scalars['json']>;
  orgId?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  questionsCount?: InputMaybe<Scalars['Int']>;
  skills?: InputMaybe<Scalars['jsonb']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subjects?: InputMaybe<Scalars['jsonb']>;
  supplies?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  title?: InputMaybe<Scalars['String']>;
  totalXP?: InputMaybe<Scalars['Int']>;
  trailerFileId?: InputMaybe<Scalars['uuid']>;
  trailerUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  visibility?: InputMaybe<Scalars['String']>;
  xpMultiplier?: InputMaybe<Scalars['smallint']>;
};

/** aggregate sum on columns */
export type Path_Sum_Fields = {
  __typename?: 'path_sum_fields';
  _schemaVersion?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  leadersCount?: Maybe<Scalars['Int']>;
  questionsCount?: Maybe<Scalars['Int']>;
  totalXP?: Maybe<Scalars['Int']>;
  xpMultiplier?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "path" */
export type Path_Sum_Order_By = {
  _schemaVersion?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  leadersCount?: InputMaybe<Order_By>;
  questionsCount?: InputMaybe<Order_By>;
  totalXP?: InputMaybe<Order_By>;
  xpMultiplier?: InputMaybe<Order_By>;
};

/** update columns of table "path" */
export enum Path_Update_Column {
  /** column name */
  SchemaVersion = '_schemaVersion',
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  Cover = 'cover',
  /** column name */
  CoverAnimated = 'coverAnimated',
  /** column name */
  CoverAnimatedFileId = 'coverAnimatedFileId',
  /** column name */
  CoverFileId = 'coverFileId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  FirestoreId = 'firestoreId',
  /** column name */
  GradeLevels = 'gradeLevels',
  /** column name */
  Id = 'id',
  /** column name */
  InterestArea = 'interestArea',
  /** column name */
  IsFeatured = 'isFeatured',
  /** column name */
  IsPublished = 'isPublished',
  /** column name */
  IsTractOriginal = 'isTractOriginal',
  /** column name */
  IsVisibleUnauthed = 'isVisibleUnauthed',
  /** column name */
  LeadersCount = 'leadersCount',
  /** column name */
  Media = 'media',
  /** column name */
  MissionsOrder = 'missionsOrder',
  /** column name */
  Notified = 'notified',
  /** column name */
  OrgId = 'orgId',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  QuestionsCount = 'questionsCount',
  /** column name */
  Skills = 'skills',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  Subjects = 'subjects',
  /** column name */
  Supplies = 'supplies',
  /** column name */
  Tags = 'tags',
  /** column name */
  Title = 'title',
  /** column name */
  TotalXp = 'totalXP',
  /** column name */
  TrailerFileId = 'trailerFileId',
  /** column name */
  TrailerUrl = 'trailerUrl',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Visibility = 'visibility',
  /** column name */
  XpMultiplier = 'xpMultiplier'
}

export type Path_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Path_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Path_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Path_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Path_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Path_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Path_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Path_Set_Input>;
  where: Path_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Path_Var_Pop_Fields = {
  __typename?: 'path_var_pop_fields';
  _schemaVersion?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  leadersCount?: Maybe<Scalars['Float']>;
  questionsCount?: Maybe<Scalars['Float']>;
  totalXP?: Maybe<Scalars['Float']>;
  xpMultiplier?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "path" */
export type Path_Var_Pop_Order_By = {
  _schemaVersion?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  leadersCount?: InputMaybe<Order_By>;
  questionsCount?: InputMaybe<Order_By>;
  totalXP?: InputMaybe<Order_By>;
  xpMultiplier?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Path_Var_Samp_Fields = {
  __typename?: 'path_var_samp_fields';
  _schemaVersion?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  leadersCount?: Maybe<Scalars['Float']>;
  questionsCount?: Maybe<Scalars['Float']>;
  totalXP?: Maybe<Scalars['Float']>;
  xpMultiplier?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "path" */
export type Path_Var_Samp_Order_By = {
  _schemaVersion?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  leadersCount?: InputMaybe<Order_By>;
  questionsCount?: InputMaybe<Order_By>;
  totalXP?: InputMaybe<Order_By>;
  xpMultiplier?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Path_Variance_Fields = {
  __typename?: 'path_variance_fields';
  _schemaVersion?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  leadersCount?: Maybe<Scalars['Float']>;
  questionsCount?: Maybe<Scalars['Float']>;
  totalXP?: Maybe<Scalars['Float']>;
  xpMultiplier?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "path" */
export type Path_Variance_Order_By = {
  _schemaVersion?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  leadersCount?: InputMaybe<Order_By>;
  questionsCount?: InputMaybe<Order_By>;
  totalXP?: InputMaybe<Order_By>;
  xpMultiplier?: InputMaybe<Order_By>;
};

/** columns and relationships of "project" */
export type Project = {
  __typename?: 'project';
  /** An array relationship */
  awards: Array<Project_Award>;
  /** An aggregate relationship */
  awards_aggregate: Project_Award_Aggregate;
  /** An object relationship */
  challenge: Mission_Challenge;
  challengeId: Scalars['Int'];
  /** An array relationship */
  comments: Array<Project_Comment>;
  /** An aggregate relationship */
  comments_aggregate: Project_Comment_Aggregate;
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  file?: Maybe<User_File>;
  fileCaptureMethod: Scalars['String'];
  fileId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  isPrivate: Scalars['Boolean'];
  /** An object relationship */
  node?: Maybe<Path_Node>;
  pathNodeId?: Maybe<Scalars['uuid']>;
  published: Scalars['Boolean'];
  /** An array relationship */
  reactions: Array<Project_Reaction>;
  /** An aggregate relationship */
  reactions_aggregate: Project_Reaction_Aggregate;
  /** An object relationship */
  rejectCoin?: Maybe<Coin_Trx>;
  rejectCoinTrxId?: Maybe<Scalars['uuid']>;
  rejectedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  rejectedByUser?: Maybe<User>;
  rejectedByUserId?: Maybe<Scalars['String']>;
  rejectedFeedback?: Maybe<Scalars['String']>;
  rejectedReason?: Maybe<Scalars['String']>;
  /** An object relationship */
  rewardCoin?: Maybe<Coin_Trx>;
  rewardCoinTrxId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  stats?: Maybe<Project_Stats>;
  status: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userId: Scalars['String'];
};


/** columns and relationships of "project" */
export type ProjectAwardsArgs = {
  distinct_on?: InputMaybe<Array<Project_Award_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Award_Order_By>>;
  where?: InputMaybe<Project_Award_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectAwards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Award_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Award_Order_By>>;
  where?: InputMaybe<Project_Award_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectCommentsArgs = {
  distinct_on?: InputMaybe<Array<Project_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Comment_Order_By>>;
  where?: InputMaybe<Project_Comment_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Comment_Order_By>>;
  where?: InputMaybe<Project_Comment_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectReactionsArgs = {
  distinct_on?: InputMaybe<Array<Project_Reaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Reaction_Order_By>>;
  where?: InputMaybe<Project_Reaction_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectReactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Reaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Reaction_Order_By>>;
  where?: InputMaybe<Project_Reaction_Bool_Exp>;
};

/** aggregated selection of "project" */
export type Project_Aggregate = {
  __typename?: 'project_aggregate';
  aggregate?: Maybe<Project_Aggregate_Fields>;
  nodes: Array<Project>;
};

/** aggregate fields of "project" */
export type Project_Aggregate_Fields = {
  __typename?: 'project_aggregate_fields';
  avg?: Maybe<Project_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Max_Fields>;
  min?: Maybe<Project_Min_Fields>;
  stddev?: Maybe<Project_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Sum_Fields>;
  var_pop?: Maybe<Project_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Var_Samp_Fields>;
  variance?: Maybe<Project_Variance_Fields>;
};


/** aggregate fields of "project" */
export type Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project" */
export type Project_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Max_Order_By>;
  min?: InputMaybe<Project_Min_Order_By>;
  stddev?: InputMaybe<Project_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project" */
export type Project_Arr_Rel_Insert_Input = {
  data: Array<Project_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Avg_Fields = {
  __typename?: 'project_avg_fields';
  challengeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project" */
export type Project_Avg_Order_By = {
  challengeId?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_award" */
export type Project_Award = {
  __typename?: 'project_award';
  /** An object relationship */
  award: Award;
  awardId: Scalars['uuid'];
  count: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  projectId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "project_award" */
export type Project_Award_Aggregate = {
  __typename?: 'project_award_aggregate';
  aggregate?: Maybe<Project_Award_Aggregate_Fields>;
  nodes: Array<Project_Award>;
};

/** aggregate fields of "project_award" */
export type Project_Award_Aggregate_Fields = {
  __typename?: 'project_award_aggregate_fields';
  avg?: Maybe<Project_Award_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Award_Max_Fields>;
  min?: Maybe<Project_Award_Min_Fields>;
  stddev?: Maybe<Project_Award_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Award_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Award_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Award_Sum_Fields>;
  var_pop?: Maybe<Project_Award_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Award_Var_Samp_Fields>;
  variance?: Maybe<Project_Award_Variance_Fields>;
};


/** aggregate fields of "project_award" */
export type Project_Award_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Award_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_award" */
export type Project_Award_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Award_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Award_Max_Order_By>;
  min?: InputMaybe<Project_Award_Min_Order_By>;
  stddev?: InputMaybe<Project_Award_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Award_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Award_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Award_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Award_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Award_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Award_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_award" */
export type Project_Award_Arr_Rel_Insert_Input = {
  data: Array<Project_Award_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Award_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Award_Avg_Fields = {
  __typename?: 'project_award_avg_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_award" */
export type Project_Award_Avg_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_award". All fields are combined with a logical 'AND'. */
export type Project_Award_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Award_Bool_Exp>>;
  _not?: InputMaybe<Project_Award_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Award_Bool_Exp>>;
  award?: InputMaybe<Award_Bool_Exp>;
  awardId?: InputMaybe<Uuid_Comparison_Exp>;
  count?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_award" */
export enum Project_Award_Constraint {
  /** unique or primary key constraint on columns "project_id", "award_id" */
  ProjectAwardPkey = 'project_award_pkey'
}

/** input type for incrementing numeric columns in table "project_award" */
export type Project_Award_Inc_Input = {
  count?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_award" */
export type Project_Award_Insert_Input = {
  award?: InputMaybe<Award_Obj_Rel_Insert_Input>;
  awardId?: InputMaybe<Scalars['uuid']>;
  count?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  projectId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Project_Award_Max_Fields = {
  __typename?: 'project_award_max_fields';
  awardId?: Maybe<Scalars['uuid']>;
  count?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  projectId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "project_award" */
export type Project_Award_Max_Order_By = {
  awardId?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Award_Min_Fields = {
  __typename?: 'project_award_min_fields';
  awardId?: Maybe<Scalars['uuid']>;
  count?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  projectId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "project_award" */
export type Project_Award_Min_Order_By = {
  awardId?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_award" */
export type Project_Award_Mutation_Response = {
  __typename?: 'project_award_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Award>;
};

/** on_conflict condition type for table "project_award" */
export type Project_Award_On_Conflict = {
  constraint: Project_Award_Constraint;
  update_columns?: Array<Project_Award_Update_Column>;
  where?: InputMaybe<Project_Award_Bool_Exp>;
};

/** Ordering options when selecting data from "project_award". */
export type Project_Award_Order_By = {
  award?: InputMaybe<Award_Order_By>;
  awardId?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_award */
export type Project_Award_Pk_Columns_Input = {
  awardId: Scalars['uuid'];
  projectId: Scalars['uuid'];
};

/** select columns of table "project_award" */
export enum Project_Award_Select_Column {
  /** column name */
  AwardId = 'awardId',
  /** column name */
  Count = 'count',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "project_award" */
export type Project_Award_Set_Input = {
  awardId?: InputMaybe<Scalars['uuid']>;
  count?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  projectId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Project_Award_Stddev_Fields = {
  __typename?: 'project_award_stddev_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_award" */
export type Project_Award_Stddev_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Award_Stddev_Pop_Fields = {
  __typename?: 'project_award_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_award" */
export type Project_Award_Stddev_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Award_Stddev_Samp_Fields = {
  __typename?: 'project_award_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_award" */
export type Project_Award_Stddev_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_award" */
export type Project_Award_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Award_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Award_Stream_Cursor_Value_Input = {
  awardId?: InputMaybe<Scalars['uuid']>;
  count?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  projectId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Project_Award_Sum_Fields = {
  __typename?: 'project_award_sum_fields';
  count?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project_award" */
export type Project_Award_Sum_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** update columns of table "project_award" */
export enum Project_Award_Update_Column {
  /** column name */
  AwardId = 'awardId',
  /** column name */
  Count = 'count',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Project_Award_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Award_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Award_Set_Input>;
  where: Project_Award_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Award_Var_Pop_Fields = {
  __typename?: 'project_award_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_award" */
export type Project_Award_Var_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Award_Var_Samp_Fields = {
  __typename?: 'project_award_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_award" */
export type Project_Award_Var_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Award_Variance_Fields = {
  __typename?: 'project_award_variance_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_award" */
export type Project_Award_Variance_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project". All fields are combined with a logical 'AND'. */
export type Project_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Bool_Exp>>;
  _not?: InputMaybe<Project_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Bool_Exp>>;
  awards?: InputMaybe<Project_Award_Bool_Exp>;
  challenge?: InputMaybe<Mission_Challenge_Bool_Exp>;
  challengeId?: InputMaybe<Int_Comparison_Exp>;
  comments?: InputMaybe<Project_Comment_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<User_File_Bool_Exp>;
  fileCaptureMethod?: InputMaybe<String_Comparison_Exp>;
  fileId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isPrivate?: InputMaybe<Boolean_Comparison_Exp>;
  node?: InputMaybe<Path_Node_Bool_Exp>;
  pathNodeId?: InputMaybe<Uuid_Comparison_Exp>;
  published?: InputMaybe<Boolean_Comparison_Exp>;
  reactions?: InputMaybe<Project_Reaction_Bool_Exp>;
  rejectCoin?: InputMaybe<Coin_Trx_Bool_Exp>;
  rejectCoinTrxId?: InputMaybe<Uuid_Comparison_Exp>;
  rejectedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  rejectedByUser?: InputMaybe<User_Bool_Exp>;
  rejectedByUserId?: InputMaybe<String_Comparison_Exp>;
  rejectedFeedback?: InputMaybe<String_Comparison_Exp>;
  rejectedReason?: InputMaybe<String_Comparison_Exp>;
  rewardCoin?: InputMaybe<Coin_Trx_Bool_Exp>;
  rewardCoinTrxId?: InputMaybe<Uuid_Comparison_Exp>;
  stats?: InputMaybe<Project_Stats_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "project_comment" */
export type Project_Comment = {
  __typename?: 'project_comment';
  /** An object relationship */
  award?: Maybe<Award>;
  awardId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  comment: Comment;
  commentId: Scalars['uuid'];
  /** An object relationship */
  project: Project;
  projectId: Scalars['uuid'];
};

/** aggregated selection of "project_comment" */
export type Project_Comment_Aggregate = {
  __typename?: 'project_comment_aggregate';
  aggregate?: Maybe<Project_Comment_Aggregate_Fields>;
  nodes: Array<Project_Comment>;
};

/** aggregate fields of "project_comment" */
export type Project_Comment_Aggregate_Fields = {
  __typename?: 'project_comment_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Project_Comment_Max_Fields>;
  min?: Maybe<Project_Comment_Min_Fields>;
};


/** aggregate fields of "project_comment" */
export type Project_Comment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Comment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_comment" */
export type Project_Comment_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Comment_Max_Order_By>;
  min?: InputMaybe<Project_Comment_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_comment" */
export type Project_Comment_Arr_Rel_Insert_Input = {
  data: Array<Project_Comment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Comment_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_comment". All fields are combined with a logical 'AND'. */
export type Project_Comment_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Comment_Bool_Exp>>;
  _not?: InputMaybe<Project_Comment_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Comment_Bool_Exp>>;
  award?: InputMaybe<Award_Bool_Exp>;
  awardId?: InputMaybe<Uuid_Comparison_Exp>;
  comment?: InputMaybe<Comment_Bool_Exp>;
  commentId?: InputMaybe<Uuid_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_comment" */
export enum Project_Comment_Constraint {
  /** unique or primary key constraint on columns "comment_id" */
  ProjectCommentPkey = 'project_comment_pkey'
}

/** input type for inserting data into table "project_comment" */
export type Project_Comment_Insert_Input = {
  award?: InputMaybe<Award_Obj_Rel_Insert_Input>;
  awardId?: InputMaybe<Scalars['uuid']>;
  comment?: InputMaybe<Comment_Obj_Rel_Insert_Input>;
  commentId?: InputMaybe<Scalars['uuid']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Project_Comment_Max_Fields = {
  __typename?: 'project_comment_max_fields';
  awardId?: Maybe<Scalars['uuid']>;
  commentId?: Maybe<Scalars['uuid']>;
  projectId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "project_comment" */
export type Project_Comment_Max_Order_By = {
  awardId?: InputMaybe<Order_By>;
  commentId?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Comment_Min_Fields = {
  __typename?: 'project_comment_min_fields';
  awardId?: Maybe<Scalars['uuid']>;
  commentId?: Maybe<Scalars['uuid']>;
  projectId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "project_comment" */
export type Project_Comment_Min_Order_By = {
  awardId?: InputMaybe<Order_By>;
  commentId?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_comment" */
export type Project_Comment_Mutation_Response = {
  __typename?: 'project_comment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Comment>;
};

/** input type for inserting object relation for remote table "project_comment" */
export type Project_Comment_Obj_Rel_Insert_Input = {
  data: Project_Comment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Comment_On_Conflict>;
};

/** on_conflict condition type for table "project_comment" */
export type Project_Comment_On_Conflict = {
  constraint: Project_Comment_Constraint;
  update_columns?: Array<Project_Comment_Update_Column>;
  where?: InputMaybe<Project_Comment_Bool_Exp>;
};

/** Ordering options when selecting data from "project_comment". */
export type Project_Comment_Order_By = {
  award?: InputMaybe<Award_Order_By>;
  awardId?: InputMaybe<Order_By>;
  comment?: InputMaybe<Comment_Order_By>;
  commentId?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_comment */
export type Project_Comment_Pk_Columns_Input = {
  commentId: Scalars['uuid'];
};

/** select columns of table "project_comment" */
export enum Project_Comment_Select_Column {
  /** column name */
  AwardId = 'awardId',
  /** column name */
  CommentId = 'commentId',
  /** column name */
  ProjectId = 'projectId'
}

/** input type for updating data in table "project_comment" */
export type Project_Comment_Set_Input = {
  awardId?: InputMaybe<Scalars['uuid']>;
  commentId?: InputMaybe<Scalars['uuid']>;
  projectId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "project_comment" */
export type Project_Comment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Comment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Comment_Stream_Cursor_Value_Input = {
  awardId?: InputMaybe<Scalars['uuid']>;
  commentId?: InputMaybe<Scalars['uuid']>;
  projectId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "project_comment" */
export enum Project_Comment_Update_Column {
  /** column name */
  AwardId = 'awardId',
  /** column name */
  CommentId = 'commentId',
  /** column name */
  ProjectId = 'projectId'
}

export type Project_Comment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Comment_Set_Input>;
  where: Project_Comment_Bool_Exp;
};

/** unique or primary key constraints on table "project" */
export enum Project_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectPkey = 'project_pkey',
  /** unique or primary key constraint on columns "rejected_at", "user_id", "path_node_id" */
  ProjectUniqueByPathNodeRejectedAt = 'project_unique_by_path_node_rejected_at'
}

/** input type for incrementing numeric columns in table "project" */
export type Project_Inc_Input = {
  challengeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "project" */
export type Project_Insert_Input = {
  awards?: InputMaybe<Project_Award_Arr_Rel_Insert_Input>;
  challenge?: InputMaybe<Mission_Challenge_Obj_Rel_Insert_Input>;
  challengeId?: InputMaybe<Scalars['Int']>;
  comments?: InputMaybe<Project_Comment_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  file?: InputMaybe<User_File_Obj_Rel_Insert_Input>;
  fileCaptureMethod?: InputMaybe<Scalars['String']>;
  fileId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  node?: InputMaybe<Path_Node_Obj_Rel_Insert_Input>;
  pathNodeId?: InputMaybe<Scalars['uuid']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reactions?: InputMaybe<Project_Reaction_Arr_Rel_Insert_Input>;
  rejectCoin?: InputMaybe<Coin_Trx_Obj_Rel_Insert_Input>;
  rejectCoinTrxId?: InputMaybe<Scalars['uuid']>;
  rejectedAt?: InputMaybe<Scalars['timestamptz']>;
  rejectedByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
  rejectedByUserId?: InputMaybe<Scalars['String']>;
  rejectedFeedback?: InputMaybe<Scalars['String']>;
  rejectedReason?: InputMaybe<Scalars['String']>;
  rewardCoin?: InputMaybe<Coin_Trx_Obj_Rel_Insert_Input>;
  rewardCoinTrxId?: InputMaybe<Scalars['uuid']>;
  stats?: InputMaybe<Project_Stats_Obj_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Max_Fields = {
  __typename?: 'project_max_fields';
  challengeId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  fileCaptureMethod?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  pathNodeId?: Maybe<Scalars['uuid']>;
  rejectCoinTrxId?: Maybe<Scalars['uuid']>;
  rejectedAt?: Maybe<Scalars['timestamptz']>;
  rejectedByUserId?: Maybe<Scalars['String']>;
  rejectedFeedback?: Maybe<Scalars['String']>;
  rejectedReason?: Maybe<Scalars['String']>;
  rewardCoinTrxId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "project" */
export type Project_Max_Order_By = {
  challengeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  fileCaptureMethod?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pathNodeId?: InputMaybe<Order_By>;
  rejectCoinTrxId?: InputMaybe<Order_By>;
  rejectedAt?: InputMaybe<Order_By>;
  rejectedByUserId?: InputMaybe<Order_By>;
  rejectedFeedback?: InputMaybe<Order_By>;
  rejectedReason?: InputMaybe<Order_By>;
  rewardCoinTrxId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Min_Fields = {
  __typename?: 'project_min_fields';
  challengeId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  fileCaptureMethod?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  pathNodeId?: Maybe<Scalars['uuid']>;
  rejectCoinTrxId?: Maybe<Scalars['uuid']>;
  rejectedAt?: Maybe<Scalars['timestamptz']>;
  rejectedByUserId?: Maybe<Scalars['String']>;
  rejectedFeedback?: Maybe<Scalars['String']>;
  rejectedReason?: Maybe<Scalars['String']>;
  rewardCoinTrxId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "project" */
export type Project_Min_Order_By = {
  challengeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  fileCaptureMethod?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pathNodeId?: InputMaybe<Order_By>;
  rejectCoinTrxId?: InputMaybe<Order_By>;
  rejectedAt?: InputMaybe<Order_By>;
  rejectedByUserId?: InputMaybe<Order_By>;
  rejectedFeedback?: InputMaybe<Order_By>;
  rejectedReason?: InputMaybe<Order_By>;
  rewardCoinTrxId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project" */
export type Project_Mutation_Response = {
  __typename?: 'project_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project>;
};

/** input type for inserting object relation for remote table "project" */
export type Project_Obj_Rel_Insert_Input = {
  data: Project_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_On_Conflict>;
};

/** on_conflict condition type for table "project" */
export type Project_On_Conflict = {
  constraint: Project_Constraint;
  update_columns?: Array<Project_Update_Column>;
  where?: InputMaybe<Project_Bool_Exp>;
};

/** Ordering options when selecting data from "project". */
export type Project_Order_By = {
  awards_aggregate?: InputMaybe<Project_Award_Aggregate_Order_By>;
  challenge?: InputMaybe<Mission_Challenge_Order_By>;
  challengeId?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<Project_Comment_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  file?: InputMaybe<User_File_Order_By>;
  fileCaptureMethod?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isPrivate?: InputMaybe<Order_By>;
  node?: InputMaybe<Path_Node_Order_By>;
  pathNodeId?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  reactions_aggregate?: InputMaybe<Project_Reaction_Aggregate_Order_By>;
  rejectCoin?: InputMaybe<Coin_Trx_Order_By>;
  rejectCoinTrxId?: InputMaybe<Order_By>;
  rejectedAt?: InputMaybe<Order_By>;
  rejectedByUser?: InputMaybe<User_Order_By>;
  rejectedByUserId?: InputMaybe<Order_By>;
  rejectedFeedback?: InputMaybe<Order_By>;
  rejectedReason?: InputMaybe<Order_By>;
  rewardCoin?: InputMaybe<Coin_Trx_Order_By>;
  rewardCoinTrxId?: InputMaybe<Order_By>;
  stats?: InputMaybe<Project_Stats_Order_By>;
  status?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project */
export type Project_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "project_reaction" */
export type Project_Reaction = {
  __typename?: 'project_reaction';
  count: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  project: Project;
  projectId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userId: Scalars['String'];
};

/** aggregated selection of "project_reaction" */
export type Project_Reaction_Aggregate = {
  __typename?: 'project_reaction_aggregate';
  aggregate?: Maybe<Project_Reaction_Aggregate_Fields>;
  nodes: Array<Project_Reaction>;
};

/** aggregate fields of "project_reaction" */
export type Project_Reaction_Aggregate_Fields = {
  __typename?: 'project_reaction_aggregate_fields';
  avg?: Maybe<Project_Reaction_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Reaction_Max_Fields>;
  min?: Maybe<Project_Reaction_Min_Fields>;
  stddev?: Maybe<Project_Reaction_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Reaction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Reaction_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Reaction_Sum_Fields>;
  var_pop?: Maybe<Project_Reaction_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Reaction_Var_Samp_Fields>;
  variance?: Maybe<Project_Reaction_Variance_Fields>;
};


/** aggregate fields of "project_reaction" */
export type Project_Reaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Reaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_reaction" */
export type Project_Reaction_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Reaction_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Reaction_Max_Order_By>;
  min?: InputMaybe<Project_Reaction_Min_Order_By>;
  stddev?: InputMaybe<Project_Reaction_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Reaction_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Reaction_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Reaction_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Reaction_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Reaction_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Reaction_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_reaction" */
export type Project_Reaction_Arr_Rel_Insert_Input = {
  data: Array<Project_Reaction_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Reaction_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Reaction_Avg_Fields = {
  __typename?: 'project_reaction_avg_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_reaction" */
export type Project_Reaction_Avg_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_reaction". All fields are combined with a logical 'AND'. */
export type Project_Reaction_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Reaction_Bool_Exp>>;
  _not?: InputMaybe<Project_Reaction_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Reaction_Bool_Exp>>;
  count?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_reaction" */
export enum Project_Reaction_Constraint {
  /** unique or primary key constraint on columns "project_id", "user_id" */
  ProjectReactionPkey = 'project_reaction_pkey'
}

/** input type for incrementing numeric columns in table "project_reaction" */
export type Project_Reaction_Inc_Input = {
  count?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_reaction" */
export type Project_Reaction_Insert_Input = {
  count?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Reaction_Max_Fields = {
  __typename?: 'project_reaction_max_fields';
  count?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  projectId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "project_reaction" */
export type Project_Reaction_Max_Order_By = {
  count?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Reaction_Min_Fields = {
  __typename?: 'project_reaction_min_fields';
  count?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  projectId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "project_reaction" */
export type Project_Reaction_Min_Order_By = {
  count?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_reaction" */
export type Project_Reaction_Mutation_Response = {
  __typename?: 'project_reaction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Reaction>;
};

/** on_conflict condition type for table "project_reaction" */
export type Project_Reaction_On_Conflict = {
  constraint: Project_Reaction_Constraint;
  update_columns?: Array<Project_Reaction_Update_Column>;
  where?: InputMaybe<Project_Reaction_Bool_Exp>;
};

/** Ordering options when selecting data from "project_reaction". */
export type Project_Reaction_Order_By = {
  count?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_reaction */
export type Project_Reaction_Pk_Columns_Input = {
  projectId: Scalars['uuid'];
  userId: Scalars['String'];
};

/** select columns of table "project_reaction" */
export enum Project_Reaction_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "project_reaction" */
export type Project_Reaction_Set_Input = {
  count?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  projectId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Project_Reaction_Stddev_Fields = {
  __typename?: 'project_reaction_stddev_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_reaction" */
export type Project_Reaction_Stddev_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Reaction_Stddev_Pop_Fields = {
  __typename?: 'project_reaction_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_reaction" */
export type Project_Reaction_Stddev_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Reaction_Stddev_Samp_Fields = {
  __typename?: 'project_reaction_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_reaction" */
export type Project_Reaction_Stddev_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_reaction" */
export type Project_Reaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Reaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Reaction_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  projectId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Project_Reaction_Sum_Fields = {
  __typename?: 'project_reaction_sum_fields';
  count?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project_reaction" */
export type Project_Reaction_Sum_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** update columns of table "project_reaction" */
export enum Project_Reaction_Update_Column {
  /** column name */
  Count = 'count',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Project_Reaction_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Reaction_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Reaction_Set_Input>;
  where: Project_Reaction_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Reaction_Var_Pop_Fields = {
  __typename?: 'project_reaction_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_reaction" */
export type Project_Reaction_Var_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Reaction_Var_Samp_Fields = {
  __typename?: 'project_reaction_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_reaction" */
export type Project_Reaction_Var_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Reaction_Variance_Fields = {
  __typename?: 'project_reaction_variance_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_reaction" */
export type Project_Reaction_Variance_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** select columns of table "project" */
export enum Project_Select_Column {
  /** column name */
  ChallengeId = 'challengeId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileCaptureMethod = 'fileCaptureMethod',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrivate = 'isPrivate',
  /** column name */
  PathNodeId = 'pathNodeId',
  /** column name */
  Published = 'published',
  /** column name */
  RejectCoinTrxId = 'rejectCoinTrxId',
  /** column name */
  RejectedAt = 'rejectedAt',
  /** column name */
  RejectedByUserId = 'rejectedByUserId',
  /** column name */
  RejectedFeedback = 'rejectedFeedback',
  /** column name */
  RejectedReason = 'rejectedReason',
  /** column name */
  RewardCoinTrxId = 'rewardCoinTrxId',
  /** column name */
  Status = 'status',
  /** column name */
  Text = 'text',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "project" */
export type Project_Set_Input = {
  challengeId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fileCaptureMethod?: InputMaybe<Scalars['String']>;
  fileId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  pathNodeId?: InputMaybe<Scalars['uuid']>;
  published?: InputMaybe<Scalars['Boolean']>;
  rejectCoinTrxId?: InputMaybe<Scalars['uuid']>;
  rejectedAt?: InputMaybe<Scalars['timestamptz']>;
  rejectedByUserId?: InputMaybe<Scalars['String']>;
  rejectedFeedback?: InputMaybe<Scalars['String']>;
  rejectedReason?: InputMaybe<Scalars['String']>;
  rewardCoinTrxId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "project_stats" */
export type Project_Stats = {
  __typename?: 'project_stats';
  awesomeScore: Scalars['numeric'];
  bestScore: Scalars['numeric'];
  commentCount: Scalars['Int'];
  likeCount: Scalars['Int'];
  /** An object relationship */
  project: Project;
  projectId: Scalars['uuid'];
  viewCount: Scalars['Int'];
};

/** aggregated selection of "project_stats" */
export type Project_Stats_Aggregate = {
  __typename?: 'project_stats_aggregate';
  aggregate?: Maybe<Project_Stats_Aggregate_Fields>;
  nodes: Array<Project_Stats>;
};

/** aggregate fields of "project_stats" */
export type Project_Stats_Aggregate_Fields = {
  __typename?: 'project_stats_aggregate_fields';
  avg?: Maybe<Project_Stats_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Stats_Max_Fields>;
  min?: Maybe<Project_Stats_Min_Fields>;
  stddev?: Maybe<Project_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Stats_Sum_Fields>;
  var_pop?: Maybe<Project_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Stats_Var_Samp_Fields>;
  variance?: Maybe<Project_Stats_Variance_Fields>;
};


/** aggregate fields of "project_stats" */
export type Project_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Project_Stats_Avg_Fields = {
  __typename?: 'project_stats_avg_fields';
  awesomeScore?: Maybe<Scalars['Float']>;
  bestScore?: Maybe<Scalars['Float']>;
  commentCount?: Maybe<Scalars['Float']>;
  likeCount?: Maybe<Scalars['Float']>;
  viewCount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "project_stats". All fields are combined with a logical 'AND'. */
export type Project_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Stats_Bool_Exp>>;
  _not?: InputMaybe<Project_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Stats_Bool_Exp>>;
  awesomeScore?: InputMaybe<Numeric_Comparison_Exp>;
  bestScore?: InputMaybe<Numeric_Comparison_Exp>;
  commentCount?: InputMaybe<Int_Comparison_Exp>;
  likeCount?: InputMaybe<Int_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  viewCount?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_stats" */
export enum Project_Stats_Constraint {
  /** unique or primary key constraint on columns "project_id" */
  ProjectStatsPkey = 'project_stats_pkey'
}

/** input type for incrementing numeric columns in table "project_stats" */
export type Project_Stats_Inc_Input = {
  awesomeScore?: InputMaybe<Scalars['numeric']>;
  bestScore?: InputMaybe<Scalars['numeric']>;
  commentCount?: InputMaybe<Scalars['Int']>;
  likeCount?: InputMaybe<Scalars['Int']>;
  viewCount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_stats" */
export type Project_Stats_Insert_Input = {
  awesomeScore?: InputMaybe<Scalars['numeric']>;
  bestScore?: InputMaybe<Scalars['numeric']>;
  commentCount?: InputMaybe<Scalars['Int']>;
  likeCount?: InputMaybe<Scalars['Int']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']>;
  viewCount?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Project_Stats_Max_Fields = {
  __typename?: 'project_stats_max_fields';
  awesomeScore?: Maybe<Scalars['numeric']>;
  bestScore?: Maybe<Scalars['numeric']>;
  commentCount?: Maybe<Scalars['Int']>;
  likeCount?: Maybe<Scalars['Int']>;
  projectId?: Maybe<Scalars['uuid']>;
  viewCount?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Project_Stats_Min_Fields = {
  __typename?: 'project_stats_min_fields';
  awesomeScore?: Maybe<Scalars['numeric']>;
  bestScore?: Maybe<Scalars['numeric']>;
  commentCount?: Maybe<Scalars['Int']>;
  likeCount?: Maybe<Scalars['Int']>;
  projectId?: Maybe<Scalars['uuid']>;
  viewCount?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "project_stats" */
export type Project_Stats_Mutation_Response = {
  __typename?: 'project_stats_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Stats>;
};

/** input type for inserting object relation for remote table "project_stats" */
export type Project_Stats_Obj_Rel_Insert_Input = {
  data: Project_Stats_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Stats_On_Conflict>;
};

/** on_conflict condition type for table "project_stats" */
export type Project_Stats_On_Conflict = {
  constraint: Project_Stats_Constraint;
  update_columns?: Array<Project_Stats_Update_Column>;
  where?: InputMaybe<Project_Stats_Bool_Exp>;
};

/** Ordering options when selecting data from "project_stats". */
export type Project_Stats_Order_By = {
  awesomeScore?: InputMaybe<Order_By>;
  bestScore?: InputMaybe<Order_By>;
  commentCount?: InputMaybe<Order_By>;
  likeCount?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  viewCount?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_stats */
export type Project_Stats_Pk_Columns_Input = {
  projectId: Scalars['uuid'];
};

/** select columns of table "project_stats" */
export enum Project_Stats_Select_Column {
  /** column name */
  AwesomeScore = 'awesomeScore',
  /** column name */
  BestScore = 'bestScore',
  /** column name */
  CommentCount = 'commentCount',
  /** column name */
  LikeCount = 'likeCount',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  ViewCount = 'viewCount'
}

/** input type for updating data in table "project_stats" */
export type Project_Stats_Set_Input = {
  awesomeScore?: InputMaybe<Scalars['numeric']>;
  bestScore?: InputMaybe<Scalars['numeric']>;
  commentCount?: InputMaybe<Scalars['Int']>;
  likeCount?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['uuid']>;
  viewCount?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Project_Stats_Stddev_Fields = {
  __typename?: 'project_stats_stddev_fields';
  awesomeScore?: Maybe<Scalars['Float']>;
  bestScore?: Maybe<Scalars['Float']>;
  commentCount?: Maybe<Scalars['Float']>;
  likeCount?: Maybe<Scalars['Float']>;
  viewCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Project_Stats_Stddev_Pop_Fields = {
  __typename?: 'project_stats_stddev_pop_fields';
  awesomeScore?: Maybe<Scalars['Float']>;
  bestScore?: Maybe<Scalars['Float']>;
  commentCount?: Maybe<Scalars['Float']>;
  likeCount?: Maybe<Scalars['Float']>;
  viewCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Project_Stats_Stddev_Samp_Fields = {
  __typename?: 'project_stats_stddev_samp_fields';
  awesomeScore?: Maybe<Scalars['Float']>;
  bestScore?: Maybe<Scalars['Float']>;
  commentCount?: Maybe<Scalars['Float']>;
  likeCount?: Maybe<Scalars['Float']>;
  viewCount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "project_stats" */
export type Project_Stats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Stats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Stats_Stream_Cursor_Value_Input = {
  awesomeScore?: InputMaybe<Scalars['numeric']>;
  bestScore?: InputMaybe<Scalars['numeric']>;
  commentCount?: InputMaybe<Scalars['Int']>;
  likeCount?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['uuid']>;
  viewCount?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Project_Stats_Sum_Fields = {
  __typename?: 'project_stats_sum_fields';
  awesomeScore?: Maybe<Scalars['numeric']>;
  bestScore?: Maybe<Scalars['numeric']>;
  commentCount?: Maybe<Scalars['Int']>;
  likeCount?: Maybe<Scalars['Int']>;
  viewCount?: Maybe<Scalars['Int']>;
};

/** update columns of table "project_stats" */
export enum Project_Stats_Update_Column {
  /** column name */
  AwesomeScore = 'awesomeScore',
  /** column name */
  BestScore = 'bestScore',
  /** column name */
  CommentCount = 'commentCount',
  /** column name */
  LikeCount = 'likeCount',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  ViewCount = 'viewCount'
}

export type Project_Stats_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Stats_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Stats_Set_Input>;
  where: Project_Stats_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Stats_Var_Pop_Fields = {
  __typename?: 'project_stats_var_pop_fields';
  awesomeScore?: Maybe<Scalars['Float']>;
  bestScore?: Maybe<Scalars['Float']>;
  commentCount?: Maybe<Scalars['Float']>;
  likeCount?: Maybe<Scalars['Float']>;
  viewCount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Project_Stats_Var_Samp_Fields = {
  __typename?: 'project_stats_var_samp_fields';
  awesomeScore?: Maybe<Scalars['Float']>;
  bestScore?: Maybe<Scalars['Float']>;
  commentCount?: Maybe<Scalars['Float']>;
  likeCount?: Maybe<Scalars['Float']>;
  viewCount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Project_Stats_Variance_Fields = {
  __typename?: 'project_stats_variance_fields';
  awesomeScore?: Maybe<Scalars['Float']>;
  bestScore?: Maybe<Scalars['Float']>;
  commentCount?: Maybe<Scalars['Float']>;
  likeCount?: Maybe<Scalars['Float']>;
  viewCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type Project_Stddev_Fields = {
  __typename?: 'project_stddev_fields';
  challengeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project" */
export type Project_Stddev_Order_By = {
  challengeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Stddev_Pop_Fields = {
  __typename?: 'project_stddev_pop_fields';
  challengeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project" */
export type Project_Stddev_Pop_Order_By = {
  challengeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Stddev_Samp_Fields = {
  __typename?: 'project_stddev_samp_fields';
  challengeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project" */
export type Project_Stddev_Samp_Order_By = {
  challengeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project" */
export type Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Stream_Cursor_Value_Input = {
  challengeId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fileCaptureMethod?: InputMaybe<Scalars['String']>;
  fileId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  pathNodeId?: InputMaybe<Scalars['uuid']>;
  published?: InputMaybe<Scalars['Boolean']>;
  rejectCoinTrxId?: InputMaybe<Scalars['uuid']>;
  rejectedAt?: InputMaybe<Scalars['timestamptz']>;
  rejectedByUserId?: InputMaybe<Scalars['String']>;
  rejectedFeedback?: InputMaybe<Scalars['String']>;
  rejectedReason?: InputMaybe<Scalars['String']>;
  rewardCoinTrxId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Project_Sum_Fields = {
  __typename?: 'project_sum_fields';
  challengeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project" */
export type Project_Sum_Order_By = {
  challengeId?: InputMaybe<Order_By>;
};

/** update columns of table "project" */
export enum Project_Update_Column {
  /** column name */
  ChallengeId = 'challengeId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileCaptureMethod = 'fileCaptureMethod',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrivate = 'isPrivate',
  /** column name */
  PathNodeId = 'pathNodeId',
  /** column name */
  Published = 'published',
  /** column name */
  RejectCoinTrxId = 'rejectCoinTrxId',
  /** column name */
  RejectedAt = 'rejectedAt',
  /** column name */
  RejectedByUserId = 'rejectedByUserId',
  /** column name */
  RejectedFeedback = 'rejectedFeedback',
  /** column name */
  RejectedReason = 'rejectedReason',
  /** column name */
  RewardCoinTrxId = 'rewardCoinTrxId',
  /** column name */
  Status = 'status',
  /** column name */
  Text = 'text',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Project_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Set_Input>;
  where: Project_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Var_Pop_Fields = {
  __typename?: 'project_var_pop_fields';
  challengeId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project" */
export type Project_Var_Pop_Order_By = {
  challengeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Var_Samp_Fields = {
  __typename?: 'project_var_samp_fields';
  challengeId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project" */
export type Project_Var_Samp_Order_By = {
  challengeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Variance_Fields = {
  __typename?: 'project_variance_fields';
  challengeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project" */
export type Project_Variance_Order_By = {
  challengeId?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename?: 'query_root';
  api_get_onboarded_orgs: Array<Org>;
  api_get_video_backdrops: Array<Video_Backdrop>;
  /** fetch data from the table: "assignment" */
  assignment: Array<Assignment>;
  /** fetch aggregated fields from the table: "assignment" */
  assignment_aggregate: Assignment_Aggregate;
  /** fetch data from the table: "assignment" using primary key columns */
  assignment_by_pk?: Maybe<Assignment>;
  /** fetch data from the table: "assignment_learner_group" */
  assignment_learner_group: Array<Assignment_Learner_Group>;
  /** fetch aggregated fields from the table: "assignment_learner_group" */
  assignment_learner_group_aggregate: Assignment_Learner_Group_Aggregate;
  /** fetch data from the table: "assignment_learner_group" using primary key columns */
  assignment_learner_group_by_pk?: Maybe<Assignment_Learner_Group>;
  /** fetch data from the table: "assignment_path" */
  assignment_path: Array<Assignment_Path>;
  /** fetch aggregated fields from the table: "assignment_path" */
  assignment_path_aggregate: Assignment_Path_Aggregate;
  /** fetch data from the table: "assignment_path" using primary key columns */
  assignment_path_by_pk?: Maybe<Assignment_Path>;
  /** fetch data from the table: "award" */
  award: Array<Award>;
  /** fetch aggregated fields from the table: "award" */
  award_aggregate: Award_Aggregate;
  /** fetch data from the table: "award" using primary key columns */
  award_by_pk?: Maybe<Award>;
  circle_posts: Array<CirclePost>;
  circle_space_groups: Array<CircleSpaceGroup>;
  circle_spaces: Array<CircleSpace>;
  /** fetch data from the table: "coin_trx" */
  coin_trx: Array<Coin_Trx>;
  /** fetch aggregated fields from the table: "coin_trx" */
  coin_trx_aggregate: Coin_Trx_Aggregate;
  /** fetch data from the table: "coin_trx" using primary key columns */
  coin_trx_by_pk?: Maybe<Coin_Trx>;
  /** fetch data from the table: "comment" */
  comment: Array<Comment>;
  /** fetch aggregated fields from the table: "comment" */
  comment_aggregate: Comment_Aggregate;
  /** fetch data from the table: "comment" using primary key columns */
  comment_by_pk?: Maybe<Comment>;
  /** fetch data from the table: "educator_code" */
  educator_code: Array<Educator_Code>;
  /** fetch aggregated fields from the table: "educator_code" */
  educator_code_aggregate: Educator_Code_Aggregate;
  /** fetch data from the table: "educator_code" using primary key columns */
  educator_code_by_pk?: Maybe<Educator_Code>;
  /** fetch data from the table: "educator_code_redemption" */
  educator_code_redemption: Array<Educator_Code_Redemption>;
  /** fetch aggregated fields from the table: "educator_code_redemption" */
  educator_code_redemption_aggregate: Educator_Code_Redemption_Aggregate;
  /** fetch data from the table: "educator_code_redemption" using primary key columns */
  educator_code_redemption_by_pk?: Maybe<Educator_Code_Redemption>;
  /** fetch data from the table: "enums.coin_trx_category" */
  enums_coin_trx_category: Array<Enums_Coin_Trx_Category>;
  /** fetch aggregated fields from the table: "enums.coin_trx_category" */
  enums_coin_trx_category_aggregate: Enums_Coin_Trx_Category_Aggregate;
  /** fetch data from the table: "enums.coin_trx_category" using primary key columns */
  enums_coin_trx_category_by_pk?: Maybe<Enums_Coin_Trx_Category>;
  /** fetch data from the table: "enums.integration_provider" */
  enums_integration_provider: Array<Enums_Integration_Provider>;
  /** fetch aggregated fields from the table: "enums.integration_provider" */
  enums_integration_provider_aggregate: Enums_Integration_Provider_Aggregate;
  /** fetch data from the table: "enums.integration_provider" using primary key columns */
  enums_integration_provider_by_pk?: Maybe<Enums_Integration_Provider>;
  /** fetch data from the table: "enums.project_status" */
  enums_project_status: Array<Enums_Project_Status>;
  /** fetch aggregated fields from the table: "enums.project_status" */
  enums_project_status_aggregate: Enums_Project_Status_Aggregate;
  /** fetch data from the table: "enums.project_status" using primary key columns */
  enums_project_status_by_pk?: Maybe<Enums_Project_Status>;
  /** fetch data from the table: "guide" */
  guide: Array<Guide>;
  /** fetch aggregated fields from the table: "guide" */
  guide_aggregate: Guide_Aggregate;
  /** fetch data from the table: "guide" using primary key columns */
  guide_by_pk?: Maybe<Guide>;
  /** fetch data from the table: "guide_path" */
  guide_path: Array<Guide_Path>;
  /** fetch aggregated fields from the table: "guide_path" */
  guide_path_aggregate: Guide_Path_Aggregate;
  /** fetch data from the table: "guide_path" using primary key columns */
  guide_path_by_pk?: Maybe<Guide_Path>;
  /** fetch data from the table: "learner_group" */
  learner_group: Array<Learner_Group>;
  /** fetch aggregated fields from the table: "learner_group" */
  learner_group_aggregate: Learner_Group_Aggregate;
  /** fetch data from the table: "learner_group" using primary key columns */
  learner_group_by_pk?: Maybe<Learner_Group>;
  /** fetch data from the table: "learner_group_member" */
  learner_group_member: Array<Learner_Group_Member>;
  /** fetch aggregated fields from the table: "learner_group_member" */
  learner_group_member_aggregate: Learner_Group_Member_Aggregate;
  /** fetch data from the table: "learner_group_member" using primary key columns */
  learner_group_member_by_pk?: Maybe<Learner_Group_Member>;
  /** fetch data from the table: "learner_group_path_collection" */
  learner_group_path_collection: Array<Learner_Group_Path_Collection>;
  /** fetch aggregated fields from the table: "learner_group_path_collection" */
  learner_group_path_collection_aggregate: Learner_Group_Path_Collection_Aggregate;
  /** fetch data from the table: "learner_group_path_collection" using primary key columns */
  learner_group_path_collection_by_pk?: Maybe<Learner_Group_Path_Collection>;
  /** fetch data from the table: "learner_group_pending_member" */
  learner_group_pending_member: Array<Learner_Group_Pending_Member>;
  /** fetch aggregated fields from the table: "learner_group_pending_member" */
  learner_group_pending_member_aggregate: Learner_Group_Pending_Member_Aggregate;
  /** fetch data from the table: "learner_group_pending_member" using primary key columns */
  learner_group_pending_member_by_pk?: Maybe<Learner_Group_Pending_Member>;
  /** execute function "list_latest_path_reviews" which returns "path_review" */
  list_latest_path_reviews: Array<Path_Review>;
  /** execute function "list_latest_path_reviews" and query aggregates on result of table type "path_review" */
  list_latest_path_reviews_aggregate: Path_Review_Aggregate;
  /** fetch data from the table: "livestream" */
  livestream: Array<Livestream>;
  /** fetch aggregated fields from the table: "livestream" */
  livestream_aggregate: Livestream_Aggregate;
  /** fetch data from the table: "livestream" using primary key columns */
  livestream_by_pk?: Maybe<Livestream>;
  /** fetch data from the table: "lms" */
  lms: Array<Lms>;
  /** fetch aggregated fields from the table: "lms" */
  lms_aggregate: Lms_Aggregate;
  /** fetch data from the table: "lms" using primary key columns */
  lms_by_pk?: Maybe<Lms>;
  /** fetch data from the table: "mission" */
  mission: Array<Mission>;
  /** fetch aggregated fields from the table: "mission" */
  mission_aggregate: Mission_Aggregate;
  /** fetch data from the table: "mission_attachment" */
  mission_attachment: Array<Mission_Attachment>;
  /** fetch aggregated fields from the table: "mission_attachment" */
  mission_attachment_aggregate: Mission_Attachment_Aggregate;
  /** fetch data from the table: "mission_attachment" using primary key columns */
  mission_attachment_by_pk?: Maybe<Mission_Attachment>;
  /** fetch data from the table: "mission" using primary key columns */
  mission_by_pk?: Maybe<Mission>;
  /** fetch data from the table: "mission_challenge" */
  mission_challenge: Array<Mission_Challenge>;
  /** fetch aggregated fields from the table: "mission_challenge" */
  mission_challenge_aggregate: Mission_Challenge_Aggregate;
  /** fetch data from the table: "mission_challenge" using primary key columns */
  mission_challenge_by_pk?: Maybe<Mission_Challenge>;
  /** fetch data from the table: "mission_comment" */
  mission_comment: Array<Mission_Comment>;
  /** fetch aggregated fields from the table: "mission_comment" */
  mission_comment_aggregate: Mission_Comment_Aggregate;
  /** fetch data from the table: "mission_comment" using primary key columns */
  mission_comment_by_pk?: Maybe<Mission_Comment>;
  /** fetch data from the table: "organization" */
  organization: Array<Organization>;
  /** fetch aggregated fields from the table: "organization" */
  organization_aggregate: Organization_Aggregate;
  /** fetch data from the table: "organization" using primary key columns */
  organization_by_pk?: Maybe<Organization>;
  /** fetch data from the table: "organization_domain" */
  organization_domain: Array<Organization_Domain>;
  /** fetch aggregated fields from the table: "organization_domain" */
  organization_domain_aggregate: Organization_Domain_Aggregate;
  /** fetch data from the table: "organization_domain" using primary key columns */
  organization_domain_by_pk?: Maybe<Organization_Domain>;
  /** fetch data from the table: "path" */
  path: Array<Path>;
  /** fetch data from the table: "path_active_user" */
  path_active_user: Array<Path_Active_User>;
  /** fetch aggregated fields from the table: "path_active_user" */
  path_active_user_aggregate: Path_Active_User_Aggregate;
  /** fetch data from the table: "path_active_user" using primary key columns */
  path_active_user_by_pk?: Maybe<Path_Active_User>;
  /** fetch data from the table: "path_activity" */
  path_activity: Array<Path_Activity>;
  /** fetch aggregated fields from the table: "path_activity" */
  path_activity_aggregate: Path_Activity_Aggregate;
  /** fetch data from the table: "path_activity" using primary key columns */
  path_activity_by_pk?: Maybe<Path_Activity>;
  /** fetch aggregated fields from the table: "path" */
  path_aggregate: Path_Aggregate;
  /** fetch data from the table: "path_author" */
  path_author: Array<Path_Author>;
  /** fetch aggregated fields from the table: "path_author" */
  path_author_aggregate: Path_Author_Aggregate;
  /** fetch data from the table: "path_author" using primary key columns */
  path_author_by_pk?: Maybe<Path_Author>;
  /** fetch data from the table: "path" using primary key columns */
  path_by_pk?: Maybe<Path>;
  /** fetch data from the table: "path_collection" */
  path_collection: Array<Path_Collection>;
  /** fetch aggregated fields from the table: "path_collection" */
  path_collection_aggregate: Path_Collection_Aggregate;
  /** fetch data from the table: "path_collection" using primary key columns */
  path_collection_by_pk?: Maybe<Path_Collection>;
  /** fetch data from the table: "path_collection_item" */
  path_collection_item: Array<Path_Collection_Item>;
  /** fetch aggregated fields from the table: "path_collection_item" */
  path_collection_item_aggregate: Path_Collection_Item_Aggregate;
  /** fetch data from the table: "path_collection_item" using primary key columns */
  path_collection_item_by_pk?: Maybe<Path_Collection_Item>;
  /** fetch data from the table: "path_feed" */
  path_feed: Array<Path_Feed>;
  /** fetch aggregated fields from the table: "path_feed" */
  path_feed_aggregate: Path_Feed_Aggregate;
  /** fetch data from the table: "path_feed" using primary key columns */
  path_feed_by_pk?: Maybe<Path_Feed>;
  /** fetch data from the table: "path_node" */
  path_node: Array<Path_Node>;
  /** fetch aggregated fields from the table: "path_node" */
  path_node_aggregate: Path_Node_Aggregate;
  /** fetch data from the table: "path_node" using primary key columns */
  path_node_by_pk?: Maybe<Path_Node>;
  /** fetch data from the table: "path_node_comment" */
  path_node_comment: Array<Path_Node_Comment>;
  /** fetch aggregated fields from the table: "path_node_comment" */
  path_node_comment_aggregate: Path_Node_Comment_Aggregate;
  /** fetch data from the table: "path_node_comment" using primary key columns */
  path_node_comment_by_pk?: Maybe<Path_Node_Comment>;
  /** fetch data from the table: "path_review" */
  path_review: Array<Path_Review>;
  /** fetch aggregated fields from the table: "path_review" */
  path_review_aggregate: Path_Review_Aggregate;
  /** fetch data from the table: "path_review" using primary key columns */
  path_review_by_pk?: Maybe<Path_Review>;
  /** fetch data from the table: "project" */
  project: Array<Project>;
  /** fetch aggregated fields from the table: "project" */
  project_aggregate: Project_Aggregate;
  /** fetch data from the table: "project_award" */
  project_award: Array<Project_Award>;
  /** fetch aggregated fields from the table: "project_award" */
  project_award_aggregate: Project_Award_Aggregate;
  /** fetch data from the table: "project_award" using primary key columns */
  project_award_by_pk?: Maybe<Project_Award>;
  /** fetch data from the table: "project" using primary key columns */
  project_by_pk?: Maybe<Project>;
  /** fetch data from the table: "project_comment" */
  project_comment: Array<Project_Comment>;
  /** fetch aggregated fields from the table: "project_comment" */
  project_comment_aggregate: Project_Comment_Aggregate;
  /** fetch data from the table: "project_comment" using primary key columns */
  project_comment_by_pk?: Maybe<Project_Comment>;
  /** fetch data from the table: "project_reaction" */
  project_reaction: Array<Project_Reaction>;
  /** fetch aggregated fields from the table: "project_reaction" */
  project_reaction_aggregate: Project_Reaction_Aggregate;
  /** fetch data from the table: "project_reaction" using primary key columns */
  project_reaction_by_pk?: Maybe<Project_Reaction>;
  /** fetch data from the table: "project_stats" */
  project_stats: Array<Project_Stats>;
  /** fetch aggregated fields from the table: "project_stats" */
  project_stats_aggregate: Project_Stats_Aggregate;
  /** fetch data from the table: "project_stats" using primary key columns */
  project_stats_by_pk?: Maybe<Project_Stats>;
  /** execute function "search_organizations" which returns "organization" */
  search_organizations: Array<Organization>;
  /** execute function "search_organizations" and query aggregates on result of table type "organization" */
  search_organizations_aggregate: Organization_Aggregate;
  /** fetch data from the table: "shop_item" */
  shop_item: Array<Shop_Item>;
  /** fetch aggregated fields from the table: "shop_item" */
  shop_item_aggregate: Shop_Item_Aggregate;
  /** fetch data from the table: "shop_item" using primary key columns */
  shop_item_by_pk?: Maybe<Shop_Item>;
  /** fetch data from the table: "shop_item_purchase" */
  shop_item_purchase: Array<Shop_Item_Purchase>;
  /** fetch aggregated fields from the table: "shop_item_purchase" */
  shop_item_purchase_aggregate: Shop_Item_Purchase_Aggregate;
  /** fetch data from the table: "shop_item_purchase" using primary key columns */
  shop_item_purchase_by_pk?: Maybe<Shop_Item_Purchase>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user_award" */
  user_award: Array<User_Award>;
  /** fetch aggregated fields from the table: "user_award" */
  user_award_aggregate: User_Award_Aggregate;
  /** fetch data from the table: "user_award" using primary key columns */
  user_award_by_pk?: Maybe<User_Award>;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table: "user_file" */
  user_file: Array<User_File>;
  /** fetch aggregated fields from the table: "user_file" */
  user_file_aggregate: User_File_Aggregate;
  /** fetch data from the table: "user_file" using primary key columns */
  user_file_by_pk?: Maybe<User_File>;
  /** fetch data from the table: "user_file_integration" */
  user_file_integration: Array<User_File_Integration>;
  /** fetch aggregated fields from the table: "user_file_integration" */
  user_file_integration_aggregate: User_File_Integration_Aggregate;
  /** fetch data from the table: "user_file_integration" using primary key columns */
  user_file_integration_by_pk?: Maybe<User_File_Integration>;
  /** fetch data from the table: "user_file_transform" */
  user_file_transform: Array<User_File_Transform>;
  /** fetch aggregated fields from the table: "user_file_transform" */
  user_file_transform_aggregate: User_File_Transform_Aggregate;
  /** fetch data from the table: "user_file_transform" using primary key columns */
  user_file_transform_by_pk?: Maybe<User_File_Transform>;
  /** fetch data from the table: "user_follow" */
  user_follow: Array<User_Follow>;
  /** fetch aggregated fields from the table: "user_follow" */
  user_follow_aggregate: User_Follow_Aggregate;
  /** fetch data from the table: "user_follow" using primary key columns */
  user_follow_by_pk?: Maybe<User_Follow>;
  /** fetch data from the table: "user_integration" */
  user_integration: Array<User_Integration>;
  /** fetch aggregated fields from the table: "user_integration" */
  user_integration_aggregate: User_Integration_Aggregate;
  /** fetch data from the table: "user_integration" using primary key columns */
  user_integration_by_pk?: Maybe<User_Integration>;
  /** fetch data from the table: "user_path" */
  user_path: Array<User_Path>;
  /** fetch aggregated fields from the table: "user_path" */
  user_path_aggregate: User_Path_Aggregate;
  /** fetch data from the table: "user_path" using primary key columns */
  user_path_by_pk?: Maybe<User_Path>;
  /** fetch data from the table: "user_subscription" */
  user_subscription: Array<User_Subscription>;
  /** fetch aggregated fields from the table: "user_subscription" */
  user_subscription_aggregate: User_Subscription_Aggregate;
  /** fetch data from the table: "user_subscription" using primary key columns */
  user_subscription_by_pk?: Maybe<User_Subscription>;
  /** fetch data from the table: "user_teacher" */
  user_teacher: Array<User_Teacher>;
  /** fetch aggregated fields from the table: "user_teacher" */
  user_teacher_aggregate: User_Teacher_Aggregate;
  /** fetch data from the table: "user_teacher" using primary key columns */
  user_teacher_by_pk?: Maybe<User_Teacher>;
  /** fetch data from the table: "view_top_creators_by_followers_count" */
  view_top_creators_by_followers_count: Array<View_Top_Creators_By_Followers_Count>;
  /** fetch aggregated fields from the table: "view_top_creators_by_followers_count" */
  view_top_creators_by_followers_count_aggregate: View_Top_Creators_By_Followers_Count_Aggregate;
};


export type Query_RootAssignmentArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Order_By>>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};


export type Query_RootAssignment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Order_By>>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};


export type Query_RootAssignment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAssignment_Learner_GroupArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Learner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Learner_Group_Order_By>>;
  where?: InputMaybe<Assignment_Learner_Group_Bool_Exp>;
};


export type Query_RootAssignment_Learner_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Learner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Learner_Group_Order_By>>;
  where?: InputMaybe<Assignment_Learner_Group_Bool_Exp>;
};


export type Query_RootAssignment_Learner_Group_By_PkArgs = {
  assignmentId: Scalars['uuid'];
  learnerGroupId: Scalars['uuid'];
};


export type Query_RootAssignment_PathArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Path_Order_By>>;
  where?: InputMaybe<Assignment_Path_Bool_Exp>;
};


export type Query_RootAssignment_Path_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Path_Order_By>>;
  where?: InputMaybe<Assignment_Path_Bool_Exp>;
};


export type Query_RootAssignment_Path_By_PkArgs = {
  assignmentId: Scalars['uuid'];
  pathId: Scalars['bigint'];
};


export type Query_RootAwardArgs = {
  distinct_on?: InputMaybe<Array<Award_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Order_By>>;
  where?: InputMaybe<Award_Bool_Exp>;
};


export type Query_RootAward_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Award_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Order_By>>;
  where?: InputMaybe<Award_Bool_Exp>;
};


export type Query_RootAward_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCircle_PostsArgs = {
  communityId: Scalars['String'];
  page: Scalars['String'];
  spaceId: Scalars['String'];
};


export type Query_RootCircle_Space_GroupsArgs = {
  communityId: Scalars['String'];
};


export type Query_RootCircle_SpacesArgs = {
  communityId: Scalars['String'];
};


export type Query_RootCoin_TrxArgs = {
  distinct_on?: InputMaybe<Array<Coin_Trx_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Coin_Trx_Order_By>>;
  where?: InputMaybe<Coin_Trx_Bool_Exp>;
};


export type Query_RootCoin_Trx_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coin_Trx_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Coin_Trx_Order_By>>;
  where?: InputMaybe<Coin_Trx_Bool_Exp>;
};


export type Query_RootCoin_Trx_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCommentArgs = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comment_Order_By>>;
  where?: InputMaybe<Comment_Bool_Exp>;
};


export type Query_RootComment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comment_Order_By>>;
  where?: InputMaybe<Comment_Bool_Exp>;
};


export type Query_RootComment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEducator_CodeArgs = {
  distinct_on?: InputMaybe<Array<Educator_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Educator_Code_Order_By>>;
  where?: InputMaybe<Educator_Code_Bool_Exp>;
};


export type Query_RootEducator_Code_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Educator_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Educator_Code_Order_By>>;
  where?: InputMaybe<Educator_Code_Bool_Exp>;
};


export type Query_RootEducator_Code_By_PkArgs = {
  code: Scalars['String'];
};


export type Query_RootEducator_Code_RedemptionArgs = {
  distinct_on?: InputMaybe<Array<Educator_Code_Redemption_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Educator_Code_Redemption_Order_By>>;
  where?: InputMaybe<Educator_Code_Redemption_Bool_Exp>;
};


export type Query_RootEducator_Code_Redemption_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Educator_Code_Redemption_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Educator_Code_Redemption_Order_By>>;
  where?: InputMaybe<Educator_Code_Redemption_Bool_Exp>;
};


export type Query_RootEducator_Code_Redemption_By_PkArgs = {
  code: Scalars['String'];
  userId: Scalars['String'];
};


export type Query_RootEnums_Coin_Trx_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Enums_Coin_Trx_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enums_Coin_Trx_Category_Order_By>>;
  where?: InputMaybe<Enums_Coin_Trx_Category_Bool_Exp>;
};


export type Query_RootEnums_Coin_Trx_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enums_Coin_Trx_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enums_Coin_Trx_Category_Order_By>>;
  where?: InputMaybe<Enums_Coin_Trx_Category_Bool_Exp>;
};


export type Query_RootEnums_Coin_Trx_Category_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootEnums_Integration_ProviderArgs = {
  distinct_on?: InputMaybe<Array<Enums_Integration_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enums_Integration_Provider_Order_By>>;
  where?: InputMaybe<Enums_Integration_Provider_Bool_Exp>;
};


export type Query_RootEnums_Integration_Provider_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enums_Integration_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enums_Integration_Provider_Order_By>>;
  where?: InputMaybe<Enums_Integration_Provider_Bool_Exp>;
};


export type Query_RootEnums_Integration_Provider_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootEnums_Project_StatusArgs = {
  distinct_on?: InputMaybe<Array<Enums_Project_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enums_Project_Status_Order_By>>;
  where?: InputMaybe<Enums_Project_Status_Bool_Exp>;
};


export type Query_RootEnums_Project_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enums_Project_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enums_Project_Status_Order_By>>;
  where?: InputMaybe<Enums_Project_Status_Bool_Exp>;
};


export type Query_RootEnums_Project_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootGuideArgs = {
  distinct_on?: InputMaybe<Array<Guide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guide_Order_By>>;
  where?: InputMaybe<Guide_Bool_Exp>;
};


export type Query_RootGuide_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Guide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guide_Order_By>>;
  where?: InputMaybe<Guide_Bool_Exp>;
};


export type Query_RootGuide_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGuide_PathArgs = {
  distinct_on?: InputMaybe<Array<Guide_Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guide_Path_Order_By>>;
  where?: InputMaybe<Guide_Path_Bool_Exp>;
};


export type Query_RootGuide_Path_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Guide_Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guide_Path_Order_By>>;
  where?: InputMaybe<Guide_Path_Bool_Exp>;
};


export type Query_RootGuide_Path_By_PkArgs = {
  guideId: Scalars['uuid'];
  pathId: Scalars['bigint'];
};


export type Query_RootLearner_GroupArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Order_By>>;
  where?: InputMaybe<Learner_Group_Bool_Exp>;
};


export type Query_RootLearner_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Order_By>>;
  where?: InputMaybe<Learner_Group_Bool_Exp>;
};


export type Query_RootLearner_Group_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLearner_Group_MemberArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Member_Order_By>>;
  where?: InputMaybe<Learner_Group_Member_Bool_Exp>;
};


export type Query_RootLearner_Group_Member_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Member_Order_By>>;
  where?: InputMaybe<Learner_Group_Member_Bool_Exp>;
};


export type Query_RootLearner_Group_Member_By_PkArgs = {
  learnerGroupId: Scalars['uuid'];
  userId: Scalars['String'];
};


export type Query_RootLearner_Group_Path_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Path_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Path_Collection_Order_By>>;
  where?: InputMaybe<Learner_Group_Path_Collection_Bool_Exp>;
};


export type Query_RootLearner_Group_Path_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Path_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Path_Collection_Order_By>>;
  where?: InputMaybe<Learner_Group_Path_Collection_Bool_Exp>;
};


export type Query_RootLearner_Group_Path_Collection_By_PkArgs = {
  learnerGroupId: Scalars['uuid'];
};


export type Query_RootLearner_Group_Pending_MemberArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Pending_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Pending_Member_Order_By>>;
  where?: InputMaybe<Learner_Group_Pending_Member_Bool_Exp>;
};


export type Query_RootLearner_Group_Pending_Member_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Pending_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Pending_Member_Order_By>>;
  where?: InputMaybe<Learner_Group_Pending_Member_Bool_Exp>;
};


export type Query_RootLearner_Group_Pending_Member_By_PkArgs = {
  foreignId: Scalars['String'];
  learnerGroupId: Scalars['uuid'];
  provider: Enums_Integration_Provider_Enum;
};


export type Query_RootList_Latest_Path_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Path_Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Review_Order_By>>;
  where?: InputMaybe<Path_Review_Bool_Exp>;
};


export type Query_RootList_Latest_Path_Reviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Review_Order_By>>;
  where?: InputMaybe<Path_Review_Bool_Exp>;
};


export type Query_RootLivestreamArgs = {
  distinct_on?: InputMaybe<Array<Livestream_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Livestream_Order_By>>;
  where?: InputMaybe<Livestream_Bool_Exp>;
};


export type Query_RootLivestream_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Livestream_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Livestream_Order_By>>;
  where?: InputMaybe<Livestream_Bool_Exp>;
};


export type Query_RootLivestream_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLmsArgs = {
  distinct_on?: InputMaybe<Array<Lms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lms_Order_By>>;
  where?: InputMaybe<Lms_Bool_Exp>;
};


export type Query_RootLms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lms_Order_By>>;
  where?: InputMaybe<Lms_Bool_Exp>;
};


export type Query_RootLms_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMissionArgs = {
  distinct_on?: InputMaybe<Array<Mission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Order_By>>;
  where?: InputMaybe<Mission_Bool_Exp>;
};


export type Query_RootMission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Order_By>>;
  where?: InputMaybe<Mission_Bool_Exp>;
};


export type Query_RootMission_AttachmentArgs = {
  distinct_on?: InputMaybe<Array<Mission_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Attachment_Order_By>>;
  where?: InputMaybe<Mission_Attachment_Bool_Exp>;
};


export type Query_RootMission_Attachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mission_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Attachment_Order_By>>;
  where?: InputMaybe<Mission_Attachment_Bool_Exp>;
};


export type Query_RootMission_Attachment_By_PkArgs = {
  fileId: Scalars['uuid'];
  missionId: Scalars['Int'];
};


export type Query_RootMission_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootMission_ChallengeArgs = {
  distinct_on?: InputMaybe<Array<Mission_Challenge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Challenge_Order_By>>;
  where?: InputMaybe<Mission_Challenge_Bool_Exp>;
};


export type Query_RootMission_Challenge_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mission_Challenge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Challenge_Order_By>>;
  where?: InputMaybe<Mission_Challenge_Bool_Exp>;
};


export type Query_RootMission_Challenge_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootMission_CommentArgs = {
  distinct_on?: InputMaybe<Array<Mission_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Comment_Order_By>>;
  where?: InputMaybe<Mission_Comment_Bool_Exp>;
};


export type Query_RootMission_Comment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mission_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Comment_Order_By>>;
  where?: InputMaybe<Mission_Comment_Bool_Exp>;
};


export type Query_RootMission_Comment_By_PkArgs = {
  commentId: Scalars['uuid'];
};


export type Query_RootOrganizationArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Query_RootOrganization_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Query_RootOrganization_By_PkArgs = {
  firestoreId: Scalars['String'];
};


export type Query_RootOrganization_DomainArgs = {
  distinct_on?: InputMaybe<Array<Organization_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Domain_Order_By>>;
  where?: InputMaybe<Organization_Domain_Bool_Exp>;
};


export type Query_RootOrganization_Domain_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Domain_Order_By>>;
  where?: InputMaybe<Organization_Domain_Bool_Exp>;
};


export type Query_RootOrganization_Domain_By_PkArgs = {
  domain: Scalars['String'];
  orgId: Scalars['String'];
};


export type Query_RootPathArgs = {
  distinct_on?: InputMaybe<Array<Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Order_By>>;
  where?: InputMaybe<Path_Bool_Exp>;
};


export type Query_RootPath_Active_UserArgs = {
  distinct_on?: InputMaybe<Array<Path_Active_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Active_User_Order_By>>;
  where?: InputMaybe<Path_Active_User_Bool_Exp>;
};


export type Query_RootPath_Active_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Active_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Active_User_Order_By>>;
  where?: InputMaybe<Path_Active_User_Bool_Exp>;
};


export type Query_RootPath_Active_User_By_PkArgs = {
  pathId: Scalars['bigint'];
  userId: Scalars['String'];
};


export type Query_RootPath_ActivityArgs = {
  distinct_on?: InputMaybe<Array<Path_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Activity_Order_By>>;
  where?: InputMaybe<Path_Activity_Bool_Exp>;
};


export type Query_RootPath_Activity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Activity_Order_By>>;
  where?: InputMaybe<Path_Activity_Bool_Exp>;
};


export type Query_RootPath_Activity_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPath_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Order_By>>;
  where?: InputMaybe<Path_Bool_Exp>;
};


export type Query_RootPath_AuthorArgs = {
  distinct_on?: InputMaybe<Array<Path_Author_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Author_Order_By>>;
  where?: InputMaybe<Path_Author_Bool_Exp>;
};


export type Query_RootPath_Author_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Author_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Author_Order_By>>;
  where?: InputMaybe<Path_Author_Bool_Exp>;
};


export type Query_RootPath_Author_By_PkArgs = {
  pathId: Scalars['bigint'];
  userId: Scalars['String'];
};


export type Query_RootPath_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPath_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Path_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Collection_Order_By>>;
  where?: InputMaybe<Path_Collection_Bool_Exp>;
};


export type Query_RootPath_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Collection_Order_By>>;
  where?: InputMaybe<Path_Collection_Bool_Exp>;
};


export type Query_RootPath_Collection_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPath_Collection_ItemArgs = {
  distinct_on?: InputMaybe<Array<Path_Collection_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Collection_Item_Order_By>>;
  where?: InputMaybe<Path_Collection_Item_Bool_Exp>;
};


export type Query_RootPath_Collection_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Collection_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Collection_Item_Order_By>>;
  where?: InputMaybe<Path_Collection_Item_Bool_Exp>;
};


export type Query_RootPath_Collection_Item_By_PkArgs = {
  collectionId: Scalars['uuid'];
  pathId: Scalars['bigint'];
};


export type Query_RootPath_FeedArgs = {
  distinct_on?: InputMaybe<Array<Path_Feed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Feed_Order_By>>;
  where?: InputMaybe<Path_Feed_Bool_Exp>;
};


export type Query_RootPath_Feed_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Feed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Feed_Order_By>>;
  where?: InputMaybe<Path_Feed_Bool_Exp>;
};


export type Query_RootPath_Feed_By_PkArgs = {
  pathId: Scalars['bigint'];
  slug: Scalars['String'];
};


export type Query_RootPath_NodeArgs = {
  distinct_on?: InputMaybe<Array<Path_Node_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Node_Order_By>>;
  where?: InputMaybe<Path_Node_Bool_Exp>;
};


export type Query_RootPath_Node_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Node_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Node_Order_By>>;
  where?: InputMaybe<Path_Node_Bool_Exp>;
};


export type Query_RootPath_Node_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPath_Node_CommentArgs = {
  distinct_on?: InputMaybe<Array<Path_Node_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Node_Comment_Order_By>>;
  where?: InputMaybe<Path_Node_Comment_Bool_Exp>;
};


export type Query_RootPath_Node_Comment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Node_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Node_Comment_Order_By>>;
  where?: InputMaybe<Path_Node_Comment_Bool_Exp>;
};


export type Query_RootPath_Node_Comment_By_PkArgs = {
  commentId: Scalars['uuid'];
};


export type Query_RootPath_ReviewArgs = {
  distinct_on?: InputMaybe<Array<Path_Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Review_Order_By>>;
  where?: InputMaybe<Path_Review_Bool_Exp>;
};


export type Query_RootPath_Review_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Review_Order_By>>;
  where?: InputMaybe<Path_Review_Bool_Exp>;
};


export type Query_RootPath_Review_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProjectArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Query_RootProject_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Query_RootProject_AwardArgs = {
  distinct_on?: InputMaybe<Array<Project_Award_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Award_Order_By>>;
  where?: InputMaybe<Project_Award_Bool_Exp>;
};


export type Query_RootProject_Award_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Award_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Award_Order_By>>;
  where?: InputMaybe<Project_Award_Bool_Exp>;
};


export type Query_RootProject_Award_By_PkArgs = {
  awardId: Scalars['uuid'];
  projectId: Scalars['uuid'];
};


export type Query_RootProject_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProject_CommentArgs = {
  distinct_on?: InputMaybe<Array<Project_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Comment_Order_By>>;
  where?: InputMaybe<Project_Comment_Bool_Exp>;
};


export type Query_RootProject_Comment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Comment_Order_By>>;
  where?: InputMaybe<Project_Comment_Bool_Exp>;
};


export type Query_RootProject_Comment_By_PkArgs = {
  commentId: Scalars['uuid'];
};


export type Query_RootProject_ReactionArgs = {
  distinct_on?: InputMaybe<Array<Project_Reaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Reaction_Order_By>>;
  where?: InputMaybe<Project_Reaction_Bool_Exp>;
};


export type Query_RootProject_Reaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Reaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Reaction_Order_By>>;
  where?: InputMaybe<Project_Reaction_Bool_Exp>;
};


export type Query_RootProject_Reaction_By_PkArgs = {
  projectId: Scalars['uuid'];
  userId: Scalars['String'];
};


export type Query_RootProject_StatsArgs = {
  distinct_on?: InputMaybe<Array<Project_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Stats_Order_By>>;
  where?: InputMaybe<Project_Stats_Bool_Exp>;
};


export type Query_RootProject_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Stats_Order_By>>;
  where?: InputMaybe<Project_Stats_Bool_Exp>;
};


export type Query_RootProject_Stats_By_PkArgs = {
  projectId: Scalars['uuid'];
};


export type Query_RootSearch_OrganizationsArgs = {
  args: Search_Organizations_Args;
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Query_RootSearch_Organizations_AggregateArgs = {
  args: Search_Organizations_Args;
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Query_RootShop_ItemArgs = {
  distinct_on?: InputMaybe<Array<Shop_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Item_Order_By>>;
  where?: InputMaybe<Shop_Item_Bool_Exp>;
};


export type Query_RootShop_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Item_Order_By>>;
  where?: InputMaybe<Shop_Item_Bool_Exp>;
};


export type Query_RootShop_Item_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootShop_Item_PurchaseArgs = {
  distinct_on?: InputMaybe<Array<Shop_Item_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Item_Purchase_Order_By>>;
  where?: InputMaybe<Shop_Item_Purchase_Bool_Exp>;
};


export type Query_RootShop_Item_Purchase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Item_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Item_Purchase_Order_By>>;
  where?: InputMaybe<Shop_Item_Purchase_Bool_Exp>;
};


export type Query_RootShop_Item_Purchase_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_AwardArgs = {
  distinct_on?: InputMaybe<Array<User_Award_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Award_Order_By>>;
  where?: InputMaybe<User_Award_Bool_Exp>;
};


export type Query_RootUser_Award_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Award_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Award_Order_By>>;
  where?: InputMaybe<User_Award_Bool_Exp>;
};


export type Query_RootUser_Award_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_By_PkArgs = {
  firestoreId: Scalars['String'];
};


export type Query_RootUser_FileArgs = {
  distinct_on?: InputMaybe<Array<User_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_File_Order_By>>;
  where?: InputMaybe<User_File_Bool_Exp>;
};


export type Query_RootUser_File_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_File_Order_By>>;
  where?: InputMaybe<User_File_Bool_Exp>;
};


export type Query_RootUser_File_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_File_IntegrationArgs = {
  distinct_on?: InputMaybe<Array<User_File_Integration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_File_Integration_Order_By>>;
  where?: InputMaybe<User_File_Integration_Bool_Exp>;
};


export type Query_RootUser_File_Integration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_File_Integration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_File_Integration_Order_By>>;
  where?: InputMaybe<User_File_Integration_Bool_Exp>;
};


export type Query_RootUser_File_Integration_By_PkArgs = {
  fileId: Scalars['uuid'];
  source: Scalars['String'];
};


export type Query_RootUser_File_TransformArgs = {
  distinct_on?: InputMaybe<Array<User_File_Transform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_File_Transform_Order_By>>;
  where?: InputMaybe<User_File_Transform_Bool_Exp>;
};


export type Query_RootUser_File_Transform_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_File_Transform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_File_Transform_Order_By>>;
  where?: InputMaybe<User_File_Transform_Bool_Exp>;
};


export type Query_RootUser_File_Transform_By_PkArgs = {
  fileId: Scalars['uuid'];
  filename: Scalars['String'];
};


export type Query_RootUser_FollowArgs = {
  distinct_on?: InputMaybe<Array<User_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Follow_Order_By>>;
  where?: InputMaybe<User_Follow_Bool_Exp>;
};


export type Query_RootUser_Follow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Follow_Order_By>>;
  where?: InputMaybe<User_Follow_Bool_Exp>;
};


export type Query_RootUser_Follow_By_PkArgs = {
  sourceUserId: Scalars['String'];
  targetUserId: Scalars['String'];
};


export type Query_RootUser_IntegrationArgs = {
  distinct_on?: InputMaybe<Array<User_Integration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Integration_Order_By>>;
  where?: InputMaybe<User_Integration_Bool_Exp>;
};


export type Query_RootUser_Integration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Integration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Integration_Order_By>>;
  where?: InputMaybe<User_Integration_Bool_Exp>;
};


export type Query_RootUser_Integration_By_PkArgs = {
  foreignId: Scalars['String'];
  provider: Enums_Integration_Provider_Enum;
};


export type Query_RootUser_PathArgs = {
  distinct_on?: InputMaybe<Array<User_Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Path_Order_By>>;
  where?: InputMaybe<User_Path_Bool_Exp>;
};


export type Query_RootUser_Path_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Path_Order_By>>;
  where?: InputMaybe<User_Path_Bool_Exp>;
};


export type Query_RootUser_Path_By_PkArgs = {
  pathId: Scalars['Int'];
  userId: Scalars['String'];
};


export type Query_RootUser_SubscriptionArgs = {
  distinct_on?: InputMaybe<Array<User_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Subscription_Order_By>>;
  where?: InputMaybe<User_Subscription_Bool_Exp>;
};


export type Query_RootUser_Subscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Subscription_Order_By>>;
  where?: InputMaybe<User_Subscription_Bool_Exp>;
};


export type Query_RootUser_Subscription_By_PkArgs = {
  userId: Scalars['String'];
};


export type Query_RootUser_TeacherArgs = {
  distinct_on?: InputMaybe<Array<User_Teacher_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Teacher_Order_By>>;
  where?: InputMaybe<User_Teacher_Bool_Exp>;
};


export type Query_RootUser_Teacher_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Teacher_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Teacher_Order_By>>;
  where?: InputMaybe<User_Teacher_Bool_Exp>;
};


export type Query_RootUser_Teacher_By_PkArgs = {
  userId: Scalars['String'];
};


export type Query_RootView_Top_Creators_By_Followers_CountArgs = {
  distinct_on?: InputMaybe<Array<View_Top_Creators_By_Followers_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_Top_Creators_By_Followers_Count_Order_By>>;
  where?: InputMaybe<View_Top_Creators_By_Followers_Count_Bool_Exp>;
};


export type Query_RootView_Top_Creators_By_Followers_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<View_Top_Creators_By_Followers_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_Top_Creators_By_Followers_Count_Order_By>>;
  where?: InputMaybe<View_Top_Creators_By_Followers_Count_Bool_Exp>;
};

export type Search_Organizations_Args = {
  search?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "shop_item" */
export type Shop_Item = {
  __typename?: 'shop_item';
  cost: Scalars['Int'];
  /** An object relationship */
  coverFile?: Maybe<User_File>;
  coverFileId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  description: Scalars['String'];
  disabled: Scalars['Boolean'];
  externalURL?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  media?: Maybe<Scalars['jsonb']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  /** An object relationship */
  owner?: Maybe<User>;
  ownerId?: Maybe<Scalars['String']>;
  /** An array relationship */
  purchases: Array<Shop_Item_Purchase>;
  /** An aggregate relationship */
  purchases_aggregate: Shop_Item_Purchase_Aggregate;
  quantity?: Maybe<Scalars['Int']>;
  tags: Scalars['jsonb'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "shop_item" */
export type Shop_ItemMediaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "shop_item" */
export type Shop_ItemMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "shop_item" */
export type Shop_ItemPurchasesArgs = {
  distinct_on?: InputMaybe<Array<Shop_Item_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Item_Purchase_Order_By>>;
  where?: InputMaybe<Shop_Item_Purchase_Bool_Exp>;
};


/** columns and relationships of "shop_item" */
export type Shop_ItemPurchases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Item_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Item_Purchase_Order_By>>;
  where?: InputMaybe<Shop_Item_Purchase_Bool_Exp>;
};


/** columns and relationships of "shop_item" */
export type Shop_ItemTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "shop_item" */
export type Shop_Item_Aggregate = {
  __typename?: 'shop_item_aggregate';
  aggregate?: Maybe<Shop_Item_Aggregate_Fields>;
  nodes: Array<Shop_Item>;
};

/** aggregate fields of "shop_item" */
export type Shop_Item_Aggregate_Fields = {
  __typename?: 'shop_item_aggregate_fields';
  avg?: Maybe<Shop_Item_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Shop_Item_Max_Fields>;
  min?: Maybe<Shop_Item_Min_Fields>;
  stddev?: Maybe<Shop_Item_Stddev_Fields>;
  stddev_pop?: Maybe<Shop_Item_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Shop_Item_Stddev_Samp_Fields>;
  sum?: Maybe<Shop_Item_Sum_Fields>;
  var_pop?: Maybe<Shop_Item_Var_Pop_Fields>;
  var_samp?: Maybe<Shop_Item_Var_Samp_Fields>;
  variance?: Maybe<Shop_Item_Variance_Fields>;
};


/** aggregate fields of "shop_item" */
export type Shop_Item_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shop_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Shop_Item_Append_Input = {
  media?: InputMaybe<Scalars['jsonb']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Shop_Item_Avg_Fields = {
  __typename?: 'shop_item_avg_fields';
  cost?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "shop_item". All fields are combined with a logical 'AND'. */
export type Shop_Item_Bool_Exp = {
  _and?: InputMaybe<Array<Shop_Item_Bool_Exp>>;
  _not?: InputMaybe<Shop_Item_Bool_Exp>;
  _or?: InputMaybe<Array<Shop_Item_Bool_Exp>>;
  cost?: InputMaybe<Int_Comparison_Exp>;
  coverFile?: InputMaybe<User_File_Bool_Exp>;
  coverFileId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  externalURL?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  media?: InputMaybe<Jsonb_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<User_Bool_Exp>;
  ownerId?: InputMaybe<String_Comparison_Exp>;
  purchases?: InputMaybe<Shop_Item_Purchase_Bool_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  tags?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shop_item" */
export enum Shop_Item_Constraint {
  /** unique or primary key constraint on columns "id" */
  ShopItemPkey = 'shop_item_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Shop_Item_Delete_At_Path_Input = {
  media?: InputMaybe<Array<Scalars['String']>>;
  metadata?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Shop_Item_Delete_Elem_Input = {
  media?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Shop_Item_Delete_Key_Input = {
  media?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "shop_item" */
export type Shop_Item_Inc_Input = {
  cost?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "shop_item" */
export type Shop_Item_Insert_Input = {
  cost?: InputMaybe<Scalars['Int']>;
  coverFile?: InputMaybe<User_File_Obj_Rel_Insert_Input>;
  coverFileId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  externalURL?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  media?: InputMaybe<Scalars['jsonb']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<User_Obj_Rel_Insert_Input>;
  ownerId?: InputMaybe<Scalars['String']>;
  purchases?: InputMaybe<Shop_Item_Purchase_Arr_Rel_Insert_Input>;
  quantity?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Shop_Item_Max_Fields = {
  __typename?: 'shop_item_max_fields';
  cost?: Maybe<Scalars['Int']>;
  coverFileId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  externalURL?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Shop_Item_Min_Fields = {
  __typename?: 'shop_item_min_fields';
  cost?: Maybe<Scalars['Int']>;
  coverFileId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  externalURL?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "shop_item" */
export type Shop_Item_Mutation_Response = {
  __typename?: 'shop_item_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Shop_Item>;
};

/** input type for inserting object relation for remote table "shop_item" */
export type Shop_Item_Obj_Rel_Insert_Input = {
  data: Shop_Item_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Shop_Item_On_Conflict>;
};

/** on_conflict condition type for table "shop_item" */
export type Shop_Item_On_Conflict = {
  constraint: Shop_Item_Constraint;
  update_columns?: Array<Shop_Item_Update_Column>;
  where?: InputMaybe<Shop_Item_Bool_Exp>;
};

/** Ordering options when selecting data from "shop_item". */
export type Shop_Item_Order_By = {
  cost?: InputMaybe<Order_By>;
  coverFile?: InputMaybe<User_File_Order_By>;
  coverFileId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  disabled?: InputMaybe<Order_By>;
  externalURL?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<User_Order_By>;
  ownerId?: InputMaybe<Order_By>;
  purchases_aggregate?: InputMaybe<Shop_Item_Purchase_Aggregate_Order_By>;
  quantity?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shop_item */
export type Shop_Item_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Shop_Item_Prepend_Input = {
  media?: InputMaybe<Scalars['jsonb']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "shop_item_purchase" */
export type Shop_Item_Purchase = {
  __typename?: 'shop_item_purchase';
  /** An object relationship */
  coinTrx: Coin_Trx;
  coinTrxId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  shopItem: Shop_Item;
  shopItemId: Scalars['uuid'];
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userId: Scalars['String'];
};

/** aggregated selection of "shop_item_purchase" */
export type Shop_Item_Purchase_Aggregate = {
  __typename?: 'shop_item_purchase_aggregate';
  aggregate?: Maybe<Shop_Item_Purchase_Aggregate_Fields>;
  nodes: Array<Shop_Item_Purchase>;
};

/** aggregate fields of "shop_item_purchase" */
export type Shop_Item_Purchase_Aggregate_Fields = {
  __typename?: 'shop_item_purchase_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Shop_Item_Purchase_Max_Fields>;
  min?: Maybe<Shop_Item_Purchase_Min_Fields>;
};


/** aggregate fields of "shop_item_purchase" */
export type Shop_Item_Purchase_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shop_Item_Purchase_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shop_item_purchase" */
export type Shop_Item_Purchase_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Shop_Item_Purchase_Max_Order_By>;
  min?: InputMaybe<Shop_Item_Purchase_Min_Order_By>;
};

/** input type for inserting array relation for remote table "shop_item_purchase" */
export type Shop_Item_Purchase_Arr_Rel_Insert_Input = {
  data: Array<Shop_Item_Purchase_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Shop_Item_Purchase_On_Conflict>;
};

/** Boolean expression to filter rows from the table "shop_item_purchase". All fields are combined with a logical 'AND'. */
export type Shop_Item_Purchase_Bool_Exp = {
  _and?: InputMaybe<Array<Shop_Item_Purchase_Bool_Exp>>;
  _not?: InputMaybe<Shop_Item_Purchase_Bool_Exp>;
  _or?: InputMaybe<Array<Shop_Item_Purchase_Bool_Exp>>;
  coinTrx?: InputMaybe<Coin_Trx_Bool_Exp>;
  coinTrxId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  shopItem?: InputMaybe<Shop_Item_Bool_Exp>;
  shopItemId?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "shop_item_purchase" */
export enum Shop_Item_Purchase_Constraint {
  /** unique or primary key constraint on columns "id" */
  ShopItemPurchasePkey = 'shop_item_purchase_pkey',
  /** unique or primary key constraint on columns "shop_item_id", "user_id", "coin_trx_id" */
  ShopItemPurchaseShopItemIdUserIdCoinTrxIdKey = 'shop_item_purchase_shop_item_id_user_id_coin_trx_id_key'
}

/** input type for inserting data into table "shop_item_purchase" */
export type Shop_Item_Purchase_Insert_Input = {
  coinTrx?: InputMaybe<Coin_Trx_Obj_Rel_Insert_Input>;
  coinTrxId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  shopItem?: InputMaybe<Shop_Item_Obj_Rel_Insert_Input>;
  shopItemId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Shop_Item_Purchase_Max_Fields = {
  __typename?: 'shop_item_purchase_max_fields';
  coinTrxId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  shopItemId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "shop_item_purchase" */
export type Shop_Item_Purchase_Max_Order_By = {
  coinTrxId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shopItemId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Shop_Item_Purchase_Min_Fields = {
  __typename?: 'shop_item_purchase_min_fields';
  coinTrxId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  shopItemId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "shop_item_purchase" */
export type Shop_Item_Purchase_Min_Order_By = {
  coinTrxId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shopItemId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shop_item_purchase" */
export type Shop_Item_Purchase_Mutation_Response = {
  __typename?: 'shop_item_purchase_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Shop_Item_Purchase>;
};

/** on_conflict condition type for table "shop_item_purchase" */
export type Shop_Item_Purchase_On_Conflict = {
  constraint: Shop_Item_Purchase_Constraint;
  update_columns?: Array<Shop_Item_Purchase_Update_Column>;
  where?: InputMaybe<Shop_Item_Purchase_Bool_Exp>;
};

/** Ordering options when selecting data from "shop_item_purchase". */
export type Shop_Item_Purchase_Order_By = {
  coinTrx?: InputMaybe<Coin_Trx_Order_By>;
  coinTrxId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shopItem?: InputMaybe<Shop_Item_Order_By>;
  shopItemId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shop_item_purchase */
export type Shop_Item_Purchase_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shop_item_purchase" */
export enum Shop_Item_Purchase_Select_Column {
  /** column name */
  CoinTrxId = 'coinTrxId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ShopItemId = 'shopItemId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "shop_item_purchase" */
export type Shop_Item_Purchase_Set_Input = {
  coinTrxId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  shopItemId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "shop_item_purchase" */
export type Shop_Item_Purchase_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shop_Item_Purchase_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shop_Item_Purchase_Stream_Cursor_Value_Input = {
  coinTrxId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  shopItemId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "shop_item_purchase" */
export enum Shop_Item_Purchase_Update_Column {
  /** column name */
  CoinTrxId = 'coinTrxId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ShopItemId = 'shopItemId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Shop_Item_Purchase_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shop_Item_Purchase_Set_Input>;
  where: Shop_Item_Purchase_Bool_Exp;
};

/** select columns of table "shop_item" */
export enum Shop_Item_Select_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  CoverFileId = 'coverFileId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  ExternalUrl = 'externalURL',
  /** column name */
  Id = 'id',
  /** column name */
  Media = 'media',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerId = 'ownerId',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Tags = 'tags',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "shop_item" */
export type Shop_Item_Set_Input = {
  cost?: InputMaybe<Scalars['Int']>;
  coverFileId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  externalURL?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  media?: InputMaybe<Scalars['jsonb']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Shop_Item_Stddev_Fields = {
  __typename?: 'shop_item_stddev_fields';
  cost?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Shop_Item_Stddev_Pop_Fields = {
  __typename?: 'shop_item_stddev_pop_fields';
  cost?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Shop_Item_Stddev_Samp_Fields = {
  __typename?: 'shop_item_stddev_samp_fields';
  cost?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "shop_item" */
export type Shop_Item_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shop_Item_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shop_Item_Stream_Cursor_Value_Input = {
  cost?: InputMaybe<Scalars['Int']>;
  coverFileId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  externalURL?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  media?: InputMaybe<Scalars['jsonb']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Shop_Item_Sum_Fields = {
  __typename?: 'shop_item_sum_fields';
  cost?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
};

/** update columns of table "shop_item" */
export enum Shop_Item_Update_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  CoverFileId = 'coverFileId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  ExternalUrl = 'externalURL',
  /** column name */
  Id = 'id',
  /** column name */
  Media = 'media',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerId = 'ownerId',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Tags = 'tags',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Shop_Item_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Shop_Item_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Shop_Item_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Shop_Item_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Shop_Item_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Shop_Item_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Shop_Item_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shop_Item_Set_Input>;
  where: Shop_Item_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Shop_Item_Var_Pop_Fields = {
  __typename?: 'shop_item_var_pop_fields';
  cost?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Shop_Item_Var_Samp_Fields = {
  __typename?: 'shop_item_var_samp_fields';
  cost?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Shop_Item_Variance_Fields = {
  __typename?: 'shop_item_variance_fields';
  cost?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']>;
  _gt?: InputMaybe<Scalars['smallint']>;
  _gte?: InputMaybe<Scalars['smallint']>;
  _in?: InputMaybe<Array<Scalars['smallint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['smallint']>;
  _lte?: InputMaybe<Scalars['smallint']>;
  _neq?: InputMaybe<Scalars['smallint']>;
  _nin?: InputMaybe<Array<Scalars['smallint']>>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "assignment" */
  assignment: Array<Assignment>;
  /** fetch aggregated fields from the table: "assignment" */
  assignment_aggregate: Assignment_Aggregate;
  /** fetch data from the table: "assignment" using primary key columns */
  assignment_by_pk?: Maybe<Assignment>;
  /** fetch data from the table: "assignment_learner_group" */
  assignment_learner_group: Array<Assignment_Learner_Group>;
  /** fetch aggregated fields from the table: "assignment_learner_group" */
  assignment_learner_group_aggregate: Assignment_Learner_Group_Aggregate;
  /** fetch data from the table: "assignment_learner_group" using primary key columns */
  assignment_learner_group_by_pk?: Maybe<Assignment_Learner_Group>;
  /** fetch data from the table in a streaming manner : "assignment_learner_group" */
  assignment_learner_group_stream: Array<Assignment_Learner_Group>;
  /** fetch data from the table: "assignment_path" */
  assignment_path: Array<Assignment_Path>;
  /** fetch aggregated fields from the table: "assignment_path" */
  assignment_path_aggregate: Assignment_Path_Aggregate;
  /** fetch data from the table: "assignment_path" using primary key columns */
  assignment_path_by_pk?: Maybe<Assignment_Path>;
  /** fetch data from the table in a streaming manner : "assignment_path" */
  assignment_path_stream: Array<Assignment_Path>;
  /** fetch data from the table in a streaming manner : "assignment" */
  assignment_stream: Array<Assignment>;
  /** fetch data from the table: "award" */
  award: Array<Award>;
  /** fetch aggregated fields from the table: "award" */
  award_aggregate: Award_Aggregate;
  /** fetch data from the table: "award" using primary key columns */
  award_by_pk?: Maybe<Award>;
  /** fetch data from the table in a streaming manner : "award" */
  award_stream: Array<Award>;
  /** fetch data from the table: "coin_trx" */
  coin_trx: Array<Coin_Trx>;
  /** fetch aggregated fields from the table: "coin_trx" */
  coin_trx_aggregate: Coin_Trx_Aggregate;
  /** fetch data from the table: "coin_trx" using primary key columns */
  coin_trx_by_pk?: Maybe<Coin_Trx>;
  /** fetch data from the table in a streaming manner : "coin_trx" */
  coin_trx_stream: Array<Coin_Trx>;
  /** fetch data from the table: "comment" */
  comment: Array<Comment>;
  /** fetch aggregated fields from the table: "comment" */
  comment_aggregate: Comment_Aggregate;
  /** fetch data from the table: "comment" using primary key columns */
  comment_by_pk?: Maybe<Comment>;
  /** fetch data from the table in a streaming manner : "comment" */
  comment_stream: Array<Comment>;
  /** fetch data from the table: "educator_code" */
  educator_code: Array<Educator_Code>;
  /** fetch aggregated fields from the table: "educator_code" */
  educator_code_aggregate: Educator_Code_Aggregate;
  /** fetch data from the table: "educator_code" using primary key columns */
  educator_code_by_pk?: Maybe<Educator_Code>;
  /** fetch data from the table: "educator_code_redemption" */
  educator_code_redemption: Array<Educator_Code_Redemption>;
  /** fetch aggregated fields from the table: "educator_code_redemption" */
  educator_code_redemption_aggregate: Educator_Code_Redemption_Aggregate;
  /** fetch data from the table: "educator_code_redemption" using primary key columns */
  educator_code_redemption_by_pk?: Maybe<Educator_Code_Redemption>;
  /** fetch data from the table in a streaming manner : "educator_code_redemption" */
  educator_code_redemption_stream: Array<Educator_Code_Redemption>;
  /** fetch data from the table in a streaming manner : "educator_code" */
  educator_code_stream: Array<Educator_Code>;
  /** fetch data from the table: "enums.coin_trx_category" */
  enums_coin_trx_category: Array<Enums_Coin_Trx_Category>;
  /** fetch aggregated fields from the table: "enums.coin_trx_category" */
  enums_coin_trx_category_aggregate: Enums_Coin_Trx_Category_Aggregate;
  /** fetch data from the table: "enums.coin_trx_category" using primary key columns */
  enums_coin_trx_category_by_pk?: Maybe<Enums_Coin_Trx_Category>;
  /** fetch data from the table in a streaming manner : "enums.coin_trx_category" */
  enums_coin_trx_category_stream: Array<Enums_Coin_Trx_Category>;
  /** fetch data from the table: "enums.integration_provider" */
  enums_integration_provider: Array<Enums_Integration_Provider>;
  /** fetch aggregated fields from the table: "enums.integration_provider" */
  enums_integration_provider_aggregate: Enums_Integration_Provider_Aggregate;
  /** fetch data from the table: "enums.integration_provider" using primary key columns */
  enums_integration_provider_by_pk?: Maybe<Enums_Integration_Provider>;
  /** fetch data from the table in a streaming manner : "enums.integration_provider" */
  enums_integration_provider_stream: Array<Enums_Integration_Provider>;
  /** fetch data from the table: "enums.project_status" */
  enums_project_status: Array<Enums_Project_Status>;
  /** fetch aggregated fields from the table: "enums.project_status" */
  enums_project_status_aggregate: Enums_Project_Status_Aggregate;
  /** fetch data from the table: "enums.project_status" using primary key columns */
  enums_project_status_by_pk?: Maybe<Enums_Project_Status>;
  /** fetch data from the table in a streaming manner : "enums.project_status" */
  enums_project_status_stream: Array<Enums_Project_Status>;
  /** fetch data from the table: "guide" */
  guide: Array<Guide>;
  /** fetch aggregated fields from the table: "guide" */
  guide_aggregate: Guide_Aggregate;
  /** fetch data from the table: "guide" using primary key columns */
  guide_by_pk?: Maybe<Guide>;
  /** fetch data from the table: "guide_path" */
  guide_path: Array<Guide_Path>;
  /** fetch aggregated fields from the table: "guide_path" */
  guide_path_aggregate: Guide_Path_Aggregate;
  /** fetch data from the table: "guide_path" using primary key columns */
  guide_path_by_pk?: Maybe<Guide_Path>;
  /** fetch data from the table in a streaming manner : "guide_path" */
  guide_path_stream: Array<Guide_Path>;
  /** fetch data from the table in a streaming manner : "guide" */
  guide_stream: Array<Guide>;
  /** fetch data from the table: "learner_group" */
  learner_group: Array<Learner_Group>;
  /** fetch aggregated fields from the table: "learner_group" */
  learner_group_aggregate: Learner_Group_Aggregate;
  /** fetch data from the table: "learner_group" using primary key columns */
  learner_group_by_pk?: Maybe<Learner_Group>;
  /** fetch data from the table: "learner_group_member" */
  learner_group_member: Array<Learner_Group_Member>;
  /** fetch aggregated fields from the table: "learner_group_member" */
  learner_group_member_aggregate: Learner_Group_Member_Aggregate;
  /** fetch data from the table: "learner_group_member" using primary key columns */
  learner_group_member_by_pk?: Maybe<Learner_Group_Member>;
  /** fetch data from the table in a streaming manner : "learner_group_member" */
  learner_group_member_stream: Array<Learner_Group_Member>;
  /** fetch data from the table: "learner_group_path_collection" */
  learner_group_path_collection: Array<Learner_Group_Path_Collection>;
  /** fetch aggregated fields from the table: "learner_group_path_collection" */
  learner_group_path_collection_aggregate: Learner_Group_Path_Collection_Aggregate;
  /** fetch data from the table: "learner_group_path_collection" using primary key columns */
  learner_group_path_collection_by_pk?: Maybe<Learner_Group_Path_Collection>;
  /** fetch data from the table in a streaming manner : "learner_group_path_collection" */
  learner_group_path_collection_stream: Array<Learner_Group_Path_Collection>;
  /** fetch data from the table: "learner_group_pending_member" */
  learner_group_pending_member: Array<Learner_Group_Pending_Member>;
  /** fetch aggregated fields from the table: "learner_group_pending_member" */
  learner_group_pending_member_aggregate: Learner_Group_Pending_Member_Aggregate;
  /** fetch data from the table: "learner_group_pending_member" using primary key columns */
  learner_group_pending_member_by_pk?: Maybe<Learner_Group_Pending_Member>;
  /** fetch data from the table in a streaming manner : "learner_group_pending_member" */
  learner_group_pending_member_stream: Array<Learner_Group_Pending_Member>;
  /** fetch data from the table in a streaming manner : "learner_group" */
  learner_group_stream: Array<Learner_Group>;
  /** execute function "list_latest_path_reviews" which returns "path_review" */
  list_latest_path_reviews: Array<Path_Review>;
  /** execute function "list_latest_path_reviews" and query aggregates on result of table type "path_review" */
  list_latest_path_reviews_aggregate: Path_Review_Aggregate;
  /** fetch data from the table: "livestream" */
  livestream: Array<Livestream>;
  /** fetch aggregated fields from the table: "livestream" */
  livestream_aggregate: Livestream_Aggregate;
  /** fetch data from the table: "livestream" using primary key columns */
  livestream_by_pk?: Maybe<Livestream>;
  /** fetch data from the table in a streaming manner : "livestream" */
  livestream_stream: Array<Livestream>;
  /** fetch data from the table: "lms" */
  lms: Array<Lms>;
  /** fetch aggregated fields from the table: "lms" */
  lms_aggregate: Lms_Aggregate;
  /** fetch data from the table: "lms" using primary key columns */
  lms_by_pk?: Maybe<Lms>;
  /** fetch data from the table in a streaming manner : "lms" */
  lms_stream: Array<Lms>;
  /** fetch data from the table: "mission" */
  mission: Array<Mission>;
  /** fetch aggregated fields from the table: "mission" */
  mission_aggregate: Mission_Aggregate;
  /** fetch data from the table: "mission_attachment" */
  mission_attachment: Array<Mission_Attachment>;
  /** fetch aggregated fields from the table: "mission_attachment" */
  mission_attachment_aggregate: Mission_Attachment_Aggregate;
  /** fetch data from the table: "mission_attachment" using primary key columns */
  mission_attachment_by_pk?: Maybe<Mission_Attachment>;
  /** fetch data from the table in a streaming manner : "mission_attachment" */
  mission_attachment_stream: Array<Mission_Attachment>;
  /** fetch data from the table: "mission" using primary key columns */
  mission_by_pk?: Maybe<Mission>;
  /** fetch data from the table: "mission_challenge" */
  mission_challenge: Array<Mission_Challenge>;
  /** fetch aggregated fields from the table: "mission_challenge" */
  mission_challenge_aggregate: Mission_Challenge_Aggregate;
  /** fetch data from the table: "mission_challenge" using primary key columns */
  mission_challenge_by_pk?: Maybe<Mission_Challenge>;
  /** fetch data from the table in a streaming manner : "mission_challenge" */
  mission_challenge_stream: Array<Mission_Challenge>;
  /** fetch data from the table: "mission_comment" */
  mission_comment: Array<Mission_Comment>;
  /** fetch aggregated fields from the table: "mission_comment" */
  mission_comment_aggregate: Mission_Comment_Aggregate;
  /** fetch data from the table: "mission_comment" using primary key columns */
  mission_comment_by_pk?: Maybe<Mission_Comment>;
  /** fetch data from the table in a streaming manner : "mission_comment" */
  mission_comment_stream: Array<Mission_Comment>;
  /** fetch data from the table in a streaming manner : "mission" */
  mission_stream: Array<Mission>;
  /** fetch data from the table: "organization" */
  organization: Array<Organization>;
  /** fetch aggregated fields from the table: "organization" */
  organization_aggregate: Organization_Aggregate;
  /** fetch data from the table: "organization" using primary key columns */
  organization_by_pk?: Maybe<Organization>;
  /** fetch data from the table: "organization_domain" */
  organization_domain: Array<Organization_Domain>;
  /** fetch aggregated fields from the table: "organization_domain" */
  organization_domain_aggregate: Organization_Domain_Aggregate;
  /** fetch data from the table: "organization_domain" using primary key columns */
  organization_domain_by_pk?: Maybe<Organization_Domain>;
  /** fetch data from the table in a streaming manner : "organization_domain" */
  organization_domain_stream: Array<Organization_Domain>;
  /** fetch data from the table in a streaming manner : "organization" */
  organization_stream: Array<Organization>;
  /** fetch data from the table: "path" */
  path: Array<Path>;
  /** fetch data from the table: "path_active_user" */
  path_active_user: Array<Path_Active_User>;
  /** fetch aggregated fields from the table: "path_active_user" */
  path_active_user_aggregate: Path_Active_User_Aggregate;
  /** fetch data from the table: "path_active_user" using primary key columns */
  path_active_user_by_pk?: Maybe<Path_Active_User>;
  /** fetch data from the table in a streaming manner : "path_active_user" */
  path_active_user_stream: Array<Path_Active_User>;
  /** fetch data from the table: "path_activity" */
  path_activity: Array<Path_Activity>;
  /** fetch aggregated fields from the table: "path_activity" */
  path_activity_aggregate: Path_Activity_Aggregate;
  /** fetch data from the table: "path_activity" using primary key columns */
  path_activity_by_pk?: Maybe<Path_Activity>;
  /** fetch data from the table in a streaming manner : "path_activity" */
  path_activity_stream: Array<Path_Activity>;
  /** fetch aggregated fields from the table: "path" */
  path_aggregate: Path_Aggregate;
  /** fetch data from the table: "path_author" */
  path_author: Array<Path_Author>;
  /** fetch aggregated fields from the table: "path_author" */
  path_author_aggregate: Path_Author_Aggregate;
  /** fetch data from the table: "path_author" using primary key columns */
  path_author_by_pk?: Maybe<Path_Author>;
  /** fetch data from the table in a streaming manner : "path_author" */
  path_author_stream: Array<Path_Author>;
  /** fetch data from the table: "path" using primary key columns */
  path_by_pk?: Maybe<Path>;
  /** fetch data from the table: "path_collection" */
  path_collection: Array<Path_Collection>;
  /** fetch aggregated fields from the table: "path_collection" */
  path_collection_aggregate: Path_Collection_Aggregate;
  /** fetch data from the table: "path_collection" using primary key columns */
  path_collection_by_pk?: Maybe<Path_Collection>;
  /** fetch data from the table: "path_collection_item" */
  path_collection_item: Array<Path_Collection_Item>;
  /** fetch aggregated fields from the table: "path_collection_item" */
  path_collection_item_aggregate: Path_Collection_Item_Aggregate;
  /** fetch data from the table: "path_collection_item" using primary key columns */
  path_collection_item_by_pk?: Maybe<Path_Collection_Item>;
  /** fetch data from the table in a streaming manner : "path_collection_item" */
  path_collection_item_stream: Array<Path_Collection_Item>;
  /** fetch data from the table in a streaming manner : "path_collection" */
  path_collection_stream: Array<Path_Collection>;
  /** fetch data from the table: "path_feed" */
  path_feed: Array<Path_Feed>;
  /** fetch aggregated fields from the table: "path_feed" */
  path_feed_aggregate: Path_Feed_Aggregate;
  /** fetch data from the table: "path_feed" using primary key columns */
  path_feed_by_pk?: Maybe<Path_Feed>;
  /** fetch data from the table in a streaming manner : "path_feed" */
  path_feed_stream: Array<Path_Feed>;
  /** fetch data from the table: "path_node" */
  path_node: Array<Path_Node>;
  /** fetch aggregated fields from the table: "path_node" */
  path_node_aggregate: Path_Node_Aggregate;
  /** fetch data from the table: "path_node" using primary key columns */
  path_node_by_pk?: Maybe<Path_Node>;
  /** fetch data from the table: "path_node_comment" */
  path_node_comment: Array<Path_Node_Comment>;
  /** fetch aggregated fields from the table: "path_node_comment" */
  path_node_comment_aggregate: Path_Node_Comment_Aggregate;
  /** fetch data from the table: "path_node_comment" using primary key columns */
  path_node_comment_by_pk?: Maybe<Path_Node_Comment>;
  /** fetch data from the table in a streaming manner : "path_node_comment" */
  path_node_comment_stream: Array<Path_Node_Comment>;
  /** fetch data from the table in a streaming manner : "path_node" */
  path_node_stream: Array<Path_Node>;
  /** fetch data from the table: "path_review" */
  path_review: Array<Path_Review>;
  /** fetch aggregated fields from the table: "path_review" */
  path_review_aggregate: Path_Review_Aggregate;
  /** fetch data from the table: "path_review" using primary key columns */
  path_review_by_pk?: Maybe<Path_Review>;
  /** fetch data from the table in a streaming manner : "path_review" */
  path_review_stream: Array<Path_Review>;
  /** fetch data from the table in a streaming manner : "path" */
  path_stream: Array<Path>;
  /** fetch data from the table: "project" */
  project: Array<Project>;
  /** fetch aggregated fields from the table: "project" */
  project_aggregate: Project_Aggregate;
  /** fetch data from the table: "project_award" */
  project_award: Array<Project_Award>;
  /** fetch aggregated fields from the table: "project_award" */
  project_award_aggregate: Project_Award_Aggregate;
  /** fetch data from the table: "project_award" using primary key columns */
  project_award_by_pk?: Maybe<Project_Award>;
  /** fetch data from the table in a streaming manner : "project_award" */
  project_award_stream: Array<Project_Award>;
  /** fetch data from the table: "project" using primary key columns */
  project_by_pk?: Maybe<Project>;
  /** fetch data from the table: "project_comment" */
  project_comment: Array<Project_Comment>;
  /** fetch aggregated fields from the table: "project_comment" */
  project_comment_aggregate: Project_Comment_Aggregate;
  /** fetch data from the table: "project_comment" using primary key columns */
  project_comment_by_pk?: Maybe<Project_Comment>;
  /** fetch data from the table in a streaming manner : "project_comment" */
  project_comment_stream: Array<Project_Comment>;
  /** fetch data from the table: "project_reaction" */
  project_reaction: Array<Project_Reaction>;
  /** fetch aggregated fields from the table: "project_reaction" */
  project_reaction_aggregate: Project_Reaction_Aggregate;
  /** fetch data from the table: "project_reaction" using primary key columns */
  project_reaction_by_pk?: Maybe<Project_Reaction>;
  /** fetch data from the table in a streaming manner : "project_reaction" */
  project_reaction_stream: Array<Project_Reaction>;
  /** fetch data from the table: "project_stats" */
  project_stats: Array<Project_Stats>;
  /** fetch aggregated fields from the table: "project_stats" */
  project_stats_aggregate: Project_Stats_Aggregate;
  /** fetch data from the table: "project_stats" using primary key columns */
  project_stats_by_pk?: Maybe<Project_Stats>;
  /** fetch data from the table in a streaming manner : "project_stats" */
  project_stats_stream: Array<Project_Stats>;
  /** fetch data from the table in a streaming manner : "project" */
  project_stream: Array<Project>;
  /** execute function "search_organizations" which returns "organization" */
  search_organizations: Array<Organization>;
  /** execute function "search_organizations" and query aggregates on result of table type "organization" */
  search_organizations_aggregate: Organization_Aggregate;
  /** fetch data from the table: "shop_item" */
  shop_item: Array<Shop_Item>;
  /** fetch aggregated fields from the table: "shop_item" */
  shop_item_aggregate: Shop_Item_Aggregate;
  /** fetch data from the table: "shop_item" using primary key columns */
  shop_item_by_pk?: Maybe<Shop_Item>;
  /** fetch data from the table: "shop_item_purchase" */
  shop_item_purchase: Array<Shop_Item_Purchase>;
  /** fetch aggregated fields from the table: "shop_item_purchase" */
  shop_item_purchase_aggregate: Shop_Item_Purchase_Aggregate;
  /** fetch data from the table: "shop_item_purchase" using primary key columns */
  shop_item_purchase_by_pk?: Maybe<Shop_Item_Purchase>;
  /** fetch data from the table in a streaming manner : "shop_item_purchase" */
  shop_item_purchase_stream: Array<Shop_Item_Purchase>;
  /** fetch data from the table in a streaming manner : "shop_item" */
  shop_item_stream: Array<Shop_Item>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user_award" */
  user_award: Array<User_Award>;
  /** fetch aggregated fields from the table: "user_award" */
  user_award_aggregate: User_Award_Aggregate;
  /** fetch data from the table: "user_award" using primary key columns */
  user_award_by_pk?: Maybe<User_Award>;
  /** fetch data from the table in a streaming manner : "user_award" */
  user_award_stream: Array<User_Award>;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table: "user_file" */
  user_file: Array<User_File>;
  /** fetch aggregated fields from the table: "user_file" */
  user_file_aggregate: User_File_Aggregate;
  /** fetch data from the table: "user_file" using primary key columns */
  user_file_by_pk?: Maybe<User_File>;
  /** fetch data from the table: "user_file_integration" */
  user_file_integration: Array<User_File_Integration>;
  /** fetch aggregated fields from the table: "user_file_integration" */
  user_file_integration_aggregate: User_File_Integration_Aggregate;
  /** fetch data from the table: "user_file_integration" using primary key columns */
  user_file_integration_by_pk?: Maybe<User_File_Integration>;
  /** fetch data from the table in a streaming manner : "user_file_integration" */
  user_file_integration_stream: Array<User_File_Integration>;
  /** fetch data from the table in a streaming manner : "user_file" */
  user_file_stream: Array<User_File>;
  /** fetch data from the table: "user_file_transform" */
  user_file_transform: Array<User_File_Transform>;
  /** fetch aggregated fields from the table: "user_file_transform" */
  user_file_transform_aggregate: User_File_Transform_Aggregate;
  /** fetch data from the table: "user_file_transform" using primary key columns */
  user_file_transform_by_pk?: Maybe<User_File_Transform>;
  /** fetch data from the table in a streaming manner : "user_file_transform" */
  user_file_transform_stream: Array<User_File_Transform>;
  /** fetch data from the table: "user_follow" */
  user_follow: Array<User_Follow>;
  /** fetch aggregated fields from the table: "user_follow" */
  user_follow_aggregate: User_Follow_Aggregate;
  /** fetch data from the table: "user_follow" using primary key columns */
  user_follow_by_pk?: Maybe<User_Follow>;
  /** fetch data from the table in a streaming manner : "user_follow" */
  user_follow_stream: Array<User_Follow>;
  /** fetch data from the table: "user_integration" */
  user_integration: Array<User_Integration>;
  /** fetch aggregated fields from the table: "user_integration" */
  user_integration_aggregate: User_Integration_Aggregate;
  /** fetch data from the table: "user_integration" using primary key columns */
  user_integration_by_pk?: Maybe<User_Integration>;
  /** fetch data from the table in a streaming manner : "user_integration" */
  user_integration_stream: Array<User_Integration>;
  /** fetch data from the table: "user_path" */
  user_path: Array<User_Path>;
  /** fetch aggregated fields from the table: "user_path" */
  user_path_aggregate: User_Path_Aggregate;
  /** fetch data from the table: "user_path" using primary key columns */
  user_path_by_pk?: Maybe<User_Path>;
  /** fetch data from the table in a streaming manner : "user_path" */
  user_path_stream: Array<User_Path>;
  /** fetch data from the table in a streaming manner : "user" */
  user_stream: Array<User>;
  /** fetch data from the table: "user_subscription" */
  user_subscription: Array<User_Subscription>;
  /** fetch aggregated fields from the table: "user_subscription" */
  user_subscription_aggregate: User_Subscription_Aggregate;
  /** fetch data from the table: "user_subscription" using primary key columns */
  user_subscription_by_pk?: Maybe<User_Subscription>;
  /** fetch data from the table in a streaming manner : "user_subscription" */
  user_subscription_stream: Array<User_Subscription>;
  /** fetch data from the table: "user_teacher" */
  user_teacher: Array<User_Teacher>;
  /** fetch aggregated fields from the table: "user_teacher" */
  user_teacher_aggregate: User_Teacher_Aggregate;
  /** fetch data from the table: "user_teacher" using primary key columns */
  user_teacher_by_pk?: Maybe<User_Teacher>;
  /** fetch data from the table in a streaming manner : "user_teacher" */
  user_teacher_stream: Array<User_Teacher>;
  /** fetch data from the table: "view_top_creators_by_followers_count" */
  view_top_creators_by_followers_count: Array<View_Top_Creators_By_Followers_Count>;
  /** fetch aggregated fields from the table: "view_top_creators_by_followers_count" */
  view_top_creators_by_followers_count_aggregate: View_Top_Creators_By_Followers_Count_Aggregate;
  /** fetch data from the table in a streaming manner : "view_top_creators_by_followers_count" */
  view_top_creators_by_followers_count_stream: Array<View_Top_Creators_By_Followers_Count>;
};


export type Subscription_RootAssignmentArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Order_By>>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};


export type Subscription_RootAssignment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Order_By>>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};


export type Subscription_RootAssignment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAssignment_Learner_GroupArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Learner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Learner_Group_Order_By>>;
  where?: InputMaybe<Assignment_Learner_Group_Bool_Exp>;
};


export type Subscription_RootAssignment_Learner_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Learner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Learner_Group_Order_By>>;
  where?: InputMaybe<Assignment_Learner_Group_Bool_Exp>;
};


export type Subscription_RootAssignment_Learner_Group_By_PkArgs = {
  assignmentId: Scalars['uuid'];
  learnerGroupId: Scalars['uuid'];
};


export type Subscription_RootAssignment_Learner_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Assignment_Learner_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Assignment_Learner_Group_Bool_Exp>;
};


export type Subscription_RootAssignment_PathArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Path_Order_By>>;
  where?: InputMaybe<Assignment_Path_Bool_Exp>;
};


export type Subscription_RootAssignment_Path_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assignment_Path_Order_By>>;
  where?: InputMaybe<Assignment_Path_Bool_Exp>;
};


export type Subscription_RootAssignment_Path_By_PkArgs = {
  assignmentId: Scalars['uuid'];
  pathId: Scalars['bigint'];
};


export type Subscription_RootAssignment_Path_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Assignment_Path_Stream_Cursor_Input>>;
  where?: InputMaybe<Assignment_Path_Bool_Exp>;
};


export type Subscription_RootAssignment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Assignment_Stream_Cursor_Input>>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};


export type Subscription_RootAwardArgs = {
  distinct_on?: InputMaybe<Array<Award_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Order_By>>;
  where?: InputMaybe<Award_Bool_Exp>;
};


export type Subscription_RootAward_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Award_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Order_By>>;
  where?: InputMaybe<Award_Bool_Exp>;
};


export type Subscription_RootAward_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAward_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Award_Stream_Cursor_Input>>;
  where?: InputMaybe<Award_Bool_Exp>;
};


export type Subscription_RootCoin_TrxArgs = {
  distinct_on?: InputMaybe<Array<Coin_Trx_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Coin_Trx_Order_By>>;
  where?: InputMaybe<Coin_Trx_Bool_Exp>;
};


export type Subscription_RootCoin_Trx_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coin_Trx_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Coin_Trx_Order_By>>;
  where?: InputMaybe<Coin_Trx_Bool_Exp>;
};


export type Subscription_RootCoin_Trx_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCoin_Trx_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Coin_Trx_Stream_Cursor_Input>>;
  where?: InputMaybe<Coin_Trx_Bool_Exp>;
};


export type Subscription_RootCommentArgs = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comment_Order_By>>;
  where?: InputMaybe<Comment_Bool_Exp>;
};


export type Subscription_RootComment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comment_Order_By>>;
  where?: InputMaybe<Comment_Bool_Exp>;
};


export type Subscription_RootComment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootComment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Comment_Stream_Cursor_Input>>;
  where?: InputMaybe<Comment_Bool_Exp>;
};


export type Subscription_RootEducator_CodeArgs = {
  distinct_on?: InputMaybe<Array<Educator_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Educator_Code_Order_By>>;
  where?: InputMaybe<Educator_Code_Bool_Exp>;
};


export type Subscription_RootEducator_Code_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Educator_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Educator_Code_Order_By>>;
  where?: InputMaybe<Educator_Code_Bool_Exp>;
};


export type Subscription_RootEducator_Code_By_PkArgs = {
  code: Scalars['String'];
};


export type Subscription_RootEducator_Code_RedemptionArgs = {
  distinct_on?: InputMaybe<Array<Educator_Code_Redemption_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Educator_Code_Redemption_Order_By>>;
  where?: InputMaybe<Educator_Code_Redemption_Bool_Exp>;
};


export type Subscription_RootEducator_Code_Redemption_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Educator_Code_Redemption_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Educator_Code_Redemption_Order_By>>;
  where?: InputMaybe<Educator_Code_Redemption_Bool_Exp>;
};


export type Subscription_RootEducator_Code_Redemption_By_PkArgs = {
  code: Scalars['String'];
  userId: Scalars['String'];
};


export type Subscription_RootEducator_Code_Redemption_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Educator_Code_Redemption_Stream_Cursor_Input>>;
  where?: InputMaybe<Educator_Code_Redemption_Bool_Exp>;
};


export type Subscription_RootEducator_Code_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Educator_Code_Stream_Cursor_Input>>;
  where?: InputMaybe<Educator_Code_Bool_Exp>;
};


export type Subscription_RootEnums_Coin_Trx_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Enums_Coin_Trx_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enums_Coin_Trx_Category_Order_By>>;
  where?: InputMaybe<Enums_Coin_Trx_Category_Bool_Exp>;
};


export type Subscription_RootEnums_Coin_Trx_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enums_Coin_Trx_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enums_Coin_Trx_Category_Order_By>>;
  where?: InputMaybe<Enums_Coin_Trx_Category_Bool_Exp>;
};


export type Subscription_RootEnums_Coin_Trx_Category_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEnums_Coin_Trx_Category_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Enums_Coin_Trx_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Enums_Coin_Trx_Category_Bool_Exp>;
};


export type Subscription_RootEnums_Integration_ProviderArgs = {
  distinct_on?: InputMaybe<Array<Enums_Integration_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enums_Integration_Provider_Order_By>>;
  where?: InputMaybe<Enums_Integration_Provider_Bool_Exp>;
};


export type Subscription_RootEnums_Integration_Provider_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enums_Integration_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enums_Integration_Provider_Order_By>>;
  where?: InputMaybe<Enums_Integration_Provider_Bool_Exp>;
};


export type Subscription_RootEnums_Integration_Provider_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEnums_Integration_Provider_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Enums_Integration_Provider_Stream_Cursor_Input>>;
  where?: InputMaybe<Enums_Integration_Provider_Bool_Exp>;
};


export type Subscription_RootEnums_Project_StatusArgs = {
  distinct_on?: InputMaybe<Array<Enums_Project_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enums_Project_Status_Order_By>>;
  where?: InputMaybe<Enums_Project_Status_Bool_Exp>;
};


export type Subscription_RootEnums_Project_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enums_Project_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enums_Project_Status_Order_By>>;
  where?: InputMaybe<Enums_Project_Status_Bool_Exp>;
};


export type Subscription_RootEnums_Project_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEnums_Project_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Enums_Project_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Enums_Project_Status_Bool_Exp>;
};


export type Subscription_RootGuideArgs = {
  distinct_on?: InputMaybe<Array<Guide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guide_Order_By>>;
  where?: InputMaybe<Guide_Bool_Exp>;
};


export type Subscription_RootGuide_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Guide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guide_Order_By>>;
  where?: InputMaybe<Guide_Bool_Exp>;
};


export type Subscription_RootGuide_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGuide_PathArgs = {
  distinct_on?: InputMaybe<Array<Guide_Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guide_Path_Order_By>>;
  where?: InputMaybe<Guide_Path_Bool_Exp>;
};


export type Subscription_RootGuide_Path_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Guide_Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guide_Path_Order_By>>;
  where?: InputMaybe<Guide_Path_Bool_Exp>;
};


export type Subscription_RootGuide_Path_By_PkArgs = {
  guideId: Scalars['uuid'];
  pathId: Scalars['bigint'];
};


export type Subscription_RootGuide_Path_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Guide_Path_Stream_Cursor_Input>>;
  where?: InputMaybe<Guide_Path_Bool_Exp>;
};


export type Subscription_RootGuide_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Guide_Stream_Cursor_Input>>;
  where?: InputMaybe<Guide_Bool_Exp>;
};


export type Subscription_RootLearner_GroupArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Order_By>>;
  where?: InputMaybe<Learner_Group_Bool_Exp>;
};


export type Subscription_RootLearner_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Order_By>>;
  where?: InputMaybe<Learner_Group_Bool_Exp>;
};


export type Subscription_RootLearner_Group_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLearner_Group_MemberArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Member_Order_By>>;
  where?: InputMaybe<Learner_Group_Member_Bool_Exp>;
};


export type Subscription_RootLearner_Group_Member_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Member_Order_By>>;
  where?: InputMaybe<Learner_Group_Member_Bool_Exp>;
};


export type Subscription_RootLearner_Group_Member_By_PkArgs = {
  learnerGroupId: Scalars['uuid'];
  userId: Scalars['String'];
};


export type Subscription_RootLearner_Group_Member_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Learner_Group_Member_Stream_Cursor_Input>>;
  where?: InputMaybe<Learner_Group_Member_Bool_Exp>;
};


export type Subscription_RootLearner_Group_Path_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Path_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Path_Collection_Order_By>>;
  where?: InputMaybe<Learner_Group_Path_Collection_Bool_Exp>;
};


export type Subscription_RootLearner_Group_Path_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Path_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Path_Collection_Order_By>>;
  where?: InputMaybe<Learner_Group_Path_Collection_Bool_Exp>;
};


export type Subscription_RootLearner_Group_Path_Collection_By_PkArgs = {
  learnerGroupId: Scalars['uuid'];
};


export type Subscription_RootLearner_Group_Path_Collection_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Learner_Group_Path_Collection_Stream_Cursor_Input>>;
  where?: InputMaybe<Learner_Group_Path_Collection_Bool_Exp>;
};


export type Subscription_RootLearner_Group_Pending_MemberArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Pending_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Pending_Member_Order_By>>;
  where?: InputMaybe<Learner_Group_Pending_Member_Bool_Exp>;
};


export type Subscription_RootLearner_Group_Pending_Member_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Pending_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Pending_Member_Order_By>>;
  where?: InputMaybe<Learner_Group_Pending_Member_Bool_Exp>;
};


export type Subscription_RootLearner_Group_Pending_Member_By_PkArgs = {
  foreignId: Scalars['String'];
  learnerGroupId: Scalars['uuid'];
  provider: Enums_Integration_Provider_Enum;
};


export type Subscription_RootLearner_Group_Pending_Member_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Learner_Group_Pending_Member_Stream_Cursor_Input>>;
  where?: InputMaybe<Learner_Group_Pending_Member_Bool_Exp>;
};


export type Subscription_RootLearner_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Learner_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Learner_Group_Bool_Exp>;
};


export type Subscription_RootList_Latest_Path_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Path_Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Review_Order_By>>;
  where?: InputMaybe<Path_Review_Bool_Exp>;
};


export type Subscription_RootList_Latest_Path_Reviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Review_Order_By>>;
  where?: InputMaybe<Path_Review_Bool_Exp>;
};


export type Subscription_RootLivestreamArgs = {
  distinct_on?: InputMaybe<Array<Livestream_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Livestream_Order_By>>;
  where?: InputMaybe<Livestream_Bool_Exp>;
};


export type Subscription_RootLivestream_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Livestream_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Livestream_Order_By>>;
  where?: InputMaybe<Livestream_Bool_Exp>;
};


export type Subscription_RootLivestream_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLivestream_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Livestream_Stream_Cursor_Input>>;
  where?: InputMaybe<Livestream_Bool_Exp>;
};


export type Subscription_RootLmsArgs = {
  distinct_on?: InputMaybe<Array<Lms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lms_Order_By>>;
  where?: InputMaybe<Lms_Bool_Exp>;
};


export type Subscription_RootLms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lms_Order_By>>;
  where?: InputMaybe<Lms_Bool_Exp>;
};


export type Subscription_RootLms_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLms_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Lms_Stream_Cursor_Input>>;
  where?: InputMaybe<Lms_Bool_Exp>;
};


export type Subscription_RootMissionArgs = {
  distinct_on?: InputMaybe<Array<Mission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Order_By>>;
  where?: InputMaybe<Mission_Bool_Exp>;
};


export type Subscription_RootMission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Order_By>>;
  where?: InputMaybe<Mission_Bool_Exp>;
};


export type Subscription_RootMission_AttachmentArgs = {
  distinct_on?: InputMaybe<Array<Mission_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Attachment_Order_By>>;
  where?: InputMaybe<Mission_Attachment_Bool_Exp>;
};


export type Subscription_RootMission_Attachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mission_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Attachment_Order_By>>;
  where?: InputMaybe<Mission_Attachment_Bool_Exp>;
};


export type Subscription_RootMission_Attachment_By_PkArgs = {
  fileId: Scalars['uuid'];
  missionId: Scalars['Int'];
};


export type Subscription_RootMission_Attachment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mission_Attachment_Stream_Cursor_Input>>;
  where?: InputMaybe<Mission_Attachment_Bool_Exp>;
};


export type Subscription_RootMission_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootMission_ChallengeArgs = {
  distinct_on?: InputMaybe<Array<Mission_Challenge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Challenge_Order_By>>;
  where?: InputMaybe<Mission_Challenge_Bool_Exp>;
};


export type Subscription_RootMission_Challenge_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mission_Challenge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Challenge_Order_By>>;
  where?: InputMaybe<Mission_Challenge_Bool_Exp>;
};


export type Subscription_RootMission_Challenge_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootMission_Challenge_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mission_Challenge_Stream_Cursor_Input>>;
  where?: InputMaybe<Mission_Challenge_Bool_Exp>;
};


export type Subscription_RootMission_CommentArgs = {
  distinct_on?: InputMaybe<Array<Mission_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Comment_Order_By>>;
  where?: InputMaybe<Mission_Comment_Bool_Exp>;
};


export type Subscription_RootMission_Comment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mission_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Comment_Order_By>>;
  where?: InputMaybe<Mission_Comment_Bool_Exp>;
};


export type Subscription_RootMission_Comment_By_PkArgs = {
  commentId: Scalars['uuid'];
};


export type Subscription_RootMission_Comment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mission_Comment_Stream_Cursor_Input>>;
  where?: InputMaybe<Mission_Comment_Bool_Exp>;
};


export type Subscription_RootMission_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mission_Stream_Cursor_Input>>;
  where?: InputMaybe<Mission_Bool_Exp>;
};


export type Subscription_RootOrganizationArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootOrganization_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootOrganization_By_PkArgs = {
  firestoreId: Scalars['String'];
};


export type Subscription_RootOrganization_DomainArgs = {
  distinct_on?: InputMaybe<Array<Organization_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Domain_Order_By>>;
  where?: InputMaybe<Organization_Domain_Bool_Exp>;
};


export type Subscription_RootOrganization_Domain_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Domain_Order_By>>;
  where?: InputMaybe<Organization_Domain_Bool_Exp>;
};


export type Subscription_RootOrganization_Domain_By_PkArgs = {
  domain: Scalars['String'];
  orgId: Scalars['String'];
};


export type Subscription_RootOrganization_Domain_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organization_Domain_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Domain_Bool_Exp>;
};


export type Subscription_RootOrganization_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organization_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootPathArgs = {
  distinct_on?: InputMaybe<Array<Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Order_By>>;
  where?: InputMaybe<Path_Bool_Exp>;
};


export type Subscription_RootPath_Active_UserArgs = {
  distinct_on?: InputMaybe<Array<Path_Active_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Active_User_Order_By>>;
  where?: InputMaybe<Path_Active_User_Bool_Exp>;
};


export type Subscription_RootPath_Active_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Active_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Active_User_Order_By>>;
  where?: InputMaybe<Path_Active_User_Bool_Exp>;
};


export type Subscription_RootPath_Active_User_By_PkArgs = {
  pathId: Scalars['bigint'];
  userId: Scalars['String'];
};


export type Subscription_RootPath_Active_User_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Path_Active_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Path_Active_User_Bool_Exp>;
};


export type Subscription_RootPath_ActivityArgs = {
  distinct_on?: InputMaybe<Array<Path_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Activity_Order_By>>;
  where?: InputMaybe<Path_Activity_Bool_Exp>;
};


export type Subscription_RootPath_Activity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Activity_Order_By>>;
  where?: InputMaybe<Path_Activity_Bool_Exp>;
};


export type Subscription_RootPath_Activity_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPath_Activity_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Path_Activity_Stream_Cursor_Input>>;
  where?: InputMaybe<Path_Activity_Bool_Exp>;
};


export type Subscription_RootPath_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Order_By>>;
  where?: InputMaybe<Path_Bool_Exp>;
};


export type Subscription_RootPath_AuthorArgs = {
  distinct_on?: InputMaybe<Array<Path_Author_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Author_Order_By>>;
  where?: InputMaybe<Path_Author_Bool_Exp>;
};


export type Subscription_RootPath_Author_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Author_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Author_Order_By>>;
  where?: InputMaybe<Path_Author_Bool_Exp>;
};


export type Subscription_RootPath_Author_By_PkArgs = {
  pathId: Scalars['bigint'];
  userId: Scalars['String'];
};


export type Subscription_RootPath_Author_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Path_Author_Stream_Cursor_Input>>;
  where?: InputMaybe<Path_Author_Bool_Exp>;
};


export type Subscription_RootPath_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPath_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Path_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Collection_Order_By>>;
  where?: InputMaybe<Path_Collection_Bool_Exp>;
};


export type Subscription_RootPath_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Collection_Order_By>>;
  where?: InputMaybe<Path_Collection_Bool_Exp>;
};


export type Subscription_RootPath_Collection_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPath_Collection_ItemArgs = {
  distinct_on?: InputMaybe<Array<Path_Collection_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Collection_Item_Order_By>>;
  where?: InputMaybe<Path_Collection_Item_Bool_Exp>;
};


export type Subscription_RootPath_Collection_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Collection_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Collection_Item_Order_By>>;
  where?: InputMaybe<Path_Collection_Item_Bool_Exp>;
};


export type Subscription_RootPath_Collection_Item_By_PkArgs = {
  collectionId: Scalars['uuid'];
  pathId: Scalars['bigint'];
};


export type Subscription_RootPath_Collection_Item_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Path_Collection_Item_Stream_Cursor_Input>>;
  where?: InputMaybe<Path_Collection_Item_Bool_Exp>;
};


export type Subscription_RootPath_Collection_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Path_Collection_Stream_Cursor_Input>>;
  where?: InputMaybe<Path_Collection_Bool_Exp>;
};


export type Subscription_RootPath_FeedArgs = {
  distinct_on?: InputMaybe<Array<Path_Feed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Feed_Order_By>>;
  where?: InputMaybe<Path_Feed_Bool_Exp>;
};


export type Subscription_RootPath_Feed_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Feed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Feed_Order_By>>;
  where?: InputMaybe<Path_Feed_Bool_Exp>;
};


export type Subscription_RootPath_Feed_By_PkArgs = {
  pathId: Scalars['bigint'];
  slug: Scalars['String'];
};


export type Subscription_RootPath_Feed_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Path_Feed_Stream_Cursor_Input>>;
  where?: InputMaybe<Path_Feed_Bool_Exp>;
};


export type Subscription_RootPath_NodeArgs = {
  distinct_on?: InputMaybe<Array<Path_Node_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Node_Order_By>>;
  where?: InputMaybe<Path_Node_Bool_Exp>;
};


export type Subscription_RootPath_Node_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Node_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Node_Order_By>>;
  where?: InputMaybe<Path_Node_Bool_Exp>;
};


export type Subscription_RootPath_Node_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPath_Node_CommentArgs = {
  distinct_on?: InputMaybe<Array<Path_Node_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Node_Comment_Order_By>>;
  where?: InputMaybe<Path_Node_Comment_Bool_Exp>;
};


export type Subscription_RootPath_Node_Comment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Node_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Node_Comment_Order_By>>;
  where?: InputMaybe<Path_Node_Comment_Bool_Exp>;
};


export type Subscription_RootPath_Node_Comment_By_PkArgs = {
  commentId: Scalars['uuid'];
};


export type Subscription_RootPath_Node_Comment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Path_Node_Comment_Stream_Cursor_Input>>;
  where?: InputMaybe<Path_Node_Comment_Bool_Exp>;
};


export type Subscription_RootPath_Node_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Path_Node_Stream_Cursor_Input>>;
  where?: InputMaybe<Path_Node_Bool_Exp>;
};


export type Subscription_RootPath_ReviewArgs = {
  distinct_on?: InputMaybe<Array<Path_Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Review_Order_By>>;
  where?: InputMaybe<Path_Review_Bool_Exp>;
};


export type Subscription_RootPath_Review_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Review_Order_By>>;
  where?: InputMaybe<Path_Review_Bool_Exp>;
};


export type Subscription_RootPath_Review_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPath_Review_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Path_Review_Stream_Cursor_Input>>;
  where?: InputMaybe<Path_Review_Bool_Exp>;
};


export type Subscription_RootPath_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Path_Stream_Cursor_Input>>;
  where?: InputMaybe<Path_Bool_Exp>;
};


export type Subscription_RootProjectArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Subscription_RootProject_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Subscription_RootProject_AwardArgs = {
  distinct_on?: InputMaybe<Array<Project_Award_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Award_Order_By>>;
  where?: InputMaybe<Project_Award_Bool_Exp>;
};


export type Subscription_RootProject_Award_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Award_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Award_Order_By>>;
  where?: InputMaybe<Project_Award_Bool_Exp>;
};


export type Subscription_RootProject_Award_By_PkArgs = {
  awardId: Scalars['uuid'];
  projectId: Scalars['uuid'];
};


export type Subscription_RootProject_Award_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Award_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Award_Bool_Exp>;
};


export type Subscription_RootProject_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProject_CommentArgs = {
  distinct_on?: InputMaybe<Array<Project_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Comment_Order_By>>;
  where?: InputMaybe<Project_Comment_Bool_Exp>;
};


export type Subscription_RootProject_Comment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Comment_Order_By>>;
  where?: InputMaybe<Project_Comment_Bool_Exp>;
};


export type Subscription_RootProject_Comment_By_PkArgs = {
  commentId: Scalars['uuid'];
};


export type Subscription_RootProject_Comment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Comment_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Comment_Bool_Exp>;
};


export type Subscription_RootProject_ReactionArgs = {
  distinct_on?: InputMaybe<Array<Project_Reaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Reaction_Order_By>>;
  where?: InputMaybe<Project_Reaction_Bool_Exp>;
};


export type Subscription_RootProject_Reaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Reaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Reaction_Order_By>>;
  where?: InputMaybe<Project_Reaction_Bool_Exp>;
};


export type Subscription_RootProject_Reaction_By_PkArgs = {
  projectId: Scalars['uuid'];
  userId: Scalars['String'];
};


export type Subscription_RootProject_Reaction_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Reaction_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Reaction_Bool_Exp>;
};


export type Subscription_RootProject_StatsArgs = {
  distinct_on?: InputMaybe<Array<Project_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Stats_Order_By>>;
  where?: InputMaybe<Project_Stats_Bool_Exp>;
};


export type Subscription_RootProject_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Stats_Order_By>>;
  where?: InputMaybe<Project_Stats_Bool_Exp>;
};


export type Subscription_RootProject_Stats_By_PkArgs = {
  projectId: Scalars['uuid'];
};


export type Subscription_RootProject_Stats_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Stats_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Stats_Bool_Exp>;
};


export type Subscription_RootProject_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Subscription_RootSearch_OrganizationsArgs = {
  args: Search_Organizations_Args;
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootSearch_Organizations_AggregateArgs = {
  args: Search_Organizations_Args;
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootShop_ItemArgs = {
  distinct_on?: InputMaybe<Array<Shop_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Item_Order_By>>;
  where?: InputMaybe<Shop_Item_Bool_Exp>;
};


export type Subscription_RootShop_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Item_Order_By>>;
  where?: InputMaybe<Shop_Item_Bool_Exp>;
};


export type Subscription_RootShop_Item_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootShop_Item_PurchaseArgs = {
  distinct_on?: InputMaybe<Array<Shop_Item_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Item_Purchase_Order_By>>;
  where?: InputMaybe<Shop_Item_Purchase_Bool_Exp>;
};


export type Subscription_RootShop_Item_Purchase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Item_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Item_Purchase_Order_By>>;
  where?: InputMaybe<Shop_Item_Purchase_Bool_Exp>;
};


export type Subscription_RootShop_Item_Purchase_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootShop_Item_Purchase_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shop_Item_Purchase_Stream_Cursor_Input>>;
  where?: InputMaybe<Shop_Item_Purchase_Bool_Exp>;
};


export type Subscription_RootShop_Item_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shop_Item_Stream_Cursor_Input>>;
  where?: InputMaybe<Shop_Item_Bool_Exp>;
};


export type Subscription_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_AwardArgs = {
  distinct_on?: InputMaybe<Array<User_Award_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Award_Order_By>>;
  where?: InputMaybe<User_Award_Bool_Exp>;
};


export type Subscription_RootUser_Award_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Award_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Award_Order_By>>;
  where?: InputMaybe<User_Award_Bool_Exp>;
};


export type Subscription_RootUser_Award_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Award_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Award_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Award_Bool_Exp>;
};


export type Subscription_RootUser_By_PkArgs = {
  firestoreId: Scalars['String'];
};


export type Subscription_RootUser_FileArgs = {
  distinct_on?: InputMaybe<Array<User_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_File_Order_By>>;
  where?: InputMaybe<User_File_Bool_Exp>;
};


export type Subscription_RootUser_File_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_File_Order_By>>;
  where?: InputMaybe<User_File_Bool_Exp>;
};


export type Subscription_RootUser_File_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_File_IntegrationArgs = {
  distinct_on?: InputMaybe<Array<User_File_Integration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_File_Integration_Order_By>>;
  where?: InputMaybe<User_File_Integration_Bool_Exp>;
};


export type Subscription_RootUser_File_Integration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_File_Integration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_File_Integration_Order_By>>;
  where?: InputMaybe<User_File_Integration_Bool_Exp>;
};


export type Subscription_RootUser_File_Integration_By_PkArgs = {
  fileId: Scalars['uuid'];
  source: Scalars['String'];
};


export type Subscription_RootUser_File_Integration_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_File_Integration_Stream_Cursor_Input>>;
  where?: InputMaybe<User_File_Integration_Bool_Exp>;
};


export type Subscription_RootUser_File_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_File_Stream_Cursor_Input>>;
  where?: InputMaybe<User_File_Bool_Exp>;
};


export type Subscription_RootUser_File_TransformArgs = {
  distinct_on?: InputMaybe<Array<User_File_Transform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_File_Transform_Order_By>>;
  where?: InputMaybe<User_File_Transform_Bool_Exp>;
};


export type Subscription_RootUser_File_Transform_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_File_Transform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_File_Transform_Order_By>>;
  where?: InputMaybe<User_File_Transform_Bool_Exp>;
};


export type Subscription_RootUser_File_Transform_By_PkArgs = {
  fileId: Scalars['uuid'];
  filename: Scalars['String'];
};


export type Subscription_RootUser_File_Transform_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_File_Transform_Stream_Cursor_Input>>;
  where?: InputMaybe<User_File_Transform_Bool_Exp>;
};


export type Subscription_RootUser_FollowArgs = {
  distinct_on?: InputMaybe<Array<User_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Follow_Order_By>>;
  where?: InputMaybe<User_Follow_Bool_Exp>;
};


export type Subscription_RootUser_Follow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Follow_Order_By>>;
  where?: InputMaybe<User_Follow_Bool_Exp>;
};


export type Subscription_RootUser_Follow_By_PkArgs = {
  sourceUserId: Scalars['String'];
  targetUserId: Scalars['String'];
};


export type Subscription_RootUser_Follow_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Follow_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Follow_Bool_Exp>;
};


export type Subscription_RootUser_IntegrationArgs = {
  distinct_on?: InputMaybe<Array<User_Integration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Integration_Order_By>>;
  where?: InputMaybe<User_Integration_Bool_Exp>;
};


export type Subscription_RootUser_Integration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Integration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Integration_Order_By>>;
  where?: InputMaybe<User_Integration_Bool_Exp>;
};


export type Subscription_RootUser_Integration_By_PkArgs = {
  foreignId: Scalars['String'];
  provider: Enums_Integration_Provider_Enum;
};


export type Subscription_RootUser_Integration_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Integration_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Integration_Bool_Exp>;
};


export type Subscription_RootUser_PathArgs = {
  distinct_on?: InputMaybe<Array<User_Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Path_Order_By>>;
  where?: InputMaybe<User_Path_Bool_Exp>;
};


export type Subscription_RootUser_Path_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Path_Order_By>>;
  where?: InputMaybe<User_Path_Bool_Exp>;
};


export type Subscription_RootUser_Path_By_PkArgs = {
  pathId: Scalars['Int'];
  userId: Scalars['String'];
};


export type Subscription_RootUser_Path_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Path_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Path_Bool_Exp>;
};


export type Subscription_RootUser_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_SubscriptionArgs = {
  distinct_on?: InputMaybe<Array<User_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Subscription_Order_By>>;
  where?: InputMaybe<User_Subscription_Bool_Exp>;
};


export type Subscription_RootUser_Subscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Subscription_Order_By>>;
  where?: InputMaybe<User_Subscription_Bool_Exp>;
};


export type Subscription_RootUser_Subscription_By_PkArgs = {
  userId: Scalars['String'];
};


export type Subscription_RootUser_Subscription_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Subscription_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Subscription_Bool_Exp>;
};


export type Subscription_RootUser_TeacherArgs = {
  distinct_on?: InputMaybe<Array<User_Teacher_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Teacher_Order_By>>;
  where?: InputMaybe<User_Teacher_Bool_Exp>;
};


export type Subscription_RootUser_Teacher_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Teacher_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Teacher_Order_By>>;
  where?: InputMaybe<User_Teacher_Bool_Exp>;
};


export type Subscription_RootUser_Teacher_By_PkArgs = {
  userId: Scalars['String'];
};


export type Subscription_RootUser_Teacher_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Teacher_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Teacher_Bool_Exp>;
};


export type Subscription_RootView_Top_Creators_By_Followers_CountArgs = {
  distinct_on?: InputMaybe<Array<View_Top_Creators_By_Followers_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_Top_Creators_By_Followers_Count_Order_By>>;
  where?: InputMaybe<View_Top_Creators_By_Followers_Count_Bool_Exp>;
};


export type Subscription_RootView_Top_Creators_By_Followers_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<View_Top_Creators_By_Followers_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_Top_Creators_By_Followers_Count_Order_By>>;
  where?: InputMaybe<View_Top_Creators_By_Followers_Count_Bool_Exp>;
};


export type Subscription_RootView_Top_Creators_By_Followers_Count_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<View_Top_Creators_By_Followers_Count_Stream_Cursor_Input>>;
  where?: InputMaybe<View_Top_Creators_By_Followers_Count_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "user" */
export type User = {
  __typename?: 'user';
  accomplishments?: Maybe<Scalars['jsonb']>;
  avatar?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['jsonb']>;
  canAuthor: Scalars['Boolean'];
  /** An array relationship */
  coinLedger: Array<Coin_Trx>;
  /** An aggregate relationship */
  coinLedger_aggregate: Coin_Trx_Aggregate;
  /** An array relationship */
  comments: Array<Comment>;
  /** An aggregate relationship */
  comments_aggregate: Comment_Aggregate;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  creatorLevel?: Maybe<Scalars['String']>;
  disabled: Scalars['Boolean'];
  /** An array relationship */
  educatorCodeRedemptions: Array<Educator_Code_Redemption>;
  /** An aggregate relationship */
  educatorCodeRedemptions_aggregate: Educator_Code_Redemption_Aggregate;
  email?: Maybe<Scalars['String']>;
  firestoreId: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  /** An array relationship */
  followers: Array<User_Follow>;
  /** An aggregate relationship */
  followers_aggregate: User_Follow_Aggregate;
  /** An array relationship */
  following: Array<User_Follow>;
  /** An aggregate relationship */
  following_aggregate: User_Follow_Aggregate;
  id: Scalars['Int'];
  /** An array relationship */
  integrations: Array<User_Integration>;
  /** An aggregate relationship */
  integrations_aggregate: User_Integration_Aggregate;
  interestAreas?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  invitedBy?: Maybe<User>;
  invitedById?: Maybe<Scalars['String']>;
  isAdmin: Scalars['Boolean'];
  isEducator: Scalars['Boolean'];
  isMod: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  lastSeen?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  learnerGroups: Array<Learner_Group_Member>;
  /** An aggregate relationship */
  learnerGroups_aggregate: Learner_Group_Member_Aggregate;
  onboarded: Scalars['Boolean'];
  orgId?: Maybe<Scalars['String']>;
  /** An object relationship */
  organization?: Maybe<Organization>;
  pathPrivacy?: Maybe<Scalars['String']>;
  /** An array relationship */
  paths: Array<Path>;
  /** An aggregate relationship */
  paths_aggregate: Path_Aggregate;
  profilePrivacy?: Maybe<Scalars['String']>;
  projectPrivacy?: Maybe<Scalars['String']>;
  /** An array relationship */
  projectReactions: Array<Project_Reaction>;
  /** An aggregate relationship */
  projectReactions_aggregate: Project_Reaction_Aggregate;
  /** An array relationship */
  projects: Array<Project>;
  /** An aggregate relationship */
  projects_aggregate: Project_Aggregate;
  subscribed: Scalars['Boolean'];
  /** An object relationship */
  subscription?: Maybe<User_Subscription>;
  subscriptionExempt: Scalars['Boolean'];
  /** An object relationship */
  teacher?: Maybe<User_Teacher>;
  updatedAt: Scalars['timestamptz'];
  userType?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  /** An array relationship */
  viewedPaths: Array<Path_Active_User>;
  /** An aggregate relationship */
  viewedPaths_aggregate: Path_Active_User_Aggregate;
};


/** columns and relationships of "user" */
export type UserAccomplishmentsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "user" */
export type UserBirthdayArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "user" */
export type UserCoinLedgerArgs = {
  distinct_on?: InputMaybe<Array<Coin_Trx_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Coin_Trx_Order_By>>;
  where?: InputMaybe<Coin_Trx_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCoinLedger_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Coin_Trx_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Coin_Trx_Order_By>>;
  where?: InputMaybe<Coin_Trx_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comment_Order_By>>;
  where?: InputMaybe<Comment_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comment_Order_By>>;
  where?: InputMaybe<Comment_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserEducatorCodeRedemptionsArgs = {
  distinct_on?: InputMaybe<Array<Educator_Code_Redemption_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Educator_Code_Redemption_Order_By>>;
  where?: InputMaybe<Educator_Code_Redemption_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserEducatorCodeRedemptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Educator_Code_Redemption_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Educator_Code_Redemption_Order_By>>;
  where?: InputMaybe<Educator_Code_Redemption_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserFollowersArgs = {
  distinct_on?: InputMaybe<Array<User_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Follow_Order_By>>;
  where?: InputMaybe<User_Follow_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserFollowers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Follow_Order_By>>;
  where?: InputMaybe<User_Follow_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserFollowingArgs = {
  distinct_on?: InputMaybe<Array<User_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Follow_Order_By>>;
  where?: InputMaybe<User_Follow_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserFollowing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Follow_Order_By>>;
  where?: InputMaybe<User_Follow_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserIntegrationsArgs = {
  distinct_on?: InputMaybe<Array<User_Integration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Integration_Order_By>>;
  where?: InputMaybe<User_Integration_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserIntegrations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Integration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Integration_Order_By>>;
  where?: InputMaybe<User_Integration_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInterestAreasArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "user" */
export type UserLearnerGroupsArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Member_Order_By>>;
  where?: InputMaybe<Learner_Group_Member_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserLearnerGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Learner_Group_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Learner_Group_Member_Order_By>>;
  where?: InputMaybe<Learner_Group_Member_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPathsArgs = {
  distinct_on?: InputMaybe<Array<Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Order_By>>;
  where?: InputMaybe<Path_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPaths_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Order_By>>;
  where?: InputMaybe<Path_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserProjectReactionsArgs = {
  distinct_on?: InputMaybe<Array<Project_Reaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Reaction_Order_By>>;
  where?: InputMaybe<Project_Reaction_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserProjectReactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Reaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Reaction_Order_By>>;
  where?: InputMaybe<Project_Reaction_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserProjectsArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserViewedPathsArgs = {
  distinct_on?: InputMaybe<Array<Path_Active_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Active_User_Order_By>>;
  where?: InputMaybe<Path_Active_User_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserViewedPaths_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Active_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Active_User_Order_By>>;
  where?: InputMaybe<Path_Active_User_Bool_Exp>;
};

/** aggregated selection of "user" */
export type User_Aggregate = {
  __typename?: 'user_aggregate';
  aggregate?: Maybe<User_Aggregate_Fields>;
  nodes: Array<User>;
};

/** aggregate fields of "user" */
export type User_Aggregate_Fields = {
  __typename?: 'user_aggregate_fields';
  avg?: Maybe<User_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Max_Fields>;
  min?: Maybe<User_Min_Fields>;
  stddev?: Maybe<User_Stddev_Fields>;
  stddev_pop?: Maybe<User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Stddev_Samp_Fields>;
  sum?: Maybe<User_Sum_Fields>;
  var_pop?: Maybe<User_Var_Pop_Fields>;
  var_samp?: Maybe<User_Var_Samp_Fields>;
  variance?: Maybe<User_Variance_Fields>;
};


/** aggregate fields of "user" */
export type User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user" */
export type User_Aggregate_Order_By = {
  avg?: InputMaybe<User_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Max_Order_By>;
  min?: InputMaybe<User_Min_Order_By>;
  stddev?: InputMaybe<User_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Sum_Order_By>;
  var_pop?: InputMaybe<User_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Append_Input = {
  accomplishments?: InputMaybe<Scalars['jsonb']>;
  birthday?: InputMaybe<Scalars['jsonb']>;
  interestAreas?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "user" */
export type User_Arr_Rel_Insert_Input = {
  data: Array<User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Avg_Fields = {
  __typename?: 'user_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user" */
export type User_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_award" */
export type User_Award = {
  __typename?: 'user_award';
  /** An object relationship */
  award: Award;
  awardId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  fromUserId: Scalars['String'];
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['String'];
};

/** aggregated selection of "user_award" */
export type User_Award_Aggregate = {
  __typename?: 'user_award_aggregate';
  aggregate?: Maybe<User_Award_Aggregate_Fields>;
  nodes: Array<User_Award>;
};

/** aggregate fields of "user_award" */
export type User_Award_Aggregate_Fields = {
  __typename?: 'user_award_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Award_Max_Fields>;
  min?: Maybe<User_Award_Min_Fields>;
};


/** aggregate fields of "user_award" */
export type User_Award_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Award_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_award". All fields are combined with a logical 'AND'. */
export type User_Award_Bool_Exp = {
  _and?: InputMaybe<Array<User_Award_Bool_Exp>>;
  _not?: InputMaybe<User_Award_Bool_Exp>;
  _or?: InputMaybe<Array<User_Award_Bool_Exp>>;
  award?: InputMaybe<Award_Bool_Exp>;
  awardId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  fromUserId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_award" */
export enum User_Award_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserAwardPkey = 'user_award_pkey'
}

/** input type for inserting data into table "user_award" */
export type User_Award_Insert_Input = {
  award?: InputMaybe<Award_Obj_Rel_Insert_Input>;
  awardId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fromUserId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Award_Max_Fields = {
  __typename?: 'user_award_max_fields';
  awardId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  fromUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Award_Min_Fields = {
  __typename?: 'user_award_min_fields';
  awardId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  fromUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_award" */
export type User_Award_Mutation_Response = {
  __typename?: 'user_award_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Award>;
};

/** on_conflict condition type for table "user_award" */
export type User_Award_On_Conflict = {
  constraint: User_Award_Constraint;
  update_columns?: Array<User_Award_Update_Column>;
  where?: InputMaybe<User_Award_Bool_Exp>;
};

/** Ordering options when selecting data from "user_award". */
export type User_Award_Order_By = {
  award?: InputMaybe<Award_Order_By>;
  awardId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  fromUserId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_award */
export type User_Award_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_award" */
export enum User_Award_Select_Column {
  /** column name */
  AwardId = 'awardId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FromUserId = 'fromUserId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_award" */
export type User_Award_Set_Input = {
  awardId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fromUserId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_award" */
export type User_Award_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Award_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Award_Stream_Cursor_Value_Input = {
  awardId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fromUserId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_award" */
export enum User_Award_Update_Column {
  /** column name */
  AwardId = 'awardId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FromUserId = 'fromUserId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type User_Award_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Award_Set_Input>;
  where: User_Award_Bool_Exp;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type User_Bool_Exp = {
  _and?: InputMaybe<Array<User_Bool_Exp>>;
  _not?: InputMaybe<User_Bool_Exp>;
  _or?: InputMaybe<Array<User_Bool_Exp>>;
  accomplishments?: InputMaybe<Jsonb_Comparison_Exp>;
  avatar?: InputMaybe<String_Comparison_Exp>;
  bio?: InputMaybe<String_Comparison_Exp>;
  birthday?: InputMaybe<Jsonb_Comparison_Exp>;
  canAuthor?: InputMaybe<Boolean_Comparison_Exp>;
  coinLedger?: InputMaybe<Coin_Trx_Bool_Exp>;
  comments?: InputMaybe<Comment_Bool_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  creatorLevel?: InputMaybe<String_Comparison_Exp>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  educatorCodeRedemptions?: InputMaybe<Educator_Code_Redemption_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  firestoreId?: InputMaybe<String_Comparison_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  followers?: InputMaybe<User_Follow_Bool_Exp>;
  following?: InputMaybe<User_Follow_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  integrations?: InputMaybe<User_Integration_Bool_Exp>;
  interestAreas?: InputMaybe<Jsonb_Comparison_Exp>;
  invitedBy?: InputMaybe<User_Bool_Exp>;
  invitedById?: InputMaybe<String_Comparison_Exp>;
  isAdmin?: InputMaybe<Boolean_Comparison_Exp>;
  isEducator?: InputMaybe<Boolean_Comparison_Exp>;
  isMod?: InputMaybe<Boolean_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  lastSeen?: InputMaybe<Timestamptz_Comparison_Exp>;
  learnerGroups?: InputMaybe<Learner_Group_Member_Bool_Exp>;
  onboarded?: InputMaybe<Boolean_Comparison_Exp>;
  orgId?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  pathPrivacy?: InputMaybe<String_Comparison_Exp>;
  paths?: InputMaybe<Path_Bool_Exp>;
  profilePrivacy?: InputMaybe<String_Comparison_Exp>;
  projectPrivacy?: InputMaybe<String_Comparison_Exp>;
  projectReactions?: InputMaybe<Project_Reaction_Bool_Exp>;
  projects?: InputMaybe<Project_Bool_Exp>;
  subscribed?: InputMaybe<Boolean_Comparison_Exp>;
  subscription?: InputMaybe<User_Subscription_Bool_Exp>;
  subscriptionExempt?: InputMaybe<Boolean_Comparison_Exp>;
  teacher?: InputMaybe<User_Teacher_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userType?: InputMaybe<String_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  viewedPaths?: InputMaybe<Path_Active_User_Bool_Exp>;
};

/** unique or primary key constraints on table "user" */
export enum User_Constraint {
  /** unique or primary key constraint on columns "email" */
  UserEmailKey = 'user_email_key',
  /** unique or primary key constraint on columns "firestore_id" */
  UserFirestoreIdKey = 'user_firestore_id_key',
  /** unique or primary key constraint on columns "id" */
  UserIdKey = 'user_id_key',
  /** unique or primary key constraint on columns "firestore_id" */
  UserPkey = 'user_pkey',
  /** unique or primary key constraint on columns "username" */
  UserUsernameKey = 'user_username_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Delete_At_Path_Input = {
  accomplishments?: InputMaybe<Array<Scalars['String']>>;
  birthday?: InputMaybe<Array<Scalars['String']>>;
  interestAreas?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Delete_Elem_Input = {
  accomplishments?: InputMaybe<Scalars['Int']>;
  birthday?: InputMaybe<Scalars['Int']>;
  interestAreas?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Delete_Key_Input = {
  accomplishments?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['String']>;
  interestAreas?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "user_file" */
export type User_File = {
  __typename?: 'user_file';
  created_at: Scalars['timestamptz'];
  filename: Scalars['String'];
  id: Scalars['uuid'];
  /** An array relationship */
  integrations: Array<User_File_Integration>;
  /** An aggregate relationship */
  integrations_aggregate: User_File_Integration_Aggregate;
  /** An array relationship */
  missions: Array<Mission>;
  /** An aggregate relationship */
  missions_aggregate: Mission_Aggregate;
  /** An array relationship */
  paths: Array<Path>;
  /** An aggregate relationship */
  paths_aggregate: Path_Aggregate;
  /** An array relationship */
  transforms: Array<User_File_Transform>;
  /** An aggregate relationship */
  transforms_aggregate: User_File_Transform_Aggregate;
  updated_at: Scalars['timestamptz'];
  userId: Scalars['String'];
};


/** columns and relationships of "user_file" */
export type User_FileIntegrationsArgs = {
  distinct_on?: InputMaybe<Array<User_File_Integration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_File_Integration_Order_By>>;
  where?: InputMaybe<User_File_Integration_Bool_Exp>;
};


/** columns and relationships of "user_file" */
export type User_FileIntegrations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_File_Integration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_File_Integration_Order_By>>;
  where?: InputMaybe<User_File_Integration_Bool_Exp>;
};


/** columns and relationships of "user_file" */
export type User_FileMissionsArgs = {
  distinct_on?: InputMaybe<Array<Mission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Order_By>>;
  where?: InputMaybe<Mission_Bool_Exp>;
};


/** columns and relationships of "user_file" */
export type User_FileMissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mission_Order_By>>;
  where?: InputMaybe<Mission_Bool_Exp>;
};


/** columns and relationships of "user_file" */
export type User_FilePathsArgs = {
  distinct_on?: InputMaybe<Array<Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Order_By>>;
  where?: InputMaybe<Path_Bool_Exp>;
};


/** columns and relationships of "user_file" */
export type User_FilePaths_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Path_Order_By>>;
  where?: InputMaybe<Path_Bool_Exp>;
};


/** columns and relationships of "user_file" */
export type User_FileTransformsArgs = {
  distinct_on?: InputMaybe<Array<User_File_Transform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_File_Transform_Order_By>>;
  where?: InputMaybe<User_File_Transform_Bool_Exp>;
};


/** columns and relationships of "user_file" */
export type User_FileTransforms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_File_Transform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_File_Transform_Order_By>>;
  where?: InputMaybe<User_File_Transform_Bool_Exp>;
};

/** aggregated selection of "user_file" */
export type User_File_Aggregate = {
  __typename?: 'user_file_aggregate';
  aggregate?: Maybe<User_File_Aggregate_Fields>;
  nodes: Array<User_File>;
};

/** aggregate fields of "user_file" */
export type User_File_Aggregate_Fields = {
  __typename?: 'user_file_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_File_Max_Fields>;
  min?: Maybe<User_File_Min_Fields>;
};


/** aggregate fields of "user_file" */
export type User_File_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_File_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_file". All fields are combined with a logical 'AND'. */
export type User_File_Bool_Exp = {
  _and?: InputMaybe<Array<User_File_Bool_Exp>>;
  _not?: InputMaybe<User_File_Bool_Exp>;
  _or?: InputMaybe<Array<User_File_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  filename?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  integrations?: InputMaybe<User_File_Integration_Bool_Exp>;
  missions?: InputMaybe<Mission_Bool_Exp>;
  paths?: InputMaybe<Path_Bool_Exp>;
  transforms?: InputMaybe<User_File_Transform_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_file" */
export enum User_File_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserFilePkey = 'user_file_pkey'
}

/** input type for inserting data into table "user_file" */
export type User_File_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  filename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  integrations?: InputMaybe<User_File_Integration_Arr_Rel_Insert_Input>;
  missions?: InputMaybe<Mission_Arr_Rel_Insert_Input>;
  paths?: InputMaybe<Path_Arr_Rel_Insert_Input>;
  transforms?: InputMaybe<User_File_Transform_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "user_file_integration" */
export type User_File_Integration = {
  __typename?: 'user_file_integration';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  file: User_File;
  fileId: Scalars['uuid'];
  foreignId: Scalars['String'];
  source: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "user_file_integration" */
export type User_File_Integration_Aggregate = {
  __typename?: 'user_file_integration_aggregate';
  aggregate?: Maybe<User_File_Integration_Aggregate_Fields>;
  nodes: Array<User_File_Integration>;
};

/** aggregate fields of "user_file_integration" */
export type User_File_Integration_Aggregate_Fields = {
  __typename?: 'user_file_integration_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_File_Integration_Max_Fields>;
  min?: Maybe<User_File_Integration_Min_Fields>;
};


/** aggregate fields of "user_file_integration" */
export type User_File_Integration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_File_Integration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_file_integration" */
export type User_File_Integration_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_File_Integration_Max_Order_By>;
  min?: InputMaybe<User_File_Integration_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_file_integration" */
export type User_File_Integration_Arr_Rel_Insert_Input = {
  data: Array<User_File_Integration_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_File_Integration_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_file_integration". All fields are combined with a logical 'AND'. */
export type User_File_Integration_Bool_Exp = {
  _and?: InputMaybe<Array<User_File_Integration_Bool_Exp>>;
  _not?: InputMaybe<User_File_Integration_Bool_Exp>;
  _or?: InputMaybe<Array<User_File_Integration_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<User_File_Bool_Exp>;
  fileId?: InputMaybe<Uuid_Comparison_Exp>;
  foreignId?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_file_integration" */
export enum User_File_Integration_Constraint {
  /** unique or primary key constraint on columns "source", "file_id" */
  UserFileIntegrationPkey = 'user_file_integration_pkey'
}

/** input type for inserting data into table "user_file_integration" */
export type User_File_Integration_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  file?: InputMaybe<User_File_Obj_Rel_Insert_Input>;
  fileId?: InputMaybe<Scalars['uuid']>;
  foreignId?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type User_File_Integration_Max_Fields = {
  __typename?: 'user_file_integration_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  fileId?: Maybe<Scalars['uuid']>;
  foreignId?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "user_file_integration" */
export type User_File_Integration_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  foreignId?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_File_Integration_Min_Fields = {
  __typename?: 'user_file_integration_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  fileId?: Maybe<Scalars['uuid']>;
  foreignId?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "user_file_integration" */
export type User_File_Integration_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  foreignId?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_file_integration" */
export type User_File_Integration_Mutation_Response = {
  __typename?: 'user_file_integration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_File_Integration>;
};

/** on_conflict condition type for table "user_file_integration" */
export type User_File_Integration_On_Conflict = {
  constraint: User_File_Integration_Constraint;
  update_columns?: Array<User_File_Integration_Update_Column>;
  where?: InputMaybe<User_File_Integration_Bool_Exp>;
};

/** Ordering options when selecting data from "user_file_integration". */
export type User_File_Integration_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  file?: InputMaybe<User_File_Order_By>;
  fileId?: InputMaybe<Order_By>;
  foreignId?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_file_integration */
export type User_File_Integration_Pk_Columns_Input = {
  fileId: Scalars['uuid'];
  source: Scalars['String'];
};

/** select columns of table "user_file_integration" */
export enum User_File_Integration_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  ForeignId = 'foreignId',
  /** column name */
  Source = 'source',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "user_file_integration" */
export type User_File_Integration_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fileId?: InputMaybe<Scalars['uuid']>;
  foreignId?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "user_file_integration" */
export type User_File_Integration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_File_Integration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_File_Integration_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fileId?: InputMaybe<Scalars['uuid']>;
  foreignId?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "user_file_integration" */
export enum User_File_Integration_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  ForeignId = 'foreignId',
  /** column name */
  Source = 'source',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type User_File_Integration_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_File_Integration_Set_Input>;
  where: User_File_Integration_Bool_Exp;
};

/** aggregate max on columns */
export type User_File_Max_Fields = {
  __typename?: 'user_file_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_File_Min_Fields = {
  __typename?: 'user_file_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_file" */
export type User_File_Mutation_Response = {
  __typename?: 'user_file_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_File>;
};

/** input type for inserting object relation for remote table "user_file" */
export type User_File_Obj_Rel_Insert_Input = {
  data: User_File_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_File_On_Conflict>;
};

/** on_conflict condition type for table "user_file" */
export type User_File_On_Conflict = {
  constraint: User_File_Constraint;
  update_columns?: Array<User_File_Update_Column>;
  where?: InputMaybe<User_File_Bool_Exp>;
};

/** Ordering options when selecting data from "user_file". */
export type User_File_Order_By = {
  created_at?: InputMaybe<Order_By>;
  filename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  integrations_aggregate?: InputMaybe<User_File_Integration_Aggregate_Order_By>;
  missions_aggregate?: InputMaybe<Mission_Aggregate_Order_By>;
  paths_aggregate?: InputMaybe<Path_Aggregate_Order_By>;
  transforms_aggregate?: InputMaybe<User_File_Transform_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_file */
export type User_File_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_file" */
export enum User_File_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_file" */
export type User_File_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  filename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_file" */
export type User_File_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_File_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_File_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  filename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "user_file_transform" */
export type User_File_Transform = {
  __typename?: 'user_file_transform';
  created_at: Scalars['timestamptz'];
  fileId: Scalars['uuid'];
  filename: Scalars['String'];
  /** An object relationship */
  originalFile: User_File;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "user_file_transform" */
export type User_File_Transform_Aggregate = {
  __typename?: 'user_file_transform_aggregate';
  aggregate?: Maybe<User_File_Transform_Aggregate_Fields>;
  nodes: Array<User_File_Transform>;
};

/** aggregate fields of "user_file_transform" */
export type User_File_Transform_Aggregate_Fields = {
  __typename?: 'user_file_transform_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_File_Transform_Max_Fields>;
  min?: Maybe<User_File_Transform_Min_Fields>;
};


/** aggregate fields of "user_file_transform" */
export type User_File_Transform_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_File_Transform_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_file_transform" */
export type User_File_Transform_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_File_Transform_Max_Order_By>;
  min?: InputMaybe<User_File_Transform_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_file_transform" */
export type User_File_Transform_Arr_Rel_Insert_Input = {
  data: Array<User_File_Transform_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_File_Transform_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_file_transform". All fields are combined with a logical 'AND'. */
export type User_File_Transform_Bool_Exp = {
  _and?: InputMaybe<Array<User_File_Transform_Bool_Exp>>;
  _not?: InputMaybe<User_File_Transform_Bool_Exp>;
  _or?: InputMaybe<Array<User_File_Transform_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fileId?: InputMaybe<Uuid_Comparison_Exp>;
  filename?: InputMaybe<String_Comparison_Exp>;
  originalFile?: InputMaybe<User_File_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_file_transform" */
export enum User_File_Transform_Constraint {
  /** unique or primary key constraint on columns "filename", "file_id" */
  UserFileTransformPkey = 'user_file_transform_pkey'
}

/** input type for inserting data into table "user_file_transform" */
export type User_File_Transform_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fileId?: InputMaybe<Scalars['uuid']>;
  filename?: InputMaybe<Scalars['String']>;
  originalFile?: InputMaybe<User_File_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type User_File_Transform_Max_Fields = {
  __typename?: 'user_file_transform_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  fileId?: Maybe<Scalars['uuid']>;
  filename?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "user_file_transform" */
export type User_File_Transform_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  filename?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_File_Transform_Min_Fields = {
  __typename?: 'user_file_transform_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  fileId?: Maybe<Scalars['uuid']>;
  filename?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "user_file_transform" */
export type User_File_Transform_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  filename?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_file_transform" */
export type User_File_Transform_Mutation_Response = {
  __typename?: 'user_file_transform_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_File_Transform>;
};

/** on_conflict condition type for table "user_file_transform" */
export type User_File_Transform_On_Conflict = {
  constraint: User_File_Transform_Constraint;
  update_columns?: Array<User_File_Transform_Update_Column>;
  where?: InputMaybe<User_File_Transform_Bool_Exp>;
};

/** Ordering options when selecting data from "user_file_transform". */
export type User_File_Transform_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  filename?: InputMaybe<Order_By>;
  originalFile?: InputMaybe<User_File_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_file_transform */
export type User_File_Transform_Pk_Columns_Input = {
  fileId: Scalars['uuid'];
  filename: Scalars['String'];
};

/** select columns of table "user_file_transform" */
export enum User_File_Transform_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Filename = 'filename',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "user_file_transform" */
export type User_File_Transform_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fileId?: InputMaybe<Scalars['uuid']>;
  filename?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "user_file_transform" */
export type User_File_Transform_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_File_Transform_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_File_Transform_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fileId?: InputMaybe<Scalars['uuid']>;
  filename?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "user_file_transform" */
export enum User_File_Transform_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Filename = 'filename',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type User_File_Transform_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_File_Transform_Set_Input>;
  where: User_File_Transform_Bool_Exp;
};

/** update columns of table "user_file" */
export enum User_File_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
}

export type User_File_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_File_Set_Input>;
  where: User_File_Bool_Exp;
};

/** Follow relationships between users. */
export type User_Follow = {
  __typename?: 'user_follow';
  createdAt: Scalars['timestamptz'];
  disabled: Scalars['Boolean'];
  /** An object relationship */
  sourceUser: User;
  sourceUserId: Scalars['String'];
  /** An object relationship */
  targetUser: User;
  targetUserId: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "user_follow" */
export type User_Follow_Aggregate = {
  __typename?: 'user_follow_aggregate';
  aggregate?: Maybe<User_Follow_Aggregate_Fields>;
  nodes: Array<User_Follow>;
};

/** aggregate fields of "user_follow" */
export type User_Follow_Aggregate_Fields = {
  __typename?: 'user_follow_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Follow_Max_Fields>;
  min?: Maybe<User_Follow_Min_Fields>;
};


/** aggregate fields of "user_follow" */
export type User_Follow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Follow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_follow" */
export type User_Follow_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Follow_Max_Order_By>;
  min?: InputMaybe<User_Follow_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_follow" */
export type User_Follow_Arr_Rel_Insert_Input = {
  data: Array<User_Follow_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Follow_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_follow". All fields are combined with a logical 'AND'. */
export type User_Follow_Bool_Exp = {
  _and?: InputMaybe<Array<User_Follow_Bool_Exp>>;
  _not?: InputMaybe<User_Follow_Bool_Exp>;
  _or?: InputMaybe<Array<User_Follow_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  sourceUser?: InputMaybe<User_Bool_Exp>;
  sourceUserId?: InputMaybe<String_Comparison_Exp>;
  targetUser?: InputMaybe<User_Bool_Exp>;
  targetUserId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_follow" */
export enum User_Follow_Constraint {
  /** unique or primary key constraint on columns "target_user_id", "source_user_id" */
  UserFollowPkey = 'user_follow_pkey'
}

/** input type for inserting data into table "user_follow" */
export type User_Follow_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  sourceUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
  sourceUserId?: InputMaybe<Scalars['String']>;
  targetUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
  targetUserId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type User_Follow_Max_Fields = {
  __typename?: 'user_follow_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  sourceUserId?: Maybe<Scalars['String']>;
  targetUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "user_follow" */
export type User_Follow_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  sourceUserId?: InputMaybe<Order_By>;
  targetUserId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Follow_Min_Fields = {
  __typename?: 'user_follow_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  sourceUserId?: Maybe<Scalars['String']>;
  targetUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "user_follow" */
export type User_Follow_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  sourceUserId?: InputMaybe<Order_By>;
  targetUserId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_follow" */
export type User_Follow_Mutation_Response = {
  __typename?: 'user_follow_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Follow>;
};

/** on_conflict condition type for table "user_follow" */
export type User_Follow_On_Conflict = {
  constraint: User_Follow_Constraint;
  update_columns?: Array<User_Follow_Update_Column>;
  where?: InputMaybe<User_Follow_Bool_Exp>;
};

/** Ordering options when selecting data from "user_follow". */
export type User_Follow_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  disabled?: InputMaybe<Order_By>;
  sourceUser?: InputMaybe<User_Order_By>;
  sourceUserId?: InputMaybe<Order_By>;
  targetUser?: InputMaybe<User_Order_By>;
  targetUserId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_follow */
export type User_Follow_Pk_Columns_Input = {
  sourceUserId: Scalars['String'];
  targetUserId: Scalars['String'];
};

/** select columns of table "user_follow" */
export enum User_Follow_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  SourceUserId = 'sourceUserId',
  /** column name */
  TargetUserId = 'targetUserId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "user_follow" */
export type User_Follow_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  sourceUserId?: InputMaybe<Scalars['String']>;
  targetUserId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "user_follow" */
export type User_Follow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Follow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Follow_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  sourceUserId?: InputMaybe<Scalars['String']>;
  targetUserId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "user_follow" */
export enum User_Follow_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  SourceUserId = 'sourceUserId',
  /** column name */
  TargetUserId = 'targetUserId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type User_Follow_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Follow_Set_Input>;
  where: User_Follow_Bool_Exp;
};

/** input type for incrementing numeric columns in table "user" */
export type User_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user" */
export type User_Insert_Input = {
  accomplishments?: InputMaybe<Scalars['jsonb']>;
  avatar?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['jsonb']>;
  canAuthor?: InputMaybe<Scalars['Boolean']>;
  coinLedger?: InputMaybe<Coin_Trx_Arr_Rel_Insert_Input>;
  comments?: InputMaybe<Comment_Arr_Rel_Insert_Input>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  creatorLevel?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  educatorCodeRedemptions?: InputMaybe<Educator_Code_Redemption_Arr_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']>;
  firestoreId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  followers?: InputMaybe<User_Follow_Arr_Rel_Insert_Input>;
  following?: InputMaybe<User_Follow_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  integrations?: InputMaybe<User_Integration_Arr_Rel_Insert_Input>;
  interestAreas?: InputMaybe<Scalars['jsonb']>;
  invitedBy?: InputMaybe<User_Obj_Rel_Insert_Input>;
  invitedById?: InputMaybe<Scalars['String']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  isEducator?: InputMaybe<Scalars['Boolean']>;
  isMod?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastSeen?: InputMaybe<Scalars['timestamptz']>;
  learnerGroups?: InputMaybe<Learner_Group_Member_Arr_Rel_Insert_Input>;
  onboarded?: InputMaybe<Scalars['Boolean']>;
  orgId?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  pathPrivacy?: InputMaybe<Scalars['String']>;
  paths?: InputMaybe<Path_Arr_Rel_Insert_Input>;
  profilePrivacy?: InputMaybe<Scalars['String']>;
  projectPrivacy?: InputMaybe<Scalars['String']>;
  projectReactions?: InputMaybe<Project_Reaction_Arr_Rel_Insert_Input>;
  projects?: InputMaybe<Project_Arr_Rel_Insert_Input>;
  subscribed?: InputMaybe<Scalars['Boolean']>;
  subscription?: InputMaybe<User_Subscription_Obj_Rel_Insert_Input>;
  subscriptionExempt?: InputMaybe<Scalars['Boolean']>;
  teacher?: InputMaybe<User_Teacher_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userType?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  viewedPaths?: InputMaybe<Path_Active_User_Arr_Rel_Insert_Input>;
};

/** User integrations to store provider foreign ids and settings */
export type User_Integration = {
  __typename?: 'user_integration';
  createdAt: Scalars['timestamptz'];
  foreignId: Scalars['String'];
  provider: Enums_Integration_Provider_Enum;
  refreshToken?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['String'];
};

/** aggregated selection of "user_integration" */
export type User_Integration_Aggregate = {
  __typename?: 'user_integration_aggregate';
  aggregate?: Maybe<User_Integration_Aggregate_Fields>;
  nodes: Array<User_Integration>;
};

/** aggregate fields of "user_integration" */
export type User_Integration_Aggregate_Fields = {
  __typename?: 'user_integration_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Integration_Max_Fields>;
  min?: Maybe<User_Integration_Min_Fields>;
};


/** aggregate fields of "user_integration" */
export type User_Integration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Integration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_integration" */
export type User_Integration_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Integration_Max_Order_By>;
  min?: InputMaybe<User_Integration_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_integration" */
export type User_Integration_Arr_Rel_Insert_Input = {
  data: Array<User_Integration_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Integration_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_integration". All fields are combined with a logical 'AND'. */
export type User_Integration_Bool_Exp = {
  _and?: InputMaybe<Array<User_Integration_Bool_Exp>>;
  _not?: InputMaybe<User_Integration_Bool_Exp>;
  _or?: InputMaybe<Array<User_Integration_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  foreignId?: InputMaybe<String_Comparison_Exp>;
  provider?: InputMaybe<Enums_Integration_Provider_Enum_Comparison_Exp>;
  refreshToken?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_integration" */
export enum User_Integration_Constraint {
  /** unique or primary key constraint on columns "provider", "foreign_id" */
  UserIntegrationPkey = 'user_integration_pkey',
  /** unique or primary key constraint on columns "provider", "user_id" */
  UserIntegrationUserIdProviderKey = 'user_integration_user_id_provider_key'
}

/** input type for inserting data into table "user_integration" */
export type User_Integration_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  foreignId?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Enums_Integration_Provider_Enum>;
  refreshToken?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Integration_Max_Fields = {
  __typename?: 'user_integration_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  foreignId?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_integration" */
export type User_Integration_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  foreignId?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Integration_Min_Fields = {
  __typename?: 'user_integration_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  foreignId?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_integration" */
export type User_Integration_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  foreignId?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_integration" */
export type User_Integration_Mutation_Response = {
  __typename?: 'user_integration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Integration>;
};

/** on_conflict condition type for table "user_integration" */
export type User_Integration_On_Conflict = {
  constraint: User_Integration_Constraint;
  update_columns?: Array<User_Integration_Update_Column>;
  where?: InputMaybe<User_Integration_Bool_Exp>;
};

/** Ordering options when selecting data from "user_integration". */
export type User_Integration_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  foreignId?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_integration */
export type User_Integration_Pk_Columns_Input = {
  foreignId: Scalars['String'];
  provider: Enums_Integration_Provider_Enum;
};

/** select columns of table "user_integration" */
export enum User_Integration_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ForeignId = 'foreignId',
  /** column name */
  Provider = 'provider',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_integration" */
export type User_Integration_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  foreignId?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Enums_Integration_Provider_Enum>;
  refreshToken?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_integration" */
export type User_Integration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Integration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Integration_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  foreignId?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Enums_Integration_Provider_Enum>;
  refreshToken?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_integration" */
export enum User_Integration_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ForeignId = 'foreignId',
  /** column name */
  Provider = 'provider',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type User_Integration_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Integration_Set_Input>;
  where: User_Integration_Bool_Exp;
};

/** aggregate max on columns */
export type User_Max_Fields = {
  __typename?: 'user_max_fields';
  avatar?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  creatorLevel?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firestoreId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  invitedById?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  lastSeen?: Maybe<Scalars['timestamptz']>;
  orgId?: Maybe<Scalars['String']>;
  pathPrivacy?: Maybe<Scalars['String']>;
  profilePrivacy?: Maybe<Scalars['String']>;
  projectPrivacy?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userType?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user" */
export type User_Max_Order_By = {
  avatar?: InputMaybe<Order_By>;
  bio?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  creatorLevel?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  firestoreId?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invitedById?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  lastSeen?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  pathPrivacy?: InputMaybe<Order_By>;
  profilePrivacy?: InputMaybe<Order_By>;
  projectPrivacy?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userType?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Min_Fields = {
  __typename?: 'user_min_fields';
  avatar?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  creatorLevel?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firestoreId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  invitedById?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  lastSeen?: Maybe<Scalars['timestamptz']>;
  orgId?: Maybe<Scalars['String']>;
  pathPrivacy?: Maybe<Scalars['String']>;
  profilePrivacy?: Maybe<Scalars['String']>;
  projectPrivacy?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userType?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user" */
export type User_Min_Order_By = {
  avatar?: InputMaybe<Order_By>;
  bio?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  creatorLevel?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  firestoreId?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invitedById?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  lastSeen?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  pathPrivacy?: InputMaybe<Order_By>;
  profilePrivacy?: InputMaybe<Order_By>;
  projectPrivacy?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userType?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user" */
export type User_Mutation_Response = {
  __typename?: 'user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User>;
};

/** input type for inserting object relation for remote table "user" */
export type User_Obj_Rel_Insert_Input = {
  data: User_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_On_Conflict>;
};

/** on_conflict condition type for table "user" */
export type User_On_Conflict = {
  constraint: User_Constraint;
  update_columns?: Array<User_Update_Column>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** Ordering options when selecting data from "user". */
export type User_Order_By = {
  accomplishments?: InputMaybe<Order_By>;
  avatar?: InputMaybe<Order_By>;
  bio?: InputMaybe<Order_By>;
  birthday?: InputMaybe<Order_By>;
  canAuthor?: InputMaybe<Order_By>;
  coinLedger_aggregate?: InputMaybe<Coin_Trx_Aggregate_Order_By>;
  comments_aggregate?: InputMaybe<Comment_Aggregate_Order_By>;
  country?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  creatorLevel?: InputMaybe<Order_By>;
  disabled?: InputMaybe<Order_By>;
  educatorCodeRedemptions_aggregate?: InputMaybe<Educator_Code_Redemption_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  firestoreId?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  followers_aggregate?: InputMaybe<User_Follow_Aggregate_Order_By>;
  following_aggregate?: InputMaybe<User_Follow_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  integrations_aggregate?: InputMaybe<User_Integration_Aggregate_Order_By>;
  interestAreas?: InputMaybe<Order_By>;
  invitedBy?: InputMaybe<User_Order_By>;
  invitedById?: InputMaybe<Order_By>;
  isAdmin?: InputMaybe<Order_By>;
  isEducator?: InputMaybe<Order_By>;
  isMod?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  lastSeen?: InputMaybe<Order_By>;
  learnerGroups_aggregate?: InputMaybe<Learner_Group_Member_Aggregate_Order_By>;
  onboarded?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  pathPrivacy?: InputMaybe<Order_By>;
  paths_aggregate?: InputMaybe<Path_Aggregate_Order_By>;
  profilePrivacy?: InputMaybe<Order_By>;
  projectPrivacy?: InputMaybe<Order_By>;
  projectReactions_aggregate?: InputMaybe<Project_Reaction_Aggregate_Order_By>;
  projects_aggregate?: InputMaybe<Project_Aggregate_Order_By>;
  subscribed?: InputMaybe<Order_By>;
  subscription?: InputMaybe<User_Subscription_Order_By>;
  subscriptionExempt?: InputMaybe<Order_By>;
  teacher?: InputMaybe<User_Teacher_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userType?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  viewedPaths_aggregate?: InputMaybe<Path_Active_User_Aggregate_Order_By>;
};

/** columns and relationships of "user_path" */
export type User_Path = {
  __typename?: 'user_path';
  addedAt: Scalars['timestamptz'];
  createdAt: Scalars['timestamptz'];
  isArchived: Scalars['Boolean'];
  isCompleted: Scalars['Boolean'];
  pathId: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['String'];
};

/** aggregated selection of "user_path" */
export type User_Path_Aggregate = {
  __typename?: 'user_path_aggregate';
  aggregate?: Maybe<User_Path_Aggregate_Fields>;
  nodes: Array<User_Path>;
};

/** aggregate fields of "user_path" */
export type User_Path_Aggregate_Fields = {
  __typename?: 'user_path_aggregate_fields';
  avg?: Maybe<User_Path_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Path_Max_Fields>;
  min?: Maybe<User_Path_Min_Fields>;
  stddev?: Maybe<User_Path_Stddev_Fields>;
  stddev_pop?: Maybe<User_Path_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Path_Stddev_Samp_Fields>;
  sum?: Maybe<User_Path_Sum_Fields>;
  var_pop?: Maybe<User_Path_Var_Pop_Fields>;
  var_samp?: Maybe<User_Path_Var_Samp_Fields>;
  variance?: Maybe<User_Path_Variance_Fields>;
};


/** aggregate fields of "user_path" */
export type User_Path_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Path_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type User_Path_Avg_Fields = {
  __typename?: 'user_path_avg_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_path". All fields are combined with a logical 'AND'. */
export type User_Path_Bool_Exp = {
  _and?: InputMaybe<Array<User_Path_Bool_Exp>>;
  _not?: InputMaybe<User_Path_Bool_Exp>;
  _or?: InputMaybe<Array<User_Path_Bool_Exp>>;
  addedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  isArchived?: InputMaybe<Boolean_Comparison_Exp>;
  isCompleted?: InputMaybe<Boolean_Comparison_Exp>;
  pathId?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_path" */
export enum User_Path_Constraint {
  /** unique or primary key constraint on columns "user_id", "path_id" */
  UserPathPkey = 'user_path_pkey'
}

/** input type for incrementing numeric columns in table "user_path" */
export type User_Path_Inc_Input = {
  pathId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_path" */
export type User_Path_Insert_Input = {
  addedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  pathId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Path_Max_Fields = {
  __typename?: 'user_path_max_fields';
  addedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  pathId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Path_Min_Fields = {
  __typename?: 'user_path_min_fields';
  addedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  pathId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_path" */
export type User_Path_Mutation_Response = {
  __typename?: 'user_path_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Path>;
};

/** on_conflict condition type for table "user_path" */
export type User_Path_On_Conflict = {
  constraint: User_Path_Constraint;
  update_columns?: Array<User_Path_Update_Column>;
  where?: InputMaybe<User_Path_Bool_Exp>;
};

/** Ordering options when selecting data from "user_path". */
export type User_Path_Order_By = {
  addedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  isArchived?: InputMaybe<Order_By>;
  isCompleted?: InputMaybe<Order_By>;
  pathId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_path */
export type User_Path_Pk_Columns_Input = {
  pathId: Scalars['Int'];
  userId: Scalars['String'];
};

/** select columns of table "user_path" */
export enum User_Path_Select_Column {
  /** column name */
  AddedAt = 'addedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  IsArchived = 'isArchived',
  /** column name */
  IsCompleted = 'isCompleted',
  /** column name */
  PathId = 'pathId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_path" */
export type User_Path_Set_Input = {
  addedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  pathId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Path_Stddev_Fields = {
  __typename?: 'user_path_stddev_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Path_Stddev_Pop_Fields = {
  __typename?: 'user_path_stddev_pop_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Path_Stddev_Samp_Fields = {
  __typename?: 'user_path_stddev_samp_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_path" */
export type User_Path_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Path_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Path_Stream_Cursor_Value_Input = {
  addedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  pathId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Path_Sum_Fields = {
  __typename?: 'user_path_sum_fields';
  pathId?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_path" */
export enum User_Path_Update_Column {
  /** column name */
  AddedAt = 'addedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  IsArchived = 'isArchived',
  /** column name */
  IsCompleted = 'isCompleted',
  /** column name */
  PathId = 'pathId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type User_Path_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Path_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Path_Set_Input>;
  where: User_Path_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Path_Var_Pop_Fields = {
  __typename?: 'user_path_var_pop_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Path_Var_Samp_Fields = {
  __typename?: 'user_path_var_samp_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Path_Variance_Fields = {
  __typename?: 'user_path_variance_fields';
  pathId?: Maybe<Scalars['Float']>;
};

/** primary key columns input for table: user */
export type User_Pk_Columns_Input = {
  firestoreId: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Prepend_Input = {
  accomplishments?: InputMaybe<Scalars['jsonb']>;
  birthday?: InputMaybe<Scalars['jsonb']>;
  interestAreas?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "user" */
export enum User_Select_Column {
  /** column name */
  Accomplishments = 'accomplishments',
  /** column name */
  Avatar = 'avatar',
  /** column name */
  Bio = 'bio',
  /** column name */
  Birthday = 'birthday',
  /** column name */
  CanAuthor = 'canAuthor',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatorLevel = 'creatorLevel',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  Email = 'email',
  /** column name */
  FirestoreId = 'firestoreId',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  InterestAreas = 'interestAreas',
  /** column name */
  InvitedById = 'invitedById',
  /** column name */
  IsAdmin = 'isAdmin',
  /** column name */
  IsEducator = 'isEducator',
  /** column name */
  IsMod = 'isMod',
  /** column name */
  LastName = 'lastName',
  /** column name */
  LastSeen = 'lastSeen',
  /** column name */
  Onboarded = 'onboarded',
  /** column name */
  OrgId = 'orgId',
  /** column name */
  PathPrivacy = 'pathPrivacy',
  /** column name */
  ProfilePrivacy = 'profilePrivacy',
  /** column name */
  ProjectPrivacy = 'projectPrivacy',
  /** column name */
  Subscribed = 'subscribed',
  /** column name */
  SubscriptionExempt = 'subscriptionExempt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserType = 'userType',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "user" */
export type User_Set_Input = {
  accomplishments?: InputMaybe<Scalars['jsonb']>;
  avatar?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['jsonb']>;
  canAuthor?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  creatorLevel?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  firestoreId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  interestAreas?: InputMaybe<Scalars['jsonb']>;
  invitedById?: InputMaybe<Scalars['String']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  isEducator?: InputMaybe<Scalars['Boolean']>;
  isMod?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastSeen?: InputMaybe<Scalars['timestamptz']>;
  onboarded?: InputMaybe<Scalars['Boolean']>;
  orgId?: InputMaybe<Scalars['String']>;
  pathPrivacy?: InputMaybe<Scalars['String']>;
  profilePrivacy?: InputMaybe<Scalars['String']>;
  projectPrivacy?: InputMaybe<Scalars['String']>;
  subscribed?: InputMaybe<Scalars['Boolean']>;
  subscriptionExempt?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userType?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Stddev_Fields = {
  __typename?: 'user_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user" */
export type User_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Stddev_Pop_Fields = {
  __typename?: 'user_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user" */
export type User_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Stddev_Samp_Fields = {
  __typename?: 'user_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user" */
export type User_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user" */
export type User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Stream_Cursor_Value_Input = {
  accomplishments?: InputMaybe<Scalars['jsonb']>;
  avatar?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['jsonb']>;
  canAuthor?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  creatorLevel?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  firestoreId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  interestAreas?: InputMaybe<Scalars['jsonb']>;
  invitedById?: InputMaybe<Scalars['String']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  isEducator?: InputMaybe<Scalars['Boolean']>;
  isMod?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastSeen?: InputMaybe<Scalars['timestamptz']>;
  onboarded?: InputMaybe<Scalars['Boolean']>;
  orgId?: InputMaybe<Scalars['String']>;
  pathPrivacy?: InputMaybe<Scalars['String']>;
  profilePrivacy?: InputMaybe<Scalars['String']>;
  projectPrivacy?: InputMaybe<Scalars['String']>;
  subscribed?: InputMaybe<Scalars['Boolean']>;
  subscriptionExempt?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userType?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "user_subscription" */
export type User_Subscription = {
  __typename?: 'user_subscription';
  createdAt: Scalars['timestamptz'];
  isExempt: Scalars['Boolean'];
  planInterval?: Maybe<Scalars['String']>;
  planType?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['String'];
};

/** aggregated selection of "user_subscription" */
export type User_Subscription_Aggregate = {
  __typename?: 'user_subscription_aggregate';
  aggregate?: Maybe<User_Subscription_Aggregate_Fields>;
  nodes: Array<User_Subscription>;
};

/** aggregate fields of "user_subscription" */
export type User_Subscription_Aggregate_Fields = {
  __typename?: 'user_subscription_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Subscription_Max_Fields>;
  min?: Maybe<User_Subscription_Min_Fields>;
};


/** aggregate fields of "user_subscription" */
export type User_Subscription_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Subscription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_subscription". All fields are combined with a logical 'AND'. */
export type User_Subscription_Bool_Exp = {
  _and?: InputMaybe<Array<User_Subscription_Bool_Exp>>;
  _not?: InputMaybe<User_Subscription_Bool_Exp>;
  _or?: InputMaybe<Array<User_Subscription_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  isExempt?: InputMaybe<Boolean_Comparison_Exp>;
  planInterval?: InputMaybe<String_Comparison_Exp>;
  planType?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_subscription" */
export enum User_Subscription_Constraint {
  /** unique or primary key constraint on columns "user_id" */
  UserSubscriptionPkey = 'user_subscription_pkey'
}

/** input type for inserting data into table "user_subscription" */
export type User_Subscription_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isExempt?: InputMaybe<Scalars['Boolean']>;
  planInterval?: InputMaybe<Scalars['String']>;
  planType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Subscription_Max_Fields = {
  __typename?: 'user_subscription_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  planInterval?: Maybe<Scalars['String']>;
  planType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Subscription_Min_Fields = {
  __typename?: 'user_subscription_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  planInterval?: Maybe<Scalars['String']>;
  planType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_subscription" */
export type User_Subscription_Mutation_Response = {
  __typename?: 'user_subscription_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Subscription>;
};

/** input type for inserting object relation for remote table "user_subscription" */
export type User_Subscription_Obj_Rel_Insert_Input = {
  data: User_Subscription_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Subscription_On_Conflict>;
};

/** on_conflict condition type for table "user_subscription" */
export type User_Subscription_On_Conflict = {
  constraint: User_Subscription_Constraint;
  update_columns?: Array<User_Subscription_Update_Column>;
  where?: InputMaybe<User_Subscription_Bool_Exp>;
};

/** Ordering options when selecting data from "user_subscription". */
export type User_Subscription_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  isExempt?: InputMaybe<Order_By>;
  planInterval?: InputMaybe<Order_By>;
  planType?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_subscription */
export type User_Subscription_Pk_Columns_Input = {
  userId: Scalars['String'];
};

/** select columns of table "user_subscription" */
export enum User_Subscription_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  IsExempt = 'isExempt',
  /** column name */
  PlanInterval = 'planInterval',
  /** column name */
  PlanType = 'planType',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_subscription" */
export type User_Subscription_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isExempt?: InputMaybe<Scalars['Boolean']>;
  planInterval?: InputMaybe<Scalars['String']>;
  planType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_subscription" */
export type User_Subscription_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Subscription_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Subscription_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isExempt?: InputMaybe<Scalars['Boolean']>;
  planInterval?: InputMaybe<Scalars['String']>;
  planType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_subscription" */
export enum User_Subscription_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  IsExempt = 'isExempt',
  /** column name */
  PlanInterval = 'planInterval',
  /** column name */
  PlanType = 'planType',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type User_Subscription_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Subscription_Set_Input>;
  where: User_Subscription_Bool_Exp;
};

/** aggregate sum on columns */
export type User_Sum_Fields = {
  __typename?: 'user_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user" */
export type User_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_teacher" */
export type User_Teacher = {
  __typename?: 'user_teacher';
  createdAt: Scalars['timestamptz'];
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  lowerGradeLevel?: Maybe<Scalars['String']>;
  subjects?: Maybe<Scalars['jsonb']>;
  updatedAt: Scalars['timestamptz'];
  upperGradeLevel?: Maybe<Scalars['String']>;
  /** An object relationship */
  user: User;
  userId: Scalars['String'];
};


/** columns and relationships of "user_teacher" */
export type User_TeacherSubjectsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "user_teacher" */
export type User_Teacher_Aggregate = {
  __typename?: 'user_teacher_aggregate';
  aggregate?: Maybe<User_Teacher_Aggregate_Fields>;
  nodes: Array<User_Teacher>;
};

/** aggregate fields of "user_teacher" */
export type User_Teacher_Aggregate_Fields = {
  __typename?: 'user_teacher_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Teacher_Max_Fields>;
  min?: Maybe<User_Teacher_Min_Fields>;
};


/** aggregate fields of "user_teacher" */
export type User_Teacher_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Teacher_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Teacher_Append_Input = {
  subjects?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "user_teacher". All fields are combined with a logical 'AND'. */
export type User_Teacher_Bool_Exp = {
  _and?: InputMaybe<Array<User_Teacher_Bool_Exp>>;
  _not?: InputMaybe<User_Teacher_Bool_Exp>;
  _or?: InputMaybe<Array<User_Teacher_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  displayName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lowerGradeLevel?: InputMaybe<String_Comparison_Exp>;
  subjects?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  upperGradeLevel?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_teacher" */
export enum User_Teacher_Constraint {
  /** unique or primary key constraint on columns "user_id" */
  UserTeacherPkey = 'user_teacher_pkey',
  /** unique or primary key constraint on columns "user_id" */
  UserTeacherUserIdKey = 'user_teacher_user_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Teacher_Delete_At_Path_Input = {
  subjects?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Teacher_Delete_Elem_Input = {
  subjects?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Teacher_Delete_Key_Input = {
  subjects?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "user_teacher" */
export type User_Teacher_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lowerGradeLevel?: InputMaybe<Scalars['String']>;
  subjects?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  upperGradeLevel?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Teacher_Max_Fields = {
  __typename?: 'user_teacher_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lowerGradeLevel?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  upperGradeLevel?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Teacher_Min_Fields = {
  __typename?: 'user_teacher_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lowerGradeLevel?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  upperGradeLevel?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_teacher" */
export type User_Teacher_Mutation_Response = {
  __typename?: 'user_teacher_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Teacher>;
};

/** input type for inserting object relation for remote table "user_teacher" */
export type User_Teacher_Obj_Rel_Insert_Input = {
  data: User_Teacher_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Teacher_On_Conflict>;
};

/** on_conflict condition type for table "user_teacher" */
export type User_Teacher_On_Conflict = {
  constraint: User_Teacher_Constraint;
  update_columns?: Array<User_Teacher_Update_Column>;
  where?: InputMaybe<User_Teacher_Bool_Exp>;
};

/** Ordering options when selecting data from "user_teacher". */
export type User_Teacher_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lowerGradeLevel?: InputMaybe<Order_By>;
  subjects?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  upperGradeLevel?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_teacher */
export type User_Teacher_Pk_Columns_Input = {
  userId: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Teacher_Prepend_Input = {
  subjects?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "user_teacher" */
export enum User_Teacher_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Id = 'id',
  /** column name */
  LowerGradeLevel = 'lowerGradeLevel',
  /** column name */
  Subjects = 'subjects',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpperGradeLevel = 'upperGradeLevel',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_teacher" */
export type User_Teacher_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lowerGradeLevel?: InputMaybe<Scalars['String']>;
  subjects?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  upperGradeLevel?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_teacher" */
export type User_Teacher_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Teacher_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Teacher_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lowerGradeLevel?: InputMaybe<Scalars['String']>;
  subjects?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  upperGradeLevel?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_teacher" */
export enum User_Teacher_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Id = 'id',
  /** column name */
  LowerGradeLevel = 'lowerGradeLevel',
  /** column name */
  Subjects = 'subjects',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpperGradeLevel = 'upperGradeLevel',
  /** column name */
  UserId = 'userId'
}

export type User_Teacher_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Teacher_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Teacher_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Teacher_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Teacher_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Teacher_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Teacher_Set_Input>;
  where: User_Teacher_Bool_Exp;
};

/** update columns of table "user" */
export enum User_Update_Column {
  /** column name */
  Accomplishments = 'accomplishments',
  /** column name */
  Avatar = 'avatar',
  /** column name */
  Bio = 'bio',
  /** column name */
  Birthday = 'birthday',
  /** column name */
  CanAuthor = 'canAuthor',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatorLevel = 'creatorLevel',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  Email = 'email',
  /** column name */
  FirestoreId = 'firestoreId',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  InterestAreas = 'interestAreas',
  /** column name */
  InvitedById = 'invitedById',
  /** column name */
  IsAdmin = 'isAdmin',
  /** column name */
  IsEducator = 'isEducator',
  /** column name */
  IsMod = 'isMod',
  /** column name */
  LastName = 'lastName',
  /** column name */
  LastSeen = 'lastSeen',
  /** column name */
  Onboarded = 'onboarded',
  /** column name */
  OrgId = 'orgId',
  /** column name */
  PathPrivacy = 'pathPrivacy',
  /** column name */
  ProfilePrivacy = 'profilePrivacy',
  /** column name */
  ProjectPrivacy = 'projectPrivacy',
  /** column name */
  Subscribed = 'subscribed',
  /** column name */
  SubscriptionExempt = 'subscriptionExempt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserType = 'userType',
  /** column name */
  Username = 'username'
}

export type User_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Set_Input>;
  where: User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Var_Pop_Fields = {
  __typename?: 'user_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user" */
export type User_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Var_Samp_Fields = {
  __typename?: 'user_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user" */
export type User_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Variance_Fields = {
  __typename?: 'user_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user" */
export type User_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

export type Video_Backdrop = {
  __typename?: 'video_backdrop';
  createdAt: Scalars['bigint'];
  name: Scalars['String'];
  url: Scalars['String'];
};

/** columns and relationships of "view_top_creators_by_followers_count" */
export type View_Top_Creators_By_Followers_Count = {
  __typename?: 'view_top_creators_by_followers_count';
  followersCount?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregated selection of "view_top_creators_by_followers_count" */
export type View_Top_Creators_By_Followers_Count_Aggregate = {
  __typename?: 'view_top_creators_by_followers_count_aggregate';
  aggregate?: Maybe<View_Top_Creators_By_Followers_Count_Aggregate_Fields>;
  nodes: Array<View_Top_Creators_By_Followers_Count>;
};

/** aggregate fields of "view_top_creators_by_followers_count" */
export type View_Top_Creators_By_Followers_Count_Aggregate_Fields = {
  __typename?: 'view_top_creators_by_followers_count_aggregate_fields';
  avg?: Maybe<View_Top_Creators_By_Followers_Count_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<View_Top_Creators_By_Followers_Count_Max_Fields>;
  min?: Maybe<View_Top_Creators_By_Followers_Count_Min_Fields>;
  stddev?: Maybe<View_Top_Creators_By_Followers_Count_Stddev_Fields>;
  stddev_pop?: Maybe<View_Top_Creators_By_Followers_Count_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<View_Top_Creators_By_Followers_Count_Stddev_Samp_Fields>;
  sum?: Maybe<View_Top_Creators_By_Followers_Count_Sum_Fields>;
  var_pop?: Maybe<View_Top_Creators_By_Followers_Count_Var_Pop_Fields>;
  var_samp?: Maybe<View_Top_Creators_By_Followers_Count_Var_Samp_Fields>;
  variance?: Maybe<View_Top_Creators_By_Followers_Count_Variance_Fields>;
};


/** aggregate fields of "view_top_creators_by_followers_count" */
export type View_Top_Creators_By_Followers_Count_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<View_Top_Creators_By_Followers_Count_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type View_Top_Creators_By_Followers_Count_Avg_Fields = {
  __typename?: 'view_top_creators_by_followers_count_avg_fields';
  followersCount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "view_top_creators_by_followers_count". All fields are combined with a logical 'AND'. */
export type View_Top_Creators_By_Followers_Count_Bool_Exp = {
  _and?: InputMaybe<Array<View_Top_Creators_By_Followers_Count_Bool_Exp>>;
  _not?: InputMaybe<View_Top_Creators_By_Followers_Count_Bool_Exp>;
  _or?: InputMaybe<Array<View_Top_Creators_By_Followers_Count_Bool_Exp>>;
  followersCount?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type View_Top_Creators_By_Followers_Count_Max_Fields = {
  __typename?: 'view_top_creators_by_followers_count_max_fields';
  followersCount?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type View_Top_Creators_By_Followers_Count_Min_Fields = {
  __typename?: 'view_top_creators_by_followers_count_min_fields';
  followersCount?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "view_top_creators_by_followers_count". */
export type View_Top_Creators_By_Followers_Count_Order_By = {
  followersCount?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "view_top_creators_by_followers_count" */
export enum View_Top_Creators_By_Followers_Count_Select_Column {
  /** column name */
  FollowersCount = 'followersCount',
  /** column name */
  UserId = 'userId'
}

/** aggregate stddev on columns */
export type View_Top_Creators_By_Followers_Count_Stddev_Fields = {
  __typename?: 'view_top_creators_by_followers_count_stddev_fields';
  followersCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type View_Top_Creators_By_Followers_Count_Stddev_Pop_Fields = {
  __typename?: 'view_top_creators_by_followers_count_stddev_pop_fields';
  followersCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type View_Top_Creators_By_Followers_Count_Stddev_Samp_Fields = {
  __typename?: 'view_top_creators_by_followers_count_stddev_samp_fields';
  followersCount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "view_top_creators_by_followers_count" */
export type View_Top_Creators_By_Followers_Count_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: View_Top_Creators_By_Followers_Count_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type View_Top_Creators_By_Followers_Count_Stream_Cursor_Value_Input = {
  followersCount?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type View_Top_Creators_By_Followers_Count_Sum_Fields = {
  __typename?: 'view_top_creators_by_followers_count_sum_fields';
  followersCount?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type View_Top_Creators_By_Followers_Count_Var_Pop_Fields = {
  __typename?: 'view_top_creators_by_followers_count_var_pop_fields';
  followersCount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type View_Top_Creators_By_Followers_Count_Var_Samp_Fields = {
  __typename?: 'view_top_creators_by_followers_count_var_samp_fields';
  followersCount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type View_Top_Creators_By_Followers_Count_Variance_Fields = {
  __typename?: 'view_top_creators_by_followers_count_variance_fields';
  followersCount?: Maybe<Scalars['Float']>;
};

export type EducatorCodeFragment = { __typename?: 'educator_code', code: string, available: number, expiresAt: any, createdAt: any };

export type ClassroomLearnerGroupFragment = { __typename?: 'learner_group', id: any, name?: string | null, type: string, privacyScope?: string | null, color?: string | null, source?: Enums_Integration_Provider_Enum | null, sourceId?: string | null, members: Array<{ __typename?: 'learner_group_member', learnerGroupId: any, userId: string, isOwner: boolean, role: string, user: { __typename?: 'user', firstName?: string | null, lastName?: string | null, email?: string | null, avatar?: string | null, isEducator: boolean, userType?: string | null, username?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } }>, pendingMembers: Array<{ __typename?: 'learner_group_pending_member', firstName?: string | null, lastName?: string | null, foreignId: string, provider: Enums_Integration_Provider_Enum }>, organization?: { __typename?: 'organization', id: any, avatar?: string | null, name: string } | null, educatorCodes: Array<{ __typename?: 'educator_code', code: string, available: number, expiresAt: any, createdAt: any }>, learner_group_path_collections: Array<{ __typename?: 'learner_group_path_collection', learnerGroupId: any, pathCollectionId: any, pathCollection: { __typename?: 'path_collection', id: any, pathCollectionItems: Array<{ __typename?: 'path_collection_item', collectionId: any, pathId: any }>, pathCollectionItems_aggregate: { __typename?: 'path_collection_item_aggregate', aggregate?: { __typename?: 'path_collection_item_aggregate_fields', count: number } | null } } }>, assignments: Array<{ __typename?: 'assignment_learner_group', assignmentId: any, learnerGroupId: any, isFinished: boolean }> };

export type PathCardFragment = { __typename?: 'path', _schemaVersion: number, authorId: string, cover?: string | null, coverAnimated?: string | null, id: any, interestArea?: string | null, isPublished: boolean, isTractOriginal: boolean, subjects?: any | null, gradeLevels?: any | null, orgId?: string | null, publishedAt?: any | null, slug?: string | null, status: string, title?: string | null, totalXP: number, isVisibleUnauthed?: boolean | null, tags?: any | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, coverAnimatedFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, creatorLevel?: string | null, id: string } | null };

export type AssignBuilderPathFragment = { __typename?: 'path', id: any, title?: string | null, slug?: string | null, isTractOriginal: boolean, description?: string | null, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, isEducator: boolean, userType?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } | null, nodes: Array<{ __typename?: 'path_node', id: any }>, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, guides: Array<{ __typename?: 'guide_path', guide: { __typename?: 'guide', id: any } }> };

export type AssignmentBuilderFragment = { __typename?: 'assignment', id: any, title: string, description?: string | null, userId: string, startDate: any, dueDate?: any | null, learnerGroups: Array<{ __typename?: 'assignment_learner_group', assignmentId: any, learnerGroupId: any }>, paths: Array<{ __typename?: 'assignment_path', assignmentId: any, pathId: any, path: { __typename?: 'path', id: any, title?: string | null, slug?: string | null, isTractOriginal: boolean, description?: string | null, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, isEducator: boolean, userType?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } | null, nodes: Array<{ __typename?: 'path_node', id: any }>, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, guides: Array<{ __typename?: 'guide_path', guide: { __typename?: 'guide', id: any } }> } }> };

export type AssignBuilderQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type AssignBuilderQuery = { __typename?: 'query_root', assignment_by_pk?: { __typename?: 'assignment', id: any, title: string, description?: string | null, userId: string, startDate: any, dueDate?: any | null, learnerGroups: Array<{ __typename?: 'assignment_learner_group', assignmentId: any, learnerGroupId: any }>, paths: Array<{ __typename?: 'assignment_path', assignmentId: any, pathId: any, path: { __typename?: 'path', id: any, title?: string | null, slug?: string | null, isTractOriginal: boolean, description?: string | null, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, isEducator: boolean, userType?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } | null, nodes: Array<{ __typename?: 'path_node', id: any }>, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, guides: Array<{ __typename?: 'guide_path', guide: { __typename?: 'guide', id: any } }> } }> } | null };

export type AssignBuilderPathByIdQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type AssignBuilderPathByIdQuery = { __typename?: 'query_root', path_by_pk?: { __typename?: 'path', id: any, title?: string | null, slug?: string | null, isTractOriginal: boolean, description?: string | null, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, isEducator: boolean, userType?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } | null, nodes: Array<{ __typename?: 'path_node', id: any }>, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, guides: Array<{ __typename?: 'guide_path', guide: { __typename?: 'guide', id: any } }> } | null };

export type CreateAssignmentMutationVariables = Exact<{
  object: Assignment_Insert_Input;
}>;


export type CreateAssignmentMutation = { __typename?: 'mutation_root', insert_assignment_one?: { __typename?: 'assignment', id: any, title: string, description?: string | null, userId: string, dueDate?: any | null, startDate: any, learnerGroups: Array<{ __typename?: 'assignment_learner_group', assignmentId: any, learnerGroupId: any }>, paths: Array<{ __typename?: 'assignment_path', assignmentId: any, pathId: any, path: { __typename?: 'path', id: any, title?: string | null, slug?: string | null, isTractOriginal: boolean, description?: string | null, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, isEducator: boolean, userType?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } | null, nodes: Array<{ __typename?: 'path_node', id: any }>, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, guides: Array<{ __typename?: 'guide_path', guide: { __typename?: 'guide', id: any } }> } }> } | null };

export type UpdateAssignmentMutationVariables = Exact<{
  id: Scalars['uuid'];
  object: Assignment_Set_Input;
  learnerGroups: Array<Assignment_Learner_Group_Insert_Input> | Assignment_Learner_Group_Insert_Input;
}>;


export type UpdateAssignmentMutation = { __typename?: 'mutation_root', delete_assignment_learner_group?: { __typename?: 'assignment_learner_group_mutation_response', affected_rows: number } | null, insert_assignment_learner_group?: { __typename?: 'assignment_learner_group_mutation_response', affected_rows: number } | null, update_assignment_by_pk?: { __typename?: 'assignment', id: any, title: string, description?: string | null, userId: string, dueDate?: any | null, startDate: any, learnerGroups: Array<{ __typename?: 'assignment_learner_group', assignmentId: any, learnerGroupId: any }>, paths: Array<{ __typename?: 'assignment_path', assignmentId: any, pathId: any, path: { __typename?: 'path', id: any, title?: string | null, slug?: string | null, isTractOriginal: boolean, description?: string | null, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, isEducator: boolean, userType?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } | null, nodes: Array<{ __typename?: 'path_node', id: any }>, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, guides: Array<{ __typename?: 'guide_path', guide: { __typename?: 'guide', id: any } }> } }> } | null };

export type ClassSavedPathsQueryVariables = Exact<{
  learnerGroupId: Scalars['uuid'];
}>;


export type ClassSavedPathsQuery = { __typename?: 'query_root', learner_group_path_collection: Array<{ __typename?: 'learner_group_path_collection', learnerGroupId: any, pathCollectionId: any, pathCollection: { __typename?: 'path_collection', id: any, title?: string | null, description?: string | null, pathCollectionItems: Array<{ __typename?: 'path_collection_item', collectionId: any, pathId: any, path: { __typename?: 'path', _schemaVersion: number, authorId: string, cover?: string | null, coverAnimated?: string | null, id: any, interestArea?: string | null, isPublished: boolean, isTractOriginal: boolean, subjects?: any | null, gradeLevels?: any | null, orgId?: string | null, publishedAt?: any | null, slug?: string | null, status: string, title?: string | null, totalXP: number, isVisibleUnauthed?: boolean | null, tags?: any | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, coverAnimatedFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, creatorLevel?: string | null, id: string } | null } }> } }> };

export type RemovePathCollectionItemMutationVariables = Exact<{
  collectionId: Scalars['uuid'];
  pathId: Scalars['bigint'];
}>;


export type RemovePathCollectionItemMutation = { __typename?: 'mutation_root', delete_path_collection_item_by_pk?: { __typename?: 'path_collection_item', pathCollection: { __typename?: 'path_collection', id: any } } | null };

export type LearnerGroupSavesForPathQueryVariables = Exact<{
  pathId: Scalars['bigint'];
}>;


export type LearnerGroupSavesForPathQuery = { __typename?: 'query_root', path_collection_item: Array<{ __typename?: 'path_collection_item', collectionId: any, pathId: any, pathCollection: { __typename?: 'path_collection', id: any, learnerGroupPathCollection: Array<{ __typename?: 'learner_group_path_collection', learnerGroupId: any, pathCollectionId: any }> } }> };

export type CreateLearnerGroupPathCollectionMutationVariables = Exact<{
  learnerGroupId: Scalars['uuid'];
  pathId: Scalars['bigint'];
  userId: Scalars['String'];
  lexorank: Scalars['String'];
}>;


export type CreateLearnerGroupPathCollectionMutation = { __typename?: 'mutation_root', insert_learner_group_path_collection_one?: { __typename?: 'learner_group_path_collection', pathCollectionId: any, learnerGroupId: any, pathCollection: { __typename?: 'path_collection', id: any, pathCollectionItems: Array<{ __typename?: 'path_collection_item', collectionId: any, pathId: any, lexorank: string, pathCollection: { __typename?: 'path_collection', id: any, learnerGroupPathCollection: Array<{ __typename?: 'learner_group_path_collection', learnerGroupId: any, pathCollectionId: any }> } }> } } | null };

export type GetLearnerGroupsForTeacherQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetLearnerGroupsForTeacherQuery = { __typename?: 'query_root', learner_group_path_collection: Array<{ __typename?: 'learner_group_path_collection', pathCollectionId: any, learnerGroupId: any, _id: any, pathCollection: { __typename?: 'path_collection', id: any, pathCollectionItems: Array<{ __typename?: 'path_collection_item', lexorank: string, _id: any }> }, learnerGroup: { __typename?: 'learner_group', id: any, name?: string | null } }> };

export type InsertPathCollectionItemMutationVariables = Exact<{
  collectionId: Scalars['uuid'];
  pathId: Scalars['bigint'];
  lexorank: Scalars['String'];
}>;


export type InsertPathCollectionItemMutation = { __typename?: 'mutation_root', insert_path_collection_item_one?: { __typename?: 'path_collection_item', collectionId: any, pathId: any, pathCollection: { __typename?: 'path_collection', id: any, learnerGroupPathCollection: Array<{ __typename?: 'learner_group_path_collection', learnerGroupId: any, pathCollectionId: any }> } } | null };

export type CollectionByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type CollectionByIdQuery = { __typename?: 'query_root', path_collection_by_pk?: { __typename?: 'path_collection', id: any, title?: string | null, description?: string | null, user: { __typename?: 'user', firstName?: string | null, username?: string | null, isEducator: boolean, lastName?: string | null, avatar?: string | null, id: string }, pathCollectionItems: Array<{ __typename?: 'path_collection_item', collectionId: any, pathId: any, lexorank: string, path: { __typename?: 'path', _schemaVersion: number, authorId: string, cover?: string | null, coverAnimated?: string | null, id: any, interestArea?: string | null, isPublished: boolean, isTractOriginal: boolean, subjects?: any | null, gradeLevels?: any | null, orgId?: string | null, publishedAt?: any | null, slug?: string | null, status: string, title?: string | null, totalXP: number, isVisibleUnauthed?: boolean | null, tags?: any | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, coverAnimatedFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, creatorLevel?: string | null, id: string } | null } }> } | null };

export type UpdatePathCollectionMutationVariables = Exact<{
  description?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  userId: Scalars['String'];
  id: Scalars['uuid'];
}>;


export type UpdatePathCollectionMutation = { __typename?: 'mutation_root', update_path_collection_by_pk?: { __typename?: 'path_collection', description?: string | null, title?: string | null, userId: string } | null };

export type UpdatePathCollectionItemMutationVariables = Exact<{
  lexorank: Scalars['String'];
  collectionId: Scalars['uuid'];
  pathId: Scalars['bigint'];
}>;


export type UpdatePathCollectionItemMutation = { __typename?: 'mutation_root', update_path_collection_item_by_pk?: { __typename?: 'path_collection_item', collectionId: any, pathId: any, lexorank: string, path: { __typename?: 'path', _schemaVersion: number, authorId: string, cover?: string | null, coverAnimated?: string | null, id: any, interestArea?: string | null, isPublished: boolean, isTractOriginal: boolean, subjects?: any | null, gradeLevels?: any | null, orgId?: string | null, publishedAt?: any | null, slug?: string | null, status: string, title?: string | null, totalXP: number, isVisibleUnauthed?: boolean | null, tags?: any | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, coverAnimatedFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, creatorLevel?: string | null, id: string } | null } } | null };

export type InsertPathCollectionMutationVariables = Exact<{
  title: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
  pathId: Scalars['bigint'];
}>;


export type InsertPathCollectionMutation = { __typename?: 'mutation_root', insert_path_collection_one?: { __typename?: 'path_collection', id: any, title?: string | null, description?: string | null, user: { __typename?: 'user', firstName?: string | null, username?: string | null, isEducator: boolean, lastName?: string | null, avatar?: string | null, id: string }, pathCollectionItems: Array<{ __typename?: 'path_collection_item', collectionId: any, pathId: any, lexorank: string, path: { __typename?: 'path', _schemaVersion: number, authorId: string, cover?: string | null, coverAnimated?: string | null, id: any, interestArea?: string | null, isPublished: boolean, isTractOriginal: boolean, subjects?: any | null, gradeLevels?: any | null, orgId?: string | null, publishedAt?: any | null, slug?: string | null, status: string, title?: string | null, totalXP: number, isVisibleUnauthed?: boolean | null, tags?: any | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, coverAnimatedFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, creatorLevel?: string | null, id: string } | null } }> } | null };

export type DeletePathCollectionMutationVariables = Exact<{
  collectionId: Scalars['uuid'];
}>;


export type DeletePathCollectionMutation = { __typename?: 'mutation_root', delete_path_collection_by_pk?: { __typename?: 'path_collection', id: any } | null };

export type ImportClassroomsMutationVariables = Exact<{
  orgId: Scalars['String'];
  accessToken: Scalars['String'];
  classes: Array<Classroom_Input> | Classroom_Input;
}>;


export type ImportClassroomsMutation = { __typename?: 'mutation_root', importClassrooms?: Array<{ __typename?: 'api_import_classrooms_output', learnerGroup?: { __typename?: 'learner_group', id: any, name?: string | null, type: string, privacyScope?: string | null, color?: string | null, source?: Enums_Integration_Provider_Enum | null, sourceId?: string | null, members: Array<{ __typename?: 'learner_group_member', learnerGroupId: any, userId: string, isOwner: boolean, role: string, user: { __typename?: 'user', firstName?: string | null, lastName?: string | null, email?: string | null, avatar?: string | null, isEducator: boolean, userType?: string | null, username?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } }>, pendingMembers: Array<{ __typename?: 'learner_group_pending_member', firstName?: string | null, lastName?: string | null, foreignId: string, provider: Enums_Integration_Provider_Enum }>, organization?: { __typename?: 'organization', id: any, avatar?: string | null, name: string } | null, educatorCodes: Array<{ __typename?: 'educator_code', code: string, available: number, expiresAt: any, createdAt: any }>, learner_group_path_collections: Array<{ __typename?: 'learner_group_path_collection', learnerGroupId: any, pathCollectionId: any, pathCollection: { __typename?: 'path_collection', id: any, pathCollectionItems: Array<{ __typename?: 'path_collection_item', collectionId: any, pathId: any }>, pathCollectionItems_aggregate: { __typename?: 'path_collection_item_aggregate', aggregate?: { __typename?: 'path_collection_item_aggregate_fields', count: number } | null } } }>, assignments: Array<{ __typename?: 'assignment_learner_group', assignmentId: any, learnerGroupId: any, isFinished: boolean }> } | null } | null> | null };

export type NextLivestreamQueryVariables = Exact<{
  startDate: Scalars['timestamptz'];
}>;


export type NextLivestreamQuery = { __typename?: 'query_root', livestream: Array<{ __typename?: 'livestream', id: any, title: string, description?: string | null, hostUserId: string, startDate?: any | null, endDate?: any | null, disabled: boolean, hostUser: { __typename?: 'user', username?: string | null, avatar?: string | null, id: string }, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null }> };

export type LivestreamBannerQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type LivestreamBannerQuery = { __typename?: 'query_root', livestream?: { __typename?: 'livestream', id: any, title: string, description?: string | null, hostUserId: string, startDate?: any | null, endDate?: any | null, disabled: boolean, hostUser: { __typename?: 'user', username?: string | null, avatar?: string | null, id: string }, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null } | null };

export type JoinLivestreamMutationVariables = Exact<{
  livestreamId: Scalars['uuid'];
}>;


export type JoinLivestreamMutation = { __typename?: 'mutation_root', api_join_livestream: any };

export type LivestreamUserByIdQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type LivestreamUserByIdQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'user', avatar?: string | null, country?: string | null, creatorLevel?: string | null, disabled: boolean, isEducator: boolean, isMod: boolean, username?: string | null, id: string, uid: string }> };

export type PathCardDataFragment = { __typename?: 'path', id: any, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, isEducator: boolean, id: string } | null, guides: Array<{ __typename?: 'guide_path', guide: { __typename?: 'guide', id: any } }> };

export type PathCardDataQueryVariables = Exact<{
  pathId: Scalars['bigint'];
}>;


export type PathCardDataQuery = { __typename?: 'query_root', path?: { __typename?: 'path', id: any, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, isEducator: boolean, id: string } | null, guides: Array<{ __typename?: 'guide_path', guide: { __typename?: 'guide', id: any } }> } | null };

export type UserProfilePopoverFragment = { __typename?: 'user', username?: string | null, avatar?: string | null, isMod: boolean, country?: string | null, firstName?: string | null, lastName?: string | null, isEducator: boolean, creatorLevel?: string | null, userType?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, organization?: { __typename?: 'organization', id: string } | null };

export type UserProfilePopoverQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type UserProfilePopoverQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', username?: string | null, avatar?: string | null, isMod: boolean, country?: string | null, firstName?: string | null, lastName?: string | null, isEducator: boolean, creatorLevel?: string | null, userType?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, organization?: { __typename?: 'organization', id: string } | null }> };

export type PopoverBodyUserFragment = { __typename?: 'user', firstName?: string | null, lastName?: string | null, username?: string | null };

export type ProjectStatsFragment = { __typename?: 'project_stats', projectId: any, commentCount: number, likeCount: number, viewCount: number };

export type ProjectCardFragment = { __typename?: 'project', id: any, text?: string | null, rewardCoinTrxId?: any | null, isPrivate: boolean, published: boolean, userId: string, rejectedAt?: any | null, rejectedReason?: string | null, rejectedFeedback?: string | null, rejectedByUserId?: string | null, awards: Array<{ __typename?: 'project_award', projectId: any, awardId: any, count: number }>, node?: { __typename?: 'path_node', id: any, title?: string | null, path: { __typename?: 'path', id: any, authorId: string } } | null, stats?: { __typename?: 'project_stats', projectId: any, commentCount: number, likeCount: number, viewCount: number } | null, user: { __typename?: 'user', avatar?: string | null, username?: string | null, isEducator: boolean, firstName?: string | null, lastName?: string | null, isMod: boolean, creatorLevel?: string | null, country?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, organization?: { __typename?: 'organization', id: string } | null }, file?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null };

export type GetLmsOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLmsOptionsQuery = { __typename?: 'query_root', lms: Array<{ __typename?: 'lms', id: any, name: string, helpArticleLink: string, imageFilePath?: string | null }> };

export type UserSocialFragment = { __typename?: 'user', username?: string | null, avatar?: string | null, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, followers: Array<{ __typename?: 'user_follow', sourceUserId: string, targetUserId: string }>, organization?: { __typename?: 'organization', id: string } | null };

export type GetVideoBackdropsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVideoBackdropsQuery = { __typename?: 'query_root', api_get_video_backdrops: Array<{ __typename?: 'video_backdrop', name: string, createdAt: any, url: string }> };

export type GetUsersByUserIdsQueryVariables = Exact<{
  userIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetUsersByUserIdsQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', firstName?: string | null, username?: string | null, userType?: string | null, id: string }> };

export type CollectionsForAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type CollectionsForAdminQuery = { __typename?: 'query_root', path_collection: Array<{ __typename?: 'path_collection', id: any, title?: string | null, description?: string | null, user: { __typename?: 'user', username?: string | null, isEducator: boolean, lastName?: string | null, firstName?: string | null, avatar?: string | null, id: string }, pathCollectionItems: Array<{ __typename?: 'path_collection_item', pathId: any, lexorank: string }> }> };

export type CommentsLearnerGroupMemberFragment = { __typename?: 'learner_group_member', learnerGroupId: any, userId: string, user: { __typename?: 'user', username?: string | null, firstName?: string | null, lastName?: string | null, id: string } };

export type AllLearnerGroupLearnersQueryVariables = Exact<{
  teacherUserId: Scalars['String'];
  learnerGroupId?: InputMaybe<Scalars['uuid']>;
}>;


export type AllLearnerGroupLearnersQuery = { __typename?: 'query_root', learner_group: Array<{ __typename?: 'learner_group', members: Array<{ __typename?: 'learner_group_member', learnerGroupId: any, userId: string, user: { __typename?: 'user', username?: string | null, firstName?: string | null, lastName?: string | null, id: string } }> }> };

export type AdminCommentFragment = { __typename?: 'comment', id: any, text?: string | null, giphyId?: string | null, createdAt: any, updatedAt: any, deletedAt: any, published: boolean, path?: any | null, user: { __typename?: 'user', avatar?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, id: string, invitedBy?: { __typename?: 'user', username?: string | null } | null }, projectComment?: { __typename?: 'project_comment', projectId: any, commentId: any, awardId?: any | null } | null, pathReviewComment?: { __typename?: 'path_review', id: any, pathId: any, commentId?: any | null } | null, pathNodeComment?: { __typename?: 'path_node_comment', pathNodeId: any, commentId: any, node: { __typename?: 'path_node', id: any, path: { __typename?: 'path', id: any, authorId: string } } } | null };

export type AdminCommentsQueryVariables = Exact<{
  where: Comment_Bool_Exp;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type AdminCommentsQuery = { __typename?: 'query_root', comments: Array<{ __typename?: 'comment', id: any, text?: string | null, giphyId?: string | null, createdAt: any, updatedAt: any, deletedAt: any, published: boolean, path?: any | null, user: { __typename?: 'user', avatar?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, id: string, invitedBy?: { __typename?: 'user', username?: string | null } | null }, projectComment?: { __typename?: 'project_comment', projectId: any, commentId: any, awardId?: any | null } | null, pathReviewComment?: { __typename?: 'path_review', id: any, pathId: any, commentId?: any | null } | null, pathNodeComment?: { __typename?: 'path_node_comment', pathNodeId: any, commentId: any, node: { __typename?: 'path_node', id: any, path: { __typename?: 'path', id: any, authorId: string } } } | null }> };

export type ParentCommentQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type ParentCommentQuery = { __typename?: 'query_root', comment_by_pk?: { __typename?: 'comment', userId: string, id: any } | null };

export type AdminUpdateCommentStatusMutationVariables = Exact<{
  commentId: Scalars['uuid'];
  deletedAt: Scalars['timestamptz'];
  published: Scalars['Boolean'];
}>;


export type AdminUpdateCommentStatusMutation = { __typename?: 'mutation_root', update_comment_by_pk?: { __typename?: 'comment', id: any, deletedAt: any, published: boolean } | null };

export type AdminLivestreamFragment = { __typename?: 'livestream', id: any, title: string, description?: string | null, hostUserId: string, startDate?: any | null, endDate?: any | null, disabled: boolean, coverFileId?: any | null, hostUser: { __typename?: 'user', username?: string | null, id: string }, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null };

export type AdminLivestreamsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  startDate: Timestamptz_Comparison_Exp;
  orderBy: Livestream_Order_By;
}>;


export type AdminLivestreamsQuery = { __typename?: 'query_root', livestreams: Array<{ __typename?: 'livestream', id: any, title: string, description?: string | null, hostUserId: string, startDate?: any | null, endDate?: any | null, disabled: boolean, coverFileId?: any | null, hostUser: { __typename?: 'user', username?: string | null, id: string }, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null }> };

export type LivestreamByPkQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type LivestreamByPkQuery = { __typename?: 'query_root', livestream?: { __typename?: 'livestream', id: any, title: string, description?: string | null, hostUserId: string, startDate?: any | null, endDate?: any | null, disabled: boolean, coverFileId?: any | null, hostUser: { __typename?: 'user', username?: string | null, id: string }, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null } | null };

export type CreateLivestreamMutationVariables = Exact<{
  object: Livestream_Insert_Input;
}>;


export type CreateLivestreamMutation = { __typename?: 'mutation_root', livestream?: { __typename?: 'livestream', id: any, title: string, description?: string | null, hostUserId: string, startDate?: any | null, endDate?: any | null, disabled: boolean, coverFileId?: any | null, hostUser: { __typename?: 'user', username?: string | null, id: string }, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null } | null };

export type UpdateLivestreamMutationVariables = Exact<{
  id: Scalars['uuid'];
  object: Livestream_Set_Input;
}>;


export type UpdateLivestreamMutation = { __typename?: 'mutation_root', livestream?: { __typename?: 'livestream', id: any, title: string, description?: string | null, hostUserId: string, startDate?: any | null, endDate?: any | null, disabled: boolean, coverFileId?: any | null, hostUser: { __typename?: 'user', username?: string | null, id: string }, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null } | null };

export type SaveOrgMutationVariables = Exact<{
  org: Api_Upsert_Organization_Data_Input;
}>;


export type SaveOrgMutation = { __typename?: 'mutation_root', api_upsert_organization?: { __typename?: 'api_upsert_organization_output', orgId: string } | null };

export type ActiveOrgTeachersQueryVariables = Exact<{
  orgId: Scalars['String'];
  userType: Scalars['String'];
}>;


export type ActiveOrgTeachersQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', firstName?: string | null, lastName?: string | null, email?: string | null, createdAt: any, avatar?: string | null, userType?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null }> };

export type AdminOrgByIdQueryVariables = Exact<{
  orgId: Scalars['String'];
}>;


export type AdminOrgByIdQuery = { __typename?: 'query_root', organization_by_pk?: { __typename?: 'organization', name: string, type: string, verified: boolean, address: string, avatar?: string | null, gradeLevel?: string | null, placeId?: string | null, addressLine1: string, addressLine2: string, city: string, zip: string, region: string, country: string, shopEnabled: boolean, id: string, users: Array<{ __typename?: 'user', id: string }>, emailDomains: Array<{ __typename?: 'organization_domain', domain: string }> } | null };

export type AdminOrgFragment = { __typename?: 'organization', name: string, verified: boolean, address: string, createdAt: any, id: string };

export type AdminOrgsByStatusQueryVariables = Exact<{
  verified: Scalars['Boolean'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type AdminOrgsByStatusQuery = { __typename?: 'query_root', adminOrgs: Array<{ __typename?: 'organization', name: string, verified: boolean, address: string, createdAt: any, id: string }>, pendingCount: { __typename?: 'organization_aggregate', aggregate?: { __typename?: 'organization_aggregate_fields', count: number } | null } };

export type AdminOrgsSearchQueryVariables = Exact<{
  search: Scalars['String'];
  verified: Scalars['Boolean'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type AdminOrgsSearchQuery = { __typename?: 'query_root', adminOrgs: Array<{ __typename?: 'organization', name: string, verified: boolean, address: string, createdAt: any, id: string }>, pendingCount: { __typename?: 'organization_aggregate', aggregate?: { __typename?: 'organization_aggregate_fields', count: number } | null } };

export type AdminDeletePendingOrgMutationVariables = Exact<{
  orgId: Scalars['String'];
}>;


export type AdminDeletePendingOrgMutation = { __typename?: 'mutation_root', delete_organization?: { __typename?: 'organization_mutation_response', affected_rows: number } | null };

export type AdminMoveUserMutationVariables = Exact<{
  userId: Scalars['String'];
  orgId: Scalars['String'];
}>;


export type AdminMoveUserMutation = { __typename?: 'mutation_root', update_user_by_pk?: { __typename?: 'user', id: number } | null, update_learner_group?: { __typename?: 'learner_group_mutation_response', affected_rows: number } | null, update_user?: { __typename?: 'user_mutation_response', affected_rows: number } | null };

export type CreatorPathsForAdminQueryVariables = Exact<{
  offset: Scalars['Int'];
  status: Scalars['String'];
  limit: Scalars['Int'];
  orderBy: Path_Order_By;
  creatorLevel: String_Comparison_Exp;
  userId: Scalars['String'];
}>;


export type CreatorPathsForAdminQuery = { __typename?: 'query_root', paths: Array<{ __typename?: 'path', id: any, slug?: string | null, title?: string | null, authorId: string, createdAt: any, updatedAt: any, isPublished: boolean, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, nodes: Array<{ __typename?: 'path_node', id: any }>, user?: { __typename?: 'user', avatar?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, isEducator: boolean, isMod: boolean, country?: string | null, userType?: string | null, creatorLevel?: string | null, orgId?: string | null, id: string } | null, authors_aggregate: { __typename?: 'path_author_aggregate', aggregate?: { __typename?: 'path_author_aggregate_fields', count: number } | null } }> };

export type AdminShopItemFragment = { __typename?: 'shop_item', id: any, name: string, description: string, cost: number, media?: any | null, quantity?: number | null, externalURL?: string | null, disabled: boolean, tags: any, createdAt: any, metadata?: any | null, ownerId?: string | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, owner?: { __typename?: 'user', email?: string | null } | null };

export type AdminShopItemOwnerFragment = { __typename?: 'user', id: number, firestoreId: string, firstName?: string | null, lastName?: string | null, email?: string | null, isAdmin: boolean, username?: string | null };

export type AdminShopItemsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type AdminShopItemsQuery = { __typename?: 'query_root', items: Array<{ __typename?: 'shop_item', id: any, name: string, description: string, cost: number, media?: any | null, quantity?: number | null, externalURL?: string | null, disabled: boolean, tags: any, createdAt: any, metadata?: any | null, ownerId?: string | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, owner?: { __typename?: 'user', email?: string | null } | null }> };

export type AdminShopItemQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type AdminShopItemQuery = { __typename?: 'query_root', item?: { __typename?: 'shop_item', id: any, name: string, description: string, cost: number, media?: any | null, quantity?: number | null, externalURL?: string | null, disabled: boolean, tags: any, createdAt: any, metadata?: any | null, ownerId?: string | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, owner?: { __typename?: 'user', email?: string | null } | null } | null, owners: Array<{ __typename?: 'user', id: number, firestoreId: string, firstName?: string | null, lastName?: string | null, email?: string | null, isAdmin: boolean, username?: string | null }> };

export type AdminShopItemOwnersQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminShopItemOwnersQuery = { __typename?: 'query_root', owners: Array<{ __typename?: 'user', id: number, firestoreId: string, firstName?: string | null, lastName?: string | null, email?: string | null, isAdmin: boolean, username?: string | null }> };

export type UpdateAdminShopItemMutationVariables = Exact<{
  id: Scalars['uuid'];
  object: Shop_Item_Set_Input;
}>;


export type UpdateAdminShopItemMutation = { __typename?: 'mutation_root', item?: { __typename?: 'shop_item', id: any, name: string, description: string, cost: number, media?: any | null, quantity?: number | null, externalURL?: string | null, disabled: boolean, tags: any, createdAt: any, metadata?: any | null, ownerId?: string | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, owner?: { __typename?: 'user', email?: string | null } | null } | null };

export type CreateAdminShopItemMutationVariables = Exact<{
  object: Shop_Item_Insert_Input;
}>;


export type CreateAdminShopItemMutation = { __typename?: 'mutation_root', item?: { __typename?: 'shop_item', id: any, name: string, description: string, cost: number, media?: any | null, quantity?: number | null, externalURL?: string | null, disabled: boolean, tags: any, createdAt: any, metadata?: any | null, ownerId?: string | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, owner?: { __typename?: 'user', email?: string | null } | null } | null };

export type AdminShopItemPurchaseFragment = { __typename?: 'shop_item_purchase', id: any, status: string, createdAt: any, coinTrx: { __typename?: 'coin_trx', id: any, amount: number }, shopItem: { __typename?: 'shop_item', id: any, name: string, media?: any | null }, user: { __typename?: 'user', avatar?: string | null, username?: string | null, id: string } };

export type AdminShopPurchasesQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type AdminShopPurchasesQuery = { __typename?: 'query_root', purchases: Array<{ __typename?: 'shop_item_purchase', id: any, status: string, createdAt: any, coinTrx: { __typename?: 'coin_trx', id: any, amount: number }, shopItem: { __typename?: 'shop_item', id: any, name: string, media?: any | null }, user: { __typename?: 'user', avatar?: string | null, username?: string | null, id: string } }> };

export type GetRejectUserByIdQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetRejectUserByIdQuery = { __typename?: 'query_root', user?: { __typename?: 'user', firstName?: string | null, lastName?: string | null } | null };

export type SubmissionLearnerFilterUsersQueryVariables = Exact<{
  userIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type SubmissionLearnerFilterUsersQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', username?: string | null, firstName?: string | null, lastName?: string | null, id: string }> };

export type AdminProjectFragment = { __typename?: 'project', id: any, text?: string | null, isPrivate: boolean, createdAt: any, updatedAt: any, userId: string, published: boolean, rejectedAt?: any | null, rejectedByUserId?: string | null, rejectedReason?: string | null, rejectedFeedback?: string | null, pathNodeId?: any | null, rewardCoin?: { __typename?: 'coin_trx', amount: number } | null, file?: { __typename?: 'user_file', id: any, filename: string } | null, user: { __typename?: 'user', username?: string | null, firstName?: string | null, lastName?: string | null, isEducator: boolean, id: string, invitedBy?: { __typename?: 'user', username?: string | null } | null } };

export type AdminProjectsQueueQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  where?: InputMaybe<Project_Bool_Exp>;
}>;


export type AdminProjectsQueueQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'project', id: any, text?: string | null, isPrivate: boolean, createdAt: any, updatedAt: any, userId: string, published: boolean, rejectedAt?: any | null, rejectedByUserId?: string | null, rejectedReason?: string | null, rejectedFeedback?: string | null, pathNodeId?: any | null, rewardCoin?: { __typename?: 'coin_trx', amount: number } | null, file?: { __typename?: 'user_file', id: any, filename: string } | null, user: { __typename?: 'user', username?: string | null, firstName?: string | null, lastName?: string | null, isEducator: boolean, id: string, invitedBy?: { __typename?: 'user', username?: string | null } | null } }> };

export type AdminProjectsQueueCountQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminProjectsQueueCountQuery = { __typename?: 'query_root', projects: { __typename?: 'project_aggregate', aggregate?: { __typename?: 'project_aggregate_fields', count: number } | null } };

export type AdminProjectsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  responseTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  userIdInput?: InputMaybe<String_Comparison_Exp>;
  pathInput?: InputMaybe<Path_Bool_Exp>;
  pathIdInput?: InputMaybe<Bigint_Comparison_Exp>;
  rejectedAtInput?: InputMaybe<Timestamptz_Comparison_Exp>;
  published?: InputMaybe<Boolean_Comparison_Exp>;
}>;


export type AdminProjectsQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'project', id: any, text?: string | null, isPrivate: boolean, createdAt: any, updatedAt: any, userId: string, published: boolean, rejectedAt?: any | null, rejectedByUserId?: string | null, rejectedReason?: string | null, rejectedFeedback?: string | null, pathNodeId?: any | null, rewardCoin?: { __typename?: 'coin_trx', amount: number } | null, file?: { __typename?: 'user_file', id: any, filename: string } | null, user: { __typename?: 'user', username?: string | null, firstName?: string | null, lastName?: string | null, isEducator: boolean, id: string, invitedBy?: { __typename?: 'user', username?: string | null } | null } }> };

export type AdminProjectPathFragment = { __typename?: 'project', node?: { __typename?: 'path_node', id: any, title?: string | null, caption?: string | null, path: { __typename?: 'path', id: any, title?: string | null, slug?: string | null, authorId: string } } | null };

export type GetPathByProjectIdQueryVariables = Exact<{
  projectId: Scalars['uuid'];
}>;


export type GetPathByProjectIdQuery = { __typename?: 'query_root', project?: { __typename?: 'project', node?: { __typename?: 'path_node', id: any, title?: string | null, caption?: string | null, path: { __typename?: 'path', id: any, title?: string | null, slug?: string | null, authorId: string } } | null } | null };

export type AdminPublishProjectMutationVariables = Exact<{
  projectId: Scalars['uuid'];
}>;


export type AdminPublishProjectMutation = { __typename?: 'mutation_root', update_project_by_pk?: { __typename?: 'project', id: any } | null };

export type UsernameSearchQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type UsernameSearchQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: string }> };

export type ProjectFeedbackQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type ProjectFeedbackQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'project', id: any, rejectedAt?: any | null, rejectedReason?: string | null, rejectedFeedback?: string | null, rejectedByUser?: { __typename?: 'user', userType?: string | null, avatar?: string | null, username?: string | null, isEducator: boolean, firstName?: string | null, lastName?: string | null, creatorLevel?: string | null, id: string } | null, node?: { __typename?: 'path_node', id: any, title?: string | null, caption?: string | null, path: { __typename?: 'path', slug?: string | null } } | null }> };

export type AdminUsersCoinBalanceByUserQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type AdminUsersCoinBalanceByUserQuery = { __typename?: 'query_root', coin_trx: Array<{ __typename?: 'coin_trx', id: any, userId: string, balance: number }> };

export type AdminDashboardEducatorCodeFragment = { __typename?: 'educator_code', code: string, available: number, expiresAt: any, createdAt: any };

export type AdminLearnerGroupMemberFragment = { __typename?: 'learner_group_member', learnerGroupId: any, userId: string, isOwner: boolean, role: string, user: { __typename?: 'user', firstName?: string | null, lastName?: string | null, email?: string | null, avatar?: string | null, userType?: string | null, isEducator: boolean, username?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } };

export type AdminDashboardLearnerGroupFragment = { __typename?: 'learner_group', id: any, name?: string | null, archivedAt?: any | null, members: Array<{ __typename?: 'learner_group_member', learnerGroupId: any, userId: string, isOwner: boolean, role: string, user: { __typename?: 'user', firstName?: string | null, lastName?: string | null, email?: string | null, avatar?: string | null, userType?: string | null, isEducator: boolean, username?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } }>, educatorCodes: Array<{ __typename?: 'educator_code', code: string, available: number, expiresAt: any, createdAt: any }> };

export type AdminDashboardClassroomsByTeacherIdQueryVariables = Exact<{
  teacherUserId: Scalars['String'];
}>;


export type AdminDashboardClassroomsByTeacherIdQuery = { __typename?: 'query_root', learnerGroups: Array<{ __typename?: 'learner_group', id: any, name?: string | null, archivedAt?: any | null, members: Array<{ __typename?: 'learner_group_member', learnerGroupId: any, userId: string, isOwner: boolean, role: string, user: { __typename?: 'user', firstName?: string | null, lastName?: string | null, email?: string | null, avatar?: string | null, userType?: string | null, isEducator: boolean, username?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } }>, educatorCodes: Array<{ __typename?: 'educator_code', code: string, available: number, expiresAt: any, createdAt: any }> }> };

export type AdminDashboardCreateClassroomMutationVariables = Exact<{
  name: Scalars['String'];
  numStudents: Scalars['Int'];
  orgId: Scalars['String'];
  userId: Scalars['String'];
  code: Scalars['String'];
  color: Scalars['String'];
}>;


export type AdminDashboardCreateClassroomMutation = { __typename?: 'mutation_root', adminCreateClassroom?: { __typename?: 'learner_group', id: any, name?: string | null, archivedAt?: any | null, members: Array<{ __typename?: 'learner_group_member', learnerGroupId: any, userId: string, isOwner: boolean, role: string, user: { __typename?: 'user', firstName?: string | null, lastName?: string | null, email?: string | null, avatar?: string | null, userType?: string | null, isEducator: boolean, username?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } }>, educatorCodes: Array<{ __typename?: 'educator_code', code: string, available: number, expiresAt: any, createdAt: any }> } | null };

export type AdminDashboardCreateEducatorCodeMutationVariables = Exact<{
  code: Scalars['String'];
  available: Scalars['Int'];
  learnerGroupId: Scalars['uuid'];
}>;


export type AdminDashboardCreateEducatorCodeMutation = { __typename?: 'mutation_root', adminCreateClassroomCode?: { __typename?: 'educator_code', code: string, available: number, expiresAt: any, createdAt: any } | null };

export type AdminDashboardDeleteEducatorCodeMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type AdminDashboardDeleteEducatorCodeMutation = { __typename?: 'mutation_root', adminDeleteClassroomCode?: { __typename?: 'educator_code', code: string } | null };

export type AdminAddCoTeacherMutationVariables = Exact<{
  learnerGroupId: Scalars['uuid'];
  userId: Scalars['String'];
}>;


export type AdminAddCoTeacherMutation = { __typename?: 'mutation_root', adminAddCoTeacher?: { __typename?: 'learner_group_member', learnerGroupId: any, userId: string, isOwner: boolean, role: string, user: { __typename?: 'user', firstName?: string | null, lastName?: string | null, email?: string | null, avatar?: string | null, userType?: string | null, isEducator: boolean, username?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } } | null };

export type AdminRemoveCoTeacherMutationVariables = Exact<{
  learnerGroupId: Scalars['uuid'];
  userId: Scalars['String'];
}>;


export type AdminRemoveCoTeacherMutation = { __typename?: 'mutation_root', adminRemoveCoTeacher?: { __typename?: 'learner_group_member_mutation_response', returning: Array<{ __typename?: 'learner_group_member', learnerGroupId: any, userId: string }> } | null };

export type AdminArchiveClassroomMutationVariables = Exact<{
  learnerGroupId: Scalars['uuid'];
  archivedAt: Scalars['timestamptz'];
}>;


export type AdminArchiveClassroomMutation = { __typename?: 'mutation_root', update_learner_group_by_pk?: { __typename?: 'learner_group', id: any, archivedAt?: any | null } | null };

export type AdminDashboardUserAccountFragment = { __typename?: 'user', avatar?: string | null, bio?: string | null, disabled: boolean, username?: string | null, firstName?: string | null, lastName?: string | null, creatorLevel?: string | null, canAuthor: boolean, orgId?: string | null, createdAt: any, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, userType?: string | null, isEducator: boolean, id: string, invitedBy?: { __typename?: 'user', username?: string | null, id: string } | null, organization?: { __typename?: 'organization', name: string, id: string } | null, learnerGroups: Array<{ __typename?: 'learner_group_member', learnerGroup: { __typename?: 'learner_group', id: any, name?: string | null, members: Array<{ __typename?: 'learner_group_member', user: { __typename?: 'user', id: number, avatar?: string | null, firestoreId: string, userType?: string | null, firstName?: string | null, email?: string | null, isEducator: boolean, lastName?: string | null, teacher?: { __typename?: 'user_teacher', id: any, displayName?: string | null } | null } }> } }> };

export type GetAdminDashboardUserQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetAdminDashboardUserQuery = { __typename?: 'query_root', user_by_pk?: { __typename?: 'user', avatar?: string | null, bio?: string | null, disabled: boolean, username?: string | null, firstName?: string | null, lastName?: string | null, creatorLevel?: string | null, canAuthor: boolean, orgId?: string | null, createdAt: any, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, userType?: string | null, isEducator: boolean, id: string, invitedBy?: { __typename?: 'user', username?: string | null, id: string } | null, organization?: { __typename?: 'organization', name: string, id: string } | null, learnerGroups: Array<{ __typename?: 'learner_group_member', learnerGroup: { __typename?: 'learner_group', id: any, name?: string | null, members: Array<{ __typename?: 'learner_group_member', user: { __typename?: 'user', id: number, avatar?: string | null, firestoreId: string, userType?: string | null, firstName?: string | null, email?: string | null, isEducator: boolean, lastName?: string | null, teacher?: { __typename?: 'user_teacher', id: any, displayName?: string | null } | null } }> } }> } | null };

export type GetAdminDashboardUsersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where: User_Bool_Exp;
}>;


export type GetAdminDashboardUsersQuery = { __typename?: 'query_root', adminDashboardUsers: Array<{ __typename?: 'user', avatar?: string | null, bio?: string | null, disabled: boolean, username?: string | null, firstName?: string | null, lastName?: string | null, creatorLevel?: string | null, canAuthor: boolean, orgId?: string | null, createdAt: any, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, userType?: string | null, isEducator: boolean, id: string, invitedBy?: { __typename?: 'user', username?: string | null, id: string } | null, organization?: { __typename?: 'organization', name: string, id: string } | null, learnerGroups: Array<{ __typename?: 'learner_group_member', learnerGroup: { __typename?: 'learner_group', id: any, name?: string | null, members: Array<{ __typename?: 'learner_group_member', user: { __typename?: 'user', id: number, avatar?: string | null, firestoreId: string, userType?: string | null, firstName?: string | null, email?: string | null, isEducator: boolean, lastName?: string | null, teacher?: { __typename?: 'user_teacher', id: any, displayName?: string | null } | null } }> } }> }> };

export type DisableUserMutationVariables = Exact<{
  userId: Scalars['String'];
  disabled: Scalars['Boolean'];
}>;


export type DisableUserMutation = { __typename?: 'mutation_root', api_disable_user?: { __typename?: 'api_disable_user_output', userId: string, disabled: boolean } | null };

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type DeleteUserMutation = { __typename?: 'mutation_root', api_delete_user: string };

export type UpdateUserCreatorLevelMutationVariables = Exact<{
  userId: Scalars['String'];
  creatorLevel: Scalars['String'];
}>;


export type UpdateUserCreatorLevelMutation = { __typename?: 'mutation_root', update_user_by_pk?: { __typename?: 'user', avatar?: string | null, bio?: string | null, disabled: boolean, username?: string | null, firstName?: string | null, lastName?: string | null, creatorLevel?: string | null, canAuthor: boolean, orgId?: string | null, createdAt: any, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, userType?: string | null, isEducator: boolean, id: string, invitedBy?: { __typename?: 'user', username?: string | null, id: string } | null, organization?: { __typename?: 'organization', name: string, id: string } | null, learnerGroups: Array<{ __typename?: 'learner_group_member', learnerGroup: { __typename?: 'learner_group', id: any, name?: string | null, members: Array<{ __typename?: 'learner_group_member', user: { __typename?: 'user', id: number, avatar?: string | null, firestoreId: string, userType?: string | null, firstName?: string | null, email?: string | null, isEducator: boolean, lastName?: string | null, teacher?: { __typename?: 'user_teacher', id: any, displayName?: string | null } | null } }> } }> } | null };

export type AdminDashboardUpdateUserProfileMutationVariables = Exact<{
  userId: Scalars['String'];
  username: Scalars['String'];
  firstName: Scalars['String'];
  avatar: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
}>;


export type AdminDashboardUpdateUserProfileMutation = { __typename?: 'mutation_root', update_user_by_pk?: { __typename?: 'user', avatar?: string | null, bio?: string | null, disabled: boolean, username?: string | null, firstName?: string | null, lastName?: string | null, creatorLevel?: string | null, canAuthor: boolean, orgId?: string | null, createdAt: any, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, userType?: string | null, isEducator: boolean, id: string, invitedBy?: { __typename?: 'user', username?: string | null, id: string } | null, organization?: { __typename?: 'organization', name: string, id: string } | null, learnerGroups: Array<{ __typename?: 'learner_group_member', learnerGroup: { __typename?: 'learner_group', id: any, name?: string | null, members: Array<{ __typename?: 'learner_group_member', user: { __typename?: 'user', id: number, avatar?: string | null, firestoreId: string, userType?: string | null, firstName?: string | null, email?: string | null, isEducator: boolean, lastName?: string | null, teacher?: { __typename?: 'user_teacher', id: any, displayName?: string | null } | null } }> } }> } | null };

export type AllOrganizationsQueryVariables = Exact<{
  offset: Scalars['Int'];
}>;


export type AllOrganizationsQuery = { __typename?: 'query_root', organization: Array<{ __typename?: 'organization', name: string, zip: string, id: string }> };

export type AdminUserCoinsLedgerQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  userId: Scalars['String'];
}>;


export type AdminUserCoinsLedgerQuery = { __typename?: 'query_root', coins: Array<{ __typename?: 'coin_trx', id: any, userId: string, amount: number, balance: number, category: Enums_Coin_Trx_Category_Enum, createdAt: any }> };

export type AdminUserAdjustCoinsMutationVariables = Exact<{
  userId: Scalars['String'];
  amount: Scalars['Int'];
}>;


export type AdminUserAdjustCoinsMutation = { __typename?: 'mutation_root', insert_coin_trx_one?: { __typename?: 'coin_trx', id: any } | null };

export type AdminCreateKidInviteMutationVariables = Exact<{
  code: Educator_Code_Insert_Input;
}>;


export type AdminCreateKidInviteMutation = { __typename?: 'mutation_root', adminCreateKidInvite?: { __typename?: 'educator_code', available: number, code: string, createdAt: any, expiresAt: any } | null };

export type AdminEditKidInviteMutationVariables = Exact<{
  code: Scalars['String'];
  available: Scalars['Int'];
}>;


export type AdminEditKidInviteMutation = { __typename?: 'mutation_root', adminEditKidInvite?: { __typename?: 'educator_code', code: string, available: number } | null };

export type PathsByStatusFragment = { __typename?: 'path', id: any, slug?: string | null, title?: string | null, authorId: string, createdAt: any, updatedAt: any, isPublished: boolean, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, nodes: Array<{ __typename?: 'path_node', id: any }>, user?: { __typename?: 'user', avatar?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, isEducator: boolean, isMod: boolean, country?: string | null, userType?: string | null, creatorLevel?: string | null, orgId?: string | null, id: string } | null, authors_aggregate: { __typename?: 'path_author_aggregate', aggregate?: { __typename?: 'path_author_aggregate_fields', count: number } | null } };

export type CreatePathMutationVariables = Exact<{
  path: Path_Insert_Input;
}>;


export type CreatePathMutation = { __typename?: 'mutation_root', insert_path_one?: { __typename?: 'path', id: any, slug?: string | null, title?: string | null, authorId: string, createdAt: any, updatedAt: any, isPublished: boolean, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, nodes: Array<{ __typename?: 'path_node', id: any }>, user?: { __typename?: 'user', avatar?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, isEducator: boolean, isMod: boolean, country?: string | null, userType?: string | null, creatorLevel?: string | null, orgId?: string | null, id: string } | null, authors_aggregate: { __typename?: 'path_author_aggregate', aggregate?: { __typename?: 'path_author_aggregate_fields', count: number } | null } } | null };

export type CreatePathNodeMutationVariables = Exact<{
  node: Path_Node_Insert_Input;
}>;


export type CreatePathNodeMutation = { __typename?: 'mutation_root', insert_path_node_one?: { __typename?: 'path_node', id: any, pathId: any, title?: string | null, caption?: string | null, createdAt: any, lexorank: string, responsesEnabled: boolean, rewardAmount: number } | null };

export type CreatorPathsQueryVariables = Exact<{
  offset: Scalars['Int'];
  status: Scalars['String'];
  authorId: Scalars['String'];
  limit: Scalars['Int'];
  orderBy: Path_Order_By;
}>;


export type CreatorPathsQuery = { __typename?: 'query_root', paths: Array<{ __typename?: 'path', id: any, slug?: string | null, title?: string | null, authorId: string, createdAt: any, updatedAt: any, isPublished: boolean, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, nodes: Array<{ __typename?: 'path_node', id: any }>, user?: { __typename?: 'user', avatar?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, isEducator: boolean, isMod: boolean, country?: string | null, userType?: string | null, creatorLevel?: string | null, orgId?: string | null, id: string } | null, authors_aggregate: { __typename?: 'path_author_aggregate', aggregate?: { __typename?: 'path_author_aggregate_fields', count: number } | null } }> };

export type PathActivityFragment = { __typename?: 'path_activity', id: any, pathId: any, userId: string, pathReviewId?: any | null, type: string, path: { __typename?: 'path', id: any, title?: string | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, user?: { __typename?: 'user', firestoreId: string, avatar?: string | null, username?: string | null, creatorLevel?: string | null, country?: string | null, id: string } | null }, user: { __typename?: 'user', firstName?: string | null, lastName?: string | null, avatar?: string | null, username?: string | null, isMod: boolean, country?: string | null, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, id: string }, pathReview?: { __typename?: 'path_review', id: any, pathId: any, type: string, userId: string, needsReview: boolean, createdAt: any, updatedAt: any, comment?: { __typename?: 'comment', text?: string | null } | null } | null };

export type CreatePathActivityWithReviewMutationVariables = Exact<{
  object: Path_Activity_Insert_Input;
  pathId: Scalars['bigint'];
  status: Scalars['String'];
  isPublished: Scalars['Boolean'];
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  slug?: InputMaybe<Scalars['String']>;
  authorId: Scalars['String'];
  authors: Array<Path_Author_Insert_Input> | Path_Author_Insert_Input;
}>;


export type CreatePathActivityWithReviewMutation = { __typename?: 'mutation_root', insert_path_activity_one?: { __typename?: 'path_activity', id: any, pathId: any, userId: string, pathReviewId?: any | null, type: string, path: { __typename?: 'path', id: any, title?: string | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, user?: { __typename?: 'user', firestoreId: string, avatar?: string | null, username?: string | null, creatorLevel?: string | null, country?: string | null, id: string } | null }, user: { __typename?: 'user', firstName?: string | null, lastName?: string | null, avatar?: string | null, username?: string | null, isMod: boolean, country?: string | null, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, id: string }, pathReview?: { __typename?: 'path_review', id: any, pathId: any, type: string, userId: string, needsReview: boolean, createdAt: any, updatedAt: any, comment?: { __typename?: 'comment', text?: string | null } | null } | null } | null, insert_path_author?: { __typename?: 'path_author_mutation_response', returning: Array<{ __typename?: 'path_author', pathId: any, userId: string }> } | null, update_path_by_pk?: { __typename?: 'path', id: any, status: string, slug?: string | null, isPublished: boolean, isTractOriginal: boolean, authorId: string, authors: Array<{ __typename?: 'path_author', pathId: any, userId: string }> } | null };

export type PathReviewFragment = { __typename?: 'path_review', id: any, pathId: any, type: string, userId: string, needsReview: boolean, createdAt: any, updatedAt: any, comment?: { __typename?: 'comment', text?: string | null } | null, user: { __typename?: 'user', avatar?: string | null, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, username?: string | null, isMod: boolean, firstName?: string | null, lastName?: string | null, id: string } };

export type CreatePathReviewMutationVariables = Exact<{
  object: Path_Review_Insert_Input;
}>;


export type CreatePathReviewMutation = { __typename?: 'mutation_root', insert_path_review_one?: { __typename?: 'path_review', id: any, pathId: any, type: string, userId: string, needsReview: boolean, createdAt: any, updatedAt: any, comment?: { __typename?: 'comment', text?: string | null } | null, user: { __typename?: 'user', avatar?: string | null, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, username?: string | null, isMod: boolean, firstName?: string | null, lastName?: string | null, id: string } } | null };

export type GetPathActivityForUserQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  userId: Scalars['String'];
  creatorLevel: String_Comparison_Exp;
  type: String_Comparison_Exp;
}>;


export type GetPathActivityForUserQuery = { __typename?: 'query_root', pathActivity: Array<{ __typename?: 'path_activity', id: any, pathId: any, userId: string, pathReviewId?: any | null, type: string, path: { __typename?: 'path', id: any, title?: string | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, user?: { __typename?: 'user', firestoreId: string, avatar?: string | null, username?: string | null, creatorLevel?: string | null, country?: string | null, id: string } | null }, user: { __typename?: 'user', firstName?: string | null, lastName?: string | null, avatar?: string | null, username?: string | null, isMod: boolean, country?: string | null, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, id: string }, pathReview?: { __typename?: 'path_review', id: any, pathId: any, type: string, userId: string, needsReview: boolean, createdAt: any, updatedAt: any, comment?: { __typename?: 'comment', text?: string | null } | null } | null }> };

export type RequestReviewFromReviewerMutationVariables = Exact<{
  pathReviewId: Scalars['uuid'];
}>;


export type RequestReviewFromReviewerMutation = { __typename?: 'mutation_root', update_path_review_by_pk?: { __typename?: 'path_review', id: any, pathId: any, needsReview: boolean, type: string } | null };

export type PathsWithReviewsQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  creatorLevel: String_Comparison_Exp;
  status: String_Comparison_Exp;
  userId: Scalars['String'];
  type: String_Comparison_Exp;
  orderBy?: InputMaybe<Array<Path_Review_Order_By> | Path_Review_Order_By>;
  reviewUserId: String_Comparison_Exp;
}>;


export type PathsWithReviewsQuery = { __typename?: 'query_root', pathReviews: Array<{ __typename?: 'path_review', id: any, pathId: any, type: string, userId: string, needsReview: boolean, createdAt: any, updatedAt: any, path: { __typename?: 'path', id: any, slug?: string | null, title?: string | null, authorId: string, createdAt: any, updatedAt: any, isPublished: boolean, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, nodes: Array<{ __typename?: 'path_node', id: any }>, user?: { __typename?: 'user', avatar?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, isEducator: boolean, isMod: boolean, country?: string | null, userType?: string | null, creatorLevel?: string | null, orgId?: string | null, id: string } | null, authors_aggregate: { __typename?: 'path_author_aggregate', aggregate?: { __typename?: 'path_author_aggregate_fields', count: number } | null } }, comment?: { __typename?: 'comment', text?: string | null } | null, user: { __typename?: 'user', avatar?: string | null, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, username?: string | null, isMod: boolean, firstName?: string | null, lastName?: string | null, id: string } }> };

export type ClassroomLearnerGroupQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type ClassroomLearnerGroupQuery = { __typename?: 'query_root', learnerGroup?: { __typename?: 'learner_group', id: any, name?: string | null, type: string, privacyScope?: string | null, color?: string | null, source?: Enums_Integration_Provider_Enum | null, sourceId?: string | null, members: Array<{ __typename?: 'learner_group_member', learnerGroupId: any, userId: string, isOwner: boolean, role: string, user: { __typename?: 'user', firstName?: string | null, lastName?: string | null, email?: string | null, avatar?: string | null, isEducator: boolean, userType?: string | null, username?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } }>, pendingMembers: Array<{ __typename?: 'learner_group_pending_member', firstName?: string | null, lastName?: string | null, foreignId: string, provider: Enums_Integration_Provider_Enum }>, organization?: { __typename?: 'organization', id: any, avatar?: string | null, name: string } | null, educatorCodes: Array<{ __typename?: 'educator_code', code: string, available: number, expiresAt: any, createdAt: any }>, learner_group_path_collections: Array<{ __typename?: 'learner_group_path_collection', learnerGroupId: any, pathCollectionId: any, pathCollection: { __typename?: 'path_collection', id: any, pathCollectionItems: Array<{ __typename?: 'path_collection_item', collectionId: any, pathId: any }>, pathCollectionItems_aggregate: { __typename?: 'path_collection_item_aggregate', aggregate?: { __typename?: 'path_collection_item_aggregate_fields', count: number } | null } } }>, assignments: Array<{ __typename?: 'assignment_learner_group', assignmentId: any, learnerGroupId: any, isFinished: boolean }> } | null };

export type ClassroomByIdQueryVariables = Exact<{
  classId: Scalars['uuid'];
}>;


export type ClassroomByIdQuery = { __typename?: 'query_root', learnerGroups: Array<{ __typename?: 'learner_group', id: any, name?: string | null, type: string, privacyScope?: string | null, color?: string | null, source?: Enums_Integration_Provider_Enum | null, sourceId?: string | null, members: Array<{ __typename?: 'learner_group_member', learnerGroupId: any, userId: string, isOwner: boolean, role: string, user: { __typename?: 'user', firstName?: string | null, lastName?: string | null, email?: string | null, avatar?: string | null, isEducator: boolean, userType?: string | null, username?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } }>, pendingMembers: Array<{ __typename?: 'learner_group_pending_member', firstName?: string | null, lastName?: string | null, foreignId: string, provider: Enums_Integration_Provider_Enum }>, organization?: { __typename?: 'organization', id: any, avatar?: string | null, name: string } | null, educatorCodes: Array<{ __typename?: 'educator_code', code: string, available: number, expiresAt: any, createdAt: any }>, learner_group_path_collections: Array<{ __typename?: 'learner_group_path_collection', learnerGroupId: any, pathCollectionId: any, pathCollection: { __typename?: 'path_collection', id: any, pathCollectionItems: Array<{ __typename?: 'path_collection_item', collectionId: any, pathId: any }>, pathCollectionItems_aggregate: { __typename?: 'path_collection_item_aggregate', aggregate?: { __typename?: 'path_collection_item_aggregate_fields', count: number } | null } } }>, assignments: Array<{ __typename?: 'assignment_learner_group', assignmentId: any, learnerGroupId: any, isFinished: boolean }> }> };

export type ClassroomsByTeacherIdQueryVariables = Exact<{
  teacherUserId: Scalars['String'];
}>;


export type ClassroomsByTeacherIdQuery = { __typename?: 'query_root', learnerGroups: Array<{ __typename?: 'learner_group', id: any, name?: string | null, type: string, privacyScope?: string | null, color?: string | null, source?: Enums_Integration_Provider_Enum | null, sourceId?: string | null, members: Array<{ __typename?: 'learner_group_member', learnerGroupId: any, userId: string, isOwner: boolean, role: string, user: { __typename?: 'user', firstName?: string | null, lastName?: string | null, email?: string | null, avatar?: string | null, isEducator: boolean, userType?: string | null, username?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } }>, pendingMembers: Array<{ __typename?: 'learner_group_pending_member', firstName?: string | null, lastName?: string | null, foreignId: string, provider: Enums_Integration_Provider_Enum }>, organization?: { __typename?: 'organization', id: any, avatar?: string | null, name: string } | null, educatorCodes: Array<{ __typename?: 'educator_code', code: string, available: number, expiresAt: any, createdAt: any }>, learner_group_path_collections: Array<{ __typename?: 'learner_group_path_collection', learnerGroupId: any, pathCollectionId: any, pathCollection: { __typename?: 'path_collection', id: any, pathCollectionItems: Array<{ __typename?: 'path_collection_item', collectionId: any, pathId: any }>, pathCollectionItems_aggregate: { __typename?: 'path_collection_item_aggregate', aggregate?: { __typename?: 'path_collection_item_aggregate_fields', count: number } | null } } }>, assignments: Array<{ __typename?: 'assignment_learner_group', assignmentId: any, learnerGroupId: any, isFinished: boolean }> }> };

export type ClassroomPathsQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  visibility: Scalars['String'];
  authorIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  isPublished: Scalars['Boolean'];
}>;


export type ClassroomPathsQuery = { __typename?: 'query_root', paths: Array<{ __typename?: 'path', _schemaVersion: number, authorId: string, cover?: string | null, coverAnimated?: string | null, id: any, interestArea?: string | null, isPublished: boolean, isTractOriginal: boolean, subjects?: any | null, gradeLevels?: any | null, orgId?: string | null, publishedAt?: any | null, slug?: string | null, status: string, title?: string | null, totalXP: number, isVisibleUnauthed?: boolean | null, tags?: any | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, coverAnimatedFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, creatorLevel?: string | null, id: string } | null }> };

export type ClassroomMemberTeachersQueryVariables = Exact<{
  classId: Scalars['uuid'];
  teacherIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type ClassroomMemberTeachersQuery = { __typename?: 'query_root', learner_group_member: Array<{ __typename?: 'learner_group_member', learnerGroupId: any, userId: string, isOwner: boolean, role: string, user: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, isEducator: boolean, userType?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } }> };

export type ClassroomProjectsQueryVariables = Exact<{
  userIds: Array<Scalars['String']> | Scalars['String'];
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  isPrivate?: InputMaybe<Boolean_Comparison_Exp>;
}>;


export type ClassroomProjectsQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'project', id: any, text?: string | null, rewardCoinTrxId?: any | null, isPrivate: boolean, published: boolean, userId: string, rejectedAt?: any | null, rejectedReason?: string | null, rejectedFeedback?: string | null, rejectedByUserId?: string | null, awards: Array<{ __typename?: 'project_award', projectId: any, awardId: any, count: number }>, node?: { __typename?: 'path_node', id: any, title?: string | null, path: { __typename?: 'path', id: any, authorId: string } } | null, stats?: { __typename?: 'project_stats', projectId: any, commentCount: number, likeCount: number, viewCount: number } | null, user: { __typename?: 'user', avatar?: string | null, username?: string | null, isEducator: boolean, firstName?: string | null, lastName?: string | null, isMod: boolean, creatorLevel?: string | null, country?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, organization?: { __typename?: 'organization', id: string } | null }, file?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null }> };

export type UpdateClassroomSettingsMutationVariables = Exact<{
  classId: Scalars['uuid'];
  name: Scalars['String'];
  color?: InputMaybe<Scalars['String']>;
  privacyScope?: InputMaybe<Scalars['String']>;
}>;


export type UpdateClassroomSettingsMutation = { __typename?: 'mutation_root', updatePrivacy?: { __typename?: 'api_update_learner_group_settings_output', name: string, color?: string | null, classId: any, privacyScope?: string | null } | null };

export type ClassroomAssignmentFragment = { __typename?: 'assignment_learner_group', assignmentId: any, learnerGroupId: any, isFinished: boolean, assignment: { __typename?: 'assignment', id: any, title: string, description?: string | null, dueDate?: any | null, startDate: any, paths: Array<{ __typename?: 'assignment_path', assignmentId: any, pathId: any, path: { __typename?: 'path', id: any, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null } }> } };

export type ClassroomAssignmentsQueryVariables = Exact<{
  where?: InputMaybe<Assignment_Learner_Group_Bool_Exp>;
  orderBy?: InputMaybe<Array<Assignment_Learner_Group_Order_By> | Assignment_Learner_Group_Order_By>;
}>;


export type ClassroomAssignmentsQuery = { __typename?: 'query_root', assignment_learner_group: Array<{ __typename?: 'assignment_learner_group', assignmentId: any, learnerGroupId: any, isFinished: boolean, assignment: { __typename?: 'assignment', id: any, title: string, description?: string | null, dueDate?: any | null, startDate: any, paths: Array<{ __typename?: 'assignment_path', assignmentId: any, pathId: any, path: { __typename?: 'path', id: any, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null } }> } }> };

export type ClassroomAssignmentMarkFinishedMutationVariables = Exact<{
  assignmentId: Scalars['uuid'];
  classId: Scalars['uuid'];
  isFinished: Scalars['Boolean'];
}>;


export type ClassroomAssignmentMarkFinishedMutation = { __typename?: 'mutation_root', update_assignment_learner_group_by_pk?: { __typename?: 'assignment_learner_group', assignmentId: any, learnerGroupId: any, isFinished: boolean } | null };

export type ClassroomAssignmentDetailFragment = { __typename?: 'assignment', id: any, title: string, startDate: any, dueDate?: any | null, paths: Array<{ __typename?: 'assignment_path', assignmentId: any, pathId: any, path: { __typename?: 'path', id: any, nodes: Array<{ __typename?: 'path_node', id: any, pathId: any, title?: string | null, responsesEnabled: boolean, projects: Array<{ __typename?: 'project', id: any, text?: string | null, rewardCoinTrxId?: any | null, isPrivate: boolean, published: boolean, userId: string, rejectedAt?: any | null, rejectedReason?: string | null, rejectedFeedback?: string | null, rejectedByUserId?: string | null, awards: Array<{ __typename?: 'project_award', projectId: any, awardId: any, count: number }>, node?: { __typename?: 'path_node', id: any, title?: string | null, path: { __typename?: 'path', id: any, authorId: string } } | null, stats?: { __typename?: 'project_stats', projectId: any, commentCount: number, likeCount: number, viewCount: number } | null, user: { __typename?: 'user', avatar?: string | null, username?: string | null, isEducator: boolean, firstName?: string | null, lastName?: string | null, isMod: boolean, creatorLevel?: string | null, country?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, organization?: { __typename?: 'organization', id: string } | null }, file?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null }> }> } }> };

export type ClassroomAssignmentDetailsQueryVariables = Exact<{
  assignmentId: Scalars['uuid'];
  learnerUserIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type ClassroomAssignmentDetailsQuery = { __typename?: 'query_root', assignment?: { __typename?: 'assignment', id: any, title: string, startDate: any, dueDate?: any | null, paths: Array<{ __typename?: 'assignment_path', assignmentId: any, pathId: any, path: { __typename?: 'path', id: any, nodes: Array<{ __typename?: 'path_node', id: any, pathId: any, title?: string | null, responsesEnabled: boolean, projects: Array<{ __typename?: 'project', id: any, text?: string | null, rewardCoinTrxId?: any | null, isPrivate: boolean, published: boolean, userId: string, rejectedAt?: any | null, rejectedReason?: string | null, rejectedFeedback?: string | null, rejectedByUserId?: string | null, awards: Array<{ __typename?: 'project_award', projectId: any, awardId: any, count: number }>, node?: { __typename?: 'path_node', id: any, title?: string | null, path: { __typename?: 'path', id: any, authorId: string } } | null, stats?: { __typename?: 'project_stats', projectId: any, commentCount: number, likeCount: number, viewCount: number } | null, user: { __typename?: 'user', avatar?: string | null, username?: string | null, isEducator: boolean, firstName?: string | null, lastName?: string | null, isMod: boolean, creatorLevel?: string | null, country?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, organization?: { __typename?: 'organization', id: string } | null }, file?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null }> }> } }> } | null };

export type SyncRosterMutationVariables = Exact<{
  classId: Scalars['String'];
  accessToken: Scalars['String'];
  learnerGroupId: Scalars['String'];
}>;


export type SyncRosterMutation = { __typename?: 'mutation_root', syncRoster?: { __typename?: 'api_sync_roster_output', invitesCount?: any | null } | null };

export type GuideFragment = { __typename?: 'guide', id: any, bigIdea?: string | null, concepts?: string | null, contentStandards?: string | null, durationLower?: number | null, durationUpper?: number | null, learningObjectives?: string | null, resources?: string | null, description?: string | null, downloadUrl?: string | null, discussionQuestions?: string | null };

export type InsertGuideMutationVariables = Exact<{
  pathId: Scalars['bigint'];
  isRelatedPath: Scalars['Boolean'];
  guide: Guide_Insert_Input;
}>;


export type InsertGuideMutation = { __typename?: 'mutation_root', guidePath?: { __typename?: 'guide_path', guideId: any, pathId: any, isRelatedPath: boolean, guide: { __typename?: 'guide', id: any, bigIdea?: string | null, concepts?: string | null, contentStandards?: string | null, durationLower?: number | null, durationUpper?: number | null, learningObjectives?: string | null, resources?: string | null, description?: string | null, downloadUrl?: string | null, discussionQuestions?: string | null } } | null };

export type UpdateGuideByPkMutationVariables = Exact<{
  id: Scalars['uuid'];
  object: Guide_Set_Input;
}>;


export type UpdateGuideByPkMutation = { __typename?: 'mutation_root', guide?: { __typename?: 'guide', id: any, bigIdea?: string | null, concepts?: string | null, contentStandards?: string | null, durationLower?: number | null, durationUpper?: number | null, learningObjectives?: string | null, resources?: string | null, description?: string | null, downloadUrl?: string | null, discussionQuestions?: string | null } | null };

export type PathCoAuthorFragment = { __typename?: 'path_author', pathId: any, userId: string, user: { __typename?: 'user', username?: string | null, firstName?: string | null, lastName?: string | null, isEducator: boolean, avatar?: string | null, id: string } };

export type PathBuilderNodeFragment = { __typename?: 'path_node', id: any, pathId: any, title?: string | null, caption?: string | null, createdAt: any, lexorank: string, responsesEnabled: boolean, rewardAmount: number, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, videoFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }>, integrations: Array<{ __typename?: 'user_file_integration', foreignId: string, source: string }> } | null };

export type PathBuilderPathV4Fragment = { __typename?: 'path', id: any, title?: string | null, description?: string | null, interestArea?: string | null, status: string, isPublished: boolean, media?: any | null, orgId?: string | null, authorId: string, slug?: string | null, publishedAt?: any | null, totalXP: number, isFeatured: boolean, xpMultiplier: any, subjects?: any | null, supplies?: string | null, tags?: any | null, skills?: any | null, gradeLevels?: any | null, isVisibleUnauthed?: boolean | null, isTractOriginal: boolean, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, coverAnimatedFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, user?: { __typename?: 'user', creatorLevel?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, isEducator: boolean, avatar?: string | null, userType?: string | null, pathPrivacy?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } | null, authors: Array<{ __typename?: 'path_author', pathId: any, userId: string, user: { __typename?: 'user', username?: string | null, firstName?: string | null, lastName?: string | null, isEducator: boolean, avatar?: string | null, id: string } }>, nodes: Array<{ __typename?: 'path_node', id: any, pathId: any, title?: string | null, caption?: string | null, createdAt: any, lexorank: string, responsesEnabled: boolean, rewardAmount: number, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, videoFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }>, integrations: Array<{ __typename?: 'user_file_integration', foreignId: string, source: string }> } | null }>, guides: Array<{ __typename?: 'guide_path', guide: { __typename?: 'guide', id: any, description?: string | null, bigIdea?: string | null, concepts?: string | null, contentStandards?: string | null, durationLower?: number | null, durationUpper?: number | null, learningObjectives?: string | null, resources?: string | null, downloadUrl?: string | null, discussionQuestions?: string | null } }> };

export type GetPathWithNodesQueryVariables = Exact<{
  pathId: Scalars['bigint'];
}>;


export type GetPathWithNodesQuery = { __typename?: 'query_root', path?: { __typename?: 'path', id: any, title?: string | null, description?: string | null, interestArea?: string | null, status: string, isPublished: boolean, media?: any | null, orgId?: string | null, authorId: string, slug?: string | null, publishedAt?: any | null, totalXP: number, isFeatured: boolean, xpMultiplier: any, subjects?: any | null, supplies?: string | null, tags?: any | null, skills?: any | null, gradeLevels?: any | null, isVisibleUnauthed?: boolean | null, isTractOriginal: boolean, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, coverAnimatedFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, user?: { __typename?: 'user', creatorLevel?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, isEducator: boolean, avatar?: string | null, userType?: string | null, pathPrivacy?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } | null, authors: Array<{ __typename?: 'path_author', pathId: any, userId: string, user: { __typename?: 'user', username?: string | null, firstName?: string | null, lastName?: string | null, isEducator: boolean, avatar?: string | null, id: string } }>, nodes: Array<{ __typename?: 'path_node', id: any, pathId: any, title?: string | null, caption?: string | null, createdAt: any, lexorank: string, responsesEnabled: boolean, rewardAmount: number, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, videoFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }>, integrations: Array<{ __typename?: 'user_file_integration', foreignId: string, source: string }> } | null }>, guides: Array<{ __typename?: 'guide_path', guide: { __typename?: 'guide', id: any, description?: string | null, bigIdea?: string | null, concepts?: string | null, contentStandards?: string | null, durationLower?: number | null, durationUpper?: number | null, learningObjectives?: string | null, resources?: string | null, downloadUrl?: string | null, discussionQuestions?: string | null } }> } | null };

export type SavePathV4MutationVariables = Exact<{
  pathId: Scalars['bigint'];
  path?: InputMaybe<Path_Set_Input>;
}>;


export type SavePathV4Mutation = { __typename?: 'mutation_root', path?: { __typename?: 'path', id: any, title?: string | null, description?: string | null, interestArea?: string | null, status: string, isPublished: boolean, media?: any | null, orgId?: string | null, authorId: string, slug?: string | null, publishedAt?: any | null, totalXP: number, isFeatured: boolean, xpMultiplier: any, subjects?: any | null, supplies?: string | null, tags?: any | null, skills?: any | null, gradeLevels?: any | null, isVisibleUnauthed?: boolean | null, isTractOriginal: boolean, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, coverAnimatedFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, user?: { __typename?: 'user', creatorLevel?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, isEducator: boolean, avatar?: string | null, userType?: string | null, pathPrivacy?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } | null, authors: Array<{ __typename?: 'path_author', pathId: any, userId: string, user: { __typename?: 'user', username?: string | null, firstName?: string | null, lastName?: string | null, isEducator: boolean, avatar?: string | null, id: string } }>, nodes: Array<{ __typename?: 'path_node', id: any, pathId: any, title?: string | null, caption?: string | null, createdAt: any, lexorank: string, responsesEnabled: boolean, rewardAmount: number, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, videoFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }>, integrations: Array<{ __typename?: 'user_file_integration', foreignId: string, source: string }> } | null }>, guides: Array<{ __typename?: 'guide_path', guide: { __typename?: 'guide', id: any, description?: string | null, bigIdea?: string | null, concepts?: string | null, contentStandards?: string | null, durationLower?: number | null, durationUpper?: number | null, learningObjectives?: string | null, resources?: string | null, downloadUrl?: string | null, discussionQuestions?: string | null } }> } | null };

export type SavePathTitleMutationVariables = Exact<{
  pathId: Scalars['bigint'];
  pathTitle: Scalars['String'];
}>;


export type SavePathTitleMutation = { __typename?: 'mutation_root', path?: { __typename?: 'path', id: any, title?: string | null } | null };

export type GetLatestPathReviewForPathQueryVariables = Exact<{
  pathId: Scalars['bigint'];
  type?: InputMaybe<String_Comparison_Exp>;
}>;


export type GetLatestPathReviewForPathQuery = { __typename?: 'query_root', pathReview: Array<{ __typename?: 'path_review', id: any, pathId: any, type: string, userId: string, needsReview: boolean, createdAt: any, updatedAt: any, comment?: { __typename?: 'comment', text?: string | null } | null, user: { __typename?: 'user', avatar?: string | null, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, username?: string | null, isMod: boolean, firstName?: string | null, lastName?: string | null, id: string } }> };

export type GetPathStatusQueryVariables = Exact<{
  pathId: Scalars['bigint'];
}>;


export type GetPathStatusQuery = { __typename?: 'query_root', path?: { __typename?: 'path', id: any, status: string } | null };

export type SavePathStatusMutationVariables = Exact<{
  pathId: Scalars['bigint'];
  status: Scalars['String'];
  isPublished?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  pathActivity: Path_Activity_Insert_Input;
  authorId: Scalars['String'];
  authors: Array<Path_Author_Insert_Input> | Path_Author_Insert_Input;
}>;


export type SavePathStatusMutation = { __typename?: 'mutation_root', path?: { __typename?: 'path', id: any, status: string, isPublished: boolean, slug?: string | null, publishedAt?: any | null } | null, insert_path_author?: { __typename?: 'path_author_mutation_response', returning: Array<{ __typename?: 'path_author', pathId: any, userId: string }> } | null, insert_path_activity_one?: { __typename?: 'path_activity', id: any, pathId: any, userId: string, pathReviewId?: any | null, type: string, path: { __typename?: 'path', id: any, title?: string | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, user?: { __typename?: 'user', firestoreId: string, avatar?: string | null, username?: string | null, creatorLevel?: string | null, country?: string | null, id: string } | null }, user: { __typename?: 'user', firstName?: string | null, lastName?: string | null, avatar?: string | null, username?: string | null, isMod: boolean, country?: string | null, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, id: string }, pathReview?: { __typename?: 'path_review', id: any, pathId: any, type: string, userId: string, needsReview: boolean, createdAt: any, updatedAt: any, comment?: { __typename?: 'comment', text?: string | null } | null } | null } | null };

export type GetPathBuilderNodeQueryVariables = Exact<{
  nodeId: Scalars['uuid'];
}>;


export type GetPathBuilderNodeQuery = { __typename?: 'query_root', node?: { __typename?: 'path_node', id: any, pathId: any, title?: string | null, caption?: string | null, createdAt: any, lexorank: string, responsesEnabled: boolean, rewardAmount: number, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, videoFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }>, integrations: Array<{ __typename?: 'user_file_integration', foreignId: string, source: string }> } | null } | null };

export type UpdatePathNodeMutationVariables = Exact<{
  nodeId: Scalars['uuid'];
  node: Path_Node_Set_Input;
}>;


export type UpdatePathNodeMutation = { __typename?: 'mutation_root', update_path_node_by_pk?: { __typename?: 'path_node', id: any, pathId: any, title?: string | null, caption?: string | null, createdAt: any, lexorank: string, responsesEnabled: boolean, rewardAmount: number, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, videoFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }>, integrations: Array<{ __typename?: 'user_file_integration', foreignId: string, source: string }> } | null } | null };

export type DeletePathNodeMutationVariables = Exact<{
  nodeId: Scalars['uuid'];
}>;


export type DeletePathNodeMutation = { __typename?: 'mutation_root', delete_path_node_by_pk?: { __typename?: 'path_node', id: any, pathId: any } | null };

export type AddPathV4CoAuthorMutationVariables = Exact<{
  pathId: Scalars['bigint'];
  userId: Scalars['String'];
}>;


export type AddPathV4CoAuthorMutation = { __typename?: 'mutation_root', insert_path_author_one?: { __typename?: 'path_author', pathId: any, userId: string, user: { __typename?: 'user', username?: string | null, firstName?: string | null, lastName?: string | null, isEducator: boolean, avatar?: string | null, id: string } } | null, update_path_by_pk?: { __typename?: 'path', id: any, isVisibleUnauthed?: boolean | null } | null };

export type RemovePathV4CoAuthorMutationVariables = Exact<{
  pathId: Scalars['bigint'];
  userId: Scalars['String'];
}>;


export type RemovePathV4CoAuthorMutation = { __typename?: 'mutation_root', delete_path_author?: { __typename?: 'path_author_mutation_response', returning: Array<{ __typename?: 'path_author', pathId: any, userId: string }> } | null };

export type AddNodeVideoFileMutationVariables = Exact<{
  fileId: Scalars['uuid'];
  nodeId: Scalars['uuid'];
  file: User_File_Insert_Input;
}>;


export type AddNodeVideoFileMutation = { __typename?: 'mutation_root', file?: { __typename?: 'user_file', id: any } | null, update_path_node_by_pk?: { __typename?: 'path_node', id: any, videoFile?: { __typename?: 'user_file', integrations: Array<{ __typename?: 'user_file_integration', foreignId: string }> } | null } | null };

export type DeleteNodeVideoFileMutationVariables = Exact<{
  nodeId: Scalars['uuid'];
  nodeVideoId: Scalars['String'];
}>;


export type DeleteNodeVideoFileMutation = { __typename?: 'mutation_root', delete_user_file_integration?: { __typename?: 'user_file_integration_mutation_response', returning: Array<{ __typename?: 'user_file_integration', fileId: any }> } | null, update_path_node_by_pk?: { __typename?: 'path_node', id: any, videoFile?: { __typename?: 'user_file', integrations: Array<{ __typename?: 'user_file_integration', foreignId: string }> } | null } | null };

export type GetPathActivityForPathQueryVariables = Exact<{
  pathId: Scalars['bigint'];
}>;


export type GetPathActivityForPathQuery = { __typename?: 'query_root', pathActivity: Array<{ __typename?: 'path_activity', createdAt: any, id: any, pathId: any, userId: string, pathReviewId?: any | null, type: string, path: { __typename?: 'path', id: any, title?: string | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, user?: { __typename?: 'user', firestoreId: string, avatar?: string | null, username?: string | null, creatorLevel?: string | null, country?: string | null, id: string } | null }, user: { __typename?: 'user', firstName?: string | null, lastName?: string | null, avatar?: string | null, username?: string | null, isMod: boolean, country?: string | null, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, id: string }, pathReview?: { __typename?: 'path_review', id: any, pathId: any, type: string, userId: string, needsReview: boolean, createdAt: any, updatedAt: any, comment?: { __typename?: 'comment', text?: string | null } | null } | null }> };

export type GetPathCardByIdQueryVariables = Exact<{
  pathId: Scalars['bigint'];
}>;


export type GetPathCardByIdQuery = { __typename?: 'query_root', path?: { __typename?: 'path', _schemaVersion: number, authorId: string, cover?: string | null, coverAnimated?: string | null, id: any, interestArea?: string | null, isPublished: boolean, isTractOriginal: boolean, subjects?: any | null, gradeLevels?: any | null, orgId?: string | null, publishedAt?: any | null, slug?: string | null, status: string, title?: string | null, totalXP: number, isVisibleUnauthed?: boolean | null, tags?: any | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, coverAnimatedFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, creatorLevel?: string | null, id: string } | null } | null };

export type ExploreCreatorUserFragment = { __typename?: 'user', firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: string | null, creatorLevel?: string | null, userType?: string | null, canAuthor: boolean, onboarded: boolean, subscribed: boolean, isEducator: boolean, isMod: boolean, country?: string | null, id: string };

export type ExploreCreatorsUsersQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  where?: InputMaybe<View_Top_Creators_By_Followers_Count_Bool_Exp>;
}>;


export type ExploreCreatorsUsersQuery = { __typename?: 'query_root', topCreators: Array<{ __typename?: 'view_top_creators_by_followers_count', user?: { __typename?: 'user', firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: string | null, creatorLevel?: string | null, userType?: string | null, canAuthor: boolean, onboarded: boolean, subscribed: boolean, isEducator: boolean, isMod: boolean, country?: string | null, id: string } | null }> };

export type ExploreOrganizationQueryVariables = Exact<{
  orgId: Scalars['String'];
}>;


export type ExploreOrganizationQuery = { __typename?: 'query_root', organization_by_pk?: { __typename?: 'organization', avatar?: string | null, name: string, id: string } | null };

export type PathFeedQueryVariables = Exact<{
  status: Scalars['String'];
  visibility: Scalars['String'];
  interestArea?: InputMaybe<String_Comparison_Exp>;
  subjects?: InputMaybe<Jsonb_Comparison_Exp>;
  skills?: InputMaybe<Jsonb_Comparison_Exp>;
  orgId?: InputMaybe<String_Comparison_Exp>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  tags?: InputMaybe<Jsonb_Comparison_Exp>;
  isVisibleUnauthed?: InputMaybe<Boolean_Comparison_Exp>;
}>;


export type PathFeedQuery = { __typename?: 'query_root', paths: Array<{ __typename?: 'path', _schemaVersion: number, authorId: string, cover?: string | null, coverAnimated?: string | null, id: any, interestArea?: string | null, isPublished: boolean, isTractOriginal: boolean, subjects?: any | null, gradeLevels?: any | null, orgId?: string | null, publishedAt?: any | null, slug?: string | null, status: string, title?: string | null, totalXP: number, isVisibleUnauthed?: boolean | null, tags?: any | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, coverAnimatedFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, creatorLevel?: string | null, id: string } | null }> };

export type PathsByIdQueryVariables = Exact<{
  pathIds: Array<Scalars['bigint']> | Scalars['bigint'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status: Scalars['String'];
}>;


export type PathsByIdQuery = { __typename?: 'query_root', paths: Array<{ __typename?: 'path', _schemaVersion: number, authorId: string, cover?: string | null, coverAnimated?: string | null, id: any, interestArea?: string | null, isPublished: boolean, isTractOriginal: boolean, subjects?: any | null, gradeLevels?: any | null, orgId?: string | null, publishedAt?: any | null, slug?: string | null, status: string, title?: string | null, totalXP: number, isVisibleUnauthed?: boolean | null, tags?: any | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, coverAnimatedFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, creatorLevel?: string | null, id: string } | null }> };

export type HomePathSectionQueryVariables = Exact<{
  limit: Scalars['Int'];
  isPublished: Scalars['Boolean'];
  visibility: Scalars['String'];
}>;


export type HomePathSectionQuery = { __typename?: 'query_root', paths: Array<{ __typename?: 'path', _schemaVersion: number, authorId: string, cover?: string | null, coverAnimated?: string | null, id: any, interestArea?: string | null, isPublished: boolean, isTractOriginal: boolean, subjects?: any | null, gradeLevels?: any | null, orgId?: string | null, publishedAt?: any | null, slug?: string | null, status: string, title?: string | null, totalXP: number, isVisibleUnauthed?: boolean | null, tags?: any | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, coverAnimatedFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, creatorLevel?: string | null, id: string } | null }> };

export type GetPathFeedQueryVariables = Exact<{
  slug: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetPathFeedQuery = { __typename?: 'query_root', paths: Array<{ __typename?: 'path_feed', slug: string, pathId: any, path: { __typename?: 'path', _schemaVersion: number, authorId: string, cover?: string | null, coverAnimated?: string | null, id: any, interestArea?: string | null, isPublished: boolean, isTractOriginal: boolean, subjects?: any | null, gradeLevels?: any | null, orgId?: string | null, publishedAt?: any | null, slug?: string | null, status: string, title?: string | null, totalXP: number, isVisibleUnauthed?: boolean | null, tags?: any | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, coverAnimatedFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, creatorLevel?: string | null, id: string } | null } }> };

export type HomeAwesomeProjectsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  where: Project_Bool_Exp;
}>;


export type HomeAwesomeProjectsQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'project', id: any, text?: string | null, rewardCoinTrxId?: any | null, isPrivate: boolean, published: boolean, userId: string, rejectedAt?: any | null, rejectedReason?: string | null, rejectedFeedback?: string | null, rejectedByUserId?: string | null, awards: Array<{ __typename?: 'project_award', projectId: any, awardId: any, count: number }>, node?: { __typename?: 'path_node', id: any, title?: string | null, path: { __typename?: 'path', id: any, authorId: string } } | null, stats?: { __typename?: 'project_stats', projectId: any, commentCount: number, likeCount: number, viewCount: number } | null, user: { __typename?: 'user', avatar?: string | null, username?: string | null, isEducator: boolean, firstName?: string | null, lastName?: string | null, isMod: boolean, creatorLevel?: string | null, country?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, organization?: { __typename?: 'organization', id: string } | null }, file?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null }> };

export type HomeLivestreamSectionQueryVariables = Exact<{
  limit: Scalars['Int'];
  startDate: Scalars['timestamptz'];
}>;


export type HomeLivestreamSectionQuery = { __typename?: 'query_root', livestreams: Array<{ __typename?: 'livestream', id: any, title: string, description?: string | null, hostUserId: string, startDate?: any | null, endDate?: any | null, disabled: boolean, hostUser: { __typename?: 'user', username?: string | null, avatar?: string | null, id: string }, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null }> };

export type PathsByTagSectionQueryVariables = Exact<{
  limit: Scalars['Int'];
  tag: Scalars['jsonb'];
}>;


export type PathsByTagSectionQuery = { __typename?: 'query_root', paths: Array<{ __typename?: 'path', _schemaVersion: number, authorId: string, cover?: string | null, coverAnimated?: string | null, id: any, interestArea?: string | null, isPublished: boolean, isTractOriginal: boolean, subjects?: any | null, gradeLevels?: any | null, orgId?: string | null, publishedAt?: any | null, slug?: string | null, status: string, title?: string | null, totalXP: number, isVisibleUnauthed?: boolean | null, tags?: any | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, coverAnimatedFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, creatorLevel?: string | null, id: string } | null }> };

export type UpdateLearnerGroupColorMutationVariables = Exact<{
  learnerGroupId: Scalars['uuid'];
  color: Scalars['String'];
}>;


export type UpdateLearnerGroupColorMutation = { __typename?: 'mutation_root', update_learner_group_by_pk?: { __typename?: 'learner_group', id: any, color?: string | null } | null };

export type ArchiveClassroomMutationVariables = Exact<{
  learnerGroupId: Scalars['uuid'];
  archivedAt: Scalars['timestamptz'];
}>;


export type ArchiveClassroomMutation = { __typename?: 'mutation_root', update_learner_group_by_pk?: { __typename?: 'learner_group', id: any, archivedAt?: any | null } | null };

export type FeaturedClassFragment = { __typename?: 'path', id: any, title?: string | null, slug?: string | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, user?: { __typename?: 'user', firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: string | null } | null };

export type GetFeaturedClassesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetFeaturedClassesQuery = { __typename?: 'query_root', paths: Array<{ __typename?: 'path', id: any, title?: string | null, slug?: string | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, user?: { __typename?: 'user', firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: string | null } | null }> };

export type GetUserInvitesQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetUserInvitesQuery = { __typename?: 'query_root', educator_code: Array<{ __typename?: 'educator_code', available: number, code: string, expiresAt: any, createdAt: any }> };

export type ClassroomsByLearnerIdQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ClassroomsByLearnerIdQuery = { __typename?: 'query_root', learnerGroups: Array<{ __typename?: 'learner_group', id: any, name?: string | null, type: string, privacyScope?: string | null, color?: string | null, source?: Enums_Integration_Provider_Enum | null, sourceId?: string | null, members: Array<{ __typename?: 'learner_group_member', learnerGroupId: any, userId: string, isOwner: boolean, role: string, user: { __typename?: 'user', firstName?: string | null, lastName?: string | null, email?: string | null, avatar?: string | null, isEducator: boolean, userType?: string | null, username?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } }>, pendingMembers: Array<{ __typename?: 'learner_group_pending_member', firstName?: string | null, lastName?: string | null, foreignId: string, provider: Enums_Integration_Provider_Enum }>, organization?: { __typename?: 'organization', id: any, avatar?: string | null, name: string } | null, educatorCodes: Array<{ __typename?: 'educator_code', code: string, available: number, expiresAt: any, createdAt: any }>, learner_group_path_collections: Array<{ __typename?: 'learner_group_path_collection', learnerGroupId: any, pathCollectionId: any, pathCollection: { __typename?: 'path_collection', id: any, pathCollectionItems: Array<{ __typename?: 'path_collection_item', collectionId: any, pathId: any }>, pathCollectionItems_aggregate: { __typename?: 'path_collection_item_aggregate', aggregate?: { __typename?: 'path_collection_item_aggregate_fields', count: number } | null } } }>, assignments: Array<{ __typename?: 'assignment_learner_group', assignmentId: any, learnerGroupId: any, isFinished: boolean }> }> };

export type LearnersTableActiveCodeFragment = { __typename?: 'educator_code', code: string, available: number, expiresAt: any };

export type DeleteLearnerGroupMemberMutationVariables = Exact<{
  classId: Scalars['uuid'];
  learnerId: Scalars['String'];
}>;


export type DeleteLearnerGroupMemberMutation = { __typename?: 'mutation_root', delete_learner_group_member_by_pk?: { __typename?: 'learner_group_member', learnerGroupId: any, userId: string } | null };

export type DeletePendingLearnerGroupMemberMutationVariables = Exact<{
  classId: Scalars['uuid'];
  foreignId: Scalars['String'];
  provider: Enums_Integration_Provider_Enum;
}>;


export type DeletePendingLearnerGroupMemberMutation = { __typename?: 'mutation_root', delete_learner_group_pending_member_by_pk?: { __typename?: 'learner_group_pending_member', learnerGroupId: any, foreignId: string, provider: Enums_Integration_Provider_Enum } | null };

export type LearnerRowUserFragment = { __typename?: 'user', avatar?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, organization?: { __typename?: 'organization', id: string } | null };

export type LearnersByUserIdsQueryVariables = Exact<{
  userIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type LearnersByUserIdsQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'user', avatar?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, organization?: { __typename?: 'organization', id: string } | null }> };

export type GetUserCoinBalancesQueryVariables = Exact<{
  userIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetUserCoinBalancesQuery = { __typename?: 'query_root', balances: Array<{ __typename?: 'coin_trx', userId: string, balance: number }> };

export type UserProjectsCompletedQueryVariables = Exact<{
  userIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type UserProjectsCompletedQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: string, projects_aggregate: { __typename?: 'project_aggregate', aggregate?: { __typename?: 'project_aggregate_fields', count: number } | null } }> };

export type LivestreamHostUserFragment = { __typename?: 'user', username?: string | null, avatar?: string | null, isMod: boolean, country?: string | null, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, organization?: { __typename?: 'organization', id: string } | null };

export type LivestreamFragment = { __typename?: 'livestream', id: any, title: string, description?: string | null, hostUserId: string, startDate?: any | null, endDate?: any | null, disabled: boolean, hostUser: { __typename?: 'user', username?: string | null, avatar?: string | null, id: string }, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null };

export type LivestreamGalleryQueryVariables = Exact<{
  limit: Scalars['Int'];
  startDateStart: Scalars['timestamptz'];
  startDateEnd: Scalars['timestamptz'];
}>;


export type LivestreamGalleryQuery = { __typename?: 'query_root', livestreams: Array<{ __typename?: 'livestream', id: any, title: string, description?: string | null, hostUserId: string, startDate?: any | null, endDate?: any | null, disabled: boolean, hostUser: { __typename?: 'user', username?: string | null, avatar?: string | null, id: string }, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null }> };

export type NotificationUserFragment = { __typename?: 'user', firestoreId: string, username?: string | null, avatar?: string | null, firstName?: string | null, lastName?: string | null, isEducator: boolean, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null };

export type NotificationUserQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type NotificationUserQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'user', firestoreId: string, username?: string | null, avatar?: string | null, firstName?: string | null, lastName?: string | null, isEducator: boolean, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null }> };

export type ProjectByIdQueryVariables = Exact<{
  projectId: Scalars['uuid'];
}>;


export type ProjectByIdQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'project', id: any, text?: string | null, rewardCoinTrxId?: any | null, isPrivate: boolean, published: boolean, userId: string, rejectedAt?: any | null, rejectedReason?: string | null, rejectedFeedback?: string | null, rejectedByUserId?: string | null, awards: Array<{ __typename?: 'project_award', projectId: any, awardId: any, count: number }>, node?: { __typename?: 'path_node', id: any, title?: string | null, path: { __typename?: 'path', id: any, authorId: string } } | null, stats?: { __typename?: 'project_stats', projectId: any, commentCount: number, likeCount: number, viewCount: number } | null, user: { __typename?: 'user', avatar?: string | null, username?: string | null, isEducator: boolean, firstName?: string | null, lastName?: string | null, isMod: boolean, creatorLevel?: string | null, country?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, organization?: { __typename?: 'organization', id: string } | null }, file?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null }> };

export type ProjectChallengeQuestionFragment = { __typename?: 'project', node?: { __typename?: 'path_node', title?: string | null } | null };

export type ProjectChallengeQuestionByIdQueryVariables = Exact<{
  projectId: Scalars['uuid'];
}>;


export type ProjectChallengeQuestionByIdQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'project', node?: { __typename?: 'path_node', title?: string | null } | null }> };

export type PathIdTitleSlugNodeIdsFragment = { __typename?: 'path', id: any, title?: string | null, slug?: string | null, nodes: Array<{ __typename?: 'path_node', id: any }> };

export type PathIdTitleSlugNodeIdsByIdQueryVariables = Exact<{
  pathId: Scalars['bigint'];
}>;


export type PathIdTitleSlugNodeIdsByIdQuery = { __typename?: 'query_root', path?: { __typename?: 'path', id: any, title?: string | null, slug?: string | null, nodes: Array<{ __typename?: 'path_node', id: any }> } | null };

export type OnboardEducatorStepSchoolMutationVariables = Exact<{
  orgId?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  gradeLevel?: InputMaybe<Scalars['String']>;
}>;


export type OnboardEducatorStepSchoolMutation = { __typename?: 'mutation_root', api_onboard_educator?: { __typename?: 'api_onboard_educator_output', orgId?: string | null } | null };

export type OnboardEducatorStepClassMutationVariables = Exact<{
  teacher: User_Teacher_Insert_Input;
}>;


export type OnboardEducatorStepClassMutation = { __typename?: 'mutation_root', teacher?: { __typename?: 'user_teacher', displayName?: string | null, lowerGradeLevel?: string | null, upperGradeLevel?: string | null, subjects?: any | null, id: string } | null };

export type GetOnboardedOrgsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOnboardedOrgsQuery = { __typename?: 'query_root', organizations: Array<{ __typename?: 'org', id: any, name: string, isVerified: boolean }> };

export type OnboardKidMutationVariables = Exact<{
  userId: Scalars['String'];
  username: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  birthday: Scalars['jsonb'];
}>;


export type OnboardKidMutation = { __typename?: 'mutation_root', onboard_kid?: { __typename?: 'user', firestoreId: string, firstName?: string | null, lastName?: string | null, birthday?: any | null } | null };

export type AwesomeChallengeProjectsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Project_Bool_Exp>;
}>;


export type AwesomeChallengeProjectsQuery = { __typename?: 'query_root', project: Array<{ __typename?: 'project', id: any, text?: string | null, rewardCoinTrxId?: any | null, isPrivate: boolean, published: boolean, userId: string, rejectedAt?: any | null, rejectedReason?: string | null, rejectedFeedback?: string | null, rejectedByUserId?: string | null, awards: Array<{ __typename?: 'project_award', projectId: any, awardId: any, count: number }>, node?: { __typename?: 'path_node', id: any, title?: string | null, path: { __typename?: 'path', id: any, authorId: string } } | null, stats?: { __typename?: 'project_stats', projectId: any, commentCount: number, likeCount: number, viewCount: number } | null, user: { __typename?: 'user', avatar?: string | null, username?: string | null, isEducator: boolean, firstName?: string | null, lastName?: string | null, isMod: boolean, creatorLevel?: string | null, country?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, organization?: { __typename?: 'organization', id: string } | null }, file?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null }> };

export type NodeCommentCommentFragment = { __typename?: 'comment', id: any, text?: string | null, createdAt: any, path?: any | null, deletedAt: any, published: boolean, user: { __typename?: 'user', avatar?: string | null, username?: string | null, isEducator: boolean, isMod: boolean, creatorLevel?: string | null, firstName?: string | null, lastName?: string | null, canAuthor: boolean, userType?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } };

export type NodeCommentFragment = { __typename?: 'path_node_comment', pathNodeId: any, commentId: any, comment: { __typename?: 'comment', id: any, text?: string | null, createdAt: any, path?: any | null, deletedAt: any, published: boolean, user: { __typename?: 'user', avatar?: string | null, username?: string | null, isEducator: boolean, isMod: boolean, creatorLevel?: string | null, firstName?: string | null, lastName?: string | null, canAuthor: boolean, userType?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } } };

export type GetNodeCommentsQueryVariables = Exact<{
  nodeId: Scalars['uuid'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  path: Ltree_Comparison_Exp;
}>;


export type GetNodeCommentsQuery = { __typename?: 'query_root', nodeComments: Array<{ __typename?: 'path_node_comment', pathNodeId: any, commentId: any, comment: { __typename?: 'comment', id: any, text?: string | null, createdAt: any, path?: any | null, deletedAt: any, published: boolean, user: { __typename?: 'user', avatar?: string | null, username?: string | null, isEducator: boolean, isMod: boolean, creatorLevel?: string | null, firstName?: string | null, lastName?: string | null, canAuthor: boolean, userType?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } } }> };

export type GetNodeCommentReplyCountQueryVariables = Exact<{
  nodeId: Scalars['uuid'];
  matches: Scalars['lquery'];
}>;


export type GetNodeCommentReplyCountQuery = { __typename?: 'query_root', path_node_comment_aggregate: { __typename?: 'path_node_comment_aggregate', aggregate?: { __typename?: 'path_node_comment_aggregate_fields', count: number } | null } };

export type CreateNodeCommentMutationVariables = Exact<{
  object: Path_Node_Comment_Insert_Input;
}>;


export type CreateNodeCommentMutation = { __typename?: 'mutation_root', insert_path_node_comment_one?: { __typename?: 'path_node_comment', pathNodeId: any, commentId: any, comment: { __typename?: 'comment', id: any, text?: string | null, createdAt: any, path?: any | null, deletedAt: any, published: boolean, user: { __typename?: 'user', avatar?: string | null, username?: string | null, isEducator: boolean, isMod: boolean, creatorLevel?: string | null, firstName?: string | null, lastName?: string | null, canAuthor: boolean, userType?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } } } | null };

export type EditNodeCommentMutationVariables = Exact<{
  commentId: Scalars['uuid'];
  text: Scalars['String'];
}>;


export type EditNodeCommentMutation = { __typename?: 'mutation_root', update_comment_by_pk?: { __typename?: 'comment', id: any, text?: string | null, createdAt: any, path?: any | null, deletedAt: any, published: boolean, user: { __typename?: 'user', avatar?: string | null, username?: string | null, isEducator: boolean, isMod: boolean, creatorLevel?: string | null, firstName?: string | null, lastName?: string | null, canAuthor: boolean, userType?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } } | null };

export type DeleteNodeCommentMutationVariables = Exact<{
  commentId: Scalars['uuid'];
}>;


export type DeleteNodeCommentMutation = { __typename?: 'mutation_root', update_comment_by_pk?: { __typename?: 'comment', id: any, deletedAt: any } | null };

export type UnauthPathViewerNodeFragment = { __typename?: 'path_node', id: any, title?: string | null, caption?: string | null, lexorank: string, responsesEnabled: boolean, rewardAmount: number, videoFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }>, integrations: Array<{ __typename?: 'user_file_integration', foreignId: string, source: string }> } | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }>, integrations: Array<{ __typename?: 'user_file_integration', foreignId: string, source: string }> } | null };

export type UnauthPathViewerPathFragment = { __typename?: 'path', id: any, title?: string | null, authorId: string, description?: string | null, slug?: string | null, interestArea?: string | null, subjects?: any | null, skills?: any | null, tags?: any | null, publishedAt?: any | null, supplies?: string | null, totalXP: number, isVisibleUnauthed?: boolean | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, user?: { __typename?: 'user', userType?: string | null, username?: string | null, avatar?: string | null, firstName?: string | null, lastName?: string | null } | null, nodes: Array<{ __typename?: 'path_node', id: any, title?: string | null, caption?: string | null, lexorank: string, responsesEnabled: boolean, rewardAmount: number, videoFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }>, integrations: Array<{ __typename?: 'user_file_integration', foreignId: string, source: string }> } | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }>, integrations: Array<{ __typename?: 'user_file_integration', foreignId: string, source: string }> } | null }> };

export type UnauthPathViewerQueryVariables = Exact<{
  where: Path_Bool_Exp;
}>;


export type UnauthPathViewerQuery = { __typename?: 'query_root', path: Array<{ __typename?: 'path', id: any, title?: string | null, authorId: string, description?: string | null, slug?: string | null, interestArea?: string | null, subjects?: any | null, skills?: any | null, tags?: any | null, publishedAt?: any | null, supplies?: string | null, totalXP: number, isVisibleUnauthed?: boolean | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, user?: { __typename?: 'user', userType?: string | null, username?: string | null, avatar?: string | null, firstName?: string | null, lastName?: string | null } | null, nodes: Array<{ __typename?: 'path_node', id: any, title?: string | null, caption?: string | null, lexorank: string, responsesEnabled: boolean, rewardAmount: number, videoFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }>, integrations: Array<{ __typename?: 'user_file_integration', foreignId: string, source: string }> } | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }>, integrations: Array<{ __typename?: 'user_file_integration', foreignId: string, source: string }> } | null }> }> };

export type PathViewerProjectFragment = { __typename?: 'project', id: any, text?: string | null, userId: string, createdAt: any, pathNodeId?: any | null, file?: { __typename?: 'user_file', id: any, userId: string, filename: string } | null };

export type PathViewerNodeFragment = { __typename?: 'path_node', id: any, title?: string | null, caption?: string | null, lexorank: string, responsesEnabled: boolean, rewardAmount: number, projects: Array<{ __typename?: 'project', id: any, text?: string | null, userId: string, createdAt: any, pathNodeId?: any | null, file?: { __typename?: 'user_file', id: any, userId: string, filename: string } | null }>, videoFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }>, integrations: Array<{ __typename?: 'user_file_integration', foreignId: string, source: string }> } | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }>, integrations: Array<{ __typename?: 'user_file_integration', foreignId: string, source: string }> } | null };

export type PathViewerPathFragment = { __typename?: 'path', id: any, title?: string | null, description?: string | null, slug?: string | null, status: string, authorId: string, interestArea?: string | null, tags?: any | null, supplies?: string | null, publishedAt?: any | null, totalXP: number, isVisibleUnauthed?: boolean | null, isTractOriginal: boolean, gradeLevels?: any | null, subjects?: any | null, xpMultiplier: any, authors: Array<{ __typename?: 'path_author', pathId: any, userId: string, user: { __typename?: 'user', username?: string | null, avatar?: string | null, firstName?: string | null, lastName?: string | null, isEducator: boolean, userType?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null, organization?: { __typename?: 'organization', id: string } | null } }>, user?: { __typename?: 'user', avatar?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, organization?: { __typename?: 'organization', id: string } | null } | null, trailer?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }>, integrations: Array<{ __typename?: 'user_file_integration', foreignId: string, source: string }> } | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, nodes: Array<{ __typename?: 'path_node', id: any, title?: string | null, caption?: string | null, lexorank: string, responsesEnabled: boolean, rewardAmount: number, projects: Array<{ __typename?: 'project', id: any, text?: string | null, userId: string, createdAt: any, pathNodeId?: any | null, file?: { __typename?: 'user_file', id: any, userId: string, filename: string } | null }>, videoFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }>, integrations: Array<{ __typename?: 'user_file_integration', foreignId: string, source: string }> } | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }>, integrations: Array<{ __typename?: 'user_file_integration', foreignId: string, source: string }> } | null }>, guides: Array<{ __typename?: 'guide_path', guide: { __typename?: 'guide', id: any, description?: string | null, bigIdea?: string | null, concepts?: string | null, contentStandards?: string | null, durationLower?: number | null, durationUpper?: number | null, learningObjectives?: string | null, resources?: string | null, downloadUrl?: string | null, discussionQuestions?: string | null } }> };

export type PathViewerQueryVariables = Exact<{
  userId: Scalars['String'];
  where: Path_Bool_Exp;
}>;


export type PathViewerQuery = { __typename?: 'query_root', path: Array<{ __typename?: 'path', id: any, title?: string | null, description?: string | null, slug?: string | null, status: string, authorId: string, interestArea?: string | null, tags?: any | null, supplies?: string | null, publishedAt?: any | null, totalXP: number, isVisibleUnauthed?: boolean | null, isTractOriginal: boolean, gradeLevels?: any | null, subjects?: any | null, xpMultiplier: any, authors: Array<{ __typename?: 'path_author', pathId: any, userId: string, user: { __typename?: 'user', username?: string | null, avatar?: string | null, firstName?: string | null, lastName?: string | null, isEducator: boolean, userType?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null, organization?: { __typename?: 'organization', id: string } | null } }>, user?: { __typename?: 'user', avatar?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, organization?: { __typename?: 'organization', id: string } | null } | null, trailer?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }>, integrations: Array<{ __typename?: 'user_file_integration', foreignId: string, source: string }> } | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, nodes: Array<{ __typename?: 'path_node', id: any, title?: string | null, caption?: string | null, lexorank: string, responsesEnabled: boolean, rewardAmount: number, projects: Array<{ __typename?: 'project', id: any, text?: string | null, userId: string, createdAt: any, pathNodeId?: any | null, file?: { __typename?: 'user_file', id: any, userId: string, filename: string } | null }>, videoFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }>, integrations: Array<{ __typename?: 'user_file_integration', foreignId: string, source: string }> } | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }>, integrations: Array<{ __typename?: 'user_file_integration', foreignId: string, source: string }> } | null }>, guides: Array<{ __typename?: 'guide_path', guide: { __typename?: 'guide', id: any, description?: string | null, bigIdea?: string | null, concepts?: string | null, contentStandards?: string | null, durationLower?: number | null, durationUpper?: number | null, learningObjectives?: string | null, resources?: string | null, downloadUrl?: string | null, discussionQuestions?: string | null } }> }> };

export type PathActiveUserFragment = { __typename?: 'path_active_user', pathId: any, userId: string, updatedAt: any };

export type PathActiveUsersAggregateQueryVariables = Exact<{
  pathId: Scalars['bigint'];
  date: Scalars['timestamptz'];
}>;


export type PathActiveUsersAggregateQuery = { __typename?: 'query_root', path_active_user_aggregate: { __typename?: 'path_active_user_aggregate', aggregate?: { __typename?: 'path_active_user_aggregate_fields', count: number } | null } };

export type PathActiveUserMutationVariables = Exact<{
  userId: Scalars['String'];
  pathId: Scalars['bigint'];
}>;


export type PathActiveUserMutation = { __typename?: 'mutation_root', insert_path_active_user_one?: { __typename?: 'path_active_user', pathId: any, userId: string, updatedAt: any } | null };

export type CreateProjectMutationVariables = Exact<{
  input?: InputMaybe<Api_Create_Project_Input>;
}>;


export type CreateProjectMutation = { __typename?: 'mutation_root', project?: { __typename?: 'api_create_project_output', id?: string | null, text?: string | null, isPrivate?: boolean | null, file?: { __typename?: 'api_create_project_file_output', id: string, filename: string } | null } | null };

export type ProjectHistoryProjectFragment = { __typename?: 'project', id: any, userId: string, pathNodeId?: any | null, createdAt: any, rejectedAt?: any | null, rejectedByUserId?: string | null, rejectedReason?: string | null, rejectedFeedback?: string | null, rewardCoin?: { __typename?: 'coin_trx', amount: number } | null, rejectedByUser?: { __typename?: 'user', firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: string | null, isEducator: boolean, isMod: boolean, canAuthor: boolean, creatorLevel?: string | null, userType?: string | null, onboarded: boolean, subscribed: boolean } | null };

export type ProjectHistoryQueryVariables = Exact<{
  userId: Scalars['String'];
  nodeId: Scalars['uuid'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type ProjectHistoryQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'project', id: any, userId: string, pathNodeId?: any | null, createdAt: any, rejectedAt?: any | null, rejectedByUserId?: string | null, rejectedReason?: string | null, rejectedFeedback?: string | null, rewardCoin?: { __typename?: 'coin_trx', amount: number } | null, rejectedByUser?: { __typename?: 'user', firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: string | null, isEducator: boolean, isMod: boolean, canAuthor: boolean, creatorLevel?: string | null, userType?: string | null, onboarded: boolean, subscribed: boolean } | null }> };

export type FollowButtonUserFragment = { __typename?: 'user', userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, organization?: { __typename?: 'organization', id: string } | null };

export type GetUserAwardsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetUserAwardsQuery = { __typename?: 'query_root', user_awards: Array<{ __typename?: 'user_award', award: { __typename?: 'award', id: any, name: string, description: string, filePath: string, type: string } }> };

export type ProjectsLikedByUidQueryVariables = Exact<{
  id: Scalars['String'];
  published?: InputMaybe<Boolean_Comparison_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type ProjectsLikedByUidQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'project_reaction', userId: string, projectId: any, project: { __typename?: 'project', id: any, text?: string | null, rewardCoinTrxId?: any | null, isPrivate: boolean, published: boolean, userId: string, rejectedAt?: any | null, rejectedReason?: string | null, rejectedFeedback?: string | null, rejectedByUserId?: string | null, awards: Array<{ __typename?: 'project_award', projectId: any, awardId: any, count: number }>, node?: { __typename?: 'path_node', id: any, title?: string | null, path: { __typename?: 'path', id: any, authorId: string } } | null, stats?: { __typename?: 'project_stats', projectId: any, commentCount: number, likeCount: number, viewCount: number } | null, user: { __typename?: 'user', avatar?: string | null, username?: string | null, isEducator: boolean, firstName?: string | null, lastName?: string | null, isMod: boolean, creatorLevel?: string | null, country?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, organization?: { __typename?: 'organization', id: string } | null }, file?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null } }> };

export type UserProfileUserFragment = { __typename?: 'user', avatar?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, isMod: boolean, country?: string | null, bio?: string | null, interestAreas?: any | null, accomplishments?: any | null, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null, organization?: { __typename?: 'organization', id: string } | null };

export type UserProfileQueryVariables = Exact<{
  where: User_Bool_Exp;
}>;


export type UserProfileQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', avatar?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, isMod: boolean, country?: string | null, bio?: string | null, interestAreas?: any | null, accomplishments?: any | null, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null, organization?: { __typename?: 'organization', id: string } | null }> };

export type UserSocialCountsFragment = { __typename?: 'user', id: string, followers_aggregate: { __typename?: 'user_follow_aggregate', aggregate?: { __typename?: 'user_follow_aggregate_fields', count: number } | null }, following_aggregate: { __typename?: 'user_follow_aggregate', aggregate?: { __typename?: 'user_follow_aggregate_fields', count: number } | null } };

export type UserSocialCountsByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type UserSocialCountsByIdQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: string, followers_aggregate: { __typename?: 'user_follow_aggregate', aggregate?: { __typename?: 'user_follow_aggregate_fields', count: number } | null }, following_aggregate: { __typename?: 'user_follow_aggregate', aggregate?: { __typename?: 'user_follow_aggregate_fields', count: number } | null } }> };

export type UserFollowersFragment = { __typename?: 'user', id: string, followers: Array<{ __typename?: 'user_follow', sourceUserId: string, sourceUser: { __typename?: 'user', username?: string | null, avatar?: string | null, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, followers: Array<{ __typename?: 'user_follow', sourceUserId: string, targetUserId: string }>, organization?: { __typename?: 'organization', id: string } | null } }> };

export type UserFollowersByIdQueryVariables = Exact<{
  id: Scalars['String'];
  currentUserId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type UserFollowersByIdQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: string, followers: Array<{ __typename?: 'user_follow', sourceUserId: string, sourceUser: { __typename?: 'user', username?: string | null, avatar?: string | null, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, followers: Array<{ __typename?: 'user_follow', sourceUserId: string, targetUserId: string }>, organization?: { __typename?: 'organization', id: string } | null } }> }> };

export type UserFollowingFragment = { __typename?: 'user', id: string, following: Array<{ __typename?: 'user_follow', targetUserId: string, targetUser: { __typename?: 'user', username?: string | null, avatar?: string | null, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, followers: Array<{ __typename?: 'user_follow', sourceUserId: string, targetUserId: string }>, organization?: { __typename?: 'organization', id: string } | null } }> };

export type UserFollowingByIdQueryVariables = Exact<{
  id: Scalars['String'];
  currentUserId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type UserFollowingByIdQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: string, following: Array<{ __typename?: 'user_follow', targetUserId: string, targetUser: { __typename?: 'user', username?: string | null, avatar?: string | null, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, followers: Array<{ __typename?: 'user_follow', sourceUserId: string, targetUserId: string }>, organization?: { __typename?: 'organization', id: string } | null } }> }> };

export type UserProfileProjectsQueryVariables = Exact<{
  userId: Scalars['String'];
  isPrivate?: InputMaybe<Boolean_Comparison_Exp>;
  published?: InputMaybe<Boolean_Comparison_Exp>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type UserProfileProjectsQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'project', id: any, text?: string | null, rewardCoinTrxId?: any | null, isPrivate: boolean, published: boolean, userId: string, rejectedAt?: any | null, rejectedReason?: string | null, rejectedFeedback?: string | null, rejectedByUserId?: string | null, awards: Array<{ __typename?: 'project_award', projectId: any, awardId: any, count: number }>, node?: { __typename?: 'path_node', id: any, title?: string | null, path: { __typename?: 'path', id: any, authorId: string } } | null, stats?: { __typename?: 'project_stats', projectId: any, commentCount: number, likeCount: number, viewCount: number } | null, user: { __typename?: 'user', avatar?: string | null, username?: string | null, isEducator: boolean, firstName?: string | null, lastName?: string | null, isMod: boolean, creatorLevel?: string | null, country?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, organization?: { __typename?: 'organization', id: string } | null }, file?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null }> };

export type ProfileLivestreamsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  hostUserId: Scalars['String'];
  startDate: Scalars['timestamptz'];
}>;


export type ProfileLivestreamsQuery = { __typename?: 'query_root', livestreams: Array<{ __typename?: 'livestream', id: any, title: string, description?: string | null, hostUserId: string, startDate?: any | null, endDate?: any | null, disabled: boolean, hostUser: { __typename?: 'user', username?: string | null, avatar?: string | null, id: string }, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null }> };

export type ProfilePathsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  userId: Scalars['String'];
}>;


export type ProfilePathsQuery = { __typename?: 'query_root', paths: Array<{ __typename?: 'path', _schemaVersion: number, authorId: string, cover?: string | null, coverAnimated?: string | null, id: any, interestArea?: string | null, isPublished: boolean, isTractOriginal: boolean, subjects?: any | null, gradeLevels?: any | null, orgId?: string | null, publishedAt?: any | null, slug?: string | null, status: string, title?: string | null, totalXP: number, isVisibleUnauthed?: boolean | null, tags?: any | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, coverAnimatedFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, creatorLevel?: string | null, id: string } | null }> };

export type GetProjectDetailsQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetProjectDetailsQuery = { __typename?: 'query_root', project?: { __typename?: 'project', id: any, text?: string | null, rewardCoinTrxId?: any | null, isPrivate: boolean, published: boolean, userId: string, rejectedAt?: any | null, rejectedReason?: string | null, rejectedFeedback?: string | null, rejectedByUserId?: string | null, awards: Array<{ __typename?: 'project_award', projectId: any, awardId: any, count: number }>, node?: { __typename?: 'path_node', id: any, title?: string | null, path: { __typename?: 'path', id: any, authorId: string } } | null, stats?: { __typename?: 'project_stats', projectId: any, commentCount: number, likeCount: number, viewCount: number } | null, user: { __typename?: 'user', avatar?: string | null, username?: string | null, isEducator: boolean, firstName?: string | null, lastName?: string | null, isMod: boolean, creatorLevel?: string | null, country?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, organization?: { __typename?: 'organization', id: string } | null }, file?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null } | null };

export type ReportModalQueryVariables = Exact<{
  nodeId: Scalars['uuid'];
  coinTrxId: Scalars['uuid'];
}>;


export type ReportModalQuery = { __typename?: 'query_root', path_node_by_pk?: { __typename?: 'path_node', id: any, title?: string | null } | null, coin_trx_by_pk?: { __typename?: 'coin_trx', id: any, amount: number } | null };

export type ProjectGalleryQueryVariables = Exact<{
  where: Project_Bool_Exp;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type ProjectGalleryQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'project', id: any, text?: string | null, rewardCoinTrxId?: any | null, isPrivate: boolean, published: boolean, userId: string, rejectedAt?: any | null, rejectedReason?: string | null, rejectedFeedback?: string | null, rejectedByUserId?: string | null, awards: Array<{ __typename?: 'project_award', projectId: any, awardId: any, count: number }>, node?: { __typename?: 'path_node', id: any, title?: string | null, path: { __typename?: 'path', id: any, authorId: string } } | null, stats?: { __typename?: 'project_stats', projectId: any, commentCount: number, likeCount: number, viewCount: number } | null, user: { __typename?: 'user', avatar?: string | null, username?: string | null, isEducator: boolean, firstName?: string | null, lastName?: string | null, isMod: boolean, creatorLevel?: string | null, country?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, organization?: { __typename?: 'organization', id: string } | null }, file?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null }> };

export type ProjectPathFragment = { __typename?: 'path', id: any, slug?: string | null, title?: string | null, authorId: string, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, user?: { __typename?: 'user', username?: string | null, avatar?: string | null, firstName?: string | null, lastName?: string | null, id: string } | null };

export type GetProjectPathQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type GetProjectPathQuery = { __typename?: 'query_root', path?: { __typename?: 'path', id: any, slug?: string | null, title?: string | null, authorId: string, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> } | null, user?: { __typename?: 'user', username?: string | null, avatar?: string | null, firstName?: string | null, lastName?: string | null, id: string } | null } | null };

export type IncProjectViewCountMutationVariables = Exact<{
  projectId: Scalars['uuid'];
}>;


export type IncProjectViewCountMutation = { __typename?: 'mutation_root', update_project_stats_by_pk?: { __typename?: 'project_stats', projectId: any, commentCount: number, likeCount: number, viewCount: number } | null };

export type CommentFragment = { __typename?: 'comment', id: any, text?: string | null, giphyId?: string | null, createdAt: any, deletedAt: any, published: boolean, userId: string, user: { __typename?: 'user', username?: string | null, avatar?: string | null, firstName?: string | null, lastName?: string | null, country?: string | null, isMod: boolean, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, id: string } };

export type ProjectCommentFragment = { __typename?: 'project_comment', projectId: any, commentId: any, awardId?: any | null, comment: { __typename?: 'comment', id: any, text?: string | null, giphyId?: string | null, createdAt: any, deletedAt: any, published: boolean, userId: string, user: { __typename?: 'user', username?: string | null, avatar?: string | null, firstName?: string | null, lastName?: string | null, country?: string | null, isMod: boolean, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, id: string } } };

export type ProjectCommentsQueryVariables = Exact<{
  projectId: Scalars['uuid'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type ProjectCommentsQuery = { __typename?: 'query_root', projectComments: Array<{ __typename?: 'project_comment', projectId: any, commentId: any, awardId?: any | null, comment: { __typename?: 'comment', id: any, text?: string | null, giphyId?: string | null, createdAt: any, deletedAt: any, published: boolean, userId: string, user: { __typename?: 'user', username?: string | null, avatar?: string | null, firstName?: string | null, lastName?: string | null, country?: string | null, isMod: boolean, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, id: string } } }> };

export type CreateProjectCommentMutationVariables = Exact<{
  projectId: Scalars['uuid'];
  text?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
  giphyId?: InputMaybe<Scalars['String']>;
}>;


export type CreateProjectCommentMutation = { __typename?: 'mutation_root', projectComment?: { __typename?: 'project_comment', projectId: any, commentId: any, awardId?: any | null, comment: { __typename?: 'comment', id: any, text?: string | null, giphyId?: string | null, createdAt: any, deletedAt: any, published: boolean, userId: string, user: { __typename?: 'user', username?: string | null, avatar?: string | null, firstName?: string | null, lastName?: string | null, country?: string | null, isMod: boolean, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, id: string } } } | null, update_project_stats_by_pk?: { __typename?: 'project_stats', projectId: any, commentCount: number, likeCount: number, viewCount: number } | null };

export type UpdateCommentMutationVariables = Exact<{
  commentId: Scalars['uuid'];
  text: Scalars['String'];
}>;


export type UpdateCommentMutation = { __typename?: 'mutation_root', update_comment_by_pk?: { __typename?: 'comment', id: any, text?: string | null } | null };

export type DeleteProjectCommentMutationVariables = Exact<{
  commentId: Scalars['uuid'];
  projectId: Scalars['uuid'];
}>;


export type DeleteProjectCommentMutation = { __typename?: 'mutation_root', update_comment_by_pk?: { __typename?: 'comment', id: any, deletedAt: any, published: boolean } | null, update_project_stats_by_pk?: { __typename?: 'project_stats', projectId: any, commentCount: number, likeCount: number, viewCount: number } | null };

export type PathNameQueryVariables = Exact<{
  pathId: Scalars['bigint'];
}>;


export type PathNameQuery = { __typename?: 'query_root', path?: { __typename?: 'path', id: any, title?: string | null } | null };

export type PathNodeNameQueryVariables = Exact<{
  nodeId: Scalars['uuid'];
}>;


export type PathNodeNameQuery = { __typename?: 'query_root', node?: { __typename?: 'path_node', id: any, title?: string | null } | null };

export type GetInviterUserQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetInviterUserQuery = { __typename?: 'query_root', user_by_pk?: { __typename?: 'user', avatar?: string | null, username?: string | null, userType?: string | null, creatorLevel?: string | null, isMod: boolean, isEducator: boolean, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, organization?: { __typename?: 'organization', id: string } | null } | null };

export type GetUserIntegrationsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetUserIntegrationsQuery = { __typename?: 'query_root', user_integration: Array<{ __typename?: 'user_integration', provider: Enums_Integration_Provider_Enum, createdAt: any }> };

export type UserPrivacyUpdateMutationVariables = Exact<{
  input: Api_Update_Privacy_Input;
}>;


export type UserPrivacyUpdateMutation = { __typename?: 'mutation_root', api_update_privacy?: { __typename?: 'api_update_privacy_output', userId: string, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null } | null };

export type ShopItemFragment = { __typename?: 'shop_item', id: any, name: string, description: string, cost: number, media?: any | null, disabled: boolean, quantity?: number | null, tags: any, externalURL?: string | null, metadata?: any | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, owner?: { __typename?: 'user', email?: string | null } | null };

export type ShopItemsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  tags: Jsonb_Comparison_Exp;
}>;


export type ShopItemsQuery = { __typename?: 'query_root', items: Array<{ __typename?: 'shop_item', id: any, name: string, description: string, cost: number, media?: any | null, disabled: boolean, quantity?: number | null, tags: any, externalURL?: string | null, metadata?: any | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, owner?: { __typename?: 'user', email?: string | null } | null }> };

export type ShopItemQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type ShopItemQuery = { __typename?: 'query_root', item?: { __typename?: 'shop_item', id: any, name: string, description: string, cost: number, media?: any | null, disabled: boolean, quantity?: number | null, tags: any, externalURL?: string | null, metadata?: any | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, owner?: { __typename?: 'user', email?: string | null } | null } | null };

export type SignUpEducatorMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type SignUpEducatorMutation = { __typename?: 'mutation_root', api_sign_up?: { __typename?: 'api_sign_up_output', userId: string, authToken: string } | null };

export type SignUpStudentMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
  code: Scalars['String'];
}>;


export type SignUpStudentMutation = { __typename?: 'mutation_root', api_sign_up?: { __typename?: 'api_sign_up_output', userId: string, authToken: string } | null };

export type JoinClassroomMutationVariables = Exact<{
  educatorCode: Scalars['String'];
  source?: InputMaybe<Scalars['String']>;
}>;


export type JoinClassroomMutation = { __typename?: 'mutation_root', api_join_classroom?: { __typename?: 'api_join_classroom_output', learnerGroupId?: string | null } | null };

export type GetOnboardingStatusQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetOnboardingStatusQuery = { __typename?: 'query_root', user_by_pk?: { __typename?: 'user', onboarded: boolean, organization?: { __typename?: 'organization', id: string } | null } | null };

export type PathSlugByNodeIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type PathSlugByNodeIdQuery = { __typename?: 'query_root', node?: { __typename?: 'path_node', id: any, path: { __typename?: 'path', id: any, slug?: string | null } } | null };

export type CreateClassroomMutationVariables = Exact<{
  name: Scalars['String'];
  orgId: Scalars['String'];
  userId: Scalars['String'];
  pathId?: InputMaybe<Scalars['bigint']>;
}>;


export type CreateClassroomMutation = { __typename?: 'mutation_root', createClassroom?: { __typename?: 'api_create_classroom_output', id?: string | null, learnerGroup?: { __typename?: 'learner_group', id: any, name?: string | null, type: string, privacyScope?: string | null, color?: string | null, source?: Enums_Integration_Provider_Enum | null, sourceId?: string | null, members: Array<{ __typename?: 'learner_group_member', learnerGroupId: any, userId: string, isOwner: boolean, role: string, user: { __typename?: 'user', firstName?: string | null, lastName?: string | null, email?: string | null, avatar?: string | null, isEducator: boolean, userType?: string | null, username?: string | null, id: string, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null } }>, pendingMembers: Array<{ __typename?: 'learner_group_pending_member', firstName?: string | null, lastName?: string | null, foreignId: string, provider: Enums_Integration_Provider_Enum }>, organization?: { __typename?: 'organization', id: any, avatar?: string | null, name: string } | null, educatorCodes: Array<{ __typename?: 'educator_code', code: string, available: number, expiresAt: any, createdAt: any }>, learner_group_path_collections: Array<{ __typename?: 'learner_group_path_collection', learnerGroupId: any, pathCollectionId: any, pathCollection: { __typename?: 'path_collection', id: any, pathCollectionItems: Array<{ __typename?: 'path_collection_item', collectionId: any, pathId: any }>, pathCollectionItems_aggregate: { __typename?: 'path_collection_item_aggregate', aggregate?: { __typename?: 'path_collection_item_aggregate_fields', count: number } | null } } }>, assignments: Array<{ __typename?: 'assignment_learner_group', assignmentId: any, learnerGroupId: any, isFinished: boolean }> } | null } | null };

export type ForumPostFragment = { __typename?: 'CirclePost', id: number, name: string, body: any, url: string, space_name: string, user_name: string, user_avatar_url: string, comments_count: number, likes_count: number, created_at: string, hide_meta_info: boolean };

export type CirclePostsQueryVariables = Exact<{
  communityId: Scalars['String'];
  spaceId: Scalars['String'];
  page: Scalars['String'];
}>;


export type CirclePostsQuery = { __typename?: 'query_root', circle_posts: Array<{ __typename?: 'CirclePost', id: number, name: string, body: any, url: string, space_name: string, user_name: string, user_avatar_url: string, comments_count: number, likes_count: number, created_at: string, hide_meta_info: boolean }> };

export type ForumSpaceGroupFragment = { __typename?: 'CircleSpaceGroup', id: number, name: string, space_order_array: Array<number> };

export type CircleSpaceGroupsQueryVariables = Exact<{
  communityId: Scalars['String'];
}>;


export type CircleSpaceGroupsQuery = { __typename?: 'query_root', circle_space_groups: Array<{ __typename?: 'CircleSpaceGroup', id: number, name: string, space_order_array: Array<number> }> };

export type ForumSpaceFragment = { __typename?: 'CircleSpace', id: number, name: string, emoji: string };

export type CircleSpacesQueryVariables = Exact<{
  communityId: Scalars['String'];
}>;


export type CircleSpacesQuery = { __typename?: 'query_root', circle_spaces: Array<{ __typename?: 'CircleSpace', id: number, name: string, emoji: string }> };

export type CoinBalanceByUserQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type CoinBalanceByUserQuery = { __typename?: 'query_root', coins: Array<{ __typename?: 'coin_trx', balance: number }> };

export type ProjectReactionFragment = { __typename?: 'project_reaction', projectId: any, userId: string, count: number };

export type UserProjectLikesQueryVariables = Exact<{
  projectId: Scalars['uuid'];
  userId: Scalars['String'];
}>;


export type UserProjectLikesQuery = { __typename?: 'query_root', projectReaction?: { __typename?: 'project_reaction', projectId: any, userId: string, count: number } | null };

export type LikeProjectMutationVariables = Exact<{
  projectId: Scalars['uuid'];
  userId: Scalars['String'];
  count?: InputMaybe<Scalars['Int']>;
}>;


export type LikeProjectMutation = { __typename?: 'mutation_root', insert_project_reaction_one?: { __typename?: 'project_reaction', projectId: any, userId: string, count: number } | null, update_project_stats_by_pk?: { __typename?: 'project_stats', projectId: any, commentCount: number, likeCount: number, viewCount: number } | null };

export type PathsFromIdArrayQueryVariables = Exact<{
  pathIds?: InputMaybe<Array<Scalars['bigint']> | Scalars['bigint']>;
  status: Scalars['String'];
  mergeBehavior?: InputMaybe<Scalars['String']>;
}>;


export type PathsFromIdArrayQuery = { __typename?: 'query_root', paths: Array<{ __typename?: 'path', _schemaVersion: number, authorId: string, cover?: string | null, coverAnimated?: string | null, id: any, interestArea?: string | null, isPublished: boolean, isTractOriginal: boolean, subjects?: any | null, gradeLevels?: any | null, orgId?: string | null, publishedAt?: any | null, slug?: string | null, status: string, title?: string | null, totalXP: number, isVisibleUnauthed?: boolean | null, tags?: any | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, coverAnimatedFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, creatorLevel?: string | null, id: string } | null }> };

export type UserFragment = { __typename?: 'user', firestoreId: string, username?: string | null, avatar?: string | null, firstName?: string | null, lastName?: string | null };

export type UserByIdQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type UserByIdQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'user', firestoreId: string, username?: string | null, avatar?: string | null, firstName?: string | null, lastName?: string | null }> };

export type UserPrivacyScopesFragment = { __typename?: 'user', profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, organization?: { __typename?: 'organization', id: string } | null };

export type UserSocialFollowHookFragment = { __typename?: 'user', userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, id: string, organization?: { __typename?: 'organization', id: string } | null };

export type FindFollowRelationshipQueryVariables = Exact<{
  sourceUserId: Scalars['String'];
  targetUserId: Scalars['String'];
}>;


export type FindFollowRelationshipQuery = { __typename?: 'query_root', user_follow_by_pk?: { __typename?: 'user_follow', sourceUserId: string, targetUserId: string } | null };

export type FollowUserMutationVariables = Exact<{
  sourceUserId: Scalars['String'];
  targetUserId: Scalars['String'];
}>;


export type FollowUserMutation = { __typename?: 'mutation_root', insert_user_follow_one?: { __typename?: 'user_follow', sourceUserId: string, targetUserId: string } | null };

export type UnfollowUserMutationVariables = Exact<{
  sourceUserId: Scalars['String'];
  targetUserId: Scalars['String'];
}>;


export type UnfollowUserMutation = { __typename?: 'mutation_root', delete_user_follow_by_pk?: { __typename?: 'user_follow', sourceUserId: string, targetUserId: string } | null };

export type UserOnlineFragment = { __typename?: 'user', lastSeen?: any | null };

export type IsEducatorCodeActiveFragment = { __typename?: 'educator_code', code: string, available: number, expiresAt: any };

export type UserDisplayNameFragment = { __typename?: 'user', firstName?: string | null, lastName?: string | null, username?: string | null, isEducator: boolean, userType?: string | null, teacher?: { __typename?: 'user_teacher', displayName?: string | null, id: string } | null };

export type UserFullNameFragment = { __typename?: 'user', firstName?: string | null, lastName?: string | null, username?: string | null, isEducator: boolean, userType?: string | null };

export type UserTypeFragment = { __typename?: 'user', userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null };

export type ProfileBadgeUserTypeFragment = { __typename?: 'user', isMod: boolean, country?: string | null, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null };

export type UserFileFragment = { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', filename: string }> };

export type AwardFragment = { __typename?: 'award', id: any, name: string, description: string, filePath: string, bonus: number, bonusDescription?: string | null, cost: number, type: string, ownerId?: string | null };

export type GetAwardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAwardsQuery = { __typename?: 'query_root', awards: Array<{ __typename?: 'award', id: any, name: string, description: string, filePath: string, bonus: number, bonusDescription?: string | null, cost: number, type: string, ownerId?: string | null }> };

export type GiveAwardMutationVariables = Exact<{
  projectId: Scalars['uuid'];
  awardId: Scalars['uuid'];
  userId: Scalars['String'];
  fromUserId: Scalars['String'];
  cost: Scalars['Int'];
  bonus: Scalars['Int'];
  comment?: InputMaybe<Scalars['String']>;
}>;


export type GiveAwardMutation = { __typename?: 'mutation_root', insert_project_award_one?: { __typename?: 'project_award', projectId: any, awardId: any, count: number } | null, update_project_award_by_pk?: { __typename?: 'project_award', projectId: any, awardId: any, count: number } | null, insert_user_award_one?: { __typename?: 'user_award', id: any } | null, coin_trx_from?: { __typename?: 'coin_trx', id: any } | null, coin_trx_to?: { __typename?: 'coin_trx', id: any } | null, projectComment?: { __typename?: 'project_comment', projectId: any, commentId: any, awardId?: any | null, comment: { __typename?: 'comment', id: any, text?: string | null, giphyId?: string | null, createdAt: any, deletedAt: any, published: boolean, userId: string, user: { __typename?: 'user', username?: string | null, avatar?: string | null, firstName?: string | null, lastName?: string | null, country?: string | null, isMod: boolean, userType?: string | null, creatorLevel?: string | null, isEducator: boolean, orgId?: string | null, id: string } } } | null, update_project_stats_by_pk?: { __typename?: 'project_stats', projectId: any, commentCount: number, likeCount: number, viewCount: number } | null };

export type CreateFileMutationVariables = Exact<{
  file: User_File_Insert_Input;
}>;


export type CreateFileMutation = { __typename?: 'mutation_root', file?: { __typename?: 'user_file', id: any, filename: string, userId: string } | null };

export type PathCollectionFragment = { __typename?: 'path_collection', id: any, title?: string | null, description?: string | null, pathCollectionItems: Array<{ __typename?: 'path_collection_item', collectionId: any, pathId: any, path: { __typename?: 'path', _schemaVersion: number, authorId: string, cover?: string | null, coverAnimated?: string | null, id: any, interestArea?: string | null, isPublished: boolean, isTractOriginal: boolean, subjects?: any | null, gradeLevels?: any | null, orgId?: string | null, publishedAt?: any | null, slug?: string | null, status: string, title?: string | null, totalXP: number, isVisibleUnauthed?: boolean | null, tags?: any | null, coverFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, coverAnimatedFile?: { __typename?: 'user_file', id: any, filename: string, transforms: Array<{ __typename?: 'user_file_transform', fileId: any, filename: string }> } | null, user?: { __typename?: 'user', avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, creatorLevel?: string | null, id: string } | null } }> };

export type GetPathFeedsByPathIdQueryVariables = Exact<{
  pathId: Scalars['bigint'];
}>;


export type GetPathFeedsByPathIdQuery = { __typename?: 'query_root', path_feed: Array<{ __typename?: 'path_feed', slug: string, pathId: any }> };

export type AddPathToPathFeedMutationVariables = Exact<{
  slug: Scalars['String'];
  pathId: Scalars['bigint'];
  userId: Scalars['String'];
}>;


export type AddPathToPathFeedMutation = { __typename?: 'mutation_root', insert_path_feed_one?: { __typename?: 'path_feed', slug: string, pathId: any } | null };

export type RemovePathFromPathFeedMutationVariables = Exact<{
  slug: Scalars['String'];
  pathId: Scalars['bigint'];
}>;


export type RemovePathFromPathFeedMutation = { __typename?: 'mutation_root', delete_path_feed_by_pk?: { __typename?: 'path_feed', slug: string, pathId: any } | null };

export type RejectProjectMutationVariables = Exact<{
  projectId: Scalars['uuid'];
  userId: Scalars['String'];
  coinAmount: Scalars['Int'];
  coinTrxId: Scalars['uuid'];
  rejectReason: Scalars['String'];
  rejectFeedback?: InputMaybe<Scalars['String']>;
  rejectedByUserId: Scalars['String'];
  rejectedAt: Scalars['timestamptz'];
}>;


export type RejectProjectMutation = { __typename?: 'mutation_root', insert_coin_trx_one?: { __typename?: 'coin_trx', id: any } | null, update_project_by_pk?: { __typename?: 'project', id: any, userId: string, challengeId: number, rejectedAt?: any | null, rejectedByUserId?: string | null, rejectedReason?: string | null, rejectedFeedback?: string | null, rejectCoinTrxId?: any | null } | null };

export type AdminRejectedProjectFragment = { __typename?: 'project', id: any, rejectedAt?: any | null, userId: string, rewardCoin?: { __typename?: 'coin_trx', amount: number } | null };

export type GetRejectedProjectByIdQueryVariables = Exact<{
  projectId: Scalars['uuid'];
}>;


export type GetRejectedProjectByIdQuery = { __typename?: 'query_root', project?: { __typename?: 'project', id: any, rejectedAt?: any | null, userId: string, rewardCoin?: { __typename?: 'coin_trx', amount: number } | null } | null };

export type UnrejectProjectMutationVariables = Exact<{
  projectId: Scalars['uuid'];
  refundAmount: Scalars['Int'];
  refundUserId: Scalars['String'];
}>;


export type UnrejectProjectMutation = { __typename?: 'mutation_root', update_project_by_pk?: { __typename?: 'project', id: any, rejectedAt?: any | null } | null, insert_coin_trx_one?: { __typename?: 'coin_trx', id: any } | null };

export type StreamIoCreateActivityMutationVariables = Exact<{
  apiKey: Scalars['String'];
  feedSlug: Scalars['String'];
  feedUserId: Scalars['String'];
  activity: StreamIoCreateActivityInput;
}>;


export type StreamIoCreateActivityMutation = { __typename?: 'mutation_root', streamio_create_activity?: { __typename?: 'StreamIOCreateActivityOutput', id: string } | null };

export type CurrentUserLearnerGroupFragment = { __typename?: 'learner_group', id: any, name?: string | null, type: string, privacyScope?: string | null, members: Array<{ __typename?: 'learner_group_member', learnerGroupId: any, userId: string, role: string, isOwner: boolean }>, assignments: Array<{ __typename?: 'assignment_learner_group', assignmentId: any, learnerGroupId: any, isFinished: boolean }> };

export type CurrentUserFragment = { __typename?: 'user', avatar?: string | null, bio?: string | null, birthday?: any | null, country?: string | null, creatorLevel?: string | null, disabled: boolean, email?: string | null, firstName?: string | null, interestAreas?: any | null, isEducator: boolean, isMod: boolean, lastName?: string | null, orgId?: string | null, subscriptionExempt: boolean, userType?: string | null, username?: string | null, accomplishments?: any | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, invitedById?: string | null, id: string, uid: string, integrations: Array<{ __typename?: 'user_integration', userId: string, foreignId: string, provider: Enums_Integration_Provider_Enum }>, organization?: { __typename?: 'organization', avatar?: string | null, name: string, verified: boolean, shopEnabled: boolean, id: string } | null, learnerGroups: Array<{ __typename?: 'learner_group_member', learnerGroupId: any, userId: string, role: string, isOwner: boolean, learnerGroup: { __typename?: 'learner_group', id: any, name?: string | null, type: string, privacyScope?: string | null, members: Array<{ __typename?: 'learner_group_member', learnerGroupId: any, userId: string, role: string, isOwner: boolean }>, assignments: Array<{ __typename?: 'assignment_learner_group', assignmentId: any, learnerGroupId: any, isFinished: boolean }> } }>, followers_aggregate: { __typename?: 'user_follow_aggregate', aggregate?: { __typename?: 'user_follow_aggregate_fields', count: number } | null }, following_aggregate: { __typename?: 'user_follow_aggregate', aggregate?: { __typename?: 'user_follow_aggregate_fields', count: number } | null }, teacher?: { __typename?: 'user_teacher', lowerGradeLevel?: string | null, upperGradeLevel?: string | null, displayName?: string | null, subjects?: any | null, id: string } | null };

export type SessionUserByIdQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type SessionUserByIdQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'user', avatar?: string | null, bio?: string | null, birthday?: any | null, country?: string | null, creatorLevel?: string | null, disabled: boolean, email?: string | null, firstName?: string | null, interestAreas?: any | null, isEducator: boolean, isMod: boolean, lastName?: string | null, orgId?: string | null, subscriptionExempt: boolean, userType?: string | null, username?: string | null, accomplishments?: any | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, invitedById?: string | null, id: string, uid: string, integrations: Array<{ __typename?: 'user_integration', userId: string, foreignId: string, provider: Enums_Integration_Provider_Enum }>, organization?: { __typename?: 'organization', avatar?: string | null, name: string, verified: boolean, shopEnabled: boolean, id: string } | null, learnerGroups: Array<{ __typename?: 'learner_group_member', learnerGroupId: any, userId: string, role: string, isOwner: boolean, learnerGroup: { __typename?: 'learner_group', id: any, name?: string | null, type: string, privacyScope?: string | null, members: Array<{ __typename?: 'learner_group_member', learnerGroupId: any, userId: string, role: string, isOwner: boolean }>, assignments: Array<{ __typename?: 'assignment_learner_group', assignmentId: any, learnerGroupId: any, isFinished: boolean }> } }>, followers_aggregate: { __typename?: 'user_follow_aggregate', aggregate?: { __typename?: 'user_follow_aggregate_fields', count: number } | null }, following_aggregate: { __typename?: 'user_follow_aggregate', aggregate?: { __typename?: 'user_follow_aggregate_fields', count: number } | null }, teacher?: { __typename?: 'user_teacher', lowerGradeLevel?: string | null, upperGradeLevel?: string | null, displayName?: string | null, subjects?: any | null, id: string } | null }> };

export type UpdateSessionUserMutationVariables = Exact<{
  id: Scalars['String'];
  avatar: Scalars['String'];
  bio: Scalars['String'];
  interestAreas: Scalars['jsonb'];
  country: Scalars['String'];
  accomplishments: Scalars['jsonb'];
}>;


export type UpdateSessionUserMutation = { __typename?: 'mutation_root', user?: { __typename?: 'user', avatar?: string | null, bio?: string | null, birthday?: any | null, country?: string | null, creatorLevel?: string | null, disabled: boolean, email?: string | null, firstName?: string | null, interestAreas?: any | null, isEducator: boolean, isMod: boolean, lastName?: string | null, orgId?: string | null, subscriptionExempt: boolean, userType?: string | null, username?: string | null, accomplishments?: any | null, profilePrivacy?: string | null, projectPrivacy?: string | null, pathPrivacy?: string | null, invitedById?: string | null, id: string, uid: string, integrations: Array<{ __typename?: 'user_integration', userId: string, foreignId: string, provider: Enums_Integration_Provider_Enum }>, organization?: { __typename?: 'organization', avatar?: string | null, name: string, verified: boolean, shopEnabled: boolean, id: string } | null, learnerGroups: Array<{ __typename?: 'learner_group_member', learnerGroupId: any, userId: string, role: string, isOwner: boolean, learnerGroup: { __typename?: 'learner_group', id: any, name?: string | null, type: string, privacyScope?: string | null, members: Array<{ __typename?: 'learner_group_member', learnerGroupId: any, userId: string, role: string, isOwner: boolean }>, assignments: Array<{ __typename?: 'assignment_learner_group', assignmentId: any, learnerGroupId: any, isFinished: boolean }> } }>, followers_aggregate: { __typename?: 'user_follow_aggregate', aggregate?: { __typename?: 'user_follow_aggregate_fields', count: number } | null }, following_aggregate: { __typename?: 'user_follow_aggregate', aggregate?: { __typename?: 'user_follow_aggregate_fields', count: number } | null }, teacher?: { __typename?: 'user_teacher', lowerGradeLevel?: string | null, upperGradeLevel?: string | null, displayName?: string | null, subjects?: any | null, id: string } | null } | null };

export type InsertUserTeacherMutationVariables = Exact<{
  object: User_Teacher_Insert_Input;
}>;


export type InsertUserTeacherMutation = { __typename?: 'mutation_root', insert_user_teacher_one?: { __typename?: 'user_teacher', userId: string, displayName?: string | null, lowerGradeLevel?: string | null, upperGradeLevel?: string | null, subjects?: any | null } | null };

export type UpdateUserTeacherMutationVariables = Exact<{
  userId: Scalars['String'];
  displayName?: InputMaybe<Scalars['String']>;
  lowerGradeLevel?: InputMaybe<Scalars['String']>;
  upperGradeLevel?: InputMaybe<Scalars['String']>;
  subjects?: InputMaybe<Scalars['jsonb']>;
}>;


export type UpdateUserTeacherMutation = { __typename?: 'mutation_root', update_user_teacher_by_pk?: { __typename?: 'user_teacher', userId: string, displayName?: string | null, lowerGradeLevel?: string | null, upperGradeLevel?: string | null, subjects?: any | null } | null };

export const EducatorCodeFragmentDoc = gql`
    fragment EducatorCode on educator_code {
  code
  available
  expiresAt
  createdAt
}
    `;
export const ClassroomLearnerGroupFragmentDoc = gql`
    fragment ClassroomLearnerGroup on learner_group {
  id
  name
  type
  privacyScope
  color
  source
  sourceId
  members {
    learnerGroupId
    userId
    isOwner
    role
    user {
      id: firestoreId
      firstName
      lastName
      email
      avatar
      isEducator
      userType
      username
      teacher {
        id: userId
        displayName
      }
    }
  }
  pendingMembers {
    firstName
    lastName
    foreignId
    provider
  }
  organization {
    id
    avatar
    name
  }
  educatorCodes(order_by: {createdAt: desc}) {
    ...EducatorCode
  }
  learner_group_path_collections {
    learnerGroupId
    pathCollectionId
    pathCollection {
      id
      pathCollectionItems {
        collectionId
        pathId
      }
      pathCollectionItems_aggregate {
        aggregate {
          count
        }
      }
    }
  }
  assignments {
    assignmentId
    learnerGroupId
    isFinished
  }
}
    ${EducatorCodeFragmentDoc}`;
export const UserDisplayNameFragmentDoc = gql`
    fragment UserDisplayName on user {
  firstName
  lastName
  username
  isEducator
  userType
  teacher {
    id: userId
    displayName
  }
}
    `;
export const UserFileFragmentDoc = gql`
    fragment UserFile on user_file {
  id
  filename
  transforms {
    filename
  }
}
    `;
export const AssignBuilderPathFragmentDoc = gql`
    fragment AssignBuilderPath on path {
  id
  title
  slug
  isTractOriginal
  description
  user {
    id: firestoreId
    avatar
    ...UserDisplayName
  }
  nodes {
    id
  }
  coverFile {
    ...UserFile
  }
  guides {
    guide {
      id
    }
  }
}
    ${UserDisplayNameFragmentDoc}
${UserFileFragmentDoc}`;
export const AssignmentBuilderFragmentDoc = gql`
    fragment AssignmentBuilder on assignment {
  id
  title
  description
  userId
  startDate
  dueDate
  learnerGroups {
    assignmentId
    learnerGroupId
  }
  paths {
    assignmentId
    pathId
    path {
      ...AssignBuilderPath
    }
  }
}
    ${AssignBuilderPathFragmentDoc}`;
export const PathCardDataFragmentDoc = gql`
    fragment PathCardData on path {
  id
  user {
    id: firestoreId
    avatar
    firstName
    lastName
    username
    isEducator
  }
  guides {
    guide {
      id
    }
  }
}
    `;
export const UserPrivacyScopesFragmentDoc = gql`
    fragment UserPrivacyScopes on user {
  id: firestoreId
  profilePrivacy
  projectPrivacy
  pathPrivacy
  organization {
    id: firestoreId
  }
}
    `;
export const UserProfilePopoverFragmentDoc = gql`
    fragment UserProfilePopover on user {
  id: firestoreId
  username
  avatar
  isMod
  country
  firstName
  lastName
  isEducator
  creatorLevel
  userType
  ...UserPrivacyScopes
}
    ${UserPrivacyScopesFragmentDoc}`;
export const PopoverBodyUserFragmentDoc = gql`
    fragment PopoverBodyUser on user {
  firstName
  lastName
  username
}
    `;
export const CommentsLearnerGroupMemberFragmentDoc = gql`
    fragment CommentsLearnerGroupMember on learner_group_member {
  learnerGroupId
  userId
  user {
    id: firestoreId
    username
    firstName
    lastName
  }
}
    `;
export const AdminCommentFragmentDoc = gql`
    fragment AdminComment on comment {
  id
  text
  giphyId
  createdAt
  updatedAt
  deletedAt
  published
  path
  user {
    id: firestoreId
    avatar
    username
    firstName
    lastName
    invitedBy {
      username
    }
  }
  projectComment {
    projectId
    commentId
    awardId
  }
  pathReviewComment {
    id
    pathId
    commentId
  }
  pathNodeComment {
    pathNodeId
    commentId
    node {
      id
      path {
        id
        authorId
      }
    }
  }
}
    `;
export const AdminLivestreamFragmentDoc = gql`
    fragment AdminLivestream on livestream {
  id
  title
  description
  hostUserId
  hostUser {
    id: firestoreId
    username
  }
  startDate
  endDate
  disabled
  coverFileId
  coverFile {
    id
    filename
    transforms {
      fileId
      filename
    }
  }
}
    `;
export const AdminOrgFragmentDoc = gql`
    fragment AdminOrg on organization {
  id: firestoreId
  name
  verified
  address
  createdAt
}
    `;
export const AdminShopItemFragmentDoc = gql`
    fragment AdminShopItem on shop_item {
  id
  name
  description
  cost
  media
  quantity
  coverFile {
    id
    filename
    transforms {
      fileId
      filename
    }
  }
  externalURL
  disabled
  tags
  createdAt
  metadata
  ownerId
  owner {
    email
  }
}
    `;
export const AdminShopItemOwnerFragmentDoc = gql`
    fragment AdminShopItemOwner on user {
  id
  firestoreId
  firstName
  lastName
  email
  isAdmin
  username
}
    `;
export const AdminShopItemPurchaseFragmentDoc = gql`
    fragment AdminShopItemPurchase on shop_item_purchase {
  id
  status
  createdAt
  coinTrx {
    id
    amount
  }
  shopItem {
    id
    name
    media
  }
  user {
    id: firestoreId
    avatar
    username
  }
}
    `;
export const AdminProjectFragmentDoc = gql`
    fragment AdminProject on project {
  id
  text
  isPrivate
  createdAt
  updatedAt
  userId
  published
  rejectedAt
  rejectedByUserId
  rejectedReason
  rejectedFeedback
  pathNodeId
  rewardCoin {
    amount
  }
  file {
    id
    filename
  }
  user {
    id: firestoreId
    username
    firstName
    lastName
    invitedBy {
      username
    }
    isEducator
  }
}
    `;
export const AdminProjectPathFragmentDoc = gql`
    fragment adminProjectPath on project {
  node {
    id
    title
    caption
    path {
      id
      title
      slug
      authorId
    }
  }
}
    `;
export const AdminLearnerGroupMemberFragmentDoc = gql`
    fragment AdminLearnerGroupMember on learner_group_member {
  learnerGroupId
  userId
  isOwner
  role
  user {
    id: firestoreId
    firstName
    lastName
    email
    avatar
    userType
    isEducator
    username
    teacher {
      id: userId
      displayName
    }
  }
}
    `;
export const AdminDashboardEducatorCodeFragmentDoc = gql`
    fragment AdminDashboardEducatorCode on educator_code {
  code
  available
  expiresAt
  createdAt
}
    `;
export const AdminDashboardLearnerGroupFragmentDoc = gql`
    fragment AdminDashboardLearnerGroup on learner_group {
  id
  name
  members {
    ...AdminLearnerGroupMember
  }
  educatorCodes(order_by: {createdAt: desc}) {
    ...AdminDashboardEducatorCode
  }
  archivedAt
}
    ${AdminLearnerGroupMemberFragmentDoc}
${AdminDashboardEducatorCodeFragmentDoc}`;
export const UserTypeFragmentDoc = gql`
    fragment UserType on user {
  userType
  creatorLevel
  isEducator
  orgId
}
    `;
export const AdminDashboardUserAccountFragmentDoc = gql`
    fragment AdminDashboardUserAccount on user {
  id: firestoreId
  avatar
  bio
  disabled
  username
  firstName
  lastName
  creatorLevel
  canAuthor
  orgId
  createdAt
  profilePrivacy
  projectPrivacy
  pathPrivacy
  invitedBy {
    id: firestoreId
    username
  }
  organization {
    id: firestoreId
    name
  }
  learnerGroups {
    learnerGroup {
      id
      name
      members(where: {isOwner: {_eq: true}}) {
        user {
          id
          avatar
          firestoreId
          userType
          firstName
          email
          isEducator
          lastName
          teacher {
            id
            displayName
          }
        }
      }
    }
  }
  ...UserType
}
    ${UserTypeFragmentDoc}`;
export const ProfileBadgeUserTypeFragmentDoc = gql`
    fragment ProfileBadgeUserType on user {
  isMod
  country
  ...UserType
}
    ${UserTypeFragmentDoc}`;
export const PathsByStatusFragmentDoc = gql`
    fragment pathsByStatus on path {
  id
  slug
  title
  authorId
  createdAt
  updatedAt
  isPublished
  coverFile {
    id
    filename
    transforms {
      filename
    }
  }
  nodes {
    id
  }
  user {
    id: firestoreId
    ...ProfileBadgeUserType
    avatar
    username
    firstName
    lastName
    isEducator
  }
  authors_aggregate {
    aggregate {
      count
    }
  }
}
    ${ProfileBadgeUserTypeFragmentDoc}`;
export const PathActivityFragmentDoc = gql`
    fragment PathActivity on path_activity {
  id
  pathId
  userId
  pathReviewId
  path {
    id
    title
    coverFile {
      id
      filename
      transforms {
        filename
      }
    }
    user {
      id: firestoreId
      firestoreId
      avatar
      username
      creatorLevel
      country
    }
  }
  type
  user {
    id: firestoreId
    firstName
    lastName
    avatar
    username
    ...ProfileBadgeUserType
  }
  pathReview {
    id
    pathId
    type
    userId
    needsReview
    createdAt
    updatedAt
    comment {
      text
    }
  }
}
    ${ProfileBadgeUserTypeFragmentDoc}`;
export const PathReviewFragmentDoc = gql`
    fragment PathReview on path_review {
  id
  pathId
  type
  userId
  needsReview
  createdAt
  updatedAt
  comment {
    text
  }
  user {
    id: firestoreId
    avatar
    userType
    creatorLevel
    isEducator
    username
    isMod
    firstName
    lastName
  }
}
    `;
export const ClassroomAssignmentFragmentDoc = gql`
    fragment ClassroomAssignment on assignment_learner_group {
  assignmentId
  learnerGroupId
  isFinished
  assignment {
    id
    title
    description
    dueDate
    startDate
    paths {
      assignmentId
      pathId
      path {
        id
        coverFile {
          ...UserFile
        }
      }
    }
  }
}
    ${UserFileFragmentDoc}`;
export const ProjectStatsFragmentDoc = gql`
    fragment projectStats on project_stats {
  projectId
  commentCount
  likeCount
  viewCount
}
    `;
export const ProjectCardFragmentDoc = gql`
    fragment projectCard on project {
  id
  text
  rewardCoinTrxId
  isPrivate
  published
  userId
  rejectedAt
  rejectedReason
  rejectedFeedback
  rejectedByUserId
  awards(order_by: {count: desc}) {
    projectId
    awardId
    count
  }
  node {
    id
    title
    path {
      id
      authorId
    }
  }
  stats {
    ...projectStats
  }
  user {
    id: firestoreId
    avatar
    username
    isEducator
    firstName
    lastName
    isMod
    creatorLevel
    country
    ...UserPrivacyScopes
  }
  file {
    id
    filename
    transforms {
      filename
    }
  }
}
    ${ProjectStatsFragmentDoc}
${UserPrivacyScopesFragmentDoc}`;
export const ClassroomAssignmentDetailFragmentDoc = gql`
    fragment ClassroomAssignmentDetail on assignment {
  id
  title
  startDate
  dueDate
  paths {
    assignmentId
    pathId
    path {
      id
      nodes {
        id
        pathId
        title
        responsesEnabled
        projects(where: {userId: {_in: $learnerUserIds}}) {
          ...projectCard
        }
      }
    }
  }
}
    ${ProjectCardFragmentDoc}`;
export const GuideFragmentDoc = gql`
    fragment guide on guide {
  id
  bigIdea
  concepts
  contentStandards
  durationLower
  durationUpper
  learningObjectives
  resources
  description
  downloadUrl
  discussionQuestions
}
    `;
export const PathCoAuthorFragmentDoc = gql`
    fragment PathCoAuthor on path_author {
  pathId
  userId
  user {
    id: firestoreId
    username
    firstName
    lastName
    isEducator
    avatar
  }
}
    `;
export const PathBuilderNodeFragmentDoc = gql`
    fragment PathBuilderNode on path_node {
  id
  pathId
  title
  caption
  createdAt
  lexorank
  responsesEnabled
  rewardAmount
  coverFile {
    id
    filename
    transforms {
      filename
    }
  }
  videoFile {
    id
    filename
    transforms {
      filename
    }
    integrations {
      foreignId
      source
    }
  }
}
    `;
export const PathBuilderPathV4FragmentDoc = gql`
    fragment PathBuilderPathV4 on path {
  id
  title
  description
  interestArea
  status
  isPublished
  media
  orgId
  authorId
  slug
  publishedAt
  totalXP
  isFeatured
  xpMultiplier
  subjects
  supplies
  tags
  skills
  gradeLevels
  isVisibleUnauthed
  isTractOriginal
  coverFile {
    id
    filename
    transforms {
      filename
    }
  }
  coverAnimatedFile {
    id
    filename
    transforms {
      filename
    }
  }
  user {
    id: firestoreId
    creatorLevel
    username
    firstName
    lastName
    isEducator
    avatar
    userType
    pathPrivacy
    teacher {
      id: userId
      displayName
    }
  }
  authors {
    ...PathCoAuthor
  }
  nodes(order_by: {lexorank: asc}) {
    ...PathBuilderNode
  }
  guides(limit: 1, where: {isRelatedPath: {_eq: false}}) {
    guide {
      id
      description
      bigIdea
      concepts
      contentStandards
      durationLower
      durationUpper
      learningObjectives
      resources
      downloadUrl
      discussionQuestions
    }
  }
}
    ${PathCoAuthorFragmentDoc}
${PathBuilderNodeFragmentDoc}`;
export const ExploreCreatorUserFragmentDoc = gql`
    fragment ExploreCreatorUser on user {
  id: firestoreId
  firstName
  lastName
  username
  avatar
  creatorLevel
  userType
  canAuthor
  onboarded
  subscribed
  isEducator
  isMod
  country
}
    `;
export const FeaturedClassFragmentDoc = gql`
    fragment FeaturedClass on path {
  id
  title
  slug
  coverFile {
    id
    filename
    transforms {
      filename
    }
  }
  user {
    firstName
    lastName
    username
    avatar
  }
}
    `;
export const LearnersTableActiveCodeFragmentDoc = gql`
    fragment LearnersTableActiveCode on educator_code {
  code
  available
  expiresAt
}
    `;
export const LearnerRowUserFragmentDoc = gql`
    fragment LearnerRowUser on user {
  id: firestoreId
  avatar
  username
  firstName
  lastName
  email
  ...UserType
  ...UserPrivacyScopes
}
    ${UserTypeFragmentDoc}
${UserPrivacyScopesFragmentDoc}`;
export const LivestreamHostUserFragmentDoc = gql`
    fragment LivestreamHostUser on user {
  id: firestoreId
  username
  avatar
  isMod
  country
  ...UserType
  ...UserPrivacyScopes
}
    ${UserTypeFragmentDoc}
${UserPrivacyScopesFragmentDoc}`;
export const LivestreamFragmentDoc = gql`
    fragment Livestream on livestream {
  id
  title
  description
  hostUserId
  hostUser {
    id: firestoreId
    username
    avatar
  }
  startDate
  endDate
  disabled
  coverFile {
    id
    filename
    transforms {
      filename
    }
  }
}
    `;
export const NotificationUserFragmentDoc = gql`
    fragment NotificationUser on user {
  firestoreId
  username
  avatar
  firstName
  lastName
  isEducator
  teacher {
    id: userId
    displayName
  }
}
    `;
export const ProjectChallengeQuestionFragmentDoc = gql`
    fragment ProjectChallengeQuestion on project {
  node {
    title
  }
}
    `;
export const PathIdTitleSlugNodeIdsFragmentDoc = gql`
    fragment PathIdTitleSlugNodeIds on path {
  id
  title
  slug
  nodes {
    id
  }
}
    `;
export const NodeCommentCommentFragmentDoc = gql`
    fragment NodeCommentComment on comment {
  id
  text
  createdAt
  path
  deletedAt
  published
  user {
    id: firestoreId
    avatar
    username
    isEducator
    isMod
    creatorLevel
    firstName
    lastName
    canAuthor
    userType
    teacher {
      id: userId
      displayName
    }
  }
}
    `;
export const NodeCommentFragmentDoc = gql`
    fragment NodeComment on path_node_comment {
  pathNodeId
  commentId
  comment {
    ...NodeCommentComment
  }
}
    ${NodeCommentCommentFragmentDoc}`;
export const UnauthPathViewerNodeFragmentDoc = gql`
    fragment UnauthPathViewerNode on path_node {
  id
  title
  caption
  lexorank
  responsesEnabled
  rewardAmount
  videoFile {
    id
    filename
    transforms {
      filename
    }
    integrations {
      foreignId
      source
    }
  }
  coverFile {
    id
    filename
    transforms {
      filename
    }
    integrations {
      foreignId
      source
    }
  }
}
    `;
export const UnauthPathViewerPathFragmentDoc = gql`
    fragment UnauthPathViewerPath on path {
  id
  title
  authorId
  description
  slug
  interestArea
  subjects
  skills
  tags
  publishedAt
  supplies
  totalXP
  isVisibleUnauthed
  coverFile {
    id
    filename
    transforms {
      filename
    }
  }
  user {
    userType
    username
    avatar
    firstName
    lastName
  }
  nodes(order_by: {lexorank: asc}) {
    ...UnauthPathViewerNode
  }
}
    ${UnauthPathViewerNodeFragmentDoc}`;
export const PathViewerProjectFragmentDoc = gql`
    fragment PathViewerProject on project {
  id
  text
  userId
  createdAt
  pathNodeId
  file {
    id
    userId
    filename
  }
}
    `;
export const PathViewerNodeFragmentDoc = gql`
    fragment PathViewerNode on path_node {
  id
  title
  caption
  lexorank
  responsesEnabled
  rewardAmount
  projects(where: {userId: {_eq: $userId}, rejectedAt: {_eq: "-infinity"}}) {
    ...PathViewerProject
  }
  videoFile {
    id
    filename
    transforms {
      filename
    }
    integrations {
      foreignId
      source
    }
  }
  coverFile {
    id
    filename
    transforms {
      filename
    }
    integrations {
      foreignId
      source
    }
  }
}
    ${PathViewerProjectFragmentDoc}`;
export const PathViewerPathFragmentDoc = gql`
    fragment PathViewerPath on path {
  id
  title
  description
  slug
  status
  authorId
  interestArea
  tags
  supplies
  publishedAt
  totalXP
  isVisibleUnauthed
  isTractOriginal
  gradeLevels
  subjects
  authors {
    pathId
    userId
    user {
      id: firestoreId
      username
      avatar
      ...UserDisplayName
      ...UserPrivacyScopes
    }
  }
  user {
    id: firestoreId
    avatar
    username
    firstName
    lastName
    ...UserType
    ...UserPrivacyScopes
  }
  trailer {
    id
    filename
    transforms {
      filename
    }
    integrations {
      foreignId
      source
    }
  }
  coverFile {
    id
    filename
    transforms {
      filename
    }
  }
  nodes(order_by: {lexorank: asc}) {
    ...PathViewerNode
  }
  xpMultiplier
  guides(limit: 1, where: {isRelatedPath: {_eq: false}}) {
    guide {
      id
      description
      bigIdea
      concepts
      contentStandards
      durationLower
      durationUpper
      learningObjectives
      resources
      downloadUrl
      discussionQuestions
    }
  }
}
    ${UserDisplayNameFragmentDoc}
${UserPrivacyScopesFragmentDoc}
${UserTypeFragmentDoc}
${PathViewerNodeFragmentDoc}`;
export const PathActiveUserFragmentDoc = gql`
    fragment PathActiveUser on path_active_user {
  pathId
  userId
  updatedAt
}
    `;
export const ProjectHistoryProjectFragmentDoc = gql`
    fragment ProjectHistoryProject on project {
  id
  userId
  pathNodeId
  createdAt
  rejectedAt
  rejectedByUserId
  rejectedReason
  rejectedFeedback
  rewardCoin {
    amount
  }
  rejectedByUser {
    firstName
    lastName
    username
    avatar
    isEducator
    isMod
    canAuthor
    creatorLevel
    userType
    onboarded
    subscribed
  }
}
    `;
export const FollowButtonUserFragmentDoc = gql`
    fragment FollowButtonUser on user {
  id: firestoreId
  ...UserType
  ...UserPrivacyScopes
}
    ${UserTypeFragmentDoc}
${UserPrivacyScopesFragmentDoc}`;
export const UserProfileUserFragmentDoc = gql`
    fragment UserProfileUser on user {
  id: firestoreId
  avatar
  username
  firstName
  lastName
  isMod
  country
  bio
  interestAreas
  accomplishments
  ...UserType
  ...UserPrivacyScopes
  teacher {
    id: userId
    displayName
  }
}
    ${UserTypeFragmentDoc}
${UserPrivacyScopesFragmentDoc}`;
export const UserSocialCountsFragmentDoc = gql`
    fragment UserSocialCounts on user {
  id: firestoreId
  followers_aggregate(where: {disabled: {_eq: false}}) {
    aggregate {
      count
    }
  }
  following_aggregate(where: {disabled: {_eq: false}}) {
    aggregate {
      count
    }
  }
}
    `;
export const UserSocialFragmentDoc = gql`
    fragment UserSocial on user {
  id: firestoreId
  username
  avatar
  followers(where: {sourceUserId: {_eq: $currentUserId}}) {
    sourceUserId
    targetUserId
  }
  ...UserType
  ...UserPrivacyScopes
}
    ${UserTypeFragmentDoc}
${UserPrivacyScopesFragmentDoc}`;
export const UserFollowersFragmentDoc = gql`
    fragment UserFollowers on user {
  id: firestoreId
  followers(limit: $limit, where: {disabled: {_eq: false}}) {
    sourceUserId
    sourceUser {
      ...UserSocial
    }
  }
}
    ${UserSocialFragmentDoc}`;
export const UserFollowingFragmentDoc = gql`
    fragment UserFollowing on user {
  id: firestoreId
  following(limit: $limit, where: {disabled: {_eq: false}}) {
    targetUserId
    targetUser {
      ...UserSocial
    }
  }
}
    ${UserSocialFragmentDoc}`;
export const ProjectPathFragmentDoc = gql`
    fragment projectPath on path {
  id
  slug
  title
  coverFile {
    id
    filename
    transforms {
      filename
    }
  }
  authorId
  user {
    id: firestoreId
    username
    avatar
    firstName
    lastName
  }
}
    `;
export const CommentFragmentDoc = gql`
    fragment comment on comment {
  id
  text
  giphyId
  createdAt
  deletedAt
  published
  userId
  user {
    id: firestoreId
    username
    avatar
    firstName
    lastName
    country
    isMod
    ...UserType
  }
}
    ${UserTypeFragmentDoc}`;
export const ProjectCommentFragmentDoc = gql`
    fragment projectComment on project_comment {
  projectId
  commentId
  awardId
  comment {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export const ShopItemFragmentDoc = gql`
    fragment ShopItem on shop_item {
  id
  name
  description
  cost
  media
  disabled
  quantity
  tags
  coverFile {
    id
    filename
    transforms {
      fileId
      filename
    }
  }
  externalURL
  metadata
  owner {
    email
  }
}
    `;
export const ForumPostFragmentDoc = gql`
    fragment ForumPost on CirclePost {
  id
  name
  body
  url
  space_name
  user_name
  user_avatar_url
  comments_count
  likes_count
  created_at
  hide_meta_info
}
    `;
export const ForumSpaceGroupFragmentDoc = gql`
    fragment ForumSpaceGroup on CircleSpaceGroup {
  id
  name
  space_order_array
}
    `;
export const ForumSpaceFragmentDoc = gql`
    fragment ForumSpace on CircleSpace {
  id
  name
  emoji
}
    `;
export const ProjectReactionFragmentDoc = gql`
    fragment projectReaction on project_reaction {
  projectId
  userId
  count
}
    `;
export const UserFragmentDoc = gql`
    fragment User on user {
  firestoreId
  username
  avatar
  firstName
  lastName
}
    `;
export const UserSocialFollowHookFragmentDoc = gql`
    fragment UserSocialFollowHook on user {
  id: firestoreId
  ...UserType
  ...UserPrivacyScopes
}
    ${UserTypeFragmentDoc}
${UserPrivacyScopesFragmentDoc}`;
export const UserOnlineFragmentDoc = gql`
    fragment UserOnline on user {
  lastSeen
}
    `;
export const IsEducatorCodeActiveFragmentDoc = gql`
    fragment IsEducatorCodeActive on educator_code {
  code
  available
  expiresAt
}
    `;
export const UserFullNameFragmentDoc = gql`
    fragment UserFullName on user {
  firstName
  lastName
  username
  isEducator
  userType
}
    `;
export const AwardFragmentDoc = gql`
    fragment Award on award {
  id
  name
  description
  filePath
  bonus
  bonusDescription
  cost
  type
  ownerId
}
    `;
export const PathCardFragmentDoc = gql`
    fragment PathCard on path {
  _schemaVersion
  authorId
  cover
  coverAnimated
  id
  interestArea
  isPublished
  isTractOriginal
  subjects
  gradeLevels
  orgId
  publishedAt
  slug
  status
  title
  totalXP
  isVisibleUnauthed
  coverFile {
    id
    filename
    transforms {
      fileId
      filename
    }
  }
  coverAnimatedFile {
    id
    filename
    transforms {
      fileId
      filename
    }
  }
  tags
  user {
    id: firestoreId
    avatar
    firstName
    lastName
    username
    creatorLevel
  }
}
    `;
export const PathCollectionFragmentDoc = gql`
    fragment PathCollection on path_collection {
  id
  title
  description
  pathCollectionItems {
    collectionId
    pathId
    path {
      ...PathCard
    }
  }
}
    ${PathCardFragmentDoc}`;
export const AdminRejectedProjectFragmentDoc = gql`
    fragment AdminRejectedProject on project {
  id
  rejectedAt
  userId
  rewardCoin {
    amount
  }
}
    `;
export const CurrentUserLearnerGroupFragmentDoc = gql`
    fragment CurrentUserLearnerGroup on learner_group {
  id
  name
  type
  privacyScope
  members {
    learnerGroupId
    userId
    role
    isOwner
  }
  assignments {
    assignmentId
    learnerGroupId
    isFinished
  }
}
    `;
export const CurrentUserFragmentDoc = gql`
    fragment CurrentUser on user {
  id: firestoreId
  uid: firestoreId
  avatar
  bio
  birthday
  country
  creatorLevel
  disabled
  email
  firstName
  interestAreas
  isEducator
  isMod
  lastName
  orgId
  subscriptionExempt
  userType
  username
  accomplishments
  profilePrivacy
  projectPrivacy
  pathPrivacy
  integrations {
    userId
    foreignId
    provider
  }
  organization {
    id: firestoreId
    avatar
    name
    verified
    shopEnabled
  }
  learnerGroups(
    where: {learnerGroup: {archivedAt: {_eq: "-infinity"}}}
    order_by: {createdAt: desc}
  ) {
    learnerGroupId
    userId
    role
    isOwner
    learnerGroup {
      ...CurrentUserLearnerGroup
    }
  }
  followers_aggregate {
    aggregate {
      count
    }
  }
  following_aggregate {
    aggregate {
      count
    }
  }
  invitedById
  teacher {
    id: userId
    lowerGradeLevel
    upperGradeLevel
    displayName
    subjects
  }
}
    ${CurrentUserLearnerGroupFragmentDoc}`;
export const AssignBuilderDocument = gql`
    query AssignBuilder($id: uuid!) {
  assignment_by_pk(id: $id) {
    ...AssignmentBuilder
  }
}
    ${AssignmentBuilderFragmentDoc}`;

/**
 * __useAssignBuilderQuery__
 *
 * To run a query within a React component, call `useAssignBuilderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignBuilderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignBuilderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssignBuilderQuery(baseOptions: Apollo.QueryHookOptions<AssignBuilderQuery, AssignBuilderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignBuilderQuery, AssignBuilderQueryVariables>(AssignBuilderDocument, options);
      }
export function useAssignBuilderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignBuilderQuery, AssignBuilderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignBuilderQuery, AssignBuilderQueryVariables>(AssignBuilderDocument, options);
        }
export type AssignBuilderQueryHookResult = ReturnType<typeof useAssignBuilderQuery>;
export type AssignBuilderLazyQueryHookResult = ReturnType<typeof useAssignBuilderLazyQuery>;
export type AssignBuilderQueryResult = Apollo.QueryResult<AssignBuilderQuery, AssignBuilderQueryVariables>;
export const AssignBuilderPathByIdDocument = gql`
    query AssignBuilderPathById($id: bigint!) {
  path_by_pk(id: $id) {
    ...AssignBuilderPath
  }
}
    ${AssignBuilderPathFragmentDoc}`;

/**
 * __useAssignBuilderPathByIdQuery__
 *
 * To run a query within a React component, call `useAssignBuilderPathByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignBuilderPathByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignBuilderPathByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssignBuilderPathByIdQuery(baseOptions: Apollo.QueryHookOptions<AssignBuilderPathByIdQuery, AssignBuilderPathByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignBuilderPathByIdQuery, AssignBuilderPathByIdQueryVariables>(AssignBuilderPathByIdDocument, options);
      }
export function useAssignBuilderPathByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignBuilderPathByIdQuery, AssignBuilderPathByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignBuilderPathByIdQuery, AssignBuilderPathByIdQueryVariables>(AssignBuilderPathByIdDocument, options);
        }
export type AssignBuilderPathByIdQueryHookResult = ReturnType<typeof useAssignBuilderPathByIdQuery>;
export type AssignBuilderPathByIdLazyQueryHookResult = ReturnType<typeof useAssignBuilderPathByIdLazyQuery>;
export type AssignBuilderPathByIdQueryResult = Apollo.QueryResult<AssignBuilderPathByIdQuery, AssignBuilderPathByIdQueryVariables>;
export const CreateAssignmentDocument = gql`
    mutation CreateAssignment($object: assignment_insert_input!) {
  insert_assignment_one(object: $object) {
    id
    title
    description
    userId
    dueDate
    startDate
    learnerGroups {
      assignmentId
      learnerGroupId
    }
    paths {
      assignmentId
      pathId
      path {
        ...AssignBuilderPath
      }
    }
  }
}
    ${AssignBuilderPathFragmentDoc}`;
export type CreateAssignmentMutationFn = Apollo.MutationFunction<CreateAssignmentMutation, CreateAssignmentMutationVariables>;

/**
 * __useCreateAssignmentMutation__
 *
 * To run a mutation, you first call `useCreateAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssignmentMutation, { data, loading, error }] = useCreateAssignmentMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useCreateAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssignmentMutation, CreateAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssignmentMutation, CreateAssignmentMutationVariables>(CreateAssignmentDocument, options);
      }
export type CreateAssignmentMutationHookResult = ReturnType<typeof useCreateAssignmentMutation>;
export type CreateAssignmentMutationResult = Apollo.MutationResult<CreateAssignmentMutation>;
export type CreateAssignmentMutationOptions = Apollo.BaseMutationOptions<CreateAssignmentMutation, CreateAssignmentMutationVariables>;
export const UpdateAssignmentDocument = gql`
    mutation UpdateAssignment($id: uuid!, $object: assignment_set_input!, $learnerGroups: [assignment_learner_group_insert_input!]!) {
  delete_assignment_learner_group(where: {assignmentId: {_eq: $id}}) {
    affected_rows
  }
  insert_assignment_learner_group(objects: $learnerGroups) {
    affected_rows
  }
  update_assignment_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
    title
    description
    userId
    dueDate
    startDate
    learnerGroups {
      assignmentId
      learnerGroupId
    }
    paths {
      assignmentId
      pathId
      path {
        ...AssignBuilderPath
      }
    }
  }
}
    ${AssignBuilderPathFragmentDoc}`;
export type UpdateAssignmentMutationFn = Apollo.MutationFunction<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>;

/**
 * __useUpdateAssignmentMutation__
 *
 * To run a mutation, you first call `useUpdateAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignmentMutation, { data, loading, error }] = useUpdateAssignmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      object: // value for 'object'
 *      learnerGroups: // value for 'learnerGroups'
 *   },
 * });
 */
export function useUpdateAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>(UpdateAssignmentDocument, options);
      }
export type UpdateAssignmentMutationHookResult = ReturnType<typeof useUpdateAssignmentMutation>;
export type UpdateAssignmentMutationResult = Apollo.MutationResult<UpdateAssignmentMutation>;
export type UpdateAssignmentMutationOptions = Apollo.BaseMutationOptions<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>;
export const ClassSavedPathsDocument = gql`
    query ClassSavedPaths($learnerGroupId: uuid!) {
  learner_group_path_collection(where: {learnerGroupId: {_eq: $learnerGroupId}}) {
    learnerGroupId
    pathCollectionId
    pathCollection {
      ...PathCollection
    }
  }
}
    ${PathCollectionFragmentDoc}`;

/**
 * __useClassSavedPathsQuery__
 *
 * To run a query within a React component, call `useClassSavedPathsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassSavedPathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassSavedPathsQuery({
 *   variables: {
 *      learnerGroupId: // value for 'learnerGroupId'
 *   },
 * });
 */
export function useClassSavedPathsQuery(baseOptions: Apollo.QueryHookOptions<ClassSavedPathsQuery, ClassSavedPathsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassSavedPathsQuery, ClassSavedPathsQueryVariables>(ClassSavedPathsDocument, options);
      }
export function useClassSavedPathsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassSavedPathsQuery, ClassSavedPathsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassSavedPathsQuery, ClassSavedPathsQueryVariables>(ClassSavedPathsDocument, options);
        }
export type ClassSavedPathsQueryHookResult = ReturnType<typeof useClassSavedPathsQuery>;
export type ClassSavedPathsLazyQueryHookResult = ReturnType<typeof useClassSavedPathsLazyQuery>;
export type ClassSavedPathsQueryResult = Apollo.QueryResult<ClassSavedPathsQuery, ClassSavedPathsQueryVariables>;
export const RemovePathCollectionItemDocument = gql`
    mutation RemovePathCollectionItem($collectionId: uuid!, $pathId: bigint!) {
  delete_path_collection_item_by_pk(collectionId: $collectionId, pathId: $pathId) {
    pathCollection {
      id
    }
  }
}
    `;
export type RemovePathCollectionItemMutationFn = Apollo.MutationFunction<RemovePathCollectionItemMutation, RemovePathCollectionItemMutationVariables>;

/**
 * __useRemovePathCollectionItemMutation__
 *
 * To run a mutation, you first call `useRemovePathCollectionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePathCollectionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePathCollectionItemMutation, { data, loading, error }] = useRemovePathCollectionItemMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function useRemovePathCollectionItemMutation(baseOptions?: Apollo.MutationHookOptions<RemovePathCollectionItemMutation, RemovePathCollectionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePathCollectionItemMutation, RemovePathCollectionItemMutationVariables>(RemovePathCollectionItemDocument, options);
      }
export type RemovePathCollectionItemMutationHookResult = ReturnType<typeof useRemovePathCollectionItemMutation>;
export type RemovePathCollectionItemMutationResult = Apollo.MutationResult<RemovePathCollectionItemMutation>;
export type RemovePathCollectionItemMutationOptions = Apollo.BaseMutationOptions<RemovePathCollectionItemMutation, RemovePathCollectionItemMutationVariables>;
export const LearnerGroupSavesForPathDocument = gql`
    query LearnerGroupSavesForPath($pathId: bigint!) {
  path_collection_item(where: {pathId: {_eq: $pathId}}) {
    collectionId
    pathId
    pathCollection {
      id
      learnerGroupPathCollection {
        learnerGroupId
        pathCollectionId
      }
    }
  }
}
    `;

/**
 * __useLearnerGroupSavesForPathQuery__
 *
 * To run a query within a React component, call `useLearnerGroupSavesForPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearnerGroupSavesForPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearnerGroupSavesForPathQuery({
 *   variables: {
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function useLearnerGroupSavesForPathQuery(baseOptions: Apollo.QueryHookOptions<LearnerGroupSavesForPathQuery, LearnerGroupSavesForPathQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearnerGroupSavesForPathQuery, LearnerGroupSavesForPathQueryVariables>(LearnerGroupSavesForPathDocument, options);
      }
export function useLearnerGroupSavesForPathLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearnerGroupSavesForPathQuery, LearnerGroupSavesForPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearnerGroupSavesForPathQuery, LearnerGroupSavesForPathQueryVariables>(LearnerGroupSavesForPathDocument, options);
        }
export type LearnerGroupSavesForPathQueryHookResult = ReturnType<typeof useLearnerGroupSavesForPathQuery>;
export type LearnerGroupSavesForPathLazyQueryHookResult = ReturnType<typeof useLearnerGroupSavesForPathLazyQuery>;
export type LearnerGroupSavesForPathQueryResult = Apollo.QueryResult<LearnerGroupSavesForPathQuery, LearnerGroupSavesForPathQueryVariables>;
export const CreateLearnerGroupPathCollectionDocument = gql`
    mutation CreateLearnerGroupPathCollection($learnerGroupId: uuid!, $pathId: bigint!, $userId: String!, $lexorank: String!) {
  insert_learner_group_path_collection_one(
    object: {learnerGroupId: $learnerGroupId, pathCollection: {data: {pathCollectionItems: {data: {pathId: $pathId, lexorank: $lexorank}}, userId: $userId}}}
  ) {
    pathCollectionId
    learnerGroupId
    pathCollection {
      id
      pathCollectionItems {
        collectionId
        pathId
        lexorank
        pathCollection {
          id
          learnerGroupPathCollection {
            learnerGroupId
            pathCollectionId
          }
        }
      }
    }
  }
}
    `;
export type CreateLearnerGroupPathCollectionMutationFn = Apollo.MutationFunction<CreateLearnerGroupPathCollectionMutation, CreateLearnerGroupPathCollectionMutationVariables>;

/**
 * __useCreateLearnerGroupPathCollectionMutation__
 *
 * To run a mutation, you first call `useCreateLearnerGroupPathCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLearnerGroupPathCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLearnerGroupPathCollectionMutation, { data, loading, error }] = useCreateLearnerGroupPathCollectionMutation({
 *   variables: {
 *      learnerGroupId: // value for 'learnerGroupId'
 *      pathId: // value for 'pathId'
 *      userId: // value for 'userId'
 *      lexorank: // value for 'lexorank'
 *   },
 * });
 */
export function useCreateLearnerGroupPathCollectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateLearnerGroupPathCollectionMutation, CreateLearnerGroupPathCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLearnerGroupPathCollectionMutation, CreateLearnerGroupPathCollectionMutationVariables>(CreateLearnerGroupPathCollectionDocument, options);
      }
export type CreateLearnerGroupPathCollectionMutationHookResult = ReturnType<typeof useCreateLearnerGroupPathCollectionMutation>;
export type CreateLearnerGroupPathCollectionMutationResult = Apollo.MutationResult<CreateLearnerGroupPathCollectionMutation>;
export type CreateLearnerGroupPathCollectionMutationOptions = Apollo.BaseMutationOptions<CreateLearnerGroupPathCollectionMutation, CreateLearnerGroupPathCollectionMutationVariables>;
export const GetLearnerGroupsForTeacherDocument = gql`
    query GetLearnerGroupsForTeacher($userId: String!) {
  learner_group_path_collection(
    where: {learnerGroup: {members: {role: {_eq: "teacher"}, userId: {_eq: $userId}}}}
  ) {
    _id: learnerGroupId
    pathCollectionId
    pathCollection {
      id
      pathCollectionItems {
        _id: pathId
        lexorank
      }
    }
    learnerGroupId
    learnerGroup {
      id
      name
    }
  }
}
    `;

/**
 * __useGetLearnerGroupsForTeacherQuery__
 *
 * To run a query within a React component, call `useGetLearnerGroupsForTeacherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearnerGroupsForTeacherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearnerGroupsForTeacherQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetLearnerGroupsForTeacherQuery(baseOptions: Apollo.QueryHookOptions<GetLearnerGroupsForTeacherQuery, GetLearnerGroupsForTeacherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLearnerGroupsForTeacherQuery, GetLearnerGroupsForTeacherQueryVariables>(GetLearnerGroupsForTeacherDocument, options);
      }
export function useGetLearnerGroupsForTeacherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLearnerGroupsForTeacherQuery, GetLearnerGroupsForTeacherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLearnerGroupsForTeacherQuery, GetLearnerGroupsForTeacherQueryVariables>(GetLearnerGroupsForTeacherDocument, options);
        }
export type GetLearnerGroupsForTeacherQueryHookResult = ReturnType<typeof useGetLearnerGroupsForTeacherQuery>;
export type GetLearnerGroupsForTeacherLazyQueryHookResult = ReturnType<typeof useGetLearnerGroupsForTeacherLazyQuery>;
export type GetLearnerGroupsForTeacherQueryResult = Apollo.QueryResult<GetLearnerGroupsForTeacherQuery, GetLearnerGroupsForTeacherQueryVariables>;
export const InsertPathCollectionItemDocument = gql`
    mutation InsertPathCollectionItem($collectionId: uuid!, $pathId: bigint!, $lexorank: String!) {
  insert_path_collection_item_one(
    object: {collectionId: $collectionId, pathId: $pathId, lexorank: $lexorank}
  ) {
    collectionId
    pathId
    pathCollection {
      id
      learnerGroupPathCollection {
        learnerGroupId
        pathCollectionId
      }
    }
  }
}
    `;
export type InsertPathCollectionItemMutationFn = Apollo.MutationFunction<InsertPathCollectionItemMutation, InsertPathCollectionItemMutationVariables>;

/**
 * __useInsertPathCollectionItemMutation__
 *
 * To run a mutation, you first call `useInsertPathCollectionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertPathCollectionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertPathCollectionItemMutation, { data, loading, error }] = useInsertPathCollectionItemMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      pathId: // value for 'pathId'
 *      lexorank: // value for 'lexorank'
 *   },
 * });
 */
export function useInsertPathCollectionItemMutation(baseOptions?: Apollo.MutationHookOptions<InsertPathCollectionItemMutation, InsertPathCollectionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertPathCollectionItemMutation, InsertPathCollectionItemMutationVariables>(InsertPathCollectionItemDocument, options);
      }
export type InsertPathCollectionItemMutationHookResult = ReturnType<typeof useInsertPathCollectionItemMutation>;
export type InsertPathCollectionItemMutationResult = Apollo.MutationResult<InsertPathCollectionItemMutation>;
export type InsertPathCollectionItemMutationOptions = Apollo.BaseMutationOptions<InsertPathCollectionItemMutation, InsertPathCollectionItemMutationVariables>;
export const CollectionByIdDocument = gql`
    query CollectionById($id: uuid = "") {
  path_collection_by_pk(id: $id) {
    id
    title
    description
    user {
      id: firestoreId
      firstName
      username
      isEducator
      lastName
      avatar
    }
    pathCollectionItems(order_by: {lexorank: asc}) {
      collectionId
      pathId
      lexorank
      path {
        ...PathCard
      }
    }
  }
}
    ${PathCardFragmentDoc}`;

/**
 * __useCollectionByIdQuery__
 *
 * To run a query within a React component, call `useCollectionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCollectionByIdQuery(baseOptions?: Apollo.QueryHookOptions<CollectionByIdQuery, CollectionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectionByIdQuery, CollectionByIdQueryVariables>(CollectionByIdDocument, options);
      }
export function useCollectionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectionByIdQuery, CollectionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectionByIdQuery, CollectionByIdQueryVariables>(CollectionByIdDocument, options);
        }
export type CollectionByIdQueryHookResult = ReturnType<typeof useCollectionByIdQuery>;
export type CollectionByIdLazyQueryHookResult = ReturnType<typeof useCollectionByIdLazyQuery>;
export type CollectionByIdQueryResult = Apollo.QueryResult<CollectionByIdQuery, CollectionByIdQueryVariables>;
export const UpdatePathCollectionDocument = gql`
    mutation UpdatePathCollection($description: String = "", $title: String!, $userId: String!, $id: uuid!) {
  update_path_collection_by_pk(
    _set: {description: $description, title: $title, userId: $userId}
    pk_columns: {id: $id}
  ) {
    description
    title
    userId
  }
}
    `;
export type UpdatePathCollectionMutationFn = Apollo.MutationFunction<UpdatePathCollectionMutation, UpdatePathCollectionMutationVariables>;

/**
 * __useUpdatePathCollectionMutation__
 *
 * To run a mutation, you first call `useUpdatePathCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePathCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePathCollectionMutation, { data, loading, error }] = useUpdatePathCollectionMutation({
 *   variables: {
 *      description: // value for 'description'
 *      title: // value for 'title'
 *      userId: // value for 'userId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdatePathCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePathCollectionMutation, UpdatePathCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePathCollectionMutation, UpdatePathCollectionMutationVariables>(UpdatePathCollectionDocument, options);
      }
export type UpdatePathCollectionMutationHookResult = ReturnType<typeof useUpdatePathCollectionMutation>;
export type UpdatePathCollectionMutationResult = Apollo.MutationResult<UpdatePathCollectionMutation>;
export type UpdatePathCollectionMutationOptions = Apollo.BaseMutationOptions<UpdatePathCollectionMutation, UpdatePathCollectionMutationVariables>;
export const UpdatePathCollectionItemDocument = gql`
    mutation UpdatePathCollectionItem($lexorank: String!, $collectionId: uuid!, $pathId: bigint!) {
  update_path_collection_item_by_pk(
    _set: {lexorank: $lexorank}
    pk_columns: {collectionId: $collectionId, pathId: $pathId}
  ) {
    collectionId
    pathId
    lexorank
    path {
      ...PathCard
    }
  }
}
    ${PathCardFragmentDoc}`;
export type UpdatePathCollectionItemMutationFn = Apollo.MutationFunction<UpdatePathCollectionItemMutation, UpdatePathCollectionItemMutationVariables>;

/**
 * __useUpdatePathCollectionItemMutation__
 *
 * To run a mutation, you first call `useUpdatePathCollectionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePathCollectionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePathCollectionItemMutation, { data, loading, error }] = useUpdatePathCollectionItemMutation({
 *   variables: {
 *      lexorank: // value for 'lexorank'
 *      collectionId: // value for 'collectionId'
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function useUpdatePathCollectionItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePathCollectionItemMutation, UpdatePathCollectionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePathCollectionItemMutation, UpdatePathCollectionItemMutationVariables>(UpdatePathCollectionItemDocument, options);
      }
export type UpdatePathCollectionItemMutationHookResult = ReturnType<typeof useUpdatePathCollectionItemMutation>;
export type UpdatePathCollectionItemMutationResult = Apollo.MutationResult<UpdatePathCollectionItemMutation>;
export type UpdatePathCollectionItemMutationOptions = Apollo.BaseMutationOptions<UpdatePathCollectionItemMutation, UpdatePathCollectionItemMutationVariables>;
export const InsertPathCollectionDocument = gql`
    mutation InsertPathCollection($title: String!, $description: String, $userId: String!, $pathId: bigint!) {
  insert_path_collection_one(
    object: {title: $title, description: $description, userId: $userId, pathCollectionItems: {data: {pathId: $pathId}}}
  ) {
    id
    title
    description
    user {
      id: firestoreId
      firstName
      username
      isEducator
      lastName
      avatar
    }
    pathCollectionItems {
      collectionId
      pathId
      lexorank
      path {
        ...PathCard
      }
    }
  }
}
    ${PathCardFragmentDoc}`;
export type InsertPathCollectionMutationFn = Apollo.MutationFunction<InsertPathCollectionMutation, InsertPathCollectionMutationVariables>;

/**
 * __useInsertPathCollectionMutation__
 *
 * To run a mutation, you first call `useInsertPathCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertPathCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertPathCollectionMutation, { data, loading, error }] = useInsertPathCollectionMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      userId: // value for 'userId'
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function useInsertPathCollectionMutation(baseOptions?: Apollo.MutationHookOptions<InsertPathCollectionMutation, InsertPathCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertPathCollectionMutation, InsertPathCollectionMutationVariables>(InsertPathCollectionDocument, options);
      }
export type InsertPathCollectionMutationHookResult = ReturnType<typeof useInsertPathCollectionMutation>;
export type InsertPathCollectionMutationResult = Apollo.MutationResult<InsertPathCollectionMutation>;
export type InsertPathCollectionMutationOptions = Apollo.BaseMutationOptions<InsertPathCollectionMutation, InsertPathCollectionMutationVariables>;
export const DeletePathCollectionDocument = gql`
    mutation DeletePathCollection($collectionId: uuid!) {
  delete_path_collection_by_pk(id: $collectionId) {
    id
  }
}
    `;
export type DeletePathCollectionMutationFn = Apollo.MutationFunction<DeletePathCollectionMutation, DeletePathCollectionMutationVariables>;

/**
 * __useDeletePathCollectionMutation__
 *
 * To run a mutation, you first call `useDeletePathCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePathCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePathCollectionMutation, { data, loading, error }] = useDeletePathCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useDeletePathCollectionMutation(baseOptions?: Apollo.MutationHookOptions<DeletePathCollectionMutation, DeletePathCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePathCollectionMutation, DeletePathCollectionMutationVariables>(DeletePathCollectionDocument, options);
      }
export type DeletePathCollectionMutationHookResult = ReturnType<typeof useDeletePathCollectionMutation>;
export type DeletePathCollectionMutationResult = Apollo.MutationResult<DeletePathCollectionMutation>;
export type DeletePathCollectionMutationOptions = Apollo.BaseMutationOptions<DeletePathCollectionMutation, DeletePathCollectionMutationVariables>;
export const ImportClassroomsDocument = gql`
    mutation ImportClassrooms($orgId: String!, $accessToken: String!, $classes: [classroom_input!]!) {
  importClassrooms: api_import_classrooms(
    orgId: $orgId
    accessToken: $accessToken
    classes: $classes
  ) {
    learnerGroup {
      ...ClassroomLearnerGroup
    }
  }
}
    ${ClassroomLearnerGroupFragmentDoc}`;
export type ImportClassroomsMutationFn = Apollo.MutationFunction<ImportClassroomsMutation, ImportClassroomsMutationVariables>;

/**
 * __useImportClassroomsMutation__
 *
 * To run a mutation, you first call `useImportClassroomsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportClassroomsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importClassroomsMutation, { data, loading, error }] = useImportClassroomsMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      accessToken: // value for 'accessToken'
 *      classes: // value for 'classes'
 *   },
 * });
 */
export function useImportClassroomsMutation(baseOptions?: Apollo.MutationHookOptions<ImportClassroomsMutation, ImportClassroomsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportClassroomsMutation, ImportClassroomsMutationVariables>(ImportClassroomsDocument, options);
      }
export type ImportClassroomsMutationHookResult = ReturnType<typeof useImportClassroomsMutation>;
export type ImportClassroomsMutationResult = Apollo.MutationResult<ImportClassroomsMutation>;
export type ImportClassroomsMutationOptions = Apollo.BaseMutationOptions<ImportClassroomsMutation, ImportClassroomsMutationVariables>;
export const NextLivestreamDocument = gql`
    query NextLivestream($startDate: timestamptz!) {
  livestream: livestream(
    limit: 1
    offset: 0
    order_by: {startDate: asc}
    where: {_or: [{startDate: {_gte: $startDate}}, {endDate: {_gte: $startDate}}], disabled: {_eq: false}}
  ) {
    ...Livestream
  }
}
    ${LivestreamFragmentDoc}`;

/**
 * __useNextLivestreamQuery__
 *
 * To run a query within a React component, call `useNextLivestreamQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextLivestreamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextLivestreamQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useNextLivestreamQuery(baseOptions: Apollo.QueryHookOptions<NextLivestreamQuery, NextLivestreamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NextLivestreamQuery, NextLivestreamQueryVariables>(NextLivestreamDocument, options);
      }
export function useNextLivestreamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NextLivestreamQuery, NextLivestreamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NextLivestreamQuery, NextLivestreamQueryVariables>(NextLivestreamDocument, options);
        }
export type NextLivestreamQueryHookResult = ReturnType<typeof useNextLivestreamQuery>;
export type NextLivestreamLazyQueryHookResult = ReturnType<typeof useNextLivestreamLazyQuery>;
export type NextLivestreamQueryResult = Apollo.QueryResult<NextLivestreamQuery, NextLivestreamQueryVariables>;
export const LivestreamBannerDocument = gql`
    query LivestreamBanner($id: uuid!) {
  livestream: livestream_by_pk(id: $id) {
    ...Livestream
  }
}
    ${LivestreamFragmentDoc}`;

/**
 * __useLivestreamBannerQuery__
 *
 * To run a query within a React component, call `useLivestreamBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useLivestreamBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLivestreamBannerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLivestreamBannerQuery(baseOptions: Apollo.QueryHookOptions<LivestreamBannerQuery, LivestreamBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LivestreamBannerQuery, LivestreamBannerQueryVariables>(LivestreamBannerDocument, options);
      }
export function useLivestreamBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LivestreamBannerQuery, LivestreamBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LivestreamBannerQuery, LivestreamBannerQueryVariables>(LivestreamBannerDocument, options);
        }
export type LivestreamBannerQueryHookResult = ReturnType<typeof useLivestreamBannerQuery>;
export type LivestreamBannerLazyQueryHookResult = ReturnType<typeof useLivestreamBannerLazyQuery>;
export type LivestreamBannerQueryResult = Apollo.QueryResult<LivestreamBannerQuery, LivestreamBannerQueryVariables>;
export const JoinLivestreamDocument = gql`
    mutation JoinLivestream($livestreamId: uuid!) {
  api_join_livestream(livestreamId: $livestreamId)
}
    `;
export type JoinLivestreamMutationFn = Apollo.MutationFunction<JoinLivestreamMutation, JoinLivestreamMutationVariables>;

/**
 * __useJoinLivestreamMutation__
 *
 * To run a mutation, you first call `useJoinLivestreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinLivestreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinLivestreamMutation, { data, loading, error }] = useJoinLivestreamMutation({
 *   variables: {
 *      livestreamId: // value for 'livestreamId'
 *   },
 * });
 */
export function useJoinLivestreamMutation(baseOptions?: Apollo.MutationHookOptions<JoinLivestreamMutation, JoinLivestreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinLivestreamMutation, JoinLivestreamMutationVariables>(JoinLivestreamDocument, options);
      }
export type JoinLivestreamMutationHookResult = ReturnType<typeof useJoinLivestreamMutation>;
export type JoinLivestreamMutationResult = Apollo.MutationResult<JoinLivestreamMutation>;
export type JoinLivestreamMutationOptions = Apollo.BaseMutationOptions<JoinLivestreamMutation, JoinLivestreamMutationVariables>;
export const LivestreamUserByIdDocument = gql`
    query LivestreamUserById($userId: String!) {
  users: user(where: {firestoreId: {_eq: $userId}}) {
    id: firestoreId
    uid: firestoreId
    avatar
    country
    creatorLevel
    disabled
    isEducator
    isMod
    username
  }
}
    `;

/**
 * __useLivestreamUserByIdQuery__
 *
 * To run a query within a React component, call `useLivestreamUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLivestreamUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLivestreamUserByIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useLivestreamUserByIdQuery(baseOptions: Apollo.QueryHookOptions<LivestreamUserByIdQuery, LivestreamUserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LivestreamUserByIdQuery, LivestreamUserByIdQueryVariables>(LivestreamUserByIdDocument, options);
      }
export function useLivestreamUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LivestreamUserByIdQuery, LivestreamUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LivestreamUserByIdQuery, LivestreamUserByIdQueryVariables>(LivestreamUserByIdDocument, options);
        }
export type LivestreamUserByIdQueryHookResult = ReturnType<typeof useLivestreamUserByIdQuery>;
export type LivestreamUserByIdLazyQueryHookResult = ReturnType<typeof useLivestreamUserByIdLazyQuery>;
export type LivestreamUserByIdQueryResult = Apollo.QueryResult<LivestreamUserByIdQuery, LivestreamUserByIdQueryVariables>;
export const PathCardDataDocument = gql`
    query PathCardData($pathId: bigint!) {
  path: path_by_pk(id: $pathId) {
    ...PathCardData
  }
}
    ${PathCardDataFragmentDoc}`;

/**
 * __usePathCardDataQuery__
 *
 * To run a query within a React component, call `usePathCardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathCardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathCardDataQuery({
 *   variables: {
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function usePathCardDataQuery(baseOptions: Apollo.QueryHookOptions<PathCardDataQuery, PathCardDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PathCardDataQuery, PathCardDataQueryVariables>(PathCardDataDocument, options);
      }
export function usePathCardDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PathCardDataQuery, PathCardDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PathCardDataQuery, PathCardDataQueryVariables>(PathCardDataDocument, options);
        }
export type PathCardDataQueryHookResult = ReturnType<typeof usePathCardDataQuery>;
export type PathCardDataLazyQueryHookResult = ReturnType<typeof usePathCardDataLazyQuery>;
export type PathCardDataQueryResult = Apollo.QueryResult<PathCardDataQuery, PathCardDataQueryVariables>;
export const UserProfilePopoverDocument = gql`
    query UserProfilePopover($userId: String!) {
  user(where: {firestoreId: {_eq: $userId}}) {
    ...UserProfilePopover
  }
}
    ${UserProfilePopoverFragmentDoc}`;

/**
 * __useUserProfilePopoverQuery__
 *
 * To run a query within a React component, call `useUserProfilePopoverQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfilePopoverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfilePopoverQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserProfilePopoverQuery(baseOptions: Apollo.QueryHookOptions<UserProfilePopoverQuery, UserProfilePopoverQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProfilePopoverQuery, UserProfilePopoverQueryVariables>(UserProfilePopoverDocument, options);
      }
export function useUserProfilePopoverLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProfilePopoverQuery, UserProfilePopoverQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProfilePopoverQuery, UserProfilePopoverQueryVariables>(UserProfilePopoverDocument, options);
        }
export type UserProfilePopoverQueryHookResult = ReturnType<typeof useUserProfilePopoverQuery>;
export type UserProfilePopoverLazyQueryHookResult = ReturnType<typeof useUserProfilePopoverLazyQuery>;
export type UserProfilePopoverQueryResult = Apollo.QueryResult<UserProfilePopoverQuery, UserProfilePopoverQueryVariables>;
export const GetLmsOptionsDocument = gql`
    query GetLMSOptions {
  lms: lms(order_by: {imageFilePath: asc}, limit: 50) {
    id
    name
    helpArticleLink
    imageFilePath
  }
}
    `;

/**
 * __useGetLmsOptionsQuery__
 *
 * To run a query within a React component, call `useGetLmsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLmsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLmsOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLmsOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetLmsOptionsQuery, GetLmsOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLmsOptionsQuery, GetLmsOptionsQueryVariables>(GetLmsOptionsDocument, options);
      }
export function useGetLmsOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLmsOptionsQuery, GetLmsOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLmsOptionsQuery, GetLmsOptionsQueryVariables>(GetLmsOptionsDocument, options);
        }
export type GetLmsOptionsQueryHookResult = ReturnType<typeof useGetLmsOptionsQuery>;
export type GetLmsOptionsLazyQueryHookResult = ReturnType<typeof useGetLmsOptionsLazyQuery>;
export type GetLmsOptionsQueryResult = Apollo.QueryResult<GetLmsOptionsQuery, GetLmsOptionsQueryVariables>;
export const GetVideoBackdropsDocument = gql`
    query getVideoBackdrops {
  api_get_video_backdrops {
    name
    createdAt
    url
  }
}
    `;

/**
 * __useGetVideoBackdropsQuery__
 *
 * To run a query within a React component, call `useGetVideoBackdropsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoBackdropsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoBackdropsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVideoBackdropsQuery(baseOptions?: Apollo.QueryHookOptions<GetVideoBackdropsQuery, GetVideoBackdropsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVideoBackdropsQuery, GetVideoBackdropsQueryVariables>(GetVideoBackdropsDocument, options);
      }
export function useGetVideoBackdropsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVideoBackdropsQuery, GetVideoBackdropsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVideoBackdropsQuery, GetVideoBackdropsQueryVariables>(GetVideoBackdropsDocument, options);
        }
export type GetVideoBackdropsQueryHookResult = ReturnType<typeof useGetVideoBackdropsQuery>;
export type GetVideoBackdropsLazyQueryHookResult = ReturnType<typeof useGetVideoBackdropsLazyQuery>;
export type GetVideoBackdropsQueryResult = Apollo.QueryResult<GetVideoBackdropsQuery, GetVideoBackdropsQueryVariables>;
export const GetUsersByUserIdsDocument = gql`
    query GetUsersByUserIds($userIds: [String!]) {
  user(where: {firestoreId: {_in: $userIds}}) {
    id: firestoreId
    firstName
    username
    userType
  }
}
    `;

/**
 * __useGetUsersByUserIdsQuery__
 *
 * To run a query within a React component, call `useGetUsersByUserIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByUserIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersByUserIdsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetUsersByUserIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersByUserIdsQuery, GetUsersByUserIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersByUserIdsQuery, GetUsersByUserIdsQueryVariables>(GetUsersByUserIdsDocument, options);
      }
export function useGetUsersByUserIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersByUserIdsQuery, GetUsersByUserIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersByUserIdsQuery, GetUsersByUserIdsQueryVariables>(GetUsersByUserIdsDocument, options);
        }
export type GetUsersByUserIdsQueryHookResult = ReturnType<typeof useGetUsersByUserIdsQuery>;
export type GetUsersByUserIdsLazyQueryHookResult = ReturnType<typeof useGetUsersByUserIdsLazyQuery>;
export type GetUsersByUserIdsQueryResult = Apollo.QueryResult<GetUsersByUserIdsQuery, GetUsersByUserIdsQueryVariables>;
export const CollectionsForAdminDocument = gql`
    query CollectionsForAdmin {
  path_collection(
    where: {_not: {learnerGroupPathCollection: {}}}
    order_by: {title: asc}
  ) {
    id
    title
    description
    user {
      id: firestoreId
      username
      isEducator
      lastName
      firstName
      avatar
    }
    pathCollectionItems {
      pathId
      lexorank
    }
  }
}
    `;

/**
 * __useCollectionsForAdminQuery__
 *
 * To run a query within a React component, call `useCollectionsForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionsForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionsForAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useCollectionsForAdminQuery(baseOptions?: Apollo.QueryHookOptions<CollectionsForAdminQuery, CollectionsForAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectionsForAdminQuery, CollectionsForAdminQueryVariables>(CollectionsForAdminDocument, options);
      }
export function useCollectionsForAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectionsForAdminQuery, CollectionsForAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectionsForAdminQuery, CollectionsForAdminQueryVariables>(CollectionsForAdminDocument, options);
        }
export type CollectionsForAdminQueryHookResult = ReturnType<typeof useCollectionsForAdminQuery>;
export type CollectionsForAdminLazyQueryHookResult = ReturnType<typeof useCollectionsForAdminLazyQuery>;
export type CollectionsForAdminQueryResult = Apollo.QueryResult<CollectionsForAdminQuery, CollectionsForAdminQueryVariables>;
export const AllLearnerGroupLearnersDocument = gql`
    query AllLearnerGroupLearners($teacherUserId: String!, $learnerGroupId: uuid) {
  learner_group(
    where: {members: {userId: {_eq: $teacherUserId}}, id: {_eq: $learnerGroupId}}
  ) {
    members(where: {role: {_eq: "learner"}}) {
      ...CommentsLearnerGroupMember
    }
  }
}
    ${CommentsLearnerGroupMemberFragmentDoc}`;

/**
 * __useAllLearnerGroupLearnersQuery__
 *
 * To run a query within a React component, call `useAllLearnerGroupLearnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLearnerGroupLearnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLearnerGroupLearnersQuery({
 *   variables: {
 *      teacherUserId: // value for 'teacherUserId'
 *      learnerGroupId: // value for 'learnerGroupId'
 *   },
 * });
 */
export function useAllLearnerGroupLearnersQuery(baseOptions: Apollo.QueryHookOptions<AllLearnerGroupLearnersQuery, AllLearnerGroupLearnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllLearnerGroupLearnersQuery, AllLearnerGroupLearnersQueryVariables>(AllLearnerGroupLearnersDocument, options);
      }
export function useAllLearnerGroupLearnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllLearnerGroupLearnersQuery, AllLearnerGroupLearnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllLearnerGroupLearnersQuery, AllLearnerGroupLearnersQueryVariables>(AllLearnerGroupLearnersDocument, options);
        }
export type AllLearnerGroupLearnersQueryHookResult = ReturnType<typeof useAllLearnerGroupLearnersQuery>;
export type AllLearnerGroupLearnersLazyQueryHookResult = ReturnType<typeof useAllLearnerGroupLearnersLazyQuery>;
export type AllLearnerGroupLearnersQueryResult = Apollo.QueryResult<AllLearnerGroupLearnersQuery, AllLearnerGroupLearnersQueryVariables>;
export const AdminCommentsDocument = gql`
    query AdminComments($where: comment_bool_exp!, $limit: Int!, $offset: Int!) {
  comments: comment(
    where: $where
    limit: $limit
    offset: $offset
    order_by: {updatedAt: desc}
  ) {
    ...AdminComment
  }
}
    ${AdminCommentFragmentDoc}`;

/**
 * __useAdminCommentsQuery__
 *
 * To run a query within a React component, call `useAdminCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCommentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAdminCommentsQuery(baseOptions: Apollo.QueryHookOptions<AdminCommentsQuery, AdminCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCommentsQuery, AdminCommentsQueryVariables>(AdminCommentsDocument, options);
      }
export function useAdminCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCommentsQuery, AdminCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCommentsQuery, AdminCommentsQueryVariables>(AdminCommentsDocument, options);
        }
export type AdminCommentsQueryHookResult = ReturnType<typeof useAdminCommentsQuery>;
export type AdminCommentsLazyQueryHookResult = ReturnType<typeof useAdminCommentsLazyQuery>;
export type AdminCommentsQueryResult = Apollo.QueryResult<AdminCommentsQuery, AdminCommentsQueryVariables>;
export const ParentCommentDocument = gql`
    query ParentComment($id: uuid!) {
  comment_by_pk(id: $id) {
    userId
    id
  }
}
    `;

/**
 * __useParentCommentQuery__
 *
 * To run a query within a React component, call `useParentCommentQuery` and pass it any options that fit your needs.
 * When your component renders, `useParentCommentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParentCommentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useParentCommentQuery(baseOptions: Apollo.QueryHookOptions<ParentCommentQuery, ParentCommentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParentCommentQuery, ParentCommentQueryVariables>(ParentCommentDocument, options);
      }
export function useParentCommentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParentCommentQuery, ParentCommentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParentCommentQuery, ParentCommentQueryVariables>(ParentCommentDocument, options);
        }
export type ParentCommentQueryHookResult = ReturnType<typeof useParentCommentQuery>;
export type ParentCommentLazyQueryHookResult = ReturnType<typeof useParentCommentLazyQuery>;
export type ParentCommentQueryResult = Apollo.QueryResult<ParentCommentQuery, ParentCommentQueryVariables>;
export const AdminUpdateCommentStatusDocument = gql`
    mutation AdminUpdateCommentStatus($commentId: uuid!, $deletedAt: timestamptz!, $published: Boolean!) {
  update_comment_by_pk(
    pk_columns: {id: $commentId}
    _set: {deletedAt: $deletedAt, published: $published}
  ) {
    id
    deletedAt
    published
  }
}
    `;
export type AdminUpdateCommentStatusMutationFn = Apollo.MutationFunction<AdminUpdateCommentStatusMutation, AdminUpdateCommentStatusMutationVariables>;

/**
 * __useAdminUpdateCommentStatusMutation__
 *
 * To run a mutation, you first call `useAdminUpdateCommentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateCommentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateCommentStatusMutation, { data, loading, error }] = useAdminUpdateCommentStatusMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      deletedAt: // value for 'deletedAt'
 *      published: // value for 'published'
 *   },
 * });
 */
export function useAdminUpdateCommentStatusMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateCommentStatusMutation, AdminUpdateCommentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateCommentStatusMutation, AdminUpdateCommentStatusMutationVariables>(AdminUpdateCommentStatusDocument, options);
      }
export type AdminUpdateCommentStatusMutationHookResult = ReturnType<typeof useAdminUpdateCommentStatusMutation>;
export type AdminUpdateCommentStatusMutationResult = Apollo.MutationResult<AdminUpdateCommentStatusMutation>;
export type AdminUpdateCommentStatusMutationOptions = Apollo.BaseMutationOptions<AdminUpdateCommentStatusMutation, AdminUpdateCommentStatusMutationVariables>;
export const AdminLivestreamsDocument = gql`
    query AdminLivestreams($limit: Int!, $offset: Int!, $startDate: timestamptz_comparison_exp!, $orderBy: livestream_order_by!) {
  livestreams: livestream(
    limit: $limit
    offset: $offset
    where: {startDate: $startDate}
    order_by: [$orderBy]
  ) {
    ...AdminLivestream
  }
}
    ${AdminLivestreamFragmentDoc}`;

/**
 * __useAdminLivestreamsQuery__
 *
 * To run a query within a React component, call `useAdminLivestreamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminLivestreamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminLivestreamsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      startDate: // value for 'startDate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAdminLivestreamsQuery(baseOptions: Apollo.QueryHookOptions<AdminLivestreamsQuery, AdminLivestreamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminLivestreamsQuery, AdminLivestreamsQueryVariables>(AdminLivestreamsDocument, options);
      }
export function useAdminLivestreamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminLivestreamsQuery, AdminLivestreamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminLivestreamsQuery, AdminLivestreamsQueryVariables>(AdminLivestreamsDocument, options);
        }
export type AdminLivestreamsQueryHookResult = ReturnType<typeof useAdminLivestreamsQuery>;
export type AdminLivestreamsLazyQueryHookResult = ReturnType<typeof useAdminLivestreamsLazyQuery>;
export type AdminLivestreamsQueryResult = Apollo.QueryResult<AdminLivestreamsQuery, AdminLivestreamsQueryVariables>;
export const LivestreamByPkDocument = gql`
    query LivestreamByPk($id: uuid!) {
  livestream: livestream_by_pk(id: $id) {
    ...AdminLivestream
  }
}
    ${AdminLivestreamFragmentDoc}`;

/**
 * __useLivestreamByPkQuery__
 *
 * To run a query within a React component, call `useLivestreamByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useLivestreamByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLivestreamByPkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLivestreamByPkQuery(baseOptions: Apollo.QueryHookOptions<LivestreamByPkQuery, LivestreamByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LivestreamByPkQuery, LivestreamByPkQueryVariables>(LivestreamByPkDocument, options);
      }
export function useLivestreamByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LivestreamByPkQuery, LivestreamByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LivestreamByPkQuery, LivestreamByPkQueryVariables>(LivestreamByPkDocument, options);
        }
export type LivestreamByPkQueryHookResult = ReturnType<typeof useLivestreamByPkQuery>;
export type LivestreamByPkLazyQueryHookResult = ReturnType<typeof useLivestreamByPkLazyQuery>;
export type LivestreamByPkQueryResult = Apollo.QueryResult<LivestreamByPkQuery, LivestreamByPkQueryVariables>;
export const CreateLivestreamDocument = gql`
    mutation CreateLivestream($object: livestream_insert_input!) {
  livestream: insert_livestream_one(object: $object) {
    ...AdminLivestream
  }
}
    ${AdminLivestreamFragmentDoc}`;
export type CreateLivestreamMutationFn = Apollo.MutationFunction<CreateLivestreamMutation, CreateLivestreamMutationVariables>;

/**
 * __useCreateLivestreamMutation__
 *
 * To run a mutation, you first call `useCreateLivestreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLivestreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLivestreamMutation, { data, loading, error }] = useCreateLivestreamMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useCreateLivestreamMutation(baseOptions?: Apollo.MutationHookOptions<CreateLivestreamMutation, CreateLivestreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLivestreamMutation, CreateLivestreamMutationVariables>(CreateLivestreamDocument, options);
      }
export type CreateLivestreamMutationHookResult = ReturnType<typeof useCreateLivestreamMutation>;
export type CreateLivestreamMutationResult = Apollo.MutationResult<CreateLivestreamMutation>;
export type CreateLivestreamMutationOptions = Apollo.BaseMutationOptions<CreateLivestreamMutation, CreateLivestreamMutationVariables>;
export const UpdateLivestreamDocument = gql`
    mutation UpdateLivestream($id: uuid!, $object: livestream_set_input!) {
  livestream: update_livestream_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...AdminLivestream
  }
}
    ${AdminLivestreamFragmentDoc}`;
export type UpdateLivestreamMutationFn = Apollo.MutationFunction<UpdateLivestreamMutation, UpdateLivestreamMutationVariables>;

/**
 * __useUpdateLivestreamMutation__
 *
 * To run a mutation, you first call `useUpdateLivestreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLivestreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLivestreamMutation, { data, loading, error }] = useUpdateLivestreamMutation({
 *   variables: {
 *      id: // value for 'id'
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpdateLivestreamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLivestreamMutation, UpdateLivestreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLivestreamMutation, UpdateLivestreamMutationVariables>(UpdateLivestreamDocument, options);
      }
export type UpdateLivestreamMutationHookResult = ReturnType<typeof useUpdateLivestreamMutation>;
export type UpdateLivestreamMutationResult = Apollo.MutationResult<UpdateLivestreamMutation>;
export type UpdateLivestreamMutationOptions = Apollo.BaseMutationOptions<UpdateLivestreamMutation, UpdateLivestreamMutationVariables>;
export const SaveOrgDocument = gql`
    mutation SaveOrg($org: api_upsert_organization_data_input!) {
  api_upsert_organization(data: $org) {
    orgId
  }
}
    `;
export type SaveOrgMutationFn = Apollo.MutationFunction<SaveOrgMutation, SaveOrgMutationVariables>;

/**
 * __useSaveOrgMutation__
 *
 * To run a mutation, you first call `useSaveOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOrgMutation, { data, loading, error }] = useSaveOrgMutation({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function useSaveOrgMutation(baseOptions?: Apollo.MutationHookOptions<SaveOrgMutation, SaveOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveOrgMutation, SaveOrgMutationVariables>(SaveOrgDocument, options);
      }
export type SaveOrgMutationHookResult = ReturnType<typeof useSaveOrgMutation>;
export type SaveOrgMutationResult = Apollo.MutationResult<SaveOrgMutation>;
export type SaveOrgMutationOptions = Apollo.BaseMutationOptions<SaveOrgMutation, SaveOrgMutationVariables>;
export const ActiveOrgTeachersDocument = gql`
    query ActiveOrgTeachers($orgId: String!, $userType: String!) {
  user(where: {orgId: {_eq: $orgId}, userType: {_eq: $userType}}) {
    id: firestoreId
    firstName
    lastName
    email
    createdAt
    avatar
    userType
    teacher {
      id: userId
      displayName
    }
  }
}
    `;

/**
 * __useActiveOrgTeachersQuery__
 *
 * To run a query within a React component, call `useActiveOrgTeachersQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveOrgTeachersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveOrgTeachersQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      userType: // value for 'userType'
 *   },
 * });
 */
export function useActiveOrgTeachersQuery(baseOptions: Apollo.QueryHookOptions<ActiveOrgTeachersQuery, ActiveOrgTeachersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveOrgTeachersQuery, ActiveOrgTeachersQueryVariables>(ActiveOrgTeachersDocument, options);
      }
export function useActiveOrgTeachersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveOrgTeachersQuery, ActiveOrgTeachersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveOrgTeachersQuery, ActiveOrgTeachersQueryVariables>(ActiveOrgTeachersDocument, options);
        }
export type ActiveOrgTeachersQueryHookResult = ReturnType<typeof useActiveOrgTeachersQuery>;
export type ActiveOrgTeachersLazyQueryHookResult = ReturnType<typeof useActiveOrgTeachersLazyQuery>;
export type ActiveOrgTeachersQueryResult = Apollo.QueryResult<ActiveOrgTeachersQuery, ActiveOrgTeachersQueryVariables>;
export const AdminOrgByIdDocument = gql`
    query AdminOrgById($orgId: String!) {
  organization_by_pk(firestoreId: $orgId) {
    id: firestoreId
    name
    type
    verified
    address
    avatar
    gradeLevel
    placeId
    addressLine1
    addressLine2
    city
    zip
    region
    country
    shopEnabled
    users(where: {isEducator: {_eq: true}}) {
      id: firestoreId
    }
    emailDomains: domains {
      domain
    }
  }
}
    `;

/**
 * __useAdminOrgByIdQuery__
 *
 * To run a query within a React component, call `useAdminOrgByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrgByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrgByIdQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useAdminOrgByIdQuery(baseOptions: Apollo.QueryHookOptions<AdminOrgByIdQuery, AdminOrgByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrgByIdQuery, AdminOrgByIdQueryVariables>(AdminOrgByIdDocument, options);
      }
export function useAdminOrgByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrgByIdQuery, AdminOrgByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrgByIdQuery, AdminOrgByIdQueryVariables>(AdminOrgByIdDocument, options);
        }
export type AdminOrgByIdQueryHookResult = ReturnType<typeof useAdminOrgByIdQuery>;
export type AdminOrgByIdLazyQueryHookResult = ReturnType<typeof useAdminOrgByIdLazyQuery>;
export type AdminOrgByIdQueryResult = Apollo.QueryResult<AdminOrgByIdQuery, AdminOrgByIdQueryVariables>;
export const AdminOrgsByStatusDocument = gql`
    query AdminOrgsByStatus($verified: Boolean!, $limit: Int!, $offset: Int!) {
  adminOrgs: organization(
    limit: $limit
    offset: $offset
    where: {verified: {_eq: $verified}}
    order_by: {createdAt: desc}
  ) {
    ...AdminOrg
  }
  pendingCount: organization_aggregate(
    where: {verified: {_eq: false}}
    order_by: {createdAt: desc}
  ) {
    aggregate {
      count
    }
  }
}
    ${AdminOrgFragmentDoc}`;

/**
 * __useAdminOrgsByStatusQuery__
 *
 * To run a query within a React component, call `useAdminOrgsByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrgsByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrgsByStatusQuery({
 *   variables: {
 *      verified: // value for 'verified'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAdminOrgsByStatusQuery(baseOptions: Apollo.QueryHookOptions<AdminOrgsByStatusQuery, AdminOrgsByStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrgsByStatusQuery, AdminOrgsByStatusQueryVariables>(AdminOrgsByStatusDocument, options);
      }
export function useAdminOrgsByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrgsByStatusQuery, AdminOrgsByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrgsByStatusQuery, AdminOrgsByStatusQueryVariables>(AdminOrgsByStatusDocument, options);
        }
export type AdminOrgsByStatusQueryHookResult = ReturnType<typeof useAdminOrgsByStatusQuery>;
export type AdminOrgsByStatusLazyQueryHookResult = ReturnType<typeof useAdminOrgsByStatusLazyQuery>;
export type AdminOrgsByStatusQueryResult = Apollo.QueryResult<AdminOrgsByStatusQuery, AdminOrgsByStatusQueryVariables>;
export const AdminOrgsSearchDocument = gql`
    query AdminOrgsSearch($search: String!, $verified: Boolean!, $limit: Int!, $offset: Int!) {
  adminOrgs: search_organizations(
    args: {search: $search}
    where: {verified: {_eq: $verified}}
    limit: $limit
    offset: $offset
  ) {
    ...AdminOrg
  }
  pendingCount: search_organizations_aggregate(
    args: {search: $search}
    where: {verified: {_eq: false}}
  ) {
    aggregate {
      count
    }
  }
}
    ${AdminOrgFragmentDoc}`;

/**
 * __useAdminOrgsSearchQuery__
 *
 * To run a query within a React component, call `useAdminOrgsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrgsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrgsSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *      verified: // value for 'verified'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAdminOrgsSearchQuery(baseOptions: Apollo.QueryHookOptions<AdminOrgsSearchQuery, AdminOrgsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrgsSearchQuery, AdminOrgsSearchQueryVariables>(AdminOrgsSearchDocument, options);
      }
export function useAdminOrgsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrgsSearchQuery, AdminOrgsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrgsSearchQuery, AdminOrgsSearchQueryVariables>(AdminOrgsSearchDocument, options);
        }
export type AdminOrgsSearchQueryHookResult = ReturnType<typeof useAdminOrgsSearchQuery>;
export type AdminOrgsSearchLazyQueryHookResult = ReturnType<typeof useAdminOrgsSearchLazyQuery>;
export type AdminOrgsSearchQueryResult = Apollo.QueryResult<AdminOrgsSearchQuery, AdminOrgsSearchQueryVariables>;
export const AdminDeletePendingOrgDocument = gql`
    mutation AdminDeletePendingOrg($orgId: String!) {
  delete_organization(where: {firestoreId: {_eq: $orgId}, verified: {_eq: false}}) {
    affected_rows
  }
}
    `;
export type AdminDeletePendingOrgMutationFn = Apollo.MutationFunction<AdminDeletePendingOrgMutation, AdminDeletePendingOrgMutationVariables>;

/**
 * __useAdminDeletePendingOrgMutation__
 *
 * To run a mutation, you first call `useAdminDeletePendingOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeletePendingOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeletePendingOrgMutation, { data, loading, error }] = useAdminDeletePendingOrgMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useAdminDeletePendingOrgMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeletePendingOrgMutation, AdminDeletePendingOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeletePendingOrgMutation, AdminDeletePendingOrgMutationVariables>(AdminDeletePendingOrgDocument, options);
      }
export type AdminDeletePendingOrgMutationHookResult = ReturnType<typeof useAdminDeletePendingOrgMutation>;
export type AdminDeletePendingOrgMutationResult = Apollo.MutationResult<AdminDeletePendingOrgMutation>;
export type AdminDeletePendingOrgMutationOptions = Apollo.BaseMutationOptions<AdminDeletePendingOrgMutation, AdminDeletePendingOrgMutationVariables>;
export const AdminMoveUserDocument = gql`
    mutation AdminMoveUser($userId: String!, $orgId: String!) {
  update_user_by_pk(pk_columns: {firestoreId: $userId}, _set: {orgId: $orgId}) {
    id
  }
  update_learner_group(
    where: {members: {userId: {_eq: $userId}, isOwner: {_eq: true}}}
    _set: {orgId: $orgId}
  ) {
    affected_rows
  }
  update_user(
    where: {learnerGroups: {learnerGroup: {members: {userId: {_eq: $userId}, isOwner: {_eq: true}}}}}
    _set: {orgId: $orgId}
  ) {
    affected_rows
  }
}
    `;
export type AdminMoveUserMutationFn = Apollo.MutationFunction<AdminMoveUserMutation, AdminMoveUserMutationVariables>;

/**
 * __useAdminMoveUserMutation__
 *
 * To run a mutation, you first call `useAdminMoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMoveUserMutation, { data, loading, error }] = useAdminMoveUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useAdminMoveUserMutation(baseOptions?: Apollo.MutationHookOptions<AdminMoveUserMutation, AdminMoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMoveUserMutation, AdminMoveUserMutationVariables>(AdminMoveUserDocument, options);
      }
export type AdminMoveUserMutationHookResult = ReturnType<typeof useAdminMoveUserMutation>;
export type AdminMoveUserMutationResult = Apollo.MutationResult<AdminMoveUserMutation>;
export type AdminMoveUserMutationOptions = Apollo.BaseMutationOptions<AdminMoveUserMutation, AdminMoveUserMutationVariables>;
export const CreatorPathsForAdminDocument = gql`
    query CreatorPathsForAdmin($offset: Int!, $status: String!, $limit: Int!, $orderBy: path_order_by!, $creatorLevel: String_comparison_exp!, $userId: String!) {
  paths: path(
    offset: $offset
    limit: $limit
    where: {_schemaVersion: {_eq: 3}, status: {_eq: $status}, user: {creatorLevel: $creatorLevel, firestoreId: {_neq: $userId}}}
    order_by: [$orderBy]
  ) {
    ...pathsByStatus
  }
}
    ${PathsByStatusFragmentDoc}`;

/**
 * __useCreatorPathsForAdminQuery__
 *
 * To run a query within a React component, call `useCreatorPathsForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreatorPathsForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatorPathsForAdminQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *      creatorLevel: // value for 'creatorLevel'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreatorPathsForAdminQuery(baseOptions: Apollo.QueryHookOptions<CreatorPathsForAdminQuery, CreatorPathsForAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreatorPathsForAdminQuery, CreatorPathsForAdminQueryVariables>(CreatorPathsForAdminDocument, options);
      }
export function useCreatorPathsForAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreatorPathsForAdminQuery, CreatorPathsForAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreatorPathsForAdminQuery, CreatorPathsForAdminQueryVariables>(CreatorPathsForAdminDocument, options);
        }
export type CreatorPathsForAdminQueryHookResult = ReturnType<typeof useCreatorPathsForAdminQuery>;
export type CreatorPathsForAdminLazyQueryHookResult = ReturnType<typeof useCreatorPathsForAdminLazyQuery>;
export type CreatorPathsForAdminQueryResult = Apollo.QueryResult<CreatorPathsForAdminQuery, CreatorPathsForAdminQueryVariables>;
export const AdminShopItemsDocument = gql`
    query AdminShopItems($limit: Int!, $offset: Int!) {
  items: shop_item(limit: $limit, offset: $offset, order_by: {updatedAt: desc}) {
    ...AdminShopItem
  }
}
    ${AdminShopItemFragmentDoc}`;

/**
 * __useAdminShopItemsQuery__
 *
 * To run a query within a React component, call `useAdminShopItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminShopItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminShopItemsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAdminShopItemsQuery(baseOptions: Apollo.QueryHookOptions<AdminShopItemsQuery, AdminShopItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminShopItemsQuery, AdminShopItemsQueryVariables>(AdminShopItemsDocument, options);
      }
export function useAdminShopItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminShopItemsQuery, AdminShopItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminShopItemsQuery, AdminShopItemsQueryVariables>(AdminShopItemsDocument, options);
        }
export type AdminShopItemsQueryHookResult = ReturnType<typeof useAdminShopItemsQuery>;
export type AdminShopItemsLazyQueryHookResult = ReturnType<typeof useAdminShopItemsLazyQuery>;
export type AdminShopItemsQueryResult = Apollo.QueryResult<AdminShopItemsQuery, AdminShopItemsQueryVariables>;
export const AdminShopItemDocument = gql`
    query AdminShopItem($id: uuid!) {
  item: shop_item_by_pk(id: $id) {
    ...AdminShopItem
  }
  owners: user(where: {isAdmin: {_eq: true}}) {
    ...AdminShopItemOwner
  }
}
    ${AdminShopItemFragmentDoc}
${AdminShopItemOwnerFragmentDoc}`;

/**
 * __useAdminShopItemQuery__
 *
 * To run a query within a React component, call `useAdminShopItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminShopItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminShopItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminShopItemQuery(baseOptions: Apollo.QueryHookOptions<AdminShopItemQuery, AdminShopItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminShopItemQuery, AdminShopItemQueryVariables>(AdminShopItemDocument, options);
      }
export function useAdminShopItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminShopItemQuery, AdminShopItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminShopItemQuery, AdminShopItemQueryVariables>(AdminShopItemDocument, options);
        }
export type AdminShopItemQueryHookResult = ReturnType<typeof useAdminShopItemQuery>;
export type AdminShopItemLazyQueryHookResult = ReturnType<typeof useAdminShopItemLazyQuery>;
export type AdminShopItemQueryResult = Apollo.QueryResult<AdminShopItemQuery, AdminShopItemQueryVariables>;
export const AdminShopItemOwnersDocument = gql`
    query AdminShopItemOwners {
  owners: user(where: {isAdmin: {_eq: true}}) {
    ...AdminShopItemOwner
  }
}
    ${AdminShopItemOwnerFragmentDoc}`;

/**
 * __useAdminShopItemOwnersQuery__
 *
 * To run a query within a React component, call `useAdminShopItemOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminShopItemOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminShopItemOwnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminShopItemOwnersQuery(baseOptions?: Apollo.QueryHookOptions<AdminShopItemOwnersQuery, AdminShopItemOwnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminShopItemOwnersQuery, AdminShopItemOwnersQueryVariables>(AdminShopItemOwnersDocument, options);
      }
export function useAdminShopItemOwnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminShopItemOwnersQuery, AdminShopItemOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminShopItemOwnersQuery, AdminShopItemOwnersQueryVariables>(AdminShopItemOwnersDocument, options);
        }
export type AdminShopItemOwnersQueryHookResult = ReturnType<typeof useAdminShopItemOwnersQuery>;
export type AdminShopItemOwnersLazyQueryHookResult = ReturnType<typeof useAdminShopItemOwnersLazyQuery>;
export type AdminShopItemOwnersQueryResult = Apollo.QueryResult<AdminShopItemOwnersQuery, AdminShopItemOwnersQueryVariables>;
export const UpdateAdminShopItemDocument = gql`
    mutation UpdateAdminShopItem($id: uuid!, $object: shop_item_set_input!) {
  item: update_shop_item_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...AdminShopItem
  }
}
    ${AdminShopItemFragmentDoc}`;
export type UpdateAdminShopItemMutationFn = Apollo.MutationFunction<UpdateAdminShopItemMutation, UpdateAdminShopItemMutationVariables>;

/**
 * __useUpdateAdminShopItemMutation__
 *
 * To run a mutation, you first call `useUpdateAdminShopItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminShopItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminShopItemMutation, { data, loading, error }] = useUpdateAdminShopItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpdateAdminShopItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminShopItemMutation, UpdateAdminShopItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminShopItemMutation, UpdateAdminShopItemMutationVariables>(UpdateAdminShopItemDocument, options);
      }
export type UpdateAdminShopItemMutationHookResult = ReturnType<typeof useUpdateAdminShopItemMutation>;
export type UpdateAdminShopItemMutationResult = Apollo.MutationResult<UpdateAdminShopItemMutation>;
export type UpdateAdminShopItemMutationOptions = Apollo.BaseMutationOptions<UpdateAdminShopItemMutation, UpdateAdminShopItemMutationVariables>;
export const CreateAdminShopItemDocument = gql`
    mutation CreateAdminShopItem($object: shop_item_insert_input!) {
  item: insert_shop_item_one(object: $object) {
    ...AdminShopItem
  }
}
    ${AdminShopItemFragmentDoc}`;
export type CreateAdminShopItemMutationFn = Apollo.MutationFunction<CreateAdminShopItemMutation, CreateAdminShopItemMutationVariables>;

/**
 * __useCreateAdminShopItemMutation__
 *
 * To run a mutation, you first call `useCreateAdminShopItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminShopItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminShopItemMutation, { data, loading, error }] = useCreateAdminShopItemMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useCreateAdminShopItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminShopItemMutation, CreateAdminShopItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminShopItemMutation, CreateAdminShopItemMutationVariables>(CreateAdminShopItemDocument, options);
      }
export type CreateAdminShopItemMutationHookResult = ReturnType<typeof useCreateAdminShopItemMutation>;
export type CreateAdminShopItemMutationResult = Apollo.MutationResult<CreateAdminShopItemMutation>;
export type CreateAdminShopItemMutationOptions = Apollo.BaseMutationOptions<CreateAdminShopItemMutation, CreateAdminShopItemMutationVariables>;
export const AdminShopPurchasesDocument = gql`
    query AdminShopPurchases($limit: Int!, $offset: Int!) {
  purchases: shop_item_purchase(
    limit: $limit
    offset: $offset
    order_by: {createdAt: desc}
  ) {
    ...AdminShopItemPurchase
  }
}
    ${AdminShopItemPurchaseFragmentDoc}`;

/**
 * __useAdminShopPurchasesQuery__
 *
 * To run a query within a React component, call `useAdminShopPurchasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminShopPurchasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminShopPurchasesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAdminShopPurchasesQuery(baseOptions: Apollo.QueryHookOptions<AdminShopPurchasesQuery, AdminShopPurchasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminShopPurchasesQuery, AdminShopPurchasesQueryVariables>(AdminShopPurchasesDocument, options);
      }
export function useAdminShopPurchasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminShopPurchasesQuery, AdminShopPurchasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminShopPurchasesQuery, AdminShopPurchasesQueryVariables>(AdminShopPurchasesDocument, options);
        }
export type AdminShopPurchasesQueryHookResult = ReturnType<typeof useAdminShopPurchasesQuery>;
export type AdminShopPurchasesLazyQueryHookResult = ReturnType<typeof useAdminShopPurchasesLazyQuery>;
export type AdminShopPurchasesQueryResult = Apollo.QueryResult<AdminShopPurchasesQuery, AdminShopPurchasesQueryVariables>;
export const GetRejectUserByIdDocument = gql`
    query GetRejectUserById($userId: String!) {
  user: user_by_pk(firestoreId: $userId) {
    firstName
    lastName
  }
}
    `;

/**
 * __useGetRejectUserByIdQuery__
 *
 * To run a query within a React component, call `useGetRejectUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRejectUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRejectUserByIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetRejectUserByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRejectUserByIdQuery, GetRejectUserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRejectUserByIdQuery, GetRejectUserByIdQueryVariables>(GetRejectUserByIdDocument, options);
      }
export function useGetRejectUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRejectUserByIdQuery, GetRejectUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRejectUserByIdQuery, GetRejectUserByIdQueryVariables>(GetRejectUserByIdDocument, options);
        }
export type GetRejectUserByIdQueryHookResult = ReturnType<typeof useGetRejectUserByIdQuery>;
export type GetRejectUserByIdLazyQueryHookResult = ReturnType<typeof useGetRejectUserByIdLazyQuery>;
export type GetRejectUserByIdQueryResult = Apollo.QueryResult<GetRejectUserByIdQuery, GetRejectUserByIdQueryVariables>;
export const SubmissionLearnerFilterUsersDocument = gql`
    query SubmissionLearnerFilterUsers($userIds: [String!]!) {
  user(where: {firestoreId: {_in: $userIds}}) {
    id: firestoreId
    username
    firstName
    lastName
  }
}
    `;

/**
 * __useSubmissionLearnerFilterUsersQuery__
 *
 * To run a query within a React component, call `useSubmissionLearnerFilterUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmissionLearnerFilterUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmissionLearnerFilterUsersQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useSubmissionLearnerFilterUsersQuery(baseOptions: Apollo.QueryHookOptions<SubmissionLearnerFilterUsersQuery, SubmissionLearnerFilterUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubmissionLearnerFilterUsersQuery, SubmissionLearnerFilterUsersQueryVariables>(SubmissionLearnerFilterUsersDocument, options);
      }
export function useSubmissionLearnerFilterUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubmissionLearnerFilterUsersQuery, SubmissionLearnerFilterUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubmissionLearnerFilterUsersQuery, SubmissionLearnerFilterUsersQueryVariables>(SubmissionLearnerFilterUsersDocument, options);
        }
export type SubmissionLearnerFilterUsersQueryHookResult = ReturnType<typeof useSubmissionLearnerFilterUsersQuery>;
export type SubmissionLearnerFilterUsersLazyQueryHookResult = ReturnType<typeof useSubmissionLearnerFilterUsersLazyQuery>;
export type SubmissionLearnerFilterUsersQueryResult = Apollo.QueryResult<SubmissionLearnerFilterUsersQuery, SubmissionLearnerFilterUsersQueryVariables>;
export const AdminProjectsQueueDocument = gql`
    query AdminProjectsQueue($limit: Int!, $offset: Int!, $where: project_bool_exp) {
  projects: project(
    limit: $limit
    offset: $offset
    where: $where
    order_by: {createdAt: desc}
  ) {
    ...AdminProject
  }
}
    ${AdminProjectFragmentDoc}`;

/**
 * __useAdminProjectsQueueQuery__
 *
 * To run a query within a React component, call `useAdminProjectsQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProjectsQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProjectsQueueQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminProjectsQueueQuery(baseOptions: Apollo.QueryHookOptions<AdminProjectsQueueQuery, AdminProjectsQueueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminProjectsQueueQuery, AdminProjectsQueueQueryVariables>(AdminProjectsQueueDocument, options);
      }
export function useAdminProjectsQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminProjectsQueueQuery, AdminProjectsQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminProjectsQueueQuery, AdminProjectsQueueQueryVariables>(AdminProjectsQueueDocument, options);
        }
export type AdminProjectsQueueQueryHookResult = ReturnType<typeof useAdminProjectsQueueQuery>;
export type AdminProjectsQueueLazyQueryHookResult = ReturnType<typeof useAdminProjectsQueueLazyQuery>;
export type AdminProjectsQueueQueryResult = Apollo.QueryResult<AdminProjectsQueueQuery, AdminProjectsQueueQueryVariables>;
export const AdminProjectsQueueCountDocument = gql`
    query AdminProjectsQueueCount {
  projects: project_aggregate(
    where: {published: {_eq: false}, rejectedAt: {_eq: "-infinity"}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminProjectsQueueCountQuery__
 *
 * To run a query within a React component, call `useAdminProjectsQueueCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProjectsQueueCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProjectsQueueCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminProjectsQueueCountQuery(baseOptions?: Apollo.QueryHookOptions<AdminProjectsQueueCountQuery, AdminProjectsQueueCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminProjectsQueueCountQuery, AdminProjectsQueueCountQueryVariables>(AdminProjectsQueueCountDocument, options);
      }
export function useAdminProjectsQueueCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminProjectsQueueCountQuery, AdminProjectsQueueCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminProjectsQueueCountQuery, AdminProjectsQueueCountQueryVariables>(AdminProjectsQueueCountDocument, options);
        }
export type AdminProjectsQueueCountQueryHookResult = ReturnType<typeof useAdminProjectsQueueCountQuery>;
export type AdminProjectsQueueCountLazyQueryHookResult = ReturnType<typeof useAdminProjectsQueueCountLazyQuery>;
export type AdminProjectsQueueCountQueryResult = Apollo.QueryResult<AdminProjectsQueueCountQuery, AdminProjectsQueueCountQueryVariables>;
export const AdminProjectsDocument = gql`
    query AdminProjects($limit: Int = 20, $offset: Int = 0, $responseTypes: [String!] = ["text", "video"], $userIdInput: String_comparison_exp, $pathInput: path_bool_exp = {}, $pathIdInput: bigint_comparison_exp, $rejectedAtInput: timestamptz_comparison_exp, $published: Boolean_comparison_exp) {
  projects: project(
    limit: $limit
    offset: $offset
    order_by: {createdAt: desc}
    where: {rejectedAt: $rejectedAtInput, node: {pathId: $pathIdInput, path: $pathInput}, published: $published, userId: $userIdInput}
  ) {
    ...AdminProject
  }
}
    ${AdminProjectFragmentDoc}`;

/**
 * __useAdminProjectsQuery__
 *
 * To run a query within a React component, call `useAdminProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProjectsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      responseTypes: // value for 'responseTypes'
 *      userIdInput: // value for 'userIdInput'
 *      pathInput: // value for 'pathInput'
 *      pathIdInput: // value for 'pathIdInput'
 *      rejectedAtInput: // value for 'rejectedAtInput'
 *      published: // value for 'published'
 *   },
 * });
 */
export function useAdminProjectsQuery(baseOptions?: Apollo.QueryHookOptions<AdminProjectsQuery, AdminProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminProjectsQuery, AdminProjectsQueryVariables>(AdminProjectsDocument, options);
      }
export function useAdminProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminProjectsQuery, AdminProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminProjectsQuery, AdminProjectsQueryVariables>(AdminProjectsDocument, options);
        }
export type AdminProjectsQueryHookResult = ReturnType<typeof useAdminProjectsQuery>;
export type AdminProjectsLazyQueryHookResult = ReturnType<typeof useAdminProjectsLazyQuery>;
export type AdminProjectsQueryResult = Apollo.QueryResult<AdminProjectsQuery, AdminProjectsQueryVariables>;
export const GetPathByProjectIdDocument = gql`
    query GetPathByProjectId($projectId: uuid!) {
  project: project_by_pk(id: $projectId) {
    ...adminProjectPath
  }
}
    ${AdminProjectPathFragmentDoc}`;

/**
 * __useGetPathByProjectIdQuery__
 *
 * To run a query within a React component, call `useGetPathByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPathByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPathByProjectIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetPathByProjectIdQuery(baseOptions: Apollo.QueryHookOptions<GetPathByProjectIdQuery, GetPathByProjectIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPathByProjectIdQuery, GetPathByProjectIdQueryVariables>(GetPathByProjectIdDocument, options);
      }
export function useGetPathByProjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPathByProjectIdQuery, GetPathByProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPathByProjectIdQuery, GetPathByProjectIdQueryVariables>(GetPathByProjectIdDocument, options);
        }
export type GetPathByProjectIdQueryHookResult = ReturnType<typeof useGetPathByProjectIdQuery>;
export type GetPathByProjectIdLazyQueryHookResult = ReturnType<typeof useGetPathByProjectIdLazyQuery>;
export type GetPathByProjectIdQueryResult = Apollo.QueryResult<GetPathByProjectIdQuery, GetPathByProjectIdQueryVariables>;
export const AdminPublishProjectDocument = gql`
    mutation AdminPublishProject($projectId: uuid!) {
  update_project_by_pk(pk_columns: {id: $projectId}, _set: {published: true}) {
    id
  }
}
    `;
export type AdminPublishProjectMutationFn = Apollo.MutationFunction<AdminPublishProjectMutation, AdminPublishProjectMutationVariables>;

/**
 * __useAdminPublishProjectMutation__
 *
 * To run a mutation, you first call `useAdminPublishProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminPublishProjectMutation, { data, loading, error }] = useAdminPublishProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useAdminPublishProjectMutation(baseOptions?: Apollo.MutationHookOptions<AdminPublishProjectMutation, AdminPublishProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminPublishProjectMutation, AdminPublishProjectMutationVariables>(AdminPublishProjectDocument, options);
      }
export type AdminPublishProjectMutationHookResult = ReturnType<typeof useAdminPublishProjectMutation>;
export type AdminPublishProjectMutationResult = Apollo.MutationResult<AdminPublishProjectMutation>;
export type AdminPublishProjectMutationOptions = Apollo.BaseMutationOptions<AdminPublishProjectMutation, AdminPublishProjectMutationVariables>;
export const UsernameSearchDocument = gql`
    query UsernameSearch($username: String!) {
  user(where: {username: {_eq: $username}}) {
    id: firestoreId
  }
}
    `;

/**
 * __useUsernameSearchQuery__
 *
 * To run a query within a React component, call `useUsernameSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsernameSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsernameSearchQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useUsernameSearchQuery(baseOptions: Apollo.QueryHookOptions<UsernameSearchQuery, UsernameSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsernameSearchQuery, UsernameSearchQueryVariables>(UsernameSearchDocument, options);
      }
export function useUsernameSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsernameSearchQuery, UsernameSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsernameSearchQuery, UsernameSearchQueryVariables>(UsernameSearchDocument, options);
        }
export type UsernameSearchQueryHookResult = ReturnType<typeof useUsernameSearchQuery>;
export type UsernameSearchLazyQueryHookResult = ReturnType<typeof useUsernameSearchLazyQuery>;
export type UsernameSearchQueryResult = Apollo.QueryResult<UsernameSearchQuery, UsernameSearchQueryVariables>;
export const ProjectFeedbackDocument = gql`
    query ProjectFeedback($limit: Int!, $offset: Int!) {
  projects: project(
    limit: $limit
    offset: $offset
    where: {rejectedAt: {_neq: "-infinity"}, rejectedByUser: {isMod: {_eq: false}}, rejectedFeedback: {_is_null: false, _neq: ""}}
    order_by: {rejectedAt: desc}
  ) {
    id
    rejectedAt
    rejectedReason
    rejectedFeedback
    rejectedByUser {
      id: firestoreId
      userType
      avatar
      username
      isEducator
      firstName
      lastName
      creatorLevel
    }
    node {
      id
      title
      caption
      path {
        slug
      }
    }
  }
}
    `;

/**
 * __useProjectFeedbackQuery__
 *
 * To run a query within a React component, call `useProjectFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectFeedbackQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useProjectFeedbackQuery(baseOptions: Apollo.QueryHookOptions<ProjectFeedbackQuery, ProjectFeedbackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectFeedbackQuery, ProjectFeedbackQueryVariables>(ProjectFeedbackDocument, options);
      }
export function useProjectFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectFeedbackQuery, ProjectFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectFeedbackQuery, ProjectFeedbackQueryVariables>(ProjectFeedbackDocument, options);
        }
export type ProjectFeedbackQueryHookResult = ReturnType<typeof useProjectFeedbackQuery>;
export type ProjectFeedbackLazyQueryHookResult = ReturnType<typeof useProjectFeedbackLazyQuery>;
export type ProjectFeedbackQueryResult = Apollo.QueryResult<ProjectFeedbackQuery, ProjectFeedbackQueryVariables>;
export const AdminUsersCoinBalanceByUserDocument = gql`
    query AdminUsersCoinBalanceByUser($userId: String!) {
  coin_trx(
    offset: 0
    where: {userId: {_eq: $userId}}
    order_by: {createdAt: desc}
    limit: 1
  ) {
    id
    userId
    balance
  }
}
    `;

/**
 * __useAdminUsersCoinBalanceByUserQuery__
 *
 * To run a query within a React component, call `useAdminUsersCoinBalanceByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUsersCoinBalanceByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUsersCoinBalanceByUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminUsersCoinBalanceByUserQuery(baseOptions: Apollo.QueryHookOptions<AdminUsersCoinBalanceByUserQuery, AdminUsersCoinBalanceByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUsersCoinBalanceByUserQuery, AdminUsersCoinBalanceByUserQueryVariables>(AdminUsersCoinBalanceByUserDocument, options);
      }
export function useAdminUsersCoinBalanceByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUsersCoinBalanceByUserQuery, AdminUsersCoinBalanceByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUsersCoinBalanceByUserQuery, AdminUsersCoinBalanceByUserQueryVariables>(AdminUsersCoinBalanceByUserDocument, options);
        }
export type AdminUsersCoinBalanceByUserQueryHookResult = ReturnType<typeof useAdminUsersCoinBalanceByUserQuery>;
export type AdminUsersCoinBalanceByUserLazyQueryHookResult = ReturnType<typeof useAdminUsersCoinBalanceByUserLazyQuery>;
export type AdminUsersCoinBalanceByUserQueryResult = Apollo.QueryResult<AdminUsersCoinBalanceByUserQuery, AdminUsersCoinBalanceByUserQueryVariables>;
export const AdminDashboardClassroomsByTeacherIdDocument = gql`
    query AdminDashboardClassroomsByTeacherId($teacherUserId: String!) {
  learnerGroups: learner_group(
    where: {members: {role: {_eq: "teacher"}, userId: {_eq: $teacherUserId}}}
    order_by: {createdAt: desc}
  ) {
    ...AdminDashboardLearnerGroup
  }
}
    ${AdminDashboardLearnerGroupFragmentDoc}`;

/**
 * __useAdminDashboardClassroomsByTeacherIdQuery__
 *
 * To run a query within a React component, call `useAdminDashboardClassroomsByTeacherIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminDashboardClassroomsByTeacherIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminDashboardClassroomsByTeacherIdQuery({
 *   variables: {
 *      teacherUserId: // value for 'teacherUserId'
 *   },
 * });
 */
export function useAdminDashboardClassroomsByTeacherIdQuery(baseOptions: Apollo.QueryHookOptions<AdminDashboardClassroomsByTeacherIdQuery, AdminDashboardClassroomsByTeacherIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminDashboardClassroomsByTeacherIdQuery, AdminDashboardClassroomsByTeacherIdQueryVariables>(AdminDashboardClassroomsByTeacherIdDocument, options);
      }
export function useAdminDashboardClassroomsByTeacherIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminDashboardClassroomsByTeacherIdQuery, AdminDashboardClassroomsByTeacherIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminDashboardClassroomsByTeacherIdQuery, AdminDashboardClassroomsByTeacherIdQueryVariables>(AdminDashboardClassroomsByTeacherIdDocument, options);
        }
export type AdminDashboardClassroomsByTeacherIdQueryHookResult = ReturnType<typeof useAdminDashboardClassroomsByTeacherIdQuery>;
export type AdminDashboardClassroomsByTeacherIdLazyQueryHookResult = ReturnType<typeof useAdminDashboardClassroomsByTeacherIdLazyQuery>;
export type AdminDashboardClassroomsByTeacherIdQueryResult = Apollo.QueryResult<AdminDashboardClassroomsByTeacherIdQuery, AdminDashboardClassroomsByTeacherIdQueryVariables>;
export const AdminDashboardCreateClassroomDocument = gql`
    mutation AdminDashboardCreateClassroom($name: String!, $numStudents: Int!, $orgId: String!, $userId: String!, $code: String!, $color: String!) {
  adminCreateClassroom: insert_learner_group_one(
    object: {name: $name, orgId: $orgId, type: "Classroom", members: {data: {isOwner: true, userId: $userId, role: "teacher"}}, educatorCodes: {data: {available: $numStudents, code: $code}}, color: $color}
  ) {
    ...AdminDashboardLearnerGroup
  }
}
    ${AdminDashboardLearnerGroupFragmentDoc}`;
export type AdminDashboardCreateClassroomMutationFn = Apollo.MutationFunction<AdminDashboardCreateClassroomMutation, AdminDashboardCreateClassroomMutationVariables>;

/**
 * __useAdminDashboardCreateClassroomMutation__
 *
 * To run a mutation, you first call `useAdminDashboardCreateClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDashboardCreateClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDashboardCreateClassroomMutation, { data, loading, error }] = useAdminDashboardCreateClassroomMutation({
 *   variables: {
 *      name: // value for 'name'
 *      numStudents: // value for 'numStudents'
 *      orgId: // value for 'orgId'
 *      userId: // value for 'userId'
 *      code: // value for 'code'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useAdminDashboardCreateClassroomMutation(baseOptions?: Apollo.MutationHookOptions<AdminDashboardCreateClassroomMutation, AdminDashboardCreateClassroomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDashboardCreateClassroomMutation, AdminDashboardCreateClassroomMutationVariables>(AdminDashboardCreateClassroomDocument, options);
      }
export type AdminDashboardCreateClassroomMutationHookResult = ReturnType<typeof useAdminDashboardCreateClassroomMutation>;
export type AdminDashboardCreateClassroomMutationResult = Apollo.MutationResult<AdminDashboardCreateClassroomMutation>;
export type AdminDashboardCreateClassroomMutationOptions = Apollo.BaseMutationOptions<AdminDashboardCreateClassroomMutation, AdminDashboardCreateClassroomMutationVariables>;
export const AdminDashboardCreateEducatorCodeDocument = gql`
    mutation AdminDashboardCreateEducatorCode($code: String!, $available: Int!, $learnerGroupId: uuid!) {
  adminCreateClassroomCode: insert_educator_code_one(
    object: {available: $available, code: $code, learnerGroupId: $learnerGroupId}
  ) {
    ...AdminDashboardEducatorCode
  }
}
    ${AdminDashboardEducatorCodeFragmentDoc}`;
export type AdminDashboardCreateEducatorCodeMutationFn = Apollo.MutationFunction<AdminDashboardCreateEducatorCodeMutation, AdminDashboardCreateEducatorCodeMutationVariables>;

/**
 * __useAdminDashboardCreateEducatorCodeMutation__
 *
 * To run a mutation, you first call `useAdminDashboardCreateEducatorCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDashboardCreateEducatorCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDashboardCreateEducatorCodeMutation, { data, loading, error }] = useAdminDashboardCreateEducatorCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      available: // value for 'available'
 *      learnerGroupId: // value for 'learnerGroupId'
 *   },
 * });
 */
export function useAdminDashboardCreateEducatorCodeMutation(baseOptions?: Apollo.MutationHookOptions<AdminDashboardCreateEducatorCodeMutation, AdminDashboardCreateEducatorCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDashboardCreateEducatorCodeMutation, AdminDashboardCreateEducatorCodeMutationVariables>(AdminDashboardCreateEducatorCodeDocument, options);
      }
export type AdminDashboardCreateEducatorCodeMutationHookResult = ReturnType<typeof useAdminDashboardCreateEducatorCodeMutation>;
export type AdminDashboardCreateEducatorCodeMutationResult = Apollo.MutationResult<AdminDashboardCreateEducatorCodeMutation>;
export type AdminDashboardCreateEducatorCodeMutationOptions = Apollo.BaseMutationOptions<AdminDashboardCreateEducatorCodeMutation, AdminDashboardCreateEducatorCodeMutationVariables>;
export const AdminDashboardDeleteEducatorCodeDocument = gql`
    mutation AdminDashboardDeleteEducatorCode($code: String!) {
  adminDeleteClassroomCode: delete_educator_code_by_pk(code: $code) {
    code
  }
}
    `;
export type AdminDashboardDeleteEducatorCodeMutationFn = Apollo.MutationFunction<AdminDashboardDeleteEducatorCodeMutation, AdminDashboardDeleteEducatorCodeMutationVariables>;

/**
 * __useAdminDashboardDeleteEducatorCodeMutation__
 *
 * To run a mutation, you first call `useAdminDashboardDeleteEducatorCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDashboardDeleteEducatorCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDashboardDeleteEducatorCodeMutation, { data, loading, error }] = useAdminDashboardDeleteEducatorCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useAdminDashboardDeleteEducatorCodeMutation(baseOptions?: Apollo.MutationHookOptions<AdminDashboardDeleteEducatorCodeMutation, AdminDashboardDeleteEducatorCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDashboardDeleteEducatorCodeMutation, AdminDashboardDeleteEducatorCodeMutationVariables>(AdminDashboardDeleteEducatorCodeDocument, options);
      }
export type AdminDashboardDeleteEducatorCodeMutationHookResult = ReturnType<typeof useAdminDashboardDeleteEducatorCodeMutation>;
export type AdminDashboardDeleteEducatorCodeMutationResult = Apollo.MutationResult<AdminDashboardDeleteEducatorCodeMutation>;
export type AdminDashboardDeleteEducatorCodeMutationOptions = Apollo.BaseMutationOptions<AdminDashboardDeleteEducatorCodeMutation, AdminDashboardDeleteEducatorCodeMutationVariables>;
export const AdminAddCoTeacherDocument = gql`
    mutation AdminAddCoTeacher($learnerGroupId: uuid!, $userId: String!) {
  adminAddCoTeacher: insert_learner_group_member_one(
    object: {learnerGroupId: $learnerGroupId, userId: $userId, role: "teacher"}
  ) {
    ...AdminLearnerGroupMember
  }
}
    ${AdminLearnerGroupMemberFragmentDoc}`;
export type AdminAddCoTeacherMutationFn = Apollo.MutationFunction<AdminAddCoTeacherMutation, AdminAddCoTeacherMutationVariables>;

/**
 * __useAdminAddCoTeacherMutation__
 *
 * To run a mutation, you first call `useAdminAddCoTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAddCoTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAddCoTeacherMutation, { data, loading, error }] = useAdminAddCoTeacherMutation({
 *   variables: {
 *      learnerGroupId: // value for 'learnerGroupId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminAddCoTeacherMutation(baseOptions?: Apollo.MutationHookOptions<AdminAddCoTeacherMutation, AdminAddCoTeacherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAddCoTeacherMutation, AdminAddCoTeacherMutationVariables>(AdminAddCoTeacherDocument, options);
      }
export type AdminAddCoTeacherMutationHookResult = ReturnType<typeof useAdminAddCoTeacherMutation>;
export type AdminAddCoTeacherMutationResult = Apollo.MutationResult<AdminAddCoTeacherMutation>;
export type AdminAddCoTeacherMutationOptions = Apollo.BaseMutationOptions<AdminAddCoTeacherMutation, AdminAddCoTeacherMutationVariables>;
export const AdminRemoveCoTeacherDocument = gql`
    mutation AdminRemoveCoTeacher($learnerGroupId: uuid!, $userId: String!) {
  adminRemoveCoTeacher: delete_learner_group_member(
    where: {learnerGroupId: {_eq: $learnerGroupId}, userId: {_eq: $userId}}
  ) {
    returning {
      learnerGroupId
      userId
    }
  }
}
    `;
export type AdminRemoveCoTeacherMutationFn = Apollo.MutationFunction<AdminRemoveCoTeacherMutation, AdminRemoveCoTeacherMutationVariables>;

/**
 * __useAdminRemoveCoTeacherMutation__
 *
 * To run a mutation, you first call `useAdminRemoveCoTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRemoveCoTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRemoveCoTeacherMutation, { data, loading, error }] = useAdminRemoveCoTeacherMutation({
 *   variables: {
 *      learnerGroupId: // value for 'learnerGroupId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminRemoveCoTeacherMutation(baseOptions?: Apollo.MutationHookOptions<AdminRemoveCoTeacherMutation, AdminRemoveCoTeacherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRemoveCoTeacherMutation, AdminRemoveCoTeacherMutationVariables>(AdminRemoveCoTeacherDocument, options);
      }
export type AdminRemoveCoTeacherMutationHookResult = ReturnType<typeof useAdminRemoveCoTeacherMutation>;
export type AdminRemoveCoTeacherMutationResult = Apollo.MutationResult<AdminRemoveCoTeacherMutation>;
export type AdminRemoveCoTeacherMutationOptions = Apollo.BaseMutationOptions<AdminRemoveCoTeacherMutation, AdminRemoveCoTeacherMutationVariables>;
export const AdminArchiveClassroomDocument = gql`
    mutation AdminArchiveClassroom($learnerGroupId: uuid!, $archivedAt: timestamptz!) {
  update_learner_group_by_pk(
    pk_columns: {id: $learnerGroupId}
    _set: {archivedAt: $archivedAt}
  ) {
    id
    archivedAt
  }
}
    `;
export type AdminArchiveClassroomMutationFn = Apollo.MutationFunction<AdminArchiveClassroomMutation, AdminArchiveClassroomMutationVariables>;

/**
 * __useAdminArchiveClassroomMutation__
 *
 * To run a mutation, you first call `useAdminArchiveClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminArchiveClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminArchiveClassroomMutation, { data, loading, error }] = useAdminArchiveClassroomMutation({
 *   variables: {
 *      learnerGroupId: // value for 'learnerGroupId'
 *      archivedAt: // value for 'archivedAt'
 *   },
 * });
 */
export function useAdminArchiveClassroomMutation(baseOptions?: Apollo.MutationHookOptions<AdminArchiveClassroomMutation, AdminArchiveClassroomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminArchiveClassroomMutation, AdminArchiveClassroomMutationVariables>(AdminArchiveClassroomDocument, options);
      }
export type AdminArchiveClassroomMutationHookResult = ReturnType<typeof useAdminArchiveClassroomMutation>;
export type AdminArchiveClassroomMutationResult = Apollo.MutationResult<AdminArchiveClassroomMutation>;
export type AdminArchiveClassroomMutationOptions = Apollo.BaseMutationOptions<AdminArchiveClassroomMutation, AdminArchiveClassroomMutationVariables>;
export const GetAdminDashboardUserDocument = gql`
    query GetAdminDashboardUser($userId: String!) {
  user_by_pk(firestoreId: $userId) {
    ...AdminDashboardUserAccount
  }
}
    ${AdminDashboardUserAccountFragmentDoc}`;

/**
 * __useGetAdminDashboardUserQuery__
 *
 * To run a query within a React component, call `useGetAdminDashboardUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminDashboardUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminDashboardUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetAdminDashboardUserQuery(baseOptions: Apollo.QueryHookOptions<GetAdminDashboardUserQuery, GetAdminDashboardUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminDashboardUserQuery, GetAdminDashboardUserQueryVariables>(GetAdminDashboardUserDocument, options);
      }
export function useGetAdminDashboardUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminDashboardUserQuery, GetAdminDashboardUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminDashboardUserQuery, GetAdminDashboardUserQueryVariables>(GetAdminDashboardUserDocument, options);
        }
export type GetAdminDashboardUserQueryHookResult = ReturnType<typeof useGetAdminDashboardUserQuery>;
export type GetAdminDashboardUserLazyQueryHookResult = ReturnType<typeof useGetAdminDashboardUserLazyQuery>;
export type GetAdminDashboardUserQueryResult = Apollo.QueryResult<GetAdminDashboardUserQuery, GetAdminDashboardUserQueryVariables>;
export const GetAdminDashboardUsersDocument = gql`
    query GetAdminDashboardUsers($limit: Int = 100, $offset: Int = 0, $where: user_bool_exp!) {
  adminDashboardUsers: user(
    limit: $limit
    offset: $offset
    order_by: {createdAt: desc}
    where: $where
  ) {
    ...AdminDashboardUserAccount
  }
}
    ${AdminDashboardUserAccountFragmentDoc}`;

/**
 * __useGetAdminDashboardUsersQuery__
 *
 * To run a query within a React component, call `useGetAdminDashboardUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminDashboardUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminDashboardUsersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAdminDashboardUsersQuery(baseOptions: Apollo.QueryHookOptions<GetAdminDashboardUsersQuery, GetAdminDashboardUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminDashboardUsersQuery, GetAdminDashboardUsersQueryVariables>(GetAdminDashboardUsersDocument, options);
      }
export function useGetAdminDashboardUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminDashboardUsersQuery, GetAdminDashboardUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminDashboardUsersQuery, GetAdminDashboardUsersQueryVariables>(GetAdminDashboardUsersDocument, options);
        }
export type GetAdminDashboardUsersQueryHookResult = ReturnType<typeof useGetAdminDashboardUsersQuery>;
export type GetAdminDashboardUsersLazyQueryHookResult = ReturnType<typeof useGetAdminDashboardUsersLazyQuery>;
export type GetAdminDashboardUsersQueryResult = Apollo.QueryResult<GetAdminDashboardUsersQuery, GetAdminDashboardUsersQueryVariables>;
export const DisableUserDocument = gql`
    mutation DisableUser($userId: String!, $disabled: Boolean!) {
  api_disable_user(input: {userId: $userId, disabled: $disabled}) {
    userId
    disabled
  }
}
    `;
export type DisableUserMutationFn = Apollo.MutationFunction<DisableUserMutation, DisableUserMutationVariables>;

/**
 * __useDisableUserMutation__
 *
 * To run a mutation, you first call `useDisableUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableUserMutation, { data, loading, error }] = useDisableUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      disabled: // value for 'disabled'
 *   },
 * });
 */
export function useDisableUserMutation(baseOptions?: Apollo.MutationHookOptions<DisableUserMutation, DisableUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableUserMutation, DisableUserMutationVariables>(DisableUserDocument, options);
      }
export type DisableUserMutationHookResult = ReturnType<typeof useDisableUserMutation>;
export type DisableUserMutationResult = Apollo.MutationResult<DisableUserMutation>;
export type DisableUserMutationOptions = Apollo.BaseMutationOptions<DisableUserMutation, DisableUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($userId: String!) {
  api_delete_user(userId: $userId)
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const UpdateUserCreatorLevelDocument = gql`
    mutation UpdateUserCreatorLevel($userId: String!, $creatorLevel: String!) {
  update_user_by_pk(
    pk_columns: {firestoreId: $userId}
    _set: {creatorLevel: $creatorLevel}
  ) {
    ...AdminDashboardUserAccount
  }
}
    ${AdminDashboardUserAccountFragmentDoc}`;
export type UpdateUserCreatorLevelMutationFn = Apollo.MutationFunction<UpdateUserCreatorLevelMutation, UpdateUserCreatorLevelMutationVariables>;

/**
 * __useUpdateUserCreatorLevelMutation__
 *
 * To run a mutation, you first call `useUpdateUserCreatorLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserCreatorLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserCreatorLevelMutation, { data, loading, error }] = useUpdateUserCreatorLevelMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      creatorLevel: // value for 'creatorLevel'
 *   },
 * });
 */
export function useUpdateUserCreatorLevelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserCreatorLevelMutation, UpdateUserCreatorLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserCreatorLevelMutation, UpdateUserCreatorLevelMutationVariables>(UpdateUserCreatorLevelDocument, options);
      }
export type UpdateUserCreatorLevelMutationHookResult = ReturnType<typeof useUpdateUserCreatorLevelMutation>;
export type UpdateUserCreatorLevelMutationResult = Apollo.MutationResult<UpdateUserCreatorLevelMutation>;
export type UpdateUserCreatorLevelMutationOptions = Apollo.BaseMutationOptions<UpdateUserCreatorLevelMutation, UpdateUserCreatorLevelMutationVariables>;
export const AdminDashboardUpdateUserProfileDocument = gql`
    mutation AdminDashboardUpdateUserProfile($userId: String!, $username: String!, $firstName: String!, $avatar: String!, $lastName: String, $bio: String) {
  update_user_by_pk(
    pk_columns: {firestoreId: $userId}
    _set: {avatar: $avatar, username: $username, firstName: $firstName, lastName: $lastName, bio: $bio}
  ) {
    ...AdminDashboardUserAccount
  }
}
    ${AdminDashboardUserAccountFragmentDoc}`;
export type AdminDashboardUpdateUserProfileMutationFn = Apollo.MutationFunction<AdminDashboardUpdateUserProfileMutation, AdminDashboardUpdateUserProfileMutationVariables>;

/**
 * __useAdminDashboardUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useAdminDashboardUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDashboardUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDashboardUpdateUserProfileMutation, { data, loading, error }] = useAdminDashboardUpdateUserProfileMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      username: // value for 'username'
 *      firstName: // value for 'firstName'
 *      avatar: // value for 'avatar'
 *      lastName: // value for 'lastName'
 *      bio: // value for 'bio'
 *   },
 * });
 */
export function useAdminDashboardUpdateUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<AdminDashboardUpdateUserProfileMutation, AdminDashboardUpdateUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDashboardUpdateUserProfileMutation, AdminDashboardUpdateUserProfileMutationVariables>(AdminDashboardUpdateUserProfileDocument, options);
      }
export type AdminDashboardUpdateUserProfileMutationHookResult = ReturnType<typeof useAdminDashboardUpdateUserProfileMutation>;
export type AdminDashboardUpdateUserProfileMutationResult = Apollo.MutationResult<AdminDashboardUpdateUserProfileMutation>;
export type AdminDashboardUpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<AdminDashboardUpdateUserProfileMutation, AdminDashboardUpdateUserProfileMutationVariables>;
export const AllOrganizationsDocument = gql`
    query AllOrganizations($offset: Int!) {
  organization(
    offset: $offset
    where: {status: {_eq: "Approved"}}
    order_by: {name: asc}
  ) {
    id: firestoreId
    name
    zip
  }
}
    `;

/**
 * __useAllOrganizationsQuery__
 *
 * To run a query within a React component, call `useAllOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllOrganizationsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAllOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<AllOrganizationsQuery, AllOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllOrganizationsQuery, AllOrganizationsQueryVariables>(AllOrganizationsDocument, options);
      }
export function useAllOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllOrganizationsQuery, AllOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllOrganizationsQuery, AllOrganizationsQueryVariables>(AllOrganizationsDocument, options);
        }
export type AllOrganizationsQueryHookResult = ReturnType<typeof useAllOrganizationsQuery>;
export type AllOrganizationsLazyQueryHookResult = ReturnType<typeof useAllOrganizationsLazyQuery>;
export type AllOrganizationsQueryResult = Apollo.QueryResult<AllOrganizationsQuery, AllOrganizationsQueryVariables>;
export const AdminUserCoinsLedgerDocument = gql`
    query AdminUserCoinsLedger($offset: Int!, $limit: Int!, $userId: String!) {
  coins: coin_trx(
    offset: $offset
    limit: $limit
    order_by: {createdAt: desc}
    where: {userId: {_eq: $userId}}
  ) {
    id
    userId
    amount
    balance
    category
    createdAt
  }
}
    `;

/**
 * __useAdminUserCoinsLedgerQuery__
 *
 * To run a query within a React component, call `useAdminUserCoinsLedgerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserCoinsLedgerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserCoinsLedgerQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminUserCoinsLedgerQuery(baseOptions: Apollo.QueryHookOptions<AdminUserCoinsLedgerQuery, AdminUserCoinsLedgerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUserCoinsLedgerQuery, AdminUserCoinsLedgerQueryVariables>(AdminUserCoinsLedgerDocument, options);
      }
export function useAdminUserCoinsLedgerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUserCoinsLedgerQuery, AdminUserCoinsLedgerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUserCoinsLedgerQuery, AdminUserCoinsLedgerQueryVariables>(AdminUserCoinsLedgerDocument, options);
        }
export type AdminUserCoinsLedgerQueryHookResult = ReturnType<typeof useAdminUserCoinsLedgerQuery>;
export type AdminUserCoinsLedgerLazyQueryHookResult = ReturnType<typeof useAdminUserCoinsLedgerLazyQuery>;
export type AdminUserCoinsLedgerQueryResult = Apollo.QueryResult<AdminUserCoinsLedgerQuery, AdminUserCoinsLedgerQueryVariables>;
export const AdminUserAdjustCoinsDocument = gql`
    mutation AdminUserAdjustCoins($userId: String!, $amount: Int!) {
  insert_coin_trx_one(
    object: {userId: $userId, amount: $amount, category: admin_adjustment}
  ) {
    id
  }
}
    `;
export type AdminUserAdjustCoinsMutationFn = Apollo.MutationFunction<AdminUserAdjustCoinsMutation, AdminUserAdjustCoinsMutationVariables>;

/**
 * __useAdminUserAdjustCoinsMutation__
 *
 * To run a mutation, you first call `useAdminUserAdjustCoinsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUserAdjustCoinsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUserAdjustCoinsMutation, { data, loading, error }] = useAdminUserAdjustCoinsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useAdminUserAdjustCoinsMutation(baseOptions?: Apollo.MutationHookOptions<AdminUserAdjustCoinsMutation, AdminUserAdjustCoinsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUserAdjustCoinsMutation, AdminUserAdjustCoinsMutationVariables>(AdminUserAdjustCoinsDocument, options);
      }
export type AdminUserAdjustCoinsMutationHookResult = ReturnType<typeof useAdminUserAdjustCoinsMutation>;
export type AdminUserAdjustCoinsMutationResult = Apollo.MutationResult<AdminUserAdjustCoinsMutation>;
export type AdminUserAdjustCoinsMutationOptions = Apollo.BaseMutationOptions<AdminUserAdjustCoinsMutation, AdminUserAdjustCoinsMutationVariables>;
export const AdminCreateKidInviteDocument = gql`
    mutation AdminCreateKidInvite($code: educator_code_insert_input!) {
  adminCreateKidInvite: insert_educator_code_one(object: $code) {
    available
    code
    createdAt
    expiresAt
  }
}
    `;
export type AdminCreateKidInviteMutationFn = Apollo.MutationFunction<AdminCreateKidInviteMutation, AdminCreateKidInviteMutationVariables>;

/**
 * __useAdminCreateKidInviteMutation__
 *
 * To run a mutation, you first call `useAdminCreateKidInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateKidInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateKidInviteMutation, { data, loading, error }] = useAdminCreateKidInviteMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useAdminCreateKidInviteMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateKidInviteMutation, AdminCreateKidInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateKidInviteMutation, AdminCreateKidInviteMutationVariables>(AdminCreateKidInviteDocument, options);
      }
export type AdminCreateKidInviteMutationHookResult = ReturnType<typeof useAdminCreateKidInviteMutation>;
export type AdminCreateKidInviteMutationResult = Apollo.MutationResult<AdminCreateKidInviteMutation>;
export type AdminCreateKidInviteMutationOptions = Apollo.BaseMutationOptions<AdminCreateKidInviteMutation, AdminCreateKidInviteMutationVariables>;
export const AdminEditKidInviteDocument = gql`
    mutation AdminEditKidInvite($code: String!, $available: Int!) {
  adminEditKidInvite: update_educator_code_by_pk(
    pk_columns: {code: $code}
    _set: {available: $available}
  ) {
    code
    available
  }
}
    `;
export type AdminEditKidInviteMutationFn = Apollo.MutationFunction<AdminEditKidInviteMutation, AdminEditKidInviteMutationVariables>;

/**
 * __useAdminEditKidInviteMutation__
 *
 * To run a mutation, you first call `useAdminEditKidInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEditKidInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEditKidInviteMutation, { data, loading, error }] = useAdminEditKidInviteMutation({
 *   variables: {
 *      code: // value for 'code'
 *      available: // value for 'available'
 *   },
 * });
 */
export function useAdminEditKidInviteMutation(baseOptions?: Apollo.MutationHookOptions<AdminEditKidInviteMutation, AdminEditKidInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminEditKidInviteMutation, AdminEditKidInviteMutationVariables>(AdminEditKidInviteDocument, options);
      }
export type AdminEditKidInviteMutationHookResult = ReturnType<typeof useAdminEditKidInviteMutation>;
export type AdminEditKidInviteMutationResult = Apollo.MutationResult<AdminEditKidInviteMutation>;
export type AdminEditKidInviteMutationOptions = Apollo.BaseMutationOptions<AdminEditKidInviteMutation, AdminEditKidInviteMutationVariables>;
export const CreatePathDocument = gql`
    mutation CreatePath($path: path_insert_input!) {
  insert_path_one(object: $path) {
    ...pathsByStatus
  }
}
    ${PathsByStatusFragmentDoc}`;
export type CreatePathMutationFn = Apollo.MutationFunction<CreatePathMutation, CreatePathMutationVariables>;

/**
 * __useCreatePathMutation__
 *
 * To run a mutation, you first call `useCreatePathMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePathMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPathMutation, { data, loading, error }] = useCreatePathMutation({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useCreatePathMutation(baseOptions?: Apollo.MutationHookOptions<CreatePathMutation, CreatePathMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePathMutation, CreatePathMutationVariables>(CreatePathDocument, options);
      }
export type CreatePathMutationHookResult = ReturnType<typeof useCreatePathMutation>;
export type CreatePathMutationResult = Apollo.MutationResult<CreatePathMutation>;
export type CreatePathMutationOptions = Apollo.BaseMutationOptions<CreatePathMutation, CreatePathMutationVariables>;
export const CreatePathNodeDocument = gql`
    mutation CreatePathNode($node: path_node_insert_input!) {
  insert_path_node_one(object: $node) {
    id
    pathId
    title
    caption
    createdAt
    lexorank
    responsesEnabled
    rewardAmount
  }
}
    `;
export type CreatePathNodeMutationFn = Apollo.MutationFunction<CreatePathNodeMutation, CreatePathNodeMutationVariables>;

/**
 * __useCreatePathNodeMutation__
 *
 * To run a mutation, you first call `useCreatePathNodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePathNodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPathNodeMutation, { data, loading, error }] = useCreatePathNodeMutation({
 *   variables: {
 *      node: // value for 'node'
 *   },
 * });
 */
export function useCreatePathNodeMutation(baseOptions?: Apollo.MutationHookOptions<CreatePathNodeMutation, CreatePathNodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePathNodeMutation, CreatePathNodeMutationVariables>(CreatePathNodeDocument, options);
      }
export type CreatePathNodeMutationHookResult = ReturnType<typeof useCreatePathNodeMutation>;
export type CreatePathNodeMutationResult = Apollo.MutationResult<CreatePathNodeMutation>;
export type CreatePathNodeMutationOptions = Apollo.BaseMutationOptions<CreatePathNodeMutation, CreatePathNodeMutationVariables>;
export const CreatorPathsDocument = gql`
    query CreatorPaths($offset: Int!, $status: String!, $authorId: String!, $limit: Int!, $orderBy: path_order_by!) {
  paths: path(
    offset: $offset
    limit: $limit
    where: {status: {_eq: $status}, _or: [{authorId: {_eq: $authorId}}, {authors: {userId: {_eq: $authorId}}}]}
    order_by: [$orderBy]
  ) {
    ...pathsByStatus
  }
}
    ${PathsByStatusFragmentDoc}`;

/**
 * __useCreatorPathsQuery__
 *
 * To run a query within a React component, call `useCreatorPathsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreatorPathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatorPathsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      status: // value for 'status'
 *      authorId: // value for 'authorId'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCreatorPathsQuery(baseOptions: Apollo.QueryHookOptions<CreatorPathsQuery, CreatorPathsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreatorPathsQuery, CreatorPathsQueryVariables>(CreatorPathsDocument, options);
      }
export function useCreatorPathsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreatorPathsQuery, CreatorPathsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreatorPathsQuery, CreatorPathsQueryVariables>(CreatorPathsDocument, options);
        }
export type CreatorPathsQueryHookResult = ReturnType<typeof useCreatorPathsQuery>;
export type CreatorPathsLazyQueryHookResult = ReturnType<typeof useCreatorPathsLazyQuery>;
export type CreatorPathsQueryResult = Apollo.QueryResult<CreatorPathsQuery, CreatorPathsQueryVariables>;
export const CreatePathActivityWithReviewDocument = gql`
    mutation CreatePathActivityWithReview($object: path_activity_insert_input!, $pathId: bigint!, $status: String!, $isPublished: Boolean!, $publishedAt: timestamptz, $slug: String, $authorId: String!, $authors: [path_author_insert_input!]!) {
  insert_path_activity_one(object: $object) {
    ...PathActivity
  }
  insert_path_author(
    objects: $authors
    on_conflict: {update_columns: [], constraint: path_author_path_id_user_id_key}
  ) {
    returning {
      pathId
      userId
    }
  }
  update_path_by_pk(
    pk_columns: {id: $pathId}
    _set: {status: $status, slug: $slug, isPublished: $isPublished, publishedAt: $publishedAt, authorId: $authorId}
  ) {
    id
    status
    slug
    isPublished
    isTractOriginal
    authorId
    authors {
      pathId
      userId
    }
  }
}
    ${PathActivityFragmentDoc}`;
export type CreatePathActivityWithReviewMutationFn = Apollo.MutationFunction<CreatePathActivityWithReviewMutation, CreatePathActivityWithReviewMutationVariables>;

/**
 * __useCreatePathActivityWithReviewMutation__
 *
 * To run a mutation, you first call `useCreatePathActivityWithReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePathActivityWithReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPathActivityWithReviewMutation, { data, loading, error }] = useCreatePathActivityWithReviewMutation({
 *   variables: {
 *      object: // value for 'object'
 *      pathId: // value for 'pathId'
 *      status: // value for 'status'
 *      isPublished: // value for 'isPublished'
 *      publishedAt: // value for 'publishedAt'
 *      slug: // value for 'slug'
 *      authorId: // value for 'authorId'
 *      authors: // value for 'authors'
 *   },
 * });
 */
export function useCreatePathActivityWithReviewMutation(baseOptions?: Apollo.MutationHookOptions<CreatePathActivityWithReviewMutation, CreatePathActivityWithReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePathActivityWithReviewMutation, CreatePathActivityWithReviewMutationVariables>(CreatePathActivityWithReviewDocument, options);
      }
export type CreatePathActivityWithReviewMutationHookResult = ReturnType<typeof useCreatePathActivityWithReviewMutation>;
export type CreatePathActivityWithReviewMutationResult = Apollo.MutationResult<CreatePathActivityWithReviewMutation>;
export type CreatePathActivityWithReviewMutationOptions = Apollo.BaseMutationOptions<CreatePathActivityWithReviewMutation, CreatePathActivityWithReviewMutationVariables>;
export const CreatePathReviewDocument = gql`
    mutation CreatePathReview($object: path_review_insert_input!) {
  insert_path_review_one(object: $object) {
    ...PathReview
  }
}
    ${PathReviewFragmentDoc}`;
export type CreatePathReviewMutationFn = Apollo.MutationFunction<CreatePathReviewMutation, CreatePathReviewMutationVariables>;

/**
 * __useCreatePathReviewMutation__
 *
 * To run a mutation, you first call `useCreatePathReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePathReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPathReviewMutation, { data, loading, error }] = useCreatePathReviewMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useCreatePathReviewMutation(baseOptions?: Apollo.MutationHookOptions<CreatePathReviewMutation, CreatePathReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePathReviewMutation, CreatePathReviewMutationVariables>(CreatePathReviewDocument, options);
      }
export type CreatePathReviewMutationHookResult = ReturnType<typeof useCreatePathReviewMutation>;
export type CreatePathReviewMutationResult = Apollo.MutationResult<CreatePathReviewMutation>;
export type CreatePathReviewMutationOptions = Apollo.BaseMutationOptions<CreatePathReviewMutation, CreatePathReviewMutationVariables>;
export const GetPathActivityForUserDocument = gql`
    query GetPathActivityForUser($offset: Int!, $limit: Int!, $userId: String!, $creatorLevel: String_comparison_exp!, $type: String_comparison_exp!) {
  pathActivity: path_activity(
    offset: $offset
    limit: $limit
    order_by: {createdAt: desc_nulls_last}
    where: {userId: {_eq: $userId}, path: {authorId: {_neq: $userId}, user: {creatorLevel: $creatorLevel}}, type: $type}
  ) {
    ...PathActivity
  }
}
    ${PathActivityFragmentDoc}`;

/**
 * __useGetPathActivityForUserQuery__
 *
 * To run a query within a React component, call `useGetPathActivityForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPathActivityForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPathActivityForUserQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      userId: // value for 'userId'
 *      creatorLevel: // value for 'creatorLevel'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetPathActivityForUserQuery(baseOptions: Apollo.QueryHookOptions<GetPathActivityForUserQuery, GetPathActivityForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPathActivityForUserQuery, GetPathActivityForUserQueryVariables>(GetPathActivityForUserDocument, options);
      }
export function useGetPathActivityForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPathActivityForUserQuery, GetPathActivityForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPathActivityForUserQuery, GetPathActivityForUserQueryVariables>(GetPathActivityForUserDocument, options);
        }
export type GetPathActivityForUserQueryHookResult = ReturnType<typeof useGetPathActivityForUserQuery>;
export type GetPathActivityForUserLazyQueryHookResult = ReturnType<typeof useGetPathActivityForUserLazyQuery>;
export type GetPathActivityForUserQueryResult = Apollo.QueryResult<GetPathActivityForUserQuery, GetPathActivityForUserQueryVariables>;
export const RequestReviewFromReviewerDocument = gql`
    mutation RequestReviewFromReviewer($pathReviewId: uuid!) {
  update_path_review_by_pk(
    pk_columns: {id: $pathReviewId}
    _set: {needsReview: true}
  ) {
    id
    pathId
    needsReview
    type
  }
}
    `;
export type RequestReviewFromReviewerMutationFn = Apollo.MutationFunction<RequestReviewFromReviewerMutation, RequestReviewFromReviewerMutationVariables>;

/**
 * __useRequestReviewFromReviewerMutation__
 *
 * To run a mutation, you first call `useRequestReviewFromReviewerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestReviewFromReviewerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestReviewFromReviewerMutation, { data, loading, error }] = useRequestReviewFromReviewerMutation({
 *   variables: {
 *      pathReviewId: // value for 'pathReviewId'
 *   },
 * });
 */
export function useRequestReviewFromReviewerMutation(baseOptions?: Apollo.MutationHookOptions<RequestReviewFromReviewerMutation, RequestReviewFromReviewerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestReviewFromReviewerMutation, RequestReviewFromReviewerMutationVariables>(RequestReviewFromReviewerDocument, options);
      }
export type RequestReviewFromReviewerMutationHookResult = ReturnType<typeof useRequestReviewFromReviewerMutation>;
export type RequestReviewFromReviewerMutationResult = Apollo.MutationResult<RequestReviewFromReviewerMutation>;
export type RequestReviewFromReviewerMutationOptions = Apollo.BaseMutationOptions<RequestReviewFromReviewerMutation, RequestReviewFromReviewerMutationVariables>;
export const PathsWithReviewsDocument = gql`
    query PathsWithReviews($offset: Int!, $limit: Int!, $creatorLevel: String_comparison_exp!, $status: String_comparison_exp!, $userId: String!, $type: String_comparison_exp!, $orderBy: [path_review_order_by!], $reviewUserId: String_comparison_exp!) {
  pathReviews: list_latest_path_reviews(
    offset: $offset
    limit: $limit
    where: {type: $type, userId: $reviewUserId, path: {status: $status, _schemaVersion: {_eq: 3}, user: {creatorLevel: $creatorLevel, firestoreId: {_neq: $userId}}}}
    order_by: $orderBy
  ) {
    ...PathReview
    path {
      ...pathsByStatus
    }
  }
}
    ${PathReviewFragmentDoc}
${PathsByStatusFragmentDoc}`;

/**
 * __usePathsWithReviewsQuery__
 *
 * To run a query within a React component, call `usePathsWithReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathsWithReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathsWithReviewsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      creatorLevel: // value for 'creatorLevel'
 *      status: // value for 'status'
 *      userId: // value for 'userId'
 *      type: // value for 'type'
 *      orderBy: // value for 'orderBy'
 *      reviewUserId: // value for 'reviewUserId'
 *   },
 * });
 */
export function usePathsWithReviewsQuery(baseOptions: Apollo.QueryHookOptions<PathsWithReviewsQuery, PathsWithReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PathsWithReviewsQuery, PathsWithReviewsQueryVariables>(PathsWithReviewsDocument, options);
      }
export function usePathsWithReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PathsWithReviewsQuery, PathsWithReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PathsWithReviewsQuery, PathsWithReviewsQueryVariables>(PathsWithReviewsDocument, options);
        }
export type PathsWithReviewsQueryHookResult = ReturnType<typeof usePathsWithReviewsQuery>;
export type PathsWithReviewsLazyQueryHookResult = ReturnType<typeof usePathsWithReviewsLazyQuery>;
export type PathsWithReviewsQueryResult = Apollo.QueryResult<PathsWithReviewsQuery, PathsWithReviewsQueryVariables>;
export const ClassroomLearnerGroupDocument = gql`
    query ClassroomLearnerGroup($id: uuid!) {
  learnerGroup: learner_group_by_pk(id: $id) {
    ...ClassroomLearnerGroup
  }
}
    ${ClassroomLearnerGroupFragmentDoc}`;

/**
 * __useClassroomLearnerGroupQuery__
 *
 * To run a query within a React component, call `useClassroomLearnerGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomLearnerGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomLearnerGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClassroomLearnerGroupQuery(baseOptions: Apollo.QueryHookOptions<ClassroomLearnerGroupQuery, ClassroomLearnerGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassroomLearnerGroupQuery, ClassroomLearnerGroupQueryVariables>(ClassroomLearnerGroupDocument, options);
      }
export function useClassroomLearnerGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassroomLearnerGroupQuery, ClassroomLearnerGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassroomLearnerGroupQuery, ClassroomLearnerGroupQueryVariables>(ClassroomLearnerGroupDocument, options);
        }
export type ClassroomLearnerGroupQueryHookResult = ReturnType<typeof useClassroomLearnerGroupQuery>;
export type ClassroomLearnerGroupLazyQueryHookResult = ReturnType<typeof useClassroomLearnerGroupLazyQuery>;
export type ClassroomLearnerGroupQueryResult = Apollo.QueryResult<ClassroomLearnerGroupQuery, ClassroomLearnerGroupQueryVariables>;
export const ClassroomByIdDocument = gql`
    query ClassroomById($classId: uuid!) {
  learnerGroups: learner_group(
    where: {id: {_eq: $classId}, archivedAt: {_eq: "-infinity"}}
  ) {
    ...ClassroomLearnerGroup
  }
}
    ${ClassroomLearnerGroupFragmentDoc}`;

/**
 * __useClassroomByIdQuery__
 *
 * To run a query within a React component, call `useClassroomByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomByIdQuery({
 *   variables: {
 *      classId: // value for 'classId'
 *   },
 * });
 */
export function useClassroomByIdQuery(baseOptions: Apollo.QueryHookOptions<ClassroomByIdQuery, ClassroomByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassroomByIdQuery, ClassroomByIdQueryVariables>(ClassroomByIdDocument, options);
      }
export function useClassroomByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassroomByIdQuery, ClassroomByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassroomByIdQuery, ClassroomByIdQueryVariables>(ClassroomByIdDocument, options);
        }
export type ClassroomByIdQueryHookResult = ReturnType<typeof useClassroomByIdQuery>;
export type ClassroomByIdLazyQueryHookResult = ReturnType<typeof useClassroomByIdLazyQuery>;
export type ClassroomByIdQueryResult = Apollo.QueryResult<ClassroomByIdQuery, ClassroomByIdQueryVariables>;
export const ClassroomsByTeacherIdDocument = gql`
    query ClassroomsByTeacherId($teacherUserId: String!) {
  learnerGroups: learner_group(
    where: {members: {role: {_eq: "teacher"}, userId: {_eq: $teacherUserId}}, archivedAt: {_eq: "-infinity"}}
    order_by: {createdAt: desc}
  ) {
    ...ClassroomLearnerGroup
  }
}
    ${ClassroomLearnerGroupFragmentDoc}`;

/**
 * __useClassroomsByTeacherIdQuery__
 *
 * To run a query within a React component, call `useClassroomsByTeacherIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomsByTeacherIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomsByTeacherIdQuery({
 *   variables: {
 *      teacherUserId: // value for 'teacherUserId'
 *   },
 * });
 */
export function useClassroomsByTeacherIdQuery(baseOptions: Apollo.QueryHookOptions<ClassroomsByTeacherIdQuery, ClassroomsByTeacherIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassroomsByTeacherIdQuery, ClassroomsByTeacherIdQueryVariables>(ClassroomsByTeacherIdDocument, options);
      }
export function useClassroomsByTeacherIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassroomsByTeacherIdQuery, ClassroomsByTeacherIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassroomsByTeacherIdQuery, ClassroomsByTeacherIdQueryVariables>(ClassroomsByTeacherIdDocument, options);
        }
export type ClassroomsByTeacherIdQueryHookResult = ReturnType<typeof useClassroomsByTeacherIdQuery>;
export type ClassroomsByTeacherIdLazyQueryHookResult = ReturnType<typeof useClassroomsByTeacherIdLazyQuery>;
export type ClassroomsByTeacherIdQueryResult = Apollo.QueryResult<ClassroomsByTeacherIdQuery, ClassroomsByTeacherIdQueryVariables>;
export const ClassroomPathsDocument = gql`
    query ClassroomPaths($offset: Int!, $limit: Int!, $visibility: String!, $authorIds: [String!], $isPublished: Boolean!) {
  paths: path(
    limit: $limit
    offset: $offset
    where: {visibility: {_eq: $visibility}, isPublished: {_eq: $isPublished}, authorId: {_in: $authorIds}}
    order_by: {publishedAt: desc}
  ) {
    ...PathCard
  }
}
    ${PathCardFragmentDoc}`;

/**
 * __useClassroomPathsQuery__
 *
 * To run a query within a React component, call `useClassroomPathsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomPathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomPathsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      visibility: // value for 'visibility'
 *      authorIds: // value for 'authorIds'
 *      isPublished: // value for 'isPublished'
 *   },
 * });
 */
export function useClassroomPathsQuery(baseOptions: Apollo.QueryHookOptions<ClassroomPathsQuery, ClassroomPathsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassroomPathsQuery, ClassroomPathsQueryVariables>(ClassroomPathsDocument, options);
      }
export function useClassroomPathsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassroomPathsQuery, ClassroomPathsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassroomPathsQuery, ClassroomPathsQueryVariables>(ClassroomPathsDocument, options);
        }
export type ClassroomPathsQueryHookResult = ReturnType<typeof useClassroomPathsQuery>;
export type ClassroomPathsLazyQueryHookResult = ReturnType<typeof useClassroomPathsLazyQuery>;
export type ClassroomPathsQueryResult = Apollo.QueryResult<ClassroomPathsQuery, ClassroomPathsQueryVariables>;
export const ClassroomMemberTeachersDocument = gql`
    query ClassroomMemberTeachers($classId: uuid!, $teacherIds: [String!]!) {
  learner_group_member(
    where: {learnerGroupId: {_eq: $classId}, userId: {_in: $teacherIds}}
  ) {
    learnerGroupId
    userId
    isOwner
    role
    user {
      id: firestoreId
      avatar
      firstName
      lastName
      email
      isEducator
      userType
      teacher {
        id: userId
        displayName
      }
    }
  }
}
    `;

/**
 * __useClassroomMemberTeachersQuery__
 *
 * To run a query within a React component, call `useClassroomMemberTeachersQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomMemberTeachersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomMemberTeachersQuery({
 *   variables: {
 *      classId: // value for 'classId'
 *      teacherIds: // value for 'teacherIds'
 *   },
 * });
 */
export function useClassroomMemberTeachersQuery(baseOptions: Apollo.QueryHookOptions<ClassroomMemberTeachersQuery, ClassroomMemberTeachersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassroomMemberTeachersQuery, ClassroomMemberTeachersQueryVariables>(ClassroomMemberTeachersDocument, options);
      }
export function useClassroomMemberTeachersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassroomMemberTeachersQuery, ClassroomMemberTeachersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassroomMemberTeachersQuery, ClassroomMemberTeachersQueryVariables>(ClassroomMemberTeachersDocument, options);
        }
export type ClassroomMemberTeachersQueryHookResult = ReturnType<typeof useClassroomMemberTeachersQuery>;
export type ClassroomMemberTeachersLazyQueryHookResult = ReturnType<typeof useClassroomMemberTeachersLazyQuery>;
export type ClassroomMemberTeachersQueryResult = Apollo.QueryResult<ClassroomMemberTeachersQuery, ClassroomMemberTeachersQueryVariables>;
export const ClassroomProjectsDocument = gql`
    query ClassroomProjects($userIds: [String!]!, $limit: Int!, $offset: Int = 0, $isPrivate: Boolean_comparison_exp) {
  projects: project(
    limit: $limit
    offset: $offset
    where: {userId: {_in: $userIds}, file: {transforms: {}}, rejectedAt: {_eq: "-infinity"}, isPrivate: $isPrivate, published: {_eq: true}, _or: [{user: {projectPrivacy: {_in: ["private", "school"]}}}, {user: {projectPrivacy: {_is_null: true}}}]}
    order_by: {createdAt: desc}
  ) {
    ...projectCard
  }
}
    ${ProjectCardFragmentDoc}`;

/**
 * __useClassroomProjectsQuery__
 *
 * To run a query within a React component, call `useClassroomProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomProjectsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      isPrivate: // value for 'isPrivate'
 *   },
 * });
 */
export function useClassroomProjectsQuery(baseOptions: Apollo.QueryHookOptions<ClassroomProjectsQuery, ClassroomProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassroomProjectsQuery, ClassroomProjectsQueryVariables>(ClassroomProjectsDocument, options);
      }
export function useClassroomProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassroomProjectsQuery, ClassroomProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassroomProjectsQuery, ClassroomProjectsQueryVariables>(ClassroomProjectsDocument, options);
        }
export type ClassroomProjectsQueryHookResult = ReturnType<typeof useClassroomProjectsQuery>;
export type ClassroomProjectsLazyQueryHookResult = ReturnType<typeof useClassroomProjectsLazyQuery>;
export type ClassroomProjectsQueryResult = Apollo.QueryResult<ClassroomProjectsQuery, ClassroomProjectsQueryVariables>;
export const UpdateClassroomSettingsDocument = gql`
    mutation UpdateClassroomSettings($classId: uuid!, $name: String!, $color: String, $privacyScope: String) {
  updatePrivacy: api_update_learner_group_settings(
    input: {classId: $classId, privacyScope: $privacyScope, name: $name, color: $color}
  ) {
    name
    color
    classId
    privacyScope
  }
}
    `;
export type UpdateClassroomSettingsMutationFn = Apollo.MutationFunction<UpdateClassroomSettingsMutation, UpdateClassroomSettingsMutationVariables>;

/**
 * __useUpdateClassroomSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateClassroomSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClassroomSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClassroomSettingsMutation, { data, loading, error }] = useUpdateClassroomSettingsMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *      name: // value for 'name'
 *      color: // value for 'color'
 *      privacyScope: // value for 'privacyScope'
 *   },
 * });
 */
export function useUpdateClassroomSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClassroomSettingsMutation, UpdateClassroomSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClassroomSettingsMutation, UpdateClassroomSettingsMutationVariables>(UpdateClassroomSettingsDocument, options);
      }
export type UpdateClassroomSettingsMutationHookResult = ReturnType<typeof useUpdateClassroomSettingsMutation>;
export type UpdateClassroomSettingsMutationResult = Apollo.MutationResult<UpdateClassroomSettingsMutation>;
export type UpdateClassroomSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateClassroomSettingsMutation, UpdateClassroomSettingsMutationVariables>;
export const ClassroomAssignmentsDocument = gql`
    query ClassroomAssignments($where: assignment_learner_group_bool_exp, $orderBy: [assignment_learner_group_order_by!]) {
  assignment_learner_group(where: $where, order_by: $orderBy) {
    ...ClassroomAssignment
  }
}
    ${ClassroomAssignmentFragmentDoc}`;

/**
 * __useClassroomAssignmentsQuery__
 *
 * To run a query within a React component, call `useClassroomAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomAssignmentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useClassroomAssignmentsQuery(baseOptions?: Apollo.QueryHookOptions<ClassroomAssignmentsQuery, ClassroomAssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassroomAssignmentsQuery, ClassroomAssignmentsQueryVariables>(ClassroomAssignmentsDocument, options);
      }
export function useClassroomAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassroomAssignmentsQuery, ClassroomAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassroomAssignmentsQuery, ClassroomAssignmentsQueryVariables>(ClassroomAssignmentsDocument, options);
        }
export type ClassroomAssignmentsQueryHookResult = ReturnType<typeof useClassroomAssignmentsQuery>;
export type ClassroomAssignmentsLazyQueryHookResult = ReturnType<typeof useClassroomAssignmentsLazyQuery>;
export type ClassroomAssignmentsQueryResult = Apollo.QueryResult<ClassroomAssignmentsQuery, ClassroomAssignmentsQueryVariables>;
export const ClassroomAssignmentMarkFinishedDocument = gql`
    mutation ClassroomAssignmentMarkFinished($assignmentId: uuid!, $classId: uuid!, $isFinished: Boolean!) {
  update_assignment_learner_group_by_pk(
    pk_columns: {assignmentId: $assignmentId, learnerGroupId: $classId}
    _set: {isFinished: $isFinished}
  ) {
    assignmentId
    learnerGroupId
    isFinished
  }
}
    `;
export type ClassroomAssignmentMarkFinishedMutationFn = Apollo.MutationFunction<ClassroomAssignmentMarkFinishedMutation, ClassroomAssignmentMarkFinishedMutationVariables>;

/**
 * __useClassroomAssignmentMarkFinishedMutation__
 *
 * To run a mutation, you first call `useClassroomAssignmentMarkFinishedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClassroomAssignmentMarkFinishedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [classroomAssignmentMarkFinishedMutation, { data, loading, error }] = useClassroomAssignmentMarkFinishedMutation({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      classId: // value for 'classId'
 *      isFinished: // value for 'isFinished'
 *   },
 * });
 */
export function useClassroomAssignmentMarkFinishedMutation(baseOptions?: Apollo.MutationHookOptions<ClassroomAssignmentMarkFinishedMutation, ClassroomAssignmentMarkFinishedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClassroomAssignmentMarkFinishedMutation, ClassroomAssignmentMarkFinishedMutationVariables>(ClassroomAssignmentMarkFinishedDocument, options);
      }
export type ClassroomAssignmentMarkFinishedMutationHookResult = ReturnType<typeof useClassroomAssignmentMarkFinishedMutation>;
export type ClassroomAssignmentMarkFinishedMutationResult = Apollo.MutationResult<ClassroomAssignmentMarkFinishedMutation>;
export type ClassroomAssignmentMarkFinishedMutationOptions = Apollo.BaseMutationOptions<ClassroomAssignmentMarkFinishedMutation, ClassroomAssignmentMarkFinishedMutationVariables>;
export const ClassroomAssignmentDetailsDocument = gql`
    query ClassroomAssignmentDetails($assignmentId: uuid!, $learnerUserIds: [String!]!) {
  assignment: assignment_by_pk(id: $assignmentId) {
    ...ClassroomAssignmentDetail
  }
}
    ${ClassroomAssignmentDetailFragmentDoc}`;

/**
 * __useClassroomAssignmentDetailsQuery__
 *
 * To run a query within a React component, call `useClassroomAssignmentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomAssignmentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomAssignmentDetailsQuery({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      learnerUserIds: // value for 'learnerUserIds'
 *   },
 * });
 */
export function useClassroomAssignmentDetailsQuery(baseOptions: Apollo.QueryHookOptions<ClassroomAssignmentDetailsQuery, ClassroomAssignmentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassroomAssignmentDetailsQuery, ClassroomAssignmentDetailsQueryVariables>(ClassroomAssignmentDetailsDocument, options);
      }
export function useClassroomAssignmentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassroomAssignmentDetailsQuery, ClassroomAssignmentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassroomAssignmentDetailsQuery, ClassroomAssignmentDetailsQueryVariables>(ClassroomAssignmentDetailsDocument, options);
        }
export type ClassroomAssignmentDetailsQueryHookResult = ReturnType<typeof useClassroomAssignmentDetailsQuery>;
export type ClassroomAssignmentDetailsLazyQueryHookResult = ReturnType<typeof useClassroomAssignmentDetailsLazyQuery>;
export type ClassroomAssignmentDetailsQueryResult = Apollo.QueryResult<ClassroomAssignmentDetailsQuery, ClassroomAssignmentDetailsQueryVariables>;
export const SyncRosterDocument = gql`
    mutation SyncRoster($classId: String!, $accessToken: String!, $learnerGroupId: String!) {
  syncRoster: api_sync_roster(
    classId: $classId
    accessToken: $accessToken
    learnerGroupId: $learnerGroupId
  ) {
    invitesCount
  }
}
    `;
export type SyncRosterMutationFn = Apollo.MutationFunction<SyncRosterMutation, SyncRosterMutationVariables>;

/**
 * __useSyncRosterMutation__
 *
 * To run a mutation, you first call `useSyncRosterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncRosterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncRosterMutation, { data, loading, error }] = useSyncRosterMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *      accessToken: // value for 'accessToken'
 *      learnerGroupId: // value for 'learnerGroupId'
 *   },
 * });
 */
export function useSyncRosterMutation(baseOptions?: Apollo.MutationHookOptions<SyncRosterMutation, SyncRosterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncRosterMutation, SyncRosterMutationVariables>(SyncRosterDocument, options);
      }
export type SyncRosterMutationHookResult = ReturnType<typeof useSyncRosterMutation>;
export type SyncRosterMutationResult = Apollo.MutationResult<SyncRosterMutation>;
export type SyncRosterMutationOptions = Apollo.BaseMutationOptions<SyncRosterMutation, SyncRosterMutationVariables>;
export const InsertGuideDocument = gql`
    mutation InsertGuide($pathId: bigint!, $isRelatedPath: Boolean!, $guide: guide_insert_input!) {
  guidePath: insert_guide_path_one(
    object: {pathId: $pathId, isRelatedPath: $isRelatedPath, guide: {data: $guide}}
  ) {
    guideId
    pathId
    isRelatedPath
    guide {
      ...guide
    }
  }
}
    ${GuideFragmentDoc}`;
export type InsertGuideMutationFn = Apollo.MutationFunction<InsertGuideMutation, InsertGuideMutationVariables>;

/**
 * __useInsertGuideMutation__
 *
 * To run a mutation, you first call `useInsertGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertGuideMutation, { data, loading, error }] = useInsertGuideMutation({
 *   variables: {
 *      pathId: // value for 'pathId'
 *      isRelatedPath: // value for 'isRelatedPath'
 *      guide: // value for 'guide'
 *   },
 * });
 */
export function useInsertGuideMutation(baseOptions?: Apollo.MutationHookOptions<InsertGuideMutation, InsertGuideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertGuideMutation, InsertGuideMutationVariables>(InsertGuideDocument, options);
      }
export type InsertGuideMutationHookResult = ReturnType<typeof useInsertGuideMutation>;
export type InsertGuideMutationResult = Apollo.MutationResult<InsertGuideMutation>;
export type InsertGuideMutationOptions = Apollo.BaseMutationOptions<InsertGuideMutation, InsertGuideMutationVariables>;
export const UpdateGuideByPkDocument = gql`
    mutation UpdateGuideByPk($id: uuid!, $object: guide_set_input!) {
  guide: update_guide_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...guide
  }
}
    ${GuideFragmentDoc}`;
export type UpdateGuideByPkMutationFn = Apollo.MutationFunction<UpdateGuideByPkMutation, UpdateGuideByPkMutationVariables>;

/**
 * __useUpdateGuideByPkMutation__
 *
 * To run a mutation, you first call `useUpdateGuideByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGuideByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGuideByPkMutation, { data, loading, error }] = useUpdateGuideByPkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpdateGuideByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGuideByPkMutation, UpdateGuideByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGuideByPkMutation, UpdateGuideByPkMutationVariables>(UpdateGuideByPkDocument, options);
      }
export type UpdateGuideByPkMutationHookResult = ReturnType<typeof useUpdateGuideByPkMutation>;
export type UpdateGuideByPkMutationResult = Apollo.MutationResult<UpdateGuideByPkMutation>;
export type UpdateGuideByPkMutationOptions = Apollo.BaseMutationOptions<UpdateGuideByPkMutation, UpdateGuideByPkMutationVariables>;
export const GetPathWithNodesDocument = gql`
    query GetPathWithNodes($pathId: bigint!) {
  path: path_by_pk(id: $pathId) {
    ...PathBuilderPathV4
  }
}
    ${PathBuilderPathV4FragmentDoc}`;

/**
 * __useGetPathWithNodesQuery__
 *
 * To run a query within a React component, call `useGetPathWithNodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPathWithNodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPathWithNodesQuery({
 *   variables: {
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function useGetPathWithNodesQuery(baseOptions: Apollo.QueryHookOptions<GetPathWithNodesQuery, GetPathWithNodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPathWithNodesQuery, GetPathWithNodesQueryVariables>(GetPathWithNodesDocument, options);
      }
export function useGetPathWithNodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPathWithNodesQuery, GetPathWithNodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPathWithNodesQuery, GetPathWithNodesQueryVariables>(GetPathWithNodesDocument, options);
        }
export type GetPathWithNodesQueryHookResult = ReturnType<typeof useGetPathWithNodesQuery>;
export type GetPathWithNodesLazyQueryHookResult = ReturnType<typeof useGetPathWithNodesLazyQuery>;
export type GetPathWithNodesQueryResult = Apollo.QueryResult<GetPathWithNodesQuery, GetPathWithNodesQueryVariables>;
export const SavePathV4Document = gql`
    mutation SavePathV4($pathId: bigint!, $path: path_set_input) {
  path: update_path_by_pk(pk_columns: {id: $pathId}, _set: $path) {
    ...PathBuilderPathV4
  }
}
    ${PathBuilderPathV4FragmentDoc}`;
export type SavePathV4MutationFn = Apollo.MutationFunction<SavePathV4Mutation, SavePathV4MutationVariables>;

/**
 * __useSavePathV4Mutation__
 *
 * To run a mutation, you first call `useSavePathV4Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePathV4Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePathV4Mutation, { data, loading, error }] = useSavePathV4Mutation({
 *   variables: {
 *      pathId: // value for 'pathId'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useSavePathV4Mutation(baseOptions?: Apollo.MutationHookOptions<SavePathV4Mutation, SavePathV4MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePathV4Mutation, SavePathV4MutationVariables>(SavePathV4Document, options);
      }
export type SavePathV4MutationHookResult = ReturnType<typeof useSavePathV4Mutation>;
export type SavePathV4MutationResult = Apollo.MutationResult<SavePathV4Mutation>;
export type SavePathV4MutationOptions = Apollo.BaseMutationOptions<SavePathV4Mutation, SavePathV4MutationVariables>;
export const SavePathTitleDocument = gql`
    mutation SavePathTitle($pathId: bigint!, $pathTitle: String!) {
  path: update_path_by_pk(pk_columns: {id: $pathId}, _set: {title: $pathTitle}) {
    id
    title
  }
}
    `;
export type SavePathTitleMutationFn = Apollo.MutationFunction<SavePathTitleMutation, SavePathTitleMutationVariables>;

/**
 * __useSavePathTitleMutation__
 *
 * To run a mutation, you first call `useSavePathTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePathTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePathTitleMutation, { data, loading, error }] = useSavePathTitleMutation({
 *   variables: {
 *      pathId: // value for 'pathId'
 *      pathTitle: // value for 'pathTitle'
 *   },
 * });
 */
export function useSavePathTitleMutation(baseOptions?: Apollo.MutationHookOptions<SavePathTitleMutation, SavePathTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePathTitleMutation, SavePathTitleMutationVariables>(SavePathTitleDocument, options);
      }
export type SavePathTitleMutationHookResult = ReturnType<typeof useSavePathTitleMutation>;
export type SavePathTitleMutationResult = Apollo.MutationResult<SavePathTitleMutation>;
export type SavePathTitleMutationOptions = Apollo.BaseMutationOptions<SavePathTitleMutation, SavePathTitleMutationVariables>;
export const GetLatestPathReviewForPathDocument = gql`
    query GetLatestPathReviewForPath($pathId: bigint!, $type: String_comparison_exp) {
  pathReview: path_review(
    limit: 1
    order_by: {createdAt: desc_nulls_last}
    where: {pathId: {_eq: $pathId}, type: $type}
  ) {
    ...PathReview
  }
}
    ${PathReviewFragmentDoc}`;

/**
 * __useGetLatestPathReviewForPathQuery__
 *
 * To run a query within a React component, call `useGetLatestPathReviewForPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestPathReviewForPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestPathReviewForPathQuery({
 *   variables: {
 *      pathId: // value for 'pathId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetLatestPathReviewForPathQuery(baseOptions: Apollo.QueryHookOptions<GetLatestPathReviewForPathQuery, GetLatestPathReviewForPathQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestPathReviewForPathQuery, GetLatestPathReviewForPathQueryVariables>(GetLatestPathReviewForPathDocument, options);
      }
export function useGetLatestPathReviewForPathLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestPathReviewForPathQuery, GetLatestPathReviewForPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestPathReviewForPathQuery, GetLatestPathReviewForPathQueryVariables>(GetLatestPathReviewForPathDocument, options);
        }
export type GetLatestPathReviewForPathQueryHookResult = ReturnType<typeof useGetLatestPathReviewForPathQuery>;
export type GetLatestPathReviewForPathLazyQueryHookResult = ReturnType<typeof useGetLatestPathReviewForPathLazyQuery>;
export type GetLatestPathReviewForPathQueryResult = Apollo.QueryResult<GetLatestPathReviewForPathQuery, GetLatestPathReviewForPathQueryVariables>;
export const GetPathStatusDocument = gql`
    query GetPathStatus($pathId: bigint!) {
  path: path_by_pk(id: $pathId) {
    id
    status
  }
}
    `;

/**
 * __useGetPathStatusQuery__
 *
 * To run a query within a React component, call `useGetPathStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPathStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPathStatusQuery({
 *   variables: {
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function useGetPathStatusQuery(baseOptions: Apollo.QueryHookOptions<GetPathStatusQuery, GetPathStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPathStatusQuery, GetPathStatusQueryVariables>(GetPathStatusDocument, options);
      }
export function useGetPathStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPathStatusQuery, GetPathStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPathStatusQuery, GetPathStatusQueryVariables>(GetPathStatusDocument, options);
        }
export type GetPathStatusQueryHookResult = ReturnType<typeof useGetPathStatusQuery>;
export type GetPathStatusLazyQueryHookResult = ReturnType<typeof useGetPathStatusLazyQuery>;
export type GetPathStatusQueryResult = Apollo.QueryResult<GetPathStatusQuery, GetPathStatusQueryVariables>;
export const SavePathStatusDocument = gql`
    mutation SavePathStatus($pathId: bigint!, $status: String!, $isPublished: Boolean, $slug: String, $publishedAt: timestamptz, $pathActivity: path_activity_insert_input!, $authorId: String!, $authors: [path_author_insert_input!]!) {
  path: update_path_by_pk(
    pk_columns: {id: $pathId}
    _set: {status: $status, isPublished: $isPublished, slug: $slug, publishedAt: $publishedAt, authorId: $authorId}
  ) {
    id
    status
    isPublished
    slug
    publishedAt
  }
  insert_path_author(
    objects: $authors
    on_conflict: {update_columns: [], constraint: path_author_path_id_user_id_key}
  ) {
    returning {
      pathId
      userId
    }
  }
  insert_path_activity_one(object: $pathActivity) {
    ...PathActivity
  }
}
    ${PathActivityFragmentDoc}`;
export type SavePathStatusMutationFn = Apollo.MutationFunction<SavePathStatusMutation, SavePathStatusMutationVariables>;

/**
 * __useSavePathStatusMutation__
 *
 * To run a mutation, you first call `useSavePathStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePathStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePathStatusMutation, { data, loading, error }] = useSavePathStatusMutation({
 *   variables: {
 *      pathId: // value for 'pathId'
 *      status: // value for 'status'
 *      isPublished: // value for 'isPublished'
 *      slug: // value for 'slug'
 *      publishedAt: // value for 'publishedAt'
 *      pathActivity: // value for 'pathActivity'
 *      authorId: // value for 'authorId'
 *      authors: // value for 'authors'
 *   },
 * });
 */
export function useSavePathStatusMutation(baseOptions?: Apollo.MutationHookOptions<SavePathStatusMutation, SavePathStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePathStatusMutation, SavePathStatusMutationVariables>(SavePathStatusDocument, options);
      }
export type SavePathStatusMutationHookResult = ReturnType<typeof useSavePathStatusMutation>;
export type SavePathStatusMutationResult = Apollo.MutationResult<SavePathStatusMutation>;
export type SavePathStatusMutationOptions = Apollo.BaseMutationOptions<SavePathStatusMutation, SavePathStatusMutationVariables>;
export const GetPathBuilderNodeDocument = gql`
    query GetPathBuilderNode($nodeId: uuid!) {
  node: path_node_by_pk(id: $nodeId) {
    ...PathBuilderNode
  }
}
    ${PathBuilderNodeFragmentDoc}`;

/**
 * __useGetPathBuilderNodeQuery__
 *
 * To run a query within a React component, call `useGetPathBuilderNodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPathBuilderNodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPathBuilderNodeQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useGetPathBuilderNodeQuery(baseOptions: Apollo.QueryHookOptions<GetPathBuilderNodeQuery, GetPathBuilderNodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPathBuilderNodeQuery, GetPathBuilderNodeQueryVariables>(GetPathBuilderNodeDocument, options);
      }
export function useGetPathBuilderNodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPathBuilderNodeQuery, GetPathBuilderNodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPathBuilderNodeQuery, GetPathBuilderNodeQueryVariables>(GetPathBuilderNodeDocument, options);
        }
export type GetPathBuilderNodeQueryHookResult = ReturnType<typeof useGetPathBuilderNodeQuery>;
export type GetPathBuilderNodeLazyQueryHookResult = ReturnType<typeof useGetPathBuilderNodeLazyQuery>;
export type GetPathBuilderNodeQueryResult = Apollo.QueryResult<GetPathBuilderNodeQuery, GetPathBuilderNodeQueryVariables>;
export const UpdatePathNodeDocument = gql`
    mutation UpdatePathNode($nodeId: uuid!, $node: path_node_set_input!) {
  update_path_node_by_pk(pk_columns: {id: $nodeId}, _set: $node) {
    ...PathBuilderNode
  }
}
    ${PathBuilderNodeFragmentDoc}`;
export type UpdatePathNodeMutationFn = Apollo.MutationFunction<UpdatePathNodeMutation, UpdatePathNodeMutationVariables>;

/**
 * __useUpdatePathNodeMutation__
 *
 * To run a mutation, you first call `useUpdatePathNodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePathNodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePathNodeMutation, { data, loading, error }] = useUpdatePathNodeMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *      node: // value for 'node'
 *   },
 * });
 */
export function useUpdatePathNodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePathNodeMutation, UpdatePathNodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePathNodeMutation, UpdatePathNodeMutationVariables>(UpdatePathNodeDocument, options);
      }
export type UpdatePathNodeMutationHookResult = ReturnType<typeof useUpdatePathNodeMutation>;
export type UpdatePathNodeMutationResult = Apollo.MutationResult<UpdatePathNodeMutation>;
export type UpdatePathNodeMutationOptions = Apollo.BaseMutationOptions<UpdatePathNodeMutation, UpdatePathNodeMutationVariables>;
export const DeletePathNodeDocument = gql`
    mutation DeletePathNode($nodeId: uuid!) {
  delete_path_node_by_pk(id: $nodeId) {
    id
    pathId
  }
}
    `;
export type DeletePathNodeMutationFn = Apollo.MutationFunction<DeletePathNodeMutation, DeletePathNodeMutationVariables>;

/**
 * __useDeletePathNodeMutation__
 *
 * To run a mutation, you first call `useDeletePathNodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePathNodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePathNodeMutation, { data, loading, error }] = useDeletePathNodeMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useDeletePathNodeMutation(baseOptions?: Apollo.MutationHookOptions<DeletePathNodeMutation, DeletePathNodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePathNodeMutation, DeletePathNodeMutationVariables>(DeletePathNodeDocument, options);
      }
export type DeletePathNodeMutationHookResult = ReturnType<typeof useDeletePathNodeMutation>;
export type DeletePathNodeMutationResult = Apollo.MutationResult<DeletePathNodeMutation>;
export type DeletePathNodeMutationOptions = Apollo.BaseMutationOptions<DeletePathNodeMutation, DeletePathNodeMutationVariables>;
export const AddPathV4CoAuthorDocument = gql`
    mutation AddPathV4CoAuthor($pathId: bigint!, $userId: String!) {
  insert_path_author_one(object: {pathId: $pathId, userId: $userId}) {
    ...PathCoAuthor
  }
  update_path_by_pk(pk_columns: {id: $pathId}, _set: {isVisibleUnauthed: false}) {
    id
    isVisibleUnauthed
  }
}
    ${PathCoAuthorFragmentDoc}`;
export type AddPathV4CoAuthorMutationFn = Apollo.MutationFunction<AddPathV4CoAuthorMutation, AddPathV4CoAuthorMutationVariables>;

/**
 * __useAddPathV4CoAuthorMutation__
 *
 * To run a mutation, you first call `useAddPathV4CoAuthorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPathV4CoAuthorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPathV4CoAuthorMutation, { data, loading, error }] = useAddPathV4CoAuthorMutation({
 *   variables: {
 *      pathId: // value for 'pathId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddPathV4CoAuthorMutation(baseOptions?: Apollo.MutationHookOptions<AddPathV4CoAuthorMutation, AddPathV4CoAuthorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPathV4CoAuthorMutation, AddPathV4CoAuthorMutationVariables>(AddPathV4CoAuthorDocument, options);
      }
export type AddPathV4CoAuthorMutationHookResult = ReturnType<typeof useAddPathV4CoAuthorMutation>;
export type AddPathV4CoAuthorMutationResult = Apollo.MutationResult<AddPathV4CoAuthorMutation>;
export type AddPathV4CoAuthorMutationOptions = Apollo.BaseMutationOptions<AddPathV4CoAuthorMutation, AddPathV4CoAuthorMutationVariables>;
export const RemovePathV4CoAuthorDocument = gql`
    mutation RemovePathV4CoAuthor($pathId: bigint!, $userId: String!) {
  delete_path_author(where: {pathId: {_eq: $pathId}, userId: {_eq: $userId}}) {
    returning {
      pathId
      userId
    }
  }
}
    `;
export type RemovePathV4CoAuthorMutationFn = Apollo.MutationFunction<RemovePathV4CoAuthorMutation, RemovePathV4CoAuthorMutationVariables>;

/**
 * __useRemovePathV4CoAuthorMutation__
 *
 * To run a mutation, you first call `useRemovePathV4CoAuthorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePathV4CoAuthorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePathV4CoAuthorMutation, { data, loading, error }] = useRemovePathV4CoAuthorMutation({
 *   variables: {
 *      pathId: // value for 'pathId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemovePathV4CoAuthorMutation(baseOptions?: Apollo.MutationHookOptions<RemovePathV4CoAuthorMutation, RemovePathV4CoAuthorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePathV4CoAuthorMutation, RemovePathV4CoAuthorMutationVariables>(RemovePathV4CoAuthorDocument, options);
      }
export type RemovePathV4CoAuthorMutationHookResult = ReturnType<typeof useRemovePathV4CoAuthorMutation>;
export type RemovePathV4CoAuthorMutationResult = Apollo.MutationResult<RemovePathV4CoAuthorMutation>;
export type RemovePathV4CoAuthorMutationOptions = Apollo.BaseMutationOptions<RemovePathV4CoAuthorMutation, RemovePathV4CoAuthorMutationVariables>;
export const AddNodeVideoFileDocument = gql`
    mutation AddNodeVideoFile($fileId: uuid!, $nodeId: uuid!, $file: user_file_insert_input!) {
  file: insert_user_file_one(object: $file) {
    id
  }
  update_path_node_by_pk(pk_columns: {id: $nodeId}, _set: {videoFileId: $fileId}) {
    id
    videoFile {
      integrations(where: {source: {_eq: "api.video"}}) {
        foreignId
      }
    }
  }
}
    `;
export type AddNodeVideoFileMutationFn = Apollo.MutationFunction<AddNodeVideoFileMutation, AddNodeVideoFileMutationVariables>;

/**
 * __useAddNodeVideoFileMutation__
 *
 * To run a mutation, you first call `useAddNodeVideoFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNodeVideoFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNodeVideoFileMutation, { data, loading, error }] = useAddNodeVideoFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      nodeId: // value for 'nodeId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useAddNodeVideoFileMutation(baseOptions?: Apollo.MutationHookOptions<AddNodeVideoFileMutation, AddNodeVideoFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNodeVideoFileMutation, AddNodeVideoFileMutationVariables>(AddNodeVideoFileDocument, options);
      }
export type AddNodeVideoFileMutationHookResult = ReturnType<typeof useAddNodeVideoFileMutation>;
export type AddNodeVideoFileMutationResult = Apollo.MutationResult<AddNodeVideoFileMutation>;
export type AddNodeVideoFileMutationOptions = Apollo.BaseMutationOptions<AddNodeVideoFileMutation, AddNodeVideoFileMutationVariables>;
export const DeleteNodeVideoFileDocument = gql`
    mutation DeleteNodeVideoFile($nodeId: uuid!, $nodeVideoId: String!) {
  delete_user_file_integration(where: {foreignId: {_eq: $nodeVideoId}}) {
    returning {
      fileId
    }
  }
  update_path_node_by_pk(pk_columns: {id: $nodeId}, _set: {videoFileId: null}) {
    id
    videoFile {
      integrations(where: {source: {_eq: "api.video"}}) {
        foreignId
      }
    }
  }
}
    `;
export type DeleteNodeVideoFileMutationFn = Apollo.MutationFunction<DeleteNodeVideoFileMutation, DeleteNodeVideoFileMutationVariables>;

/**
 * __useDeleteNodeVideoFileMutation__
 *
 * To run a mutation, you first call `useDeleteNodeVideoFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNodeVideoFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNodeVideoFileMutation, { data, loading, error }] = useDeleteNodeVideoFileMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *      nodeVideoId: // value for 'nodeVideoId'
 *   },
 * });
 */
export function useDeleteNodeVideoFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNodeVideoFileMutation, DeleteNodeVideoFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNodeVideoFileMutation, DeleteNodeVideoFileMutationVariables>(DeleteNodeVideoFileDocument, options);
      }
export type DeleteNodeVideoFileMutationHookResult = ReturnType<typeof useDeleteNodeVideoFileMutation>;
export type DeleteNodeVideoFileMutationResult = Apollo.MutationResult<DeleteNodeVideoFileMutation>;
export type DeleteNodeVideoFileMutationOptions = Apollo.BaseMutationOptions<DeleteNodeVideoFileMutation, DeleteNodeVideoFileMutationVariables>;
export const GetPathActivityForPathDocument = gql`
    query GetPathActivityForPath($pathId: bigint!) {
  pathActivity: path_activity(
    order_by: {createdAt: desc_nulls_last}
    where: {pathId: {_eq: $pathId}}
  ) {
    ...PathActivity
    createdAt
  }
}
    ${PathActivityFragmentDoc}`;

/**
 * __useGetPathActivityForPathQuery__
 *
 * To run a query within a React component, call `useGetPathActivityForPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPathActivityForPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPathActivityForPathQuery({
 *   variables: {
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function useGetPathActivityForPathQuery(baseOptions: Apollo.QueryHookOptions<GetPathActivityForPathQuery, GetPathActivityForPathQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPathActivityForPathQuery, GetPathActivityForPathQueryVariables>(GetPathActivityForPathDocument, options);
      }
export function useGetPathActivityForPathLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPathActivityForPathQuery, GetPathActivityForPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPathActivityForPathQuery, GetPathActivityForPathQueryVariables>(GetPathActivityForPathDocument, options);
        }
export type GetPathActivityForPathQueryHookResult = ReturnType<typeof useGetPathActivityForPathQuery>;
export type GetPathActivityForPathLazyQueryHookResult = ReturnType<typeof useGetPathActivityForPathLazyQuery>;
export type GetPathActivityForPathQueryResult = Apollo.QueryResult<GetPathActivityForPathQuery, GetPathActivityForPathQueryVariables>;
export const GetPathCardByIdDocument = gql`
    query GetPathCardById($pathId: bigint!) {
  path: path_by_pk(id: $pathId) {
    ...PathCard
  }
}
    ${PathCardFragmentDoc}`;

/**
 * __useGetPathCardByIdQuery__
 *
 * To run a query within a React component, call `useGetPathCardByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPathCardByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPathCardByIdQuery({
 *   variables: {
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function useGetPathCardByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPathCardByIdQuery, GetPathCardByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPathCardByIdQuery, GetPathCardByIdQueryVariables>(GetPathCardByIdDocument, options);
      }
export function useGetPathCardByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPathCardByIdQuery, GetPathCardByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPathCardByIdQuery, GetPathCardByIdQueryVariables>(GetPathCardByIdDocument, options);
        }
export type GetPathCardByIdQueryHookResult = ReturnType<typeof useGetPathCardByIdQuery>;
export type GetPathCardByIdLazyQueryHookResult = ReturnType<typeof useGetPathCardByIdLazyQuery>;
export type GetPathCardByIdQueryResult = Apollo.QueryResult<GetPathCardByIdQuery, GetPathCardByIdQueryVariables>;
export const ExploreCreatorsUsersDocument = gql`
    query ExploreCreatorsUsers($offset: Int!, $limit: Int!, $where: view_top_creators_by_followers_count_bool_exp) @cached(ttl: 300) {
  topCreators: view_top_creators_by_followers_count(
    limit: $limit
    offset: $offset
    where: $where
    order_by: {followersCount: desc}
  ) {
    user {
      ...ExploreCreatorUser
    }
  }
}
    ${ExploreCreatorUserFragmentDoc}`;

/**
 * __useExploreCreatorsUsersQuery__
 *
 * To run a query within a React component, call `useExploreCreatorsUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExploreCreatorsUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExploreCreatorsUsersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useExploreCreatorsUsersQuery(baseOptions: Apollo.QueryHookOptions<ExploreCreatorsUsersQuery, ExploreCreatorsUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExploreCreatorsUsersQuery, ExploreCreatorsUsersQueryVariables>(ExploreCreatorsUsersDocument, options);
      }
export function useExploreCreatorsUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExploreCreatorsUsersQuery, ExploreCreatorsUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExploreCreatorsUsersQuery, ExploreCreatorsUsersQueryVariables>(ExploreCreatorsUsersDocument, options);
        }
export type ExploreCreatorsUsersQueryHookResult = ReturnType<typeof useExploreCreatorsUsersQuery>;
export type ExploreCreatorsUsersLazyQueryHookResult = ReturnType<typeof useExploreCreatorsUsersLazyQuery>;
export type ExploreCreatorsUsersQueryResult = Apollo.QueryResult<ExploreCreatorsUsersQuery, ExploreCreatorsUsersQueryVariables>;
export const ExploreOrganizationDocument = gql`
    query ExploreOrganization($orgId: String!) {
  organization_by_pk(firestoreId: $orgId) {
    id: firestoreId
    avatar
    name
  }
}
    `;

/**
 * __useExploreOrganizationQuery__
 *
 * To run a query within a React component, call `useExploreOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useExploreOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExploreOrganizationQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useExploreOrganizationQuery(baseOptions: Apollo.QueryHookOptions<ExploreOrganizationQuery, ExploreOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExploreOrganizationQuery, ExploreOrganizationQueryVariables>(ExploreOrganizationDocument, options);
      }
export function useExploreOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExploreOrganizationQuery, ExploreOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExploreOrganizationQuery, ExploreOrganizationQueryVariables>(ExploreOrganizationDocument, options);
        }
export type ExploreOrganizationQueryHookResult = ReturnType<typeof useExploreOrganizationQuery>;
export type ExploreOrganizationLazyQueryHookResult = ReturnType<typeof useExploreOrganizationLazyQuery>;
export type ExploreOrganizationQueryResult = Apollo.QueryResult<ExploreOrganizationQuery, ExploreOrganizationQueryVariables>;
export const PathFeedDocument = gql`
    query PathFeed($status: String!, $visibility: String!, $interestArea: String_comparison_exp, $subjects: jsonb_comparison_exp, $skills: jsonb_comparison_exp, $orgId: String_comparison_exp, $limit: Int!, $offset: Int!, $tags: jsonb_comparison_exp, $isVisibleUnauthed: Boolean_comparison_exp) @cached(ttl: 120) {
  paths: path(
    limit: $limit
    offset: $offset
    order_by: {publishedAt: desc_nulls_last}
    where: {_schemaVersion: {_eq: 3}, status: {_eq: $status}, visibility: {_eq: $visibility}, interestArea: $interestArea, subjects: $subjects, skills: $skills, orgId: $orgId, tags: $tags, isVisibleUnauthed: $isVisibleUnauthed}
  ) {
    ...PathCard
  }
}
    ${PathCardFragmentDoc}`;

/**
 * __usePathFeedQuery__
 *
 * To run a query within a React component, call `usePathFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathFeedQuery({
 *   variables: {
 *      status: // value for 'status'
 *      visibility: // value for 'visibility'
 *      interestArea: // value for 'interestArea'
 *      subjects: // value for 'subjects'
 *      skills: // value for 'skills'
 *      orgId: // value for 'orgId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      tags: // value for 'tags'
 *      isVisibleUnauthed: // value for 'isVisibleUnauthed'
 *   },
 * });
 */
export function usePathFeedQuery(baseOptions: Apollo.QueryHookOptions<PathFeedQuery, PathFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PathFeedQuery, PathFeedQueryVariables>(PathFeedDocument, options);
      }
export function usePathFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PathFeedQuery, PathFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PathFeedQuery, PathFeedQueryVariables>(PathFeedDocument, options);
        }
export type PathFeedQueryHookResult = ReturnType<typeof usePathFeedQuery>;
export type PathFeedLazyQueryHookResult = ReturnType<typeof usePathFeedLazyQuery>;
export type PathFeedQueryResult = Apollo.QueryResult<PathFeedQuery, PathFeedQueryVariables>;
export const PathsByIdDocument = gql`
    query PathsById($pathIds: [bigint!]!, $limit: Int = 20, $offset: Int = 0, $status: String!) {
  paths: path(
    limit: $limit
    offset: $offset
    order_by: {createdAt: desc}
    where: {id: {_in: $pathIds}, status: {_eq: $status}, isPublished: {_eq: true}}
  ) {
    ...PathCard
  }
}
    ${PathCardFragmentDoc}`;

/**
 * __usePathsByIdQuery__
 *
 * To run a query within a React component, call `usePathsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathsByIdQuery({
 *   variables: {
 *      pathIds: // value for 'pathIds'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      status: // value for 'status'
 *   },
 * });
 */
export function usePathsByIdQuery(baseOptions: Apollo.QueryHookOptions<PathsByIdQuery, PathsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PathsByIdQuery, PathsByIdQueryVariables>(PathsByIdDocument, options);
      }
export function usePathsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PathsByIdQuery, PathsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PathsByIdQuery, PathsByIdQueryVariables>(PathsByIdDocument, options);
        }
export type PathsByIdQueryHookResult = ReturnType<typeof usePathsByIdQuery>;
export type PathsByIdLazyQueryHookResult = ReturnType<typeof usePathsByIdLazyQuery>;
export type PathsByIdQueryResult = Apollo.QueryResult<PathsByIdQuery, PathsByIdQueryVariables>;
export const HomePathSectionDocument = gql`
    query HomePathSection($limit: Int!, $isPublished: Boolean!, $visibility: String!) @cached(ttl: 120) {
  paths: path(
    limit: $limit
    order_by: {publishedAt: desc_nulls_last}
    where: {orgId: {_is_null: true}, isPublished: {_eq: $isPublished}, visibility: {_eq: $visibility}}
  ) {
    ...PathCard
  }
}
    ${PathCardFragmentDoc}`;

/**
 * __useHomePathSectionQuery__
 *
 * To run a query within a React component, call `useHomePathSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePathSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePathSectionQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      isPublished: // value for 'isPublished'
 *      visibility: // value for 'visibility'
 *   },
 * });
 */
export function useHomePathSectionQuery(baseOptions: Apollo.QueryHookOptions<HomePathSectionQuery, HomePathSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomePathSectionQuery, HomePathSectionQueryVariables>(HomePathSectionDocument, options);
      }
export function useHomePathSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomePathSectionQuery, HomePathSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomePathSectionQuery, HomePathSectionQueryVariables>(HomePathSectionDocument, options);
        }
export type HomePathSectionQueryHookResult = ReturnType<typeof useHomePathSectionQuery>;
export type HomePathSectionLazyQueryHookResult = ReturnType<typeof useHomePathSectionLazyQuery>;
export type HomePathSectionQueryResult = Apollo.QueryResult<HomePathSectionQuery, HomePathSectionQueryVariables>;
export const GetPathFeedDocument = gql`
    query GetPathFeed($slug: String!, $limit: Int = 4, $offset: Int = 0) {
  paths: path_feed(
    where: {slug: {_eq: $slug}, path: {status: {_eq: "PUBLISHED"}}}
    order_by: {createdAt: desc}
    limit: $limit
    offset: $offset
  ) {
    slug
    pathId
    path {
      ...PathCard
    }
  }
}
    ${PathCardFragmentDoc}`;

/**
 * __useGetPathFeedQuery__
 *
 * To run a query within a React component, call `useGetPathFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPathFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPathFeedQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetPathFeedQuery(baseOptions: Apollo.QueryHookOptions<GetPathFeedQuery, GetPathFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPathFeedQuery, GetPathFeedQueryVariables>(GetPathFeedDocument, options);
      }
export function useGetPathFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPathFeedQuery, GetPathFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPathFeedQuery, GetPathFeedQueryVariables>(GetPathFeedDocument, options);
        }
export type GetPathFeedQueryHookResult = ReturnType<typeof useGetPathFeedQuery>;
export type GetPathFeedLazyQueryHookResult = ReturnType<typeof useGetPathFeedLazyQuery>;
export type GetPathFeedQueryResult = Apollo.QueryResult<GetPathFeedQuery, GetPathFeedQueryVariables>;
export const HomeAwesomeProjectsDocument = gql`
    query HomeAwesomeProjects($limit: Int!, $offset: Int!, $where: project_bool_exp!) {
  projects: project(
    where: $where
    limit: $limit
    offset: $offset
    order_by: {createdAt: desc}
  ) {
    ...projectCard
  }
}
    ${ProjectCardFragmentDoc}`;

/**
 * __useHomeAwesomeProjectsQuery__
 *
 * To run a query within a React component, call `useHomeAwesomeProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeAwesomeProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeAwesomeProjectsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useHomeAwesomeProjectsQuery(baseOptions: Apollo.QueryHookOptions<HomeAwesomeProjectsQuery, HomeAwesomeProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeAwesomeProjectsQuery, HomeAwesomeProjectsQueryVariables>(HomeAwesomeProjectsDocument, options);
      }
export function useHomeAwesomeProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeAwesomeProjectsQuery, HomeAwesomeProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeAwesomeProjectsQuery, HomeAwesomeProjectsQueryVariables>(HomeAwesomeProjectsDocument, options);
        }
export type HomeAwesomeProjectsQueryHookResult = ReturnType<typeof useHomeAwesomeProjectsQuery>;
export type HomeAwesomeProjectsLazyQueryHookResult = ReturnType<typeof useHomeAwesomeProjectsLazyQuery>;
export type HomeAwesomeProjectsQueryResult = Apollo.QueryResult<HomeAwesomeProjectsQuery, HomeAwesomeProjectsQueryVariables>;
export const HomeLivestreamSectionDocument = gql`
    query HomeLivestreamSection($limit: Int!, $startDate: timestamptz!) {
  livestreams: livestream(
    limit: $limit
    offset: 0
    order_by: {startDate: asc}
    where: {_or: [{startDate: {_gte: $startDate}}, {endDate: {_gte: $startDate}}], disabled: {_eq: false}}
  ) {
    ...Livestream
  }
}
    ${LivestreamFragmentDoc}`;

/**
 * __useHomeLivestreamSectionQuery__
 *
 * To run a query within a React component, call `useHomeLivestreamSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeLivestreamSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeLivestreamSectionQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useHomeLivestreamSectionQuery(baseOptions: Apollo.QueryHookOptions<HomeLivestreamSectionQuery, HomeLivestreamSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeLivestreamSectionQuery, HomeLivestreamSectionQueryVariables>(HomeLivestreamSectionDocument, options);
      }
export function useHomeLivestreamSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeLivestreamSectionQuery, HomeLivestreamSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeLivestreamSectionQuery, HomeLivestreamSectionQueryVariables>(HomeLivestreamSectionDocument, options);
        }
export type HomeLivestreamSectionQueryHookResult = ReturnType<typeof useHomeLivestreamSectionQuery>;
export type HomeLivestreamSectionLazyQueryHookResult = ReturnType<typeof useHomeLivestreamSectionLazyQuery>;
export type HomeLivestreamSectionQueryResult = Apollo.QueryResult<HomeLivestreamSectionQuery, HomeLivestreamSectionQueryVariables>;
export const PathsByTagSectionDocument = gql`
    query PathsByTagSection($limit: Int!, $tag: jsonb!) {
  paths: path(
    limit: $limit
    offset: 0
    order_by: {publishedAt: desc_nulls_last}
    where: {status: {_eq: "PUBLISHED"}, tags: {_contains: $tag}}
  ) {
    ...PathCard
  }
}
    ${PathCardFragmentDoc}`;

/**
 * __usePathsByTagSectionQuery__
 *
 * To run a query within a React component, call `usePathsByTagSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathsByTagSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathsByTagSectionQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function usePathsByTagSectionQuery(baseOptions: Apollo.QueryHookOptions<PathsByTagSectionQuery, PathsByTagSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PathsByTagSectionQuery, PathsByTagSectionQueryVariables>(PathsByTagSectionDocument, options);
      }
export function usePathsByTagSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PathsByTagSectionQuery, PathsByTagSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PathsByTagSectionQuery, PathsByTagSectionQueryVariables>(PathsByTagSectionDocument, options);
        }
export type PathsByTagSectionQueryHookResult = ReturnType<typeof usePathsByTagSectionQuery>;
export type PathsByTagSectionLazyQueryHookResult = ReturnType<typeof usePathsByTagSectionLazyQuery>;
export type PathsByTagSectionQueryResult = Apollo.QueryResult<PathsByTagSectionQuery, PathsByTagSectionQueryVariables>;
export const UpdateLearnerGroupColorDocument = gql`
    mutation UpdateLearnerGroupColor($learnerGroupId: uuid!, $color: String!) {
  update_learner_group_by_pk(
    pk_columns: {id: $learnerGroupId}
    _set: {color: $color}
  ) {
    id
    color
  }
}
    `;
export type UpdateLearnerGroupColorMutationFn = Apollo.MutationFunction<UpdateLearnerGroupColorMutation, UpdateLearnerGroupColorMutationVariables>;

/**
 * __useUpdateLearnerGroupColorMutation__
 *
 * To run a mutation, you first call `useUpdateLearnerGroupColorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLearnerGroupColorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLearnerGroupColorMutation, { data, loading, error }] = useUpdateLearnerGroupColorMutation({
 *   variables: {
 *      learnerGroupId: // value for 'learnerGroupId'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useUpdateLearnerGroupColorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLearnerGroupColorMutation, UpdateLearnerGroupColorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLearnerGroupColorMutation, UpdateLearnerGroupColorMutationVariables>(UpdateLearnerGroupColorDocument, options);
      }
export type UpdateLearnerGroupColorMutationHookResult = ReturnType<typeof useUpdateLearnerGroupColorMutation>;
export type UpdateLearnerGroupColorMutationResult = Apollo.MutationResult<UpdateLearnerGroupColorMutation>;
export type UpdateLearnerGroupColorMutationOptions = Apollo.BaseMutationOptions<UpdateLearnerGroupColorMutation, UpdateLearnerGroupColorMutationVariables>;
export const ArchiveClassroomDocument = gql`
    mutation ArchiveClassroom($learnerGroupId: uuid!, $archivedAt: timestamptz!) {
  update_learner_group_by_pk(
    pk_columns: {id: $learnerGroupId}
    _set: {archivedAt: $archivedAt}
  ) {
    id
    archivedAt
  }
}
    `;
export type ArchiveClassroomMutationFn = Apollo.MutationFunction<ArchiveClassroomMutation, ArchiveClassroomMutationVariables>;

/**
 * __useArchiveClassroomMutation__
 *
 * To run a mutation, you first call `useArchiveClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveClassroomMutation, { data, loading, error }] = useArchiveClassroomMutation({
 *   variables: {
 *      learnerGroupId: // value for 'learnerGroupId'
 *      archivedAt: // value for 'archivedAt'
 *   },
 * });
 */
export function useArchiveClassroomMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveClassroomMutation, ArchiveClassroomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveClassroomMutation, ArchiveClassroomMutationVariables>(ArchiveClassroomDocument, options);
      }
export type ArchiveClassroomMutationHookResult = ReturnType<typeof useArchiveClassroomMutation>;
export type ArchiveClassroomMutationResult = Apollo.MutationResult<ArchiveClassroomMutation>;
export type ArchiveClassroomMutationOptions = Apollo.BaseMutationOptions<ArchiveClassroomMutation, ArchiveClassroomMutationVariables>;
export const GetFeaturedClassesDocument = gql`
    query GetFeaturedClasses($limit: Int) {
  paths: path(
    limit: $limit
    where: {isFeatured: {_eq: true}, status: {_eq: "PUBLISHED"}}
    order_by: {publishedAt: desc}
  ) {
    ...FeaturedClass
  }
}
    ${FeaturedClassFragmentDoc}`;

/**
 * __useGetFeaturedClassesQuery__
 *
 * To run a query within a React component, call `useGetFeaturedClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedClassesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetFeaturedClassesQuery(baseOptions?: Apollo.QueryHookOptions<GetFeaturedClassesQuery, GetFeaturedClassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedClassesQuery, GetFeaturedClassesQueryVariables>(GetFeaturedClassesDocument, options);
      }
export function useGetFeaturedClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedClassesQuery, GetFeaturedClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedClassesQuery, GetFeaturedClassesQueryVariables>(GetFeaturedClassesDocument, options);
        }
export type GetFeaturedClassesQueryHookResult = ReturnType<typeof useGetFeaturedClassesQuery>;
export type GetFeaturedClassesLazyQueryHookResult = ReturnType<typeof useGetFeaturedClassesLazyQuery>;
export type GetFeaturedClassesQueryResult = Apollo.QueryResult<GetFeaturedClassesQuery, GetFeaturedClassesQueryVariables>;
export const GetUserInvitesDocument = gql`
    query GetUserInvites($userId: String!) {
  educator_code(
    where: {userId: {_eq: $userId}, type: {_eq: "kid_invite"}, learnerGroupId: {_is_null: true}}
    order_by: {createdAt: desc}
  ) {
    available
    code
    expiresAt
    createdAt
  }
}
    `;

/**
 * __useGetUserInvitesQuery__
 *
 * To run a query within a React component, call `useGetUserInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInvitesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserInvitesQuery(baseOptions: Apollo.QueryHookOptions<GetUserInvitesQuery, GetUserInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserInvitesQuery, GetUserInvitesQueryVariables>(GetUserInvitesDocument, options);
      }
export function useGetUserInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserInvitesQuery, GetUserInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserInvitesQuery, GetUserInvitesQueryVariables>(GetUserInvitesDocument, options);
        }
export type GetUserInvitesQueryHookResult = ReturnType<typeof useGetUserInvitesQuery>;
export type GetUserInvitesLazyQueryHookResult = ReturnType<typeof useGetUserInvitesLazyQuery>;
export type GetUserInvitesQueryResult = Apollo.QueryResult<GetUserInvitesQuery, GetUserInvitesQueryVariables>;
export const ClassroomsByLearnerIdDocument = gql`
    query ClassroomsByLearnerId($userId: String!) {
  learnerGroups: learner_group(
    where: {members: {userId: {_eq: $userId}}, archivedAt: {_eq: "-infinity"}}
    order_by: {createdAt: desc}
  ) {
    ...ClassroomLearnerGroup
  }
}
    ${ClassroomLearnerGroupFragmentDoc}`;

/**
 * __useClassroomsByLearnerIdQuery__
 *
 * To run a query within a React component, call `useClassroomsByLearnerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomsByLearnerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomsByLearnerIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useClassroomsByLearnerIdQuery(baseOptions: Apollo.QueryHookOptions<ClassroomsByLearnerIdQuery, ClassroomsByLearnerIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassroomsByLearnerIdQuery, ClassroomsByLearnerIdQueryVariables>(ClassroomsByLearnerIdDocument, options);
      }
export function useClassroomsByLearnerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassroomsByLearnerIdQuery, ClassroomsByLearnerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassroomsByLearnerIdQuery, ClassroomsByLearnerIdQueryVariables>(ClassroomsByLearnerIdDocument, options);
        }
export type ClassroomsByLearnerIdQueryHookResult = ReturnType<typeof useClassroomsByLearnerIdQuery>;
export type ClassroomsByLearnerIdLazyQueryHookResult = ReturnType<typeof useClassroomsByLearnerIdLazyQuery>;
export type ClassroomsByLearnerIdQueryResult = Apollo.QueryResult<ClassroomsByLearnerIdQuery, ClassroomsByLearnerIdQueryVariables>;
export const DeleteLearnerGroupMemberDocument = gql`
    mutation DeleteLearnerGroupMember($classId: uuid!, $learnerId: String!) {
  delete_learner_group_member_by_pk(learnerGroupId: $classId, userId: $learnerId) {
    learnerGroupId
    userId
  }
}
    `;
export type DeleteLearnerGroupMemberMutationFn = Apollo.MutationFunction<DeleteLearnerGroupMemberMutation, DeleteLearnerGroupMemberMutationVariables>;

/**
 * __useDeleteLearnerGroupMemberMutation__
 *
 * To run a mutation, you first call `useDeleteLearnerGroupMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLearnerGroupMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLearnerGroupMemberMutation, { data, loading, error }] = useDeleteLearnerGroupMemberMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *      learnerId: // value for 'learnerId'
 *   },
 * });
 */
export function useDeleteLearnerGroupMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLearnerGroupMemberMutation, DeleteLearnerGroupMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLearnerGroupMemberMutation, DeleteLearnerGroupMemberMutationVariables>(DeleteLearnerGroupMemberDocument, options);
      }
export type DeleteLearnerGroupMemberMutationHookResult = ReturnType<typeof useDeleteLearnerGroupMemberMutation>;
export type DeleteLearnerGroupMemberMutationResult = Apollo.MutationResult<DeleteLearnerGroupMemberMutation>;
export type DeleteLearnerGroupMemberMutationOptions = Apollo.BaseMutationOptions<DeleteLearnerGroupMemberMutation, DeleteLearnerGroupMemberMutationVariables>;
export const DeletePendingLearnerGroupMemberDocument = gql`
    mutation DeletePendingLearnerGroupMember($classId: uuid!, $foreignId: String!, $provider: enums_integration_provider_enum!) {
  delete_learner_group_pending_member_by_pk(
    learnerGroupId: $classId
    foreignId: $foreignId
    provider: $provider
  ) {
    learnerGroupId
    foreignId
    provider
  }
}
    `;
export type DeletePendingLearnerGroupMemberMutationFn = Apollo.MutationFunction<DeletePendingLearnerGroupMemberMutation, DeletePendingLearnerGroupMemberMutationVariables>;

/**
 * __useDeletePendingLearnerGroupMemberMutation__
 *
 * To run a mutation, you first call `useDeletePendingLearnerGroupMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePendingLearnerGroupMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePendingLearnerGroupMemberMutation, { data, loading, error }] = useDeletePendingLearnerGroupMemberMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *      foreignId: // value for 'foreignId'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useDeletePendingLearnerGroupMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeletePendingLearnerGroupMemberMutation, DeletePendingLearnerGroupMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePendingLearnerGroupMemberMutation, DeletePendingLearnerGroupMemberMutationVariables>(DeletePendingLearnerGroupMemberDocument, options);
      }
export type DeletePendingLearnerGroupMemberMutationHookResult = ReturnType<typeof useDeletePendingLearnerGroupMemberMutation>;
export type DeletePendingLearnerGroupMemberMutationResult = Apollo.MutationResult<DeletePendingLearnerGroupMemberMutation>;
export type DeletePendingLearnerGroupMemberMutationOptions = Apollo.BaseMutationOptions<DeletePendingLearnerGroupMemberMutation, DeletePendingLearnerGroupMemberMutationVariables>;
export const LearnersByUserIdsDocument = gql`
    query LearnersByUserIds($userIds: [String!]!) {
  users: user(where: {firestoreId: {_in: $userIds}, username: {_is_null: false}}) {
    ...LearnerRowUser
  }
}
    ${LearnerRowUserFragmentDoc}`;

/**
 * __useLearnersByUserIdsQuery__
 *
 * To run a query within a React component, call `useLearnersByUserIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearnersByUserIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearnersByUserIdsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useLearnersByUserIdsQuery(baseOptions: Apollo.QueryHookOptions<LearnersByUserIdsQuery, LearnersByUserIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearnersByUserIdsQuery, LearnersByUserIdsQueryVariables>(LearnersByUserIdsDocument, options);
      }
export function useLearnersByUserIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearnersByUserIdsQuery, LearnersByUserIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearnersByUserIdsQuery, LearnersByUserIdsQueryVariables>(LearnersByUserIdsDocument, options);
        }
export type LearnersByUserIdsQueryHookResult = ReturnType<typeof useLearnersByUserIdsQuery>;
export type LearnersByUserIdsLazyQueryHookResult = ReturnType<typeof useLearnersByUserIdsLazyQuery>;
export type LearnersByUserIdsQueryResult = Apollo.QueryResult<LearnersByUserIdsQuery, LearnersByUserIdsQueryVariables>;
export const GetUserCoinBalancesDocument = gql`
    query GetUserCoinBalances($userIds: [String!]!) {
  balances: coin_trx(
    distinct_on: [userId]
    where: {userId: {_in: $userIds}}
    order_by: [{userId: asc}, {createdAt: desc}]
  ) {
    userId
    balance
  }
}
    `;

/**
 * __useGetUserCoinBalancesQuery__
 *
 * To run a query within a React component, call `useGetUserCoinBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCoinBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCoinBalancesQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetUserCoinBalancesQuery(baseOptions: Apollo.QueryHookOptions<GetUserCoinBalancesQuery, GetUserCoinBalancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCoinBalancesQuery, GetUserCoinBalancesQueryVariables>(GetUserCoinBalancesDocument, options);
      }
export function useGetUserCoinBalancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCoinBalancesQuery, GetUserCoinBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCoinBalancesQuery, GetUserCoinBalancesQueryVariables>(GetUserCoinBalancesDocument, options);
        }
export type GetUserCoinBalancesQueryHookResult = ReturnType<typeof useGetUserCoinBalancesQuery>;
export type GetUserCoinBalancesLazyQueryHookResult = ReturnType<typeof useGetUserCoinBalancesLazyQuery>;
export type GetUserCoinBalancesQueryResult = Apollo.QueryResult<GetUserCoinBalancesQuery, GetUserCoinBalancesQueryVariables>;
export const UserProjectsCompletedDocument = gql`
    query UserProjectsCompleted($userIds: [String!]!) {
  user(where: {firestoreId: {_in: $userIds}}) {
    id: firestoreId
    projects_aggregate(
      where: {rejectedAt: {_eq: "-infinity"}, published: {_eq: true}, file: {transforms: {}}}
    ) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useUserProjectsCompletedQuery__
 *
 * To run a query within a React component, call `useUserProjectsCompletedQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProjectsCompletedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProjectsCompletedQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useUserProjectsCompletedQuery(baseOptions: Apollo.QueryHookOptions<UserProjectsCompletedQuery, UserProjectsCompletedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProjectsCompletedQuery, UserProjectsCompletedQueryVariables>(UserProjectsCompletedDocument, options);
      }
export function useUserProjectsCompletedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProjectsCompletedQuery, UserProjectsCompletedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProjectsCompletedQuery, UserProjectsCompletedQueryVariables>(UserProjectsCompletedDocument, options);
        }
export type UserProjectsCompletedQueryHookResult = ReturnType<typeof useUserProjectsCompletedQuery>;
export type UserProjectsCompletedLazyQueryHookResult = ReturnType<typeof useUserProjectsCompletedLazyQuery>;
export type UserProjectsCompletedQueryResult = Apollo.QueryResult<UserProjectsCompletedQuery, UserProjectsCompletedQueryVariables>;
export const LivestreamGalleryDocument = gql`
    query LivestreamGallery($limit: Int!, $startDateStart: timestamptz!, $startDateEnd: timestamptz!) {
  livestreams: livestream(
    limit: $limit
    offset: 0
    order_by: {startDate: asc}
    where: {_or: [{startDate: {_gte: $startDateStart, _lte: $startDateEnd}}, {endDate: {_gte: $startDateStart, _lte: $startDateEnd}}], disabled: {_eq: false}}
  ) {
    ...Livestream
  }
}
    ${LivestreamFragmentDoc}`;

/**
 * __useLivestreamGalleryQuery__
 *
 * To run a query within a React component, call `useLivestreamGalleryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLivestreamGalleryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLivestreamGalleryQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      startDateStart: // value for 'startDateStart'
 *      startDateEnd: // value for 'startDateEnd'
 *   },
 * });
 */
export function useLivestreamGalleryQuery(baseOptions: Apollo.QueryHookOptions<LivestreamGalleryQuery, LivestreamGalleryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LivestreamGalleryQuery, LivestreamGalleryQueryVariables>(LivestreamGalleryDocument, options);
      }
export function useLivestreamGalleryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LivestreamGalleryQuery, LivestreamGalleryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LivestreamGalleryQuery, LivestreamGalleryQueryVariables>(LivestreamGalleryDocument, options);
        }
export type LivestreamGalleryQueryHookResult = ReturnType<typeof useLivestreamGalleryQuery>;
export type LivestreamGalleryLazyQueryHookResult = ReturnType<typeof useLivestreamGalleryLazyQuery>;
export type LivestreamGalleryQueryResult = Apollo.QueryResult<LivestreamGalleryQuery, LivestreamGalleryQueryVariables>;
export const NotificationUserDocument = gql`
    query NotificationUser($userId: String!) {
  users: user(limit: 1, where: {firestoreId: {_eq: $userId}}) {
    ...NotificationUser
  }
}
    ${NotificationUserFragmentDoc}`;

/**
 * __useNotificationUserQuery__
 *
 * To run a query within a React component, call `useNotificationUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useNotificationUserQuery(baseOptions: Apollo.QueryHookOptions<NotificationUserQuery, NotificationUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationUserQuery, NotificationUserQueryVariables>(NotificationUserDocument, options);
      }
export function useNotificationUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationUserQuery, NotificationUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationUserQuery, NotificationUserQueryVariables>(NotificationUserDocument, options);
        }
export type NotificationUserQueryHookResult = ReturnType<typeof useNotificationUserQuery>;
export type NotificationUserLazyQueryHookResult = ReturnType<typeof useNotificationUserLazyQuery>;
export type NotificationUserQueryResult = Apollo.QueryResult<NotificationUserQuery, NotificationUserQueryVariables>;
export const ProjectByIdDocument = gql`
    query ProjectById($projectId: uuid!) {
  projects: project(where: {id: {_eq: $projectId}}) {
    ...projectCard
  }
}
    ${ProjectCardFragmentDoc}`;

/**
 * __useProjectByIdQuery__
 *
 * To run a query within a React component, call `useProjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectByIdQuery(baseOptions: Apollo.QueryHookOptions<ProjectByIdQuery, ProjectByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectByIdQuery, ProjectByIdQueryVariables>(ProjectByIdDocument, options);
      }
export function useProjectByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectByIdQuery, ProjectByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectByIdQuery, ProjectByIdQueryVariables>(ProjectByIdDocument, options);
        }
export type ProjectByIdQueryHookResult = ReturnType<typeof useProjectByIdQuery>;
export type ProjectByIdLazyQueryHookResult = ReturnType<typeof useProjectByIdLazyQuery>;
export type ProjectByIdQueryResult = Apollo.QueryResult<ProjectByIdQuery, ProjectByIdQueryVariables>;
export const ProjectChallengeQuestionByIdDocument = gql`
    query ProjectChallengeQuestionById($projectId: uuid!) {
  projects: project(where: {id: {_eq: $projectId}}) {
    ...ProjectChallengeQuestion
  }
}
    ${ProjectChallengeQuestionFragmentDoc}`;

/**
 * __useProjectChallengeQuestionByIdQuery__
 *
 * To run a query within a React component, call `useProjectChallengeQuestionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectChallengeQuestionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectChallengeQuestionByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectChallengeQuestionByIdQuery(baseOptions: Apollo.QueryHookOptions<ProjectChallengeQuestionByIdQuery, ProjectChallengeQuestionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectChallengeQuestionByIdQuery, ProjectChallengeQuestionByIdQueryVariables>(ProjectChallengeQuestionByIdDocument, options);
      }
export function useProjectChallengeQuestionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectChallengeQuestionByIdQuery, ProjectChallengeQuestionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectChallengeQuestionByIdQuery, ProjectChallengeQuestionByIdQueryVariables>(ProjectChallengeQuestionByIdDocument, options);
        }
export type ProjectChallengeQuestionByIdQueryHookResult = ReturnType<typeof useProjectChallengeQuestionByIdQuery>;
export type ProjectChallengeQuestionByIdLazyQueryHookResult = ReturnType<typeof useProjectChallengeQuestionByIdLazyQuery>;
export type ProjectChallengeQuestionByIdQueryResult = Apollo.QueryResult<ProjectChallengeQuestionByIdQuery, ProjectChallengeQuestionByIdQueryVariables>;
export const PathIdTitleSlugNodeIdsByIdDocument = gql`
    query PathIdTitleSlugNodeIdsById($pathId: bigint!) {
  path: path_by_pk(id: $pathId) {
    ...PathIdTitleSlugNodeIds
  }
}
    ${PathIdTitleSlugNodeIdsFragmentDoc}`;

/**
 * __usePathIdTitleSlugNodeIdsByIdQuery__
 *
 * To run a query within a React component, call `usePathIdTitleSlugNodeIdsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathIdTitleSlugNodeIdsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathIdTitleSlugNodeIdsByIdQuery({
 *   variables: {
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function usePathIdTitleSlugNodeIdsByIdQuery(baseOptions: Apollo.QueryHookOptions<PathIdTitleSlugNodeIdsByIdQuery, PathIdTitleSlugNodeIdsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PathIdTitleSlugNodeIdsByIdQuery, PathIdTitleSlugNodeIdsByIdQueryVariables>(PathIdTitleSlugNodeIdsByIdDocument, options);
      }
export function usePathIdTitleSlugNodeIdsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PathIdTitleSlugNodeIdsByIdQuery, PathIdTitleSlugNodeIdsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PathIdTitleSlugNodeIdsByIdQuery, PathIdTitleSlugNodeIdsByIdQueryVariables>(PathIdTitleSlugNodeIdsByIdDocument, options);
        }
export type PathIdTitleSlugNodeIdsByIdQueryHookResult = ReturnType<typeof usePathIdTitleSlugNodeIdsByIdQuery>;
export type PathIdTitleSlugNodeIdsByIdLazyQueryHookResult = ReturnType<typeof usePathIdTitleSlugNodeIdsByIdLazyQuery>;
export type PathIdTitleSlugNodeIdsByIdQueryResult = Apollo.QueryResult<PathIdTitleSlugNodeIdsByIdQuery, PathIdTitleSlugNodeIdsByIdQueryVariables>;
export const OnboardEducatorStepSchoolDocument = gql`
    mutation OnboardEducatorStepSchool($orgId: String, $placeId: String, $gradeLevel: String) {
  api_onboard_educator(orgId: $orgId, placeId: $placeId, gradeLevel: $gradeLevel) {
    orgId
  }
}
    `;
export type OnboardEducatorStepSchoolMutationFn = Apollo.MutationFunction<OnboardEducatorStepSchoolMutation, OnboardEducatorStepSchoolMutationVariables>;

/**
 * __useOnboardEducatorStepSchoolMutation__
 *
 * To run a mutation, you first call `useOnboardEducatorStepSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardEducatorStepSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardEducatorStepSchoolMutation, { data, loading, error }] = useOnboardEducatorStepSchoolMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      placeId: // value for 'placeId'
 *      gradeLevel: // value for 'gradeLevel'
 *   },
 * });
 */
export function useOnboardEducatorStepSchoolMutation(baseOptions?: Apollo.MutationHookOptions<OnboardEducatorStepSchoolMutation, OnboardEducatorStepSchoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardEducatorStepSchoolMutation, OnboardEducatorStepSchoolMutationVariables>(OnboardEducatorStepSchoolDocument, options);
      }
export type OnboardEducatorStepSchoolMutationHookResult = ReturnType<typeof useOnboardEducatorStepSchoolMutation>;
export type OnboardEducatorStepSchoolMutationResult = Apollo.MutationResult<OnboardEducatorStepSchoolMutation>;
export type OnboardEducatorStepSchoolMutationOptions = Apollo.BaseMutationOptions<OnboardEducatorStepSchoolMutation, OnboardEducatorStepSchoolMutationVariables>;
export const OnboardEducatorStepClassDocument = gql`
    mutation OnboardEducatorStepClass($teacher: user_teacher_insert_input!) {
  teacher: insert_user_teacher_one(object: $teacher) {
    id: userId
    displayName
    lowerGradeLevel
    upperGradeLevel
    subjects
  }
}
    `;
export type OnboardEducatorStepClassMutationFn = Apollo.MutationFunction<OnboardEducatorStepClassMutation, OnboardEducatorStepClassMutationVariables>;

/**
 * __useOnboardEducatorStepClassMutation__
 *
 * To run a mutation, you first call `useOnboardEducatorStepClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardEducatorStepClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardEducatorStepClassMutation, { data, loading, error }] = useOnboardEducatorStepClassMutation({
 *   variables: {
 *      teacher: // value for 'teacher'
 *   },
 * });
 */
export function useOnboardEducatorStepClassMutation(baseOptions?: Apollo.MutationHookOptions<OnboardEducatorStepClassMutation, OnboardEducatorStepClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardEducatorStepClassMutation, OnboardEducatorStepClassMutationVariables>(OnboardEducatorStepClassDocument, options);
      }
export type OnboardEducatorStepClassMutationHookResult = ReturnType<typeof useOnboardEducatorStepClassMutation>;
export type OnboardEducatorStepClassMutationResult = Apollo.MutationResult<OnboardEducatorStepClassMutation>;
export type OnboardEducatorStepClassMutationOptions = Apollo.BaseMutationOptions<OnboardEducatorStepClassMutation, OnboardEducatorStepClassMutationVariables>;
export const GetOnboardedOrgsDocument = gql`
    query GetOnboardedOrgs {
  organizations: api_get_onboarded_orgs {
    id
    name
    isVerified
  }
}
    `;

/**
 * __useGetOnboardedOrgsQuery__
 *
 * To run a query within a React component, call `useGetOnboardedOrgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardedOrgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnboardedOrgsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOnboardedOrgsQuery(baseOptions?: Apollo.QueryHookOptions<GetOnboardedOrgsQuery, GetOnboardedOrgsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOnboardedOrgsQuery, GetOnboardedOrgsQueryVariables>(GetOnboardedOrgsDocument, options);
      }
export function useGetOnboardedOrgsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOnboardedOrgsQuery, GetOnboardedOrgsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOnboardedOrgsQuery, GetOnboardedOrgsQueryVariables>(GetOnboardedOrgsDocument, options);
        }
export type GetOnboardedOrgsQueryHookResult = ReturnType<typeof useGetOnboardedOrgsQuery>;
export type GetOnboardedOrgsLazyQueryHookResult = ReturnType<typeof useGetOnboardedOrgsLazyQuery>;
export type GetOnboardedOrgsQueryResult = Apollo.QueryResult<GetOnboardedOrgsQuery, GetOnboardedOrgsQueryVariables>;
export const OnboardKidDocument = gql`
    mutation OnboardKid($userId: String!, $username: String!, $firstName: String!, $lastName: String!, $birthday: jsonb!) {
  onboard_kid: update_user_by_pk(
    pk_columns: {firestoreId: $userId}
    _set: {firstName: $firstName, lastName: $lastName, username: $username, birthday: $birthday}
  ) {
    firestoreId
    firstName
    lastName
    birthday
  }
}
    `;
export type OnboardKidMutationFn = Apollo.MutationFunction<OnboardKidMutation, OnboardKidMutationVariables>;

/**
 * __useOnboardKidMutation__
 *
 * To run a mutation, you first call `useOnboardKidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardKidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardKidMutation, { data, loading, error }] = useOnboardKidMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      username: // value for 'username'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      birthday: // value for 'birthday'
 *   },
 * });
 */
export function useOnboardKidMutation(baseOptions?: Apollo.MutationHookOptions<OnboardKidMutation, OnboardKidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardKidMutation, OnboardKidMutationVariables>(OnboardKidDocument, options);
      }
export type OnboardKidMutationHookResult = ReturnType<typeof useOnboardKidMutation>;
export type OnboardKidMutationResult = Apollo.MutationResult<OnboardKidMutation>;
export type OnboardKidMutationOptions = Apollo.BaseMutationOptions<OnboardKidMutation, OnboardKidMutationVariables>;
export const AwesomeChallengeProjectsDocument = gql`
    query AwesomeChallengeProjects($limit: Int = 20, $where: project_bool_exp) {
  project(limit: $limit, offset: 0, where: $where, order_by: {createdAt: desc}) {
    ...projectCard
  }
}
    ${ProjectCardFragmentDoc}`;

/**
 * __useAwesomeChallengeProjectsQuery__
 *
 * To run a query within a React component, call `useAwesomeChallengeProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwesomeChallengeProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwesomeChallengeProjectsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAwesomeChallengeProjectsQuery(baseOptions?: Apollo.QueryHookOptions<AwesomeChallengeProjectsQuery, AwesomeChallengeProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwesomeChallengeProjectsQuery, AwesomeChallengeProjectsQueryVariables>(AwesomeChallengeProjectsDocument, options);
      }
export function useAwesomeChallengeProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwesomeChallengeProjectsQuery, AwesomeChallengeProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwesomeChallengeProjectsQuery, AwesomeChallengeProjectsQueryVariables>(AwesomeChallengeProjectsDocument, options);
        }
export type AwesomeChallengeProjectsQueryHookResult = ReturnType<typeof useAwesomeChallengeProjectsQuery>;
export type AwesomeChallengeProjectsLazyQueryHookResult = ReturnType<typeof useAwesomeChallengeProjectsLazyQuery>;
export type AwesomeChallengeProjectsQueryResult = Apollo.QueryResult<AwesomeChallengeProjectsQuery, AwesomeChallengeProjectsQueryVariables>;
export const GetNodeCommentsDocument = gql`
    query GetNodeComments($nodeId: uuid!, $limit: Int!, $offset: Int!, $path: ltree_comparison_exp!) {
  nodeComments: path_node_comment(
    limit: $limit
    offset: $offset
    where: {pathNodeId: {_eq: $nodeId}, comment: {path: $path, deletedAt: {_eq: "-infinity"}}}
    order_by: {comment: {createdAt: desc}}
  ) {
    ...NodeComment
  }
}
    ${NodeCommentFragmentDoc}`;

/**
 * __useGetNodeCommentsQuery__
 *
 * To run a query within a React component, call `useGetNodeCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNodeCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNodeCommentsQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useGetNodeCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetNodeCommentsQuery, GetNodeCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNodeCommentsQuery, GetNodeCommentsQueryVariables>(GetNodeCommentsDocument, options);
      }
export function useGetNodeCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNodeCommentsQuery, GetNodeCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNodeCommentsQuery, GetNodeCommentsQueryVariables>(GetNodeCommentsDocument, options);
        }
export type GetNodeCommentsQueryHookResult = ReturnType<typeof useGetNodeCommentsQuery>;
export type GetNodeCommentsLazyQueryHookResult = ReturnType<typeof useGetNodeCommentsLazyQuery>;
export type GetNodeCommentsQueryResult = Apollo.QueryResult<GetNodeCommentsQuery, GetNodeCommentsQueryVariables>;
export const GetNodeCommentReplyCountDocument = gql`
    query GetNodeCommentReplyCount($nodeId: uuid!, $matches: lquery!) {
  path_node_comment_aggregate(
    where: {pathNodeId: {_eq: $nodeId}, comment: {path: {_matches: $matches}, deletedAt: {_eq: "-infinity"}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetNodeCommentReplyCountQuery__
 *
 * To run a query within a React component, call `useGetNodeCommentReplyCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNodeCommentReplyCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNodeCommentReplyCountQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *      matches: // value for 'matches'
 *   },
 * });
 */
export function useGetNodeCommentReplyCountQuery(baseOptions: Apollo.QueryHookOptions<GetNodeCommentReplyCountQuery, GetNodeCommentReplyCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNodeCommentReplyCountQuery, GetNodeCommentReplyCountQueryVariables>(GetNodeCommentReplyCountDocument, options);
      }
export function useGetNodeCommentReplyCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNodeCommentReplyCountQuery, GetNodeCommentReplyCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNodeCommentReplyCountQuery, GetNodeCommentReplyCountQueryVariables>(GetNodeCommentReplyCountDocument, options);
        }
export type GetNodeCommentReplyCountQueryHookResult = ReturnType<typeof useGetNodeCommentReplyCountQuery>;
export type GetNodeCommentReplyCountLazyQueryHookResult = ReturnType<typeof useGetNodeCommentReplyCountLazyQuery>;
export type GetNodeCommentReplyCountQueryResult = Apollo.QueryResult<GetNodeCommentReplyCountQuery, GetNodeCommentReplyCountQueryVariables>;
export const CreateNodeCommentDocument = gql`
    mutation CreateNodeComment($object: path_node_comment_insert_input!) {
  insert_path_node_comment_one(object: $object) {
    ...NodeComment
  }
}
    ${NodeCommentFragmentDoc}`;
export type CreateNodeCommentMutationFn = Apollo.MutationFunction<CreateNodeCommentMutation, CreateNodeCommentMutationVariables>;

/**
 * __useCreateNodeCommentMutation__
 *
 * To run a mutation, you first call `useCreateNodeCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNodeCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNodeCommentMutation, { data, loading, error }] = useCreateNodeCommentMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useCreateNodeCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateNodeCommentMutation, CreateNodeCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNodeCommentMutation, CreateNodeCommentMutationVariables>(CreateNodeCommentDocument, options);
      }
export type CreateNodeCommentMutationHookResult = ReturnType<typeof useCreateNodeCommentMutation>;
export type CreateNodeCommentMutationResult = Apollo.MutationResult<CreateNodeCommentMutation>;
export type CreateNodeCommentMutationOptions = Apollo.BaseMutationOptions<CreateNodeCommentMutation, CreateNodeCommentMutationVariables>;
export const EditNodeCommentDocument = gql`
    mutation EditNodeComment($commentId: uuid!, $text: String!) {
  update_comment_by_pk(pk_columns: {id: $commentId}, _set: {text: $text}) {
    ...NodeCommentComment
  }
}
    ${NodeCommentCommentFragmentDoc}`;
export type EditNodeCommentMutationFn = Apollo.MutationFunction<EditNodeCommentMutation, EditNodeCommentMutationVariables>;

/**
 * __useEditNodeCommentMutation__
 *
 * To run a mutation, you first call `useEditNodeCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditNodeCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editNodeCommentMutation, { data, loading, error }] = useEditNodeCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useEditNodeCommentMutation(baseOptions?: Apollo.MutationHookOptions<EditNodeCommentMutation, EditNodeCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditNodeCommentMutation, EditNodeCommentMutationVariables>(EditNodeCommentDocument, options);
      }
export type EditNodeCommentMutationHookResult = ReturnType<typeof useEditNodeCommentMutation>;
export type EditNodeCommentMutationResult = Apollo.MutationResult<EditNodeCommentMutation>;
export type EditNodeCommentMutationOptions = Apollo.BaseMutationOptions<EditNodeCommentMutation, EditNodeCommentMutationVariables>;
export const DeleteNodeCommentDocument = gql`
    mutation DeleteNodeComment($commentId: uuid!) {
  update_comment_by_pk(pk_columns: {id: $commentId}, _set: {deletedAt: "now()"}) {
    id
    deletedAt
  }
}
    `;
export type DeleteNodeCommentMutationFn = Apollo.MutationFunction<DeleteNodeCommentMutation, DeleteNodeCommentMutationVariables>;

/**
 * __useDeleteNodeCommentMutation__
 *
 * To run a mutation, you first call `useDeleteNodeCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNodeCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNodeCommentMutation, { data, loading, error }] = useDeleteNodeCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteNodeCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNodeCommentMutation, DeleteNodeCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNodeCommentMutation, DeleteNodeCommentMutationVariables>(DeleteNodeCommentDocument, options);
      }
export type DeleteNodeCommentMutationHookResult = ReturnType<typeof useDeleteNodeCommentMutation>;
export type DeleteNodeCommentMutationResult = Apollo.MutationResult<DeleteNodeCommentMutation>;
export type DeleteNodeCommentMutationOptions = Apollo.BaseMutationOptions<DeleteNodeCommentMutation, DeleteNodeCommentMutationVariables>;
export const UnauthPathViewerDocument = gql`
    query UnauthPathViewer($where: path_bool_exp!) {
  path: path(where: $where) {
    ...UnauthPathViewerPath
  }
}
    ${UnauthPathViewerPathFragmentDoc}`;

/**
 * __useUnauthPathViewerQuery__
 *
 * To run a query within a React component, call `useUnauthPathViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnauthPathViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnauthPathViewerQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUnauthPathViewerQuery(baseOptions: Apollo.QueryHookOptions<UnauthPathViewerQuery, UnauthPathViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnauthPathViewerQuery, UnauthPathViewerQueryVariables>(UnauthPathViewerDocument, options);
      }
export function useUnauthPathViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnauthPathViewerQuery, UnauthPathViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnauthPathViewerQuery, UnauthPathViewerQueryVariables>(UnauthPathViewerDocument, options);
        }
export type UnauthPathViewerQueryHookResult = ReturnType<typeof useUnauthPathViewerQuery>;
export type UnauthPathViewerLazyQueryHookResult = ReturnType<typeof useUnauthPathViewerLazyQuery>;
export type UnauthPathViewerQueryResult = Apollo.QueryResult<UnauthPathViewerQuery, UnauthPathViewerQueryVariables>;
export const PathViewerDocument = gql`
    query PathViewer($userId: String!, $where: path_bool_exp!) {
  path(where: $where, limit: 1) {
    ...PathViewerPath
  }
}
    ${PathViewerPathFragmentDoc}`;

/**
 * __usePathViewerQuery__
 *
 * To run a query within a React component, call `usePathViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathViewerQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePathViewerQuery(baseOptions: Apollo.QueryHookOptions<PathViewerQuery, PathViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PathViewerQuery, PathViewerQueryVariables>(PathViewerDocument, options);
      }
export function usePathViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PathViewerQuery, PathViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PathViewerQuery, PathViewerQueryVariables>(PathViewerDocument, options);
        }
export type PathViewerQueryHookResult = ReturnType<typeof usePathViewerQuery>;
export type PathViewerLazyQueryHookResult = ReturnType<typeof usePathViewerLazyQuery>;
export type PathViewerQueryResult = Apollo.QueryResult<PathViewerQuery, PathViewerQueryVariables>;
export const PathActiveUsersAggregateDocument = gql`
    query PathActiveUsersAggregate($pathId: bigint!, $date: timestamptz!) @cached(ttl: 300) {
  path_active_user_aggregate(
    where: {pathId: {_eq: $pathId}, updatedAt: {_gt: $date}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __usePathActiveUsersAggregateQuery__
 *
 * To run a query within a React component, call `usePathActiveUsersAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathActiveUsersAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathActiveUsersAggregateQuery({
 *   variables: {
 *      pathId: // value for 'pathId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function usePathActiveUsersAggregateQuery(baseOptions: Apollo.QueryHookOptions<PathActiveUsersAggregateQuery, PathActiveUsersAggregateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PathActiveUsersAggregateQuery, PathActiveUsersAggregateQueryVariables>(PathActiveUsersAggregateDocument, options);
      }
export function usePathActiveUsersAggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PathActiveUsersAggregateQuery, PathActiveUsersAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PathActiveUsersAggregateQuery, PathActiveUsersAggregateQueryVariables>(PathActiveUsersAggregateDocument, options);
        }
export type PathActiveUsersAggregateQueryHookResult = ReturnType<typeof usePathActiveUsersAggregateQuery>;
export type PathActiveUsersAggregateLazyQueryHookResult = ReturnType<typeof usePathActiveUsersAggregateLazyQuery>;
export type PathActiveUsersAggregateQueryResult = Apollo.QueryResult<PathActiveUsersAggregateQuery, PathActiveUsersAggregateQueryVariables>;
export const PathActiveUserDocument = gql`
    mutation PathActiveUser($userId: String!, $pathId: bigint!) {
  insert_path_active_user_one(
    object: {pathId: $pathId, userId: $userId}
    on_conflict: {constraint: path_active_user_pkey, update_columns: [pathId, userId]}
  ) {
    ...PathActiveUser
  }
}
    ${PathActiveUserFragmentDoc}`;
export type PathActiveUserMutationFn = Apollo.MutationFunction<PathActiveUserMutation, PathActiveUserMutationVariables>;

/**
 * __usePathActiveUserMutation__
 *
 * To run a mutation, you first call `usePathActiveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePathActiveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pathActiveUserMutation, { data, loading, error }] = usePathActiveUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function usePathActiveUserMutation(baseOptions?: Apollo.MutationHookOptions<PathActiveUserMutation, PathActiveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PathActiveUserMutation, PathActiveUserMutationVariables>(PathActiveUserDocument, options);
      }
export type PathActiveUserMutationHookResult = ReturnType<typeof usePathActiveUserMutation>;
export type PathActiveUserMutationResult = Apollo.MutationResult<PathActiveUserMutation>;
export type PathActiveUserMutationOptions = Apollo.BaseMutationOptions<PathActiveUserMutation, PathActiveUserMutationVariables>;
export const CreateProjectDocument = gql`
    mutation CreateProject($input: api_create_project_input) {
  project: api_create_project(input: $input) {
    id
    text
    isPrivate
    file {
      id
      filename
    }
  }
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const ProjectHistoryDocument = gql`
    query ProjectHistory($userId: String!, $nodeId: uuid!, $limit: Int = 10) {
  projects: project(
    order_by: {createdAt: desc}
    limit: $limit
    where: {pathNodeId: {_eq: $nodeId}, userId: {_eq: $userId}}
  ) {
    ...ProjectHistoryProject
  }
}
    ${ProjectHistoryProjectFragmentDoc}`;

/**
 * __useProjectHistoryQuery__
 *
 * To run a query within a React component, call `useProjectHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectHistoryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      nodeId: // value for 'nodeId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useProjectHistoryQuery(baseOptions: Apollo.QueryHookOptions<ProjectHistoryQuery, ProjectHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectHistoryQuery, ProjectHistoryQueryVariables>(ProjectHistoryDocument, options);
      }
export function useProjectHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectHistoryQuery, ProjectHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectHistoryQuery, ProjectHistoryQueryVariables>(ProjectHistoryDocument, options);
        }
export type ProjectHistoryQueryHookResult = ReturnType<typeof useProjectHistoryQuery>;
export type ProjectHistoryLazyQueryHookResult = ReturnType<typeof useProjectHistoryLazyQuery>;
export type ProjectHistoryQueryResult = Apollo.QueryResult<ProjectHistoryQuery, ProjectHistoryQueryVariables>;
export const GetUserAwardsDocument = gql`
    query GetUserAwards($userId: String!) {
  user_awards: user_award(where: {userId: {_eq: $userId}}) {
    award {
      id
      name
      description
      filePath
      type
    }
  }
}
    `;

/**
 * __useGetUserAwardsQuery__
 *
 * To run a query within a React component, call `useGetUserAwardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAwardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAwardsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserAwardsQuery(baseOptions: Apollo.QueryHookOptions<GetUserAwardsQuery, GetUserAwardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAwardsQuery, GetUserAwardsQueryVariables>(GetUserAwardsDocument, options);
      }
export function useGetUserAwardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAwardsQuery, GetUserAwardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAwardsQuery, GetUserAwardsQueryVariables>(GetUserAwardsDocument, options);
        }
export type GetUserAwardsQueryHookResult = ReturnType<typeof useGetUserAwardsQuery>;
export type GetUserAwardsLazyQueryHookResult = ReturnType<typeof useGetUserAwardsLazyQuery>;
export type GetUserAwardsQueryResult = Apollo.QueryResult<GetUserAwardsQuery, GetUserAwardsQueryVariables>;
export const ProjectsLikedByUidDocument = gql`
    query ProjectsLikedByUid($id: String!, $published: Boolean_comparison_exp, $limit: Int = 54, $offset: Int = 0) {
  projects: project_reaction(
    order_by: {createdAt: desc}
    where: {userId: {_eq: $id}, project: {published: $published}}
    limit: $limit
    offset: $offset
  ) {
    userId
    projectId
    project {
      ...projectCard
    }
  }
}
    ${ProjectCardFragmentDoc}`;

/**
 * __useProjectsLikedByUidQuery__
 *
 * To run a query within a React component, call `useProjectsLikedByUidQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsLikedByUidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsLikedByUidQuery({
 *   variables: {
 *      id: // value for 'id'
 *      published: // value for 'published'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useProjectsLikedByUidQuery(baseOptions: Apollo.QueryHookOptions<ProjectsLikedByUidQuery, ProjectsLikedByUidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsLikedByUidQuery, ProjectsLikedByUidQueryVariables>(ProjectsLikedByUidDocument, options);
      }
export function useProjectsLikedByUidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsLikedByUidQuery, ProjectsLikedByUidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsLikedByUidQuery, ProjectsLikedByUidQueryVariables>(ProjectsLikedByUidDocument, options);
        }
export type ProjectsLikedByUidQueryHookResult = ReturnType<typeof useProjectsLikedByUidQuery>;
export type ProjectsLikedByUidLazyQueryHookResult = ReturnType<typeof useProjectsLikedByUidLazyQuery>;
export type ProjectsLikedByUidQueryResult = Apollo.QueryResult<ProjectsLikedByUidQuery, ProjectsLikedByUidQueryVariables>;
export const UserProfileDocument = gql`
    query UserProfile($where: user_bool_exp!) {
  user(where: $where) {
    ...UserProfileUser
  }
}
    ${UserProfileUserFragmentDoc}`;

/**
 * __useUserProfileQuery__
 *
 * To run a query within a React component, call `useUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUserProfileQuery(baseOptions: Apollo.QueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
      }
export function useUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
        }
export type UserProfileQueryHookResult = ReturnType<typeof useUserProfileQuery>;
export type UserProfileLazyQueryHookResult = ReturnType<typeof useUserProfileLazyQuery>;
export type UserProfileQueryResult = Apollo.QueryResult<UserProfileQuery, UserProfileQueryVariables>;
export const UserSocialCountsByIdDocument = gql`
    query UserSocialCountsById($id: String!) {
  user(where: {firestoreId: {_eq: $id}}) {
    ...UserSocialCounts
  }
}
    ${UserSocialCountsFragmentDoc}`;

/**
 * __useUserSocialCountsByIdQuery__
 *
 * To run a query within a React component, call `useUserSocialCountsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSocialCountsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSocialCountsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserSocialCountsByIdQuery(baseOptions: Apollo.QueryHookOptions<UserSocialCountsByIdQuery, UserSocialCountsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSocialCountsByIdQuery, UserSocialCountsByIdQueryVariables>(UserSocialCountsByIdDocument, options);
      }
export function useUserSocialCountsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSocialCountsByIdQuery, UserSocialCountsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSocialCountsByIdQuery, UserSocialCountsByIdQueryVariables>(UserSocialCountsByIdDocument, options);
        }
export type UserSocialCountsByIdQueryHookResult = ReturnType<typeof useUserSocialCountsByIdQuery>;
export type UserSocialCountsByIdLazyQueryHookResult = ReturnType<typeof useUserSocialCountsByIdLazyQuery>;
export type UserSocialCountsByIdQueryResult = Apollo.QueryResult<UserSocialCountsByIdQuery, UserSocialCountsByIdQueryVariables>;
export const UserFollowersByIdDocument = gql`
    query UserFollowersById($id: String!, $currentUserId: String!, $limit: Int = 25) {
  user(where: {firestoreId: {_eq: $id}}) {
    ...UserFollowers
  }
}
    ${UserFollowersFragmentDoc}`;

/**
 * __useUserFollowersByIdQuery__
 *
 * To run a query within a React component, call `useUserFollowersByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFollowersByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFollowersByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      currentUserId: // value for 'currentUserId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUserFollowersByIdQuery(baseOptions: Apollo.QueryHookOptions<UserFollowersByIdQuery, UserFollowersByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFollowersByIdQuery, UserFollowersByIdQueryVariables>(UserFollowersByIdDocument, options);
      }
export function useUserFollowersByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFollowersByIdQuery, UserFollowersByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFollowersByIdQuery, UserFollowersByIdQueryVariables>(UserFollowersByIdDocument, options);
        }
export type UserFollowersByIdQueryHookResult = ReturnType<typeof useUserFollowersByIdQuery>;
export type UserFollowersByIdLazyQueryHookResult = ReturnType<typeof useUserFollowersByIdLazyQuery>;
export type UserFollowersByIdQueryResult = Apollo.QueryResult<UserFollowersByIdQuery, UserFollowersByIdQueryVariables>;
export const UserFollowingByIdDocument = gql`
    query UserFollowingById($id: String!, $currentUserId: String!, $limit: Int = 25) {
  user(where: {firestoreId: {_eq: $id}}) {
    ...UserFollowing
  }
}
    ${UserFollowingFragmentDoc}`;

/**
 * __useUserFollowingByIdQuery__
 *
 * To run a query within a React component, call `useUserFollowingByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFollowingByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFollowingByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      currentUserId: // value for 'currentUserId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUserFollowingByIdQuery(baseOptions: Apollo.QueryHookOptions<UserFollowingByIdQuery, UserFollowingByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFollowingByIdQuery, UserFollowingByIdQueryVariables>(UserFollowingByIdDocument, options);
      }
export function useUserFollowingByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFollowingByIdQuery, UserFollowingByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFollowingByIdQuery, UserFollowingByIdQueryVariables>(UserFollowingByIdDocument, options);
        }
export type UserFollowingByIdQueryHookResult = ReturnType<typeof useUserFollowingByIdQuery>;
export type UserFollowingByIdLazyQueryHookResult = ReturnType<typeof useUserFollowingByIdLazyQuery>;
export type UserFollowingByIdQueryResult = Apollo.QueryResult<UserFollowingByIdQuery, UserFollowingByIdQueryVariables>;
export const UserProfileProjectsDocument = gql`
    query UserProfileProjects($userId: String!, $isPrivate: Boolean_comparison_exp, $published: Boolean_comparison_exp, $limit: Int!, $offset: Int!) {
  projects: project(
    order_by: {createdAt: desc}
    where: {userId: {_eq: $userId}, file: {transforms: {}}, rejectedAt: {_eq: "-infinity"}, isPrivate: $isPrivate, published: $published}
    limit: $limit
    offset: $offset
  ) {
    ...projectCard
  }
}
    ${ProjectCardFragmentDoc}`;

/**
 * __useUserProfileProjectsQuery__
 *
 * To run a query within a React component, call `useUserProfileProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileProjectsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      isPrivate: // value for 'isPrivate'
 *      published: // value for 'published'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useUserProfileProjectsQuery(baseOptions: Apollo.QueryHookOptions<UserProfileProjectsQuery, UserProfileProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProfileProjectsQuery, UserProfileProjectsQueryVariables>(UserProfileProjectsDocument, options);
      }
export function useUserProfileProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProfileProjectsQuery, UserProfileProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProfileProjectsQuery, UserProfileProjectsQueryVariables>(UserProfileProjectsDocument, options);
        }
export type UserProfileProjectsQueryHookResult = ReturnType<typeof useUserProfileProjectsQuery>;
export type UserProfileProjectsLazyQueryHookResult = ReturnType<typeof useUserProfileProjectsLazyQuery>;
export type UserProfileProjectsQueryResult = Apollo.QueryResult<UserProfileProjectsQuery, UserProfileProjectsQueryVariables>;
export const ProfileLivestreamsDocument = gql`
    query ProfileLivestreams($limit: Int!, $offset: Int!, $hostUserId: String!, $startDate: timestamptz!) {
  livestreams: livestream(
    limit: $limit
    offset: $offset
    order_by: {startDate: asc}
    where: {hostUserId: {_eq: $hostUserId}, _or: [{startDate: {_gte: $startDate}}, {endDate: {_gte: $startDate}}], disabled: {_eq: false}}
  ) {
    ...Livestream
  }
}
    ${LivestreamFragmentDoc}`;

/**
 * __useProfileLivestreamsQuery__
 *
 * To run a query within a React component, call `useProfileLivestreamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileLivestreamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileLivestreamsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      hostUserId: // value for 'hostUserId'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useProfileLivestreamsQuery(baseOptions: Apollo.QueryHookOptions<ProfileLivestreamsQuery, ProfileLivestreamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileLivestreamsQuery, ProfileLivestreamsQueryVariables>(ProfileLivestreamsDocument, options);
      }
export function useProfileLivestreamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileLivestreamsQuery, ProfileLivestreamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileLivestreamsQuery, ProfileLivestreamsQueryVariables>(ProfileLivestreamsDocument, options);
        }
export type ProfileLivestreamsQueryHookResult = ReturnType<typeof useProfileLivestreamsQuery>;
export type ProfileLivestreamsLazyQueryHookResult = ReturnType<typeof useProfileLivestreamsLazyQuery>;
export type ProfileLivestreamsQueryResult = Apollo.QueryResult<ProfileLivestreamsQuery, ProfileLivestreamsQueryVariables>;
export const ProfilePathsDocument = gql`
    query ProfilePaths($limit: Int!, $offset: Int!, $userId: String!) {
  paths: path(
    limit: $limit
    offset: $offset
    order_by: {publishedAt: desc}
    where: {_or: [{authorId: {_eq: $userId}}, {authors: {userId: {_eq: $userId}}}], isPublished: {_eq: true}}
  ) {
    ...PathCard
  }
}
    ${PathCardFragmentDoc}`;

/**
 * __useProfilePathsQuery__
 *
 * To run a query within a React component, call `useProfilePathsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfilePathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfilePathsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useProfilePathsQuery(baseOptions: Apollo.QueryHookOptions<ProfilePathsQuery, ProfilePathsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfilePathsQuery, ProfilePathsQueryVariables>(ProfilePathsDocument, options);
      }
export function useProfilePathsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfilePathsQuery, ProfilePathsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfilePathsQuery, ProfilePathsQueryVariables>(ProfilePathsDocument, options);
        }
export type ProfilePathsQueryHookResult = ReturnType<typeof useProfilePathsQuery>;
export type ProfilePathsLazyQueryHookResult = ReturnType<typeof useProfilePathsLazyQuery>;
export type ProfilePathsQueryResult = Apollo.QueryResult<ProfilePathsQuery, ProfilePathsQueryVariables>;
export const GetProjectDetailsDocument = gql`
    query GetProjectDetails($id: uuid!) {
  project: project_by_pk(id: $id) {
    ...projectCard
  }
}
    ${ProjectCardFragmentDoc}`;

/**
 * __useGetProjectDetailsQuery__
 *
 * To run a query within a React component, call `useGetProjectDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetProjectDetailsQuery, GetProjectDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectDetailsQuery, GetProjectDetailsQueryVariables>(GetProjectDetailsDocument, options);
      }
export function useGetProjectDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectDetailsQuery, GetProjectDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectDetailsQuery, GetProjectDetailsQueryVariables>(GetProjectDetailsDocument, options);
        }
export type GetProjectDetailsQueryHookResult = ReturnType<typeof useGetProjectDetailsQuery>;
export type GetProjectDetailsLazyQueryHookResult = ReturnType<typeof useGetProjectDetailsLazyQuery>;
export type GetProjectDetailsQueryResult = Apollo.QueryResult<GetProjectDetailsQuery, GetProjectDetailsQueryVariables>;
export const ReportModalDocument = gql`
    query ReportModal($nodeId: uuid!, $coinTrxId: uuid!) {
  path_node_by_pk(id: $nodeId) {
    id
    title
  }
  coin_trx_by_pk(id: $coinTrxId) {
    id
    amount
  }
}
    `;

/**
 * __useReportModalQuery__
 *
 * To run a query within a React component, call `useReportModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportModalQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *      coinTrxId: // value for 'coinTrxId'
 *   },
 * });
 */
export function useReportModalQuery(baseOptions: Apollo.QueryHookOptions<ReportModalQuery, ReportModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportModalQuery, ReportModalQueryVariables>(ReportModalDocument, options);
      }
export function useReportModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportModalQuery, ReportModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportModalQuery, ReportModalQueryVariables>(ReportModalDocument, options);
        }
export type ReportModalQueryHookResult = ReturnType<typeof useReportModalQuery>;
export type ReportModalLazyQueryHookResult = ReturnType<typeof useReportModalLazyQuery>;
export type ReportModalQueryResult = Apollo.QueryResult<ReportModalQuery, ReportModalQueryVariables>;
export const ProjectGalleryDocument = gql`
    query ProjectGallery($where: project_bool_exp!, $limit: Int!, $offset: Int!) {
  projects: project(
    limit: $limit
    offset: $offset
    where: $where
    order_by: {createdAt: desc}
  ) {
    ...projectCard
  }
}
    ${ProjectCardFragmentDoc}`;

/**
 * __useProjectGalleryQuery__
 *
 * To run a query within a React component, call `useProjectGalleryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectGalleryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectGalleryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useProjectGalleryQuery(baseOptions: Apollo.QueryHookOptions<ProjectGalleryQuery, ProjectGalleryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectGalleryQuery, ProjectGalleryQueryVariables>(ProjectGalleryDocument, options);
      }
export function useProjectGalleryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectGalleryQuery, ProjectGalleryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectGalleryQuery, ProjectGalleryQueryVariables>(ProjectGalleryDocument, options);
        }
export type ProjectGalleryQueryHookResult = ReturnType<typeof useProjectGalleryQuery>;
export type ProjectGalleryLazyQueryHookResult = ReturnType<typeof useProjectGalleryLazyQuery>;
export type ProjectGalleryQueryResult = Apollo.QueryResult<ProjectGalleryQuery, ProjectGalleryQueryVariables>;
export const GetProjectPathDocument = gql`
    query GetProjectPath($id: bigint!) {
  path: path_by_pk(id: $id) {
    ...projectPath
  }
}
    ${ProjectPathFragmentDoc}`;

/**
 * __useGetProjectPathQuery__
 *
 * To run a query within a React component, call `useGetProjectPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectPathQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectPathQuery(baseOptions: Apollo.QueryHookOptions<GetProjectPathQuery, GetProjectPathQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectPathQuery, GetProjectPathQueryVariables>(GetProjectPathDocument, options);
      }
export function useGetProjectPathLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectPathQuery, GetProjectPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectPathQuery, GetProjectPathQueryVariables>(GetProjectPathDocument, options);
        }
export type GetProjectPathQueryHookResult = ReturnType<typeof useGetProjectPathQuery>;
export type GetProjectPathLazyQueryHookResult = ReturnType<typeof useGetProjectPathLazyQuery>;
export type GetProjectPathQueryResult = Apollo.QueryResult<GetProjectPathQuery, GetProjectPathQueryVariables>;
export const IncProjectViewCountDocument = gql`
    mutation IncProjectViewCount($projectId: uuid!) {
  update_project_stats_by_pk(
    pk_columns: {projectId: $projectId}
    _inc: {viewCount: 1}
  ) {
    ...projectStats
  }
}
    ${ProjectStatsFragmentDoc}`;
export type IncProjectViewCountMutationFn = Apollo.MutationFunction<IncProjectViewCountMutation, IncProjectViewCountMutationVariables>;

/**
 * __useIncProjectViewCountMutation__
 *
 * To run a mutation, you first call `useIncProjectViewCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIncProjectViewCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [incProjectViewCountMutation, { data, loading, error }] = useIncProjectViewCountMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useIncProjectViewCountMutation(baseOptions?: Apollo.MutationHookOptions<IncProjectViewCountMutation, IncProjectViewCountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IncProjectViewCountMutation, IncProjectViewCountMutationVariables>(IncProjectViewCountDocument, options);
      }
export type IncProjectViewCountMutationHookResult = ReturnType<typeof useIncProjectViewCountMutation>;
export type IncProjectViewCountMutationResult = Apollo.MutationResult<IncProjectViewCountMutation>;
export type IncProjectViewCountMutationOptions = Apollo.BaseMutationOptions<IncProjectViewCountMutation, IncProjectViewCountMutationVariables>;
export const ProjectCommentsDocument = gql`
    query ProjectComments($projectId: uuid!, $offset: Int!, $limit: Int!) {
  projectComments: project_comment(
    limit: $limit
    offset: $offset
    where: {projectId: {_eq: $projectId}, comment: {deletedAt: {_eq: "-infinity"}}}
    order_by: {comment: {createdAt: desc}}
  ) {
    ...projectComment
  }
}
    ${ProjectCommentFragmentDoc}`;

/**
 * __useProjectCommentsQuery__
 *
 * To run a query within a React component, call `useProjectCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectCommentsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useProjectCommentsQuery(baseOptions: Apollo.QueryHookOptions<ProjectCommentsQuery, ProjectCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectCommentsQuery, ProjectCommentsQueryVariables>(ProjectCommentsDocument, options);
      }
export function useProjectCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectCommentsQuery, ProjectCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectCommentsQuery, ProjectCommentsQueryVariables>(ProjectCommentsDocument, options);
        }
export type ProjectCommentsQueryHookResult = ReturnType<typeof useProjectCommentsQuery>;
export type ProjectCommentsLazyQueryHookResult = ReturnType<typeof useProjectCommentsLazyQuery>;
export type ProjectCommentsQueryResult = Apollo.QueryResult<ProjectCommentsQuery, ProjectCommentsQueryVariables>;
export const CreateProjectCommentDocument = gql`
    mutation CreateProjectComment($projectId: uuid!, $text: String, $userId: String!, $giphyId: String) {
  projectComment: insert_project_comment_one(
    object: {comment: {data: {text: $text, userId: $userId, giphyId: $giphyId}}, projectId: $projectId}
  ) {
    ...projectComment
  }
  update_project_stats_by_pk(
    pk_columns: {projectId: $projectId}
    _inc: {commentCount: 1}
  ) {
    ...projectStats
  }
}
    ${ProjectCommentFragmentDoc}
${ProjectStatsFragmentDoc}`;
export type CreateProjectCommentMutationFn = Apollo.MutationFunction<CreateProjectCommentMutation, CreateProjectCommentMutationVariables>;

/**
 * __useCreateProjectCommentMutation__
 *
 * To run a mutation, you first call `useCreateProjectCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectCommentMutation, { data, loading, error }] = useCreateProjectCommentMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      text: // value for 'text'
 *      userId: // value for 'userId'
 *      giphyId: // value for 'giphyId'
 *   },
 * });
 */
export function useCreateProjectCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectCommentMutation, CreateProjectCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectCommentMutation, CreateProjectCommentMutationVariables>(CreateProjectCommentDocument, options);
      }
export type CreateProjectCommentMutationHookResult = ReturnType<typeof useCreateProjectCommentMutation>;
export type CreateProjectCommentMutationResult = Apollo.MutationResult<CreateProjectCommentMutation>;
export type CreateProjectCommentMutationOptions = Apollo.BaseMutationOptions<CreateProjectCommentMutation, CreateProjectCommentMutationVariables>;
export const UpdateCommentDocument = gql`
    mutation UpdateComment($commentId: uuid!, $text: String!) {
  update_comment_by_pk(pk_columns: {id: $commentId}, _set: {text: $text}) {
    id
    text
  }
}
    `;
export type UpdateCommentMutationFn = Apollo.MutationFunction<UpdateCommentMutation, UpdateCommentMutationVariables>;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentMutation, UpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(UpdateCommentDocument, options);
      }
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = Apollo.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const DeleteProjectCommentDocument = gql`
    mutation DeleteProjectComment($commentId: uuid!, $projectId: uuid!) {
  update_comment_by_pk(
    pk_columns: {id: $commentId}
    _set: {deletedAt: "now()", published: false}
  ) {
    id
    deletedAt
    published
  }
  update_project_stats_by_pk(
    pk_columns: {projectId: $projectId}
    _inc: {commentCount: -1}
  ) {
    ...projectStats
  }
}
    ${ProjectStatsFragmentDoc}`;
export type DeleteProjectCommentMutationFn = Apollo.MutationFunction<DeleteProjectCommentMutation, DeleteProjectCommentMutationVariables>;

/**
 * __useDeleteProjectCommentMutation__
 *
 * To run a mutation, you first call `useDeleteProjectCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectCommentMutation, { data, loading, error }] = useDeleteProjectCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteProjectCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectCommentMutation, DeleteProjectCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectCommentMutation, DeleteProjectCommentMutationVariables>(DeleteProjectCommentDocument, options);
      }
export type DeleteProjectCommentMutationHookResult = ReturnType<typeof useDeleteProjectCommentMutation>;
export type DeleteProjectCommentMutationResult = Apollo.MutationResult<DeleteProjectCommentMutation>;
export type DeleteProjectCommentMutationOptions = Apollo.BaseMutationOptions<DeleteProjectCommentMutation, DeleteProjectCommentMutationVariables>;
export const PathNameDocument = gql`
    query PathName($pathId: bigint!) {
  path: path_by_pk(id: $pathId) {
    id
    title
  }
}
    `;

/**
 * __usePathNameQuery__
 *
 * To run a query within a React component, call `usePathNameQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathNameQuery({
 *   variables: {
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function usePathNameQuery(baseOptions: Apollo.QueryHookOptions<PathNameQuery, PathNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PathNameQuery, PathNameQueryVariables>(PathNameDocument, options);
      }
export function usePathNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PathNameQuery, PathNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PathNameQuery, PathNameQueryVariables>(PathNameDocument, options);
        }
export type PathNameQueryHookResult = ReturnType<typeof usePathNameQuery>;
export type PathNameLazyQueryHookResult = ReturnType<typeof usePathNameLazyQuery>;
export type PathNameQueryResult = Apollo.QueryResult<PathNameQuery, PathNameQueryVariables>;
export const PathNodeNameDocument = gql`
    query PathNodeName($nodeId: uuid!) {
  node: path_node_by_pk(id: $nodeId) {
    id
    title
  }
}
    `;

/**
 * __usePathNodeNameQuery__
 *
 * To run a query within a React component, call `usePathNodeNameQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathNodeNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathNodeNameQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function usePathNodeNameQuery(baseOptions: Apollo.QueryHookOptions<PathNodeNameQuery, PathNodeNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PathNodeNameQuery, PathNodeNameQueryVariables>(PathNodeNameDocument, options);
      }
export function usePathNodeNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PathNodeNameQuery, PathNodeNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PathNodeNameQuery, PathNodeNameQueryVariables>(PathNodeNameDocument, options);
        }
export type PathNodeNameQueryHookResult = ReturnType<typeof usePathNodeNameQuery>;
export type PathNodeNameLazyQueryHookResult = ReturnType<typeof usePathNodeNameLazyQuery>;
export type PathNodeNameQueryResult = Apollo.QueryResult<PathNodeNameQuery, PathNodeNameQueryVariables>;
export const GetInviterUserDocument = gql`
    query GetInviterUser($userId: String!) {
  user_by_pk(firestoreId: $userId) {
    avatar
    username
    userType
    creatorLevel
    isMod
    isEducator
    ...UserPrivacyScopes
  }
}
    ${UserPrivacyScopesFragmentDoc}`;

/**
 * __useGetInviterUserQuery__
 *
 * To run a query within a React component, call `useGetInviterUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInviterUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInviterUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetInviterUserQuery(baseOptions: Apollo.QueryHookOptions<GetInviterUserQuery, GetInviterUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInviterUserQuery, GetInviterUserQueryVariables>(GetInviterUserDocument, options);
      }
export function useGetInviterUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInviterUserQuery, GetInviterUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInviterUserQuery, GetInviterUserQueryVariables>(GetInviterUserDocument, options);
        }
export type GetInviterUserQueryHookResult = ReturnType<typeof useGetInviterUserQuery>;
export type GetInviterUserLazyQueryHookResult = ReturnType<typeof useGetInviterUserLazyQuery>;
export type GetInviterUserQueryResult = Apollo.QueryResult<GetInviterUserQuery, GetInviterUserQueryVariables>;
export const GetUserIntegrationsDocument = gql`
    query GetUserIntegrations($userId: String!) {
  user_integration(where: {userId: {_eq: $userId}}) {
    provider
    createdAt
  }
}
    `;

/**
 * __useGetUserIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetUserIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserIntegrationsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<GetUserIntegrationsQuery, GetUserIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserIntegrationsQuery, GetUserIntegrationsQueryVariables>(GetUserIntegrationsDocument, options);
      }
export function useGetUserIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserIntegrationsQuery, GetUserIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserIntegrationsQuery, GetUserIntegrationsQueryVariables>(GetUserIntegrationsDocument, options);
        }
export type GetUserIntegrationsQueryHookResult = ReturnType<typeof useGetUserIntegrationsQuery>;
export type GetUserIntegrationsLazyQueryHookResult = ReturnType<typeof useGetUserIntegrationsLazyQuery>;
export type GetUserIntegrationsQueryResult = Apollo.QueryResult<GetUserIntegrationsQuery, GetUserIntegrationsQueryVariables>;
export const UserPrivacyUpdateDocument = gql`
    mutation UserPrivacyUpdate($input: api_update_privacy_input!) {
  api_update_privacy(input: $input) {
    userId
    profilePrivacy
    projectPrivacy
    pathPrivacy
  }
}
    `;
export type UserPrivacyUpdateMutationFn = Apollo.MutationFunction<UserPrivacyUpdateMutation, UserPrivacyUpdateMutationVariables>;

/**
 * __useUserPrivacyUpdateMutation__
 *
 * To run a mutation, you first call `useUserPrivacyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserPrivacyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userPrivacyUpdateMutation, { data, loading, error }] = useUserPrivacyUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserPrivacyUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserPrivacyUpdateMutation, UserPrivacyUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserPrivacyUpdateMutation, UserPrivacyUpdateMutationVariables>(UserPrivacyUpdateDocument, options);
      }
export type UserPrivacyUpdateMutationHookResult = ReturnType<typeof useUserPrivacyUpdateMutation>;
export type UserPrivacyUpdateMutationResult = Apollo.MutationResult<UserPrivacyUpdateMutation>;
export type UserPrivacyUpdateMutationOptions = Apollo.BaseMutationOptions<UserPrivacyUpdateMutation, UserPrivacyUpdateMutationVariables>;
export const ShopItemsDocument = gql`
    query ShopItems($limit: Int!, $offset: Int!, $tags: jsonb_comparison_exp!) {
  items: shop_item(
    where: {disabled: {_eq: false}, tags: $tags}
    limit: $limit
    offset: $offset
    order_by: {cost: asc}
  ) {
    ...ShopItem
  }
}
    ${ShopItemFragmentDoc}`;

/**
 * __useShopItemsQuery__
 *
 * To run a query within a React component, call `useShopItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopItemsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useShopItemsQuery(baseOptions: Apollo.QueryHookOptions<ShopItemsQuery, ShopItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopItemsQuery, ShopItemsQueryVariables>(ShopItemsDocument, options);
      }
export function useShopItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopItemsQuery, ShopItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopItemsQuery, ShopItemsQueryVariables>(ShopItemsDocument, options);
        }
export type ShopItemsQueryHookResult = ReturnType<typeof useShopItemsQuery>;
export type ShopItemsLazyQueryHookResult = ReturnType<typeof useShopItemsLazyQuery>;
export type ShopItemsQueryResult = Apollo.QueryResult<ShopItemsQuery, ShopItemsQueryVariables>;
export const ShopItemDocument = gql`
    query ShopItem($id: uuid!) {
  item: shop_item_by_pk(id: $id) {
    ...ShopItem
  }
}
    ${ShopItemFragmentDoc}`;

/**
 * __useShopItemQuery__
 *
 * To run a query within a React component, call `useShopItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useShopItemQuery(baseOptions: Apollo.QueryHookOptions<ShopItemQuery, ShopItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopItemQuery, ShopItemQueryVariables>(ShopItemDocument, options);
      }
export function useShopItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopItemQuery, ShopItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopItemQuery, ShopItemQueryVariables>(ShopItemDocument, options);
        }
export type ShopItemQueryHookResult = ReturnType<typeof useShopItemQuery>;
export type ShopItemLazyQueryHookResult = ReturnType<typeof useShopItemLazyQuery>;
export type ShopItemQueryResult = Apollo.QueryResult<ShopItemQuery, ShopItemQueryVariables>;
export const SignUpEducatorDocument = gql`
    mutation SignUpEducator($firstName: String!, $lastName: String!, $email: String!, $password: String!) {
  api_sign_up(
    role: EDUCATOR
    firstName: $firstName
    lastName: $lastName
    email: $email
    password: $password
  ) {
    userId
    authToken
  }
}
    `;
export type SignUpEducatorMutationFn = Apollo.MutationFunction<SignUpEducatorMutation, SignUpEducatorMutationVariables>;

/**
 * __useSignUpEducatorMutation__
 *
 * To run a mutation, you first call `useSignUpEducatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpEducatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpEducatorMutation, { data, loading, error }] = useSignUpEducatorMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSignUpEducatorMutation(baseOptions?: Apollo.MutationHookOptions<SignUpEducatorMutation, SignUpEducatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpEducatorMutation, SignUpEducatorMutationVariables>(SignUpEducatorDocument, options);
      }
export type SignUpEducatorMutationHookResult = ReturnType<typeof useSignUpEducatorMutation>;
export type SignUpEducatorMutationResult = Apollo.MutationResult<SignUpEducatorMutation>;
export type SignUpEducatorMutationOptions = Apollo.BaseMutationOptions<SignUpEducatorMutation, SignUpEducatorMutationVariables>;
export const SignUpStudentDocument = gql`
    mutation SignUpStudent($username: String!, $password: String!, $code: String!) {
  api_sign_up(
    role: STUDENT
    username: $username
    password: $password
    code: $code
  ) {
    userId
    authToken
  }
}
    `;
export type SignUpStudentMutationFn = Apollo.MutationFunction<SignUpStudentMutation, SignUpStudentMutationVariables>;

/**
 * __useSignUpStudentMutation__
 *
 * To run a mutation, you first call `useSignUpStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpStudentMutation, { data, loading, error }] = useSignUpStudentMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSignUpStudentMutation(baseOptions?: Apollo.MutationHookOptions<SignUpStudentMutation, SignUpStudentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpStudentMutation, SignUpStudentMutationVariables>(SignUpStudentDocument, options);
      }
export type SignUpStudentMutationHookResult = ReturnType<typeof useSignUpStudentMutation>;
export type SignUpStudentMutationResult = Apollo.MutationResult<SignUpStudentMutation>;
export type SignUpStudentMutationOptions = Apollo.BaseMutationOptions<SignUpStudentMutation, SignUpStudentMutationVariables>;
export const JoinClassroomDocument = gql`
    mutation JoinClassroom($educatorCode: String!, $source: String) {
  api_join_classroom(educatorCode: $educatorCode, source: $source) {
    learnerGroupId
  }
}
    `;
export type JoinClassroomMutationFn = Apollo.MutationFunction<JoinClassroomMutation, JoinClassroomMutationVariables>;

/**
 * __useJoinClassroomMutation__
 *
 * To run a mutation, you first call `useJoinClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinClassroomMutation, { data, loading, error }] = useJoinClassroomMutation({
 *   variables: {
 *      educatorCode: // value for 'educatorCode'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useJoinClassroomMutation(baseOptions?: Apollo.MutationHookOptions<JoinClassroomMutation, JoinClassroomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinClassroomMutation, JoinClassroomMutationVariables>(JoinClassroomDocument, options);
      }
export type JoinClassroomMutationHookResult = ReturnType<typeof useJoinClassroomMutation>;
export type JoinClassroomMutationResult = Apollo.MutationResult<JoinClassroomMutation>;
export type JoinClassroomMutationOptions = Apollo.BaseMutationOptions<JoinClassroomMutation, JoinClassroomMutationVariables>;
export const GetOnboardingStatusDocument = gql`
    query GetOnboardingStatus($userId: String!) {
  user_by_pk(firestoreId: $userId) {
    onboarded
    organization {
      id: firestoreId
    }
  }
}
    `;

/**
 * __useGetOnboardingStatusQuery__
 *
 * To run a query within a React component, call `useGetOnboardingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnboardingStatusQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetOnboardingStatusQuery(baseOptions: Apollo.QueryHookOptions<GetOnboardingStatusQuery, GetOnboardingStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOnboardingStatusQuery, GetOnboardingStatusQueryVariables>(GetOnboardingStatusDocument, options);
      }
export function useGetOnboardingStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOnboardingStatusQuery, GetOnboardingStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOnboardingStatusQuery, GetOnboardingStatusQueryVariables>(GetOnboardingStatusDocument, options);
        }
export type GetOnboardingStatusQueryHookResult = ReturnType<typeof useGetOnboardingStatusQuery>;
export type GetOnboardingStatusLazyQueryHookResult = ReturnType<typeof useGetOnboardingStatusLazyQuery>;
export type GetOnboardingStatusQueryResult = Apollo.QueryResult<GetOnboardingStatusQuery, GetOnboardingStatusQueryVariables>;
export const PathSlugByNodeIdDocument = gql`
    query PathSlugByNodeId($id: uuid!) {
  node: path_node_by_pk(id: $id) {
    id
    path {
      id
      slug
    }
  }
}
    `;

/**
 * __usePathSlugByNodeIdQuery__
 *
 * To run a query within a React component, call `usePathSlugByNodeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathSlugByNodeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathSlugByNodeIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePathSlugByNodeIdQuery(baseOptions: Apollo.QueryHookOptions<PathSlugByNodeIdQuery, PathSlugByNodeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PathSlugByNodeIdQuery, PathSlugByNodeIdQueryVariables>(PathSlugByNodeIdDocument, options);
      }
export function usePathSlugByNodeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PathSlugByNodeIdQuery, PathSlugByNodeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PathSlugByNodeIdQuery, PathSlugByNodeIdQueryVariables>(PathSlugByNodeIdDocument, options);
        }
export type PathSlugByNodeIdQueryHookResult = ReturnType<typeof usePathSlugByNodeIdQuery>;
export type PathSlugByNodeIdLazyQueryHookResult = ReturnType<typeof usePathSlugByNodeIdLazyQuery>;
export type PathSlugByNodeIdQueryResult = Apollo.QueryResult<PathSlugByNodeIdQuery, PathSlugByNodeIdQueryVariables>;
export const CreateClassroomDocument = gql`
    mutation CreateClassroom($name: String!, $orgId: String!, $userId: String!, $pathId: bigint) {
  createClassroom: api_create_classroom(
    name: $name
    orgId: $orgId
    userId: $userId
    pathId: $pathId
  ) {
    id
    learnerGroup {
      ...ClassroomLearnerGroup
    }
  }
}
    ${ClassroomLearnerGroupFragmentDoc}`;
export type CreateClassroomMutationFn = Apollo.MutationFunction<CreateClassroomMutation, CreateClassroomMutationVariables>;

/**
 * __useCreateClassroomMutation__
 *
 * To run a mutation, you first call `useCreateClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClassroomMutation, { data, loading, error }] = useCreateClassroomMutation({
 *   variables: {
 *      name: // value for 'name'
 *      orgId: // value for 'orgId'
 *      userId: // value for 'userId'
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function useCreateClassroomMutation(baseOptions?: Apollo.MutationHookOptions<CreateClassroomMutation, CreateClassroomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClassroomMutation, CreateClassroomMutationVariables>(CreateClassroomDocument, options);
      }
export type CreateClassroomMutationHookResult = ReturnType<typeof useCreateClassroomMutation>;
export type CreateClassroomMutationResult = Apollo.MutationResult<CreateClassroomMutation>;
export type CreateClassroomMutationOptions = Apollo.BaseMutationOptions<CreateClassroomMutation, CreateClassroomMutationVariables>;
export const CirclePostsDocument = gql`
    query CirclePosts($communityId: String!, $spaceId: String!, $page: String!) {
  circle_posts(communityId: $communityId, spaceId: $spaceId, page: $page) {
    ...ForumPost
  }
}
    ${ForumPostFragmentDoc}`;

/**
 * __useCirclePostsQuery__
 *
 * To run a query within a React component, call `useCirclePostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCirclePostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCirclePostsQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      spaceId: // value for 'spaceId'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useCirclePostsQuery(baseOptions: Apollo.QueryHookOptions<CirclePostsQuery, CirclePostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CirclePostsQuery, CirclePostsQueryVariables>(CirclePostsDocument, options);
      }
export function useCirclePostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CirclePostsQuery, CirclePostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CirclePostsQuery, CirclePostsQueryVariables>(CirclePostsDocument, options);
        }
export type CirclePostsQueryHookResult = ReturnType<typeof useCirclePostsQuery>;
export type CirclePostsLazyQueryHookResult = ReturnType<typeof useCirclePostsLazyQuery>;
export type CirclePostsQueryResult = Apollo.QueryResult<CirclePostsQuery, CirclePostsQueryVariables>;
export const CircleSpaceGroupsDocument = gql`
    query CircleSpaceGroups($communityId: String!) {
  circle_space_groups(communityId: $communityId) {
    ...ForumSpaceGroup
  }
}
    ${ForumSpaceGroupFragmentDoc}`;

/**
 * __useCircleSpaceGroupsQuery__
 *
 * To run a query within a React component, call `useCircleSpaceGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCircleSpaceGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCircleSpaceGroupsQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useCircleSpaceGroupsQuery(baseOptions: Apollo.QueryHookOptions<CircleSpaceGroupsQuery, CircleSpaceGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CircleSpaceGroupsQuery, CircleSpaceGroupsQueryVariables>(CircleSpaceGroupsDocument, options);
      }
export function useCircleSpaceGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CircleSpaceGroupsQuery, CircleSpaceGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CircleSpaceGroupsQuery, CircleSpaceGroupsQueryVariables>(CircleSpaceGroupsDocument, options);
        }
export type CircleSpaceGroupsQueryHookResult = ReturnType<typeof useCircleSpaceGroupsQuery>;
export type CircleSpaceGroupsLazyQueryHookResult = ReturnType<typeof useCircleSpaceGroupsLazyQuery>;
export type CircleSpaceGroupsQueryResult = Apollo.QueryResult<CircleSpaceGroupsQuery, CircleSpaceGroupsQueryVariables>;
export const CircleSpacesDocument = gql`
    query CircleSpaces($communityId: String!) {
  circle_spaces(communityId: $communityId) {
    ...ForumSpace
  }
}
    ${ForumSpaceFragmentDoc}`;

/**
 * __useCircleSpacesQuery__
 *
 * To run a query within a React component, call `useCircleSpacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCircleSpacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCircleSpacesQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useCircleSpacesQuery(baseOptions: Apollo.QueryHookOptions<CircleSpacesQuery, CircleSpacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CircleSpacesQuery, CircleSpacesQueryVariables>(CircleSpacesDocument, options);
      }
export function useCircleSpacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CircleSpacesQuery, CircleSpacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CircleSpacesQuery, CircleSpacesQueryVariables>(CircleSpacesDocument, options);
        }
export type CircleSpacesQueryHookResult = ReturnType<typeof useCircleSpacesQuery>;
export type CircleSpacesLazyQueryHookResult = ReturnType<typeof useCircleSpacesLazyQuery>;
export type CircleSpacesQueryResult = Apollo.QueryResult<CircleSpacesQuery, CircleSpacesQueryVariables>;
export const CoinBalanceByUserDocument = gql`
    query CoinBalanceByUser($userId: String!) {
  coins: coin_trx(
    order_by: {createdAt: desc}
    limit: 1
    where: {userId: {_eq: $userId}}
  ) {
    balance
  }
}
    `;

/**
 * __useCoinBalanceByUserQuery__
 *
 * To run a query within a React component, call `useCoinBalanceByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoinBalanceByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoinBalanceByUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCoinBalanceByUserQuery(baseOptions: Apollo.QueryHookOptions<CoinBalanceByUserQuery, CoinBalanceByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoinBalanceByUserQuery, CoinBalanceByUserQueryVariables>(CoinBalanceByUserDocument, options);
      }
export function useCoinBalanceByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoinBalanceByUserQuery, CoinBalanceByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoinBalanceByUserQuery, CoinBalanceByUserQueryVariables>(CoinBalanceByUserDocument, options);
        }
export type CoinBalanceByUserQueryHookResult = ReturnType<typeof useCoinBalanceByUserQuery>;
export type CoinBalanceByUserLazyQueryHookResult = ReturnType<typeof useCoinBalanceByUserLazyQuery>;
export type CoinBalanceByUserQueryResult = Apollo.QueryResult<CoinBalanceByUserQuery, CoinBalanceByUserQueryVariables>;
export const UserProjectLikesDocument = gql`
    query UserProjectLikes($projectId: uuid!, $userId: String!) {
  projectReaction: project_reaction_by_pk(projectId: $projectId, userId: $userId) {
    ...projectReaction
  }
}
    ${ProjectReactionFragmentDoc}`;

/**
 * __useUserProjectLikesQuery__
 *
 * To run a query within a React component, call `useUserProjectLikesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProjectLikesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProjectLikesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserProjectLikesQuery(baseOptions: Apollo.QueryHookOptions<UserProjectLikesQuery, UserProjectLikesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProjectLikesQuery, UserProjectLikesQueryVariables>(UserProjectLikesDocument, options);
      }
export function useUserProjectLikesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProjectLikesQuery, UserProjectLikesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProjectLikesQuery, UserProjectLikesQueryVariables>(UserProjectLikesDocument, options);
        }
export type UserProjectLikesQueryHookResult = ReturnType<typeof useUserProjectLikesQuery>;
export type UserProjectLikesLazyQueryHookResult = ReturnType<typeof useUserProjectLikesLazyQuery>;
export type UserProjectLikesQueryResult = Apollo.QueryResult<UserProjectLikesQuery, UserProjectLikesQueryVariables>;
export const LikeProjectDocument = gql`
    mutation LikeProject($projectId: uuid!, $userId: String!, $count: Int = 1) {
  insert_project_reaction_one(
    object: {projectId: $projectId, userId: $userId, count: $count}
    on_conflict: {constraint: project_reaction_pkey, update_columns: count}
  ) {
    ...projectReaction
  }
  update_project_stats_by_pk(
    pk_columns: {projectId: $projectId}
    _inc: {likeCount: 1}
  ) {
    ...projectStats
  }
}
    ${ProjectReactionFragmentDoc}
${ProjectStatsFragmentDoc}`;
export type LikeProjectMutationFn = Apollo.MutationFunction<LikeProjectMutation, LikeProjectMutationVariables>;

/**
 * __useLikeProjectMutation__
 *
 * To run a mutation, you first call `useLikeProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikeProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likeProjectMutation, { data, loading, error }] = useLikeProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      userId: // value for 'userId'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useLikeProjectMutation(baseOptions?: Apollo.MutationHookOptions<LikeProjectMutation, LikeProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LikeProjectMutation, LikeProjectMutationVariables>(LikeProjectDocument, options);
      }
export type LikeProjectMutationHookResult = ReturnType<typeof useLikeProjectMutation>;
export type LikeProjectMutationResult = Apollo.MutationResult<LikeProjectMutation>;
export type LikeProjectMutationOptions = Apollo.BaseMutationOptions<LikeProjectMutation, LikeProjectMutationVariables>;
export const PathsFromIdArrayDocument = gql`
    query PathsFromIdArray($pathIds: [bigint!], $status: String!, $mergeBehavior: String) {
  paths: path(offset: 0, where: {id: {_in: $pathIds}, status: {_eq: $status}}) {
    ...PathCard
  }
}
    ${PathCardFragmentDoc}`;

/**
 * __usePathsFromIdArrayQuery__
 *
 * To run a query within a React component, call `usePathsFromIdArrayQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathsFromIdArrayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathsFromIdArrayQuery({
 *   variables: {
 *      pathIds: // value for 'pathIds'
 *      status: // value for 'status'
 *      mergeBehavior: // value for 'mergeBehavior'
 *   },
 * });
 */
export function usePathsFromIdArrayQuery(baseOptions: Apollo.QueryHookOptions<PathsFromIdArrayQuery, PathsFromIdArrayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PathsFromIdArrayQuery, PathsFromIdArrayQueryVariables>(PathsFromIdArrayDocument, options);
      }
export function usePathsFromIdArrayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PathsFromIdArrayQuery, PathsFromIdArrayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PathsFromIdArrayQuery, PathsFromIdArrayQueryVariables>(PathsFromIdArrayDocument, options);
        }
export type PathsFromIdArrayQueryHookResult = ReturnType<typeof usePathsFromIdArrayQuery>;
export type PathsFromIdArrayLazyQueryHookResult = ReturnType<typeof usePathsFromIdArrayLazyQuery>;
export type PathsFromIdArrayQueryResult = Apollo.QueryResult<PathsFromIdArrayQuery, PathsFromIdArrayQueryVariables>;
export const UserByIdDocument = gql`
    query UserById($userId: String!) {
  users: user(limit: 1, where: {firestoreId: {_eq: $userId}}) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUserByIdQuery__
 *
 * To run a query within a React component, call `useUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserByIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserByIdQuery(baseOptions: Apollo.QueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
      }
export function useUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
        }
export type UserByIdQueryHookResult = ReturnType<typeof useUserByIdQuery>;
export type UserByIdLazyQueryHookResult = ReturnType<typeof useUserByIdLazyQuery>;
export type UserByIdQueryResult = Apollo.QueryResult<UserByIdQuery, UserByIdQueryVariables>;
export const FindFollowRelationshipDocument = gql`
    query FindFollowRelationship($sourceUserId: String!, $targetUserId: String!) {
  user_follow_by_pk(sourceUserId: $sourceUserId, targetUserId: $targetUserId) {
    sourceUserId
    targetUserId
  }
}
    `;

/**
 * __useFindFollowRelationshipQuery__
 *
 * To run a query within a React component, call `useFindFollowRelationshipQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFollowRelationshipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFollowRelationshipQuery({
 *   variables: {
 *      sourceUserId: // value for 'sourceUserId'
 *      targetUserId: // value for 'targetUserId'
 *   },
 * });
 */
export function useFindFollowRelationshipQuery(baseOptions: Apollo.QueryHookOptions<FindFollowRelationshipQuery, FindFollowRelationshipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindFollowRelationshipQuery, FindFollowRelationshipQueryVariables>(FindFollowRelationshipDocument, options);
      }
export function useFindFollowRelationshipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindFollowRelationshipQuery, FindFollowRelationshipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindFollowRelationshipQuery, FindFollowRelationshipQueryVariables>(FindFollowRelationshipDocument, options);
        }
export type FindFollowRelationshipQueryHookResult = ReturnType<typeof useFindFollowRelationshipQuery>;
export type FindFollowRelationshipLazyQueryHookResult = ReturnType<typeof useFindFollowRelationshipLazyQuery>;
export type FindFollowRelationshipQueryResult = Apollo.QueryResult<FindFollowRelationshipQuery, FindFollowRelationshipQueryVariables>;
export const FollowUserDocument = gql`
    mutation FollowUser($sourceUserId: String!, $targetUserId: String!) {
  insert_user_follow_one(
    object: {sourceUserId: $sourceUserId, targetUserId: $targetUserId}
  ) {
    sourceUserId
    targetUserId
  }
}
    `;
export type FollowUserMutationFn = Apollo.MutationFunction<FollowUserMutation, FollowUserMutationVariables>;

/**
 * __useFollowUserMutation__
 *
 * To run a mutation, you first call `useFollowUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followUserMutation, { data, loading, error }] = useFollowUserMutation({
 *   variables: {
 *      sourceUserId: // value for 'sourceUserId'
 *      targetUserId: // value for 'targetUserId'
 *   },
 * });
 */
export function useFollowUserMutation(baseOptions?: Apollo.MutationHookOptions<FollowUserMutation, FollowUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowUserMutation, FollowUserMutationVariables>(FollowUserDocument, options);
      }
export type FollowUserMutationHookResult = ReturnType<typeof useFollowUserMutation>;
export type FollowUserMutationResult = Apollo.MutationResult<FollowUserMutation>;
export type FollowUserMutationOptions = Apollo.BaseMutationOptions<FollowUserMutation, FollowUserMutationVariables>;
export const UnfollowUserDocument = gql`
    mutation UnfollowUser($sourceUserId: String!, $targetUserId: String!) {
  delete_user_follow_by_pk(
    sourceUserId: $sourceUserId
    targetUserId: $targetUserId
  ) {
    sourceUserId
    targetUserId
  }
}
    `;
export type UnfollowUserMutationFn = Apollo.MutationFunction<UnfollowUserMutation, UnfollowUserMutationVariables>;

/**
 * __useUnfollowUserMutation__
 *
 * To run a mutation, you first call `useUnfollowUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowUserMutation, { data, loading, error }] = useUnfollowUserMutation({
 *   variables: {
 *      sourceUserId: // value for 'sourceUserId'
 *      targetUserId: // value for 'targetUserId'
 *   },
 * });
 */
export function useUnfollowUserMutation(baseOptions?: Apollo.MutationHookOptions<UnfollowUserMutation, UnfollowUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfollowUserMutation, UnfollowUserMutationVariables>(UnfollowUserDocument, options);
      }
export type UnfollowUserMutationHookResult = ReturnType<typeof useUnfollowUserMutation>;
export type UnfollowUserMutationResult = Apollo.MutationResult<UnfollowUserMutation>;
export type UnfollowUserMutationOptions = Apollo.BaseMutationOptions<UnfollowUserMutation, UnfollowUserMutationVariables>;
export const GetAwardsDocument = gql`
    query GetAwards {
  awards: award(where: {disabled: {_eq: false}}) {
    ...Award
  }
}
    ${AwardFragmentDoc}`;

/**
 * __useGetAwardsQuery__
 *
 * To run a query within a React component, call `useGetAwardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAwardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAwardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAwardsQuery(baseOptions?: Apollo.QueryHookOptions<GetAwardsQuery, GetAwardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAwardsQuery, GetAwardsQueryVariables>(GetAwardsDocument, options);
      }
export function useGetAwardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAwardsQuery, GetAwardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAwardsQuery, GetAwardsQueryVariables>(GetAwardsDocument, options);
        }
export type GetAwardsQueryHookResult = ReturnType<typeof useGetAwardsQuery>;
export type GetAwardsLazyQueryHookResult = ReturnType<typeof useGetAwardsLazyQuery>;
export type GetAwardsQueryResult = Apollo.QueryResult<GetAwardsQuery, GetAwardsQueryVariables>;
export const GiveAwardDocument = gql`
    mutation GiveAward($projectId: uuid!, $awardId: uuid!, $userId: String!, $fromUserId: String!, $cost: Int!, $bonus: Int!, $comment: String) {
  insert_project_award_one(
    object: {projectId: $projectId, awardId: $awardId, count: 0}
    on_conflict: {update_columns: [], constraint: project_award_pkey}
  ) {
    projectId
    awardId
    count
  }
  update_project_award_by_pk(
    pk_columns: {projectId: $projectId, awardId: $awardId}
    _inc: {count: 1}
  ) {
    projectId
    awardId
    count
  }
  insert_user_award_one(
    object: {awardId: $awardId, userId: $userId, fromUserId: $fromUserId}
  ) {
    id
  }
  coin_trx_from: insert_coin_trx_one(
    object: {amount: $cost, userId: $fromUserId, category: project_award_purchase}
  ) {
    id
  }
  coin_trx_to: insert_coin_trx_one(
    object: {amount: $bonus, userId: $userId, category: project_award_bonus}
  ) {
    id
  }
  projectComment: insert_project_comment_one(
    object: {projectId: $projectId, awardId: $awardId, comment: {data: {text: $comment, userId: $fromUserId}}}
  ) {
    ...projectComment
  }
  update_project_stats_by_pk(
    pk_columns: {projectId: $projectId}
    _inc: {commentCount: 1}
  ) {
    ...projectStats
  }
}
    ${ProjectCommentFragmentDoc}
${ProjectStatsFragmentDoc}`;
export type GiveAwardMutationFn = Apollo.MutationFunction<GiveAwardMutation, GiveAwardMutationVariables>;

/**
 * __useGiveAwardMutation__
 *
 * To run a mutation, you first call `useGiveAwardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGiveAwardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [giveAwardMutation, { data, loading, error }] = useGiveAwardMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      awardId: // value for 'awardId'
 *      userId: // value for 'userId'
 *      fromUserId: // value for 'fromUserId'
 *      cost: // value for 'cost'
 *      bonus: // value for 'bonus'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useGiveAwardMutation(baseOptions?: Apollo.MutationHookOptions<GiveAwardMutation, GiveAwardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GiveAwardMutation, GiveAwardMutationVariables>(GiveAwardDocument, options);
      }
export type GiveAwardMutationHookResult = ReturnType<typeof useGiveAwardMutation>;
export type GiveAwardMutationResult = Apollo.MutationResult<GiveAwardMutation>;
export type GiveAwardMutationOptions = Apollo.BaseMutationOptions<GiveAwardMutation, GiveAwardMutationVariables>;
export const CreateFileDocument = gql`
    mutation CreateFile($file: user_file_insert_input!) {
  file: insert_user_file_one(
    object: $file
    on_conflict: {constraint: user_file_pkey, update_columns: [id, filename, userId]}
  ) {
    id
    filename
    userId
  }
}
    `;
export type CreateFileMutationFn = Apollo.MutationFunction<CreateFileMutation, CreateFileMutationVariables>;

/**
 * __useCreateFileMutation__
 *
 * To run a mutation, you first call `useCreateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileMutation, { data, loading, error }] = useCreateFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useCreateFileMutation(baseOptions?: Apollo.MutationHookOptions<CreateFileMutation, CreateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFileMutation, CreateFileMutationVariables>(CreateFileDocument, options);
      }
export type CreateFileMutationHookResult = ReturnType<typeof useCreateFileMutation>;
export type CreateFileMutationResult = Apollo.MutationResult<CreateFileMutation>;
export type CreateFileMutationOptions = Apollo.BaseMutationOptions<CreateFileMutation, CreateFileMutationVariables>;
export const GetPathFeedsByPathIdDocument = gql`
    query GetPathFeedsByPathId($pathId: bigint!) {
  path_feed(where: {pathId: {_eq: $pathId}}) {
    slug
    pathId
  }
}
    `;

/**
 * __useGetPathFeedsByPathIdQuery__
 *
 * To run a query within a React component, call `useGetPathFeedsByPathIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPathFeedsByPathIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPathFeedsByPathIdQuery({
 *   variables: {
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function useGetPathFeedsByPathIdQuery(baseOptions: Apollo.QueryHookOptions<GetPathFeedsByPathIdQuery, GetPathFeedsByPathIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPathFeedsByPathIdQuery, GetPathFeedsByPathIdQueryVariables>(GetPathFeedsByPathIdDocument, options);
      }
export function useGetPathFeedsByPathIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPathFeedsByPathIdQuery, GetPathFeedsByPathIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPathFeedsByPathIdQuery, GetPathFeedsByPathIdQueryVariables>(GetPathFeedsByPathIdDocument, options);
        }
export type GetPathFeedsByPathIdQueryHookResult = ReturnType<typeof useGetPathFeedsByPathIdQuery>;
export type GetPathFeedsByPathIdLazyQueryHookResult = ReturnType<typeof useGetPathFeedsByPathIdLazyQuery>;
export type GetPathFeedsByPathIdQueryResult = Apollo.QueryResult<GetPathFeedsByPathIdQuery, GetPathFeedsByPathIdQueryVariables>;
export const AddPathToPathFeedDocument = gql`
    mutation AddPathToPathFeed($slug: String!, $pathId: bigint!, $userId: String!) {
  insert_path_feed_one(
    object: {slug: $slug, userId: $userId, pathId: $pathId}
    on_conflict: {constraint: path_feed_pkey}
  ) {
    slug
    pathId
  }
}
    `;
export type AddPathToPathFeedMutationFn = Apollo.MutationFunction<AddPathToPathFeedMutation, AddPathToPathFeedMutationVariables>;

/**
 * __useAddPathToPathFeedMutation__
 *
 * To run a mutation, you first call `useAddPathToPathFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPathToPathFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPathToPathFeedMutation, { data, loading, error }] = useAddPathToPathFeedMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      pathId: // value for 'pathId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddPathToPathFeedMutation(baseOptions?: Apollo.MutationHookOptions<AddPathToPathFeedMutation, AddPathToPathFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPathToPathFeedMutation, AddPathToPathFeedMutationVariables>(AddPathToPathFeedDocument, options);
      }
export type AddPathToPathFeedMutationHookResult = ReturnType<typeof useAddPathToPathFeedMutation>;
export type AddPathToPathFeedMutationResult = Apollo.MutationResult<AddPathToPathFeedMutation>;
export type AddPathToPathFeedMutationOptions = Apollo.BaseMutationOptions<AddPathToPathFeedMutation, AddPathToPathFeedMutationVariables>;
export const RemovePathFromPathFeedDocument = gql`
    mutation RemovePathFromPathFeed($slug: String!, $pathId: bigint!) {
  delete_path_feed_by_pk(slug: $slug, pathId: $pathId) {
    slug
    pathId
  }
}
    `;
export type RemovePathFromPathFeedMutationFn = Apollo.MutationFunction<RemovePathFromPathFeedMutation, RemovePathFromPathFeedMutationVariables>;

/**
 * __useRemovePathFromPathFeedMutation__
 *
 * To run a mutation, you first call `useRemovePathFromPathFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePathFromPathFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePathFromPathFeedMutation, { data, loading, error }] = useRemovePathFromPathFeedMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function useRemovePathFromPathFeedMutation(baseOptions?: Apollo.MutationHookOptions<RemovePathFromPathFeedMutation, RemovePathFromPathFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePathFromPathFeedMutation, RemovePathFromPathFeedMutationVariables>(RemovePathFromPathFeedDocument, options);
      }
export type RemovePathFromPathFeedMutationHookResult = ReturnType<typeof useRemovePathFromPathFeedMutation>;
export type RemovePathFromPathFeedMutationResult = Apollo.MutationResult<RemovePathFromPathFeedMutation>;
export type RemovePathFromPathFeedMutationOptions = Apollo.BaseMutationOptions<RemovePathFromPathFeedMutation, RemovePathFromPathFeedMutationVariables>;
export const RejectProjectDocument = gql`
    mutation RejectProject($projectId: uuid!, $userId: String!, $coinAmount: Int!, $coinTrxId: uuid!, $rejectReason: String!, $rejectFeedback: String, $rejectedByUserId: String!, $rejectedAt: timestamptz!) {
  insert_coin_trx_one(
    object: {id: $coinTrxId, amount: $coinAmount, userId: $userId, category: project_reject}
  ) {
    id
  }
  update_project_by_pk(
    pk_columns: {id: $projectId}
    _set: {rejectedAt: $rejectedAt, rejectedByUserId: $rejectedByUserId, rejectedReason: $rejectReason, rejectedFeedback: $rejectFeedback, rejectCoinTrxId: $coinTrxId}
  ) {
    id
    userId
    challengeId
    rejectedAt
    rejectedByUserId
    rejectedReason
    rejectedFeedback
    rejectCoinTrxId
  }
}
    `;
export type RejectProjectMutationFn = Apollo.MutationFunction<RejectProjectMutation, RejectProjectMutationVariables>;

/**
 * __useRejectProjectMutation__
 *
 * To run a mutation, you first call `useRejectProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectProjectMutation, { data, loading, error }] = useRejectProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      userId: // value for 'userId'
 *      coinAmount: // value for 'coinAmount'
 *      coinTrxId: // value for 'coinTrxId'
 *      rejectReason: // value for 'rejectReason'
 *      rejectFeedback: // value for 'rejectFeedback'
 *      rejectedByUserId: // value for 'rejectedByUserId'
 *      rejectedAt: // value for 'rejectedAt'
 *   },
 * });
 */
export function useRejectProjectMutation(baseOptions?: Apollo.MutationHookOptions<RejectProjectMutation, RejectProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectProjectMutation, RejectProjectMutationVariables>(RejectProjectDocument, options);
      }
export type RejectProjectMutationHookResult = ReturnType<typeof useRejectProjectMutation>;
export type RejectProjectMutationResult = Apollo.MutationResult<RejectProjectMutation>;
export type RejectProjectMutationOptions = Apollo.BaseMutationOptions<RejectProjectMutation, RejectProjectMutationVariables>;
export const GetRejectedProjectByIdDocument = gql`
    query GetRejectedProjectById($projectId: uuid!) {
  project: project_by_pk(id: $projectId) {
    ...AdminRejectedProject
  }
}
    ${AdminRejectedProjectFragmentDoc}`;

/**
 * __useGetRejectedProjectByIdQuery__
 *
 * To run a query within a React component, call `useGetRejectedProjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRejectedProjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRejectedProjectByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetRejectedProjectByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRejectedProjectByIdQuery, GetRejectedProjectByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRejectedProjectByIdQuery, GetRejectedProjectByIdQueryVariables>(GetRejectedProjectByIdDocument, options);
      }
export function useGetRejectedProjectByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRejectedProjectByIdQuery, GetRejectedProjectByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRejectedProjectByIdQuery, GetRejectedProjectByIdQueryVariables>(GetRejectedProjectByIdDocument, options);
        }
export type GetRejectedProjectByIdQueryHookResult = ReturnType<typeof useGetRejectedProjectByIdQuery>;
export type GetRejectedProjectByIdLazyQueryHookResult = ReturnType<typeof useGetRejectedProjectByIdLazyQuery>;
export type GetRejectedProjectByIdQueryResult = Apollo.QueryResult<GetRejectedProjectByIdQuery, GetRejectedProjectByIdQueryVariables>;
export const UnrejectProjectDocument = gql`
    mutation UnrejectProject($projectId: uuid!, $refundAmount: Int!, $refundUserId: String!) {
  update_project_by_pk(
    pk_columns: {id: $projectId}
    _set: {rejectedAt: "-infinity", rejectedReason: null, rejectedFeedback: null, rejectedByUserId: null, rejectCoinTrxId: null}
  ) {
    id
    rejectedAt
  }
  insert_coin_trx_one(
    object: {userId: $refundUserId, amount: $refundAmount, category: project_reject_refund}
  ) {
    id
  }
}
    `;
export type UnrejectProjectMutationFn = Apollo.MutationFunction<UnrejectProjectMutation, UnrejectProjectMutationVariables>;

/**
 * __useUnrejectProjectMutation__
 *
 * To run a mutation, you first call `useUnrejectProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnrejectProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unrejectProjectMutation, { data, loading, error }] = useUnrejectProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      refundAmount: // value for 'refundAmount'
 *      refundUserId: // value for 'refundUserId'
 *   },
 * });
 */
export function useUnrejectProjectMutation(baseOptions?: Apollo.MutationHookOptions<UnrejectProjectMutation, UnrejectProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnrejectProjectMutation, UnrejectProjectMutationVariables>(UnrejectProjectDocument, options);
      }
export type UnrejectProjectMutationHookResult = ReturnType<typeof useUnrejectProjectMutation>;
export type UnrejectProjectMutationResult = Apollo.MutationResult<UnrejectProjectMutation>;
export type UnrejectProjectMutationOptions = Apollo.BaseMutationOptions<UnrejectProjectMutation, UnrejectProjectMutationVariables>;
export const StreamIoCreateActivityDocument = gql`
    mutation StreamIOCreateActivity($apiKey: String!, $feedSlug: String!, $feedUserId: String!, $activity: StreamIOCreateActivityInput!) {
  streamio_create_activity(
    api_key: $apiKey
    feed_slug: $feedSlug
    feed_user_id: $feedUserId
    activity: $activity
  ) {
    id
  }
}
    `;
export type StreamIoCreateActivityMutationFn = Apollo.MutationFunction<StreamIoCreateActivityMutation, StreamIoCreateActivityMutationVariables>;

/**
 * __useStreamIoCreateActivityMutation__
 *
 * To run a mutation, you first call `useStreamIoCreateActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStreamIoCreateActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [streamIoCreateActivityMutation, { data, loading, error }] = useStreamIoCreateActivityMutation({
 *   variables: {
 *      apiKey: // value for 'apiKey'
 *      feedSlug: // value for 'feedSlug'
 *      feedUserId: // value for 'feedUserId'
 *      activity: // value for 'activity'
 *   },
 * });
 */
export function useStreamIoCreateActivityMutation(baseOptions?: Apollo.MutationHookOptions<StreamIoCreateActivityMutation, StreamIoCreateActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StreamIoCreateActivityMutation, StreamIoCreateActivityMutationVariables>(StreamIoCreateActivityDocument, options);
      }
export type StreamIoCreateActivityMutationHookResult = ReturnType<typeof useStreamIoCreateActivityMutation>;
export type StreamIoCreateActivityMutationResult = Apollo.MutationResult<StreamIoCreateActivityMutation>;
export type StreamIoCreateActivityMutationOptions = Apollo.BaseMutationOptions<StreamIoCreateActivityMutation, StreamIoCreateActivityMutationVariables>;
export const SessionUserByIdDocument = gql`
    query SessionUserById($userId: String!) {
  users: user(where: {firestoreId: {_eq: $userId}}) {
    ...CurrentUser
  }
}
    ${CurrentUserFragmentDoc}`;

/**
 * __useSessionUserByIdQuery__
 *
 * To run a query within a React component, call `useSessionUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionUserByIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSessionUserByIdQuery(baseOptions: Apollo.QueryHookOptions<SessionUserByIdQuery, SessionUserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionUserByIdQuery, SessionUserByIdQueryVariables>(SessionUserByIdDocument, options);
      }
export function useSessionUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionUserByIdQuery, SessionUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionUserByIdQuery, SessionUserByIdQueryVariables>(SessionUserByIdDocument, options);
        }
export type SessionUserByIdQueryHookResult = ReturnType<typeof useSessionUserByIdQuery>;
export type SessionUserByIdLazyQueryHookResult = ReturnType<typeof useSessionUserByIdLazyQuery>;
export type SessionUserByIdQueryResult = Apollo.QueryResult<SessionUserByIdQuery, SessionUserByIdQueryVariables>;
export const UpdateSessionUserDocument = gql`
    mutation UpdateSessionUser($id: String!, $avatar: String!, $bio: String!, $interestAreas: jsonb!, $country: String!, $accomplishments: jsonb!) {
  user: update_user_by_pk(
    pk_columns: {firestoreId: $id}
    _set: {avatar: $avatar, bio: $bio, interestAreas: $interestAreas, country: $country, accomplishments: $accomplishments}
  ) {
    ...CurrentUser
  }
}
    ${CurrentUserFragmentDoc}`;
export type UpdateSessionUserMutationFn = Apollo.MutationFunction<UpdateSessionUserMutation, UpdateSessionUserMutationVariables>;

/**
 * __useUpdateSessionUserMutation__
 *
 * To run a mutation, you first call `useUpdateSessionUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionUserMutation, { data, loading, error }] = useUpdateSessionUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      avatar: // value for 'avatar'
 *      bio: // value for 'bio'
 *      interestAreas: // value for 'interestAreas'
 *      country: // value for 'country'
 *      accomplishments: // value for 'accomplishments'
 *   },
 * });
 */
export function useUpdateSessionUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSessionUserMutation, UpdateSessionUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSessionUserMutation, UpdateSessionUserMutationVariables>(UpdateSessionUserDocument, options);
      }
export type UpdateSessionUserMutationHookResult = ReturnType<typeof useUpdateSessionUserMutation>;
export type UpdateSessionUserMutationResult = Apollo.MutationResult<UpdateSessionUserMutation>;
export type UpdateSessionUserMutationOptions = Apollo.BaseMutationOptions<UpdateSessionUserMutation, UpdateSessionUserMutationVariables>;
export const InsertUserTeacherDocument = gql`
    mutation InsertUserTeacher($object: user_teacher_insert_input!) {
  insert_user_teacher_one(object: $object) {
    userId
    displayName
    lowerGradeLevel
    upperGradeLevel
    subjects
  }
}
    `;
export type InsertUserTeacherMutationFn = Apollo.MutationFunction<InsertUserTeacherMutation, InsertUserTeacherMutationVariables>;

/**
 * __useInsertUserTeacherMutation__
 *
 * To run a mutation, you first call `useInsertUserTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertUserTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUserTeacherMutation, { data, loading, error }] = useInsertUserTeacherMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertUserTeacherMutation(baseOptions?: Apollo.MutationHookOptions<InsertUserTeacherMutation, InsertUserTeacherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertUserTeacherMutation, InsertUserTeacherMutationVariables>(InsertUserTeacherDocument, options);
      }
export type InsertUserTeacherMutationHookResult = ReturnType<typeof useInsertUserTeacherMutation>;
export type InsertUserTeacherMutationResult = Apollo.MutationResult<InsertUserTeacherMutation>;
export type InsertUserTeacherMutationOptions = Apollo.BaseMutationOptions<InsertUserTeacherMutation, InsertUserTeacherMutationVariables>;
export const UpdateUserTeacherDocument = gql`
    mutation UpdateUserTeacher($userId: String!, $displayName: String, $lowerGradeLevel: String, $upperGradeLevel: String, $subjects: jsonb) {
  update_user_teacher_by_pk(
    pk_columns: {userId: $userId}
    _set: {displayName: $displayName, lowerGradeLevel: $lowerGradeLevel, upperGradeLevel: $upperGradeLevel, subjects: $subjects}
  ) {
    userId
    displayName
    lowerGradeLevel
    upperGradeLevel
    subjects
  }
}
    `;
export type UpdateUserTeacherMutationFn = Apollo.MutationFunction<UpdateUserTeacherMutation, UpdateUserTeacherMutationVariables>;

/**
 * __useUpdateUserTeacherMutation__
 *
 * To run a mutation, you first call `useUpdateUserTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserTeacherMutation, { data, loading, error }] = useUpdateUserTeacherMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      displayName: // value for 'displayName'
 *      lowerGradeLevel: // value for 'lowerGradeLevel'
 *      upperGradeLevel: // value for 'upperGradeLevel'
 *      subjects: // value for 'subjects'
 *   },
 * });
 */
export function useUpdateUserTeacherMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserTeacherMutation, UpdateUserTeacherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserTeacherMutation, UpdateUserTeacherMutationVariables>(UpdateUserTeacherDocument, options);
      }
export type UpdateUserTeacherMutationHookResult = ReturnType<typeof useUpdateUserTeacherMutation>;
export type UpdateUserTeacherMutationResult = Apollo.MutationResult<UpdateUserTeacherMutation>;
export type UpdateUserTeacherMutationOptions = Apollo.BaseMutationOptions<UpdateUserTeacherMutation, UpdateUserTeacherMutationVariables>;